const landingScreen = document.querySelector("#landing-screen");
const intakeScreen = document.querySelector("#intake-screen");
const initialPrivateRouteLoader = document.querySelector(".initial-private-route-loader");
const aboutScreen = document.querySelector("#about-screen");
const aboutTitle = document.querySelector("#about-title");
const donationScreen = document.querySelector("#donation-screen");
const donationTitle = document.querySelector("#donation-title");
const donationMethods = document.querySelector("#donation-methods");
const donationHomeButtons = document.querySelectorAll("[data-donation-home]");
const donationInfoDialog = document.querySelector("#donation-info-dialog");
const donationInfoTitle = document.querySelector("#donation-info-title");
const donationInfoCloseButton = document.querySelector("#donation-info-close");
const donationMethodDialog = document.querySelector("#donation-method-dialog");
const donationMethodDialogEyebrow = document.querySelector("#donation-method-dialog-eyebrow");
const donationMethodDialogTitle = document.querySelector("#donation-method-dialog-title");
const donationMethodDialogContent = document.querySelector("#donation-method-dialog-content");
const donationMethodCloseButton = document.querySelector("#donation-method-close");
const landingAstroDiagram = document.querySelector(".landing-astro-preview .astroanamnesis-svg");
const landingAstroMobileQuery = window.matchMedia("(max-width: 520px)");
const chatScreen = document.querySelector("#chat-screen");
const privateScreen = document.querySelector("#private-screen");
const guestMapsScreen = document.querySelector("#guest-maps-screen");
const guestMapsStage = document.querySelector("#guest-maps-stage");
const guestMapControls = document.querySelector("#guest-map-controls");
const guestMapsNewChartButton = document.querySelector("#guest-maps-new-chart");
const intakeHomeButton = document.querySelector("#intake-home-button");
const adminScreen = document.querySelector("#admin-screen");
const birthForm = document.querySelector("#birth-form");
const calculateButton = document.querySelector("#calculate-button");
const formStatus = document.querySelector("#form-status");
const loginGoogleLink = document.querySelector("#login-google");
const openPrivateButton = document.querySelector("#open-private");
const authStatus = document.querySelector("#auth-status");
const landingAuthStatus = document.querySelector("#landing-auth-status");
const landingTryButtons = document.querySelectorAll(".landing-try");
const landingLoginLinks = document.querySelectorAll(".landing-login");
const authDialog = document.querySelector("#auth-dialog");
const authDialogCloseButton = document.querySelector("#auth-dialog-close");
const authDialogTitle = document.querySelector("#auth-dialog-title");
const authDialogEyebrow = document.querySelector("#auth-dialog-eyebrow");
const authDialogSubtitle = document.querySelector("#auth-dialog-subtitle");
const authDialogStatus = document.querySelector("#auth-dialog-status");
const authOpenButtons = document.querySelectorAll("[data-auth-open]");
const authModeButtons = document.querySelectorAll("[data-auth-mode]");
const authViews = document.querySelectorAll("[data-auth-view]");
const authLoginForm = document.querySelector("#auth-login-form");
const authLoginEmail = document.querySelector("#auth-login-email");
const authLoginPassword = document.querySelector("#auth-login-password");
const authLoginRemember = document.querySelector("#auth-login-remember");
const authRegisterForm = document.querySelector("#auth-register-form");
const authRegisterName = document.querySelector("#auth-register-name");
const authRegisterEmail = document.querySelector("#auth-register-email");
const authRegisterConsent = document.querySelector("#auth-register-consent");
const authForgotForm = document.querySelector("#auth-forgot-form");
const authForgotEmail = document.querySelector("#auth-forgot-email");
const authResetForm = document.querySelector("#auth-reset-form");
const authResetToken = document.querySelector("#auth-reset-token");
const authResetPassword = document.querySelector("#auth-reset-password");
const authResetConfirm = document.querySelector("#auth-reset-confirm");
const authGoogleButton = document.querySelector("#auth-google-button");
const authGuestButton = document.querySelector("[data-auth-guest]");
const landingOpenPrivateButton = document.querySelector("#landing-open-private");
const landingHeaderTryButton = document.querySelector("#landing-try-free");
const landingHeroPrimaryButton = document.querySelector("#landing-hero-primary");
const landingHeroTrialNote = document.querySelector("#landing-hero-trial-note");
const landingBottomTryButton = document.querySelector("#landing-bottom-try-free");
const landingBottomEyebrow = document.querySelector("#landing-bottom-eyebrow");
const landingBottomTitle = document.querySelector("#landing-bottom-title");
const landingBottomCopy = document.querySelector("#landing-bottom-copy");
const landingTrainingAnnouncement = document.querySelector("#landing-training-announcement");
const trainingBanner = document.querySelector("#training-banner");
const openAboutButtons = document.querySelectorAll("[data-open-about]");
const aboutHomeButtons = document.querySelectorAll("[data-about-home]");
const aboutStartButtons = document.querySelectorAll("[data-about-start]");
const themeButtons = document.querySelectorAll("[data-theme-choice]");
const privateUser = document.querySelector("#private-user");
const privateAccount = document.querySelector("#private-account");
const privateAccountMenu = document.querySelector("#private-account-menu");
const privateBackButton = document.querySelector("#private-back");
const logoutButton = document.querySelector("#logout-button");
const togglePrivateSidebarButton = document.querySelector("#toggle-private-sidebar");
const privateSidebar = document.querySelector(".private-sidebar");
const privatePanel = document.querySelector(".private-panel");
const privateSidebarBackdrop = document.querySelector("#private-sidebar-backdrop");
const privateSidebarMobileQuery = window.matchMedia("(max-width: 860px)");
const privateMapControlsMobileQuery = window.matchMedia("(max-width: 640px)");
const adminUser = document.querySelector("#admin-user");
const adminBackHomeButton = document.querySelector("#admin-back-home");
const adminLogoutButton = document.querySelector("#admin-logout");
const adminStatus = document.querySelector("#admin-status");
const adminTabs = document.querySelector(".admin-tabs");
const adminSections = document.querySelectorAll("[data-admin-section]");
const adminOverview = document.querySelector("#admin-overview");
const adminUsers = document.querySelector("#admin-users");
const adminWaitlist = document.querySelector("#admin-waitlist");
const adminContact = document.querySelector("#admin-contact");
const adminOrders = document.querySelector("#admin-orders");
const adminTraining = document.querySelector("#admin-training");
const adminTrainingCourseDialog = document.querySelector("#admin-training-course-dialog");
const adminTrainingCourseForm = document.querySelector("#admin-training-course-form");
const adminTrainingCourseTitle = document.querySelector("#admin-training-course-title");
const adminTrainingCourseId = document.querySelector("#admin-training-course-id");
const adminTrainingTitleInput = document.querySelector("#admin-training-title");
const adminTrainingSummaryInput = document.querySelector("#admin-training-summary");
const adminTrainingDescriptionInput = document.querySelector("#admin-training-description");
const adminTrainingStartsAtInput = document.querySelector("#admin-training-starts-at");
const adminTrainingEndsAtInput = document.querySelector("#admin-training-ends-at");
const adminTrainingRegistrationOpensInput = document.querySelector("#admin-training-registration-opens");
const adminTrainingRegistrationClosesInput = document.querySelector("#admin-training-registration-closes");
const adminTrainingModalityInput = document.querySelector("#admin-training-modality");
const adminTrainingLocationInput = document.querySelector("#admin-training-location");
const adminTrainingCapacityInput = document.querySelector("#admin-training-capacity");
const adminTrainingPriceInput = document.querySelector("#admin-training-price");
const adminTrainingStatusInput = document.querySelector("#admin-training-status");
const adminTrainingFeaturedInput = document.querySelector("#admin-training-featured");
const adminTrainingAnnouncementInput = document.querySelector("#admin-training-announcement");
const adminTrainingAudienceInput = document.querySelector("#admin-training-audience");
const adminTrainingSyllabusInput = document.querySelector("#admin-training-syllabus");
const adminTrainingCourseStatus = document.querySelector("#admin-training-course-status");
const adminTrainingCourseCloseButton = document.querySelector("#admin-training-course-close");
const adminTrainingCourseCancelButton = document.querySelector("#admin-training-course-cancel");
const adminUserAdjustDialog = document.querySelector("#admin-user-adjust-dialog");
const adminUserAdjustForm = document.querySelector("#admin-user-adjust-form");
const adminUserAdjustSummary = document.querySelector("#admin-user-adjust-summary");
const adminAdjustPlanSelect = document.querySelector("#admin-adjust-plan");
const adminAdjustCreditsInput = document.querySelector("#admin-adjust-credits");
const adminAdjustReasonInput = document.querySelector("#admin-adjust-reason");
const adminUserAdjustStatus = document.querySelector("#admin-user-adjust-status");
const adminUserAdjustSubmit = document.querySelector("#admin-user-adjust-submit");
const adminUserAdjustCloseButton = document.querySelector("#admin-user-adjust-close");
const adminUserAdjustCancelButton = document.querySelector("#admin-user-adjust-cancel");
const adminOrderStatusDialog = document.querySelector("#admin-order-status-dialog");
const adminOrderStatusForm = document.querySelector("#admin-order-status-form");
const adminOrderStatusSummary = document.querySelector("#admin-order-status-summary");
const adminOrderContext = document.querySelector("#admin-order-context");
const adminOrderStatusSelect = document.querySelector("#admin-order-status-select");
const adminOrderStatusMessage = document.querySelector("#admin-order-status-message");
const adminOrderStatusSubmit = document.querySelector("#admin-order-status-submit");
const adminOrderStatusCloseButton = document.querySelector("#admin-order-status-close");
const adminOrderStatusCancelButton = document.querySelector("#admin-order-status-cancel");
const togglePersonFormButton = document.querySelector("#toggle-person-form");
const personFormWrap = document.querySelector("#person-form-wrap");
const personForm = document.querySelector("#person-form");
const personIdInput = document.querySelector("#person-id");
const personGenderSelect = document.querySelector("#person-gender");
const personGenderOtherField = document.querySelector("#person-gender-other-field");
const personGenderOtherInput = document.querySelector("#person-gender-other");
const personMonthSelect = document.querySelector("#person-month");
const personHourSelect = document.querySelector("#person-hour");
const personMinuteSelect = document.querySelector("#person-minute");
const personCountryCombobox = document.querySelector("#person-country-combobox");
const personCountrySearchInput = document.querySelector("#person-country-search");
const personCountrySelect = document.querySelector("#person-country");
const personCountryResults = document.querySelector("#person-country-results");
const personCityInput = document.querySelector("#person-city");
const personPlaceIdInput = document.querySelector("#person-place-id");
const personLatInput = document.querySelector("#person-lat");
const personLonInput = document.querySelector("#person-lon");
const personTzInput = document.querySelector("#person-tz");
const personCityResults = document.querySelector("#person-city-results");
const personSaveButton = document.querySelector("#person-save");
const personCancelEditButton = document.querySelector("#person-cancel-edit");
const peopleSearchInput = document.querySelector("#people-search");
const peopleInitialFilter = document.querySelector("#people-initial-filter");
const peopleSolarFilter = document.querySelector("#people-solar-filter");
const peopleListEl = document.querySelector("#people-list");
const peopleEmpty = document.querySelector("#people-empty");
const peopleCount = document.querySelector("#people-count");
const billingPanel = document.querySelector("#billing-panel");
const billingEyebrow = document.querySelector("#billing-eyebrow");
const billingTitle = document.querySelector("#billing-title");
const billingMode = document.querySelector("#billing-mode");
const billingStatus = document.querySelector("#billing-status");
const billingContent = document.querySelector("#billing-content");
const subscriptionWaitlistDialog = document.querySelector("#subscription-waitlist-dialog");
const subscriptionWaitlistCloseButton = document.querySelector("#subscription-waitlist-close");
const subscriptionWaitlistCancelButton = document.querySelector("#subscription-waitlist-cancel");
const subscriptionWaitlistConfirmButton = document.querySelector("#subscription-waitlist-confirm");
const subscriptionWaitlistConsentInput = document.querySelector("#subscription-waitlist-consent");
const subscriptionWaitlistEmail = document.querySelector("#subscription-waitlist-email");
const subscriptionWaitlistStatus = document.querySelector("#subscription-waitlist-status");
const storeCartHeaderButton = document.querySelector("#store-cart-header");
const storeCartHeaderCount = document.querySelector("#store-cart-header-count");
const storeCartDialog = document.querySelector("#store-cart-dialog");
const storeCartDialogContent = document.querySelector("#store-cart-dialog-content");
const storeProductDialog = document.querySelector("#store-product-dialog");
const storeProductDialogContent = document.querySelector("#store-product-dialog-content");
const storeImageZoomDialog = document.querySelector("#store-image-zoom-dialog");
const storeImageZoomImage = document.querySelector("#store-image-zoom-image");
const storeImageZoomCloseButton = document.querySelector("#store-image-zoom-close");
const storeImageZoomPrevButton = document.querySelector("#store-image-zoom-prev");
const storeImageZoomNextButton = document.querySelector("#store-image-zoom-next");
const storeImageZoomCounter = document.querySelector("#store-image-zoom-counter");
const privateStatus = document.querySelector("#private-status");
const privateDashboardSection = document.querySelector("#private-dashboard-section");
const privateListSection = document.querySelector("#private-list-section");
const privateMapsSection = document.querySelector("#private-maps-section");
const privateToolsSection = document.querySelector("#private-tools-section");
const privateToolsMenu = document.querySelector("[data-private-tools-menu]");
const privateToolsToggle = document.querySelector("[data-private-tools-toggle]");
const privateToolsSubmenu = document.querySelector("#private-tools-submenu");
const privateToolsRouteButtons = document.querySelectorAll("[data-private-tools-route]");
const subscriberToolNavigationButtons = document.querySelectorAll("[data-private-tools-route], [data-private-section-tab='transits']");
const privateToolsEyebrow = document.querySelector("#private-tools-eyebrow");
const privateToolsTitle = document.querySelector("#private-tools-title");
const privateToolsSubtitle = document.querySelector("#private-tools-subtitle");
const privateTrainingSection = document.querySelector("#private-training-section");
const privateSessionsSection = document.querySelector("#private-sessions-section");
const privateTrainingRouteButtons = document.querySelectorAll("[data-private-training-route]");
const trainingStatus = document.querySelector("#training-status");
const trainingCoursesView = document.querySelector("#training-courses-view");
const trainingRegistrationsView = document.querySelector("#training-registrations-view");
const trainingFeatured = document.querySelector("#training-featured");
const trainingCourseList = document.querySelector("#training-course-list");
const trainingRegistrationList = document.querySelector("#training-registration-list");
const trainingCourseDialog = document.querySelector("#training-course-dialog");
const trainingCourseDialogCloseButton = document.querySelector("#training-course-dialog-close");
const trainingCourseDialogContent = document.querySelector("#training-course-dialog-content");
const trainingRegistrationDialog = document.querySelector("#training-registration-dialog");
const trainingRegistrationForm = document.querySelector("#training-registration-form");
const trainingRegistrationDialogCloseButton = document.querySelector("#training-registration-dialog-close");
const trainingRegistrationCancelButton = document.querySelector("#training-registration-cancel");
const trainingRegistrationCourse = document.querySelector("#training-registration-course");
const trainingRegistrationAccount = document.querySelector("#training-registration-account");
const trainingRegistrationPhone = document.querySelector("#training-registration-phone");
const trainingRegistrationConsent = document.querySelector("#training-registration-consent");
const trainingRegistrationFormStatus = document.querySelector("#training-registration-form-status");
const privatePrognosisSection = document.querySelector("#private-prognosis-section");
const privateTransitsSection = document.querySelector("#private-transits-section");
const privateAdminSection = document.querySelector("#private-admin-section");
const aspectFinderForm = document.querySelector("#aspect-finder-form");
const aspectFinderPlanetA = document.querySelector("#aspect-finder-planet-a");
const aspectFinderPlanetB = document.querySelector("#aspect-finder-planet-b");
const aspectFinderSwapButton = document.querySelector("#aspect-finder-swap");
const aspectFinderAngle = document.querySelector("#aspect-finder-angle");
const aspectFinderOrb = document.querySelector("#aspect-finder-orb");
const aspectFinderHorizon = document.querySelector("#aspect-finder-horizon");
const aspectFinderDate = document.querySelector("#aspect-finder-date");
const aspectFinderTime = document.querySelector("#aspect-finder-time");
const aspectFinderCountry = document.querySelector("#aspect-finder-country");
const aspectFinderCity = document.querySelector("#aspect-finder-city");
const aspectFinderCityResults = document.querySelector("#aspect-finder-city-results");
const aspectFinderLocationStatus = document.querySelector("#aspect-finder-location-status");
const aspectFinderStatus = document.querySelector("#aspect-finder-status");
const aspectFinderSubmit = document.querySelector("#aspect-finder-submit");
const aspectFinderResult = document.querySelector("#aspect-finder-result");
const privateToolsViewPanels = document.querySelectorAll("[data-tools-view-panel]");
const natalAspectFinderForm = document.querySelector("#natal-aspect-finder-form");
const natalAspectFinderPerson = document.querySelector("#natal-aspect-finder-person");
const natalAspectFinderPersonPicker = document.querySelector("#natal-aspect-finder-person-picker");
const natalAspectFinderTransitPlanet = document.querySelector("#natal-aspect-finder-transit-planet");
const natalAspectFinderNatalPlanet = document.querySelector("#natal-aspect-finder-natal-planet");
const natalAspectFinderAngle = document.querySelector("#natal-aspect-finder-angle");
const natalAspectFinderOrb = document.querySelector("#natal-aspect-finder-orb");
const natalAspectFinderHorizon = document.querySelector("#natal-aspect-finder-horizon");
const natalAspectFinderDate = document.querySelector("#natal-aspect-finder-date");
const natalAspectFinderTime = document.querySelector("#natal-aspect-finder-time");
const natalAspectFinderCountry = document.querySelector("#natal-aspect-finder-country");
const natalAspectFinderCity = document.querySelector("#natal-aspect-finder-city");
const natalAspectFinderCityResults = document.querySelector("#natal-aspect-finder-city-results");
const natalAspectFinderLocationStatus = document.querySelector("#natal-aspect-finder-location-status");
const natalAspectFinderStatus = document.querySelector("#natal-aspect-finder-status");
const natalAspectFinderSubmit = document.querySelector("#natal-aspect-finder-submit");
const natalAspectFinderResult = document.querySelector("#natal-aspect-finder-result");
const privateTransitsToday = document.querySelector("#private-transits-today");
const privateTransitPersonSelect = document.querySelector("#private-transit-person");
const privateTransitDateInput = document.querySelector("#private-transit-date");
const privateTransitOrbFilterSelect = document.querySelector("#private-transit-orb-filter");
const privateTransitStatus = document.querySelector("#private-transit-status");
const featuredTransitFree = document.querySelector("#featured-transit-free");
const privateTransitPlanetFilters = document.querySelector("#private-transit-planet-filters");
const privateTransitTable = document.querySelector("#private-transit-table");
const generateDailyHoroscopeButton = document.querySelector("#generate-daily-horoscope");
const dailyHoroscopeUsage = document.querySelector("#daily-horoscope-usage");
const dailyHoroscopeHistoryList = document.querySelector("#daily-horoscope-history-list");
const clearDailyHoroscopeHistoryButton = document.querySelector("#clear-daily-horoscope-history");
const dailyHoroscopeDialog = document.querySelector("#daily-horoscope-dialog");
const closeDailyHoroscopeButton = document.querySelector("#close-daily-horoscope");
const dailyHoroscopeSubtitle = document.querySelector("#daily-horoscope-subtitle");
const dailyHoroscopeContent = document.querySelector("#daily-horoscope-content");
const saveDailyHoroscopeButton = document.querySelector("#save-daily-horoscope");
const downloadDailyHoroscopeButton = document.querySelector("#download-daily-horoscope");
const privateSpaceTabs = document.querySelectorAll("[data-private-section-tab]");
const privateSpaceNav = document.querySelector(".private-space-nav");
const privateFeatureNav = document.querySelector("#private-feature-nav");
const privateQuickNav = document.querySelector("#private-quick-nav");
const privateQuickActionButtons = document.querySelectorAll("[data-private-quick-action]");
const privateAdminLink = document.querySelector("#private-admin-link");
const privateAdminNavSection = document.querySelector("#private-admin-nav-section");
const privateAdminDashboardCard = document.querySelector("#private-admin-dashboard-card");
const privateMapContext = document.querySelector("#private-map-context");
const privateMapActiveCard = document.querySelector("#private-map-active-card");
const privateMapControls = document.querySelector("#private-map-controls");
const privateMapPromptButton = document.querySelector("#private-map-prompt");
const privateMapOffer = document.querySelector("#private-map-offer");
const privateMapChatButton = document.querySelector("#private-map-chat");
const privateMapListButton = document.querySelector("#private-map-list");
const privateMapActions = document.querySelector(".private-map-actions");
const privateMapsSubtitle = document.querySelector("#private-maps-subtitle");
const privateMapCollapsedContextSlot = document.querySelector("#private-map-collapsed-context-slot");
const privateMapMobileContextSlot = document.querySelector("#private-map-mobile-context-slot");
const privateMapMobileOfferSlot = document.querySelector("#private-map-mobile-offer-slot");
const privateMapsStage = document.querySelector("#private-maps-stage");
const privateMapsChat = document.querySelector("#private-maps-chat");
const MODULE_VISIBILITY_STORAGE_KEY = "astroanamnesis:moduleVisibility";
const ALWAYS_ENABLED_MODULES = new Set(["privateSpace"]);
const STORE_CART_STORAGE_PREFIX = "astroanamnesis:storeCart";
const CHART_VIEW_TYPE_STORAGE_KEY = "astroanamnesis:chartViewType";
const CUSTOM_CHART_SELECTION_STORAGE_KEY = "astroanamnesis:customChartSelection";
const CHART_RELATED_PERSON_STORAGE_PREFIX = "astroanamnesis:chartRelatedPerson";
const PROMPT_SESSION_PREPARATION_CONTEXT = "Quiero que actúes como un copiloto del astrologo y me prepares un guion operativo de tres sesiones con foco, núcleo clínico, escenas, preguntas y cierres. Mantén el orden Astroanamnesis: día → Memoria → Tropical → Sideral → síntesis/integración.";
const PROMPT_ASTROLOGY_TECHNICAL_CONTEXT = "Utiliza lenguaje astrológico técnico, pero tradúcelo siempre a escena observable, papel, conducta, expectativa, compensación, coste, decepción y repetición. No hagas inventario de posiciones ni redactes como un manual.";
const PROMPT_NO_ASTROLOGY_LANGUAGE_CONTEXT = [
"No muestres lenguaje astrológico técnico en la redacción del informe. Usa los datos de las cartas únicamente como base interna de interpretación y tradúcelos directamente a lenguaje clínico-simbólico observable.",
"No menciones signos, planetas, casas, grados, aspectos, cúspides, decanatos, dodecatemorias, regentes, Nodos ni posiciones técnicas, salvo que sea imprescindible para señalar un límite técnico.",
"Expón directamente:\npapel → conducta → necesidad → expectativa → compensación → coste → decepción → repetición → observación.",
"La interpretación debe conservar toda la profundidad técnica de las cartas, pero el lector no debe necesitar conocimientos astrológicos para comprenderla."].
join("\n\n");
const PROMPT_ASTROLOGY_VISIBLE_STYLES = [
"Profesional",
"Conversacional",
"Técnico",
"Clínico-simbólico"];

const PROMPT_ASTROLOGY_HIDDEN_STYLES = [
"Profesional",
"Conversacional",
"Clínico-simbólico",
"Técnicamente profundo, pero sin terminología astrológica visible"];

const PROMPT_ASTROANAMNESIS_CONTEXT = [
"Usa una voz clínico-simbólica, cálida, directa y conversacional. Habla en segunda persona. Avanza por reconocimiento progresivo: una idea central cada vez, preguntas breves y una sola trama clínica. No inventes respuestas del consultante.",
PROMPT_ASTROLOGY_TECHNICAL_CONTEXT,
"No uses psicología externa, coaching ni lenguaje motivacional. No moralices, no diagnostiques, no predigas y no prometas liberación. Evita frases como “tu misión”, “tu verdadera identidad” o “la vida quiere enseñarte”.",
"Las películas de Memoria son hipótesis simbólicas. Distingue siempre dato explícito, inferencia probable, hipótesis clínica y límite técnico. Toda imagen espiritual debe traducirse a un mecanismo inconsciente observable.",
"En conversación, avanza paso a paso. En modo Informe, desarrolla la estructura completa establecida en AA_00."].
join("\n\n");
const PROMPT_REPORT_ORDER = "Microencuadre → Día → Tropical → Síntesis Tropical → Pregunta umbral → Introducción fija → Memoria → Espejo → Primera síntesis → Sideral → Síntesis final → Integración.";
const DEFAULT_MODULE_VISIBILITY = {
  transits: false,
  synastry: false,
  subscriptionSection: false,
  reportsSection: false,
  storeCart: false,
  storeStationery: false,
  storeTextile: false,
  mapCompleteReading: false,
  reportPsychologicalIdentity: false,
  reportFamilySocialRelations: false,
  reportCompositeChart: true,
  reportCompositeAstroanamnesis: true
};
const MODULE_VISIBILITY_LABELS = { get
  transits() {return { get title() {return T("interface.transitos");}, get description() {return T("interface.seccion_de_transitos_personales_en_la_navegacion_privada");} };}, get



  synastry() {return { get title() {return T("interface.sinastria");}, get description() {return T("interface.vista_de_sinastria_tropical_en_el_selector_de_mapas");} };}, get



  subscriptionSection() {return { get title() {return T("interface.apartado_suscripcion");}, get description() {return T("interface.seccion_de_suscripcion_en_la_navegacion_mi_espacio_y_configuracion_de_cuenta");} };}, get



  reportsSection() {return { get title() {return T("interface.apartado_informes");}, get description() {return T("interface.seccion_completa_de_informes_en_la_navegacion_y_mi_espacio");} };}, get



  storeCart() {return { get title() {return T("interface.tienda_carrito");}, get description() {return T("interface.carrito_y_acciones_para_anadir_productos_dentro_de_la_tienda");} };}, get



  storeStationery() {return { get title() {return T("interface.tienda_papeleria");}, get description() {return T("interface.productos_de_la_categoria_papeleria_dentro_de_la_tienda");} };}, get



  storeTextile() {return { get title() {return T("interface.tienda_textil");}, get description() {return T("interface.productos_de_la_categoria_textil_dentro_de_la_tienda");} };}, get



  mapCompleteReading() {return { get title() {return T("interface.mapas_lectura_completa");}, get description() {return T("interface.oferta_de_lectura_completa_en_la_vista_astroanamnesis_de_mapas");} };}, get



  reportPsychologicalIdentity() {return { get title() {return T("interface.informe_psicologico_y_de_identidad");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get



  reportFamilySocialRelations() {return { get title() {return T("interface.informe_relaciones_familiares_y_sociales");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get



  reportCompositeChart() {return { get title() {return T("interface.informe_carta_compuesta");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get



  reportCompositeAstroanamnesis() {return { get title() {return T("interface.informe_carta_compuesta_astroanamnesis");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}



};
const REPORT_VISIBILITY_MODULES = {
  "psychological-identity": "reportPsychologicalIdentity",
  "family-social-relations": "reportFamilySocialRelations",
  "composite-chart": "reportCompositeChart",
  "composite-astroanamnesis": "reportCompositeAstroanamnesis"
};
const OPTIONAL_CHART_MODULES = ["synastry"];
const SUBSCRIBER_ONLY_CHART_VIEW_TYPES = new Set(["compositeMultiple"]);
const PRIVATE_SECTION_MODULE_MAP = {
  plans: "subscriptionSection",
  reports: "reportsSection",
  transits: "transits"
};
const PRIVATE_ACTION_MODULE_MAP = {
  transits: "transits",
  plans: "subscriptionSection",
  orders: "reportsSection"
};
const STORE_CATEGORY_VISIBILITY_MODULES = {
  papeleria: "storeStationery",
  textil: "storeTextile"
};
let moduleVisibility = loadModuleVisibilitySettings();
const legacyModuleVisibility = { ...moduleVisibility };
let moduleVisibilityDraft = { ...moduleVisibility };
let moduleVisibilityLoadPromise = null;
let moduleVisibilityServerInitialized = false;
let moduleVisibilitySaveState = {
  dirty: false,
  saving: false,
  message: "",
  error: false
};
const genderSelect = document.querySelector("#birth-gender");
const genderOtherField = document.querySelector("#gender-other-field");
const genderOtherInput = document.querySelector("#birth-gender-other");
const monthSelect = document.querySelector("#birth-month");
const hourSelect = document.querySelector("#birth-hour");
const minuteSelect = document.querySelector("#birth-minute");
const countrySelect = document.querySelector("#birth-country");
const cityInput = document.querySelector("#birth-city");
const placeIdInput = document.querySelector("#birth-place-id");
const latInput = document.querySelector("#birth-lat");
const lonInput = document.querySelector("#birth-lon");
const tzInput = document.querySelector("#birth-tz");
const cityResults = document.querySelector("#city-results");
const birthSummary = document.querySelector("#birth-summary");
const openChartWheelButton = document.querySelector("#open-chart-wheel");
const openChartDataButton = document.querySelector("#open-chart-data");
const calculateAnotherChartButton = document.querySelector("#calculate-another-chart");
const sidebarChartControls = document.querySelector("#sidebar-chart-controls");
const chatHomeButton = document.querySelector("#chat-home");
const chatCreditSummary = document.querySelector("#chat-credit-summary");
const openBillingInfoButton = document.querySelector("#open-billing-info");
const chatFoldersPanel = document.querySelector("#chat-folders-panel");
const chatFoldersList = document.querySelector("#chat-folders-list");
const createChatFolderButton = document.querySelector("#create-chat-folder");
const chatFolderDialog = document.querySelector("#chat-folder-dialog");
const chatFolderForm = document.querySelector("#chat-folder-form");
const chatFolderNameInput = document.querySelector("#chat-folder-name");
const chatFolderStatus = document.querySelector("#chat-folder-status");
const chatFolderCancelButton = document.querySelector("#chat-folder-cancel");
const chatFolderCancelXButton = document.querySelector("#chat-folder-cancel-x");
const deleteFolderDialog = document.querySelector("#delete-folder-dialog");
const deleteFolderForm = document.querySelector("#delete-folder-form");
const deleteFolderMessage = document.querySelector("#delete-folder-message");
const deleteFolderCancelButton = document.querySelector("#delete-folder-cancel");
const deleteFolderCancelXButton = document.querySelector("#delete-folder-cancel-x");
const destructiveConfirmDialog = document.querySelector("#destructive-confirm-dialog");
const destructiveConfirmForm = document.querySelector("#destructive-confirm-form");
const destructiveConfirmTitle = document.querySelector("#destructive-confirm-title");
const destructiveConfirmMessage = document.querySelector("#destructive-confirm-message");
const destructiveConfirmWarning = document.querySelector("#destructive-confirm-warning");
const destructiveConfirmSubmitButton = document.querySelector("#destructive-confirm-submit");
const destructiveConfirmCancelButton = document.querySelector("#destructive-confirm-cancel");
const destructiveConfirmCancelXButton = document.querySelector("#destructive-confirm-cancel-x");
const downloadConfirmDialog = document.querySelector("#download-confirm-dialog");
const downloadConfirmForm = document.querySelector("#download-confirm-form");
const downloadConfirmTitle = document.querySelector("#download-confirm-title");
const downloadConfirmMessage = document.querySelector("#download-confirm-message");
const downloadConfirmSubmitButton = document.querySelector("#download-confirm-submit");
const downloadConfirmCancelButton = document.querySelector("#download-confirm-cancel");
const downloadConfirmCancelXButton = document.querySelector("#download-confirm-cancel-x");
const chartPlanetVisibilityDialog = document.querySelector("#chart-planet-visibility-dialog");
const chartPlanetVisibilityForm = document.querySelector("#chart-planet-visibility-form");
const chartPlanetVisibilityList = document.querySelector("#chart-planet-visibility-list");
const chartPlanetColorEditor = document.querySelector("#chart-planet-color-editor");
const chartPlanetColorEditorTitle = document.querySelector("#chart-planet-color-editor-title");
const chartPlanetColorEditorSymbol = document.querySelector("#chart-planet-color-editor-symbol");
const chartPlanetColorEditorCloseButton = document.querySelector("#chart-planet-color-editor-close");
const chartPlanetColorPalette = document.querySelector("#chart-planet-color-palette");
const chartPlanetCustomColorInput = document.querySelector("#chart-planet-custom-color-input");
const chartPlanetCustomColorValue = document.querySelector("#chart-planet-custom-color-value");
const chartPlanetColorRestoreCurrentButton = document.querySelector("#chart-planet-color-restore-current");
const chartPlanetColorRestoreAllButton = document.querySelector("#chart-planet-color-restore-all");
const chartPlanetColorStatus = document.querySelector("#chart-planet-color-status");
const chartAspectVisibilityList = document.querySelector("#chart-aspect-visibility-list");
const chartAspectColorEditor = document.querySelector("#chart-aspect-color-editor");
const chartAspectColorEditorTitle = document.querySelector("#chart-aspect-color-editor-title");
const chartAspectColorEditorSymbol = document.querySelector("#chart-aspect-color-editor-symbol");
const chartAspectColorEditorCloseButton = document.querySelector("#chart-aspect-color-editor-close");
const chartAspectColorPalette = document.querySelector("#chart-aspect-color-palette");
const chartAspectCustomColorInput = document.querySelector("#chart-aspect-custom-color-input");
const chartAspectCustomColorValue = document.querySelector("#chart-aspect-custom-color-value");
const chartAspectColorRestoreCurrentButton = document.querySelector("#chart-aspect-color-restore-current");
const chartAspectColorRestoreAllButton = document.querySelector("#chart-aspect-color-restore-all");
const chartAspectColorStatus = document.querySelector("#chart-aspect-color-status");
const chartAspectOrbSettings = document.querySelector("#chart-aspect-orb-settings");
const chartAspectOrbList = document.querySelector("#chart-aspect-orb-list");
const chartAspectOrbSummary = document.querySelector("#chart-aspect-orb-summary");
const chartAspectOrbToggleLabel = document.querySelector("#chart-aspect-orb-toggle-label");
const chartAspectOrbHelp = document.querySelector("#chart-aspect-orb-help");
const chartAspectOrbRestoreDefaultsButton = document.querySelector("#chart-aspect-orb-restore-defaults");
const chartConjunctionCuspRule = document.querySelector("#chart-conjunction-cusp-rule");
const chartConjunctionCuspLimit = document.querySelector("#chart-conjunction-cusp-limit");
const chartHouseSystemSelect = document.querySelector("#chart-house-system-select");
const chartHouseSystemPreview = document.querySelector("#chart-house-system-preview");
const chartPlanetVisibilityStatus = document.querySelector("#chart-planet-visibility-status");
const chartPlanetVisibilityClearAllButton = document.querySelector("#chart-planet-visibility-clear-all");
const chartAspectRestoreDefaultsButton = document.querySelector("#chart-aspect-restore-defaults");
const chartPlanetVisibilityCancelButton = document.querySelector("#chart-planet-visibility-cancel");
const chartPlanetVisibilityCloseButton = document.querySelector("#chart-planet-visibility-close");
const chartDataDialog = document.querySelector("#chart-data-dialog");
const closeChartDataButton = document.querySelector("#close-chart-data");
const dismissChartDataButton = document.querySelector("#dismiss-chart-data");
const generateChartDataButton = document.querySelector("#generate-chart-data");
const copyChartDataButton = document.querySelector("#copy-chart-data");
const chartDataFormatSelect = document.querySelector("#chart-data-format");
const chartPromptProfileSelect = document.querySelector("#chart-prompt-profile");
const chartPromptProfileLabel = document.querySelector("#chart-prompt-profile-label");
const chartPromptMultipleOptions = document.querySelector("#chart-prompt-multiple-options");
const chartPromptIncludeMemoria = document.querySelector("#chart-prompt-include-memoria");
const chartPromptIncludeTropical = document.querySelector("#chart-prompt-include-tropical");
const chartPromptIncludeSideral = document.querySelector("#chart-prompt-include-sideral");
const chartPromptEnablePreferences = document.querySelector("#chart-prompt-enable-preferences");
const chartPromptEnablePreferencesLabel = document.querySelector("#chart-prompt-enable-preferences-label");
const chartPromptPreferencesPanel = document.querySelector("#chart-prompt-preferences-panel");
const chartPromptLanguageSelect = document.querySelector("#chart-prompt-language");
const chartPromptSizeSelect = document.querySelector("#chart-prompt-size");
const chartPromptAstrologyLanguageSelect = document.querySelector("#chart-prompt-astrology-language");
const chartPromptNarrativeSelect = document.querySelector("#chart-prompt-narrative");
const chartPromptExtraInfo = document.querySelector("#chart-prompt-extra-info");
const chartPromptOtherStyleField = document.querySelector("#chart-prompt-other-style-field");
const chartPromptOtherStyleInput = document.querySelector("#chart-prompt-other-style");
const chartPromptOtherToneField = document.querySelector("#chart-prompt-other-tone-field");
const chartPromptOtherToneInput = document.querySelector("#chart-prompt-other-tone");
const chartDataOutput = document.querySelector("#chart-data-output");
const chartDataCopyStatus = document.querySelector("#chart-data-copy-status");
const personSwitchDialog = document.querySelector("#person-switch-dialog");
const closePersonSwitchButton = document.querySelector("#close-person-switch");
const personSwitchEyebrow = personSwitchDialog?.querySelector(".person-switch-header .eyebrow");
const personSwitchTitle = document.querySelector("#person-switch-title");
const personSwitchSearch = document.querySelector("#person-switch-search");
const personSwitchStatus = document.querySelector("#person-switch-status");
const personSwitchList = document.querySelector("#person-switch-list");
let personSwitchRole = "subject";
let personSwitchReturnFocus = null;
let personSwitchOpenSequence = 0;
let personSwitchLoadRequest = null;
const chatIaDialog = document.querySelector("#chat-ia-dialog");
const chartWheelDialog = document.querySelector("#chart-wheel-dialog");
const closeChartWheelButton = document.querySelector("#close-chart-wheel");
const chartWheelControls = document.querySelector(".chart-wheel-controls");
const chartWheelTypeSelect = document.querySelector("#chart-wheel-type");
const chartTypeHelpText = document.querySelector("#chart-type-help-text");
const chatChartContextTools = document.querySelector("#chat-chart-context-tools");
const chatChartContextTypeSelect = document.querySelector("#chat-chart-context-type");
const chatChartContextHelpText = document.querySelector("#chat-chart-context-help-text");
const chatLoadChartContextButton = document.querySelector("#chat-load-chart-context");
const chatChartContextStatus = document.querySelector("#chat-chart-context-status");
const chartTransitField = document.querySelector("#chart-transit-field");
const chartTransitLegend = document.querySelector("#chart-transit-legend");
const chartTransitDateInput = document.querySelector("#chart-transit-date");
const chartTransitTimeInput = document.querySelector("#chart-transit-time");
const chartProgressedField = document.querySelector("#chart-progressed-field");
const chartProgressedDateInput = document.querySelector("#chart-progressed-date");
const chartProgressedTimeInput = document.querySelector("#chart-progressed-time");
const chartProgressedNote = document.querySelector("#chart-progressed-note");
const chartSynastryField = document.querySelector("#chart-synastry-field");
const chartSynastryPersonSelect = document.querySelector("#chart-synastry-person");
const renderChartWheelButton = document.querySelector("#render-chart-wheel");
const chartWheelStatus = document.querySelector("#chart-wheel-status");
const chartWheelStage = document.querySelector("#chart-wheel-stage");
const chartSolarReturnField = document.querySelector("#chart-solar-return-field");
const chartSolarReturnYearInput = document.querySelector("#chart-solar-return-year");
const chartSolarReturnNatalInput = document.querySelector("#chart-solar-return-natal");
const chartSolarReturnCustomLocationInput = document.querySelector("#chart-solar-return-custom-location");
const chartSolarReturnLocation = document.querySelector("#chart-solar-return-location");
const chartSolarReturnCountrySelect = document.querySelector("#chart-solar-return-country");
const chartSolarReturnCityInput = document.querySelector("#chart-solar-return-city");
const chartSolarReturnPlaceIdInput = document.querySelector("#chart-solar-return-place-id");
const chartSolarReturnCityResults = document.querySelector("#chart-solar-return-city-results");
const personCountryControl = { input: personCountrySearchInput, select: personCountrySelect, results: personCountryResults, city: personCityInput, matches: [], activeIndex: -1 };
const solarReturnCountryControl = { input: document.querySelector("#chart-solar-return-country-search"), select: chartSolarReturnCountrySelect, results: document.querySelector("#chart-solar-return-country-results"), city: chartSolarReturnCityInput, matches: [], activeIndex: -1 };
const chartMainPanel = document.querySelector("#chart-main-panel");
const chatPanel = document.querySelector(".chat-panel");
const chatSidebar = document.querySelector("#chat-screen .sidebar");
const chartWheelModal = document.querySelector(".chart-wheel-modal");
const legalDialog = document.querySelector("#legal-dialog");
const legalTitle = document.querySelector("#legal-title");
const legalContent = document.querySelector("#legal-content");
const closeLegalButton = document.querySelector("#close-legal");
const contactDialog = document.querySelector("#contact-dialog");
const contactForm = document.querySelector("#contact-form");
const contactReasonInput = document.querySelector("#contact-reason");
const contactNameInput = document.querySelector("#contact-name");
const contactEmailInput = document.querySelector("#contact-email");
const contactMessageInput = document.querySelector("#contact-message");
const contactStatus = document.querySelector("#contact-status");
const contactSubmitButton = document.querySelector("#contact-submit");
const contactCloseButton = document.querySelector("#contact-close");
const contactSuccess = document.querySelector("#contact-success");
const contactSuccessCloseButton = document.querySelector("#contact-success-close");
const contactSupport = document.querySelector("#contact-support");
const contactDonationLink = document.querySelector("#contact-donation-link");
const billingInfoDialog = document.querySelector("#billing-info-dialog");
const billingInfoContent = document.querySelector("#billing-info-content");
const closeBillingInfoButton = document.querySelector("#close-billing-info");
const birthLegalConsentInput = document.querySelector("#birth-legal-consent");
const personLegalConsentInput = document.querySelector("#person-legal-consent");
const chatLegalConsent = document.querySelector("#chat-legal-consent");
const chatLegalAcceptInput = document.querySelector("#chat-legal-accept");
const attachContextFileButton = document.querySelector("#attach-context-file");
const contextFileInput = document.querySelector("#context-file-input");
const contextFilesList = document.querySelector("#context-files-list");
const editBirthButton = document.querySelector("#edit-birth");
const chatPrivateButton = document.querySelector("#chat-private");
const sidebarAccount = document.querySelector("#sidebar-account");
const sidebarAccountToggle = document.querySelector("#sidebar-account-toggle");
const sidebarAccountMenu = document.querySelector("#sidebar-account-menu");
const sidebarAccountAvatar = document.querySelector("#sidebar-account-avatar");
const sidebarAccountName = document.querySelector("#sidebar-account-name");
const sidebarAccountEmail = document.querySelector("#sidebar-account-email");
const sidebarAccountMenuName = document.querySelector("#sidebar-account-menu-name");
const sidebarAccountMenuEmail = document.querySelector("#sidebar-account-menu-email");
const sidebarAdminLink = document.querySelector("#sidebar-admin-link");
const accountSettingsDialog = document.querySelector("#account-settings-dialog");
const closeAccountSettingsButton = document.querySelector("#close-account-settings");
const closeAccountSettingsIconButton = document.querySelector("#close-account-settings-icon");
const accountSettingsPlan = document.querySelector("#account-settings-plan");
const accountSettingsCredits = document.querySelector("#account-settings-credits");
const accountSettingsUsage = document.querySelector("#account-settings-usage");
const accountSettingsLastUsage = document.querySelector("#account-settings-last-usage");
const accountSettingsAvatar = document.querySelector("#account-settings-avatar");
const accountSettingsName = document.querySelector("#account-settings-name");
const accountSettingsEmail = document.querySelector("#account-settings-email");
const accountPersonalInformationForm = document.querySelector("#account-personal-information-form");
const accountPersonalFirstNameInput = document.querySelector("#account-personal-first-name");
const accountPersonalLastNameInput = document.querySelector("#account-personal-last-name");
const accountPersonalPhoneInput = document.querySelector("#account-personal-phone");
const accountPersonalCountrySelect = document.querySelector("#account-personal-country");
const accountPersonalLanguageSelect = document.querySelector("#account-personal-language");
const accountPersonalTimezoneInput = document.querySelector("#account-personal-timezone");
const accountPersonalInformationStatus = document.querySelector("#account-personal-information-status");
const saveAccountPersonalInformationButton = document.querySelector("#save-account-personal-information");
const cancelAccountPersonalInformationButton = document.querySelector("#cancel-account-personal-information");
const accountSettingsConnected = document.querySelector("#account-settings-connected");
const accountProfileForm = document.querySelector("#account-profile-form");
const accountProfileNameInput = document.querySelector("#account-profile-name");
const accountAvatarInput = document.querySelector("#account-avatar-input");
const chooseAccountAvatarButton = document.querySelector("#choose-account-avatar");
const removeAccountAvatarButton = document.querySelector("#remove-account-avatar");
const toggleProfileEditButton = document.querySelector("#toggle-profile-edit");
const cancelProfileEditButton = document.querySelector("#cancel-profile-edit");
const accountUpgradePlanButton = document.querySelector("#account-upgrade-plan");
const accountAddCreditsButton = document.querySelector("#account-add-credits");
const deleteAccountButton = document.querySelector("#delete-account-button");
const accountSettingsStatus = document.querySelector("#account-settings-status");
const accountPreferencesStatus = document.querySelector("#account-preferences-status");
const accountSettingsTabs = document.querySelector(".account-settings-tabs");
const accountSettingsSections = document.querySelectorAll("[data-account-section]");
const accountDefaultChartViewSelect = document.querySelector("#account-default-chart-view");
const accountHouseSystemSelect = document.querySelector("#account-house-system");
const accountMapVisibilitySummary = document.querySelector("#account-map-visibility-summary");
const accountOpenMapSettingsButton = document.querySelector("#account-open-map-settings");
const accountResetMapPreferencesButton = document.querySelector("#account-reset-map-preferences");
const accountTextSizeButtons = document.querySelectorAll("[data-account-text-size]");
const accountReduceMotionInput = document.querySelector("#account-reduce-motion");
const accountResetAppearanceButton = document.querySelector("#account-reset-appearance");
const accountNotificationSummary = document.querySelector("#account-notification-summary");
const accountNotificationState = document.querySelector("#account-notification-state");
const accountNotificationActionButton = document.querySelector("#account-notification-action");
const accountLogoutAllButton = document.querySelector("#account-logout-all");
const chatHistoryPanel = document.querySelector("#chat-history-panel");
const chatHistoryList = document.querySelector("#chat-history-list");
const chatHistoryCount = document.querySelector("#chat-history-count");
const chatHistoryEmpty = document.querySelector("#chat-history-empty");
const toggleChatHistoryButton = document.querySelector("#toggle-chat-history");
const toggleChatSidebarButton = document.querySelector("#toggle-chat-sidebar");
const collapsedSidebarActions = document.querySelector("#collapsed-sidebar-actions");
const collapsedPrivateButton = document.querySelector("#collapsed-private");
const collapsedOpenChartWheelButton = document.querySelector("#collapsed-open-chart-wheel");
const collapsedChatPopover = document.querySelector("#collapsed-chat-popover");
const collapsedChatList = document.querySelector("#collapsed-chat-list");
const collapsedChatCount = document.querySelector("#collapsed-chat-count");
const collapsedChatEmpty = document.querySelector("#collapsed-chat-empty");
const emptyChatHero = document.querySelector("#empty-chat-hero");
const messagesEl = document.querySelector("#messages");
const form = document.querySelector("#chat-form");
const input = document.querySelector("#message-input");
const voiceDictationButton = document.querySelector("#voice-dictation");
const modelLevelSelect = document.querySelector("#model-level");
const sendButton = document.querySelector("#send-button");
const statusEl = document.querySelector("#status");
const promptSuggestions = document.querySelector("#prompt-suggestions");
const newChatButton = document.querySelector("#new-chat");
const connectionDot = document.querySelector("#connection-dot");
const connectionText = document.querySelector("#connection-text");
const LOCATION_DISPLAY_NAMES = Object.freeze({
  "2512989": "Palma de Mallorca"
});

let conversationId = localStorage.getItem("conversationId") || "";
let birthProfile = readBirthProfile();
let chartCalculation = readChartCalculation();
let isStreaming = false;
let isDictating = false;
let speechRecognition = null;
let dictationBaseText = "";
let knowledgeStatusLoaded = false;
let chatContextPreloaded = false;
let autoScrollLocked = false;
let lastMessagesScrollTop = 0;
let cityList = [];
let lastCountry = "";
let solarReturnCityList = [];
let solarReturnLastCountry = "";
let solarReturnLocationRefreshTimer = null;
let countriesCache = [];
let countriesPromise = null;
let currentUser = null;
let onboardingController = null;
let onboardingOwnerId = null;
let privateWorkPeopleOwner = null;
let privateWorkPeopleError = null;
let privateNotebookTarget = null;
let onboardingLoading = null;
let onboardingSidebarBefore = null;
let onboardingOpenedExport = false;
window.OnboardingAccess = { sync: syncOnboardingAccess, offer: offerOnboarding };
let atlasChartScriptLoading = false;
let privateAtlasAssetsPromise = null;
let privateAtlasController = null;
let privateTimelineController = null,privateTimelineRequest = null,privateTimelineSelection = null;
let privateObservatoryController = null,privateObservatoryRequest = null,privateObservatoryCalculationRequest = null;
let privateAtlasRequest = null;
let privateAtlasPath = "/private/atlas";
let privateAtlas3DController = null;
let privateAtlas3DRequest = null;
let privateAtlas3DSelection = null;
let privateAtlas3DSelectionRequest = null;
let authDialogReturnFocus = null;
let contactReturnFocus = null;
let contactSubmissionPending = false;
let publicDonationConfig = {};
let donationDialogReturnFocus = null;
let lastAccountSubscriptionSyncAt = 0;
let accountSubscriptionSyncPromise = null;
let adminData = {
  summary: null,
  users: [],
  waitlist: [],
  waitlistSummary: null,
  waitlistLoaded: false,
  waitlistQuery: "",
  waitlistStatus: "all",
  contactMessages: [],
  contactSummary: null,
  contactLoaded: false,
  contactQuery: "",
  contactStatus: "all",
  contactReason: "all",
  orders: [],
  trainingCourses: [],
  trainingRegistrations: [],
  trainingSummary: null,
  trainingLoaded: false
};
let activeAdminTab = "overview";
let activeAdminAdjustUserId = "";
let activeAdminOrderId = "";
let pendingAvatarDataUrl = "";
let pendingAvatarRemoval = false;
let savedPeople = [];
let activePeopleSolarSign = "";
let activePeopleInitial = "";
let privateCityList = [];
let privateLastCountry = "";
let activePersonId = localStorage.getItem("activePersonId") || "";
let activeChatId = localStorage.getItem("activeChatId") || "";
let chatHistory = [];
let chatHistoryLoaded = false;
let chatHistoryLimit = 10;
let chatFolders = [];
let chatFolderAssignments = {};
let pinnedChatIds = [];
let activeChatFolderId = "all";
let chatHistoryCollapsed = false;
let openChatMenuId = "";
let openMoveChatId = "";
let openFolderMenuId = "";
let chatUiServerLoaded = false;
let chatUiSaveTimer = null;
let pendingFolderResolve = null;
let pendingDeleteFolderResolve = null;
let pendingDestructiveConfirmResolve = null;
let pendingDownloadConfirmResolve = null;
let chatSidebarCollapsed = localStorage.getItem("chatSidebarCollapsed") === "true";
let privateSidebarCollapsed = privateSidebarMobileQuery.matches ?
true :
localStorage.getItem("privateSidebarPinned") !== "true";
let collapsedChatPopoverOpen = false;
let savedTheme = "indigo";
let accountTextSize = "normal";
let accountReduceMotion = false;
let accountPersonalInformation = {
  firstName: "",
  lastName: "",
  phone: "",
  country: "",
  language: "es",
  timezone: ""
};
let accountPreferencesLoaded = false;
let accountPreferencesApplying = false;
let accountPreferencesSaveTimer = null;
let accountPreferencesSavePromise = null;
let accountPreferencesSaveDirty = false;
let accountPreferencesStatusTimer = null;
let billingSummary = null;
let subscriptionWaitlistBusy = false;
let storeCart = [];
let storeImageZoomGallery = [];
let storeImageZoomIndex = 0;
let privateMapOfferStatus = "";
let privateMapOfferBusy = false;
let privateMapOfferRequested = false;
let privateMapOfferContextKey = "";
let aspectFinderInitialized = false;
let latestAspectFinderResult = null;
let natalAspectFinderInitialized = false;
let latestNatalAspectFinderResult = null;
let activePrivateToolsView = "transits";
let privateToolsMenuExpanded = false;
let activePrivateTrainingView = "courses";
let trainingCourses = [];
let trainingRegistrations = [];
let trainingLoaded = false;
let activeTrainingCourseId = 0;
let trainingBannerDismissed = false;
let activeAspectMomentOccurrenceIndex = 0;
let aspectFinderSelectedPlace = null;
let aspectFinderCitySearchTimer = 0;
let natalAspectFinderSelectedPlace = null;
let natalAspectFinderCitySearchTimer = 0;
let activePrivateSection = "list";
const PRIVATE_SECTION_ROUTES = {
  timeline: "linea-del-tiempo",
  observatory: "observatorio",
  atlas: "atlas",
  atlas3d: "atlas-3d",
  space: "mi-espacio",
  list: "mi-lista",
  maps: "mapas",
  tools: "herramientas",
  training: "formacion",
  sessions: "sesiones",
  plans: "suscripcion",
  reports: "informes",
  store: "tienda",
  prognosis: "prognosis",
  transits: "transitos",
  admin: "administracion"
};
const PRIVATE_TOOLS_VIEW_ROUTES = Object.freeze({
  transits: "buscador-de-aspectos",
  natal: "aspectos-carta-natal"
});
const PRIVATE_TOOLS_ROUTE_VIEWS = Object.freeze(Object.fromEntries(
  Object.entries(PRIVATE_TOOLS_VIEW_ROUTES).map(([view, slug]) => [slug, view])
));
const PRIVATE_TRAINING_VIEW_ROUTES = Object.freeze({
  courses: "cursos",
  registrations: "mis-inscripciones",
  videos: "videos"
});
const PRIVATE_TRAINING_ROUTE_VIEWS = Object.freeze(Object.fromEntries(
  Object.entries(PRIVATE_TRAINING_VIEW_ROUTES).map(([view, slug]) => [slug, view])
));
const PRIVATE_TOOLS_VIEW_META = Object.freeze({ get
  transits() {return { get eyebrow() {return T("interface.herramientas_aspectos");}, get title() {return T("navigation.aspectFinder");}, get subtitle() {return T("interface.localiza_el_proximo_aspecto_exacto_entre_dos_planetas_en_transito");} };}, get




  natal() {return { get eyebrow() {return T("interface.herramientas_carta_natal");}, get title() {return T("navigation.natalTransitFinder");}, get subtitle() {return T("interface.localiza_el_proximo_transito_exacto_sobre_una_posicion_de_la_carta_tropical_natal_de_");} };}




});
const ABOUT_ROUTE = "/astroanamnesis";
const DONATION_ROUTE = "/donaciones";
const GUEST_INTAKE_ROUTE = "/crear-carta";
const TRAINING_PROMOTION_DISMISSAL_KEY = "trainingBannerDismissed_v1";
const TRAINING_PROMOTION_PUBLIC_ROUTES = new Set(["/", ABOUT_ROUTE, DONATION_ROUTE]);
const PRIVATE_ROUTE_SECTIONS = {
  "linea-del-tiempo": "timeline",
  observatorio: "observatory",
  atlas: "atlas",
  "atlas-3d": "atlas3d",
  "mi-espacio": "space",
  space: "space",
  "mi-lista": "list",
  lista: "list",
  list: "list",
  mapas: "maps",
  maps: "maps",
  herramientas: "tools",
  tools: "tools",
  formacion: "training",
  training: "training",
  sesiones: "sessions",
  sessions: "sessions",
  suscripcion: "plans",
  subscription: "plans",
  plans: "plans",
  informes: "reports",
  reports: "reports",
  tienda: "store",
  store: "store",
  prognosis: "prognosis",
  prognostico: "prognosis",
  transitos: "transits",
  transits: "transits",
  administracion: "admin",
  admin: "admin"
};
let transitCalculation = null;
let progressedCalculation = null;
let chartWheelRenderSequence = 0;
let solarReturnCalculation = null;
let solarReturnNatalVisible = false;
let solarReturnComparisonVisible = false;
let customChartSelection = loadCustomChartSelection();
let synastryCalculation = null;
let compositeCalculation = null;
const storedChartViewType = localStorage.getItem(CHART_VIEW_TYPE_STORAGE_KEY) || "";
let activeChartViewType = Array.from(chartWheelTypeSelect?.options || []).
some((option) => option.value === storedChartViewType) ?
storedChartViewType :
"";
if (storedChartViewType && !activeChartViewType) {
  localStorage.removeItem(CHART_VIEW_TYPE_STORAGE_KEY);
}
let nodalReferenceState = { profileKey: "", date: "" };
let privateTransitNatalCache = new Map();
let privateTransitRequestId = 0;
let privateTransitRows = [];
let privateTransitFilterPlanet = "";
let privateTransitFilterOrb = "3";
let privateTransitRenderContext = null;
let currentDailyHoroscope = null;
let attachedContextDocuments = [];
let contextFilesBusy = false;
let contextDragDepth = 0;
let floatingPanelZ = 10;
let chatContextSelection = readChatContextSelection();
let chatModalSidebar = null;
let chartWheelSurface = "";
let privateMapsView = "charts";
const GUEST_CHART_TYPES = new Set(["multiple", "customChart", "tropical", "memoria", "sideral"]);

function swapChartAndChatSurfaces() {
  if (!chartMainPanel || !chatPanel || !chatSidebar || !chartWheelModal || !chatIaDialog) return;

  chatSidebarCollapsed = false;
  localStorage.setItem("chatSidebarCollapsed", "false");
  mountChartWheelInChat();

  chatIaDialog.classList.add("chat-modal-dialog");
  chatPanel.classList.add("chat-panel-modal");

  if (closeChartWheelButton) {
    closeChartWheelButton.classList.add("chat-modal-close");
    I18n.bind(closeChartWheelButton, "@aria-label", () => T("interface.cerrar_chat"));
    I18n.bind(closeChartWheelButton, "title", () => T("interface.cerrar_chat"));
    chatPanel.prepend(closeChartWheelButton);
  }

  chatModalSidebar = document.createElement("aside");
  chatModalSidebar.className = "sidebar chat-modal-sidebar";
  I18n.bind(chatModalSidebar, "@aria-label", () => T("interface.conversaciones_del_chat"));
  chatModalSidebar.addEventListener("click", handleChatModalSidebarClick);
  chatIaDialog.appendChild(chatModalSidebar);
  chatIaDialog.appendChild(chatPanel);
  syncChatModalSidebar();
}

function mountChatInPrivateMaps() {
  if (!privateMapsChat || !chatPanel) return;

  if (chatIaDialog?.open) chatIaDialog.close();
  chatPanel.classList.add("chat-panel-modal", "private-maps-chat-panel");
  privateMapsChat.appendChild(chatPanel);
  if (closeChartWheelButton) {
    closeChartWheelButton.classList.add("chat-modal-close");
    I18n.bind(closeChartWheelButton, "@aria-label", () => T("interface.volver_a_mapas"));
    I18n.bind(closeChartWheelButton, "title", () => T("interface.volver_a_mapas"));
    chatPanel.prepend(closeChartWheelButton);
  }
}

function setPrivateMapsView(view = "charts") {
  privateMapsView = "charts";
  privateScreen?.classList.remove("private-maps-chat-active");
  privateMapsStage?.classList.remove("is-hidden");
}

function isPrivateRoutePath(pathname = I18n.routePath()) {
  return pathname === "/private" || pathname.startsWith("/private/");
}

function getPrivateSectionFromRoute(pathname = I18n.routePath()) {
  if (!isPrivateRoutePath(pathname)) return "list";
  const slug = decodeURIComponent(pathname.replace(/^\/private\/?/, "").split("/")[0] || "");
  return PRIVATE_ROUTE_SECTIONS[slug] || "list";
}

function getPrivateToolsViewFromRoute(pathname = I18n.routePath()) {
  if (!isPrivateRoutePath(pathname) || getPrivateSectionFromRoute(pathname) !== "tools") return "transits";
  const routeParts = decodeURIComponent(pathname.replace(/^\/private\/?/, "")).
  split("/").
  filter(Boolean);
  return PRIVATE_TOOLS_ROUTE_VIEWS[routeParts[1]] || "transits";
}

function getPrivateTrainingViewFromRoute(pathname = I18n.routePath()) {
  if (!isPrivateRoutePath(pathname) || getPrivateSectionFromRoute(pathname) !== "training") return "courses";
  const routeParts = decodeURIComponent(pathname.replace(/^\/private\/?/, "")).
  split("/").
  filter(Boolean);
  return PRIVATE_TRAINING_ROUTE_VIEWS[routeParts[1]] || "courses";
}

function getPrivateSectionPath(section = "list", options = {}) {
  const slug = PRIVATE_SECTION_ROUTES[section] || PRIVATE_SECTION_ROUTES.list;
  if (section === "tools") {
    const toolsView = options.toolsView === "natal" ?
    "natal" :
    options.toolsView === "transits" ?
    "transits" :
    activePrivateToolsView;
    return `/private/${slug}/${PRIVATE_TOOLS_VIEW_ROUTES[toolsView]}`;
  }
  if (section === "training") {
    const trainingView = Object.hasOwn(PRIVATE_TRAINING_VIEW_ROUTES, options.trainingView) ?
    options.trainingView : activePrivateTrainingView;
    return `/private/${slug}/${PRIVATE_TRAINING_VIEW_ROUTES[trainingView]}`;
  }
  return `/private/${slug}`;
}

function updatePrivateSectionRoute(section = "list", options = {}) {
  if (!isPrivateRoutePath(I18n.routePath())) return;
  const nextPath = getPrivateSectionPath(section, {
    toolsView: options.toolsView,
    trainingView: options.trainingView
  });
  if (I18n.routePath() === nextPath) return;
  const method = options.replace ? "replaceState" : "pushState";
  history[method](null, "", nextPath);
}

function mountChartWheelInChat() {
  if (!chartMainPanel || !chartWheelModal) return;
  chartMainPanel.appendChild(chartWheelModal);
  chartWheelModal.classList.add("chart-wheel-inline");
  chartWheelModal.classList.remove("private-chart-wheel-inline");
  if (sidebarChartControls && chartWheelControls) {
    sidebarChartControls.appendChild(chartWheelControls);
  }
  chartWheelSurface = "chat";
}

function mountChartWheelInPrivateMaps() {
  if (!privateMapsStage || !chartWheelModal) return;
  if (chartWheelModal.parentElement !== privateMapsStage) {
    privateMapsStage.appendChild(chartWheelModal);
  }
  chartWheelModal.classList.add("chart-wheel-inline", "private-chart-wheel-inline");
  if (privateMapControls && chartWheelControls && chartWheelControls.parentElement !== privateMapControls) {
    privateMapControls.appendChild(chartWheelControls);
  }
  chartWheelSurface = "private-maps";
}

function syncPrivateMapContextPlacement() {
  const isMobile = privateMapControlsMobileQuery.matches;

  if (privateMapContext) {
    const target = isMobile ?
    privateMapMobileContextSlot :
    privateMapCollapsedContextSlot;
    if (target && privateMapContext.parentElement !== target) {
      target.appendChild(privateMapContext);
    }
  }

  if (!privateMapOffer) return;
  if (isMobile) {
    if (privateMapMobileOfferSlot && privateMapOffer.parentElement !== privateMapMobileOfferSlot) {
      privateMapMobileOfferSlot.appendChild(privateMapOffer);
    }
  } else if (privateMapActions && privateMapOffer.parentElement !== privateMapActions) {
    privateMapActions.insertBefore(privateMapOffer, privateMapChatButton || null);
  }
}

function mountChartWheelInGuestMaps() {
  if (!guestMapsStage || !guestMapControls || !chartWheelModal) return;
  guestMapsStage.appendChild(chartWheelModal);
  chartWheelModal.classList.add("chart-wheel-inline", "private-chart-wheel-inline", "guest-chart-wheel-inline");
  if (chartWheelControls) guestMapControls.appendChild(chartWheelControls);
  chartWheelSurface = "guest-maps";
}

function syncChatModalSidebar() {
  if (!chatModalSidebar || !chatSidebar) return;

  I18n.bind(chatModalSidebar, "innerHTML", () => chatSidebar.innerHTML);
  const modalBrandRow = chatModalSidebar.querySelector(".sidebar-brand-row");
  if (modalBrandRow) {
    I18n.bind(modalBrandRow, "innerHTML", () => '<img class="brand-logo sidebar-logo" src="/assets/eliseo-logo-tight.png?v=2" alt="Eliseo">');
  }
  chatModalSidebar.querySelectorAll("[id]").forEach((element) => {
    element.dataset.mirrorId = element.id;
    element.removeAttribute("id");
  });
  chatModalSidebar.querySelector('[data-mirror-id="chat-private"]')?.remove();
  chatModalSidebar.querySelector('[data-mirror-id="sidebar-chart-controls"]')?.remove();
}

async function handleChatModalSidebarClick(event) {
  const button = event.target.closest("button, a");
  if (!button || !chatModalSidebar?.contains(button)) return;

  const mirrorId = button.dataset.mirrorId || "";
  const chatAction = button.dataset.action || "";
  const folderAction = button.dataset.folderAction || "";

  if (mirrorId === "new-chat") {
    event.preventDefault();
    newChatButton?.click();
    syncChatModalSidebar();
    return;
  }

  if (mirrorId === "switch-person") {
    event.preventDefault();
    openPersonSwitchModal();
    return;
  }

  if (mirrorId === "create-chat-folder") {
    event.preventDefault();
    await createChatFolder();
    syncChatModalSidebar();
    return;
  }

  if (mirrorId === "toggle-chat-history") {
    event.preventDefault();
    chatHistoryCollapsed = !chatHistoryCollapsed;
    openChatMenuId = "";
    openMoveChatId = "";
    saveChatUiPreferences();
    renderChatHistory();
    return;
  }

  if (mirrorId === "open-chart-wheel") {
    event.preventDefault();
    input?.focus();
    return;
  }

  if (folderAction) {
    event.preventDefault();
    const folderId = button.dataset.folderId || "";
    if (folderAction === "menu") {
      openFolderMenuId = openFolderMenuId === folderId ? "" : folderId;
      openChatMenuId = "";
      openMoveChatId = "";
      renderChatFolders();
      syncChatModalSidebar();
    } else if (folderAction === "delete") {
      await deleteChatFolder(folderId);
      syncChatModalSidebar();
    }
    return;
  }

  if (button.dataset.folderId) {
    event.preventDefault();
    activeChatFolderId = button.dataset.folderId;
    openChatMenuId = "";
    openMoveChatId = "";
    openFolderMenuId = "";
    renderChatFolders();
    saveChatUiPreferences();
    renderChatHistory();
    return;
  }

  if (chatAction) {
    event.preventDefault();
    const chatId = button.dataset.id;
    if (chatAction === "load") {
      await loadSavedChat(chatId);
    } else if (chatAction === "menu") {
      openChatMenuId = openChatMenuId === chatId ? "" : chatId;
      openMoveChatId = "";
      renderChatHistory();
    } else if (chatAction === "pin") {
      togglePinnedChat(chatId);
    } else if (chatAction === "rename") {
      await renameSavedChat(chatId);
    } else if (chatAction === "move") {
      openMoveChatId = openMoveChatId === chatId ? "" : chatId;
      renderChatHistory();
    } else if (chatAction === "move-to") {
      await moveChatToFolder(chatId, button.dataset.folderId || "");
    } else if (chatAction === "create-folder-move") {
      await createFolderAndMoveChat(chatId);
    } else if (chatAction === "download") {
      await downloadSavedChat(chatId);
    } else if (chatAction === "delete") {
      await deleteSavedChat(chatId);
    }
    syncChatModalSidebar();
  }
}

const DEFAULT_CAPABILITIES = { get
  plan() {return { key: "free", get label() {return T("navigation.notSubscribed");}, get description() {return T("interface.acceso_basico_a_creacion_de_cartas");}, includedCredits: 0 };},





  maxPeople: 500,
  maxChatsPerPerson: 3,
  maxMessagesPerChat: 40,
  includedCredits: 0,
  allowedModelLevels: ["quick", "balanced"],
  canExportChartData: false,
  canUsePremiumModel: false,
  canUseTags: false,
  canExportPdf: false,
  isSubscribed: false
};

const SUBSCRIBED_ACCOUNT_EMAILS = new Set(["pello566@gmail.com"]);
const SUBSCRIPTION_MAX_PEOPLE = 2000;

const ADMIN_PLAN_LABELS = { get
  essential() {return T("interface.esencial");}, get
  personal() {return T("interface.personal");}, get
  professional() {return T("interface.profesional");}
};

const SUBSCRIPTION_STATUS_LABELS = { get
  subscribed() {return T("interface.suscrito");}, get
  unsubscribed() {return T("navigation.notSubscribed");}
};

const ADMIN_ORDER_STATUS_LABELS = { get
  test_requested() {return T("interface.prueba_solicitada");}, get
  pending() {return T("interface.pendiente");}, get
  in_review() {return T("interface.en_revision");}, get
  completed() {return T("interface.completado");}, get
  cancelled() {return T("interface.cancelado");}
};

const ADMIN_WAITLIST_STATUS_LABELS = { get
  waiting() {return T("interface.pendiente");}, get
  notified() {return T("interface.notificado");}, get
  cancelled() {return T("interface.cancelado");}
};

const PROMPT_PLANET_LABELS = {
  Sun: "Sol",
  Moon: "Luna",
  Mercury: "Mercurio",
  Venus: "Venus",
  Mars: "Marte",
  Jupiter: "Júpiter",
  Saturn: "Saturno",
  Uranus: "Urano",
  Neptune: "Neptuno",
  Pluto: "Plutón",
  "true Node": "Nodo norte",
  "south Node": "Nodo sur",
  Lilith: "Lilith",
  "Part of Fortune": "Parte de la Fortuna",
  "Part of Misfortune": "Parte del Infortunio",
  Vertex: "Vertex",
  Chiron: "Quirón",
  Ceres: "Ceres",
  Pallas: "Palas",
  Juno: "Juno",
  Vesta: "Vesta",
  Chariklo: "Chariklo",
  Eros: "Eros",
  Eris: "Eris",
  Icarus: "Ícaro",
  Nessus: "Nessus",
  Pholus: "Pholus",
  Psyche: "Psique",
  midpoint: "Punto medio Sol-Luna",
  Ascendant: "Ascendente",
  Midheaven: "Medio Cielo",
  Descendant: "Descendente",
  ImumCoeli: "Bajo Cielo",
  tierra: "Tierra"
};
const PROMPT_PRIMARY_PLANET_ORDER = ["Sun", "Moon", "Mercury", "Venus", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune", "Pluto"];
const PROMPT_OPTIONAL_BODY_ORDER = ["Lilith", "Part of Fortune", "Part of Misfortune", "Vertex", "Chiron", "Ceres", "Pallas", "Juno", "Vesta", "Chariklo", "Eros", "Eris", "Icarus", "Nessus", "Pholus", "Psyche"];
const PROMPT_TECHNICAL_POINT_ORDER = ["true Node", "south Node", "midpoint"];
const PROMPT_ASPECT_ORDER = [...PROMPT_PRIMARY_PLANET_ORDER, ...PROMPT_TECHNICAL_POINT_ORDER, ...PROMPT_OPTIONAL_BODY_ORDER];
const NODAL_ASPECT_ORDER = [...PROMPT_ASPECT_ORDER];
const PROMPT_CUSP_HOUSES = Array.from({ length: 12 }, (_, index) => index + 1);
const PROMPT_SIGNS = ["Aries", "Tauro", "Geminis", "Cancer", "Leo", "Virgo", "Libra", "Escorpio", "Sagitario", "Capricornio", "Acuario", "Piscis"];
const ZODIAC_SYMBOLS = ["\u2648\uFE0E", "\u2649\uFE0E", "\u264A\uFE0E", "\u264B\uFE0E", "\u264C\uFE0E", "\u264D\uFE0E", "\u264E\uFE0E", "\u264F\uFE0E", "\u2650\uFE0E", "\u2651\uFE0E", "\u2652\uFE0E", "\u2653\uFE0E"];
const ZODIAC_COLORS = ["#e9a1a1", "#b9dfbd", "#fff2a9", "#9fcff2", "#e9a1a1", "#b9dfbd", "#fff2a9", "#9fcff2", "#e9a1a1", "#b9dfbd", "#fff2a9", "#9fcff2"];
const ZODIAC_GLYPH_COLORS = ["rgb(229, 115, 115)", "rgb(129, 199, 132)", "rgb(255, 241, 118)", "rgb(100, 181, 246)", "rgb(229, 115, 115)", "rgb(129, 199, 132)", "rgb(255, 241, 118)", "rgb(100, 181, 246)", "rgb(229, 115, 115)", "rgb(129, 199, 132)", "rgb(255, 241, 118)", "rgb(100, 181, 246)"];
const ZODIAC_LIGHT_GLYPH_COLORS = ["#b73a3a", "#277443", "#c4a000", "#236fa6", "#b73a3a", "#277443", "#c4a000", "#236fa6", "#b73a3a", "#277443", "#c4a000", "#236fa6"];
const ZODIAC_TABLE_COLORS = ["#d34f4f", "#348f52", "#c89b12", "#2f8fd2", "#d34f4f", "#348f52", "#c89b12", "#2f8fd2", "#d34f4f", "#348f52", "#c89b12", "#2f8fd2"];
const PEOPLE_SOLAR_COLORS = ["#c94c4c", "#4f9a66", "#c08a18", "#3f8ec7", "#c94c4c", "#4f9a66", "#c08a18", "#3f8ec7", "#c94c4c", "#4f9a66", "#c08a18", "#3f8ec7"];
const PLANET_SYMBOLS = {
  Sun: "\u2609",
  Moon: "\u263D",
  Mercury: "\u263F",
  Venus: "\u2640",
  Mars: "\u2642",
  Jupiter: "\u2643",
  Saturn: "\u2644",
  Uranus: "\u2645",
  Neptune: "\u2646",
  Pluto: "\u2647",
  "true Node": "\u260A",
  "south Node": "\u260B",
  Lilith: "\u26B8",
  "Part of Fortune": "\u2297",
  "Part of Misfortune": "\u2298",
  Vertex: "Vx",
  Chiron: "\u26B7",
  Ceres: "\u26B3",
  Pallas: "\u26B4",
  Juno: "\u26B5",
  Vesta: "\u26B6",
  Chariklo: "Ch",
  Eros: "E",
  Eris: "\u2BF0",
  Icarus: "Ic",
  Nessus: "N",
  Pholus: "Ph",
  Psyche: "\u03A8",
  // Keep the eight-point star typographic on iOS instead of its orange emoji.
  midpoint: "\u2734\uFE0E",
  Ascendant: "ASC",
  Midheaven: "MC",
  Descendant: "DESC",
  ImumCoeli: "BC",
  tierra: "\u2295"
};
const PLANET_COLORS = {
  Sun: "#ff0000",
  Moon: "#ff0000",
  Mercury: "#1e4f8f",
  Venus: "#1e4f8f",
  Mars: "#1e4f8f",
  Jupiter: "#2f8f46",
  Saturn: "#8b5a2b",
  Uranus: "#f505f0",
  Neptune: "#f505f0",
  Pluto: "#f505f0",
  "true Node": "#111827",
  "south Node": "#111827",
  Lilith: "#6d28d9",
  "Part of Fortune": "#b7791f",
  "Part of Misfortune": "#7f1d1d",
  Vertex: "#475569",
  Chiron: "#0f766e",
  Ceres: "#3f7d44",
  Pallas: "#1d4ed8",
  Juno: "#a21caf",
  Vesta: "#c2410c",
  Chariklo: "#0e7490",
  Eros: "#be123c",
  Eris: "#7e22ce",
  Icarus: "#ea580c",
  Nessus: "#78350f",
  Pholus: "#4d7c0f",
  Psyche: "#9333ea",
  midpoint: "#111827",
  Ascendant: "#b42318",
  Midheaven: "#b42318",
  Descendant: "#b42318",
  ImumCoeli: "#b42318",
  tierra: "#ff8c00"
};
const CHART_DEFAULT_PLANET_COLORS = Object.freeze({ ...PLANET_COLORS });
const CHART_PLANET_COLOR_KEYS = Object.freeze(Object.keys(CHART_DEFAULT_PLANET_COLORS));
const CHART_PLANET_COLOR_PRESETS = Object.freeze([
Object.freeze({ value: "#ff0000", get label() {return T("interface.rojo");} }),
Object.freeze({ value: "#1e4f8f", get label() {return T("interface.azul");} }),
Object.freeze({ value: "#2f8f46", get label() {return T("interface.verde");} }),
Object.freeze({ value: "#8b5a2b", get label() {return T("interface.tierra");} }),
Object.freeze({ value: "#f505f0", get label() {return T("interface.magenta");} }),
Object.freeze({ value: "#6d28d9", get label() {return T("interface.violeta");} }),
Object.freeze({ value: "#0f766e", get label() {return T("interface.turquesa");} }),
Object.freeze({ value: "#b7791f", get label() {return T("interface.ocre");} }),
Object.freeze({ value: "#c2410c", get label() {return T("interface.naranja");} }),
Object.freeze({ value: "#111827", get label() {return T("interface.tinta");} })]
);

function syncAspectFinderPlanetSelectAppearance(select) {
  if (!select) return;

  select.style.setProperty(
    "--aspect-finder-planet-color",
    chartPlanetColorCssValue(select.value, "var(--text)")
  );

  Array.from(select.options).forEach((option) => {
    option.style.color = chartPlanetColorCssValue(option.value, "");
  });
}

function syncAspectFinderPlanetSelectsAppearance() {
  syncAspectFinderPlanetSelectAppearance(aspectFinderPlanetA);
  syncAspectFinderPlanetSelectAppearance(aspectFinderPlanetB);
}

const TROPICAL_TRANSIT_LABEL_VISUALS = {
  protectedAnglePadding: 60,
  minLabelDistance: 14,
  minLabelGapX: 10,
  minLabelGapY: 10,
  // Compact fallback lanes. Transit and progression charts normally use the
  // ordered perimeter layout below, which avoids clamping several lanes onto
  // the same SVG edge.
  transitLabelRadii: [8, 34, 60],
  maxTangentialShift: 110,
  leaderLineOpacity: 0.42,
  transitFontSize: 15.2,
  transitGlyphFontSize: 27,
  transitMajorGlyphFontSize: 32
};
const SYNASTRY_EXTERIOR_LABEL_VISUALS = {
  minLabelDistance: 38,
  minLabelGapX: 38,
  minLabelGapY: 24,
  // Relative to the synastry exterior anchor radius; B remains outside A without drifting too far.
  labelRadii: [34, 58, 82],
  maxTangentialShift: 42,
  leaderLineOpacity: 0.42,
  fontSize: 13
};
const ASPECT_SYMBOLS = {
  0: "\u260C",
  30: "\u26BA",
  45: "\u2220",
  60: "\u26B9",
  72: "Q",
  90: "\u25A1",
  120: "\u25B3",
  135: "\u26BC",
  144: "bQ",
  150: "\u26BB",
  180: "\u260D"
};
const ASPECT_COLORS = {
  0: "var(--chart-aspect-conjunction)",
  30: "var(--chart-aspect-minor-harmonious)",
  45: "var(--chart-aspect-minor-tense)",
  60: "var(--chart-aspect-harmonious)",
  72: "var(--chart-aspect-creative)",
  90: "var(--chart-aspect-tense)",
  120: "var(--chart-aspect-harmonious)",
  135: "var(--chart-aspect-minor-tense)",
  144: "var(--chart-aspect-creative)",
  150: "var(--chart-aspect-quincunx)",
  180: "var(--chart-aspect-tense)"
};
const CHART_DEFAULT_ASPECT_COLORS = Object.freeze({
  0: "#d97706",
  30: "#5579a8",
  45: "#b84b5f",
  60: "#245fbd",
  72: "#7c3aed",
  90: "#d92d2d",
  120: "#245fbd",
  135: "#b84b5f",
  144: "#7c3aed",
  150: "#187044",
  180: "#d92d2d"
});
const CHART_ASPECT_COLOR_PRESETS = Object.freeze([
Object.freeze({ value: "#d97706", get label() {return T("interface.ambar");} }),
Object.freeze({ value: "#245fbd", get label() {return T("interface.azul");} }),
Object.freeze({ value: "#187044", get label() {return T("interface.verde");} }),
Object.freeze({ value: "#d92d2d", get label() {return T("interface.rojo");} }),
Object.freeze({ value: "#7c3aed", get label() {return T("interface.violeta");} }),
Object.freeze({ value: "#5579a8", get label() {return T("interface.azul_pizarra");} }),
Object.freeze({ value: "#b84b5f", get label() {return T("interface.carmin");} })]
);

function syncAspectFinderAspectSelectAppearance(select = aspectFinderAngle) {
  if (!select) return;

  const selectedAngle = Number(select.value);
  select.style.setProperty(
    "--aspect-finder-aspect-color",
    chartAspectColorCssValue(selectedAngle)
  );

  Array.from(select.options).forEach((option) => {
    const angle = Number(option.value);
    option.style.color = chartAspectColorCssValue(angle);
  });
}
const CURRENT_AGE_SYMBOL = "\uD83E\uDDD1";
const ASPECT_CONFIGS = [
{ angle: 0, orb: 9, name: "conjuncion", label: "Conjunción", group: "principal" },
{ angle: 30, orb: 2, name: "semisextil", label: "Semisextil", group: "menor" },
{ angle: 45, orb: 2, name: "semicuadratura", label: "Semicuadratura", group: "menor" },
{ angle: 60, orb: 5, name: "sextil", label: "Sextil", group: "principal" },
{ angle: 72, orb: 2, name: "quintil", label: "Quintil", group: "menor" },
{ angle: 90, orb: 9, name: "cuadratura", label: "Cuadratura", group: "principal" },
{ angle: 120, orb: 9, name: "trigono", label: "Trígono", group: "principal" },
{ angle: 135, orb: 2, name: "sesquicuadratura", label: "Sesquicuadratura", group: "menor" },
{ angle: 144, orb: 2, name: "biquintil", label: "Biquintil", group: "menor" },
{ angle: 150, orb: 3, name: "quincuncio", label: "Quincuncio", group: "menor" },
{ angle: 180, orb: 9, name: "oposicion", label: "Oposición", group: "principal" }];

const VISUAL_ASPECT_ANGLES = new Set(ASPECT_CONFIGS.map((aspect) => aspect.angle));
const CHART_LEGACY_DEFAULT_VISIBLE_ASPECT_ANGLES = [0, 60, 72, 90, 120, 150, 180];
const CHART_DEFAULT_VISIBLE_ASPECT_ANGLES = [0, 60, 90, 120, 150, 180];
function isEnabledAspect(aspect = {}) {
  const angle = Number(aspect?.angle ?? aspect?.aspect?.angle);
  return VISUAL_ASPECT_ANGLES.has(angle);
}
function filterEnabledAspects(aspects = []) {
  return (Array.isArray(aspects) ? aspects : []).filter((aspect) =>
  isEnabledAspect(aspect) && isChartAspectTypeVisible(aspect?.angle)
  );
}
function isHabitualChartAspect(aspect = {}) {
  const angle = Number(aspect?.angle ?? aspect?.aspect?.angle);
  return CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.includes(angle);
}
const CHART_ASCENDANT_KEY = "Ascendant";
const CHART_ANGLE_POINTS = Object.freeze([
Object.freeze({ key: CHART_ASCENDANT_KEY, house: 1, label: "Ascendente", shortLabel: "ASC" }),
Object.freeze({ key: "Midheaven", house: 10, label: "Medio Cielo", shortLabel: "MC" }),
Object.freeze({ key: "Descendant", house: 7, label: "Descendente", shortLabel: "DESC" }),
Object.freeze({ key: "ImumCoeli", house: 4, label: "Bajo Cielo", shortLabel: "BC" })]
);
const CHART_ANGLE_POINT_KEYS = CHART_ANGLE_POINTS.map((point) => point.key);
const CHART_ANGLE_POINT_BY_HOUSE = new Map(CHART_ANGLE_POINTS.map((point) => [point.house, point]));
const CHART_PLANET_ORDER = [...PROMPT_PRIMARY_PLANET_ORDER, "true Node", "south Node", ...PROMPT_OPTIONAL_BODY_ORDER];
const CHART_SELECTABLE_PLANETS = [
...PROMPT_PRIMARY_PLANET_ORDER,
...CHART_ANGLE_POINT_KEYS,
...PROMPT_TECHNICAL_POINT_ORDER,
...PROMPT_OPTIONAL_BODY_ORDER];

const CHART_DEFAULT_VISIBLE_PLANETS = [...PROMPT_PRIMARY_PLANET_ORDER, ...CHART_ANGLE_POINT_KEYS, ...PROMPT_TECHNICAL_POINT_ORDER];
const CHART_DEFAULT_ASPECT_PLANETS = [...PROMPT_PRIMARY_PLANET_ORDER];
const CHART_PLANET_VISIBILITY_STORAGE_KEY = "astroanamnesis:chart-visible-planets";
const CHART_PLANET_ASPECT_VISIBILITY_STORAGE_KEY = "astroanamnesis:chart-aspect-planets";
const CHART_PLANET_VISIBILITY_SCHEMA_STORAGE_KEY = "astroanamnesis:chart-visible-planets-schema";
const CHART_PLANET_ASPECT_VISIBILITY_SCHEMA_STORAGE_KEY = "astroanamnesis:chart-aspect-planets-schema";
const CHART_PLANET_VISIBILITY_SCHEMA_VERSION = "4";
const CHART_PLANET_COLORS_STORAGE_KEY = "astroanamnesis:chart-planet-colors";
const CHART_ASPECT_TYPE_VISIBILITY_STORAGE_KEY = "astroanamnesis:chart-visible-aspect-types";
const CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_STORAGE_KEY = "astroanamnesis:chart-visible-aspect-types-schema";
const CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_VERSION = "2";
const CHART_ASPECT_ORBS_STORAGE_KEY = "astroanamnesis:chart-aspect-orbs";
const CHART_ASPECT_COLORS_STORAGE_KEY = "astroanamnesis:chart-aspect-colors";
const CHART_ASPECT_ORB_MIN = 0;
const CHART_ASPECT_ORB_MAX = 15;
const CHART_ASPECT_ORB_STEP = 0.5;
const CHART_DEFAULT_ASPECT_ORBS = Object.freeze(Object.fromEntries(
  ASPECT_CONFIGS.map((aspect) => [aspect.angle, aspect.orb])
));
const CHART_HOUSE_SYSTEM_STORAGE_KEY = "astroanamnesis:chart-house-system";
const DEFAULT_CHART_HOUSE_SYSTEM = "placidus";
const CHART_HOUSE_SYSTEMS = Object.freeze({ get
  placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get
  koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get
  alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get
  topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get
  porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get
  regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get
  campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get
  polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get
  equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get
  wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get
  wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get
  vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get
  morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get
  none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };}
});
let chartVisiblePlanetKeys = loadChartVisiblePlanetKeys();
let chartAspectPlanetKeys = loadChartAspectPlanetKeys();
let chartPlanetColors = loadChartPlanetColors();
let chartPlanetColorsBeforeDialog = null;
let activeChartPlanetColorKey = null;
let chartPlanetColorReturnFocus = null;
applyChartPlanetColorVariables();
let chartVisibleAspectAngles = loadChartVisibleAspectAngles();
let chartAspectOrbs = loadChartAspectOrbs();
let chartAspectColors = loadChartAspectColors();
let chartAspectColorsBeforeDialog = null;
let activeChartAspectColorAngle = null;
let chartAspectColorReturnFocus = null;
applyChartAspectColorVariables();
let chartHouseSystemKey = loadChartHouseSystemKey();
let activeChartSettingsTab = "bodies";
const FREE_TRANSIT_PLANET_ORDER = ["Sun", "Moon", "Mercury", "Venus", "Mars", "Jupiter", "Saturn"];
const FREE_TRANSIT_ASPECTS = [
{ key: "conjunción", get label() {return T("interface.conjuncion_2");}, angle: 0, score: 10 },
{ key: "sextil", get label() {return T("interface.sextil_2");}, angle: 60, score: 5 },
{ key: "cuadratura", get label() {return T("interface.cuadratura_2");}, angle: 90, score: 9 },
{ key: "trígono", get label() {return T("interface.trigono_2");}, angle: 120, score: 6 },
{ key: "oposición", get label() {return T("interface.oposicion_2");}, angle: 180, score: 9 }];

const FREE_TRANSIT_ORBS = {
  Moon: 0.75,
  Sun: 1,
  Mercury: 1,
  Venus: 1,
  Mars: 1,
  Jupiter: 1.5,
  Saturn: 1.5
};
const FREE_TRANSIT_FALLBACK_MAX_ORB = 5;
const FREE_TRANSIT_PLANET_SCORES = {
  Saturn: 10,
  Jupiter: 8,
  Mars: 7,
  Sun: 6,
  Venus: 5,
  Mercury: 4,
  Moon: 3
};
const FREE_NATAL_PLANET_SCORES = {
  Sun: 10,
  Moon: 10,
  Saturn: 8,
  Venus: 7,
  Mars: 7,
  Mercury: 6,
  Jupiter: 6
};
const FREE_TRANSIT_PLANET_NAMES = {
  Sun: "Sol",
  Moon: "Luna",
  Mercury: "Mercurio",
  Venus: "Venus",
  Mars: "Marte",
  Jupiter: "Júpiter",
  Saturn: "Saturno"
};
let FREE_TRANSIT_INTERPRETATIONS = [];
let FREE_TRANSIT_INTERPRETATION_INDEX = new Map();
const freeTransitInterpretationsReady = loadFreeTransitInterpretations();
const DEFAULT_THEME = "indigo";
const THEME_STORAGE_VERSION = "2";
const THEME_KEYS = ["indigo", "teal", "dark", "magenta", "amber", "eclipse", "aurora"];
const ACCOUNT_TEXT_SIZE_STORAGE_KEY = "astroanamnesis:accountTextSize";
const ACCOUNT_REDUCE_MOTION_STORAGE_KEY = "astroanamnesis:accountReduceMotion";
const ACCOUNT_TEXT_SIZES = ["normal", "large", "extra-large"];
const ACCOUNT_PROFILE_LANGUAGES = ["es", "ca", "en", "fr", "de", "it", "pt"];
const EXAMPLE_QUESTIONS = [
"Quiero una lectura completa",
"¿Qué patrón suelo repetir en mis relaciones?",
"¿Qué tipo de personas me activan emocionalmente?",
"¿Por qué me cuesta soltar ciertas relaciones?",
"¿Qué personaje he construido para sentirme querido?",
"¿Qué espera mi inconsciente de los demás?",
"¿Qué me decepciona siempre en pareja?",
"¿Qué parte de mí proyecto en los otros?",
"¿Qué bloqueo se repite en mi trabajo o vocación?",
"¿Qué necesito observar para dejar de repetir el mismo bucle?",
"¿Qué cualidad de mi Self está reprimida detrás de mi personaje?"];

const MEMORIA_CUSP_REMAP = {
  1: 7,
  2: 6,
  3: 5,
  4: 4,
  5: 3,
  6: 2,
  7: 1,
  8: 12,
  9: 11,
  10: 10,
  11: 9,
  12: 8
};
const LEGAL_CONSENT_KEY = "eliseoLegalConsentAccepted";
const LEGAL_SECTIONS = window.AstroLegal.sections;

populateDateTimeSelects(monthSelect, hourSelect, minuteSelect);
populateDateTimeSelects(personMonthSelect, personHourSelect, personMinuteSelect);
applyTheme(getInitialTheme(), { persist: true });
accountTextSize = readStoredAccountTextSize();
accountReduceMotion = readStoredReduceMotion();
applyAccountAccessibilityPreferences({ persist: false });
initLandingAstroDiagramLayout();
initLandingReveals();
renderPromptSuggestions();

renderLegalConsentState();
modelLevelSelect.value = localStorage.getItem("modelLevel") || "balanced";
countriesPromise = loadCountries();
moduleVisibilityLoadPromise = loadModuleVisibilityFromServer();
if (I18n.routePath() === DONATION_ROUTE) {
  showDonationPage(false);
  document.documentElement.classList.remove("is-donation-route-pending");
}
if (I18n.routePath() === ABOUT_ROUTE) {
  showAboutPage(false);
  document.documentElement.classList.remove("is-about-route-pending");
}
window.AppAuthReady = loadAuthState();
window.addEventListener("pageshow", handleAuthPageRestore);
window.addEventListener("focus", () => {
  void refreshAccountSubscriptionState();
});
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") void refreshAccountSubscriptionState();
});
if (birthProfile && activePersonId && !birthProfile.personId) {
  birthProfile.personId = activePersonId;
  localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
}

birthForm.addEventListener("submit", async (event) => {
  event.preventDefault();

  if (!acceptLegalConsentFromInput(birthLegalConsentInput, setFormStatus)) return;

  const profile = getBirthProfileFromForm(new FormData(birthForm));
  if (!isValidBirthProfile(profile)) return;

  setFormStatus(() => T("interface.calculando_cartas"));
  setCalculateBusy(true);

  try {
    const calculation = await calculateBirthCharts(profile);
    birthProfile = {
      ...profile,
      lat: String(calculation.profile.location.lat),
      lon: String(calculation.profile.location.lon),
      tz: calculation.profile.location.tz,
      city: calculation.profile.location.name,
      country: calculation.profile.location.country,
      countryName: calculation.profile.location.countryName || profile.countryName
    };
    chartCalculation = calculation;
    progressedCalculation = null;
    setActiveChartViewType("multiple", { syncControls: true });
    if (activePersonId) birthProfile.personId = activePersonId;
    if (currentUser) {
      localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
      localStorage.setItem("birthChartCalculation", JSON.stringify(chartCalculation));
    } else {
      localStorage.removeItem("birthProfile");
      localStorage.removeItem("birthChartCalculation");
    }
    conversationId = "";
    activeChatId = "";
    localStorage.removeItem("conversationId");
    localStorage.removeItem("activeChatId");
    I18n.clear(messagesEl, "innerHTML");
    updateEmptyChatState();
    knowledgeStatusLoaded = false;
    chatContextPreloaded = false;
    if (!currentUser) {
      setFormStatus("");
      await openGuestMaps();
      return;
    }
    setFormStatus(() => T("interface.preparando_consulta"));
    await preloadChatContext();
    setFormStatus("");
    await openPrivateArea(true, "maps");
  } catch (error) {
    setFormStatus(() => error.message || T("interface.no_se_pudieron_calcular_las_cartas"), true);
  } finally {
    setCalculateBusy(false);
  }
});

openPrivateButton.addEventListener("click", () => {
  openPrivateArea();
});

authOpenButtons.forEach((button) => {
  button.addEventListener("click", () => openAuthDialog("login", button));
});

authModeButtons.forEach((button) => {
  button.addEventListener("click", () => setAuthDialogMode(button.dataset.authMode || "login"));
});

authDialogCloseButton?.addEventListener("click", closeAuthDialog);
authDialog?.addEventListener("click", (event) => {
  if (event.target === authDialog) closeAuthDialog();
  const toggle = event.target.closest('[data-password-toggle]');
  if (toggle && authDialog.contains(toggle)) {
    const input = document.getElementById(toggle.dataset.passwordToggle);
    if (input && !input.disabled) setAuthPasswordVisibility(input, input.type === 'password');
  }
});
authDialog?.addEventListener("close", () => {
  resetAuthPasswordVisibility();
  const focusTarget = authDialogReturnFocus;
  authDialogReturnFocus = null;
  if (focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
});
authGuestButton?.addEventListener("click", () => {
  closeAuthDialog();
  showIntake();
});
authDialog?.addEventListener('submit', resetAuthPasswordVisibility, true);
authDialog?.addEventListener('reset', resetAuthPasswordVisibility);
authLoginForm?.addEventListener("submit", handleEmailLogin);
authRegisterForm?.addEventListener("submit", handleEmailRegistration);
authForgotForm?.addEventListener("submit", handlePasswordRecoveryRequest);
authResetForm?.addEventListener("submit", handlePasswordReset);
document.querySelector("#auth-verification-request-form")?.addEventListener("submit", handleVerificationRequest);
document.querySelector("#auth-verification-form")?.addEventListener("submit", handleEmailVerification);
document.querySelector("#auth-reauth-form")?.addEventListener("submit", handleReauthentication);

landingOpenPrivateButton?.addEventListener("click", () => {
  openPrivateArea(true, "space");
});

landingTryButtons.forEach((button) => {
  button.addEventListener("click", async () => {
    if (currentUser) {
      if (button.dataset.landingAuthAction === "new-chart") {
        await openPrivateArea(true, "list");
        openNewPersonForm();
      } else {
        await openPrivateArea(true, "space");
      }
      return;
    }
    showIntake();
  });
});

openAboutButtons.forEach((button) => {
  button.addEventListener("click", () => showAboutPage());
});

aboutHomeButtons.forEach((button) => {
  button.addEventListener("click", () => {
    showLanding();
    if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
    scrollPublicPageToTop();
  });
});

donationHomeButtons.forEach((button) => {
  button.addEventListener("click", () => {
    showLanding();
    if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
    scrollPublicPageToTop();
  });
});

contactDonationLink?.addEventListener("click", (event) => {
  const donationUrl = new URL(contactDonationLink.href, window.location.origin);
  if (donationUrl.origin !== window.location.origin || donationUrl.pathname !== DONATION_ROUTE) return;
  event.preventDefault();
  closeContactModal();
  showDonationPage(true);
});

async function handleDonationCopy(event) {
  const copyButton = event.target.closest("[data-donation-copy]");
  if (!copyButton) return;
  const value = clean(copyButton.dataset.donationCopy);
  if (!value) return;
  const originalLabel = copyButton.textContent;
  try {
    await navigator.clipboard.writeText(value);
    I18n.bind(copyButton, "textContent", () => T("interface.copiado"));
  } catch {
    I18n.bind(copyButton, "textContent", () => T("interface.no_se_pudo_copiar"));
  }
  window.setTimeout(() => {
    I18n.bind(copyButton, "textContent", () => originalLabel);
  }, 1800);
}

donationMethods?.addEventListener("click", (event) => {
  const methodButton = event.target.closest("[data-donation-method]");
  if (methodButton) openDonationMethodDialog(methodButton.dataset.donationMethod, methodButton);
});

donationMethodDialog?.addEventListener("click", handleDonationCopy);
document.querySelectorAll("[data-donation-info-open]").forEach((button) => {
  button.addEventListener("click", () => openDonationInfoDialog(button));
});

donationInfoCloseButton?.addEventListener("click", () => donationInfoDialog?.close());
donationMethodCloseButton?.addEventListener("click", () => donationMethodDialog?.close());
[donationInfoDialog, donationMethodDialog].forEach((dialog) => {
  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog?.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    event.preventDefault();
    dialog.close();
  });
  dialog?.addEventListener("close", restoreDonationDialogFocus);
});

aboutStartButtons.forEach((button) => {
  button.addEventListener("click", () => {
    if (currentUser) {
      openPrivateArea(true, "list");
      return;
    }
    showIntake();
    scrollPublicPageToTop();
  });
});

guestMapsNewChartButton?.addEventListener("click", () => {
  showIntake();
});

intakeHomeButton?.addEventListener("click", () => {
  setFormStatus("");
  showLanding();
  if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
  scrollPublicPageToTop();
});

themeButtons.forEach((button) => {
  // Night mode requires deliberate activation (click, tap or keyboard).
  if (button.dataset.themeChoice === "dark") {
    button.addEventListener("click", () => {
      applyTheme("dark", { persist: true });
    });
    return;
  }

  const canPreviewTheme = () =>
  !privateSidebarMobileQuery.matches &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches;


  button.addEventListener("pointerdown", (event) => {
    const usesTouchInput = event.pointerType === "touch" || event.pointerType === "pen";
    if (usesTouchInput) {
      applyTheme(button.dataset.themeChoice, { persist: true });
    }
  });
  button.addEventListener("mousedown", () => {
    if (privateSidebarMobileQuery.matches) {
      applyTheme(button.dataset.themeChoice, { persist: true });
    }
  });
  button.addEventListener("click", () => {
    applyTheme(button.dataset.themeChoice, { persist: true });
  });
  button.addEventListener("mouseenter", () => {
    if (canPreviewTheme()) previewTheme(button.dataset.themeChoice);
  });
  button.addEventListener("focus", () => {
    if (canPreviewTheme()) previewTheme(button.dataset.themeChoice);
  });
  button.addEventListener("mouseleave", () => {
    if (canPreviewTheme()) restoreSavedTheme();
  });
  button.addEventListener("blur", () => {
    if (canPreviewTheme()) restoreSavedTheme();
  });
});

chatPrivateButton.addEventListener("click", () => {
  openPrivateArea();
});

collapsedPrivateButton?.addEventListener("click", () => {
  closeCollapsedChatPopover();
  openPrivateArea();
});

privateMapPromptButton?.addEventListener("click", () => {
  openChartDataDialog();
});

privateMapChatButton?.addEventListener("click", () => {
  if (privateMapsView === "chat") {
    setPrivateMapsView("charts");
  } else {
    openChartWheelModal();
  }
});

privateMapListButton?.addEventListener("click", () => {
  showPrivateSection("list");
});

privateMapOffer?.addEventListener("click", async (event) => {
  const offerButton = event.target.closest("[data-map-offer-purchase]");
  if (!offerButton || privateMapOfferBusy || privateMapOfferRequested) return;

  const result = await purchaseBillingItem("service", "complete-reading", {
    context: buildPrivateMapPurchaseContext()
  });
  privateMapOfferRequested = Boolean(result);
  privateMapOfferStatus = result ?
  "Informe solicitado correctamente." :
  "No se pudo registrar la solicitud.";
  updatePrivateMapOffer();
});

privateMapContext?.addEventListener("click", (event) => {
  const actionButton = event.target.closest("[data-private-map-action]");
  if (!actionButton) return;

  const action = actionButton.dataset.privateMapAction;
  if (action === "switch") {
    openPersonSwitchModal();
  } else if (action === "list") {
    showPrivateSection("list");
  }
});

privateMapsStage?.addEventListener("click", (event) => {
  const actionButton = event.target.closest("[data-private-map-empty-action]");
  if (!actionButton) return;
  if (actionButton.dataset.privateMapEmptyAction === "list") {
    showPrivateSection("list");
  }
});

chatHomeButton?.addEventListener("click", () => {
  showLanding();
  if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
});

calculateAnotherChartButton?.addEventListener("click", () => {
  closeSidebarAccountMenu();
  showIntake();
  if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
});

sidebarAccountToggle?.addEventListener("click", () => {
  const open = sidebarAccountMenu?.classList.contains("is-hidden");
  sidebarAccountMenu?.classList.toggle("is-hidden", !open);
  sidebarAccountToggle.setAttribute("aria-expanded", open ? "true" : "false");
});

sidebarAccountMenu?.addEventListener("click", async (event) => {
  const actionButton = event.target.closest("[data-account-action]");
  if (!actionButton) return;

  closeSidebarAccountMenu();
  const action = actionButton.dataset.accountAction;

  if (action === "upgrade") {
    await openPrivateArea();
    showPrivateSection("plans");
    return;
  }

  if (action === "logout") {
    await logoutCurrentUser();
    return;
  }

  if (action === "settings") {
    openAccountSettings("account");
    return;
  }

  if (action === "admin") {
    await openAdminPanel();
    return;
  }

  if (action === "support") {
    openContactModal(actionButton);
    return;
  }

  const messages = {
    language: "Idioma: por ahora Eliseo está configurado en español."
  };
  setStatus(messages[action] || "");
});

privateAccount?.addEventListener("click", (event) => {
  const toggle = event.target.closest("#private-account-toggle");
  if (toggle) {
    const open = toggle.getAttribute("aria-expanded") !== "true";
    closeSidebarAccountMenu();
    toggle.setAttribute("aria-expanded", String(open));
    privateAccountMenu?.classList.toggle("is-hidden", !open);
    return;
  }
  const action = event.target.closest("button");
  if (!action) return;
  if (action.dataset.privateUserAction === "settings") {
    closePrivateAccountMenu({ restoreFocus: true });
    openAccountSettings("account");
  } else {
    closePrivateAccountMenu();
  }
});

privateAccount?.addEventListener("keydown", (event) => {
  if (event.key !== "Escape" || privateAccountMenu?.classList.contains("is-hidden")) return;
  event.preventDefault();
  event.stopPropagation();
  closePrivateAccountMenu({ restoreFocus: true });
});

privateAccount?.addEventListener("focusout", (event) => {
  if (!privateAccount.contains(event.relatedTarget)) closePrivateAccountMenu();
});

document.addEventListener("click", (event) => {
  if (privateAccount && !privateAccount.contains(event.target)) closePrivateAccountMenu();
});

adminBackHomeButton?.addEventListener("click", () => {
  showLanding();
  I18n.pushState(null, "", "/");
});

adminOverview?.addEventListener("change", (event) => {
  const input = event.target.closest("[data-module-toggle]");
  if (!input) return;
  const moduleKey = input.dataset.moduleToggle;
  if (!moduleKey || !(moduleKey in DEFAULT_MODULE_VISIBILITY)) return;
  moduleVisibilityDraft = {
    ...moduleVisibilityDraft,
    [moduleKey]: input.checked
  };
  moduleVisibilitySaveState = {
    dirty: !areModuleVisibilitySettingsEqual(moduleVisibilityDraft, moduleVisibility),
    saving: false,
    message: "",
    error: false
  };
  syncAdminModuleSaveControls();
});

adminOverview?.addEventListener("click", (event) => {
  const button = event.target.closest("[data-admin-modules-save]");
  if (!button) return;
  saveAdminModuleVisibility().catch(() => null);
});

window.addEventListener("beforeunload", (event) => {
  if (!moduleVisibilitySaveState.dirty || moduleVisibilitySaveState.saving) return;
  event.preventDefault();
  event.returnValue = "";
});

adminLogoutButton?.addEventListener("click", async () => {
  await logoutCurrentUser();
});

adminTabs?.addEventListener("click", (event) => {
  const button = event.target.closest("[data-admin-tab]");
  if (!button) return;
  showAdminTab(button.dataset.adminTab);
  loadAdminPanel(button.dataset.adminTab);
});

adminUsers?.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-admin-action][data-user-id]");
  if (!button) return;
  if (button.dataset.adminAction === "adjust-user") {
    openAdminUserAdjustDialog(button.dataset.userId);
  }
});

adminWaitlist?.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-admin-waitlist-filters]");
  if (!form) return;
  event.preventDefault();
  const data = new FormData(form);
  adminData.waitlistQuery = clean(data.get("q")).slice(0, 100);
  adminData.waitlistStatus = clean(data.get("status")).toLowerCase() || "all";
  adminData.waitlistLoaded = false;
  await loadAdminPanel("waitlist", { force: true });
});

adminWaitlist?.addEventListener("change", async (event) => {
  if (!event.target.matches("[data-admin-waitlist-status]")) return;
  event.target.form?.requestSubmit();
});

adminWaitlist?.addEventListener("click", async (event) => {
  const resetButton = event.target.closest("[data-admin-waitlist-reset]");
  if (resetButton) {
    adminData.waitlistQuery = "";
    adminData.waitlistStatus = "all";
    adminData.waitlistLoaded = false;
    await loadAdminPanel("waitlist", { force: true });
    return;
  }

  const actionButton = event.target.closest("[data-admin-waitlist-action][data-user-id]");
  if (!actionButton) return;
  await updateAdminWaitlistStatus(
    actionButton.dataset.userId,
    actionButton.dataset.adminWaitlistAction,
    actionButton
  );
});

adminContact?.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-admin-contact-filters]");
  if (!form) return;
  event.preventDefault();
  const data = new FormData(form);
  adminData.contactQuery = clean(data.get("q")).slice(0, 100);
  adminData.contactStatus = clean(data.get("status")).toLowerCase() || "all";
  adminData.contactReason = clean(data.get("reason")).toLowerCase() || "all";
  adminData.contactLoaded = false;
  await loadAdminPanel("contact", { force: true });
});

adminContact?.addEventListener("change", (event) => {
  if (!event.target.matches("[data-admin-contact-filter]")) return;
  event.target.form?.requestSubmit();
});

adminContact?.addEventListener("click", async (event) => {
  const resetButton = event.target.closest("[data-admin-contact-reset]");
  if (resetButton) {
    adminData.contactQuery = "";
    adminData.contactStatus = "all";
    adminData.contactReason = "all";
    adminData.contactLoaded = false;
    await loadAdminPanel("contact", { force: true });
    return;
  }

  const actionButton = event.target.closest("[data-admin-contact-action][data-message-id]");
  if (!actionButton) return;
  await updateAdminContactMessage(
    actionButton.dataset.messageId,
    actionButton.dataset.adminContactAction,
    actionButton
  );
});

adminOrders?.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-admin-action][data-order-id]");
  if (!button) return;
  if (button.dataset.adminAction === "order-status") {
    openAdminOrderStatusDialog(button.dataset.orderId);
  }
});

adminTraining?.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-admin-training-action]");
  if (!button) return;
  const action = button.dataset.adminTrainingAction;
  if (action === "new-course") {
    openAdminTrainingCourseDialog();
  } else if (action === "edit-course") {
    openAdminTrainingCourseDialog(button.dataset.courseId);
  } else if (action === "save-registration") {
    await updateAdminTrainingRegistration(button.dataset.registrationId, button);
  }
});

adminTrainingCourseForm?.addEventListener("submit", submitAdminTrainingCourse);
adminTrainingCourseCloseButton?.addEventListener("click", closeAdminTrainingCourseDialog);
adminTrainingCourseCancelButton?.addEventListener("click", closeAdminTrainingCourseDialog);
adminTrainingCourseDialog?.addEventListener("click", (event) => {
  if (event.target === adminTrainingCourseDialog) closeAdminTrainingCourseDialog();
});

adminUserAdjustForm?.addEventListener("submit", adminAdjustUser);
adminUserAdjustCloseButton?.addEventListener("click", closeAdminUserAdjustDialog);
adminUserAdjustCancelButton?.addEventListener("click", closeAdminUserAdjustDialog);
adminUserAdjustDialog?.addEventListener("click", (event) => {
  if (event.target === adminUserAdjustDialog) closeAdminUserAdjustDialog();
});

adminOrderStatusForm?.addEventListener("submit", adminUpdateOrderStatus);
adminOrderStatusCloseButton?.addEventListener("click", closeAdminOrderStatusDialog);
adminOrderStatusCancelButton?.addEventListener("click", closeAdminOrderStatusDialog);
adminOrderStatusDialog?.addEventListener("click", (event) => {
  if (event.target === adminOrderStatusDialog) closeAdminOrderStatusDialog();
});

closeAccountSettingsButton?.addEventListener("click", closeAccountSettings);
closeAccountSettingsIconButton?.addEventListener("click", closeAccountSettings);
accountSettingsDialog?.addEventListener("click", (event) => {
  if (event.target === accountSettingsDialog) closeAccountSettings();
});
accountUpgradePlanButton?.addEventListener("click", async () => {
  closeAccountSettings();
  await openPrivateArea();
  showPrivateSection("plans");
});
accountAddCreditsButton?.addEventListener("click", async () => {
  closeAccountSettings();
  await openPrivateArea();
  showPrivateSection("plans");
});
accountSettingsTabs?.addEventListener("click", (event) => {
  const button = event.target.closest("[data-account-tab]");
  if (!button) return;
  showAccountSettingsTab(button.dataset.accountTab);
});
toggleProfileEditButton?.addEventListener("click", () => {
  accountProfileForm?.classList.remove("is-hidden");
  accountProfileNameInput?.focus();
});
cancelProfileEditButton?.addEventListener("click", () => {
  pendingAvatarDataUrl = "";
  pendingAvatarRemoval = false;
  accountProfileForm?.classList.add("is-hidden");
  renderAccountSettings();
});
chooseAccountAvatarButton?.addEventListener("click", () => accountAvatarInput?.click());
removeAccountAvatarButton?.addEventListener("click", () => {
  pendingAvatarDataUrl = "";
  pendingAvatarRemoval = true;
  renderAvatarElement(accountSettingsAvatar, { ...currentUser, picture: currentUser?.googlePicture || "" });
  setAccountSettingsStatus(() => T("interface.se_quitara_la_imagen_propia_al_guardar_los_cambios"));
});
accountAvatarInput?.addEventListener("change", async () => {
  const file = accountAvatarInput.files?.[0];
  if (!file) return;
  if (!["image/png", "image/jpeg", "image/webp"].includes(file.type)) {
    setAccountSettingsStatus(() => T("interface.usa_una_imagen_png_jpg_o_webp"), true);
    accountAvatarInput.value = "";
    return;
  }
  if (file.size > 512 * 1024) {
    setAccountSettingsStatus(() => T("interface.la_imagen_supera_el_maximo_de_512_kb"), true);
    accountAvatarInput.value = "";
    return;
  }
  pendingAvatarDataUrl = await readFileAsDataUrl(file);
  pendingAvatarRemoval = false;
  renderAvatarElement(accountSettingsAvatar, { ...currentUser, picture: pendingAvatarDataUrl });
  setAccountSettingsStatus(() => T("interface.imagen_preparada_guarda_los_cambios_para_aplicarla"));
});
accountProfileForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  await saveAccountProfile();
});
accountPersonalInformationForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  await saveAccountPersonalInformation();
});
accountPersonalInformationForm?.addEventListener("input", () => {
  setAccountPersonalInformationStatus("");
});
accountPersonalInformationForm?.addEventListener("change", () => {
  setAccountPersonalInformationStatus("");
});
cancelAccountPersonalInformationButton?.addEventListener("click", () => {
  fillAccountPersonalInformationForm();
  setAccountPersonalInformationStatus(() => T("interface.cambios_descartados"));
});
deleteAccountButton?.addEventListener("click", deleteCurrentAccount);
accountDefaultChartViewSelect?.addEventListener("change", () => {
  const nextView = safeChartViewType(accountDefaultChartViewSelect.value);
  setActiveChartViewType(nextView, { syncControls: true, persist: true });
  renderAccountSettings();
  setAccountPreferencesStatus(() => T("interface.vista_predeterminada_guardada"));
});
accountHouseSystemSelect?.addEventListener("change", () => {
  const nextSystem = CHART_HOUSE_SYSTEMS[accountHouseSystemSelect.value] ?
  accountHouseSystemSelect.value :
  DEFAULT_CHART_HOUSE_SYSTEM;
  chartHouseSystemKey = nextSystem;
  persistChartHouseSystemKey();
  renderAccountSettings();
  setAccountPreferencesStatus(() => T("interface.sistema_de_casas_guardado_para_los_proximos_calculos"));
});
accountOpenMapSettingsButton?.addEventListener("click", () => {
  activeChartSettingsTab = "bodies";
  openChartPlanetVisibilityDialog();
});
accountResetMapPreferencesButton?.addEventListener("click", resetAccountMapPreferences);
accountTextSizeButtons.forEach((button) => {
  button.addEventListener("click", () => {
    setAccountTextSize(button.dataset.accountTextSize, { persist: true });
    renderAccountSettings();
    setAccountPreferencesStatus(() => T("interface.tamano_del_texto_guardado"));
  });
});
accountReduceMotionInput?.addEventListener("change", () => {
  accountReduceMotion = Boolean(accountReduceMotionInput.checked);
  applyAccountAccessibilityPreferences({ persist: true });
  renderAccountSettings();
  setAccountPreferencesStatus(() => accountReduceMotion ? T("interface.movimiento_reducido_activado") : T("interface.movimiento_reducido_desactivado"));
});
accountResetAppearanceButton?.addEventListener("click", resetAccountAppearancePreferences);
accountNotificationActionButton?.addEventListener("click", handleAccountNotificationAction);
document.querySelectorAll("#account-import-astro, #people-import-astro").forEach((button) => {
  button.addEventListener("click", () => {
    if (currentUser) window.PeopleAaf.open("import", loadPeople);
  });
});
document.querySelectorAll("#account-export-astro, #people-export-astro").forEach((button) => {
  button.addEventListener("click", () => {
    if (currentUser) window.PeopleAaf.open("export");
  });
});
accountLogoutAllButton?.addEventListener("click", logoutAllAccountSessions);
chartPlanetVisibilityDialog?.addEventListener("close", () => {
  if (accountSettingsDialog?.open) renderAccountSettings();
});

privateBackButton.addEventListener("click", () => {
  if (privateSidebarMobileQuery.matches) {
    privateSidebarCollapsed = true;
    applyPrivateSidebarState();
  }
  showLanding();
  if (I18n.routePath() !== "/") I18n.pushState(null, "", "/");
});

document.querySelectorAll("[data-brand-home]").forEach((link) => {
  link.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    showLanding();
    if (I18n.routePath() !== "/" || window.location.search || window.location.hash) {
      I18n.pushState(null, "", "/");
    }
    scrollPublicPageToTop();
    landingScreen?.querySelector("[data-brand-home]")?.focus({ preventScroll: true });
  });
});

logoutButton.addEventListener("click", async () => {
  if (privateSidebarMobileQuery.matches) privateSidebarCollapsed = true;
  await logoutCurrentUser();
});

togglePersonFormButton.addEventListener("click", () => {
  if (isPersonFormOpen()) {
    closePersonForm();
    return;
  }

  openNewPersonForm();
});

personCancelEditButton.addEventListener("click", () => {
  closePersonForm();
});

personForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (!acceptLegalConsentFromInput(personLegalConsentInput, setPrivateStatus)) return;

  const profile = getPersonProfileFromForm(new FormData(personForm));
  if (!isValidPersonProfile(profile)) return;

  const editingId = personIdInput.value;
  setPrivateStatus(() => editingId ? T("interface.guardando_cambios") : T("interface.guardando_carta"));
  setPersonBusy(true);

  try {
    const response = await I18n.fetch(editingId ? `/api/people/${editingId}` : "/api/people", {
      method: editingId ? "PUT" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profile)
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

    closePersonForm();
    await loadPeople();
    setPrivateStatus(() => editingId ? T("interface.carta_actualizada") : T("interface.carta_guardada"));
  } catch (error) {
    setPrivateStatus(() => error.message || T("interface.no_se_pudo_guardar_la_carta"), true);
  } finally {
    setPersonBusy(false);
  }
});

personGenderSelect.addEventListener("change", () => {
  const isOther = personGenderSelect.value === "otro";
  personGenderOtherField.classList.toggle("is-hidden", !isOther);
  personGenderOtherInput.required = isOther;
  I18n.validity(personGenderOtherInput, () => "");
  if (!isOther) personGenderOtherInput.value = "";
});

personCountrySelect.addEventListener("change", async () => {
  syncCountryCombobox();
  clearPrivateSelectedCity();
  await loadPrivateCities(personCountrySelect.value, "");
  personCityInput.disabled = !personCountrySelect.value;
  if (personCountrySelect.value) personCityInput.focus();
});

bindCountrySearch(personCountryControl, clearPrivateSelectedCity);
bindCountrySearch(solarReturnCountryControl, () => {
  clearSolarReturnSelectedCity();
  solarReturnCalculation = null;
});

personCityInput.addEventListener("input", async () => {
  personPlaceIdInput.value = "";
  personLatInput.value = "";
  personLonInput.value = "";
  personTzInput.value = "";

  const query = personCityInput.value.trim();
  if (!personCountrySelect.value || !query) {
    I18n.clear(personCityResults, "innerHTML");
    return;
  }

  if (personCountrySelect.value !== privateLastCountry || privateCityList.length === 0 || query.length >= 2) {
    await loadPrivateCities(personCountrySelect.value, query);
  }

  renderPrivateCitySuggestions(query);
});

personCityInput.addEventListener("keydown", (event) => {
  if (event.key === "Enter") event.preventDefault();
});

peopleSearchInput.addEventListener("input", renderPeopleList);

peopleListEl.addEventListener("click", async (event) => {
  const button = event.target.closest("button[data-action][data-id]");
  if (button) {
    const person = savedPeople.find((item) => String(item.id) === button.dataset.id);
    if (!person) return;

    if (button.dataset.action === "use") {
      await useSavedPerson(person);
    } else if (button.dataset.action === "favorite") {
      await toggleSavedPersonFavorite(person);
    } else if (button.dataset.action === "edit") {
      await editSavedPerson(person);
    } else if (button.dataset.action === "delete") {
      await deleteSavedPerson(person);
    }
    return;
  }

  const item = event.target.closest(".people-item[data-id]");
  if (!item) return;
  const person = savedPeople.find((entry) => String(entry.id) === item.dataset.id);
  if (person) await useSavedPerson(person);
});

peopleListEl.addEventListener("keydown", async (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;
  if (event.target.closest("button, input, select, textarea, a")) return;

  const item = event.target.closest(".people-item[data-id]");
  if (!item) return;
  event.preventDefault();
  const person = savedPeople.find((entry) => String(entry.id) === item.dataset.id);
  if (person) await useSavedPerson(person);
});

chatHistoryList.addEventListener("click", async (event) => {
  const button = event.target.closest("button[data-action][data-id]");
  if (!button) return;

  event.stopPropagation();
  const chatId = button.dataset.id;
  if (button.dataset.action === "load") {
    openChatMenuId = "";
    openMoveChatId = "";
    await loadSavedChat(chatId);
  } else if (button.dataset.action === "menu") {
    openChatMenuId = openChatMenuId === chatId ? "" : chatId;
    openMoveChatId = "";
    renderChatHistory();
  } else if (button.dataset.action === "pin") {
    togglePinnedChat(chatId);
  } else if (button.dataset.action === "rename") {
    await renameSavedChat(chatId);
  } else if (button.dataset.action === "move") {
    openMoveChatId = openMoveChatId === chatId ? "" : chatId;
    renderChatHistory();
  } else if (button.dataset.action === "move-to-folder") {
    await moveChatToFolder(chatId, button.dataset.folderId || "");
  } else if (button.dataset.action === "create-folder-and-move") {
    await createFolderAndMoveChat(chatId);
  } else if (button.dataset.action === "download") {
    await downloadSavedChat(chatId);
  } else if (button.dataset.action === "delete") {
    await deleteSavedChat(chatId);
  }
});

chatFoldersList?.addEventListener("click", (event) => {
  const actionButton = event.target.closest("button[data-folder-action]");
  if (actionButton) {
    event.stopPropagation();
    const folderId = actionButton.dataset.folderId || "";
    if (actionButton.dataset.folderAction === "menu") {
      openFolderMenuId = openFolderMenuId === folderId ? "" : folderId;
      openChatMenuId = "";
      openMoveChatId = "";
      renderChatFolders();
    } else if (actionButton.dataset.folderAction === "delete") {
      deleteChatFolder(folderId);
    }
    return;
  }

  const button = event.target.closest("button[data-folder-id]");
  if (!button) return;
  activeChatFolderId = button.dataset.folderId;
  openChatMenuId = "";
  openMoveChatId = "";
  openFolderMenuId = "";
  saveChatUiPreferences();
  renderChatHistory();
});

createChatFolderButton?.addEventListener("click", async () => {
  await createChatFolder();
});

chatFolderForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  const name = clean(chatFolderNameInput?.value || "");
  if (!name) {
    if (chatFolderStatus) I18n.bind(chatFolderStatus, "textContent", () => T("interface.escribe_un_nombre_para_la_carpeta"));
    chatFolderNameInput?.focus();
    return;
  }
  resolveFolderDialog(name);
});

chatFolderCancelButton?.addEventListener("click", () => resolveFolderDialog(null));
chatFolderCancelXButton?.addEventListener("click", () => resolveFolderDialog(null));
chatFolderDialog?.addEventListener("cancel", (event) => {
  event.preventDefault();
  resolveFolderDialog(null);
});

deleteFolderForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  resolveDeleteFolderDialog(true);
});

deleteFolderCancelButton?.addEventListener("click", () => resolveDeleteFolderDialog(false));
deleteFolderCancelXButton?.addEventListener("click", () => resolveDeleteFolderDialog(false));
deleteFolderDialog?.addEventListener("cancel", (event) => {
  event.preventDefault();
  resolveDeleteFolderDialog(false);
});

destructiveConfirmForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  resolveDestructiveConfirmDialog(true);
});

destructiveConfirmCancelButton?.addEventListener("click", () => resolveDestructiveConfirmDialog(false));
destructiveConfirmCancelXButton?.addEventListener("click", () => resolveDestructiveConfirmDialog(false));
destructiveConfirmDialog?.addEventListener("cancel", (event) => {
  event.preventDefault();
  resolveDestructiveConfirmDialog(false);
});

downloadConfirmForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  resolveDownloadConfirmDialog(true);
});

downloadConfirmCancelButton?.addEventListener("click", () => resolveDownloadConfirmDialog(false));
downloadConfirmCancelXButton?.addEventListener("click", () => resolveDownloadConfirmDialog(false));
downloadConfirmDialog?.addEventListener("cancel", (event) => {
  event.preventDefault();
  resolveDownloadConfirmDialog(false);
});

chartPlanetVisibilityForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  const selectedKeys = Array.from(chartPlanetVisibilityForm.querySelectorAll("input[name='chart-visible-planet']:checked")).
  map((input) => input.value).
  filter((key) => CHART_SELECTABLE_PLANETS.includes(key));
  chartVisiblePlanetKeys = new Set(selectedKeys);
  const selectedAspectKeys = Array.from(chartPlanetVisibilityForm.querySelectorAll("input[name='chart-aspect-planet']:checked")).
  map((input) => input.value).
  filter((key) => CHART_SELECTABLE_PLANETS.includes(key));
  chartAspectPlanetKeys = new Set(selectedAspectKeys);
  const selectedAspectAngles = Array.from(chartPlanetVisibilityForm.querySelectorAll("input[name='chart-visible-aspect']:checked")).
  map((input) => Number(input.value)).
  filter((angle) => VISUAL_ASPECT_ANGLES.has(angle));
  chartVisibleAspectAngles = new Set(selectedAspectAngles);
  chartAspectOrbs = new Map(ASPECT_CONFIGS.map((aspect) => {
    const input = chartPlanetVisibilityForm.querySelector(`input[name='chart-aspect-orb'][data-aspect-angle='${aspect.angle}']`);
    return [Number(aspect.angle), normalizeChartAspectOrb(aspect.angle, input?.dataset.orbValue ?? input?.value)];
  }));
  const nextHouseSystemKey = CHART_HOUSE_SYSTEMS[chartHouseSystemSelect?.value] ?
  chartHouseSystemSelect.value :
  DEFAULT_CHART_HOUSE_SYSTEM;
  const calculatedHouseSystemKey = chartCalculation?.charts?.tropical?.houseSystem?.key ||
  DEFAULT_CHART_HOUSE_SYSTEM;
  const houseSystemChanged = nextHouseSystemKey !== chartHouseSystemKey ||
  nextHouseSystemKey !== calculatedHouseSystemKey;
  persistChartVisiblePlanetKeys();
  persistChartAspectPlanetKeys();
  persistChartPlanetColors();
  persistChartVisibleAspectAngles();
  persistChartAspectOrbs();
  persistChartAspectColors();
  chartPlanetColorsBeforeDialog = null;
  chartAspectColorsBeforeDialog = null;
  if (!houseSystemChanged || !birthProfile || !chartCalculation) {
    chartHouseSystemKey = nextHouseSystemKey;
    persistChartHouseSystemKey();
    chartPlanetVisibilityDialog?.close();
    rerenderChartWheelForPlanetVisibility();
    return;
  }

  const submitButton = chartPlanetVisibilityForm.querySelector("button[type='submit']");
  if (submitButton) submitButton.disabled = true;
  if (chartPlanetVisibilityStatus) I18n.bind(chartPlanetVisibilityStatus, "textContent", () => T("interface.recalculando_cuspides_y_posiciones_por_casa"));
  try {
    const calculation = await calculateBirthCharts(birthProfile, nextHouseSystemKey);
    const appliedHouseSystemKey = calculation?.charts?.tropical?.houseSystem?.key;
    if (appliedHouseSystemKey !== nextHouseSystemKey) {
      throw new Error(T("interface.el_servidor_no_confirmo_el_sistema_de_casas_seleccionado_vuelve_a_intentarlo"));
    }
    chartHouseSystemKey = nextHouseSystemKey;
    persistChartHouseSystemKey();
    chartCalculation = calculation;
    progressedCalculation = null;
    solarReturnCalculation = null;
    synastryCalculation = null;
    compositeCalculation = null;
    if (currentUser) localStorage.setItem("birthChartCalculation", JSON.stringify(chartCalculation));
    chartPlanetVisibilityDialog?.close();
    await renderSelectedChartWheel();
    setChartWheelStatus(() => T("interface.value_aplicado_cuspides_y_posiciones_por_casa_recalculadas", { v0: I18n.label(CHART_HOUSE_SYSTEMS[nextHouseSystemKey].label) }));
  } catch (error) {
    if (chartPlanetVisibilityStatus) {
      I18n.bind(chartPlanetVisibilityStatus, "textContent", () => error.message || T("interface.no_se_pudo_aplicar_el_sistema_de_casas"));
      chartPlanetVisibilityStatus.classList.add("error");
    }
  } finally {
    if (submitButton) submitButton.disabled = false;
  }
});

chartPlanetVisibilityCancelButton?.addEventListener("click", closeChartPlanetVisibilityDialog);
chartPlanetVisibilityCloseButton?.addEventListener("click", closeChartPlanetVisibilityDialog);
chartPlanetVisibilityClearAllButton?.addEventListener("click", () => {
  chartPlanetVisibilityList?.querySelectorAll("input[name='chart-visible-planet'], input[name='chart-aspect-planet']").forEach((input) => {
    input.checked = false;
  });
  chartPlanetVisibilityList?.querySelectorAll("input[name='chart-aspect-planet']").forEach((input) => {
    input.disabled = true;
  });
  updateChartPlanetVisibilityStatus();
});
chartPlanetVisibilityList?.addEventListener("click", (event) => {
  const trigger = event.target.closest?.("[data-planet-color-trigger]");
  if (!trigger) return;
  event.preventDefault();
  event.stopPropagation();
  openChartPlanetColorEditor(trigger.dataset.planetColorTrigger, trigger);
});
chartPlanetColorPalette?.addEventListener("click", (event) => {
  const swatch = event.target.closest?.("[data-planet-color-value]");
  if (!swatch || !activeChartPlanetColorKey) return;
  setChartPlanetColor(activeChartPlanetColorKey, swatch.dataset.planetColorValue, { announce: true });
});
chartPlanetCustomColorInput?.addEventListener("input", () => {
  if (!activeChartPlanetColorKey) return;
  setChartPlanetColor(activeChartPlanetColorKey, chartPlanetCustomColorInput.value, { announce: false });
});
chartPlanetCustomColorInput?.addEventListener("change", () => {
  if (!activeChartPlanetColorKey) return;
  setChartPlanetColor(activeChartPlanetColorKey, chartPlanetCustomColorInput.value, { announce: true });
});
chartPlanetColorRestoreCurrentButton?.addEventListener("click", () => {
  if (!activeChartPlanetColorKey) return;
  setChartPlanetColor(activeChartPlanetColorKey, CHART_DEFAULT_PLANET_COLORS[activeChartPlanetColorKey], { announce: true });
});
chartPlanetColorRestoreAllButton?.addEventListener("click", () => {
  chartPlanetColors = defaultChartPlanetColorsMap();
  applyChartPlanetColorVariables();
  syncChartPlanetColorControls();
  updateChartPlanetVisibilityStatus();
  if (chartPlanetColorStatus) I18n.bind(chartPlanetColorStatus, "textContent", () => T("interface.se_han_restaurado_los_colores_habituales_de_todos_los_planetas_y_puntos"));
});
chartPlanetColorEditorCloseButton?.addEventListener("click", () => closeChartPlanetColorEditor({ restoreFocus: true }));
chartAspectRestoreDefaultsButton?.addEventListener("click", () => {
  chartAspectVisibilityList?.querySelectorAll("input[name='chart-visible-aspect']").forEach((input) => {
    input.checked = CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.includes(Number(input.value));
  });
  syncChartAspectOrbControls();
  updateChartPlanetVisibilityStatus();
});
chartAspectOrbRestoreDefaultsButton?.addEventListener("click", () => {
  chartAspectOrbList?.querySelectorAll("input[name='chart-aspect-orb']").forEach((input) => {
    const angle = Number(input.dataset.aspectAngle);
    const defaultOrb = Number(CHART_DEFAULT_ASPECT_ORBS[angle]);
    input.value = String(defaultOrb);
    input.dataset.orbValue = String(defaultOrb);
  });
  syncChartAspectOrbControls();
  updateChartPlanetVisibilityStatus();
});
function handleChartAspectColorTrigger(event) {
  const trigger = event.target.closest?.("[data-aspect-color-trigger]");
  if (!trigger) return;
  event.preventDefault();
  event.stopPropagation();
  openChartAspectColorEditor(Number(trigger.dataset.aspectColorTrigger), trigger);
}
chartAspectVisibilityList?.addEventListener("click", handleChartAspectColorTrigger);
chartAspectOrbList?.addEventListener("click", handleChartAspectColorTrigger);
chartAspectColorPalette?.addEventListener("click", (event) => {
  const swatch = event.target.closest?.("[data-aspect-color-value]");
  if (!swatch || !Number.isFinite(activeChartAspectColorAngle)) return;
  setChartAspectColor(activeChartAspectColorAngle, swatch.dataset.aspectColorValue, { announce: true });
});
chartAspectCustomColorInput?.addEventListener("input", () => {
  if (!Number.isFinite(activeChartAspectColorAngle)) return;
  setChartAspectColor(activeChartAspectColorAngle, chartAspectCustomColorInput.value, { announce: false });
});
chartAspectCustomColorInput?.addEventListener("change", () => {
  if (!Number.isFinite(activeChartAspectColorAngle)) return;
  setChartAspectColor(activeChartAspectColorAngle, chartAspectCustomColorInput.value, { announce: true });
});
chartAspectColorRestoreCurrentButton?.addEventListener("click", () => {
  if (!Number.isFinite(activeChartAspectColorAngle)) return;
  setChartAspectColor(activeChartAspectColorAngle, CHART_DEFAULT_ASPECT_COLORS[activeChartAspectColorAngle], { announce: true });
});
chartAspectColorRestoreAllButton?.addEventListener("click", () => {
  chartAspectColors = defaultChartAspectColorsMap();
  applyChartAspectColorVariables();
  syncChartAspectColorControls();
  updateChartPlanetVisibilityStatus();
  if (chartAspectColorStatus) I18n.bind(chartAspectColorStatus, "textContent", () => T("interface.se_han_restaurado_los_colores_habituales_de_todos_los_aspectos"));
});
chartAspectColorEditorCloseButton?.addEventListener("click", () => closeChartAspectColorEditor({ restoreFocus: true }));
chartPlanetVisibilityList?.addEventListener("change", (event) => {
  const visibilityInput = event.target.closest("input[name='chart-visible-planet']");
  if (visibilityInput) {
    const aspectInput = chartPlanetVisibilityList.querySelector(`input[name='chart-aspect-planet'][value="${CSS.escape(visibilityInput.value)}"]`);
    if (aspectInput) {
      aspectInput.disabled = !visibilityInput.checked;
      if (!visibilityInput.checked) aspectInput.checked = false;
    }
  }
  updateChartPlanetVisibilityStatus();
});
chartAspectVisibilityList?.addEventListener("change", () => {
  syncChartAspectOrbControls();
  updateChartPlanetVisibilityStatus();
});
chartAspectOrbList?.addEventListener("input", (event) => {
  const input = event.target.closest?.("input[name='chart-aspect-orb']");
  if (!input) return;
  const numericValue = Number(input.value);
  if (Number.isFinite(numericValue)) input.dataset.orbValue = String(numericValue);
  updateChartAspectOrbSummary();
  updateChartPlanetVisibilityStatus();
});
chartAspectOrbList?.addEventListener("change", (event) => {
  const input = event.target.closest?.("input[name='chart-aspect-orb']");
  if (!input) return;
  const normalized = normalizeChartAspectOrb(input.dataset.aspectAngle, input.dataset.orbValue ?? input.value);
  input.value = String(normalized);
  input.dataset.orbValue = String(normalized);
  updateChartAspectOrbSummary();
  updateChartPlanetVisibilityStatus();
});
chartAspectOrbSettings?.addEventListener("toggle", () => {
  if (chartAspectOrbToggleLabel) {
    I18n.bind(chartAspectOrbToggleLabel, "textContent", () => chartAspectOrbSettings.open ? T("interface.ocultar_ajustes") : T("interface.mostrar_ajustes"));
  }
});
chartHouseSystemSelect?.addEventListener("change", () => {
  renderChartHouseSystemPreview(chartHouseSystemSelect.value);
  updateChartPlanetVisibilityStatus();
});
chartPlanetVisibilityDialog?.querySelectorAll("[data-chart-settings-tab]").forEach((button) => {
  button.addEventListener("click", () => setChartSettingsTab(button.dataset.chartSettingsTab));
  button.addEventListener("keydown", (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const tabs = Array.from(chartPlanetVisibilityDialog.querySelectorAll("[data-chart-settings-tab]"));
    const currentIndex = Math.max(0, tabs.indexOf(button));
    const direction = event.key === "ArrowRight" ? 1 : -1;
    const nextButton = tabs[(currentIndex + direction + tabs.length) % tabs.length];
    const nextTab = nextButton?.dataset.chartSettingsTab || "bodies";
    setChartSettingsTab(nextTab);
    chartPlanetVisibilityDialog?.
    querySelector(`[data-chart-settings-tab="${nextTab}"]`)?.
    focus({ preventScroll: true });
  });
});
chartPlanetVisibilityDialog?.addEventListener("click", (event) => {
  if (event.target === chartPlanetVisibilityDialog) closeChartPlanetVisibilityDialog();
});
chartPlanetVisibilityDialog?.addEventListener("close", () => {
  restoreChartPlanetColorsBeforeDialog();
  restoreChartAspectColorsBeforeDialog();
  closeChartPlanetColorEditor();
  closeChartAspectColorEditor();
});

toggleChatHistoryButton?.addEventListener("click", () => {
  chatHistoryCollapsed = !chatHistoryCollapsed;
  openChatMenuId = "";
  openMoveChatId = "";
  saveChatUiPreferences();
  renderChatHistory();
});

toggleChatSidebarButton?.addEventListener("click", () => {
  chatSidebarCollapsed = !chatSidebarCollapsed;
  localStorage.setItem("chatSidebarCollapsed", chatSidebarCollapsed ? "true" : "false");
  applyChatSidebarState();
});

togglePrivateSidebarButton?.addEventListener("click", () => {
  privateSidebarCollapsed = !privateSidebarCollapsed;
  if (!privateSidebarMobileQuery.matches) {
    localStorage.setItem("privateSidebarCollapsed", privateSidebarCollapsed ? "true" : "false");
    localStorage.setItem("privateSidebarPinned", privateSidebarCollapsed ? "false" : "true");
  }
  applyPrivateSidebarState();
});

privateSidebarBackdrop?.addEventListener("click", () => {
  if (!privateSidebarMobileQuery.matches || privateSidebarCollapsed) return;
  privateSidebarCollapsed = true;
  applyPrivateSidebarState();
  togglePrivateSidebarButton?.focus({ preventScroll: true });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape" || !privateSidebarMobileQuery.matches || privateSidebarCollapsed) return;
  privateSidebarCollapsed = true;
  applyPrivateSidebarState();
  togglePrivateSidebarButton?.focus({ preventScroll: true });
});

privateSidebarMobileQuery.addEventListener("change", (event) => {
  privateSidebarCollapsed = event.matches ?
  true :
  localStorage.getItem("privateSidebarPinned") !== "true";
  applyPrivateSidebarState();
});

privateMapControlsMobileQuery.addEventListener("change", () => {
  syncPrivateMapContextPlacement();
});
syncPrivateMapContextPlacement();

document.addEventListener("click", (event) => {
  const clickedChatMenu = event.target.closest(".chat-history-menu, .chat-history-move-panel, .chat-history-menu-button");
  const clickedFolderMenu = event.target.closest(".chat-folder-menu, .chat-folder-menu-button");
  const clickedCollapsedChats = event.target.closest("#collapsed-chat-popover");
  let changed = false;

  if (openChatMenuId && !clickedChatMenu) {
    openChatMenuId = "";
    openMoveChatId = "";
    changed = true;
  }

  if (openFolderMenuId && !clickedFolderMenu) {
    openFolderMenuId = "";
    changed = true;
  }

  if (changed) renderChatHistory();
  if (collapsedChatPopoverOpen && !clickedCollapsedChats) closeCollapsedChatPopover();
});

peopleInitialFilter.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-letter]");
  if (!button) return;
  activePeopleInitial = button.dataset.letter === "all" ? "" : button.dataset.letter;
  renderPeopleList();
});

peopleSolarFilter.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-solar-sign]");
  if (!button) return;
  activePeopleSolarSign = button.dataset.solarSign === "all" ? "" : button.dataset.solarSign;
  renderPeopleList();
});

window.addEventListener("popstate", async () => {
  destroyPrivateTimeline();
  destroyPrivateObservatory();
  if (activePrivateSection === "atlas3d" && privateAtlas3DController && !privateAtlas3DController.canLeave()) {
    I18n.pushState(null, "", getPrivateSectionPath("atlas3d"));
    return;
  }
  destroyPrivateAtlas3D();
  if (activePrivateSection === "atlas" && privateAtlasController && !privateAtlasController.canLeave()) {
    I18n.pushState(null, "", privateAtlasPath);
    return;
  }
  if (activePrivateSection === "atlas") {
    privateAtlasController?.destroy();
    privateAtlasController = null;
  }
  if (I18n.routePath() === GUEST_INTAKE_ROUTE) {
    showIntake(false);
  } else if (I18n.routePath() === ABOUT_ROUTE) {
    showAboutPage(false);
  } else if (I18n.routePath() === DONATION_ROUTE) {
    showDonationPage(false);
  } else if (I18n.routePath() === "/chat") {
    I18n.replaceState(null, "", currentUser ? getPrivateSectionPath("maps") : "/");
    if (currentUser) await openPrivateArea(false, "maps");else
    showLanding();
  } else if (isPrivateRoutePath(I18n.routePath())) {
    if (currentUser) {
      openPrivateArea(false, getPrivateSectionFromRoute());
    } else {
      I18n.replaceState(null, "", "/");
      showLanding();
      setAuthStatus("");
    }
  } else if (I18n.routePath() === "/admin" && currentUser?.isAdmin) {
    openAdminPanel(false);
  } else {
    showLanding();
  }
});

genderSelect.addEventListener("change", () => {
  const isOther = genderSelect.value === "otro";
  genderOtherField.classList.toggle("is-hidden", !isOther);
  genderOtherInput.required = isOther;
  I18n.validity(genderOtherInput, () => "");
  if (!isOther) genderOtherInput.value = "";
});

countrySelect.addEventListener("change", async () => {
  clearSelectedCity();
  await loadCities(countrySelect.value, "");
  cityInput.disabled = !countrySelect.value;
  cityInput.focus();
});

cityInput.addEventListener("input", async () => {
  placeIdInput.value = "";
  latInput.value = "";
  lonInput.value = "";
  tzInput.value = "";

  const query = cityInput.value.trim();
  if (!countrySelect.value || !query) {
    I18n.clear(cityResults, "innerHTML");
    return;
  }

  if (countrySelect.value !== lastCountry || cityList.length === 0 || query.length >= 2) {
    await loadCities(countrySelect.value, query);
  }

  renderCitySuggestions(query);
});

cityInput.addEventListener("keydown", (event) => {
  if (event.key === "Enter") event.preventDefault();
});

document.addEventListener("click", (event) => {
  const contactButton = event.target.closest("[data-contact-open]");
  if (contactButton) {
    openContactModal(contactButton);
    return;
  }

  const legalButton = event.target.closest("button[data-legal]");
  if (legalButton) {
    openLegalSection(legalButton.dataset.legal);
    return;
  }

  if (!cityResults.contains(event.target) && event.target !== cityInput) {
    I18n.clear(cityResults, "innerHTML");
  }
  if (!personCityResults.contains(event.target) && event.target !== personCityInput) {
    I18n.clear(personCityResults, "innerHTML");
  }
  if (personCountryCombobox && !personCountryCombobox.contains(event.target)) {
    closeCountrySuggestions();
  }
  if (!solarReturnCountryControl.input.closest(".country-combobox").contains(event.target)) {
    closeCountrySuggestions(solarReturnCountryControl);
  }
  if (chartSolarReturnCityResults && !chartSolarReturnCityResults.contains(event.target) && event.target !== chartSolarReturnCityInput) {
    I18n.clear(chartSolarReturnCityResults, "innerHTML");
  }
  if (sidebarAccount && !sidebarAccount.contains(event.target)) {
    closeSidebarAccountMenu();
  }
});

editBirthButton?.addEventListener("click", () => {
  showIntake();
});

openChartDataButton.addEventListener("click", () => {
  openChartDataDialog();
});

async function openChartDataDialog() {
  if (!chartCalculation) return;
  if (!canAccessGptIa()) {
    const message = T("interface.la_exportacion_de_prompts_esta_disponible_con_la_suscripcion_de_astroanamnesis");
    if (activePrivateSection === "maps") {
      setPrivateStatus(message, true);
    } else {
      setStatus(message);
    }
    return;
  }

  openChartDataButton.disabled = true;
  try {
    await ensureChartDataMatchesCurrentView();
    ensureAstroanamnesisPromptDefaults();
    renderChartDataModal();
    chartDataDialog.showModal();
  } catch (error) {
    setChartWheelStatus(() => error.message || T("interface.no_se_pudieron_preparar_los_datos_del_prompt_exportable"), true);
  } finally {
    openChartDataButton.disabled = false;
  }
}

openChartWheelButton?.addEventListener("click", () => {
  if (!chartCalculation) return;
  if (!canUseChartWheel()) {
    setStatus(() => T("interface.esta_vista_ya_no_esta_disponible"));
    return;
  }
  openChartWheelModal();
});

birthSummary.addEventListener("click", (event) => {
  const switchButton = event.target.closest("#switch-person");
  if (switchButton) {
    openPersonSwitchModal();
    return;
  }
});

collapsedOpenChartWheelButton?.addEventListener("click", () => {
  closeCollapsedChatPopover();
  if (!chartCalculation) {
    setStatus(() => T("interface.primero_calcula_las_cartas_para_abrir_los_graficos"));
    return;
  }
  if (!canUseChartWheel()) {
    setStatus(() => T("interface.esta_vista_ya_no_esta_disponible"));
    return;
  }
  openChartWheelModal();
});

collapsedChatList?.addEventListener("click", async (event) => {
  const button = event.target.closest("button[data-chat-id]");
  if (!button) return;
  closeCollapsedChatPopover();
  await loadSavedChat(button.dataset.chatId);
});

closePersonSwitchButton.addEventListener("click", closePersonSwitchModal);

personSwitchDialog.addEventListener("click", (event) => {
  if (event.target === personSwitchDialog) closePersonSwitchModal();
});

personSwitchDialog.addEventListener("cancel", (event) => {
  if (!["atlas3d", "tool"].includes(personSwitchRole)) return;
  event.preventDefault();
  closePersonSwitchModal();
});

personSwitchSearch.addEventListener("input", renderPersonSwitchList);

personSwitchList.addEventListener("click", async (event) => {
  if (personSwitchRole === "tool" && event.target.closest("button[data-tool-clear-person]")) {
    closePersonSwitchModal();
    selectToolPerson(null);
    return;
  }
  if (personSwitchRole === "atlas3d" && event.target.closest("button[data-atlas3d-clear-person]")) {
    closePersonSwitchModal();
    await selectPrivateAtlas3DPerson(null);
    return;
  }
  const button = event.target.closest("button[data-person-id]");
  if (!button) return;

  const person = savedPeople.find((item) => String(item.id) === button.dataset.personId);
  if (!person) return;

  if (personSwitchRole === "tool") {
    closePersonSwitchModal();
    selectToolPerson(person);
    return;
  }

  if (personSwitchRole === "atlas3d") {
    closePersonSwitchModal();
    await selectPrivateAtlas3DPerson(person);
    return;
  }

  if (personSwitchRole === "natal-transit") {
    natalAspectFinderPerson.value = String(person.id);
    renderNatalAspectFinderPeopleOptions();
    setNatalAspectFinderDefaultPlaceForPerson();
    window.WorkDashboard?.remember({ explicit: true });
    closePersonSwitchModal();
    return;
  }

  I18n.bind(personSwitchStatus, "textContent", () => T("interface.cargando_value", { v0: person.name }));
  personSwitchList.querySelectorAll("button").forEach((item) => {
    item.disabled = true;
  });
  const fullscreenSurface = activeChartFullscreenSurface();
  fullscreenSurface?.classList.add("is-chart-person-switch-loading");
  fullscreenSurface?.setAttribute("aria-busy", "true");

  try {
    closePersonSwitchModal();
    if (personSwitchRole === "partner") {
      if (String(person.id) === String(activePersonId || birthProfile?.personId || "")) {
        throw new Error(T("interface.la_persona_b_debe_ser_diferente_de_la_persona_a"));
      }
      chartSynastryPersonSelect.value = String(person.id);
      persistSelectedRelatedPerson();
      synastryCalculation = null;
      compositeCalculation = null;
      renderBirthSummary();
      await renderSelectedChartWheel();
    } else {
      await useSavedPerson(person);
    }
  } catch (error) {
    personSwitchDialog.showModal();
    I18n.bind(personSwitchStatus, "textContent", () => error.message || T("interface.no_se_pudo_cambiar_de_persona"));
    renderPersonSwitchList();
  } finally {
    const currentFullscreenSurface = activeChartFullscreenSurface();
    currentFullscreenSurface?.classList.remove("is-chart-person-switch-loading");
    currentFullscreenSurface?.removeAttribute("aria-busy");
  }
});

closeChartDataButton?.addEventListener("click", closeChartDataModal);
dismissChartDataButton?.addEventListener("click", closeChartDataModal);
generateChartDataButton?.addEventListener("click", async () => {
  generateChartDataButton.disabled = true;
  try {
    await ensureChartDataMatchesCurrentView();
    renderChartDataModal();
  } catch (error) {
    I18n.bind(chartDataOutput, "textContent", () => error.message || T("interface.no_se_pudieron_generar_los_datos_de_la_carta_seleccionada"));
  } finally {
    generateChartDataButton.disabled = false;
  }
});

chartDataDialog?.addEventListener("click", (event) => {
  if (event.target === chartDataDialog) closeChartDataModal();
});

closeChartWheelButton.addEventListener("click", closeChartWheelModal);

chartWheelDialog.addEventListener("click", (event) => {
  if (event.target === chartWheelDialog) closeChartWheelModal();
});

chatIaDialog?.addEventListener("click", (event) => {
  if (event.target === chatIaDialog) closeChartWheelModal();
});

chartWheelTypeSelect.addEventListener("change", async () => {
  const requestedType = chartWheelTypeSelect.value;
  const previousType = activeChartViewType || "multiple";
  try {
    await authorizeChartViewType(requestedType);
    setActiveChartViewType(requestedType, { syncControls: true });
    syncChartWheelControls();
    syncChatChartContextControls();
    renderBirthSummary();
    await renderSelectedChartWheel({ accessVerified: true });
  } catch (error) {
    setActiveChartViewType(previousType, { syncControls: true });
    syncChartWheelControls();
    syncChatChartContextControls();
    setChartWheelStatus(() => error.message || T("interface.no_tienes_acceso_a_esta_vista_de_carta"), true);
  }
});

if (renderChartWheelButton) {
  renderChartWheelButton.addEventListener("click", renderSelectedChartWheel);
}

if (chatChartContextTypeSelect) {
  chatChartContextTypeSelect.addEventListener("change", async () => {
    if (!chartWheelTypeSelect) return;
    const requestedType = chatChartContextTypeSelect.value;
    const previousType = activeChartViewType || "multiple";
    try {
      await authorizeChartViewType(requestedType);
      setActiveChartViewType(requestedType, { syncControls: true });
      syncChartWheelControls();
      syncChatChartContextControls();
      renderBirthSummary();
      await renderSelectedChartWheel({ accessVerified: true });
    } catch (error) {
      setActiveChartViewType(previousType, { syncControls: true });
      syncChartWheelControls();
      syncChatChartContextControls();
      setChartContextLoadStatus(() => error.message || T("interface.no_tienes_acceso_a_esta_vista_de_carta"), true);
    }
  });
}

if (chatLoadChartContextButton) {
  chatLoadChartContextButton.addEventListener("click", () => {
    loadSelectedChartContextIntoChat(chatChartContextTypeSelect?.value || "");
  });
}

chartWheelStage?.addEventListener("click", (event) => {
  const personSwitchButton = event.target.closest?.('[data-chart-action="switch-person"]');
  if (personSwitchButton && chartWheelStage.contains(personSwitchButton)) {
    openPersonSwitchModal({ role: personSwitchButton.dataset.personRole || "subject" });
    return;
  }

  const actionButton = event.target.closest?.("[data-chart-card-action]");
  if (!actionButton || !chartWheelStage.contains(actionButton)) return;

  const action = actionButton.dataset.chartCardAction;
  if (action === "planet-visibility") {
    actionButton.closest("details")?.removeAttribute("open");
    openChartPlanetVisibilityDialog();
    return;
  }

  if (action === "interpret") {
    actionButton.closest("details")?.removeAttribute("open");
    if (!chartCalculation || !canAccessGptIa()) return;
    openChartDataDialog();
    return;
  }

  if (action === "fullscreen") {
    toggleChartCardFullscreen(chartActionFullscreenTarget(actionButton));
    return;
  }

  if (action === "export-png" || action === "export-pdf") {
    actionButton.closest("details")?.removeAttribute("open");
    requestChartDownload(action === "export-pdf" ? "pdf" : "image", actionButton);
  }
});

function handleTransitDateTimeChange() {
  if (chartWheelTypeSelect.value === "transits") {
    renderBirthSummary();
    renderSelectedChartWheel();
  }
}

chartTransitDateInput.addEventListener("change", handleTransitDateTimeChange);
chartTransitTimeInput?.addEventListener("change", handleTransitDateTimeChange);

function handleProgressedDateTimeChange() {
  if (chartWheelTypeSelect.value !== "progressed") return;
  syncProgressedTimeMinimum();
  progressedCalculation = null;
  renderBirthSummary();
  renderSelectedChartWheel();
}

chartProgressedDateInput?.addEventListener("change", handleProgressedDateTimeChange);
chartProgressedTimeInput?.addEventListener("change", handleProgressedDateTimeChange);

chartSolarReturnYearInput?.addEventListener("change", () => {
  requestSolarReturnRefresh({ resolveLocation: true });
});
chartSolarReturnNatalInput?.addEventListener("change", handleSolarReturnNatalChange);
document.querySelector("#chart-solar-return-comparison")?.addEventListener("change", handleSolarReturnNatalChange);
chartWheelStage?.addEventListener("change", handleSolarReturnNatalChange);

chartSolarReturnCustomLocationInput?.addEventListener("change", () => {
  syncSolarReturnLocationControls();
  requestSolarReturnRefresh({ resolveLocation: true });
});

chartSolarReturnCountrySelect?.addEventListener("change", async () => {
  syncCountryCombobox(solarReturnCountryControl);
  clearSolarReturnSelectedCity();
  await loadSolarReturnCities(chartSolarReturnCountrySelect.value, "");
  chartSolarReturnCityInput.disabled = !chartSolarReturnCountrySelect.value;
  if (chartSolarReturnCountrySelect.value) chartSolarReturnCityInput.focus();
  if (chartWheelTypeSelect.value === "solarReturn" && chartSolarReturnCustomLocationInput?.checked) {
    solarReturnCalculation = null;
    setChartWheelStatus(() => T("interface.selecciona_la_ciudad_de_revolucion_para_recalcular"));
  }
});

chartSolarReturnCityInput?.addEventListener("input", async () => {
  clearSolarReturnPlaceSelection();
  const query = chartSolarReturnCityInput.value.trim();
  setChartWheelStatus("");
  if (!chartSolarReturnCountrySelect.value || !query) {
    I18n.clear(chartSolarReturnCityResults, "innerHTML");
    return;
  }

  if (chartSolarReturnCountrySelect.value !== solarReturnLastCountry || solarReturnCityList.length === 0 || query.length >= 2) {
    await loadSolarReturnCities(chartSolarReturnCountrySelect.value, query);
  }

  renderSolarReturnCitySuggestions(query);
  scheduleSolarReturnLocationRefresh();
});

chartSolarReturnCityInput?.addEventListener("keydown", (event) => {
  if (event.key === "Enter") {
    event.preventDefault();
    const exactCity = findSolarReturnExactCity(chartSolarReturnCityInput.value);
    if (exactCity) selectSolarReturnCity(exactCity);
  }
});

chartSolarReturnCityInput?.addEventListener("focus", () => {
  renderSolarReturnCitySuggestions(chartSolarReturnCityInput.value);
});

chartSolarReturnCityInput?.addEventListener("blur", () => {
  scheduleSolarReturnLocationRefresh();
});

chartSynastryPersonSelect.addEventListener("change", () => {
  persistSelectedRelatedPerson();
  if (["synastry", "composite", "compositeMultiple"].includes(chartWheelTypeSelect.value)) {
    renderBirthSummary();
    renderSelectedChartWheel();
  }
});

chartWheelStage.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-panel-action]");
  if (!button) return;

  button.closest(".chart-technical-more-menu")?.removeAttribute("open");
  toggleFloatingPanel(button.dataset.panelId, button.dataset.panelAction, button);
});

chartWheelStage.addEventListener("change", handleNodalReferenceControlChange);
chartWheelStage.addEventListener("change", handleCustomChartChange);
chartWheelStage.addEventListener("click", handleNodalReferenceControlClick);

chartWheelStage.addEventListener("click", async (event) => {
  const button = event.target.closest('button[data-chart-action="open-progressed-stations"]');
  if (!button) return;

  button.closest(".chart-technical-more-menu")?.removeAttribute("open");
  button.disabled = true;
  try {
    await authorizeChartViewType("progressed");
    const workspace = button.closest(".chart-wheel-workspace");
    if (!workspace) throw new Error(T("interface.no_se_encontro_el_espacio_de_la_carta_tropical"));

    let panel = workspace.querySelector("#tropical-progresada-estaciones");
    if (!panel) {
      setChartWheelStatus(() => T("interface.calculando_estaciones_progresadas"));
      if (!progressedCalculation) progressedCalculation = await fetchSecondaryProgressedCalculation();
      workspace.insertAdjacentHTML("beforeend", progressedStationsPanel(progressedCalculation));
      panel = workspace.querySelector("#tropical-progresada-estaciones");
    }

    if (!panel) throw new Error(T("interface.no_se_pudo_preparar_el_panel_de_estaciones_progresadas"));
    toggleFloatingPanel("tropical-progresada-estaciones", "show");
    setChartWheelStatus("");
  } catch (error) {
    setChartWheelStatus(() => error.message || T("interface.no_se_pudieron_abrir_las_estaciones_progresadas"), true);
  } finally {
    if (button.isConnected) button.disabled = false;
  }
});

chartWheelStage.addEventListener("pointerdown", startFloatingPanelDrag);
chartWheelStage.addEventListener("pointerdown", startFloatingPanelResize);
chartWheelStage.addEventListener("click", handleChartPatternClick);
chartWheelStage.addEventListener("click", handleChartPlanetFocusClick);
chartWheelStage.addEventListener("keydown", handleChartPlanetFocusKeydown);
chartWheelStage.addEventListener("keydown", handleChartContextDismiss);
document.addEventListener("click", handleChartContextDismiss);
document.addEventListener("focusin", handleChartContextDismiss);
chartWheelStage.addEventListener("focusin", handleChartPlanetTooltipFocusIn);
chartWheelStage.addEventListener("focusout", handleChartPlanetTooltipFocusOut);
chartWheelStage.addEventListener("pointerover", showChartPlanetTooltip);
chartWheelStage.addEventListener("pointermove", showChartPlanetTooltip);
chartWheelStage.addEventListener("pointerout", handleChartPlanetTooltipPointerOut);
chartWheelStage.addEventListener("pointerleave", () => hideChartPlanetTooltip());
chartWheelStage.addEventListener("scroll", () => hideChartPlanetTooltip({ force: true }), { capture: true, passive: true });
chartWheelStage.addEventListener("touchstart", handleChartTouchZoomStart, { passive: false });
chartWheelStage.addEventListener("touchmove", handleChartTouchZoomMove, { passive: false });
chartWheelStage.addEventListener("touchend", handleChartTouchZoomEnd, { passive: false });
chartWheelStage.addEventListener("touchcancel", handleChartTouchZoomEnd, { passive: false });
ensureChartPlanetTooltipElement();
document.addEventListener("pointermove", handleChartPlanetTooltipGlobalPointerMove, { passive: true });
document.addEventListener("pointerover", handleChartPlanetTooltipGlobalPointerMove, { passive: true });
document.addEventListener("click", handleChartPlanetTooltipDismiss);
// Capture the close gesture before fullscreen chart handlers or focus changes
// can turn it into a tap on the wheel underneath the tooltip.
document.addEventListener("pointerdown", handleChartTooltipCloseInteraction, true);
document.addEventListener("touchstart", handleChartTooltipCloseInteraction, { capture: true, passive: false });
document.addEventListener("touchend", handleChartTooltipCloseInteraction, { capture: true, passive: false });
document.addEventListener("click", handleChartTooltipCloseInteraction, true);
document.addEventListener("pointerdown", rememberChartTooltipOutsidePress, true);
document.addEventListener("click", handleChartTooltipOutsidePress, true);
window.addEventListener("resize", () => {
  arrangeFloatingPanels(chartWheelStage.querySelector(".chart-wheel-workspace"));
  repositionActiveChartPlanetTooltip();
});
window.visualViewport?.addEventListener("resize", () => {
  arrangeFloatingPanels(chartWheelStage.querySelector(".chart-wheel-workspace"));
  repositionActiveChartPlanetTooltip();
});
window.visualViewport?.addEventListener("scroll", () => {
  arrangeFloatingPanels(chartWheelStage.querySelector(".chart-wheel-workspace"));
  repositionActiveChartPlanetTooltip();
});

messagesEl.addEventListener("click", handleMessageActionClick);

closeLegalButton.addEventListener("click", closeLegalModal);

legalDialog.addEventListener("click", (event) => {
  if (event.target === legalDialog) closeLegalModal();
});

contactCloseButton?.addEventListener("click", closeContactModal);
contactSuccessCloseButton?.addEventListener("click", closeContactModal);
contactDialog?.addEventListener("click", (event) => {
  if (event.target === contactDialog) closeContactModal();
});
contactDialog?.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  event.preventDefault();
  closeContactModal();
});
contactDialog?.addEventListener("close", () => {
  const returnFocus = contactReturnFocus;
  contactReturnFocus = null;
  if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
});
contactForm?.addEventListener("submit", submitContactForm);
[contactReasonInput, contactNameInput, contactEmailInput, contactMessageInput].forEach((field) => {
  field?.addEventListener("input", () => clearContactFieldError(field));
  field?.addEventListener("change", () => clearContactFieldError(field));
});

privateSpaceTabs.forEach((button) => {
  button.addEventListener("click", () => {
    if (button.matches("[data-private-tools-toggle]")) {
      privateToolsMenuExpanded = !privateToolsMenuExpanded;
      syncPrivateToolsNavigationState();
      return;
    }
    showPrivateSection(button.dataset.privateSectionTab || "list");
    if (privateSidebarMobileQuery.matches) {
      privateSidebarCollapsed = true;
      applyPrivateSidebarState();
    }
    if (privateSidebarCollapsed) {
      togglePrivateSidebarButton?.focus({ preventScroll: true });
    }
  });
});

privateToolsRouteButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const toolsView = button.dataset.privateToolsRoute === "natal" ? "natal" : "transits";
    activePrivateToolsView = toolsView;
    privateToolsMenuExpanded = true;
    showPrivateSection("tools", { toolsView });
    if (privateSidebarMobileQuery.matches) {
      privateSidebarCollapsed = true;
      applyPrivateSidebarState();
      togglePrivateSidebarButton?.focus({ preventScroll: true });
    }
  });
});

privateToolsMenu?.addEventListener("keydown", (event) => {
  if (event.key !== "Escape" || !privateToolsMenuExpanded) return;
  event.preventDefault();
  event.stopPropagation();
  privateToolsMenuExpanded = false;
  syncPrivateToolsNavigationState();
  privateToolsToggle?.focus({ preventScroll: true });
});

privateTrainingRouteButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const trainingView = Object.hasOwn(PRIVATE_TRAINING_VIEW_ROUTES, button.dataset.privateTrainingRoute) ? button.dataset.privateTrainingRoute : "courses";
    activePrivateTrainingView = trainingView;
    showPrivateSection("training", { trainingView });
    if (privateSidebarMobileQuery.matches) {
      privateSidebarCollapsed = true;
      applyPrivateSidebarState();
      togglePrivateSidebarButton?.focus({ preventScroll: true });
    }
  });
});

async function handleTrainingActionClick(event) {
  const button = event.target.closest("[data-training-action]");
  if (!button) return;
  const action = button.dataset.trainingAction;
  const course = getTrainingCourse(button.dataset.courseId);
  if (action === "details" || action === "landing-details") {
    if (action === "landing-details") hideTrainingBanner();
    openTrainingCourseDialog(button.dataset.courseId);
  } else if (action === "register") {
    closeTrainingCourseDialog();
    openTrainingRegistrationDialog(button.dataset.courseId);
  } else if (action === "login-register") {
    closeTrainingCourseDialog();
    openAuthDialog("login", button);
  } else if (action === "calendar" && course) {
    downloadTrainingCalendar(course);
  } else if (action === "calendar-registration") {
    const registration = trainingRegistrations.find((item) => String(item.id) === String(button.dataset.registrationId));
    if (registration) downloadTrainingCalendar({ ...registration, title: registration.courseTitle, slug: registration.courseSlug });
  } else if (action === "cancel-registration") {
    await cancelTrainingRegistration(button.dataset.registrationId);
  } else if (action === "registrations" || action === "courses") {
    closeTrainingCourseDialog();
    const trainingView = action === "registrations" ? "registrations" : "courses";
    if (privateScreen?.classList.contains("is-hidden")) await openPrivateArea(true, "training");
    showPrivateSection("training", { trainingView });
  }
}

[trainingFeatured, trainingCourseList, trainingRegistrationList, trainingCourseDialogContent, landingTrainingAnnouncement].
forEach((element) => element?.addEventListener("click", handleTrainingActionClick));
trainingBanner?.addEventListener("click", handleTrainingBannerClick);
trainingCourseDialogCloseButton?.addEventListener("click", closeTrainingCourseDialog);
trainingCourseDialog?.addEventListener("click", (event) => {
  if (event.target === trainingCourseDialog) closeTrainingCourseDialog();
});
trainingRegistrationForm?.addEventListener("submit", submitTrainingRegistration);
trainingRegistrationDialogCloseButton?.addEventListener("click", closeTrainingRegistrationDialog);
trainingRegistrationCancelButton?.addEventListener("click", closeTrainingRegistrationDialog);
trainingRegistrationDialog?.addEventListener("click", (event) => {
  if (event.target === trainingRegistrationDialog) closeTrainingRegistrationDialog();
});

async function handlePrivateQuickActionClick(event) {
  const button = event.target.closest("button[data-private-quick-action]");
  if (!button) return;

  await handlePrivateDashboardAction(button.dataset.privateQuickAction || "");
  if (privateSidebarMobileQuery.matches) {
    privateSidebarCollapsed = true;
    applyPrivateSidebarState();
    togglePrivateSidebarButton?.focus({ preventScroll: true });
  }
}

privateFeatureNav?.addEventListener("click", handlePrivateQuickActionClick);
privateSpaceNav?.addEventListener("click", handlePrivateQuickActionClick);
privateQuickNav?.addEventListener("click", handlePrivateQuickActionClick);

aspectFinderForm?.addEventListener("submit", handleAspectFinderSubmit);
[aspectFinderPlanetA, aspectFinderPlanetB].forEach((select) => {
  select?.addEventListener("change", () => syncAspectFinderPlanetSelectAppearance(select));
});
aspectFinderAngle?.addEventListener("change", () => syncAspectFinderAspectSelectAppearance(aspectFinderAngle));
aspectFinderSwapButton?.addEventListener("click", () => {
  if (!aspectFinderPlanetA || !aspectFinderPlanetB) return;
  const planetA = aspectFinderPlanetA.value;
  aspectFinderPlanetA.value = aspectFinderPlanetB.value;
  aspectFinderPlanetB.value = planetA;
  syncAspectFinderPlanetSelectsAppearance();
});
aspectFinderCountry?.addEventListener("change", () => {
  aspectFinderSelectedPlace = null;
  if (aspectFinderCity) {
    aspectFinderCity.value = "";
    aspectFinderCity.disabled = !aspectFinderCountry.value;
    I18n.bind(aspectFinderCity, "placeholder", () => aspectFinderCountry.value ? T("interface.buscar_ciudad") : T("interface.selecciona_primero_un_pais"));
  }
  if (aspectFinderCityResults) I18n.clear(aspectFinderCityResults, "innerHTML");
  setAspectFinderLocationStatus(() => aspectFinderCountry.value ? T("interface.busca_y_selecciona_una_ciudad_de_la_lista") : T("interface.selecciona_un_pais"), true);
});
aspectFinderCity?.addEventListener("input", () => {
  aspectFinderSelectedPlace = null;
  setAspectFinderLocationStatus(() => T("interface.selecciona_una_ciudad_de_la_lista_para_confirmar_la_referencia"), true);
  window.clearTimeout(aspectFinderCitySearchTimer);
  aspectFinderCitySearchTimer = window.setTimeout(searchAspectFinderCities, 240);
});
aspectFinderCity?.addEventListener("keydown", (event) => {
  if (event.key !== "Enter") return;
  const firstResult = aspectFinderCityResults?.querySelector("button[data-place-id]");
  if (!firstResult) return;
  event.preventDefault();
  firstResult.click();
});
aspectFinderResult?.addEventListener("click", (event) => {
  const calendarButton = event.target.closest("[data-aspect-finder-calendar]");
  if (calendarButton) downloadAspectFinderCalendar();
  const chartButton = event.target.closest("[data-aspect-moment-chart]");
  if (chartButton) {
    openAspectMomentDialog(Number(chartButton.dataset.aspectMomentChart || 0)).catch((error) => {
      setAspectFinderStatus(() => error.message || T("interface.no_se_pudo_abrir_la_carta_del_momento"), true);
    });
  }
});

natalAspectFinderPersonPicker?.addEventListener("click", () => openPersonSwitchModal({ role: "natal-transit" }));
natalAspectFinderForm?.addEventListener("submit", handleNatalAspectFinderSubmit);
natalAspectFinderPerson?.addEventListener("change", () => {
  setNatalAspectFinderDefaultPlaceForPerson();
  window.WorkDashboard?.remember({ explicit: true });
});
[natalAspectFinderDate, natalAspectFinderTime].forEach((input) => {
  input?.addEventListener("input", syncNatalAspectFinderBirthLimits);
});
[natalAspectFinderTransitPlanet, natalAspectFinderNatalPlanet].forEach((select) => {
  select?.addEventListener("change", () => syncAspectFinderPlanetSelectAppearance(select));
});
natalAspectFinderAngle?.addEventListener("change", () => syncAspectFinderAspectSelectAppearance(natalAspectFinderAngle));
natalAspectFinderCountry?.addEventListener("change", () => {
  natalAspectFinderSelectedPlace = null;
  syncNatalAspectFinderBirthLimits();
  if (natalAspectFinderCity) {
    natalAspectFinderCity.value = "";
    natalAspectFinderCity.disabled = !natalAspectFinderCountry.value;
    I18n.bind(natalAspectFinderCity, "placeholder", () => natalAspectFinderCountry.value ? T("interface.buscar_ciudad") : T("interface.selecciona_primero_un_pais"));
  }
  if (natalAspectFinderCityResults) I18n.clear(natalAspectFinderCityResults, "innerHTML");
  setNatalAspectFinderLocationStatus(() => natalAspectFinderCountry.value ? T("interface.busca_y_selecciona_una_ciudad_de_la_lista") : T("interface.selecciona_un_pais"), true);
});
natalAspectFinderCity?.addEventListener("input", () => {
  natalAspectFinderSelectedPlace = null;
  syncNatalAspectFinderBirthLimits();
  setNatalAspectFinderLocationStatus(() => T("interface.selecciona_una_ciudad_de_la_lista_para_confirmar_la_referencia"), true);
  window.clearTimeout(natalAspectFinderCitySearchTimer);
  natalAspectFinderCitySearchTimer = window.setTimeout(searchNatalAspectFinderCities, 240);
});
natalAspectFinderCity?.addEventListener("keydown", (event) => {
  if (event.key !== "Enter") return;
  const firstResult = natalAspectFinderCityResults?.querySelector("button[data-place-id]");
  if (!firstResult) return;
  event.preventDefault();
  firstResult.click();
});
natalAspectFinderResult?.addEventListener("click", (event) => {
  if (event.target.closest("[data-aspect-finder-calendar]")) {
    downloadAspectFinderCalendar(latestNatalAspectFinderResult);
  }
  const chartButton = event.target.closest("[data-natal-transit-chart]");
  if (chartButton) {
    openNatalTransitMomentDialog(Number(chartButton.dataset.natalTransitChart || 0)).catch((error) => {
      setNatalAspectFinderStatus(() => error.message || T("interface.no_se_pudo_abrir_la_carta_con_transitos"), true);
    });
  }
});

privateDashboardSection?.addEventListener("click", async (event) => {
  const button = event.target.closest("button[data-private-dashboard-action]");
  if (!button) return;

  await handlePrivateDashboardAction(button.dataset.privateDashboardAction || "");
});

privateTransitPersonSelect?.addEventListener("change", () => {
  calculatePrivateTransits().catch((error) => {
    setPrivateTransitStatus(() => error.message || T("interface.no_se_pudieron_calcular_los_transitos"), true);
  });
});

privateTransitDateInput?.addEventListener("change", () => {
  calculatePrivateTransits().catch((error) => {
    setPrivateTransitStatus(() => error.message || T("interface.no_se_pudieron_calcular_los_transitos"), true);
  });
});

privateTransitOrbFilterSelect?.addEventListener("change", () => {
  privateTransitFilterOrb = privateTransitOrbFilterSelect.value || "3";
  renderPrivateTransitPlanetFilters();
  renderPrivateTransitTableFromState();
});

privateTransitPlanetFilters?.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-transit-planet-filter]");
  if (!button) return;

  privateTransitFilterPlanet = button.dataset.transitPlanetFilter || "";
  renderPrivateTransitPlanetFilters();
  renderPrivateTransitTableFromState();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && chartPlanetTooltipPinnedTarget) {
    clearChartPlanetFocus();
    hideChartPlanetTooltip({ force: true });
    return;
  }
});

document.addEventListener("fullscreenchange", () => {
  hideChartPlanetTooltip({ force: true });
  syncChartCardFullscreenState();
  syncAspectMomentFullscreenState();
  syncMobileFullscreenLongitudePanel();
  resetInactiveChartTouchZoom();
  arrangeFloatingPanels(chartWheelStage?.querySelector(".chart-wheel-workspace"));
  window.requestAnimationFrame(() => {
    initChartToolsScrollHints(chartWheelStage);
    initChartViewportFit(chartWheelStage);
  });
});

window.addEventListener("resize", () => {
  hideChartPlanetTooltip({ force: true });
  initChartToolsScrollHints(chartWheelStage);
  initChartViewportFit(chartWheelStage);
}, { passive: true });

generateDailyHoroscopeButton?.addEventListener("click", () => {
  generateDailyHoroscope().catch((error) => {
    setPrivateTransitStatus(() => error.message || T("interface.no_se_pudieron_consultar_los_transitos_personales"), true);
  });
});

dailyHoroscopeHistoryList?.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-horoscope-history-id]");
  if (!button) return;

  const item = readDailyHoroscopeHistory().find((entry) => entry.id === button.dataset.horoscopeHistoryId);
  if (item) openDailyHoroscopeModal(item, { fromHistory: true });
});

clearDailyHoroscopeHistoryButton?.addEventListener("click", () => {
  localStorage.removeItem(dailyHoroscopeHistoryKey());
  renderDailyHoroscopeHistory();
});

closeDailyHoroscopeButton?.addEventListener("click", () => dailyHoroscopeDialog?.close());

dailyHoroscopeDialog?.addEventListener("click", (event) => {
  if (event.target === dailyHoroscopeDialog) dailyHoroscopeDialog.close();
});

saveDailyHoroscopeButton?.addEventListener("click", () => {
  if (!currentDailyHoroscope) return;
  saveDailyHoroscopeToHistory(currentDailyHoroscope);
});

downloadDailyHoroscopeButton?.addEventListener("click", () => {
  if (!currentDailyHoroscope) return;
  downloadDailyHoroscope(currentDailyHoroscope);
});

billingPanel.addEventListener("click", async (event) => {
  const waitlistOpenButton = event.target.closest("[data-subscription-waitlist-open]");
  if (waitlistOpenButton) {
    openSubscriptionWaitlistDialog();
    return;
  }

  const waitlistCancelButton = event.target.closest("[data-subscription-waitlist-cancel]");
  if (waitlistCancelButton) {
    await cancelSubscriptionWaitlist(waitlistCancelButton);
    return;
  }

  const productDetailsButton = event.target.closest("[data-store-product-details]");
  if (productDetailsButton) {
    const productCard = productDetailsButton.closest("[data-store-product]");
    const selectedImage = productCard?.querySelector("[data-store-product-image]")?.getAttribute("src") || "";
    openStoreProductDetails(productDetailsButton.dataset.storeProductDetails, { initialImage: selectedImage });
    return;
  }

  const cardQuantityButton = event.target.closest("[data-store-card-quantity-change]");
  if (cardQuantityButton) {
    const input = cardQuantityButton.closest(".store-quantity-control")?.querySelector("[data-store-card-quantity]");
    setStoreQuantity(input, Number(input?.value || 1) + Number(cardQuantityButton.dataset.storeCardQuantityChange || 0));
    return;
  }

  const addToCartButton = event.target.closest("[data-store-cart-add]");
  if (addToCartButton) {
    addStoreCardToCart(addToCartButton.closest("[data-store-product]"));
    return;
  }

  const button = event.target.closest("button[data-purchase-kind]");
  if (!button) return;

  const purchaseKind = button.dataset.purchaseKind;
  const context = { source: activePrivateSection };
  if (purchaseKind === "store") {
    const productCard = button.closest("[data-store-product]");
    const variantSelect = productCard?.querySelector("[data-store-variant]");
    if (variantSelect?.required && !variantSelect.value) {
      variantSelect.reportValidity();
      return;
    }
    context.variant = variantSelect?.value || "";
  }

  await purchaseBillingItem(purchaseKind, button.dataset.purchaseKey, { context });
});

billingPanel.addEventListener("change", (event) => {
  const productOption = event.target.closest("[data-store-option]");
  if (productOption) {
    const card = productOption.closest("[data-store-product]");
    const image = card?.querySelector("[data-store-product-image]");
    const selectedImage = Array.from(card?.querySelectorAll("[data-store-option]") || []).
    map((select) => select.selectedOptions[0]?.dataset.optionImage || "").
    filter(Boolean).
    at(-1);
    const product = getStoreProduct(card?.dataset.storeProduct);
    if (image && product) image.src = selectedImage || product.image;
    return;
  }

  const cardQuantity = event.target.closest("[data-store-card-quantity]");
  if (cardQuantity) {
    setStoreQuantity(cardQuantity, cardQuantity.value);
    return;
  }

});

subscriptionWaitlistCloseButton?.addEventListener("click", closeSubscriptionWaitlistDialog);
subscriptionWaitlistCancelButton?.addEventListener("click", closeSubscriptionWaitlistDialog);
subscriptionWaitlistConsentInput?.addEventListener("change", syncSubscriptionWaitlistDialog);
subscriptionWaitlistConfirmButton?.addEventListener("click", submitSubscriptionWaitlist);
subscriptionWaitlistDialog?.addEventListener("click", (event) => {
  if (event.target === subscriptionWaitlistDialog) closeSubscriptionWaitlistDialog();
});

storeCartHeaderButton?.addEventListener("click", openStoreCartDialog);

storeCartDialog?.addEventListener("click", async (event) => {
  if (event.target === storeCartDialog || event.target.closest("[data-store-cart-close]")) {
    closeStoreCartDialog();
    return;
  }

  const quantityButton = event.target.closest("[data-store-cart-quantity-change]");
  if (quantityButton) {
    const index = Number(quantityButton.dataset.storeCartIndex);
    const item = storeCart[index];
    if (item) updateStoreCartQuantity(index, item.quantity + Number(quantityButton.dataset.storeCartQuantityChange || 0));
    return;
  }

  const removeButton = event.target.closest("[data-store-cart-remove]");
  if (removeButton) {
    storeCart.splice(Number(removeButton.dataset.storeCartIndex), 1);
    saveStoreCart();
    renderStoreCartDialog();
    return;
  }

  if (event.target.closest("[data-store-cart-checkout]")) {
    await checkoutStoreCart();
  }
});

storeCartDialog?.addEventListener("change", (event) => {
  const quantityInput = event.target.closest("[data-store-cart-quantity]");
  if (quantityInput) {
    updateStoreCartQuantity(Number(quantityInput.dataset.storeCartIndex), quantityInput.value);
  }
});

storeCartDialog?.addEventListener("close", syncStoreCartHeader);

function renderStoreImageZoom() {
  if (!storeImageZoomImage || !storeImageZoomCounter) return;
  const image = storeImageZoomGallery[storeImageZoomIndex];
  if (!image) return;

  storeImageZoomImage.src = image.src;
  I18n.bind(storeImageZoomImage, "alt", () => image.alt);
  I18n.bind(storeImageZoomCounter, "textContent", ((__i18nSnapshot0, __i18nSnapshot1) => () => __i18nSnapshot0.length > 1 ? `${__i18nSnapshot1 + 1} / ${__i18nSnapshot0.length}` : "")(storeImageZoomGallery, storeImageZoomIndex));


  const hasMultipleImages = storeImageZoomGallery.length > 1;
  storeImageZoomPrevButton?.classList.toggle("is-hidden", !hasMultipleImages);
  storeImageZoomNextButton?.classList.toggle("is-hidden", !hasMultipleImages);
}

function changeStoreImageZoom(step) {
  if (storeImageZoomGallery.length < 2) return;
  storeImageZoomIndex = (storeImageZoomIndex + step + storeImageZoomGallery.length) % storeImageZoomGallery.length;
  renderStoreImageZoom();
}

function openStoreImageZoom() {
  const mainImage = storeProductDialog?.querySelector("[data-store-product-detail-image]");
  if (!mainImage || !storeImageZoomDialog) return;

  const galleryButtons = Array.from(storeProductDialog.querySelectorAll("[data-store-product-gallery-image]"));
  storeImageZoomGallery = galleryButtons.length ?
  galleryButtons.map((button) => ({
    src: button.dataset.storeProductGalleryImage, get
    alt() {return button.dataset.storeProductGalleryLabel || T("interface.imagen_ampliada_del_producto");}
  })) :
  [{ src: mainImage.src, alt: mainImage.alt }];

  const currentPath = new URL(mainImage.src, window.location.href).pathname;
  const selectedIndex = storeImageZoomGallery.findIndex((image) => new URL(image.src, window.location.href).pathname === currentPath);
  storeImageZoomIndex = selectedIndex >= 0 ? selectedIndex : 0;
  renderStoreImageZoom();
  storeImageZoomDialog.showModal();
}

storeProductDialog?.addEventListener("click", (event) => {
  if (event.target === storeProductDialog || event.target.closest("[data-store-product-close]")) {
    storeProductDialog.close();
    return;
  }

  const zoomButton = event.target.closest("[data-store-product-image-zoom]");
  if (zoomButton) {
    openStoreImageZoom();
    return;
  }

  const galleryButton = event.target.closest("[data-store-product-gallery-image]");
  if (galleryButton) {
    const mainImage = storeProductDialog.querySelector("[data-store-product-detail-image]");
    const imageStage = storeProductDialog.querySelector("[data-store-product-image-zoom]");
    if (mainImage) {
      mainImage.src = galleryButton.dataset.storeProductGalleryImage;
      I18n.bind(mainImage, "alt", () => galleryButton.dataset.storeProductGalleryLabel || "");
    }
    if (imageStage) I18n.bind(imageStage, "@aria-label", () => T("interface.ampliar_value", { get v0() {return mainImage?.alt || T("interface.imagen_del_producto");} }));
    storeProductDialog.querySelectorAll("[data-store-product-gallery-image]").forEach((button) => {
      button.setAttribute("aria-pressed", String(button === galleryButton));
    });
    return;
  }

  const addButton = event.target.closest("[data-store-product-detail-add]");
  if (addButton) {
    const product = getStoreProduct(addButton.dataset.storeProductDetailAdd);
    storeProductDialog.close();
    addStoreItemToCart(product);
  }
});

storeImageZoomCloseButton?.addEventListener("click", () => storeImageZoomDialog?.close());
storeImageZoomPrevButton?.addEventListener("click", () => changeStoreImageZoom(-1));
storeImageZoomNextButton?.addEventListener("click", () => changeStoreImageZoom(1));

storeImageZoomDialog?.addEventListener("click", (event) => {
  if (event.target === storeImageZoomDialog) storeImageZoomDialog.close();
});

storeImageZoomDialog?.addEventListener("keydown", (event) => {
  if (event.key === "ArrowLeft") {
    event.preventDefault();
    changeStoreImageZoom(-1);
  } else if (event.key === "ArrowRight") {
    event.preventDefault();
    changeStoreImageZoom(1);
  }
});

openBillingInfoButton.addEventListener("click", () => {
  renderBillingInfoModal();
  billingInfoDialog.showModal();
});

chartDataFormatSelect?.addEventListener("change", renderChartDataModal);
chartPromptProfileSelect?.addEventListener("change", () => {
  const mode = selectedPromptMode();
  if (mode === "multiple" || mode === "report" || mode === "sessions") {
    if (chartPromptIncludeMemoria) chartPromptIncludeMemoria.checked = true;
    if (chartPromptIncludeTropical) chartPromptIncludeTropical.checked = true;
    if (chartPromptIncludeSideral) chartPromptIncludeSideral.checked = true;
  }
  if (mode === "multiple" || mode === "report") {
    applyAstroanamnesisPromptDefaults();
  } else if (mode === "sessions") {
    if (chartPromptEnablePreferences) chartPromptEnablePreferences.checked = true;
    if (chartPromptExtraInfo) chartPromptExtraInfo.value = PROMPT_SESSION_PREPARATION_CONTEXT;
  }
  renderChartDataModal();
});
[
chartPromptIncludeMemoria,
chartPromptIncludeTropical,
chartPromptIncludeSideral].
forEach((input) => {
  input?.addEventListener("change", () => {
    if (chartPromptProfileSelect && selectedPromptMode() !== "sessions") {
      const nextMode = promptConfigIsDefault(promptConfigCardSelection()) ?
      "multiple" :
      "custom";
      const previousMode = selectedPromptMode();
      chartPromptProfileSelect.value = nextMode;
      if (nextMode === "multiple" && previousMode !== "multiple") {
        applyAstroanamnesisPromptDefaults();
      }
    }
    renderChartDataModal();
  });
});
[
chartPromptEnablePreferences,
chartPromptLanguageSelect,
chartPromptSizeSelect,
chartPromptNarrativeSelect].
forEach((input) => {
  input?.addEventListener("change", renderChartDataModal);
});
chartPromptAstrologyLanguageSelect?.addEventListener("change", () => {
  syncPromptAstrologyLanguageContext();
  renderChartDataModal();
});
document.querySelectorAll("[data-prompt-preference]").forEach((input) => {
  input.addEventListener("change", () => {
    syncPromptConfigUi();
    renderChartDataModal();
  });
});
chartPromptExtraInfo?.addEventListener("input", renderChartDataModal);
chartPromptOtherStyleInput?.addEventListener("input", renderChartDataModal);
chartPromptOtherToneInput?.addEventListener("input", renderChartDataModal);

closeBillingInfoButton.addEventListener("click", closeBillingInfoModal);

billingInfoDialog.addEventListener("click", (event) => {
  if (event.target === billingInfoDialog) closeBillingInfoModal();
});


if (chatLegalAcceptInput) {
  chatLegalAcceptInput.addEventListener("change", () => {
    if (!chatLegalAcceptInput.checked) return;
    acceptLegalConsent();
    setStatus("");
  });
}

messagesEl.addEventListener("wheel", (event) => {
  if (isStreaming && event.deltaY < 0) autoScrollLocked = true;
}, { passive: true });

messagesEl.addEventListener("touchstart", () => {
  lastMessagesScrollTop = messagesEl.scrollTop;
}, { passive: true });

messagesEl.addEventListener("scroll", () => {
  if (!isStreaming) return;

  const scrollingUp = messagesEl.scrollTop < lastMessagesScrollTop;
  if (scrollingUp) autoScrollLocked = true;
  if (isNearBottom()) autoScrollLocked = false;

  lastMessagesScrollTop = messagesEl.scrollTop;
}, { passive: true });

promptSuggestions?.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-question]");
  if (!button) return;

  input.value = button.dataset.question;
  syncModelLevelWithMessage(input.value);
  resizeInput();
  input.focus();
  input.setSelectionRange(input.value.length, input.value.length);
});

attachContextFileButton?.addEventListener("click", () => {
  if (contextFilesBusy) return;
  contextFileInput?.click();
});

contextFileInput?.addEventListener("change", async () => {
  const files = Array.from(contextFileInput.files || []);
  contextFileInput.value = "";
  if (files.length) await addContextFiles(files);
});

contextFilesList?.addEventListener("click", (event) => {
  const button = event.target.closest("button[data-remove-context-file]");
  if (!button) return;
  attachedContextDocuments = attachedContextDocuments.filter((document) => document.id !== button.dataset.removeContextFile);
  renderAttachedContextDocuments();
});

chatScreen?.addEventListener("dragenter", handleContextDragEnter);
chatScreen?.addEventListener("dragover", handleContextDragOver);
chatScreen?.addEventListener("dragleave", handleContextDragLeave);
chatScreen?.addEventListener("drop", handleContextDrop);

copyChartDataButton?.addEventListener("click", async () => {
  const text = chartDataOutput.textContent.trim();
  if (!text) return;

  try {
    await navigator.clipboard.writeText(text);
    const copyLabel = copyChartDataButton.textContent;
    I18n.bind(copyChartDataButton, "textContent", () => T("interface.copiado"));
    I18n.bind(chartDataCopyStatus, "textContent", () => T("interface.prompt_copiado"));
    setTimeout(() => {
      I18n.bind(copyChartDataButton, "textContent", () => copyLabel || T("interface.copiar_prompt"));
      I18n.clear(chartDataCopyStatus, "textContent");
    }, 1800);
  } catch {
    I18n.bind(chartDataCopyStatus, "textContent", () => T("interface.no_se_pudo_copiar"));
  }
});

form.addEventListener("submit", async (event) => {
  event.preventDefault();
  const content = input.value.trim();
  if (!content || isStreaming) return;

  stopVoiceDictation();
  if (!ensureChatLegalConsent()) return;

  const canSend = await canSendCurrentMessage();
  if (!canSend) return;

  syncModelLevelWithMessage(content);
  input.value = "";
  resizeInput();
  autoScrollLocked = false;
  const userMessage = addMessage("user", content);

  const assistantMessage = addMessage("assistant", "");
  await sendMessage(content, assistantMessage, userMessage, buildAttachedContextPayload());
});

modelLevelSelect.addEventListener("change", () => {
  if (!isModelLevelAllowed(modelLevelSelect.value)) {
    syncAllowedModelLevel(true);
    return;
  }
  localStorage.setItem("modelLevel", modelLevelSelect.value);
});

newChatButton.addEventListener("click", startNewChat);

async function startNewChat() {
  const canCreateChat = await canCreateNewChat();
  if (!canCreateChat) return;

  closeCollapsedChatPopover();
  conversationId = "";
  activeChatId = "";
  localStorage.removeItem("conversationId");
  localStorage.removeItem("activeChatId");
  chatContextPreloaded = false;
  I18n.clear(messagesEl, "innerHTML");
  updateEmptyChatState();
  knowledgeStatusLoaded = false;
  await preloadChatContext().catch(() => {
    setError("Contexto pendiente");
  });
  setChatContextNotice();
  renderChatHistory();
  loadKnowledgeStatus();
}

input.addEventListener("input", resizeInput);
input.addEventListener("keydown", (event) => {
  if (event.key === "Enter" && !event.shiftKey) {
    event.preventDefault();
    form.requestSubmit();
  }
});

voiceDictationButton?.addEventListener("click", toggleVoiceDictation);
setupVoiceDictationButton();

async function sendMessage(content, assistantMessage, userMessage, attachedContext = null) {
  setBusy(true, "Conectando...");
  let streamFailed = false;
  let preserveStatus = false;

  try {
    let contextFallback = "";
    if (!chatContextPreloaded) {
      try {
        await preloadChatContext();
      } catch {
        contextFallback = buildBirthContext();
      }
    }

    const body = {
      conversationId,
      chatId: activeChatId || "",
      content,
      modelLevel: modelLevelSelect.value
    };
    if (contextFallback) body.context = contextFallback;
    if (attachedContext?.documents?.length) body.attachedContext = attachedContext;

    const response = await I18n.fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    if (!response.ok || !response.body) {
      throw new Error(T("interface.el_servidor_respondio_value", { v0: response.status }));
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let eventType = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("event: ")) {
          eventType = line.slice(7);
        } else if (line.startsWith("data: ")) {
          const payload = JSON.parse(line.slice(6));
          handleEvent(eventType, payload, assistantMessage);
          if (eventType === "error") streamFailed = true;
        }
      }
    }

    if (!streamFailed) {
      clearAttachedContextDocuments();
      await saveActiveChat(content).catch((error) => {
        setStatus(() => error.message || T("interface.no_se_pudo_guardar_el_chat"));
        preserveStatus = true;
      });
    } else if (userMessage && !getMessageText(assistantMessage).trim()) {
      userMessage.remove();
    }
  } catch (error) {
    const currentText = getMessageText(assistantMessage).trim();
    if (currentText) {
      setStatus(() => error.message || T("interface.el_stream_se_interrumpio_despues_de_recibir_una_respuesta_parcial"));
      preserveStatus = true;
    } else {
      setMessageText(assistantMessage, error.message || "No se pudo enviar el mensaje.");
    }
    assistantMessage.classList.add("error");
    setError("Error");
  } finally {
    setBusy(false, "Listo");
    if (!preserveStatus && !statusEl.textContent.startsWith("Consumo estimado")) setStatus("");
  }
}

function handleEvent(type, data, assistantMessage) {
  switch (type) {
    case "stream_start":
      conversationId = data.conversationId;
      localStorage.setItem("conversationId", conversationId);
      break;
    case "status":
      setStatus(data.text);
      break;
    case "token":
      appendMessageText(assistantMessage, data.text);
      scrollToBottom();
      break;
    case "stream_end":
      setMessageText(assistantMessage, data.content);
      renderAssistantMessageActions(assistantMessage);
      break;
    case "usage":
      applyUsageUpdate(data);
      break;
    case "error":
      if (getMessageText(assistantMessage).trim()) {
        setStatus(() => data.message || T("interface.el_stream_se_interrumpio_despues_de_recibir_una_respuesta_parcial"));
      } else {
        setMessageText(assistantMessage, data.message);
      }
      setError(data.code || "Error");
      break;
  }
}

function setAuthDialogStatus(text = "", isError = false) {
  if (!authDialogStatus) return;
  I18n.bind(authDialogStatus, "textContent", () => text);
  authDialogStatus.classList.toggle("error", Boolean(isError));
}

function setAuthPasswordVisibility(input, visible) {
  const toggle = authDialog?.querySelector('[data-password-toggle="' + input.id + '"]');
  if (!toggle) return;
  const start = input.selectionStart,end = input.selectionEnd;
  input.type = visible ? 'text' : 'password';
  // Preserve the original input, value, autofill and caret; change presentation only.
  if (start !== null && end !== null) input.setSelectionRange(start, end);
  const label = visible ? T("password-visibility.hide") : T("password-visibility.show");
  I18n.bind(toggle, "@aria-label", () => visible ? T("password-visibility.hide") : T("password-visibility.show"));
  I18n.bind(toggle, "title", () => visible ? T("password-visibility.hide") : T("password-visibility.show"));
  toggle.querySelector('[data-password-slash]')?.toggleAttribute('hidden', !visible);
}

function resetAuthPasswordVisibility() {
  authDialog?.querySelectorAll('[data-password-toggle]').forEach((toggle) => {
    const input = document.getElementById(toggle.dataset.passwordToggle);
    if (input) setAuthPasswordVisibility(input, false);
  });
}

function setAuthDialogMode(mode = "login", options = {}) {
  resetAuthPasswordVisibility();
  const safeMode = ["login", "register", "forgot", "reset", "request-verification", "verify", "reauth"].includes(mode) ? mode : "login";
  const content = { get
    login() {return { get eyebrow() {return T("interface.acceso_a_la_plataforma");}, get title() {return T("navigation.login");}, get subtitle() {return T("interface.entra_con_tu_correo_o_utiliza_tu_cuenta_de_google");}, focus: authLoginEmail };}, get





    register() {return { get eyebrow() {return T("interface.nueva_cuenta");}, get title() {return T("navigation.register");}, get subtitle() {return T("interface.confirma_tu_correo_para_guardar_tus_cartas_y_acceder_a_las_herramientas");}, focus: authRegisterName };}, get





    forgot() {return { get eyebrow() {return T("interface.recuperar_acceso");}, get title() {return T("interface.restablecer_contrasena");}, get subtitle() {return T("interface.te_ayudamos_a_volver_a_entrar_de_forma_segura");}, focus: authForgotEmail };}, get





    "request-verification"() {return { get eyebrow() {return T("interface.verificacion_de_correo");}, get title() {return T("interface.revisa_tu_correo");}, get subtitle() {return T("interface.un_paso_mas_para_proteger_tu_cuenta");}, focus: document.querySelector("#auth-verification-email") };}, get



    verify() {return { get eyebrow() {return T("interface.acceso_seguro");}, get title() {return T("interface.confirma_tu_correo");}, get subtitle() {return T("interface.elige_una_contrasena_para_completar_la_verificacion");}, focus: document.querySelector("#auth-verification-password") };}, get



    reauth() {return { get eyebrow() {return T("interface.proteccion_de_tu_cuenta");}, get title() {return T("interface.confirma_tu_identidad");}, get subtitle() {return T("interface.esta_accion_necesita_una_comprobacion_reciente_de_tu_identidad");}, focus: document.querySelector("#auth-reauth-password") };}, get



    reset() {return { get eyebrow() {return T("interface.nueva_contrasena");}, get title() {return T("interface.recuperar_tu_cuenta");}, get subtitle() {return T("interface.el_enlace_es_de_un_solo_uso_y_caduca_por_seguridad");}, focus: authResetPassword };}





  }[safeMode];

  authViews.forEach((view) => view.classList.toggle("is-hidden", view.dataset.authView !== safeMode));
  if (authDialogEyebrow) I18n.bind(authDialogEyebrow, "textContent", () => ({ get login() {return { get eyebrow() {return T("interface.acceso_a_la_plataforma");}, get title() {return T("navigation.login");}, get subtitle() {return T("interface.entra_con_tu_correo_o_utiliza_tu_cuenta_de_google");}, focus: authLoginEmail };}, get register() {return { get eyebrow() {return T("interface.nueva_cuenta");}, get title() {return T("navigation.register");}, get subtitle() {return T("interface.confirma_tu_correo_para_guardar_tus_cartas_y_acceder_a_las_herramientas");}, focus: authRegisterName };}, get forgot() {return { get eyebrow() {return T("interface.recuperar_acceso");}, get title() {return T("interface.restablecer_contrasena");}, get subtitle() {return T("interface.te_ayudamos_a_volver_a_entrar_de_forma_segura");}, focus: authForgotEmail };}, get "request-verification"() {return { get eyebrow() {return T("interface.verificacion_de_correo");}, get title() {return T("interface.revisa_tu_correo");}, get subtitle() {return T("interface.un_paso_mas_para_proteger_tu_cuenta");}, focus: document.querySelector("#auth-verification-email") };}, get verify() {return { get eyebrow() {return T("interface.acceso_seguro");}, get title() {return T("interface.confirma_tu_correo");}, get subtitle() {return T("interface.elige_una_contrasena_para_completar_la_verificacion");}, focus: document.querySelector("#auth-verification-password") };}, get reauth() {return { get eyebrow() {return T("interface.proteccion_de_tu_cuenta");}, get title() {return T("interface.confirma_tu_identidad");}, get subtitle() {return T("interface.esta_accion_necesita_una_comprobacion_reciente_de_tu_identidad");}, focus: document.querySelector("#auth-reauth-password") };}, get reset() {return { get eyebrow() {return T("interface.nueva_contrasena");}, get title() {return T("interface.recuperar_tu_cuenta");}, get subtitle() {return T("interface.el_enlace_es_de_un_solo_uso_y_caduca_por_seguridad");}, focus: authResetPassword };} })[safeMode].eyebrow);
  if (authDialogTitle) I18n.bind(authDialogTitle, "textContent", () => ({ get login() {return { get eyebrow() {return T("interface.acceso_a_la_plataforma");}, get title() {return T("navigation.login");}, get subtitle() {return T("interface.entra_con_tu_correo_o_utiliza_tu_cuenta_de_google");}, focus: authLoginEmail };}, get register() {return { get eyebrow() {return T("interface.nueva_cuenta");}, get title() {return T("navigation.register");}, get subtitle() {return T("interface.confirma_tu_correo_para_guardar_tus_cartas_y_acceder_a_las_herramientas");}, focus: authRegisterName };}, get forgot() {return { get eyebrow() {return T("interface.recuperar_acceso");}, get title() {return T("interface.restablecer_contrasena");}, get subtitle() {return T("interface.te_ayudamos_a_volver_a_entrar_de_forma_segura");}, focus: authForgotEmail };}, get "request-verification"() {return { get eyebrow() {return T("interface.verificacion_de_correo");}, get title() {return T("interface.revisa_tu_correo");}, get subtitle() {return T("interface.un_paso_mas_para_proteger_tu_cuenta");}, focus: document.querySelector("#auth-verification-email") };}, get verify() {return { get eyebrow() {return T("interface.acceso_seguro");}, get title() {return T("interface.confirma_tu_correo");}, get subtitle() {return T("interface.elige_una_contrasena_para_completar_la_verificacion");}, focus: document.querySelector("#auth-verification-password") };}, get reauth() {return { get eyebrow() {return T("interface.proteccion_de_tu_cuenta");}, get title() {return T("interface.confirma_tu_identidad");}, get subtitle() {return T("interface.esta_accion_necesita_una_comprobacion_reciente_de_tu_identidad");}, focus: document.querySelector("#auth-reauth-password") };}, get reset() {return { get eyebrow() {return T("interface.nueva_contrasena");}, get title() {return T("interface.recuperar_tu_cuenta");}, get subtitle() {return T("interface.el_enlace_es_de_un_solo_uso_y_caduca_por_seguridad");}, focus: authResetPassword };} })[safeMode].title);
  if (authDialogSubtitle) I18n.bind(authDialogSubtitle, "textContent", () => ({ get login() {return { get eyebrow() {return T("interface.acceso_a_la_plataforma");}, get title() {return T("navigation.login");}, get subtitle() {return T("interface.entra_con_tu_correo_o_utiliza_tu_cuenta_de_google");}, focus: authLoginEmail };}, get register() {return { get eyebrow() {return T("interface.nueva_cuenta");}, get title() {return T("navigation.register");}, get subtitle() {return T("interface.confirma_tu_correo_para_guardar_tus_cartas_y_acceder_a_las_herramientas");}, focus: authRegisterName };}, get forgot() {return { get eyebrow() {return T("interface.recuperar_acceso");}, get title() {return T("interface.restablecer_contrasena");}, get subtitle() {return T("interface.te_ayudamos_a_volver_a_entrar_de_forma_segura");}, focus: authForgotEmail };}, get "request-verification"() {return { get eyebrow() {return T("interface.verificacion_de_correo");}, get title() {return T("interface.revisa_tu_correo");}, get subtitle() {return T("interface.un_paso_mas_para_proteger_tu_cuenta");}, focus: document.querySelector("#auth-verification-email") };}, get verify() {return { get eyebrow() {return T("interface.acceso_seguro");}, get title() {return T("interface.confirma_tu_correo");}, get subtitle() {return T("interface.elige_una_contrasena_para_completar_la_verificacion");}, focus: document.querySelector("#auth-verification-password") };}, get reauth() {return { get eyebrow() {return T("interface.proteccion_de_tu_cuenta");}, get title() {return T("interface.confirma_tu_identidad");}, get subtitle() {return T("interface.esta_accion_necesita_una_comprobacion_reciente_de_tu_identidad");}, focus: document.querySelector("#auth-reauth-password") };}, get reset() {return { get eyebrow() {return T("interface.nueva_contrasena");}, get title() {return T("interface.recuperar_tu_cuenta");}, get subtitle() {return T("interface.el_enlace_es_de_un_solo_uso_y_caduca_por_seguridad");}, focus: authResetPassword };} })[safeMode].subtitle);
  if (!options.preserveStatus) setAuthDialogStatus("");

  if (safeMode === "forgot" && authForgotEmail && !authForgotEmail.value) {
    authForgotEmail.value = authLoginEmail?.value || authRegisterEmail?.value || "";
  }
  if (safeMode === "login" && authLoginEmail && !authLoginEmail.value) {
    authLoginEmail.value = authRegisterEmail?.value || authForgotEmail?.value || "";
  }
  if (safeMode === "request-verification") {
    const field = document.querySelector("#auth-verification-email");
    if (!field.value) field.value = authRegisterEmail?.value || authLoginEmail?.value || "";
  }
  if (safeMode === "reauth") {
    const hasVerifiedPassword = Boolean(currentUser?.hasPassword);
    document.querySelector("#auth-reauth-form")?.classList.toggle("is-hidden", !hasVerifiedPassword);
    document.querySelector('[data-auth-view="reauth"] .auth-divider')?.classList.toggle("is-hidden", !hasVerifiedPassword);
    if (!hasVerifiedPassword) content.focus = document.querySelector('[data-auth-view="reauth"] .auth-google-action');
  }
  window.requestAnimationFrame(() => content.focus?.focus({ preventScroll: true }));
}

function openAuthDialog(mode = "login", trigger = null, options = {}) {
  if (!authDialog) return;
  hideTrainingBanner();
  authDialogReturnFocus = trigger || document.activeElement;
  if (options.resetToken && authResetToken) authResetToken.value = options.resetToken;
  if (options.verifyToken) document.querySelector("#auth-verification-token").value = options.verifyToken;
  setAuthDialogMode(mode, { preserveStatus: options.preserveStatus });
  if (!authDialog.open) authDialog.showModal();
}

function closeAuthDialog() {
  if (authDialog?.open) authDialog.close();
}

function setAuthFormBusy(form, busy, busyText) {
  const submit = form?.querySelector('button[type="submit"]');
  if (!submit) return;
  if (!submit.dataset.defaultLabel) submit.dataset.defaultLabel = submit.textContent.trim();
  submit.disabled = busy;
  I18n.bind(submit, "textContent", () => busy ? busyText : submit.dataset.defaultLabel);
}

async function postAuthRequest(path, body) {
  const actions = { "/api/auth/login": "login", "/api/auth/register": "register", "/api/auth/email/resend": "resend", "/api/auth/password/forgot": "forgot" };
  if (actions[path]) body = { ...body, turnstileToken: await window.BotProtection.token(actions[path]) };
  const response = await I18n.fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || T("interface.no_se_pudo_completar_la_solicitud"));
    error.code = payload.code || "AUTH_REQUEST_ERROR";
    throw error;
  }
  return payload;
}

function validateAuthPasswordPair(password, confirmation) {
  if (Array.from(password).length < 10) throw new Error(T("interface.la_contrasena_debe_tener_al_menos_10_caracteres_puedes_utilizar_una_frase_larga"));
  if (password !== confirmation) throw new Error(T("interface.las_contrasenas_no_coinciden"));
}

async function completeEmailAuthentication(payload) {
  currentUser = payload.user || null;
  closeAuthDialog();
  await loadAuthState();
  await openPrivateArea(true, "space");
}

async function handleEmailLogin(event) {
  event.preventDefault();
  if (!authLoginForm?.checkValidity()) {
    authLoginForm?.reportValidity();
    return;
  }
  setAuthDialogStatus("");
  setAuthFormBusy(authLoginForm, true, T("interface.entrando"));
  try {
    const payload = await postAuthRequest("/api/auth/login", {
      email: authLoginEmail.value,
      password: authLoginPassword.value,
      remember: Boolean(authLoginRemember?.checked)
    });
    authLoginPassword.value = "";
    await completeEmailAuthentication(payload);
  } catch (error) {
    if (error.code === "EMAIL_VERIFICATION_REQUIRED") {
      document.querySelector("#auth-verification-email").value = authLoginEmail.value;
      setAuthDialogMode("request-verification");
    }
    setAuthDialogStatus(() => error.message || T("interface.no_se_pudo_iniciar_sesion"), true);
  } finally {
    setAuthFormBusy(authLoginForm, false, "");
  }
}

async function handleEmailRegistration(event) {
  event.preventDefault();
  if (!authRegisterForm?.checkValidity()) {
    authRegisterForm?.reportValidity();
    return;
  }
  setAuthDialogStatus("");
  setAuthFormBusy(authRegisterForm, true, T("interface.creando_cuenta"));
  try {
    if (!authRegisterConsent.checked) throw new Error(T("interface.debes_aceptar_la_politica_de_privacidad_y_las_condiciones"));
    const payload = await postAuthRequest("/api/auth/register", {
      name: authRegisterName.value,
      email: authRegisterEmail.value,
      language: window.I18n?.language || "es",
      consent: true
    });
    document.querySelector("#auth-verification-email").value = authRegisterEmail.value;
    setAuthDialogMode("request-verification");
    setAuthDialogStatus(payload.message);
  } catch (error) {
    setAuthDialogStatus(() => error.message || T("interface.no_se_pudo_crear_la_cuenta"), true);
  } finally {
    setAuthFormBusy(authRegisterForm, false, "");
  }
}

async function handlePasswordRecoveryRequest(event) {
  event.preventDefault();
  if (!authForgotForm?.checkValidity()) {
    authForgotForm?.reportValidity();
    return;
  }
  setAuthDialogStatus("");
  setAuthFormBusy(authForgotForm, true, T("interface.enviando"));
  try {
    await postAuthRequest("/api/auth/password/forgot", { email: authForgotEmail.value });
    setAuthDialogStatus(() => T("interface.si_existe_una_cuenta_con_ese_correo_recibiras_un_enlace_para_restablecer_la_contrasen"));
  } catch (error) {
    setAuthDialogStatus(() => error.message || T("interface.no_se_pudo_enviar_el_enlace"), true);
  } finally {
    setAuthFormBusy(authForgotForm, false, "");
  }
}

async function handlePasswordReset(event) {
  event.preventDefault();
  if (!authResetForm?.checkValidity()) {
    authResetForm?.reportValidity();
    return;
  }
  setAuthDialogStatus("");
  setAuthFormBusy(authResetForm, true, T("interface.guardando_2"));
  try {
    validateAuthPasswordPair(authResetPassword.value, authResetConfirm.value);
    const payload = await postAuthRequest("/api/auth/password/reset", {
      token: authResetToken.value,
      password: authResetPassword.value
    });
    authResetPassword.value = "";
    authResetConfirm.value = "";
    authResetToken.value = "";
    await loadAuthState();
    setAuthDialogMode("login");
    setAuthDialogStatus(payload.message);
  } catch (error) {
    setAuthDialogStatus(() => error.message || T("interface.el_enlace_no_es_valido_o_ha_caducado"), true);
  } finally {
    setAuthFormBusy(authResetForm, false, "");
  }
}

async function handleVerificationRequest(event) {
  event.preventDefault();
  const form = event.currentTarget;
  if (!form.reportValidity()) return;
  setAuthFormBusy(form, true, T("interface.enviando"));
  setAuthDialogStatus("");
  try {
    const payload = await postAuthRequest("/api/auth/email/resend", { email: document.querySelector("#auth-verification-email").value });
    setAuthDialogStatus(payload.message);
  } catch (error) {setAuthDialogStatus(error.message, true);} finally
  {setAuthFormBusy(form, false, "");}
}

async function handleEmailVerification(event) {
  event.preventDefault();
  const form = event.currentTarget;
  if (!form.reportValidity()) return;
  const password = document.querySelector("#auth-verification-password");
  const confirmation = document.querySelector("#auth-verification-confirm");
  const token = document.querySelector("#auth-verification-token");
  setAuthFormBusy(form, true, T("interface.confirmando"));
  setAuthDialogStatus("");
  try {
    validateAuthPasswordPair(password.value, confirmation.value);
    const payload = await postAuthRequest("/api/auth/email/verify", { token: token.value, password: password.value });
    password.value = confirmation.value = token.value = "";
    await loadAuthState();
    setAuthDialogMode("login");
    setAuthDialogStatus(payload.message);
  } catch (error) {setAuthDialogStatus(error.message, true);} finally
  {setAuthFormBusy(form, false, "");}
}

async function handleReauthentication(event) {
  event.preventDefault();
  const form = event.currentTarget;
  if (!form.reportValidity()) return;
  const input = document.querySelector("#auth-reauth-password");
  setAuthFormBusy(form, true, T("interface.comprobando"));
  setAuthDialogStatus("");
  try {
    await postAuthRequest("/api/auth/reauthenticate", { password: input.value });
    input.value = "";
    closeAuthDialog();
    setAccountSettingsStatus(() => T("interface.identidad_confirmada_ya_puedes_volver_a_solicitar_la_accion"));
    if (currentUser?.isAdmin && !privateAdminSection?.classList.contains("is-hidden")) await window.AdminSecurity.ensure(true);
  } catch (error) {setAuthDialogStatus(error.message, true);} finally
  {setAuthFormBusy(form, false, "");}
}

function handleAuthPageRestore(event) {
  // Back/forward cache restores the old DOM and currentUser without rerunning
  // startup, even when the session cookie changed during Google sign-in.
  if (!event.persisted) return;
  landingScreen?.classList.add("is-auth-pending");
  return loadAuthState();
}

async function loadAuthState() {
  try {
    const authParams = new URLSearchParams(window.location.search);
    const authError = authParams.get("auth_error");
    const tokenParams = new URLSearchParams(window.location.hash.slice(1));
    const resetToken = clean(tokenParams.get("reset_token") || authParams.get("reset_token"));
    const verifyToken = clean(tokenParams.get("verify_token"));
    if (resetToken || verifyToken) {
      authParams.delete("reset_token");
      const remaining = authParams.toString();
      I18n.replaceState(null, "", I18n.routePath() + (remaining ? `?${remaining}` : ""));
    }
    const response = await I18n.fetch("/api/auth/me", { cache: "no-store", signal: AbortSignal.timeout(10000) });
    const payload = await response.json().catch(() => ({}));
    currentUser = payload.authenticated ? payload.user : null;
    document.dispatchEvent(new CustomEvent("security-auth-changed", { detail: currentUser?.id || null }));
    const emailNotice = document.querySelector("#auth-email-availability");
    if (emailNotice) {
      const unavailable = payload.emailDeliveryConfigured === false;
      emailNotice.classList.toggle("is-hidden", !unavailable);
      I18n.bind(emailNotice, "textContent", () => unavailable ? T("interface.el_registro_por_correo_estara_disponible_cuando_se_active_el_servicio_de_verificacion") : "");
      const registerSubmit = authRegisterForm?.querySelector('button[type="submit"]');
      if (registerSubmit) registerSubmit.disabled = unavailable;
    }
    renderLandingAuthState();
    if (currentUser) await loadAccountPreferences().catch(() => null);
    await revealLandingHeader();
    await moduleVisibilityLoadPromise?.catch(() => null);
    prepareLegacyModuleVisibilityDraft();
    chatHistory = [];
    chatHistoryLoaded = false;
    loadChatUiPreferences();
    if (currentUser) {
      await loadChatUiPreferencesFromServer().catch(() => null);
      await loadBillingSummary({ silent: true }).catch(() => null);
    } else {
      accountPreferencesLoaded = false;
      chatUiServerLoaded = false;
    }
    renderAuthState(payload);
    renderChatHistory();
    await loadTrainingData({ force: true }).catch(() => {
      renderLandingTrainingAnnouncement();
    });
    if (!chatScreen.classList.contains("is-hidden")) {
      await loadChatHistory().catch(() => renderChatHistory());
    }

    if (I18n.routePath() === GUEST_INTAKE_ROUTE) {
      showIntake(false);
    } else if (I18n.routePath() === ABOUT_ROUTE) {
      showAboutPage(false);
    } else if (I18n.routePath() === DONATION_ROUTE) {
      showDonationPage(false);
    } else if (I18n.routePath() === "/chat") {
      I18n.replaceState(null, "", currentUser ? getPrivateSectionPath("maps") : "/");
      if (currentUser) await openPrivateArea(false, "maps");else
      showLanding();
    } else if (isPrivateRoutePath(I18n.routePath())) {
      if (currentUser) {
        await openPrivateArea(false, getPrivateSectionFromRoute());
      } else {
        I18n.replaceState(null, "", "/");
        showLanding();
        setAuthStatus("");
      }
    } else if (I18n.routePath() === "/admin") {
      if (currentUser?.isAdmin) {
        await openAdminPanel(false);
        if (I18n.routePath() !== getPrivateSectionPath("admin")) {
          I18n.replaceState(null, "", getPrivateSectionPath("admin"));
        }
      } else {
        showLanding();
        setAuthStatus(() => T("interface.no_tienes_permisos_de_administracion"), true);
      }
    }

    if (resetToken || verifyToken || !currentUser && authError) {
      showLanding();
      I18n.replaceState(null, "", I18n.routePath() || "/");
      if (verifyToken) {
        openAuthDialog("verify", null, { verifyToken });
      } else if (resetToken) {
        openAuthDialog("reset", null, { resetToken });
      } else {
        openAuthDialog("login", null, { preserveStatus: true });
        setAuthDialogStatus(getAuthErrorMessage(authError), true);
      }
    }
  } catch {
    renderLandingAuthState();
    await revealLandingHeader();
    setAuthStatus(() => T("interface.no_se_pudo_comprobar_la_sesion"), true);
  } finally {
    document.documentElement.classList.remove("is-private-route-pending");
    document.documentElement.classList.remove("is-donation-route-pending");
    document.documentElement.classList.remove("is-about-route-pending");
    initialPrivateRouteLoader?.setAttribute("aria-hidden", "true");
  }
}

async function refreshAccountSubscriptionState() {
  if (!currentUser || document.visibilityState === "hidden") return null;
  if (accountSubscriptionSyncPromise) return accountSubscriptionSyncPromise;

  const now = Date.now();
  if (now - lastAccountSubscriptionSyncAt < 5_000) return null;
  lastAccountSubscriptionSyncAt = now;

  accountSubscriptionSyncPromise = loadBillingSummary({ silent: true }).
  then((summary) => {
    if (!summary || !currentUser) return summary;
    renderAuthState();
    if (accountSettingsDialog?.open) renderAccountSettings();
    return summary;
  }).
  catch(() => null).
  finally(() => {
    accountSubscriptionSyncPromise = null;
  });

  return accountSubscriptionSyncPromise;
}

async function revealLandingHeader() {
  if (!landingScreen?.classList.contains("is-auth-pending")) return;
  // Font metrics affect how many theme buttons fit. Reveal the complete header
  // only after preferences and fonts settle; a blocked font must not hide it forever.
  let fontTimeout;
  try {
    await Promise.race([
    document.fonts?.ready || Promise.resolve(),
    new Promise((resolve) => {fontTimeout = setTimeout(resolve, 1500);})]
    );
  } catch {

    // System fonts remain usable if a web font fails.
  } finally {clearTimeout(fontTimeout);
    landingScreen?.classList.remove("is-auth-pending");
  }
}

function renderLandingAuthState() {
  const authenticated = Boolean(currentUser);
  if (!authenticated) {privateWorkPeopleOwner = null;privateNotebookTarget = null;}
  landingLoginLinks.forEach((link) => link.classList.toggle("is-hidden", authenticated));
  landingOpenPrivateButton?.classList.toggle("is-hidden", !authenticated);
  landingHeaderTryButton?.classList.toggle("is-hidden", authenticated);
  landingHeroTrialNote?.classList.toggle("is-hidden", authenticated);
  if (landingHeroPrimaryButton) {
    I18n.bind(landingHeroPrimaryButton, "textContent", () => authenticated ? T("interface.crear_una_carta") : T("interface.crear_mi_primera_carta"));
  }
  if (landingBottomTryButton) {
    I18n.bind(landingBottomTryButton, "textContent", () => authenticated ? T("interface.ir_a_mi_espacio") : T("interface.crear_mi_carta"));
  }
  if (landingBottomEyebrow) {
    I18n.bind(landingBottomEyebrow, "textContent", () => authenticated ? T("interface.continua_en_mi_espacio") : T("interface.empieza_con_tu_primera_carta"));
  }
  if (landingBottomTitle) {
    I18n.bind(landingBottomTitle, "textContent", () => authenticated ? T("interface.tus_cartas_y_herramientas_estan_en_mi_espacio") : T("interface.crea_una_carta_explora_sus_mapas_y_decide_si_quieres_guardarla"));


  }
  if (landingBottomCopy) {
    I18n.bind(landingBottomCopy, "textContent", () => authenticated ? T("interface.vuelve_a_tu_espacio_de_trabajo_para_organizar_cartas_consultantes_y_sesiones") : T("interface.puedes_crearla_sin_registrarte_cuando_quieras_conservarla_y_organizar_tus_consultante"));


  }
}

function syncMemoryGameNavigation() {
  let link = document.getElementById("private-memory-game-link");
  let section = document.getElementById("private-memory-game-section");
  if (!currentUser?.canPlayMemoryWorlds) {link?.remove();section?.remove();return;}
  if (link) return;
  const nav = document.querySelector(".private-space-nav");
  if (!nav) return;
  const games = nav.querySelector('.entertainment-link[href="/juegos/"]');
  let items = games?.parentElement;
  if (!items) {
    section = document.createElement("div");
    section.id = "private-memory-game-section";
    section.className = "private-nav-section";
    const title = document.createElement("p");
    title.className = "private-nav-section-title";
    I18n.bind(title, "textContent", () => T("navigation.entertainment"));
    items = document.createElement("div");
    items.className = "private-nav-section-items";
    section.append(title, items);
    nav.append(section);
  }
  link = document.createElement("a");
  link.id = "private-memory-game-link";
  link.className = "entertainment-link";
  link.href = "/juegos/atlas-144";
  const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  icon.setAttribute("viewBox", "0 0 24 24");
  icon.setAttribute("aria-hidden", "true");
  const arch = document.createElementNS("http://www.w3.org/2000/svg", "path");
  arch.setAttribute("d", "M5 21V11a7 7 0 0 1 14 0v10M3 21h18M9 21V11a3 3 0 0 1 6 0v10M12 1v3");
  icon.append(arch);
  const label = document.createElement("span");
  I18n.bind(label, "textContent", () => T("navigation.memoryGame"));
  link.append(icon, label);
  if (games) games.after(link);else
  items.append(link);
}

function renderAuthState(payload = {}) {
  window.WorkDashboard?.sync();
  syncObservatoryNavigation();
  syncTimelineNavigation();
  syncMemoryGameNavigation();
  window.OnboardingAccess?.sync();
  syncAtlasChartAccess();
  window.PeopleAaf?.setUser(currentUser?.id || null);
  renderLandingAuthState();
  const authenticated = Boolean(currentUser);
  loginGoogleLink.classList.toggle("is-hidden", authenticated);
  openPrivateButton.classList.toggle("is-hidden", !authenticated);
  intakeHomeButton?.classList.toggle("is-hidden", authenticated);
  chatPrivateButton.classList.toggle("is-hidden", !authenticated);
  collapsedPrivateButton?.classList.toggle("is-hidden", !authenticated);
  chatHomeButton?.classList.toggle("is-hidden", authenticated);
  calculateAnotherChartButton?.classList.toggle("is-hidden", authenticated);
  sidebarAccount?.classList.toggle("is-hidden", !authenticated);
  sidebarAdminLink?.classList.toggle("is-hidden", !currentUser?.isAdmin);
  privateAdminLink?.classList.toggle("is-hidden", !currentUser?.isAdmin);
  privateAdminNavSection?.classList.toggle("is-hidden", !currentUser?.isAdmin);
  privateAdminDashboardCard?.classList.toggle("is-hidden", !currentUser?.isAdmin);
  // Create this private navigation item only for the server-granted capability.
  let atlasNav = document.getElementById("private-atlas-link");
  if (currentUser?.canAccessAtlas && !atlasNav) {
    atlasNav = document.createElement("button");
    atlasNav.id = "private-atlas-link";
    atlasNav.type = "button";
    atlasNav.dataset.privateSectionTab = "atlas";
    I18n.bind(atlasNav, "textContent", () => T("atlas.name"));
    atlasNav.addEventListener("click", async () => {
      if (!currentUser?.canAccessAtlas) return;
      if (!currentUser.isAdmin || (await window.AdminSecurity?.ensure())) {
        if (!currentUser?.canAccessAtlas) return;
        showPrivateSection("atlas", { atlasPath: "/private/atlas" });
        if (privateSidebarMobileQuery.matches) {
          privateSidebarCollapsed = true;
          applyPrivateSidebarState();
        }
      } else
      showPrivateSection("admin");
    });
    privateToolsSubmenu?.prepend(atlasNav);
  } else if (!currentUser?.canAccessAtlas) {
    atlasNav?.remove();
    privateAtlasRequest?.abort();
    privateAtlasController?.destroy();
    privateAtlasController = null;
    document.getElementById("private-atlas-section")?.remove();
  }
  if (!authenticated) closeSidebarAccountMenu();
  syncAllowedModelLevel(false);
  syncSubscriberOnlyChartViews();
  syncSubscriberOnlyTools();
  updateChartDataButton();
  renderCreditWidgets();
  renderBillingUI();
  renderSidebarAccount();
  if (authGoogleButton) {
    const googleAvailable = payload.googleConfigured !== false;
    authGoogleButton.setAttribute("aria-disabled", googleAvailable ? "false" : "true");
    I18n.bind(authGoogleButton, "title", () => googleAvailable ? "" : T("interface.el_acceso_con_google_aun_no_esta_configurado"));
  }

  if (authenticated) {
    setAuthStatus("");
  } else if (payload.googleConfigured === false) {
    setAuthStatus(() => T("interface.google_oauth_aun_no_esta_configurado_en_el_backend"), true);
  } else if (!authStatus.classList.contains("error")) {
    setAuthStatus("");
  }

  if (privateUser) {
    I18n.bind(privateUser, "innerHTML", () => authenticated ? renderPrivateUserCard({ sidebar: true }) : "");


    closePrivateAccountMenu();
  }
  if (adminUser) {
    I18n.bind(adminUser, "innerHTML", () => authenticated ? renderPrivateUserCard() : "");


  }
  // Clear account renderers before language refresh can revisit their content.
  window.I18n?.setUser(currentUser?.id || null);
}

function renderSidebarAccount() {
  if (!sidebarAccount || !currentUser) return;

  const name = currentUser.name || currentUser.email || T("interface.usuario");
  const email = currentUser.email || "";

  renderAvatarElement(sidebarAccountAvatar, currentUser);
  if (sidebarAccountName) I18n.bind(sidebarAccountName, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.name || __i18nSnapshot0.email || T("interface.usuario"))(currentUser));
  if (sidebarAccountEmail) I18n.bind(sidebarAccountEmail, "textContent", () => email);
  if (sidebarAccountMenuName) I18n.bind(sidebarAccountMenuName, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.name || __i18nSnapshot0.email || T("interface.usuario"))(currentUser));
  if (sidebarAccountMenuEmail) I18n.bind(sidebarAccountMenuEmail, "textContent", () => email);
}

function renderAvatarElement(target, user = currentUser) {
  if (!target || !user) return;
  const name = user.name || user.email || T("interface.usuario");
  const email = user.email || "";
  const picture = user.picture || "";
  I18n.bind(target, "innerHTML", () => picture ? `<img src="${escapeHtml(picture)}" alt="">` : escapeHtml(getUserInitials(user.name || user.email || T("interface.usuario"), email)));


}

function readStoredAccountTextSize() {
  try {
    const stored = localStorage.getItem(ACCOUNT_TEXT_SIZE_STORAGE_KEY) || "normal";
    return ACCOUNT_TEXT_SIZES.includes(stored) ? stored : "normal";
  } catch (_error) {
    return "normal";
  }
}

function readStoredReduceMotion() {
  try {
    return localStorage.getItem(ACCOUNT_REDUCE_MOTION_STORAGE_KEY) === "true";
  } catch (_error) {
    return false;
  }
}

function applyAccountAccessibilityPreferences(options = {}) {
  accountTextSize = ACCOUNT_TEXT_SIZES.includes(accountTextSize) ? accountTextSize : "normal";
  document.documentElement.dataset.textSize = accountTextSize;
  document.documentElement.dataset.reduceMotion = accountReduceMotion ? "true" : "false";
  if (options.persist) {
    try {
      localStorage.setItem(ACCOUNT_TEXT_SIZE_STORAGE_KEY, accountTextSize);
      localStorage.setItem(ACCOUNT_REDUCE_MOTION_STORAGE_KEY, accountReduceMotion ? "true" : "false");
    } catch (_error) {

      // Las preferencias siguen activas durante esta sesión.
    }queueAccountPreferencesSave();
  }
}

function setAccountTextSize(value, options = {}) {
  accountTextSize = ACCOUNT_TEXT_SIZES.includes(value) ? value : "normal";
  applyAccountAccessibilityPreferences(options);
}

function detectAccountTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (_error) {
    return "UTC";
  }
}

function splitAccountDisplayName(value = "") {
  const parts = String(value || "").trim().split(/\s+/).filter(Boolean);
  return {
    firstName: parts.shift() || "",
    lastName: parts.join(" ")
  };
}

function normalizeAccountPersonalInformation(profile = {}, options = {}) {
  const source = profile && typeof profile === "object" && !Array.isArray(profile) ? profile : {};
  const fallbackName = options.useAccountName === false ?
  { firstName: "", lastName: "" } :
  splitAccountDisplayName(currentUser?.name || "");
  const language = String(source.language || "").trim().toLowerCase();
  const country = String(source.country || "").trim().toUpperCase();
  return {
    firstName: String(source.firstName || fallbackName.firstName).trim().slice(0, 80),
    lastName: String(source.lastName || fallbackName.lastName).trim().slice(0, 120),
    phone: String(source.phone || "").trim().slice(0, 40),
    country: /^[A-Z]{2}$/.test(country) ? country : "",
    language: ACCOUNT_PROFILE_LANGUAGES.includes(language) ? language : "es",
    timezone: String(source.timezone || detectAccountTimeZone()).trim().slice(0, 100) || "UTC"
  };
}

function buildCurrentAccountPreferences() {
  return {
    profile: normalizeAccountPersonalInformation(accountPersonalInformation),
    map: {
      defaultView: safeChartViewType(localStorage.getItem(CHART_VIEW_TYPE_STORAGE_KEY) || activeChartViewType || "multiple"),
      customCharts: normalizeCustomChartSelection(customChartSelection),
      houseSystem: CHART_HOUSE_SYSTEMS[chartHouseSystemKey] ? chartHouseSystemKey : DEFAULT_CHART_HOUSE_SYSTEM,
      visiblePlanets: Array.from(chartVisiblePlanetKeys).filter((key) => CHART_SELECTABLE_PLANETS.includes(key)),
      aspectPlanets: Array.from(chartAspectPlanetKeys).filter((key) => CHART_SELECTABLE_PLANETS.includes(key)),
      planetColors: Object.fromEntries(CHART_PLANET_COLOR_KEYS.map((key) => [key, chartPlanetColorForKey(key)])),
      aspectVisibilityVersion: Number(CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_VERSION),
      visibleAspectAngles: Array.from(chartVisibleAspectAngles).map(Number).filter((angle) => VISUAL_ASPECT_ANGLES.has(angle)).sort((a, b) => a - b),
      aspectOrbs: Object.fromEntries(ASPECT_CONFIGS.map((aspect) => [aspect.angle, chartAspectOrbForAngle(aspect.angle)])),
      aspectColors: Object.fromEntries(ASPECT_CONFIGS.map((aspect) => [aspect.angle, chartAspectColorForAngle(aspect.angle)]))
    },
    appearance: {
      theme: THEME_KEYS.includes(savedTheme) ? savedTheme : DEFAULT_THEME,
      textSize: ACCOUNT_TEXT_SIZES.includes(accountTextSize) ? accountTextSize : "normal",
      reduceMotion: Boolean(accountReduceMotion)
    }
  };
}

function applyAccountPreferences(preferences = {}) {
  const profile = preferences?.profile || {};
  const map = preferences?.map || {};
  const appearance = preferences?.appearance || {};
  accountPreferencesApplying = true;
  try {
    accountPersonalInformation = normalizeAccountPersonalInformation(profile);
    const defaultView = safeChartViewType(map.defaultView || "multiple");
    customChartSelection = normalizeCustomChartSelection(map.customCharts);
    persistCustomChartSelection();
    setActiveChartViewType(defaultView, { syncControls: true, persist: true });
    chartHouseSystemKey = CHART_HOUSE_SYSTEMS[map.houseSystem] ? map.houseSystem : DEFAULT_CHART_HOUSE_SYSTEM;
    chartVisiblePlanetKeys = new Set(Array.isArray(map.visiblePlanets) ?
    map.visiblePlanets.filter((key) => CHART_SELECTABLE_PLANETS.includes(key)) :
    CHART_DEFAULT_VISIBLE_PLANETS);
    chartAspectPlanetKeys = new Set(Array.isArray(map.aspectPlanets) ?
    map.aspectPlanets.filter((key) => CHART_SELECTABLE_PLANETS.includes(key)) :
    CHART_DEFAULT_ASPECT_PLANETS);
    chartPlanetColors = new Map(CHART_PLANET_COLOR_KEYS.map((key) => [
    key,
    normalizeChartPlanetColor(key, map.planetColors?.[key])]
    ));
    applyChartPlanetColorVariables();
    chartVisibleAspectAngles = new Set(Array.isArray(map.visibleAspectAngles) ?
    map.visibleAspectAngles.map(Number).filter((angle) => VISUAL_ASPECT_ANGLES.has(angle)) :
    CHART_DEFAULT_VISIBLE_ASPECT_ANGLES);
    chartAspectOrbs = new Map(ASPECT_CONFIGS.map((aspect) => [
    Number(aspect.angle),
    normalizeChartAspectOrb(aspect.angle, map.aspectOrbs?.[aspect.angle])]
    ));
    chartAspectColors = new Map(ASPECT_CONFIGS.map((aspect) => [
    Number(aspect.angle),
    normalizeChartAspectColor(aspect.angle, map.aspectColors?.[aspect.angle])]
    ));
    applyChartAspectColorVariables();
    persistChartVisiblePlanetKeys();
    persistChartAspectPlanetKeys();
    persistChartPlanetColors();
    persistChartVisibleAspectAngles();
    persistChartAspectOrbs();
    persistChartAspectColors();
    persistChartHouseSystemKey();
    applyTheme(appearance.theme || DEFAULT_THEME, { persist: true });
    accountTextSize = ACCOUNT_TEXT_SIZES.includes(appearance.textSize) ? appearance.textSize : "normal";
    accountReduceMotion = appearance.reduceMotion === true;
    applyAccountAccessibilityPreferences({ persist: true });
  } finally {
    accountPreferencesApplying = false;
  }
}

async function loadAccountPreferences() {
  if (!currentUser) return null;
  // Subscription options start disabled in HTML. Synchronize the authenticated
  // capabilities before validating either local or saved chart preferences.
  syncSubscriberOnlyChartViews();
  const localPreferences = buildCurrentAccountPreferences();
  const response = await I18n.fetch("/api/account/preferences", { cache: "no-store", signal: AbortSignal.timeout(10000) });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_cargar_las_preferencias"));
  if (payload.exists) {
    applyAccountPreferences(payload.preferences);
  } else {
    const migrationResponse = await I18n.fetch("/api/account/preferences", {
      method: "PATCH",
      signal: AbortSignal.timeout(10000),
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ preferences: localPreferences })
    });
    const migrationPayload = await migrationResponse.json().catch(() => ({}));
    if (!migrationResponse.ok) throw new Error(migrationPayload.error || T("interface.no_se_pudieron_sincronizar_las_preferencias"));
    applyAccountPreferences(migrationPayload.preferences || localPreferences);
  }
  accountPreferencesLoaded = true;
  return buildCurrentAccountPreferences();
}

function queueAccountPreferencesSave() {
  if (!currentUser || !accountPreferencesLoaded || accountPreferencesApplying) return;
  accountPreferencesSaveDirty = true;
  window.clearTimeout(accountPreferencesSaveTimer);
  accountPreferencesSaveTimer = window.setTimeout(() => {
    saveAccountPreferences().catch(() => {
      if (accountSettingsDialog?.open) setAccountPreferencesStatus(() => T("interface.no_se_pudieron_sincronizar_las_preferencias"), true);
    });
  }, 450);
}

async function saveAccountPreferences() {
  if (!currentUser || accountPreferencesApplying) return null;
  if (accountPreferencesSavePromise) return accountPreferencesSavePromise;
  const preferences = buildCurrentAccountPreferences();
  accountPreferencesSaveDirty = false;
  accountPreferencesSavePromise = I18n.fetch("/api/account/preferences", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ preferences })
  }).then(async (response) => {
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_guardar_las_preferencias"));
    return payload.preferences;
  }).finally(() => {
    accountPreferencesSavePromise = null;
    if (accountPreferencesSaveDirty) queueAccountPreferencesSave();
  });
  return accountPreferencesSavePromise;
}

function setAccountPreferencesStatus(text, isError = false) {
  if (!accountPreferencesStatus) return;
  window.clearTimeout(accountPreferencesStatusTimer);
  accountPreferencesStatusTimer = null;
  I18n.bind(accountPreferencesStatus, "textContent", () => text || "");
  accountPreferencesStatus.classList.toggle("error", Boolean(isError));
  accountPreferencesStatus.classList.toggle("is-hidden", !text);
  if (!text) return;
  accountPreferencesStatusTimer = window.setTimeout(() => {
    accountPreferencesStatus.classList.add("is-hidden");
    I18n.clear(accountPreferencesStatus, "textContent");
    accountPreferencesStatusTimer = null;
  }, isError ? 5200 : 2800);
}

function placeAccountPreferencesStatus(tab) {
  if (!accountPreferencesStatus) return;
  const section = Array.from(accountSettingsSections).
  find((candidate) => candidate.dataset.accountSection === tab);
  if (!section) return;
  let actions = Array.from(section.children).
  find((child) => child.classList.contains("account-section-actions"));
  if (!actions) {
    actions = document.createElement("div");
    actions.className = "account-section-actions";
    section.appendChild(actions);
  }
  actions.prepend(accountPreferencesStatus);
}

function resetAccountMapPreferences() {
  customChartSelection = normalizeCustomChartSelection();
  persistCustomChartSelection();
  chartVisiblePlanetKeys = new Set(CHART_DEFAULT_VISIBLE_PLANETS);
  chartAspectPlanetKeys = new Set(CHART_DEFAULT_ASPECT_PLANETS);
  chartPlanetColors = defaultChartPlanetColorsMap();
  applyChartPlanetColorVariables();
  chartVisibleAspectAngles = new Set(CHART_DEFAULT_VISIBLE_ASPECT_ANGLES);
  chartAspectOrbs = new Map(ASPECT_CONFIGS.map((aspect) => [Number(aspect.angle), Number(aspect.orb)]));
  chartAspectColors = defaultChartAspectColorsMap();
  applyChartAspectColorVariables();
  chartHouseSystemKey = DEFAULT_CHART_HOUSE_SYSTEM;
  setActiveChartViewType("multiple", { syncControls: true, persist: true });
  persistChartVisiblePlanetKeys();
  persistChartAspectPlanetKeys();
  persistChartPlanetColors();
  persistChartVisibleAspectAngles();
  persistChartAspectOrbs();
  persistChartAspectColors();
  persistChartHouseSystemKey();
  rerenderChartWheelForPlanetVisibility();
  renderAccountSettings();
  setAccountPreferencesStatus(() => T("interface.preferencias_de_mapas_restauradas"));
}

function resetAccountAppearancePreferences() {
  applyTheme(DEFAULT_THEME, { persist: true });
  accountTextSize = "normal";
  accountReduceMotion = false;
  applyAccountAccessibilityPreferences({ persist: true });
  renderAccountSettings();
  setAccountPreferencesStatus(() => T("interface.apariencia_restaurada"));
}

async function handleAccountNotificationAction() {
  const waitlist = getSubscriptionWaitlistState();
  if (!waitlist.active) {
    closeAccountSettings();
    openSubscriptionWaitlistDialog();
    return;
  }
  await cancelSubscriptionWaitlist(accountNotificationActionButton);
  renderAccountSettings();
}

async function logoutAllAccountSessions() {
  if (!currentUser) return;
  const confirmed = await confirmDestructiveAction({ get
    title() {return T("interface.cerrar_todas_las_sesiones");}, get
    message() {return T("interface.se_cerrara_astroanamnesis_en_este_navegador_y_en_los_demas_dispositivos_donde_hayas_i");},
    warning: "Tendrás que volver a entrar con Google para acceder a tu cuenta.", get
    confirmLabel() {return T("interface.cerrar_todas");}
  });
  if (!confirmed) return;
  accountLogoutAllButton.disabled = true;
  try {
    const response = await I18n.fetch("/api/auth/logout-all", { method: "POST" });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_cerrar_todas_las_sesiones"));
    currentUser = null;
    accountPreferencesLoaded = false;
    window.clearTimeout(accountPreferencesSaveTimer);
    accountPreferencesSaveDirty = false;
    billingSummary = null;
    savedPeople = [];
    closeAccountSettings();
    renderAuthState();
    renderBillingUI();
    renderPeopleList();
    resetPersonForm();
    showLanding();
    I18n.replaceState(null, "", "/");
    setAuthStatus(() => T("interface.se_han_cerrado_todas_las_sesiones"));
  } catch (error) {
    setAccountPreferencesStatus(() => error.message || T("interface.no_se_pudieron_cerrar_todas_las_sesiones"), true);
  } finally {
    accountLogoutAllButton.disabled = false;
  }
}

function openAccountSettings(initialTab = "account") {
  if (!currentUser || !accountSettingsDialog) return;
  pendingAvatarDataUrl = "";
  pendingAvatarRemoval = false;
  renderAccountSettings();
  showAccountSettingsTab(initialTab);
  accountProfileForm?.classList.add("is-hidden");
  accountSettingsDialog.showModal();
  Promise.all([
  loadBillingSummary({ silent: true }),
  accountPreferencesLoaded ? Promise.resolve() : loadAccountPreferences()]
  ).then(() => {
    renderAccountSettings();
    showAccountSettingsTab(initialTab);
  }).
  catch(() => setAccountPreferencesStatus(() => T("interface.no_se_pudieron_actualizar_ahora_todos_los_datos_de_la_cuenta"), true));
}

function closeAccountSettings() {
  accountSettingsDialog?.close();
  pendingAvatarDataUrl = "";
  pendingAvatarRemoval = false;
  setAccountSettingsStatus("");
  setAccountPersonalInformationStatus("");
  setAccountPreferencesStatus("");
}

function renderAccountSettings() {
  if (!currentUser) return;
  const capabilities = getCapabilities();
  const subscribed = isSubscribedUser();
  const name = currentUser.name || currentUser.email || T("interface.usuario");
  const email = currentUser.email || "";
  const subscriptionTab = accountSettingsTabs?.querySelector('[data-account-tab="subscription"]');
  const subscriptionSection = document.querySelector('[data-account-section="subscription"]');
  const subscriptionVisible = subscribed && isModuleEnabled("subscriptionSection");
  const activeAccountTab = accountSettingsTabs?.querySelector("[data-account-tab].active")?.dataset.accountTab || "account";
  subscriptionTab?.classList.toggle("is-hidden", !subscriptionVisible);
  subscriptionSection?.classList.toggle(
    "is-hidden",
    !subscriptionVisible || activeAccountTab !== "subscription"
  );
  if (accountSettingsPlan) I18n.bind(accountSettingsPlan, "textContent", () => subscribed ? T("interface.suscrito") : T("navigation.notSubscribed"));
  if (accountSettingsCredits) I18n.bind(accountSettingsCredits, "textContent", () => T("interface.value_personas", { v0: formatNumber(capabilities.maxPeople) }));
  if (accountSettingsUsage) {
    I18n.bind(accountSettingsUsage, "textContent", () => subscribed ? T("interface.acceso_a_extraccion_de_prompts_configurables_para_preparar_lecturas_profesionales") : T("interface.sin_suscripcion_activa"));


  }
  if (accountSettingsLastUsage) {
    I18n.bind(accountSettingsLastUsage, "textContent", () => subscribed ? T("interface.gpt_ia_disponible") : T("interface.gpt_ia_no_disponible"));
  }
  accountAddCreditsButton?.classList.add("is-hidden");
  accountUpgradePlanButton?.classList.add("is-hidden");
  if (accountSettingsName) I18n.bind(accountSettingsName, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.name || __i18nSnapshot0.email || T("interface.usuario"))(currentUser));
  if (accountSettingsEmail) accountSettingsEmail.value = email;
  if (accountSettingsConnected) {
    const accessMethods = [
    currentUser.hasPassword ? "Correo y contraseña" : "",
    currentUser.hasGoogle ? "Google" : ""].
    filter(Boolean);
    I18n.bind(accountSettingsConnected, "textContent", () => `${accessMethods.join(" · ") || T("interface.cuenta_astroanamnesis")} · ${email}`);
  }
  if (accountProfileNameInput) accountProfileNameInput.value = name;
  fillAccountPersonalInformationForm();
  if (accountDefaultChartViewSelect) {
    const storedView = safeChartViewType(localStorage.getItem(CHART_VIEW_TYPE_STORAGE_KEY) || activeChartViewType || "multiple");
    accountDefaultChartViewSelect.value = storedView;
    Array.from(accountDefaultChartViewSelect.options).forEach((option) => {
      option.disabled = !isChartViewTypeAvailable(option.value) && option.value !== storedView;
    });
  }
  if (accountHouseSystemSelect) accountHouseSystemSelect.value = chartHouseSystemKey;
  if (accountMapVisibilitySummary) {
    I18n.bind(accountMapVisibilitySummary, "textContent", ((__i18nSnapshot0, __i18nSnapshot1, __i18nSnapshot2) => () => T("interface.value_cuerpos_visibles_value_con_aspectos_value_tipos_de_aspectovalue", { v0: __i18nSnapshot0.size, v1: __i18nSnapshot1.size, v2: __i18nSnapshot2.size, get v3() {return chartUsesDefaultAspectOrbs() ? "" : T("interface.orbes_personalizados");} }))(chartVisiblePlanetKeys, chartAspectPlanetKeys, chartVisibleAspectAngles));
  }
  accountTextSizeButtons.forEach((button) => {
    const active = button.dataset.accountTextSize === accountTextSize;
    button.classList.toggle("active", active);
    button.setAttribute("aria-checked", active ? "true" : "false");
  });
  if (accountReduceMotionInput) accountReduceMotionInput.checked = accountReduceMotion;
  const waitlist = getSubscriptionWaitlistState();
  if (accountNotificationState) I18n.bind(accountNotificationState, "textContent", () => waitlist.active ? T("interface.aviso_solicitado") : T("interface.no_solicitado"));
  if (accountNotificationSummary) {
    I18n.bind(accountNotificationSummary, "textContent", ((__i18nSnapshot0) => () => waitlist.active ? T("interface.te_avisaremos_una_sola_vez_en_value_cuando_la_suscripcion_este_disponible", { v0: maskAccountEmail(__i18nSnapshot0.email) }) : T("interface.puedes_solicitar_un_unico_aviso_en_el_correo_asociado_a_tu_cuenta_cuando_la_suscripci"))(currentUser));


  }
  if (accountNotificationActionButton) {
    I18n.bind(accountNotificationActionButton, "textContent", () => waitlist.active ? T("interface.cancelar_aviso") : T("interface.avisame"));
    accountNotificationActionButton.classList.toggle("danger", waitlist.active);
  }
  renderAvatarElement(accountSettingsAvatar, currentUser);
}

function showAccountSettingsTab(tab = "account") {
  const nextTab = tab === "subscription" && (
  !isSubscribedUser() || !isModuleEnabled("subscriptionSection")) ?
  "account" :
  tab;
  const previousTab = accountSettingsTabs?.
  querySelector("[data-account-tab].active")?.
  dataset.accountTab;
  if (previousTab && previousTab !== nextTab) setAccountPreferencesStatus("");
  accountSettingsTabs?.querySelectorAll("[data-account-tab]").forEach((button) => {
    button.classList.toggle("active", button.dataset.accountTab === nextTab);
  });
  accountSettingsSections.forEach((section) => {
    section.classList.toggle("is-hidden", section.dataset.accountSection !== nextTab);
  });
  placeAccountPreferencesStatus(nextTab);
}

function setAccountSettingsStatus(text, isError = false) {
  if (!accountSettingsStatus) return;
  I18n.bind(accountSettingsStatus, "textContent", () => text || "");
  accountSettingsStatus.classList.toggle("error", Boolean(isError));
}

function setAccountPersonalInformationStatus(text, isError = false) {
  if (!accountPersonalInformationStatus) return;
  I18n.bind(accountPersonalInformationStatus, "textContent", () => text || "");
  accountPersonalInformationStatus.classList.toggle("error", Boolean(isError));
  accountPersonalInformationStatus.classList.toggle("is-hidden", !text);
}

function fillAccountPersonalInformationForm() {
  if (!accountPersonalInformationForm) return;
  const profile = normalizeAccountPersonalInformation(accountPersonalInformation);
  if (accountPersonalFirstNameInput) accountPersonalFirstNameInput.value = profile.firstName;
  if (accountPersonalLastNameInput) accountPersonalLastNameInput.value = profile.lastName;
  if (accountPersonalPhoneInput) accountPersonalPhoneInput.value = profile.phone;
  if (accountPersonalCountrySelect) accountPersonalCountrySelect.value = profile.country;
  if (accountPersonalLanguageSelect) accountPersonalLanguageSelect.value = window.I18n?.language || profile.language;
  if (accountPersonalTimezoneInput) accountPersonalTimezoneInput.value = detectAccountTimeZone();
  if (accountSettingsEmail) accountSettingsEmail.value = currentUser?.email || "";
}

async function saveAccountPersonalInformation() {
  if (!currentUser || !accountPersonalInformationForm) return;
  const previousProfile = { ...accountPersonalInformation };
  const nextProfile = normalizeAccountPersonalInformation({
    firstName: accountPersonalFirstNameInput?.value || "",
    lastName: accountPersonalLastNameInput?.value || "",
    phone: accountPersonalPhoneInput?.value || "",
    country: accountPersonalCountrySelect?.value || "",
    language: accountPersonalLanguageSelect?.value || "es",
    timezone: detectAccountTimeZone()
  }, { useAccountName: false });

  accountPersonalInformation = nextProfile;
  saveAccountPersonalInformationButton?.setAttribute("disabled", "");
  cancelAccountPersonalInformationButton?.setAttribute("disabled", "");
  setAccountPersonalInformationStatus(() => T("interface.guardando_informacion"));

  try {
    window.clearTimeout(accountPreferencesSaveTimer);
    accountPreferencesSaveDirty = false;
    if (accountPreferencesSavePromise) await accountPreferencesSavePromise;
    const savedPreferences = await saveAccountPreferences();
    accountPersonalInformation = normalizeAccountPersonalInformation(savedPreferences?.profile || nextProfile, {
      useAccountName: false
    });
    fillAccountPersonalInformationForm();
    setAccountPersonalInformationStatus(() => T("interface.informacion_personal_guardada"));
  } catch (error) {
    accountPersonalInformation = previousProfile;
    setAccountPersonalInformationStatus(() => error.message || T("interface.no_se_pudo_guardar_la_informacion_personal"), true);
  } finally {
    saveAccountPersonalInformationButton?.removeAttribute("disabled");
    cancelAccountPersonalInformationButton?.removeAttribute("disabled");
  }
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(String(reader.result || "")));
    reader.addEventListener("error", () => reject(new Error(T("interface.no_se_pudo_leer_la_imagen"))));
    reader.readAsDataURL(file);
  });
}

async function saveAccountProfile() {
  if (!currentUser) return;
  setAccountSettingsStatus(() => T("interface.guardando_perfil"));
  const payload = {
    name: accountProfileNameInput?.value || currentUser.name || currentUser.email,
    avatarDataUrl: pendingAvatarDataUrl || "",
    removeAvatar: pendingAvatarRemoval
  };

  try {
    const response = await I18n.fetch("/api/auth/profile", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || T("interface.no_se_pudo_guardar_el_perfil"));
    currentUser = data.user;
    pendingAvatarDataUrl = "";
    pendingAvatarRemoval = false;
    accountProfileForm?.classList.add("is-hidden");
    renderAuthState();
    renderAccountSettings();
    setAccountSettingsStatus(() => T("interface.perfil_actualizado"));
  } catch (error) {
    setAccountSettingsStatus(() => error.message || T("interface.no_se_pudo_guardar_el_perfil"), true);
  }
}

async function deleteCurrentAccount() {
  if (!currentUser) return;
  const confirmed = await confirmDestructiveAction({ get
    title() {return T("interface.eliminar_cuenta");}, get
    message() {return T("interface.vas_a_eliminar_la_cuenta_asociada_a_value", { get v0() {return currentUser.email || currentUser.name || T("interface.tu_perfil");} });},
    warning: "Se eliminarán las personas guardadas, el historial y todos los datos asociados. Esta acción no se puede deshacer.", get
    confirmLabel() {return T("interface.eliminar_cuenta");}
  });
  if (!confirmed) return;
  setAccountSettingsStatus(() => T("interface.eliminando_cuenta"));
  try {
    const response = await I18n.fetch("/api/auth/account", { method: "DELETE" });
    const data = await response.json().catch(() => ({}));
    if (data.code === "REAUTH_REQUIRED") {
      setAccountSettingsStatus(data.error);
      openAuthDialog("reauth");
      return;
    }
    if (!response.ok) throw new Error(data.error || T("interface.no_se_pudo_eliminar_la_cuenta"));
    currentUser = null;
    accountPreferencesLoaded = false;
    window.clearTimeout(accountPreferencesSaveTimer);
    accountPreferencesSaveDirty = false;
    billingSummary = null;
    savedPeople = [];
    closeAccountSettings();
    renderAuthState();
    renderBillingUI();
    renderPeopleList();
    resetPersonForm();
    showLanding();
    I18n.replaceState(null, "", "/");
  } catch (error) {
    setAccountSettingsStatus(() => error.message || T("interface.no_se_pudo_eliminar_la_cuenta"), true);
  }
}

function getUserInitials(name, email) {
  const source = (name || email || "E").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length > 1) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
}

function closeSidebarAccountMenu() {
  sidebarAccountMenu?.classList.add("is-hidden");
  sidebarAccountToggle?.setAttribute("aria-expanded", "false");
}

function closePrivateAccountMenu({ restoreFocus = false } = {}) {
  privateAccountMenu?.classList.add("is-hidden");
  const toggle = privateUser?.querySelector("#private-account-toggle");
  toggle?.setAttribute("aria-expanded", "false");
  if (restoreFocus) toggle?.focus({ preventScroll: true });
}

function loadChatUiPreferences() {
  chatFolders = readChatUiValue("folders", []);
  chatFolderAssignments = readChatUiValue("folderAssignments", {});
  pinnedChatIds = readChatUiValue("pinned", []);
  activeChatFolderId = readChatUiValue("activeFolder", "all") || "all";
  chatHistoryCollapsed = Boolean(readChatUiValue("historyCollapsed", false));
  if (activeChatFolderId !== "all" && !chatFolders.some((folder) => folder.id === activeChatFolderId)) {
    activeChatFolderId = "all";
  }
}

function saveChatUiPreferences(options = {}) {
  writeChatUiValue("folders", chatFolders);
  writeChatUiValue("folderAssignments", chatFolderAssignments);
  writeChatUiValue("pinned", pinnedChatIds);
  writeChatUiValue("activeFolder", activeChatFolderId);
  writeChatUiValue("historyCollapsed", chatHistoryCollapsed);
  if (options.remote !== false) scheduleChatUiPreferencesSave();
}

async function loadChatUiPreferencesFromServer() {
  if (!currentUser) return;
  const localState = getChatUiPreferenceState();
  const response = await I18n.fetch("/api/chat-ui-state");
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_cargar_la_organizacion_de_chats"));

  chatUiServerLoaded = true;
  if (payload.exists && payload.state) {
    applyChatUiPreferenceState(payload.state);
    saveChatUiPreferences({ remote: false });
  } else if (hasChatUiPreferenceContent(localState)) {
    await persistChatUiPreferencesToServer(localState);
  }
}

function getChatUiPreferenceState() {
  return {
    folders: Array.isArray(chatFolders) ? chatFolders : [],
    folderAssignments: chatFolderAssignments && typeof chatFolderAssignments === "object" ? chatFolderAssignments : {},
    pinned: Array.isArray(pinnedChatIds) ? pinnedChatIds : [],
    activeFolder: activeChatFolderId || "all",
    historyCollapsed: Boolean(chatHistoryCollapsed)
  };
}

function applyChatUiPreferenceState(state = {}) {
  chatFolders = Array.isArray(state.folders) ? state.folders : [];
  chatFolderAssignments = state.folderAssignments && typeof state.folderAssignments === "object" ? state.folderAssignments : {};
  pinnedChatIds = Array.isArray(state.pinned) ? state.pinned.map(String) : [];
  activeChatFolderId = state.activeFolder || "all";
  chatHistoryCollapsed = Boolean(state.historyCollapsed);
  if (activeChatFolderId !== "all" && !chatFolders.some((folder) => folder.id === activeChatFolderId)) {
    activeChatFolderId = "all";
  }
}

function hasChatUiPreferenceContent(state = {}) {
  return Boolean(
    state.folders?.length ||
    Object.keys(state.folderAssignments || {}).length ||
    state.pinned?.length ||
    state.activeFolder && state.activeFolder !== "all" ||
    state.historyCollapsed
  );
}

function scheduleChatUiPreferencesSave() {
  if (!currentUser || !chatUiServerLoaded) return;
  window.clearTimeout(chatUiSaveTimer);
  chatUiSaveTimer = window.setTimeout(() => {
    persistChatUiPreferencesToServer().catch(() => {
      setStatus(() => T("interface.no_se_pudo_guardar_la_organizacion_de_chats_revisa_la_conexion"));
    });
  }, 250);
}

async function persistChatUiPreferencesToServer(state = getChatUiPreferenceState()) {
  if (!currentUser) return;
  const response = await I18n.fetch("/api/chat-ui-state", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ state })
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_guardar_la_organizacion_de_chats"));
  chatUiServerLoaded = true;
}

async function saveChatUiPreferencesNow() {
  window.clearTimeout(chatUiSaveTimer);
  saveChatUiPreferences({ remote: false });
  await persistChatUiPreferencesToServer();
}

function readChatUiValue(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(chatUiStorageKey(key)) || JSON.stringify(fallback));
  } catch {
    return fallback;
  }
}

function writeChatUiValue(key, value) {
  localStorage.setItem(chatUiStorageKey(key), JSON.stringify(value));
}

function chatUiStorageKey(key) {
  const scope = currentUser?.id || currentUser?.email || "anon";
  return `eliseoChatUi:${scope}:${key}`;
}

function renderPrivateUserCard({ sidebar = false } = {}) {
  if (!currentUser) return "";
  const subscribed = isSubscribedUser();
  if (sidebar) {
    const name = currentUser.name || currentUser.email;
    return `
      <button id="private-account-toggle" class="private-account-toggle" type="button" aria-expanded="false" aria-controls="private-account-menu">
        <span class="private-account-avatar" aria-hidden="true">${escapeHtml(getUserInitials(currentUser.name, currentUser.email))}</span>
        <span class="private-account-identity">
          <strong>${escapeHtml(name)}</strong>
          <small>${subscribed ? T("interface.suscripcion_activa") : T("navigation.noSubscription")}</small>
        </span>
        <svg class="private-account-chevron" viewBox="0 0 24 24" aria-hidden="true">
          <path d="m7 14 5-5 5 5"></path>
        </svg>
      </button>
    `;
  }
  const accountMeta = subscribed ? T("interface.suscrito") : T("navigation.notSubscribed");
  return `
    <div class="private-user-heading">
      <span class="private-user-avatar">${currentUser.picture ? `<img src="${escapeHtml(currentUser.picture)}" alt="">` : escapeHtml(getUserInitials(currentUser.name, currentUser.email))}</span>
      <div>
        <span class="private-user-name-row">
          <strong>${escapeHtml(currentUser.name || currentUser.email)}</strong>
        </span>
        <span>${escapeHtml(currentUser.email)}</span>
        <small class="private-user-plan-badge">${escapeHtml(accountMeta)}</small>
      </div>
      <button class="private-user-settings" type="button" data-private-user-action="settings" aria-label="${T("interface.configuracion_de_usuario")}" title="${T("interface.configuracion_de_usuario")}">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"></path>
          <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.7 1.7 0 0 0 15 19.37a1.7 1.7 0 0 0-1 .63 1.7 1.7 0 0 0-.4 1.1V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 8.5 19.3a1.7 1.7 0 0 0-1.88.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.13 15a1.7 1.7 0 0 0-.63-1 1.7 1.7 0 0 0-1.1-.4H2a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 3.7 8.5a1.7 1.7 0 0 0-.34-1.88l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 8.5 4.13a1.7 1.7 0 0 0 1-.63 1.7 1.7 0 0 0 .4-1.1V2a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 3.7a1.7 1.7 0 0 0 1.88-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.37 8.5a1.7 1.7 0 0 0 .63 1 1.7 1.7 0 0 0 1.1.4H22a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.61 1.1Z"></path>
        </svg>
      </button>
    </div>
  `;
}

function normalizeUserEmail(value) {
  return String(value || "").trim().toLowerCase();
}

function isSubscribedUser(user = currentUser) {
  return Boolean(user?.capabilities?.isSubscribed) ||
  user?.capabilities?.plan?.key === "subscription" ||
  SUBSCRIBED_ACCOUNT_EMAILS.has(normalizeUserEmail(user?.email));
}

function buildSubscriptionCapabilities(base = DEFAULT_CAPABILITIES) {
  return {
    ...base, get
    plan() {return { key: "subscription", get label() {return T("public-offers.subscription");}, get description() {return T("interface.acceso_activo_a_astroanamnesis_profesional");}, includedCredits: 0 };},





    maxPeople: SUBSCRIPTION_MAX_PEOPLE,
    maxChatsPerPerson: Math.max(base.maxChatsPerPerson || 0, 30),
    maxMessagesPerChat: Math.max(base.maxMessagesPerChat || 0, 120),
    includedCredits: 0,
    allowedModelLevels: Array.from(new Set([...(base.allowedModelLevels || []), "quick", "balanced", "deep", "premium", "thinking_standard"])),
    canExportChartData: true,
    canUsePremiumModel: true,
    canUseTags: true,
    canExportPdf: true,
    isSubscribed: true
  };
}

function getCapabilities() {
  const capabilities = currentUser?.capabilities || DEFAULT_CAPABILITIES;
  return isSubscribedUser(currentUser) ? buildSubscriptionCapabilities(capabilities) : DEFAULT_CAPABILITIES;
}

function canAccessGptIa() {
  return Boolean(currentUser && isSubscribedUser(currentUser));
}

function isModelLevelAllowed(level) {
  return getCapabilities().allowedModelLevels.includes(level);
}

function syncAllowedModelLevel(persist = false) {
  const capabilities = getCapabilities();
  for (const option of modelLevelSelect.options) {
    option.disabled = !capabilities.allowedModelLevels.includes(option.value);
  }

  if (!capabilities.allowedModelLevels.includes(modelLevelSelect.value)) {
    modelLevelSelect.value = capabilities.allowedModelLevels.includes("balanced") ?
    "balanced" :
    capabilities.allowedModelLevels[0] || "quick";
    if (persist) localStorage.setItem("modelLevel", modelLevelSelect.value);
  }
}

async function openPrivateArea(pushRoute = true, initialSection = pushRoute ? "list" : getPrivateSectionFromRoute()) {
  if (!currentUser) {
    setAuthStatus(() => T("interface.inicia_sesion_con_google_para_abrir_mi_espacio"), true);
    return;
  }

  landingScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  donationScreen?.classList.add("is-hidden");
  intakeScreen.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  privateScreen.classList.remove("is-hidden");
  if (privateSidebarMobileQuery.matches) privateSidebarCollapsed = true;
  if (pushRoute && !isPrivateRoutePath(I18n.routePath())) {
    I18n.pushState(null, "", getPrivateSectionPath(initialSection));
  }

  applyModuleVisibility();
  applyPrivateSidebarState();
  showPrivateSection(initialSection, { updateRoute: true, replaceRoute: !pushRoute });
  setPrivateStatus(() => T("interface.cargando_cartas"));
  await countriesPromise.catch(() => null);
  await loadPeople();
  await loadBillingSummary({ silent: true }).catch(() => null);
  setPrivateStatus("");
  window.OnboardingAccess?.offer();
}

async function openAdminPanel(pushRoute = true) {
  if (!currentUser?.isAdmin) {
    setStatus(() => T("interface.no_tienes_permisos_de_administracion"));
    return;
  }

  landingScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  donationScreen?.classList.add("is-hidden");
  intakeScreen.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  privateScreen.classList.remove("is-hidden");
  if (privateSidebarMobileQuery.matches) privateSidebarCollapsed = true;
  if (pushRoute && !isPrivateRoutePath(I18n.routePath())) {
    I18n.pushState(null, "", getPrivateSectionPath("admin"));
  }
  applyModuleVisibility();
  applyPrivateSidebarState();
  showPrivateSection("admin", { updateRoute: true, replaceRoute: !pushRoute });
}

function getSafeAdminTab(tab = "overview") {
  return ["overview", "users", "waitlist", "contact", "orders", "training", "videos"].includes(tab) ? tab : "overview";
}

function showAdminTab(tab = "overview") {
  activeAdminTab = getSafeAdminTab(tab);
  adminTabs?.querySelectorAll("[data-admin-tab]").forEach((button) => {
    button.classList.toggle("active", button.dataset.adminTab === activeAdminTab);
  });
  adminSections.forEach((section) => {
    section.classList.toggle("is-hidden", section.dataset.adminSection !== activeAdminTab);
  });
}

async function loadAdminPanel(tab = activeAdminTab, options = {}) {
  if (!currentUser?.isAdmin) return;
  if (!(await window.AdminSecurity.ensure())) {setAdminStatus(() => T("interface.confirma_tu_acceso_para_continuar"));return;}
  tab = getSafeAdminTab(tab);
  activeAdminTab = tab;
  setAdminStatus(() => T("interface.cargando_administracion"));
  try {
    if (!adminData.summary || options.force || tab === "overview") {
      adminData.summary = await adminFetch("/api/admin/summary");
    }
    if (tab === "users" && (!adminData.users.length || options.force)) {
      adminData.users = (await adminFetch("/api/admin/users")).users || [];
    }
    if (tab === "waitlist" && (!adminData.waitlistLoaded || options.force)) {
      const params = getAdminWaitlistSearchParams();
      const payload = await adminFetch(`/api/admin/subscription-waitlist?${params.toString()}`);
      adminData.waitlist = payload.waitlist || [];
      adminData.waitlistSummary = payload.summary || {};
      adminData.waitlistLoaded = true;
    }
    if (tab === "contact" && (!adminData.contactLoaded || options.force)) {
      const params = getAdminContactSearchParams();
      const payload = await adminFetch(`/api/admin/contact-messages?${params.toString()}`);
      adminData.contactMessages = payload.messages || [];
      adminData.contactSummary = payload.summary || {};
      adminData.contactLoaded = true;
    }
    if (tab === "orders" && (!adminData.orders.length || options.force)) {
      adminData.orders = (await adminFetch("/api/admin/orders")).orders || [];
    }
    if (tab === "training" && (!adminData.trainingLoaded || options.force)) {
      const payload = await adminFetch("/api/admin/training");
      adminData.trainingCourses = payload.courses || [];
      adminData.trainingRegistrations = payload.registrations || [];
      adminData.trainingSummary = payload.summary || {};
      adminData.trainingLoaded = true;
    }
    renderAdminPanel();
    if (tab === "videos") await window.TrainingVideos.loadAdmin();
    setAdminStatus(() => T("interface.panel_actualizado"));
  } catch (error) {
    setAdminStatus(() => error.message || T("interface.no_se_pudo_cargar_el_panel"), true);
  }
}

async function adminFetch(path, options = {}) {
  const response = await I18n.fetch(path, { cache: "no-store", ...options });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (["MFA_REQUIRED", "MFA_SETUP_REQUIRED"].includes(payload.code)) await window.AdminSecurity.ensure();
    throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));
  }
  return payload;
}

function loadModuleVisibilitySettings() {
  try {
    const stored = JSON.parse(localStorage.getItem(MODULE_VISIBILITY_STORAGE_KEY) || "{}");
    return normalizeModuleVisibilitySettings(stored);
  } catch {
    return normalizeModuleVisibilitySettings();
  }
}

function saveModuleVisibilitySettings() {
  try {
    const storedVisibility = { ...moduleVisibility };
    ALWAYS_ENABLED_MODULES.forEach((moduleKey) => {
      delete storedVisibility[moduleKey];
    });
    localStorage.setItem(MODULE_VISIBILITY_STORAGE_KEY, JSON.stringify(storedVisibility));
    return true;
  } catch {
    // La visibilidad sigue funcionando en memoria si el navegador bloquea localStorage.
    return false;
  }
}

function normalizeModuleVisibilitySettings(value = {}) {
  const source = value && typeof value === "object" && !Array.isArray(value) ? value : {};
  const visibility = { ...DEFAULT_MODULE_VISIBILITY };
  Object.keys(DEFAULT_MODULE_VISIBILITY).forEach((moduleKey) => {
    if (typeof source[moduleKey] === "boolean") {
      visibility[moduleKey] = source[moduleKey];
    }
  });
  ALWAYS_ENABLED_MODULES.forEach((moduleKey) => {
    visibility[moduleKey] = true;
  });
  return visibility;
}

async function loadModuleVisibilityFromServer() {
  try {
    const response = await I18n.fetch("/api/config/modules", { cache: "no-store" });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_cargar_la_configuracion_de_modulos"));
    configureDonationLink(payload.donationUrl);
    configureDonationMethods(payload.donation);
    moduleVisibilityServerInitialized = Boolean(payload.updatedAt);
    moduleVisibility = normalizeModuleVisibilitySettings(payload.modules);
    moduleVisibilityDraft = { ...moduleVisibility };
    moduleVisibilitySaveState = { dirty: false, saving: false, message: "", error: false };
    saveModuleVisibilitySettings();
    applyModuleVisibility();
    return moduleVisibility;
  } catch {
    configureDonationLink(DONATION_ROUTE);
    configureDonationMethods();
    moduleVisibility = normalizeModuleVisibilitySettings(moduleVisibility);
    moduleVisibilityDraft = { ...moduleVisibility };
    applyModuleVisibility();
    return moduleVisibility;
  }
}

function configureDonationLink(value = "") {
  if (!contactSupport || !contactDonationLink) return;
  try {
    const donationUrl = new URL(clean(value), window.location.origin);
    if (!["http:", "https:"].includes(donationUrl.protocol)) throw new Error(T("interface.invalid_donation_url"));
    contactDonationLink.href = donationUrl.toString();
    if (donationUrl.origin === window.location.origin) {
      contactDonationLink.removeAttribute("target");
      contactDonationLink.removeAttribute("rel");
    } else {
      contactDonationLink.target = "_blank";
      contactDonationLink.rel = "noopener noreferrer";
    }
    contactSupport.hidden = false;
  } catch {
    contactDonationLink.removeAttribute("href");
    contactDonationLink.removeAttribute("target");
    contactDonationLink.removeAttribute("rel");
    contactSupport.hidden = true;
  }
}

function safePublicDonationUrl(value = "") {
  const normalized = clean(value);
  if (!normalized) return "";
  try {
    const parsed = new URL(normalized, window.location.origin);
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.toString() : "";
  } catch {
    return "";
  }
}

function configureDonationMethods(config = {}) {
  publicDonationConfig = {
    paypalUrl: safePublicDonationUrl(config?.paypalUrl),
    bank: {
      beneficiary: clean(config?.bank?.beneficiary),
      iban: clean(config?.bank?.iban),
      bic: clean(config?.bank?.bic)
    },
    crypto: {
      bitcoin: clean(config?.crypto?.bitcoin),
      ethereum: clean(config?.crypto?.ethereum)
    }
  };
  renderDonationMethods();
}

function donationCopyControl(label, value) {
  return `
    <div class="donation-copy-row">
      <span>${escapeHtml(I18n.label(label))}</span>
      <code>${escapeHtml(value)}</code>
      <button type="button" data-donation-copy="${escapeHtml(value)}" aria-label="${T("interface.copiar_value", { v3: escapeHtml(I18n.label(I18n.label(label))) })}">${T("common.copy")}</button>
    </div>
  `;
}

function donationMethodIcon(kind) {
  if (kind === "bank") {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 9h18M5 9v8m4-8v8m6-8v8m4-8v8M3 20h18M12 3l9 4H3l9-4Z"></path>
      </svg>
    `;
  }
  if (kind === "bitcoin") return `<span aria-hidden="true">₿</span>`;
  if (kind === "ethereum") {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m12 3-5 9 5 3 5-3-5-9Zm0 12-5-3 5 8 5-8-5 3Z"></path>
      </svg>
    `;
  }
  return `<span aria-hidden="true">P</span>`;
}

function donationMethodCard({ kind, name, url = "" }) {
  const icon = `<span class="donation-method-icon donation-method-icon--${kind}">${donationMethodIcon(kind)}</span>`;
  const arrow = `<span class="donation-method-arrow" aria-hidden="true">${url ? "↗" : "→"}</span>`;
  if (url) {
    return `
      <a class="donation-method-card" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer" aria-label="${T("interface.aportar_mediante_value_se_abre_en_una_pestana_nueva", { v1: escapeHtml(name) })}">
        ${icon}<span>${escapeHtml(name)}</span>${arrow}
      </a>
    `;
  }
  return `
    <button class="donation-method-card" type="button" data-donation-method="${escapeHtml(kind)}" aria-label="${T("interface.ver_los_datos_para_aportar_mediante_value", { v1: escapeHtml(name) })}">
      ${icon}<span>${escapeHtml(name)}</span>${arrow}
    </button>
  `;
}

function renderDonationMethods() {
  if (!donationMethods) return;
  const { paypalUrl, bank = {}, crypto: donationCrypto = {} } = publicDonationConfig;
  const methods = [
  paypalUrl ? { kind: "paypal", name: "PayPal", url: paypalUrl } : null,
  bank.iban ? { kind: "bank", name: "Transferencia bancaria" } : null,
  donationCrypto.bitcoin ? { kind: "bitcoin", name: "Bitcoin" } : null,
  donationCrypto.ethereum ? { kind: "ethereum", name: "Ether" } : null].
  filter(Boolean);

  donationMethods.dataset.count = String(methods.length);
  I18n.bind(donationMethods, "innerHTML", () => methods.length ? methods.map(donationMethodCard).join("") : `<p class="donation-empty-state">${T("interface.ahora_mismo_no_hay_metodos_de_aportacion_disponibles")}</p>`);


}

function openDonationInfoDialog(trigger) {
  if (!donationInfoDialog) return;
  donationDialogReturnFocus = trigger || document.activeElement;
  if (!donationInfoDialog.open) donationInfoDialog.showModal();
  window.requestAnimationFrame(() => donationInfoTitle?.focus({ preventScroll: true }));
}

function openDonationMethodDialog(methodKey, trigger) {
  if (!donationMethodDialog || !donationMethodDialogTitle || !donationMethodDialogContent) return;
  const { bank = {}, crypto: donationCrypto = {} } = publicDonationConfig;
  let eyebrow = "Método de aportación";
  let title = "";
  let content = "";

  if (methodKey === "bank" && bank.iban) {
    eyebrow = "Transferencia bancaria";
    title = "Datos para la transferencia";
    content = `
      <div class="donation-copy-list">
        ${bank.beneficiary ? donationCopyControl("Beneficiario", bank.beneficiary) : ""}
        ${donationCopyControl("IBAN", bank.iban)}
        ${bank.bic ? donationCopyControl(T("interface.bic_swift"), bank.bic) : ""}
      </div>
      <p class="donation-method-note">${T("interface.puedes_indicar_apoyo_astroanamnesis_como_concepto")}</p>
    `;
  } else if (methodKey === "bitcoin" && donationCrypto.bitcoin) {
    eyebrow = "Bitcoin · red Bitcoin";
    title = "Dirección de Bitcoin";
    content = `
      <div class="donation-copy-list">${donationCopyControl(T("interface.direccion_btc"), donationCrypto.bitcoin)}</div>
      <p class="donation-method-note">${T("interface.envia_unicamente_bitcoin_mediante_la_red_bitcoin_comprueba_la_direccion_antes_de_conf")}</p>
    `;
  } else if (methodKey === "ethereum" && donationCrypto.ethereum) {
    eyebrow = "Ether · red Ethereum";
    title = "Dirección de Ether";
    content = `
      <div class="donation-copy-list">${donationCopyControl(T("interface.direccion_eth"), donationCrypto.ethereum)}</div>
      <p class="donation-method-note">${T("interface.envia_unicamente_ether_mediante_la_red_ethereum_comprueba_la_direccion_antes_de_confi")}</p>
    `;
  } else {
    return;
  }

  donationDialogReturnFocus = trigger || document.activeElement;
  if (donationMethodDialogEyebrow) I18n.bind(donationMethodDialogEyebrow, "textContent", () => eyebrow);
  I18n.bind(donationMethodDialogTitle, "textContent", () => title);
  I18n.bind(donationMethodDialogContent, "innerHTML", () => content);
  if (!donationMethodDialog.open) donationMethodDialog.showModal();
  window.requestAnimationFrame(() => donationMethodDialogTitle.focus({ preventScroll: true }));
}

function restoreDonationDialogFocus() {
  const returnFocus = donationDialogReturnFocus;
  donationDialogReturnFocus = null;
  if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
}

function areModuleVisibilitySettingsEqual(first = {}, second = {}) {
  return Object.keys(DEFAULT_MODULE_VISIBILITY).every(
    (moduleKey) => Boolean(first[moduleKey]) === Boolean(second[moduleKey])
  );
}

function prepareLegacyModuleVisibilityDraft() {
  if (!currentUser?.isAdmin || moduleVisibilityServerInitialized) return;
  const legacyDraft = normalizeModuleVisibilitySettings(legacyModuleVisibility);
  if (areModuleVisibilitySettingsEqual(legacyDraft, moduleVisibility)) return;
  moduleVisibilityDraft = legacyDraft;
  moduleVisibilitySaveState = {
    dirty: true,
    saving: false, get
    message() {return T("interface.revisa_la_configuracion_anterior_y_guardala_para_publicarla");},
    error: false
  };
}

function syncAdminModuleSaveControls() {
  const saveButton = adminOverview?.querySelector("[data-admin-modules-save]");
  const status = adminOverview?.querySelector("[data-admin-modules-status]");
  adminOverview?.querySelectorAll("[data-module-toggle]").forEach((input) => {
    input.disabled = moduleVisibilitySaveState.saving;
    input.closest(".admin-module-toggle")?.classList.toggle("is-saving", moduleVisibilitySaveState.saving);
  });
  if (saveButton) {
    saveButton.disabled = moduleVisibilitySaveState.saving || !moduleVisibilitySaveState.dirty;
    I18n.bind(saveButton, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.saving ? T("interface.guardando_2") : T("common.saveChanges"))(moduleVisibilitySaveState));
  }
  if (status) {
    I18n.bind(status, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.message || (__i18nSnapshot0.dirty ? T("interface.hay_cambios_sin_guardar") : T("interface.los_cambios_se_aplican_al_guardar")))(moduleVisibilitySaveState));


    status.classList.toggle("is-error", Boolean(moduleVisibilitySaveState.error));
    status.classList.toggle(
      "is-success",
      Boolean(moduleVisibilitySaveState.message) && !moduleVisibilitySaveState.error && !moduleVisibilitySaveState.dirty
    );
  }
}

async function saveAdminModuleVisibility() {
  if (moduleVisibilitySaveState.saving || !moduleVisibilitySaveState.dirty) return;
  const requestedVisibility = normalizeModuleVisibilitySettings(moduleVisibilityDraft);
  const shouldRefreshChartView = OPTIONAL_CHART_MODULES.some(
    (moduleKey) => !requestedVisibility[moduleKey] && chartWheelTypeSelect?.value === moduleKey
  );

  moduleVisibilitySaveState = {
    ...moduleVisibilitySaveState,
    saving: true, get
    message() {return T("interface.guardando_la_configuracion");},
    error: false
  };
  syncAdminModuleSaveControls();

  try {
    const payload = await adminFetch("/api/admin/modules", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ modules: requestedVisibility })
    });
    moduleVisibility = normalizeModuleVisibilitySettings(payload.modules);
    moduleVisibilityDraft = { ...moduleVisibility };
    moduleVisibilityServerInitialized = true;
    moduleVisibilitySaveState = {
      dirty: false,
      saving: false, get
      message() {return T("interface.modulos_guardados_correctamente");},
      error: false
    };
    saveModuleVisibilitySettings();
    applyModuleVisibility();
    updateChartDataButton();
    renderBillingUI();
    if (accountSettingsDialog?.open) renderAccountSettings();
    if (shouldRefreshChartView && chartCalculation) {
      syncChartWheelControls();
      renderSelectedChartWheel();
    }
  } catch (error) {
    moduleVisibilitySaveState = {
      dirty: true,
      saving: false, get
      message() {return error.message || T("interface.no_se_pudieron_guardar_los_modulos_vuelve_a_intentarlo");},
      error: true
    };
  }
  syncAdminModuleSaveControls();
}

function isModuleEnabled(moduleKey) {
  if (!moduleKey) return true;
  if (ALWAYS_ENABLED_MODULES.has(moduleKey)) return true;
  return moduleVisibility[moduleKey] !== false;
}

function applyChartTypeModuleVisibility() {
  OPTIONAL_CHART_MODULES.forEach((moduleKey) => {
    const enabled = isModuleEnabled(moduleKey);

    document.querySelectorAll(`option[value="${moduleKey}"]`).forEach((option) => {
      option.hidden = !enabled;
      option.disabled = !enabled;
    });

    [chartWheelTypeSelect, chatChartContextTypeSelect].forEach((select) => {
      if (select && select.value === moduleKey && !enabled) {
        select.value = "multiple";
      }
    });

    if (!enabled && activeChartViewType === moduleKey) {
      setActiveChartViewType("multiple");
    }
  });
}

function applyModuleVisibility() {
  document.querySelectorAll("[data-module-key]").forEach((element) => {
    const moduleKey = element.dataset.moduleKey;
    element.classList.toggle("is-hidden", Boolean(moduleKey && !isModuleEnabled(moduleKey)));
  });

  document.querySelectorAll("[data-module-group]").forEach((group) => {
    const moduleItems = Array.from(group.querySelectorAll("[data-module-key]"));
    const shouldHideGroup = moduleItems.length > 0 && moduleItems.every((item) => item.classList.contains("is-hidden"));
    group.classList.toggle("is-hidden", shouldHideGroup);
  });

  document.querySelectorAll("[data-module-toggle]").forEach((input) => {
    const moduleKey = input.dataset.moduleToggle;
    input.checked = moduleVisibilitySaveState.dirty ?
    moduleVisibilityDraft[moduleKey] !== false :
    isModuleEnabled(moduleKey);
  });

  applyChartTypeModuleVisibility();
  syncStoreCartHeader();
}

function renderAdminPanel() {
  renderAdminOverview();
  renderAdminUsers();
  renderAdminWaitlist();
  renderAdminContact();
  renderAdminOrders();
  renderAdminTraining();
}

function renderAdminOverview() {
  if (!adminOverview || !adminData.summary) return;
  const totals = adminData.summary.totals || {};
  I18n.bind(adminOverview, "innerHTML", ((__i18nSnapshot0) => () => `
    <div class="admin-metric-grid">
      ${adminMetric(T("interface.usuarios"), totals.users?.total, `${formatNumber(totals.users?.admins)} admins`)}
      ${adminMetric(T("interface.personas_creadas"), totals.activity?.people, T("interface.total_guardado_entre_todos_los_usuarios"))}
      ${adminMetric(T("interface.pedidos"), totals.activity?.service_orders, T("interface.solicitudes_registradas"))}
      ${adminMetric(T("interface.lista_de_espera"), totals.activity?.subscription_waitlist, T("interface.avisos_de_suscripcion_activos"))}
      ${adminMetric(T("navigation.contact"), totals.activity?.contact_messages, T("interface.mensajes_pendientes"))}
    </div>
    <section class="admin-card admin-module-card">
      <div class="admin-module-card-head">
        <div>
          <p class="eyebrow">${T("interface.habilitar_modulos")}</p>
          <h3>${T("interface.modulos_apartados_e_informes_visibles")}</h3>
          <p>${T("interface.activa_herramientas_e_informes_cuando_esten_listos_para_mostrarse_en_la_navegacion_el")}</p>
        </div>
      </div>
      <div class="admin-module-list">
        ${Object.entries({ get transits() {return { get title() {return T("interface.transitos");}, get description() {return T("interface.seccion_de_transitos_personales_en_la_navegacion_privada");} };}, get synastry() {return { get title() {return T("interface.sinastria");}, get description() {return T("interface.vista_de_sinastria_tropical_en_el_selector_de_mapas");} };}, get subscriptionSection() {return { get title() {return T("interface.apartado_suscripcion");}, get description() {return T("interface.seccion_de_suscripcion_en_la_navegacion_mi_espacio_y_configuracion_de_cuenta");} };}, get reportsSection() {return { get title() {return T("interface.apartado_informes");}, get description() {return T("interface.seccion_completa_de_informes_en_la_navegacion_y_mi_espacio");} };}, get storeCart() {return { get title() {return T("interface.tienda_carrito");}, get description() {return T("interface.carrito_y_acciones_para_anadir_productos_dentro_de_la_tienda");} };}, get storeStationery() {return { get title() {return T("interface.tienda_papeleria");}, get description() {return T("interface.productos_de_la_categoria_papeleria_dentro_de_la_tienda");} };}, get storeTextile() {return { get title() {return T("interface.tienda_textil");}, get description() {return T("interface.productos_de_la_categoria_textil_dentro_de_la_tienda");} };}, get mapCompleteReading() {return { get title() {return T("interface.mapas_lectura_completa");}, get description() {return T("interface.oferta_de_lectura_completa_en_la_vista_astroanamnesis_de_mapas");} };}, get reportPsychologicalIdentity() {return { get title() {return T("interface.informe_psicologico_y_de_identidad");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get reportFamilySocialRelations() {return { get title() {return T("interface.informe_relaciones_familiares_y_sociales");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get reportCompositeChart() {return { get title() {return T("interface.informe_carta_compuesta");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };}, get reportCompositeAstroanamnesis() {return { get title() {return T("interface.informe_carta_compuesta_astroanamnesis");}, get description() {return T("interface.producto_visible_en_el_catalogo_de_informes");} };} }).map(([moduleKey, module]) => `
          <label class="admin-module-toggle">
            <input type="checkbox" data-module-toggle="${escapeHtml(moduleKey)}" ${__i18nSnapshot0[moduleKey] !== false ? "checked" : ""}>
            <span class="admin-module-toggle-ui" aria-hidden="true"></span>
            <span>
              <b>${escapeHtml(module.title)}</b>
              <small>${escapeHtml(module.description)}</small>
            </span>
          </label>
        `).join("")}
      </div>
      <div class="admin-module-actions">
        <p class="admin-module-save-status" data-admin-modules-status role="status" aria-live="polite"></p>
        <button class="primary-action admin-module-save" type="button" data-admin-modules-save>
          ${T("common.saveChanges")}
        </button>
      </div>
    </section>
  `)(moduleVisibilityDraft));
  applyModuleVisibility();
  syncAdminModuleSaveControls();
}

function isAdminUserSubscribed(user) {
  if (typeof user?.subscriptionActive === "boolean") {
    return user.subscriptionActive;
  }
  const email = String(user?.email || "").trim().toLowerCase();
  return Boolean(
    user?.capabilities?.isSubscribed ||
    user?.planKey === "professional" ||
    SUBSCRIBED_ACCOUNT_EMAILS.has(email)
  );
}

function getAdminSubscriptionLabel(user) {
  return isAdminUserSubscribed(user) ?
  SUBSCRIPTION_STATUS_LABELS.subscribed :
  SUBSCRIPTION_STATUS_LABELS.unsubscribed;
}

function getAdminSubscriptionVariant(user) {
  return isAdminUserSubscribed(user) ? "subscribed" : "unsubscribed";
}

function renderAdminUsers() {
  if (!adminUsers) return;
  I18n.bind(adminUsers, "innerHTML", ((__i18nSnapshot0) => () => `
    <header class="admin-section-head">
      <div>
        <h3>${T("interface.usuarios")}</h3>
        <p>${T("interface.gestiona_suscripcion_capacidad_y_permisos_de_cuenta")}</p>
      </div>
    </header>
    ${adminTable([T("interface.usuario"), "Rol", T("public-offers.subscription"), "Aviso", "Personas", ""], __i18nSnapshot0.users.map((user) => [`<b>${escapeHtml(user.name)}</b><small>${escapeHtml(user.email)}</small>`, adminPill(user.isAdmin ? "Admin" : T("interface.usuario"), user.isAdmin ? "admin" : "user"), adminPill(getAdminSubscriptionLabel(user), getAdminSubscriptionVariant(user)), user.subscriptionWaitlistActive ? adminPill(T("interface.en_lista"), "pending") : `<span aria-label="${T("interface.sin_aviso_activo")}">—</span>`, formatNumber(user.peopleCount), `<button class="btn-small admin-action-button" type="button" data-admin-action="adjust-user" data-user-id="${user.id}">${T("interface.ajustar_cuenta")}</button>`]))}
  `)(adminData));











}

function getAdminWaitlistSearchParams(options = {}) {
  const params = new URLSearchParams();
  if (adminData.waitlistQuery) params.set("q", adminData.waitlistQuery);
  if (adminData.waitlistStatus && adminData.waitlistStatus !== "all") {
    params.set("status", adminData.waitlistStatus);
  }
  if (options.format) params.set("format", options.format);
  return params;
}

function getAdminWaitlistStatusLabel(status) {
  return ADMIN_WAITLIST_STATUS_LABELS[status] || status || T("interface.sin_estado");
}

function getAdminWaitlistStatusVariant(status) {
  if (status === "notified") return "completed";
  if (status === "cancelled") return "cancelled";
  return "pending";
}

function renderAdminWaitlistAction(entry) {
  if (entry.status === "waiting") {
    return `<button class="btn-small admin-action-button" type="button" data-admin-waitlist-action="notified" data-user-id="${entry.userId}">${T("interface.marcar_notificado")}</button>`;
  }
  if (entry.status === "notified") {
    return `<button class="btn-small admin-action-button" type="button" data-admin-waitlist-action="waiting" data-user-id="${entry.userId}">${T("interface.volver_a_pendiente")}</button>`;
  }
  return `<small class="admin-waitlist-withdrawn">${T("interface.retirado_por_el_usuario")}</small>`;
}

function renderAdminWaitlist() {
  if (!adminWaitlist) return;
  const summary = adminData.waitlistSummary || {};
  const exportParams = getAdminWaitlistSearchParams({ format: "csv" });
  const hasFilters = Boolean(adminData.waitlistQuery || adminData.waitlistStatus !== "all");
  I18n.bind(adminWaitlist, "innerHTML", ((__i18nSnapshot0) => () => `
    <header class="admin-section-head admin-waitlist-head">
      <div>
        <h3>${T("interface.lista_de_espera")}</h3>
        <p>${T("interface.consulta_los_avisos_de_suscripcion_y_registra_cuando_se_ha_informado_a_cada_persona")}</p>
      </div>
      <a class="secondary-action admin-waitlist-export" href="/api/admin/subscription-waitlist?${escapeHtml(exportParams.toString())}" download>${T("interface.exportar_csv")}</a>
    </header>
    <div class="admin-metric-grid admin-waitlist-metrics">
      ${adminMetric("Solicitudes", summary.total, T("interface.historial_completo"))}
      ${adminMetric(T("interface.pendientes"), summary.waiting, T("interface.avisos_activos"))}
      ${adminMetric(T("interface.notificados"), summary.notified, T("interface.marcados_como_enviados"))}
      ${adminMetric(T("interface.cancelados"), summary.cancelled, T("interface.consentimiento_retirado"))}
    </div>
    <form class="admin-waitlist-filters" data-admin-waitlist-filters>
      <label>
        <span>${T("common.search")}</span>
        <input name="q" type="search" maxlength="100" value="${escapeHtml(__i18nSnapshot0.waitlistQuery)}" placeholder="${T("interface.nombre_o_correo")}">
      </label>
      <label>
        <span>${T("common.status")}</span>
        <select name="status" data-admin-waitlist-status>
          <option value="all" ${__i18nSnapshot0.waitlistStatus === "all" ? "selected" : ""}>${T("common.all")}</option>
          <option value="waiting" ${__i18nSnapshot0.waitlistStatus === "waiting" ? "selected" : ""}>${T("interface.pendientes")}</option>
          <option value="notified" ${__i18nSnapshot0.waitlistStatus === "notified" ? "selected" : ""}>${T("interface.notificados")}</option>
          <option value="cancelled" ${__i18nSnapshot0.waitlistStatus === "cancelled" ? "selected" : ""}>${T("interface.cancelados")}</option>
        </select>
      </label>
      <button class="primary-action admin-waitlist-search" type="submit">${T("common.search")}</button>
      ${hasFilters ? `<button class="secondary-action admin-waitlist-reset" type="button" data-admin-waitlist-reset>${T("interface.limpiar")}</button>` : ""}
    </form>
    <p class="admin-waitlist-result-count">${formatNumber(__i18nSnapshot0.waitlist.length)} ${__i18nSnapshot0.waitlist.length === 1 ? T("interface.registro_mostrado") : T("interface.registros_mostrados")}</p>
    ${adminTable([T("interface.persona"), T("common.status"), "Alta", T("interface.ultimo_cambio"), ""], __i18nSnapshot0.waitlist.map((entry) => {const lastChange = entry.status === "notified" ? entry.notifiedAt : entry.status === "cancelled" ? entry.cancelledAt : entry.requestedAt;return [`<b>${escapeHtml(entry.name)}</b><small>${escapeHtml(entry.email)}</small>`, adminPill(getAdminWaitlistStatusLabel(entry.status), getAdminWaitlistStatusVariant(entry.status)), formatAdminDate(entry.requestedAt) || "—", lastChange ? formatAdminDate(lastChange) : "—", renderAdminWaitlistAction(entry)];}))}
    <p class="admin-waitlist-privacy-note">${T("interface.los_registros_cancelados_se_conservan_como_historial_y_no_pueden_reactivarse_desde_ad")}</p>
  `)(adminData));















}

const ADMIN_CONTACT_REASON_LABELS = Object.freeze({ get
  platform_support() {return T("interface.soporte_de_la_plataforma");}, get
  training() {return T("navigation.training");},
  astroanamnesis: "Astroanamnesis", get
  billing_orders() {return T("interface.facturacion_y_pedidos");}, get
  other() {return T("interface.otro");}
});

function getAdminContactSearchParams() {
  const params = new URLSearchParams();
  if (adminData.contactQuery) params.set("q", adminData.contactQuery);
  if (adminData.contactStatus !== "all") params.set("status", adminData.contactStatus);
  if (adminData.contactReason !== "all") params.set("reason", adminData.contactReason);
  return params;
}

function adminContactDeliveryLabel(status = "") {
  return { get sent() {return T("interface.aviso_enviado");}, get failed() {return T("interface.fallo_de_correo");}, get pending() {return T("interface.enviando_aviso");}, get stored() {return T("interface.solo_guardado");} }[status] || T("interface.solo_guardado");

}

function renderAdminContactAction(message) {
  if (message.status === "resolved") {
    return `<button class="btn-small admin-action-button" type="button" data-admin-contact-action="new" data-message-id="${message.id}">${T("interface.reabrir")}</button>`;
  }
  return `<button class="btn-small admin-action-button" type="button" data-admin-contact-action="resolved" data-message-id="${message.id}">${T("interface.marcar_resuelto")}</button>`;
}

function renderAdminContactMessage(message) {
  const fullMessage = clean(message.message);
  const preview = fullMessage.length > 105 ? `${fullMessage.slice(0, 105).trim()}…` : fullMessage;
  return `
    <details class="admin-contact-message">
      <summary>${escapeHtml(preview || T("interface.sin_mensaje"))}</summary>
      <p>${escapeHtml(fullMessage).replace(/\n/g, "<br>")}</p>
    </details>
  `;
}

function renderAdminContact() {
  if (!adminContact) return;
  const summary = adminData.contactSummary || {};
  const hasFilters = Boolean(
    adminData.contactQuery ||
    adminData.contactStatus !== "all" ||
    adminData.contactReason !== "all"
  );
  I18n.bind(adminContact, "innerHTML", ((__i18nSnapshot0) => () => `
    <header class="admin-section-head">
      <div>
        <h3>${T("interface.mensajes_de_contacto")}</h3>
        <p>${T("interface.consulta_los_mensajes_enviados_desde_la_web_y_registra_cuales_estan_resueltos")}</p>
      </div>
    </header>
    <div class="admin-metric-grid">
      ${adminMetric("Mensajes", summary.total, T("interface.historial_completo"))}
      ${adminMetric(T("interface.pendientes"), summary.pending, T("interface.requieren_revision"))}
      ${adminMetric(T("interface.resueltos"), summary.resolved, T("interface.consultas_gestionadas"))}
      ${adminMetric(T("interface.avisos_por_email"), summary.emailed, T("interface.entregados_por_resend"))}
    </div>
    <form class="admin-waitlist-filters admin-contact-filters" data-admin-contact-filters>
      <label>
        <span>${T("common.search")}</span>
        <input name="q" type="search" maxlength="100" value="${escapeHtml(__i18nSnapshot0.contactQuery)}" placeholder="${T("interface.nombre_correo_o_mensaje")}">
      </label>
      <label>
        <span>${T("common.status")}</span>
        <select name="status" data-admin-contact-filter>
          <option value="all" ${__i18nSnapshot0.contactStatus === "all" ? "selected" : ""}>${T("common.all")}</option>
          <option value="new" ${__i18nSnapshot0.contactStatus === "new" ? "selected" : ""}>${T("interface.pendientes")}</option>
          <option value="resolved" ${__i18nSnapshot0.contactStatus === "resolved" ? "selected" : ""}>${T("interface.resueltos")}</option>
        </select>
      </label>
      <label>
        <span>${T("interface.motivo")}</span>
        <select name="reason" data-admin-contact-filter>
          <option value="all" ${__i18nSnapshot0.contactReason === "all" ? "selected" : ""}>${T("interface.todos_los_motivos")}</option>
          ${Object.entries(Object.freeze({ get platform_support() {return T("interface.soporte_de_la_plataforma");}, get training() {return T("navigation.training");}, astroanamnesis: "Astroanamnesis", get billing_orders() {return T("interface.facturacion_y_pedidos");}, get other() {return T("interface.otro");} })).map(([key, label]) => `
            <option value="${escapeHtml(key)}" ${__i18nSnapshot0.contactReason === key ? "selected" : ""}>${escapeHtml(I18n.label(label))}</option>
          `).join("")}
        </select>
      </label>
      <button class="primary-action admin-waitlist-search" type="submit">${T("common.search")}</button>
      ${hasFilters ? `<button class="secondary-action admin-waitlist-reset" type="button" data-admin-contact-reset>${T("interface.limpiar")}</button>` : ""}
    </form>
    <p class="admin-waitlist-result-count">${formatNumber(__i18nSnapshot0.contactMessages.length)} ${__i18nSnapshot0.contactMessages.length === 1 ? T("interface.mensaje_mostrado") : T("interface.mensajes_mostrados")}</p>
    ${adminTable([T("interface.persona"), T("interface.motivo"), T("interface.mensaje"), T("common.status"), "Recibido", ""], __i18nSnapshot0.contactMessages.map((message) => [`<b>${escapeHtml(message.name)}</b><a class="admin-contact-email" href="mailto:${encodeURIComponent(message.email)}">${escapeHtml(message.email)}</a>`, `<span>${escapeHtml(message.reasonLabel || Object.freeze({ get platform_support() {return T("interface.soporte_de_la_plataforma");}, get training() {return T("navigation.training");}, astroanamnesis: "Astroanamnesis", get billing_orders() {return T("interface.facturacion_y_pedidos");}, get other() {return T("interface.otro");} })[message.reasonKey] || T("interface.otro"))}</span>`, renderAdminContactMessage(message), `${adminPill(message.status === "resolved" ? "Resuelto" : T("interface.pendiente"), message.status === "resolved" ? "completed" : "pending")}<small>${escapeHtml(adminContactDeliveryLabel(message.deliveryStatus))}</small>`, formatAdminDate(message.createdAt) || "—", renderAdminContactAction(message)]))}
    <p class="admin-waitlist-privacy-note">${T("interface.estos_mensajes_contienen_datos_personales_utilizalos_unicamente_para_responder_a_la_c")}</p>
  `)(adminData));









}

async function updateAdminContactMessage(messageId, status, button) {
  if (!messageId || !["new", "resolved"].includes(status)) return;
  const previousLabel = button?.textContent || "";
  if (button) {
    button.disabled = true;
    I18n.bind(button, "textContent", () => T("interface.guardando"));
  }
  setAdminStatus(() => T("interface.actualizando_mensaje"));
  try {
    await adminFetch(`/api/admin/contact-messages/${messageId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status })
    });
    adminData.contactLoaded = false;
    await loadAdminPanel("contact", { force: true });
    setAdminStatus(() => status === "resolved" ? T("interface.mensaje_marcado_como_resuelto") : T("interface.mensaje_devuelto_a_pendientes"));
  } catch (error) {
    if (button) {
      button.disabled = false;
      I18n.bind(button, "textContent", () => previousLabel);
    }
    setAdminStatus(() => error.message || T("interface.no_se_pudo_actualizar_el_mensaje"), true);
  }
}

async function updateAdminWaitlistStatus(userId, status, button) {
  const entry = adminData.waitlist.find((item) => String(item.userId) === String(userId));
  if (!entry || !["waiting", "notified"].includes(status)) return;
  const confirmation = status === "notified" ?
  `Confirma que ya se ha enviado el aviso a ${entry.email}.` :
  `¿Quieres devolver el aviso de ${entry.email} al estado pendiente?`;
  if (!window.confirm(confirmation)) return;

  const previousLabel = button?.textContent || T("interface.actualizar");
  if (button) {
    button.disabled = true;
    I18n.bind(button, "textContent", () => T("interface.guardando"));
  }
  setAdminStatus(() => T("interface.actualizando_lista_de_espera"));
  try {
    await adminFetch(`/api/admin/subscription-waitlist/${userId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status })
    });
    adminData.waitlistLoaded = false;
    await loadAdminPanel("waitlist", { force: true });
    setAdminStatus(() => status === "notified" ? T("interface.aviso_marcado_como_notificado") : T("interface.aviso_devuelto_a_pendiente"));
  } catch (error) {
    if (button) {
      button.disabled = false;
      I18n.bind(button, "textContent", () => button?.textContent || T("interface.actualizar"));
    }
    setAdminStatus(() => error.message || T("interface.no_se_pudo_actualizar_el_aviso"), true);
  }
}

function formatAdminOrderBirthDate(value) {
  const [year, month, day] = String(value || "").split("-");
  return year && month && day ? `${day}/${month}/${year}` : "";
}

function adminOrderPersonCell(order) {
  const context = order.purchaseContext || {};
  if (!context.personName) {
    const cartQuantity = (order.cartItems || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const detail = order.orderType === "store" ?
    cartQuantity ?
    T("products.itemCount", { count: cartQuantity }) :
    context.variant ? `Variante: ${context.variant}` : "Producto de tienda" :
    "Sin contexto de carta";
    return `<span class="admin-order-no-context">${escapeHtml(detail)}</span>`;
  }

  const birthDetails = [
  formatAdminOrderBirthDate(context.birthDate),
  context.birthTime].
  filter(Boolean).join(" · ");
  const place = [context.city, context.countryName || context.country].filter(Boolean).join(", ");
  return `
    <b>${escapeHtml(context.personName)}</b>
    <small>${escapeHtml(context.chartLabel || context.chartViewType || T("interface.carta"))}</small>
    ${birthDetails ? `<small>${escapeHtml(birthDetails)}</small>` : ""}
    ${place ? `<small>${escapeHtml(place)}</small>` : ""}
  `;
}

function renderAdminOrderContext(order) {
  const context = order.purchaseContext || {};
  if (!context.personName) {
    if (order.orderType === "store" && order.cartItems?.length) {
      return `
        <div class="admin-store-order-lines">
          ${order.cartItems.map((item) => `
            <div>
              <dt>${formatNumber(item.quantity)} × ${escapeHtml(I18n.label(item.label))}</dt>
              <dd>${escapeHtml([item.subtitle, ...(item.optionLabels || [])].filter(Boolean).join(" · ") || T("interface.sin_variantes"))}</dd>
            </div>
          `).join("")}
        </div>
      `;
    }
    return `
      <div class="admin-order-context-empty">
        <dt>${T("interface.contexto")}</dt>
        <dd>${escapeHtml(order.orderType === "store" ? T("interface.pedido_de_tienda") : T("interface.este_pedido_no_contiene_una_carta_asociada"))}</dd>
      </div>
    `;
  }

  const gender = context.gender === "otro" ?
  context.genderOther || T("interface.otro") :
  context.gender ?
  `${context.gender.charAt(0).toUpperCase()}${context.gender.slice(1)}` :
  "";
  const birthDetails = [
  formatAdminOrderBirthDate(context.birthDate),
  context.birthTime].
  filter(Boolean).join(" · ");
  const place = [context.city, context.countryName || context.country].filter(Boolean).join(", ");
  const coordinates = context.lat && context.lon ? `${context.lat}, ${context.lon}` : "";

  return [
  ["Persona", context.personName],
  ["Vista de carta", context.chartLabel || context.chartViewType],
  ["Datos natales", [birthDetails, gender].filter(Boolean).join(" · ")],
  ["Lugar", place],
  ["Zona horaria", context.tz],
  ["Coordenadas", coordinates],
  ["Referencia", context.personId ? `Persona #${context.personId}` : ""]].
  filter(([, value]) => value).map(([label, value]) => `
    <div>
      <dt>${escapeHtml(I18n.label(label))}</dt>
      <dd>${escapeHtml(value)}</dd>
    </div>
  `).join("");
}

function renderAdminOrders() {
  if (!adminOrders) return;
  I18n.bind(adminOrders, "innerHTML", ((__i18nSnapshot0) => () => `
    <header class="admin-section-head">
      <div>
        <h3>${T("interface.pedidos")}</h3>
        <p>${T("interface.controla_el_estado_de_cada_solicitud_revisada_sin_salir_del_panel")}</p>
      </div>
    </header>
    ${adminTable([T("interface.pedido"), "Comprador", T("interface.persona_carta"), T("common.status"), T("common.date"), ""], __i18nSnapshot0.orders.map((order) => [`<b>${escapeHtml(I18n.label(order.label))}</b><small>${escapeHtml(order.productKey)}</small>`, `<b>${escapeHtml(order.userName)}</b><small>${escapeHtml(order.userEmail)}</small>`, adminOrderPersonCell(order), adminPill(getAdminOrderStatusLabel(order.status), order.status), formatAdminDate(order.createdAt), `<button class="btn-small admin-action-button" type="button" data-admin-action="order-status" data-order-id="${order.id}">${T("interface.cambiar_estado")}</button>`]))}
  `)(adminData));









}

const TRAINING_REGISTRATION_LABELS = Object.freeze({ get
  requested() {return T("interface.solicitud_recibida");}, get
  confirmed() {return T("interface.plaza_confirmada");}, get
  waitlist() {return T("interface.lista_de_espera");}, get
  cancelled() {return T("interface.cancelada");}
});

const TRAINING_COURSE_STATUS_LABELS = Object.freeze({ get
  draft() {return T("interface.borrador");}, get
  published() {return T("interface.publicado");}, get
  completed() {return T("interface.finalizado");}, get
  cancelled() {return T("interface.cancelado");}
});

function parseTrainingDate(value) {
  if (!value) return null;
  const date = new Date(String(value).replace(" ", "T"));
  return Number.isFinite(date.getTime()) ? date : null;
}

function formatTrainingDate(value, options = {}) {
  const date = parseTrainingDate(value);
  if (!date) return "Fecha por confirmar";
  return new Intl.DateTimeFormat(I18n.locale(), {
    weekday: options.weekday === false ? undefined : "long",
    day: "numeric",
    month: "long",
    year: options.year === false ? undefined : "numeric",
    hour: options.time === false ? undefined : "2-digit",
    minute: options.time === false ? undefined : "2-digit"
  }).format(date);
}

function formatTrainingDateRange(course = {}) {
  const starts = parseTrainingDate(course.startsAt);
  if (!starts) return "Fecha por confirmar";
  // The course may be rescheduled; its stored end date is not a public promise.
  return formatTrainingDate(course.startsAt);
}

function getTrainingDateBadge(course = {}) {
  const date = parseTrainingDate(course.startsAt);
  if (!date) return { day: "—", month: "Próx." };
  return {
    day: new Intl.DateTimeFormat("es-ES", { day: "2-digit" }).format(date),
    month: new Intl.DateTimeFormat(I18n.locale(), { month: "short" }).format(date).replace(".", "")
  };
}

function formatTrainingPrice(course = {}) {
  const cents = Number(course.priceCents || 0);
  if (!cents) return "Acceso sin pago online";
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: course.currency || "EUR",
    maximumFractionDigits: cents % 100 ? 2 : 0
  }).format(cents / 100);
}

function trainingModalityLabel(value = "") {
  return { get online() {return T("interface.online");}, get presencial() {return T("interface.presencial");}, get hibrida() {return T("interface.hibrida");} }[value] || T("interface.modalidad_por_confirmar");
}

function trainingRegistrationLabel(status = "") {
  return TRAINING_REGISTRATION_LABELS[status] || T("interface.sin_estado");
}

function trainingRegistrationVariant(status = "") {
  return { confirmed: "confirmed", waitlist: "waitlist", cancelled: "cancelled" }[status] || "requested";
}

function renderTrainingStatusPill(label, variant = "neutral") {
  const safeVariant = clean(variant).toLowerCase().replace(/[^a-z0-9_-]/g, "-") || "neutral";
  return `<span class="training-pill training-pill-${safeVariant}">${escapeHtml(I18n.label(label))}</span>`;
}

function renderTrainingMeta(course = {}, { compact = false } = {}) {
  const location = course.location ? ` · ${escapeHtml(course.location)}` : "";
  return `
    <div class="training-meta${compact ? " training-meta-compact" : ""}">
      <span><b>${T("training_dates.start_date")}</b>${escapeHtml(formatTrainingDateRange(course))}</span>
      <span><b>${T("interface.modalidad")}</b>${escapeHtml(trainingModalityLabel(course.modality))}${location}</span>
      <span><b>${T("interface.informacion")}</b>${T("interface.movil_y_email")}</span>
    </div>
  `;
}

function renderTrainingCourseAction(course = {}, { featured = false } = {}) {
  const registration = course.myRegistration;
  if (registration && registration.status !== "cancelled") {
    return `<button class="${featured ? "primary-action" : "secondary-action"}" type="button" data-training-action="registrations">${T("interface.ver_mi_inscripcion")}</button>`;
  }
  if (course.availability?.canRegister) {
    const label = course.availability.key === "full" ? T("interface.unirme_a_la_lista_de_espera") : T("interface.solicitar_plaza");
    return `<button class="primary-action" type="button" data-training-action="register" data-course-id="${course.id}">${I18n.label(label)}</button>`;
  }
  return `<span class="training-action-note">${escapeHtml(I18n.label(course.availability?.label || T("common.notAvailable")))}</span>`;
}

function renderTrainingCourseCard(course = {}) {
  const badge = getTrainingDateBadge(course);
  const seatText = course.availability?.key === "open" ?
  `${formatNumber(course.remainingSeats)} ${course.remainingSeats === 1 ? "plaza disponible" : "plazas disponibles"}` :
  course.availability?.label || "Disponibilidad por confirmar";
  return `
    <article class="training-course-card">
      <header class="training-course-card-head">
        <div class="training-date-badge" aria-label="${escapeHtml(formatTrainingDate(course.startsAt, { time: false }))}">
          <strong>${escapeHtml(badge.day)}</strong>
          <span>${escapeHtml(badge.month)}</span>
        </div>
        ${renderTrainingStatusPill(course.availability?.label || T("public-offers.soon"), course.availability?.key || "neutral")}
      </header>
      <div class="training-course-card-copy">
        <p class="eyebrow">${escapeHtml(trainingModalityLabel(course.modality))}</p>
        <h3>${escapeHtml(I18n.content(course, "title"))}</h3>
        <p>${escapeHtml(I18n.content(course, "summary") || I18n.content(course, "description") || T("interface.consulta_los_contenidos_y_la_informacion_de_esta_formacion"))}</p>
      </div>
      ${renderTrainingMeta(course, { compact: true })}
      <p class="training-seat-line">${escapeHtml(seatText)}</p>
      <footer class="training-course-actions">
        <button class="secondary-action" type="button" data-training-action="details" data-course-id="${course.id}">${T("interface.ver_detalles")}</button>
        ${renderTrainingCourseAction(course)}
      </footer>
    </article>
  `;
}

function renderTrainingFeaturedCourse(course = {}) {
  const badge = getTrainingDateBadge(course);
  return `
    <article class="training-featured-card">
      <div class="training-featured-copy">
        <div class="training-featured-topline">
          <p class="eyebrow">${T("interface.proxima_formacion_destacada")}</p>
          ${renderTrainingStatusPill(course.availability?.label || T("public-offers.soon"), course.availability?.key || "neutral")}
        </div>
        <h3>${escapeHtml(I18n.content(course, "title"))}</h3>
        <p>${escapeHtml(I18n.content(course, "summary") || I18n.content(course, "description") || T("interface.formacion_dirigida_por_eliseo_gallardo"))}</p>
        ${renderTrainingMeta(course)}
        <div class="training-featured-actions">
          ${renderTrainingCourseAction(course, { featured: true })}
          <button class="secondary-action" type="button" data-training-action="details" data-course-id="${course.id}">${T("interface.programa_y_detalles")}</button>
          ${renderTrainingCalendarActions(course)}
        </div>
      </div>
      <div class="training-featured-date" aria-hidden="true">
        <span>${escapeHtml(badge.month)}</span>
        <strong>${escapeHtml(badge.day)}</strong>
        <small>${escapeHtml(trainingModalityLabel(course.modality))}</small>
      </div>
    </article>
  `;
}

function renderTrainingEmpty(title, message, action = "") {
  return `
    <div class="training-empty">
      <span class="training-empty-icon" aria-hidden="true">${renderTrainingMark()}</span>
      <h3>${escapeHtml(title)}</h3>
      <p>${escapeHtml(message)}</p>
      ${action}
    </div>
  `;
}

function renderTrainingSection() {
  if (!privateTrainingSection) return;
  trainingCoursesView?.classList.toggle("is-hidden", activePrivateTrainingView !== "courses");
  trainingRegistrationsView?.classList.toggle("is-hidden", activePrivateTrainingView !== "registrations");
  document.querySelector("#training-videos-view")?.classList.toggle("is-hidden", activePrivateTrainingView !== "videos");

  const featuredCourse = trainingCourses.find((course) => course.featured && !["completed", "cancelled"].includes(course.availability?.key)) ||
  trainingCourses.find((course) => !["completed", "cancelled"].includes(course.availability?.key));
  if (trainingFeatured) {
    I18n.bind(trainingFeatured, "innerHTML", () => featuredCourse ? renderTrainingFeaturedCourse(featuredCourse) : "");
    trainingFeatured.classList.toggle("is-hidden", !featuredCourse);
  }
  if (trainingCourseList) {
    const catalog = trainingCourses.filter((course) => course.id !== featuredCourse?.id);
    I18n.bind(trainingCourseList, "innerHTML", () => catalog.length ? catalog.map(renderTrainingCourseCard).join("") : featuredCourse ? `<p class="training-catalog-note">${T("interface.publicaremos_aqui_nuevas_fechas_cuando_esten_disponibles")}</p>` : renderTrainingEmpty(T("interface.estamos_preparando_la_proxima_formacion"), T("interface.cuando_eliseo_publique_una_nueva_convocatoria_podras_consultar_aqui_las_fechas_el_pro")));







  }
  renderTrainingRegistrations();
  syncPrivateTrainingNavigationState();
}

function renderTrainingRegistrations() {
  if (!trainingRegistrationList) return;
  if (!trainingRegistrations.length) {
    I18n.bind(trainingRegistrationList, "innerHTML", () => renderTrainingEmpty(T("interface.aun_no_tienes_inscripciones"), T("interface.consulta_las_proximas_formaciones_y_solicita_tu_plaza_desde_la_ficha_del_curso"), `<button class="primary-action" type="button" data-training-action="courses">${T("interface.ver_cursos")}</button>`));




    return;
  }
  I18n.bind(trainingRegistrationList, "innerHTML", ((__i18nSnapshot0) => () => __i18nSnapshot0.map((registration) => `
    <article class="training-registration-card">
      <div class="training-registration-main">
        ${renderTrainingStatusPill(trainingRegistrationLabel(registration.status), trainingRegistrationVariant(registration.status))}
        <h3>${escapeHtml(registration.courseTitle)}</h3>
        <p class="training-registration-date">${renderTrainingIcon("calendar")}<span>${escapeHtml(formatTrainingDateRange(registration))}</span></p>
        <div class="training-registration-meta">
          <span>${renderTrainingIcon(registration.modality === "online" ? "video" : "location")}${escapeHtml(trainingModalityLabel(registration.modality))}${registration.location ? ` · ${escapeHtml(registration.location)}` : ""}</span>
          <span>${T("interface.solicitada_el_value", { v7: escapeHtml(I18n.label(I18n.label(formatTrainingDate(registration.requestedAt || registration.createdAt, { weekday: false })))) })}</span>
        </div>
      </div>
      <footer class="training-registration-side">
        ${registration.status !== "cancelled" ? renderTrainingCalendarActions({ ...getTrainingCourse(registration.courseId), ...registration, title: registration.courseTitle }, registration.id) : ""}
        ${["requested", "confirmed", "waitlist"].includes(registration.status) ? `<button class="training-danger-action" type="button" data-training-action="cancel-registration" data-registration-id="${registration.id}">${T("interface.cancelar_inscripcion")}</button>` : ""}
      </footer>
    </article>
  `).join(""))(trainingRegistrations));




}

function getLandingTrainingAnnouncementCourse() {
  return trainingCourses.find((item) => item.announcementEnabled && !["completed", "cancelled"].includes(item.availability?.key)) || null;
}

function hasDismissedTrainingPromotion() {
  if (trainingBannerDismissed) return true;
  try {
    return localStorage.getItem(TRAINING_PROMOTION_DISMISSAL_KEY) === "1";
  } catch {
    return false;
  }
}

function dismissTrainingBanner() {
  trainingBannerDismissed = true;
  try {
    localStorage.setItem(TRAINING_PROMOTION_DISMISSAL_KEY, "1");
  } catch {

    // Still dismiss for this visit when browser storage is unavailable.
  }hideTrainingBanner();
}

function hideTrainingBanner() {
  if (trainingBanner) trainingBanner.hidden = true;
}

function handleTrainingBannerClick(event) {
  const button = event.target.closest("[data-training-banner-action]");
  if (!button) return;
  if (button.dataset.trainingBannerAction === "dismiss") {
    dismissTrainingBanner();
  } else if (button.dataset.trainingBannerAction === "details") {
    const course = getLandingTrainingAnnouncementCourse();
    if (course) openTrainingCourseDialog(course.id);
  }
}

function renderTrainingMark() {
  return `<svg viewBox="0 0 48 48" focusable="false" aria-hidden="true">
    <circle cx="24" cy="24" r="21.5" fill="none" stroke="currentColor" stroke-width="1.5"></circle>
    <circle cx="24" cy="24" r="3.4" fill="currentColor"></circle>
  </svg>`;
}

function updateTrainingBanner() {
  if (!trainingBanner) return;
  const course = getLandingTrainingAnnouncementCourse();
  if (course) {
    I18n.bind(trainingBanner.querySelector("[data-training-banner-status]"), "textContent", () => course.availability?.key === "full" ? T("interface.lista_de_espera_abierta") : T("interface.inscripciones_abiertas"));

    I18n.bind(trainingBanner.querySelector("[data-training-banner-date]"), "textContent", () => formatTrainingDateRange(course));
  }
  trainingBanner.hidden = !course ||
  !TRAINING_PROMOTION_PUBLIC_ROUTES.has(I18n.routePath()) ||
  hasDismissedTrainingPromotion();
}

function renderLandingTrainingAnnouncement() {
  if (!landingTrainingAnnouncement) return;
  const course = getLandingTrainingAnnouncementCourse();
  landingTrainingAnnouncement.classList.toggle("is-hidden", !course);
  if (!course) {
    I18n.clear(landingTrainingAnnouncement, "innerHTML");
    updateTrainingBanner();
    return;
  }
  I18n.bind(landingTrainingAnnouncement, "innerHTML", () => `
    <div class="landing-training-inner">
      <div class="landing-training-mark" aria-hidden="true">
        ${renderTrainingMark()}
      </div>
      <div class="landing-training-copy">
        <p class="eyebrow">${T("interface.inscripciones_value", { get v1() {return course.availability?.key === "full" ? T("interface.en_lista_de_espera") : T("homepage.open");} })}</p>
        <h2>${escapeHtml(I18n.content(course, "title"))}</h2>
        <p class="landing-training-meta">
          <span class="landing-training-dates">${escapeHtml(formatTrainingDateRange(course))}</span>
          <span class="landing-training-modality">${escapeHtml(trainingModalityLabel(course.modality))}</span>
        </p>
      </div>
      <button class="secondary-action" type="button" data-training-action="landing-details" data-course-id="${course.id}">${T("interface.consultar_formacion")}</button>
    </div>
  `);
  updateTrainingBanner();
}

function setTrainingStatus(message = "", isError = false) {
  if (!trainingStatus) return;
  I18n.bind(trainingStatus, "textContent", () => message);
  trainingStatus.classList.toggle("error", Boolean(isError));
}

async function loadTrainingData({ force = false } = {}) {
  if (trainingLoaded && !force) {
    renderTrainingSection();
    renderLandingTrainingAnnouncement();
    return;
  }
  const courseResponse = await I18n.fetch("/api/training/courses", { cache: "no-store" });
  const coursePayload = await courseResponse.json().catch(() => ({}));
  if (!courseResponse.ok) throw new Error(coursePayload.error || T("interface.no_se_pudo_cargar_la_formacion"));
  trainingCourses = coursePayload.courses || [];
  trainingRegistrations = [];
  if (currentUser) {
    const registrationResponse = await I18n.fetch("/api/training/registrations", { cache: "no-store" });
    const registrationPayload = await registrationResponse.json().catch(() => ({}));
    if (registrationResponse.ok) trainingRegistrations = registrationPayload.registrations || [];
  }
  trainingLoaded = true;
  renderTrainingSection();
  renderLandingTrainingAnnouncement();
}

async function prepareTrainingSection(view = "courses") {
  activePrivateTrainingView = Object.hasOwn(PRIVATE_TRAINING_VIEW_ROUTES, view) ? view : "courses";
  renderTrainingSection();
  if (activePrivateTrainingView === "videos") {
    setTrainingStatus("");
    await window.TrainingVideos.loadLibrary();
    return;
  }
  if (!trainingLoaded) {
    setTrainingStatus(() => T("interface.cargando_formacion"));
    await loadTrainingData();
  }
  setTrainingStatus("");
}

function getTrainingCourse(courseId) {
  return trainingCourses.find((course) => String(course.id) === String(courseId));
}

function renderTrainingRichText(value = "") {
  return clean(value).
  split(/\n{2,}/).
  map((paragraph) => `<p>${escapeHtml(paragraph).replaceAll("\n", "<br>")}</p>`).
  join("");
}

function renderTrainingSyllabus(value = "") {
  const items = clean(value).split("\n").map(clean).filter(Boolean);
  if (!items.length) return "";
  return `<ol class="training-program-list">${items.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ol>`;
}

function openTrainingCourseDialog(courseId) {
  const course = getTrainingCourse(courseId);
  if (!course || !trainingCourseDialogContent) return;
  activeTrainingCourseId = course.id;
  I18n.bind(trainingCourseDialogContent, "innerHTML", ((__i18nSnapshot0) => () => `
    <section class="training-detail-hero">
      <div>
        ${renderTrainingStatusPill(course.availability?.label || T("public-offers.soon"), course.availability?.key || "neutral")}
        <h3>${escapeHtml(I18n.content(course, "title"))}</h3>
        <p>${escapeHtml(I18n.content(course, "summary") || T("interface.formacion_dirigida_por_eliseo_gallardo"))}</p>
      </div>
      ${renderTrainingMeta(course)}
    </section>
    ${I18n.content(course, "description") ? `<section class="training-detail-section"><h4>${T("interface.sobre_esta_formacion")}</h4>${renderTrainingRichText(I18n.content(course, "description"))}</section>` : ""}
    ${I18n.content(course, "audience") ? `<section class="training-detail-section"><h4>${T("interface.a_quien_esta_dirigida")}</h4>${renderTrainingRichText(I18n.content(course, "audience"))}</section>` : ""}
    ${I18n.content(course, "syllabus") ? `<section class="training-detail-section"><h4>${T("interface.programa")}</h4>${renderTrainingSyllabus(I18n.content(course, "syllabus"))}</section>` : ""}
    <footer class="training-detail-actions">
      ${renderTrainingCalendarActions(course)}
      ${__i18nSnapshot0 ? renderTrainingCourseAction(course, { featured: true }) : course.availability?.canRegister ? `<button class="primary-action" type="button" data-training-action="login-register">${T("interface.iniciar_sesion_para_solicitar_plaza")}</button>` : ""}
    </footer>
  `)(currentUser));




  if (!trainingCourseDialog.open) trainingCourseDialog.showModal();
}

function closeTrainingCourseDialog() {
  activeTrainingCourseId = 0;
  trainingCourseDialog?.close();
}

function openTrainingRegistrationDialog(courseId) {
  const course = getTrainingCourse(courseId);
  if (!course) return;
  if (!currentUser) {
    openAuthDialog("login");
    return;
  }
  activeTrainingCourseId = course.id;
  if (trainingRegistrationCourse) {
    I18n.bind(trainingRegistrationCourse, "innerHTML", () => `
      <strong>${escapeHtml(I18n.content(course, "title"))}</strong>
      <span>${escapeHtml(formatTrainingDateRange(course))}</span>
      <span>${escapeHtml(trainingModalityLabel(course.modality))}${course.location ? ` · ${escapeHtml(course.location)}` : ""}</span>
    `);
  }
  if (trainingRegistrationAccount) {
    I18n.bind(trainingRegistrationAccount, "textContent", ((__i18nSnapshot0) => () => `${__i18nSnapshot0.name || T("interface.tu_cuenta")} · ${__i18nSnapshot0.email || ""}`)(currentUser));
  }
  if (trainingRegistrationPhone) trainingRegistrationPhone.value = "";
  if (trainingRegistrationConsent) trainingRegistrationConsent.checked = false;
  if (trainingRegistrationFormStatus) {
    I18n.clear(trainingRegistrationFormStatus, "textContent");
    trainingRegistrationFormStatus.classList.remove("error");
  }
  trainingRegistrationDialog?.showModal();
  trainingRegistrationPhone?.focus();
}

function closeTrainingRegistrationDialog() {
  activeTrainingCourseId = 0;
  trainingRegistrationDialog?.close();
}

async function submitTrainingRegistration(event) {
  event.preventDefault();
  const course = getTrainingCourse(activeTrainingCourseId);
  if (!course || !trainingRegistrationForm) return;
  if (!trainingRegistrationConsent?.checked) {
    I18n.bind(trainingRegistrationFormStatus, "textContent", () => T("interface.acepta_el_tratamiento_de_datos_para_continuar"));
    trainingRegistrationFormStatus.classList.add("error");
    return;
  }
  const submit = trainingRegistrationForm.querySelector('[type="submit"]');
  submit.disabled = true;
  I18n.bind(trainingRegistrationFormStatus, "textContent", () => T("interface.registrando_tu_solicitud"));
  trainingRegistrationFormStatus.classList.remove("error");
  try {
    const response = await I18n.fetch(`/api/training/courses/${course.id}/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phone: clean(trainingRegistrationPhone?.value || ""),
        consent: true
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_registrar_la_solicitud"));
    closeTrainingRegistrationDialog();
    trainingLoaded = false;
    await loadTrainingData({ force: true });
    activePrivateTrainingView = "registrations";
    showPrivateSection("training", { trainingView: "registrations" });
    setTrainingStatus(() => payload.registration?.status === "waitlist" ? T("interface.te_hemos_anadido_a_la_lista_de_espera_puedes_consultar_el_estado_aqui") : T("interface.hemos_recibido_tu_solicitud_de_plaza")

    );
  } catch (error) {
    I18n.bind(trainingRegistrationFormStatus, "textContent", () => error.message || T("interface.no_se_pudo_registrar_la_solicitud"));
    trainingRegistrationFormStatus.classList.add("error");
  } finally {
    submit.disabled = false;
  }
}

async function cancelTrainingRegistration(registrationId) {
  const registration = trainingRegistrations.find((item) => String(item.id) === String(registrationId));
  if (!registration) return;
  const confirmed = await confirmDestructiveAction({ get
    title() {return T("interface.cancelar_solicitud");}, get
    message() {return T("interface.vas_a_cancelar_tu_solicitud_para_value", { v0: registration.courseTitle });},
    warning: "La plaza quedará libre. Si vuelves a solicitarla más adelante, dependerá de la disponibilidad del momento.", get
    confirmLabel() {return T("interface.cancelar_solicitud");}
  });
  if (!confirmed) return;
  setTrainingStatus(() => T("interface.cancelando_solicitud"));
  const response = await I18n.fetch(`/api/training/registrations/${registration.id}`, { method: "DELETE" });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setTrainingStatus(() => payload.error || T("interface.no_se_pudo_cancelar_la_solicitud"), true);
    return;
  }
  trainingLoaded = false;
  await loadTrainingData({ force: true });
  setTrainingStatus(() => T("interface.la_solicitud_se_ha_cancelado_correctamente"));
}

function formatTrainingIcsDate(value) {
  const date = parseTrainingDate(value);
  if (!date) return "";
  return date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
}

function trainingGoogleCalendarUrl(course = {}) {
  const start = parseTrainingDate(course.startsAt);
  if (!start) return "";
  const params = new URLSearchParams({
    action: "TEMPLATE", get
    text() {return T("training_dates.calendar_start", { title: I18n.content(course, "title") || I18n.label("Formación Astroanamnesis") });},
    dates: `${formatTrainingIcsDate(start.toISOString())}/${formatTrainingIcsDate(start.toISOString())}`,
    details: I18n.content(course, "summary") || I18n.label("Formación con Eliseo Gallardo"),
    location: course.location || trainingModalityLabel(course.modality)
  });
  return `https://calendar.google.com/calendar/r/eventedit?${params.toString()}`;
}

function renderTrainingIcon(name) {
  const paths = {
    calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18M8 15h2M14 15h2M8 18h2"/>',
    download: '<path d="M12 3v12m-4-4 4 4 4-4M4 16v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4"/>',
    external: '<path d="M7 17 17 7M7 7h10v10"/>',
    video: '<rect x="3" y="5" width="13" height="14" rx="2"/><path d="m16 10 5-3v10l-5-3"/>',
    location: '<path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>'
  };
  return `<svg class="training-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths[name] || paths.calendar}</svg>`;
}

function renderTrainingCalendarActions(course, registrationId = null) {
  const googleUrl = trainingGoogleCalendarUrl(course);
  if (!googleUrl) return "";
  const downloadAttributes = registrationId === null ?
  `data-training-action="calendar" data-course-id="${escapeHtml(String(course.id))}"` :
  `data-training-action="calendar-registration" data-registration-id="${escapeHtml(String(registrationId))}"`;
  return `
    <div class="training-calendar-actions" role="group" aria-label="${T("interface.anadir_a_tu_calendario")}">
      <span class="training-calendar-label">${T("interface.anadir_a_tu_calendario")}</span>
      <div class="training-calendar-buttons">
        <a class="training-calendar-button training-google-calendar" href="${escapeHtml(googleUrl)}" target="_blank" rel="noopener noreferrer" aria-label="${T("interface.anadir_a_google_calendar_se_abre_en_otra_pestana")}">
          ${renderTrainingIcon("calendar")}<span>${T("interface.google_calendar")}</span>${renderTrainingIcon("external")}
        </a>
        <button class="training-calendar-button training-calendar-download" type="button" ${downloadAttributes} aria-label="${T("interface.descargar_archivo_ics_para_otros_calendarios")}">
          ${renderTrainingIcon("download")}<span>${T("interface.otros_calendarios")}</span><span class="training-calendar-format">${T("interface.ics")}</span>
        </button>
      </div>
    </div>
  `;
}

function downloadTrainingCalendar(course = {}) {
  if (!course?.startsAt) return;
  const content = [
  "BEGIN:VCALENDAR",
  "VERSION:2.0",
  "PRODID:-//Astroanamnesis//Formacion//ES",
  "BEGIN:VEVENT",
  `UID:formacion-${course.id}@astroanamnesis`,
  `DTSTAMP:${formatTrainingIcsDate(new Date().toISOString())}`,
  `DTSTART:${formatTrainingIcsDate(course.startsAt)}`,
  `SUMMARY:${String(T("training_dates.calendar_start", { title: I18n.content(course, "title") || I18n.label("Formación Astroanamnesis") })).replace(/[;,\\]/g, " ")}`,
  `DESCRIPTION:${String(I18n.content(course, "summary") || I18n.label("Formación con Eliseo Gallardo")).replace(/\n/g, " ").replace(/[;,\\]/g, " ")}`,
  `LOCATION:${String(course.location || trainingModalityLabel(course.modality)).replace(/[;,\\]/g, " ")}`,
  "END:VEVENT",
  "END:VCALENDAR"].
  join("\r\n");
  const url = URL.createObjectURL(new Blob([content], { type: "text/calendar;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${course.slug || "formacion-astroanamnesis"}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function trainingDateTimeInputValue(value = "") {
  return clean(value).replace(" ", "T").slice(0, 16);
}

function renderAdminTraining() {
  if (!adminTraining) return;
  const summary = adminData.trainingSummary || {};
  I18n.bind(adminTraining, "innerHTML", ((__i18nSnapshot0) => () => `
    <header class="admin-section-head admin-training-head">
      <div>
        <h3>${T("navigation.training")}</h3>
        <p>${T("interface.publica_cursos_y_gestiona_solicitudes_plazas_confirmadas_y_listas_de_espera")}</p>
      </div>
      <button class="primary-action" type="button" data-admin-training-action="new-course">${T("interface.nueva_formacion")}</button>
    </header>
    <div class="admin-metric-grid">
      ${adminMetric("Formaciones", summary.courses, T("interface.historial_completo"))}
      ${adminMetric("Publicadas", summary.published, T("interface.visibles_para_usuarios"))}
      ${adminMetric(T("interface.solicitudes_activas"), summary.active_registrations, T("interface.pendientes_o_confirmadas"))}
      ${adminMetric(T("interface.lista_de_espera"), summary.waitlist, T("interface.pendientes_de_plaza"))}
    </div>
    <section class="admin-training-block">
      <header><div><p class="eyebrow">${T("interface.convocatorias")}</p><h4>${T("interface.cursos_y_encuentros")}</h4></div></header>
      <div class="admin-training-course-list">
        ${__i18nSnapshot0.trainingCourses.length ? __i18nSnapshot0.trainingCourses.map((course) => `
          <article class="admin-training-course">
            <div class="admin-training-course-main">
              <div class="admin-training-course-title-row">
                <h5>${escapeHtml(I18n.content(course, "title"))}</h5>
                ${adminPill(Object.freeze({ get draft() {return T("interface.borrador");}, get published() {return T("interface.publicado");}, get completed() {return T("interface.finalizado");}, get cancelled() {return T("interface.cancelado");} })[course.status] || course.status, course.status)}
                ${course.featured ? adminPill("Destacada", "completed") : ""}
              </div>
              <p>${escapeHtml(formatTrainingDateRange(course))}</p>
              <small>${T("interface.valuevalue_value_value_plazas", { v4: escapeHtml(trainingModalityLabel(course.modality)), v5: course.location ? ` · ${escapeHtml(course.location)}` : "", v6: formatNumber(course.registeredCount), v7: formatNumber(course.capacity) })}</small>
            </div>
            <button class="secondary-action" type="button" data-admin-training-action="edit-course" data-course-id="${course.id}">${T("common.edit")}</button>
          </article>
        `).join("") : renderTrainingEmpty(T("interface.no_hay_formaciones_creadas"), T("interface.crea_la_primera_convocatoria_y_mantenla_como_borrador_hasta_que_este_lista"))}
      </div>
    </section>
    <section class="admin-training-block">
      <header><div><p class="eyebrow">${T("interface.inscripciones")}</p><h4>${T("interface.solicitudes_recibidas")}</h4></div></header>
      ${adminTable([T("interface.persona"), T("navigation.training"), T("common.status"), "Solicitud", ""], __i18nSnapshot0.trainingRegistrations.map((registration) => [`<b>${escapeHtml(registration.fullName)}</b><small>${escapeHtml(registration.email)}</small>${registration.phone ? `<small>${escapeHtml(registration.phone)}</small>` : ""}`, `<b>${escapeHtml(registration.courseTitle)}</b><small>${escapeHtml(I18n.label(formatTrainingDate(registration.startsAt, { weekday: false, time: false })))}</small>`, `<select class="admin-training-status-select" data-training-registration-status="${registration.id}" aria-label="${T("interface.estado_de_value", { v1: escapeHtml(registration.fullName) })}">
          ${Object.entries(Object.freeze({ get requested() {return T("interface.solicitud_recibida");}, get confirmed() {return T("interface.plaza_confirmada");}, get waitlist() {return T("interface.lista_de_espera");}, get cancelled() {return T("interface.cancelada");} })).map(([value, label]) => `<option value="${value}" ${registration.status === value ? "selected" : ""}>${escapeHtml(I18n.label(label))}</option>`).join("")}
        </select>`, formatAdminDate(registration.requestedAt || registration.createdAt), `<button class="btn-small admin-action-button" type="button" data-admin-training-action="save-registration" data-registration-id="${registration.id}">${T("common.save")}</button>`]))}
    </section>
  `)(adminData));






}

function openAdminTrainingCourseDialog(courseId = 0) {
  const course = adminData.trainingCourses.find((item) => String(item.id) === String(courseId));
  adminTrainingCourseForm?.reset();
  if (adminTrainingCourseTitle) I18n.bind(adminTrainingCourseTitle, "textContent", () => course ? T("interface.editar_formacion") : T("interface.nueva_formacion"));
  if (adminTrainingCourseId) adminTrainingCourseId.value = course?.id || "";
  if (adminTrainingTitleInput) adminTrainingTitleInput.value = course?.title || "";
  if (adminTrainingSummaryInput) adminTrainingSummaryInput.value = course?.summary || "";
  if (adminTrainingDescriptionInput) adminTrainingDescriptionInput.value = course?.description || "";
  if (adminTrainingStartsAtInput) adminTrainingStartsAtInput.value = trainingDateTimeInputValue(course?.startsAt);
  if (adminTrainingEndsAtInput) adminTrainingEndsAtInput.value = trainingDateTimeInputValue(course?.endsAt);
  if (adminTrainingRegistrationOpensInput) adminTrainingRegistrationOpensInput.value = trainingDateTimeInputValue(course?.registrationOpensAt);
  if (adminTrainingRegistrationClosesInput) adminTrainingRegistrationClosesInput.value = trainingDateTimeInputValue(course?.registrationClosesAt);
  if (adminTrainingModalityInput) adminTrainingModalityInput.value = course?.modality || "online";
  if (adminTrainingLocationInput) adminTrainingLocationInput.value = course?.location || "";
  if (adminTrainingCapacityInput) adminTrainingCapacityInput.value = course?.capacity || 20;
  if (adminTrainingPriceInput) adminTrainingPriceInput.value = ((course?.priceCents || 0) / 100).toFixed(course?.priceCents % 100 ? 2 : 0);
  if (adminTrainingStatusInput) adminTrainingStatusInput.value = course?.status || "draft";
  if (adminTrainingFeaturedInput) adminTrainingFeaturedInput.checked = Boolean(course?.featured);
  if (adminTrainingAnnouncementInput) adminTrainingAnnouncementInput.checked = Boolean(course?.announcementEnabled);
  if (adminTrainingAudienceInput) adminTrainingAudienceInput.value = course?.audience || "";
  if (adminTrainingSyllabusInput) adminTrainingSyllabusInput.value = course?.syllabus || "";
  if (adminTrainingCourseStatus) {
    I18n.clear(adminTrainingCourseStatus, "textContent");
    adminTrainingCourseStatus.classList.remove("error");
  }
  adminTrainingCourseDialog?.showModal();
  adminTrainingTitleInput?.focus();
}

function closeAdminTrainingCourseDialog() {
  adminTrainingCourseDialog?.close();
  if (adminTrainingCourseStatus) {
    I18n.clear(adminTrainingCourseStatus, "textContent");
    adminTrainingCourseStatus.classList.remove("error");
  }
}

async function submitAdminTrainingCourse(event) {
  event.preventDefault();
  const courseId = Number(adminTrainingCourseId?.value || 0);
  const payload = {
    title: clean(adminTrainingTitleInput?.value || ""),
    summary: clean(adminTrainingSummaryInput?.value || ""),
    description: clean(adminTrainingDescriptionInput?.value || ""),
    startsAt: adminTrainingStartsAtInput?.value || "",
    endsAt: adminTrainingEndsAtInput?.value || "",
    registrationOpensAt: adminTrainingRegistrationOpensInput?.value || "",
    registrationClosesAt: adminTrainingRegistrationClosesInput?.value || "",
    modality: adminTrainingModalityInput?.value || "online",
    location: clean(adminTrainingLocationInput?.value || ""),
    capacity: Number(adminTrainingCapacityInput?.value || 1),
    priceCents: Math.round(Number(adminTrainingPriceInput?.value || 0) * 100),
    status: adminTrainingStatusInput?.value || "draft",
    featured: Boolean(adminTrainingFeaturedInput?.checked),
    announcementEnabled: Boolean(adminTrainingAnnouncementInput?.checked),
    audience: clean(adminTrainingAudienceInput?.value || ""),
    syllabus: clean(adminTrainingSyllabusInput?.value || "")
  };
  const submit = adminTrainingCourseForm?.querySelector('[type="submit"]');
  if (submit) submit.disabled = true;
  if (adminTrainingCourseStatus) {
    I18n.bind(adminTrainingCourseStatus, "textContent", () => T("interface.guardando_formacion"));
    adminTrainingCourseStatus.classList.remove("error");
  }
  try {
    await adminFetch(courseId ? `/api/admin/training/courses/${courseId}` : "/api/admin/training/courses", {
      method: courseId ? "PATCH" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    closeAdminTrainingCourseDialog();
    adminData.trainingLoaded = false;
    trainingLoaded = false;
    await loadAdminPanel("training", { force: true });
    await loadTrainingData({ force: true }).catch(() => null);
    setAdminStatus(() => courseId ? T("interface.formacion_actualizada") : T("interface.formacion_creada_como_nueva_convocatoria"));
  } catch (error) {
    if (adminTrainingCourseStatus) {
      I18n.bind(adminTrainingCourseStatus, "textContent", () => error.message || T("interface.no_se_pudo_guardar_la_formacion"));
      adminTrainingCourseStatus.classList.add("error");
    }
  } finally {
    if (submit) submit.disabled = false;
  }
}

async function updateAdminTrainingRegistration(registrationId, button) {
  const select = adminTraining?.querySelector(`[data-training-registration-status="${registrationId}"]`);
  if (!select) return;
  const previousText = button?.textContent || T("common.save");
  if (button) {
    button.disabled = true;
    I18n.bind(button, "textContent", () => T("interface.guardando"));
  }
  try {
    await adminFetch(`/api/admin/training/registrations/${registrationId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: select.value })
    });
    adminData.trainingLoaded = false;
    trainingLoaded = false;
    await loadAdminPanel("training", { force: true });
    setAdminStatus(() => T("interface.estado_de_inscripcion_actualizado"));
  } catch (error) {
    if (button) {
      button.disabled = false;
      I18n.bind(button, "textContent", () => button?.textContent || T("common.save"));
    }
    setAdminStatus(() => error.message || T("interface.no_se_pudo_actualizar_la_inscripcion"), true);
  }
}

function openAdminUserAdjustDialog(userId) {
  const user = adminData.users.find((item) => String(item.id) === String(userId));
  if (!user) return;
  activeAdminAdjustUserId = String(userId);
  if (adminUserAdjustSummary) {
    I18n.bind(adminUserAdjustSummary, "innerHTML", () => `
      <div>
        <b>${escapeHtml(user.name || user.email)}</b>
        <small>${escapeHtml(user.email)}</small>
      </div>
      <div>
        ${adminPill(getAdminSubscriptionLabel(user), getAdminSubscriptionVariant(user))}
        <small>${T("interface.value_personas_guardadas", { v3: formatNumber(user.peopleCount) })}</small>
      </div>
    `);
  }
  if (adminAdjustPlanSelect) {
    adminAdjustPlanSelect.value = isAdminUserSubscribed(user) ? "professional" : "essential";
  }
  if (adminAdjustCreditsInput) adminAdjustCreditsInput.value = "0";
  if (adminAdjustReasonInput) adminAdjustReasonInput.value = "Ajuste manual solicitado";
  setAdminAdjustStatus("");
  adminUserAdjustDialog?.showModal();
  adminAdjustPlanSelect?.focus();
}

function closeAdminUserAdjustDialog() {
  activeAdminAdjustUserId = "";
  setAdminAdjustStatus("");
  adminUserAdjustDialog?.close();
}

async function adminAdjustUser(event) {
  event.preventDefault();
  const userId = activeAdminAdjustUserId;
  const user = adminData.users.find((item) => String(item.id) === String(userId));
  if (!user) return;

  const planKey = clean(adminAdjustPlanSelect?.value || "");
  const subscriptionActive = planKey ?
  planKey === "professional" :
  null;
  const creditDelta = Number(adminAdjustCreditsInput?.value || 0);
  const reason = clean(adminAdjustReasonInput?.value || "");

  if (!planKey && creditDelta === 0) {
    setAdminAdjustStatus(() => T("interface.indica_un_cambio_de_suscripcion"), true);
    return;
  }
  if (!Number.isFinite(creditDelta) || Math.abs(creditDelta) > 10_000_000) {
    setAdminAdjustStatus(() => T("interface.el_ajuste_interno_no_es_valido"), true);
    return;
  }
  if (!reason) {
    setAdminAdjustStatus(() => T("interface.indica_un_motivo_interno_para_dejar_trazabilidad"), true);
    return;
  }

  setAdminAdjustStatus(() => T("interface.guardando_ajuste"));
  setAdminAdjustBusy(true);

  try {
    const response = await adminFetch(`/api/admin/users/${userId}/billing`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        planKey,
        subscriptionActive,
        creditDelta,
        reason
      })
    });
    if (
    subscriptionActive !== null &&
    Boolean(response.user?.subscriptionActive) !== subscriptionActive)
    {
      throw new Error(T("interface.el_servidor_no_confirmo_el_cambio_de_suscripcion"));
    }
    const index = adminData.users.findIndex((item) => String(item.id) === String(userId));
    if (index >= 0) adminData.users[index] = response.user;
    if (String(currentUser?.id || "") === String(userId) && response.user?.capabilities) {
      currentUser.plan = response.user.capabilities.plan;
      currentUser.capabilities = response.user.capabilities;
      renderAuthState();
      await loadBillingSummary({ silent: true }).catch(() => null);
    }
    adminData.summary = null;
    renderAdminPanel();
    closeAdminUserAdjustDialog();
    setAdminStatus(() => T("interface.usuario_ajustado_correctamente"));
  } catch (error) {
    setAdminAdjustStatus(() => error.message || T("interface.no_se_pudo_ajustar_la_cuenta"), true);
  } finally {
    setAdminAdjustBusy(false);
  }
}

function openAdminOrderStatusDialog(orderId) {
  const order = adminData.orders.find((item) => String(item.id) === String(orderId));
  if (!order) return;
  activeAdminOrderId = String(orderId);
  if (adminOrderStatusSummary) {
    I18n.bind(adminOrderStatusSummary, "innerHTML", () => `
      <div>
        <b>${escapeHtml(I18n.label(order.label))}</b>
        <small>${escapeHtml(order.productKey)}</small>
      </div>
      <div>
        ${adminPill(getAdminOrderStatusLabel(order.status), order.status)}
        <small>${escapeHtml(order.userEmail)}</small>
      </div>
    `);
  }
  if (adminOrderContext) {
    I18n.bind(adminOrderContext, "innerHTML", () => renderAdminOrderContext(order));
  }
  if (adminOrderStatusSelect) adminOrderStatusSelect.value = order.status;
  setAdminOrderStatusMessage("");
  adminOrderStatusDialog?.showModal();
  adminOrderStatusSelect?.focus();
}

function closeAdminOrderStatusDialog() {
  activeAdminOrderId = "";
  if (adminOrderContext) I18n.clear(adminOrderContext, "innerHTML");
  setAdminOrderStatusMessage("");
  adminOrderStatusDialog?.close();
}

async function adminUpdateOrderStatus(event) {
  event.preventDefault();
  const orderId = activeAdminOrderId;
  const order = adminData.orders.find((item) => String(item.id) === String(orderId));
  if (!order) return;
  const status = clean(adminOrderStatusSelect?.value || "");

  if (!ADMIN_ORDER_STATUS_LABELS[status]) {
    setAdminOrderStatusMessage(T("interface.selecciona_un_estado_valido"), true);
    return;
  }

  setAdminOrderStatusMessage(T("interface.guardando_estado"));
  setAdminOrderStatusBusy(true);

  try {
    const response = await adminFetch(`/api/admin/orders/${orderId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status })
    });
    const index = adminData.orders.findIndex((item) => String(item.id) === String(orderId));
    if (index >= 0) adminData.orders[index] = response.order;
    renderAdminOrders();
    closeAdminOrderStatusDialog();
    setAdminStatus(() => T("interface.pedido_actualizado_correctamente"));
  } catch (error) {
    setAdminOrderStatusMessage(error.message || T("interface.no_se_pudo_actualizar_el_pedido"), true);
  } finally {
    setAdminOrderStatusBusy(false);
  }
}

function getAdminOrderStatusLabel(status) {
  return ADMIN_ORDER_STATUS_LABELS[status] || status || T("interface.sin_estado");
}

function adminPill(label, variant = "neutral") {
  const safeVariant = clean(variant).toLowerCase().replace(/[^a-z0-9_-]/g, "-") || "neutral";
  return `<span class="admin-pill admin-pill-${safeVariant}">${escapeHtml(I18n.label(label || T("interface.sin_dato")))}</span>`;
}

function setAdminAdjustStatus(text, isError = false) {
  if (!adminUserAdjustStatus) return;
  I18n.bind(adminUserAdjustStatus, "textContent", () => text || "");
  adminUserAdjustStatus.classList.toggle("error", Boolean(isError));
}

function setAdminAdjustBusy(busy) {
  if (adminUserAdjustSubmit) adminUserAdjustSubmit.disabled = busy;
  if (adminUserAdjustCancelButton) adminUserAdjustCancelButton.disabled = busy;
  if (adminUserAdjustCloseButton) adminUserAdjustCloseButton.disabled = busy;
}

function setAdminOrderStatusMessage(text, isError = false) {
  if (!adminOrderStatusMessage) return;
  I18n.bind(adminOrderStatusMessage, "textContent", () => text || "");
  adminOrderStatusMessage.classList.toggle("error", Boolean(isError));
}

function setAdminOrderStatusBusy(busy) {
  if (adminOrderStatusSubmit) adminOrderStatusSubmit.disabled = busy;
  if (adminOrderStatusCancelButton) adminOrderStatusCancelButton.disabled = busy;
  if (adminOrderStatusCloseButton) adminOrderStatusCloseButton.disabled = busy;
}

function adminMetric(label, value, detail) {
  return `
    <article class="admin-metric">
      <span>${escapeHtml(I18n.label(label))}</span>
      <strong>${formatNumber(value)}</strong>
      <small>${escapeHtml(detail || "")}</small>
    </article>
  `;
}

function adminTable(headers, rows) {
  if (!rows.length) return `<p class="admin-empty">${T("interface.sin_registros")}</p>`;
  return `
    <div class="admin-table-wrap">
      <table class="admin-table">
        <thead><tr>${headers.map((header) => `<th>${escapeHtml(header)}</th>`).join("")}</tr></thead>
        <tbody>
          ${rows.map((row) => `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`).join("")}
        </tbody>
      </table>
    </div>
  `;
}

function formatAdminDate(value) {
  if (!value) return "";
  return formatChatDate(value, false);
}

function setAdminStatus(text, isError = false) {
  if (!adminStatus) return;
  I18n.bind(adminStatus, "textContent", () => text || "");
  adminStatus.classList.toggle("error", Boolean(isError));
}

function scrollPublicPageToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function showLanding() {
  destroyPrivateObservatory();
  destroyPrivateTimeline();
  destroyPrivateAtlas3D();
  closePersonForm();
  if (privateSidebarMobileQuery.matches) {
    privateSidebarCollapsed = true;
    applyPrivateSidebarState();
  }
  intakeScreen.classList.add("is-hidden");
  privateScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  donationScreen?.classList.add("is-hidden");
  landingScreen?.classList.remove("is-hidden");
  updateTrainingBanner();
}

function showAboutPage(pushRoute = true) {
  destroyPrivateObservatory();
  destroyPrivateTimeline();
  destroyPrivateAtlas3D();
  closePersonForm();
  landingScreen?.classList.add("is-hidden");
  donationScreen?.classList.add("is-hidden");
  intakeScreen.classList.add("is-hidden");
  privateScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  aboutScreen?.classList.remove("is-hidden");
  if (pushRoute && I18n.routePath() !== ABOUT_ROUTE) {
    I18n.pushState(null, "", ABOUT_ROUTE);
  }
  scrollPublicPageToTop();
  if (pushRoute) {
    window.requestAnimationFrame(() => aboutTitle?.focus({ preventScroll: true }));
  }
  updateTrainingBanner();
}

function showDonationPage(pushRoute = true) {
  destroyPrivateObservatory();
  destroyPrivateTimeline();
  destroyPrivateAtlas3D();
  closeContactModal();
  closeAccountSettings();
  document.querySelectorAll("dialog[open]").forEach((dialog) => dialog.close());
  closePersonForm();
  landingScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  intakeScreen.classList.add("is-hidden");
  privateScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  donationScreen?.classList.remove("is-hidden");
  if (pushRoute && I18n.routePath() !== DONATION_ROUTE) {
    I18n.pushState(null, "", DONATION_ROUTE);
  }
  scrollPublicPageToTop();
  if (pushRoute) {
    window.requestAnimationFrame(() => donationTitle?.focus({ preventScroll: true }));
  }
  updateTrainingBanner();
}

function showIntake(pushRoute = true) {
  destroyPrivateObservatory();
  destroyPrivateTimeline();
  destroyPrivateAtlas3D();
  hideTrainingBanner();
  closePersonForm();
  landingScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  donationScreen?.classList.add("is-hidden");
  privateScreen.classList.add("is-hidden");
  guestMapsScreen?.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  intakeScreen.classList.remove("is-hidden");
  if (pushRoute && I18n.routePath() !== GUEST_INTAKE_ROUTE) {
    I18n.pushState(null, "", GUEST_INTAKE_ROUTE);
  }
  scrollPublicPageToTop();
}

function isGuestMapsMode() {
  return Boolean(guestMapsScreen && !guestMapsScreen.classList.contains("is-hidden"));
}

function applyGuestChartLimits() {
  if (!chartWheelTypeSelect || !isGuestMapsMode()) return;
  Array.from(chartWheelTypeSelect.options).forEach((option) => {
    const allowed = GUEST_CHART_TYPES.has(option.value);
    option.hidden = !allowed;
    option.disabled = !allowed;
  });
  if (!GUEST_CHART_TYPES.has(chartWheelTypeSelect.value)) {
    chartWheelTypeSelect.value = "multiple";
  }
}

async function openGuestMaps() {
  destroyPrivateObservatory();
  destroyPrivateTimeline();
  destroyPrivateAtlas3D();
  if (!chartCalculation || !guestMapsScreen) {
    showIntake();
    return;
  }

  closePersonForm();
  landingScreen?.classList.add("is-hidden");
  aboutScreen?.classList.add("is-hidden");
  intakeScreen.classList.add("is-hidden");
  privateScreen.classList.add("is-hidden");
  chatScreen.classList.add("is-hidden");
  adminScreen?.classList.add("is-hidden");
  guestMapsScreen.classList.remove("is-hidden");

  mountChartWheelInGuestMaps();
  chartWheelTypeSelect.value = "multiple";
  applyChartTypeModuleVisibility();
  applyGuestChartLimits();
  syncChartWheelControls();
  await renderSelectedChartWheel();
}

async function logoutCurrentUser() {
  destroyPrivateObservatory(true);
  destroyPrivateTimeline(true);
  destroyPrivateAtlas3D(true);
  window.TrainingVideos?.reset();
  closeSidebarAccountMenu();
  closePrivateAccountMenu();
  setPrivateStatus(() => T("interface.cerrando_sesion"));
  setStatus(() => T("interface.cerrando_sesion"));
  await I18n.fetch("/api/auth/logout", { method: "POST" }).catch(() => null);
  currentUser = null;
  accountPreferencesLoaded = false;
  window.clearTimeout(accountPreferencesSaveTimer);
  accountPreferencesSaveDirty = false;
  billingSummary = null;
  savedPeople = [];
  renderAuthState();
  renderBillingUI();
  renderPeopleList();
  resetPersonForm();
  showLanding();
  I18n.replaceState(null, "", "/");
  setPrivateStatus("");
  setStatus("");
}

async function loadPeople(options = {}) {
  const peopleOwnerId = currentUser?.id;
  let response;
  try {response = await I18n.fetch("/api/people", options.signal ? { signal: options.signal } : undefined);}
  catch (error) {if (!options.signal?.aborted && peopleOwnerId === currentUser?.id) {privateWorkPeopleError = peopleOwnerId;window.WorkDashboard?.sync();}throw error;}
  const payload = await response.json().catch(() => ({}));
  if (options.signal?.aborted || peopleOwnerId !== currentUser?.id || options.ownerId !== undefined && options.ownerId !== currentUser?.id) return;

  if (response.status === 401) {
    currentUser = null;
    renderAuthState();
    showLanding();
    setAuthStatus(() => T("interface.la_sesion_ha_caducado_inicia_sesion_de_nuevo"), true);
    return;
  }

  if (!response.ok) {privateWorkPeopleError = peopleOwnerId;window.WorkDashboard?.sync();throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));}

  savedPeople = sortPeopleByFavorite(payload.people || []);
  privateWorkPeopleOwner = currentUser?.id || null;
  privateWorkPeopleError = null;
  privateTransitNatalCache.clear();
  if (currentUser && payload.capabilities) currentUser.capabilities = payload.capabilities;
  syncAllowedModelLevel(false);
  updateChartDataButton();
  renderAuthState();
  const capabilities = getCapabilities();
  I18n.bind(peopleCount, "textContent", ((__i18nSnapshot0) => () => T("interface.value_value_personas_guardadas_value", { v0: __i18nSnapshot0.length, v1: payload.limit || capabilities.maxPeople, get v2() {return isSubscribedUser() ? T("interface.suscrito") : T("navigation.notSubscribed");} }))(savedPeople));
  syncPeopleLimitState();
  renderPeopleList();
  window.WorkDashboard?.remember();
}

async function loadBillingSummary(options = {}) {
  if (!currentUser) {
    billingSummary = null;
    renderBillingUI();
    renderCreditWidgets();
    return null;
  }

  const response = await I18n.fetch("/api/billing/summary", { cache: "no-store" });
  const payload = await response.json().catch(() => ({}));

  if (response.status === 401) {
    currentUser = null;
    billingSummary = null;
    renderAuthState();
    showLanding();
    setAuthStatus(() => T("interface.la_sesion_ha_caducado_inicia_sesion_de_nuevo"), true);
    return null;
  }

  if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

  billingSummary = payload;
  currentUser.plan = payload.plan;
  currentUser.capabilities = payload.capabilities;
  currentUser.billing = payload.account;
  syncSubscriberOnlyChartViews();
  syncSubscriberOnlyTools();
  syncAllowedModelLevel(false);
  updateChartDataButton();
  if (privateUser) {
    I18n.bind(privateUser, "innerHTML", () => renderPrivateUserCard({ sidebar: true }));
    closePrivateAccountMenu();
  }
  if (adminUser) I18n.bind(adminUser, "innerHTML", () => renderPrivateUserCard());
  renderBillingUI();
  updatePrivateMapOffer();
  renderCreditWidgets();
  if (options.announce) setBillingStatus(() => T("interface.saldo_actualizado"));
  window.WorkDashboard?.sync();
  return payload;
}

function getBillingAccount() {
  return billingSummary?.account || currentUser?.billing || {
    balance: 0,
    lifetimeGranted: 0,
    lifetimeSpent: 0,
    lowBalance: false
  };
}

function getPrivateQuickActionSection(action) {
  if (action === "saved-charts" || action === "add-chart") return "list";
  if (action === "maps") return "maps";
  if (action === "prognosis" || action === "lunar-phases") return "prognosis";
  if (action === "transits") return "transits";
  return "";
}

function updatePrivateQuickNavState(section) {
  privateQuickActionButtons.forEach((button) => {
    const action = button.dataset.privateQuickAction || "";
    const mappedSection = getPrivateQuickActionSection(action);
    const active = mappedSection === section && !(section === "list" && action === "add-chart");
    button.classList.toggle("active", active);
    if (active) {
      button.setAttribute("aria-current", "page");
    } else {
      button.removeAttribute("aria-current");
    }
  });
}

async function preparePrivateMapsSection() {
  mountChartWheelInPrivateMaps();
  renderPrivateMapActiveCard();
  renderBirthSummary();
  updateChartDataButton();
  syncChatChartContextControls();

  if (!chartCalculation) {
    if (chartWheelStage) {
      I18n.bind(chartWheelStage, "innerHTML", () => `
        <div class="chart-wheel-empty private-maps-empty">
          <h3>${T("interface.selecciona_una_carta_para_ver_los_mapas")}</h3>
          <p>${T("interface.usa_mi_lista_para_cargar_una_persona_guardada_o_anade_una_carta_nueva")}</p>
          <button class="primary-action" type="button" data-private-map-empty-action="list">${T("interface.ir_a_mi_lista")}</button>
        </div>
      `);
    }
    return;
  }

  await refreshPrimaryChartWheel();
}

function syncPrivateToolsNavigationState(section = activePrivateSection) {
  const isToolsSection = section === "tools";
  const expanded = Boolean(privateToolsMenuExpanded);
  const hasActiveTool = ["atlas", "atlas3d", "observatory", "timeline", "tools", "transits"].includes(section);
  privateToolsMenu?.classList.toggle("is-expanded", expanded);
  privateToolsToggle?.setAttribute("aria-expanded", String(expanded));
  privateToolsToggle?.classList.toggle("has-active-child", hasActiveTool);
  if (privateToolsSubmenu) {
    if (!expanded && privateToolsSubmenu.contains(document.activeElement)) privateToolsToggle?.focus({ preventScroll: true });
    privateToolsSubmenu.hidden = !expanded;
    privateToolsSubmenu.setAttribute("aria-hidden", String(!expanded));
    if (expanded) privateToolsSubmenu.removeAttribute("inert");else
    privateToolsSubmenu.setAttribute("inert", "");
  }
  privateToolsRouteButtons.forEach((button) => {
    const active = isToolsSection && button.dataset.privateToolsRoute === activePrivateToolsView;
    button.classList.toggle("active", active);
    if (active) button.setAttribute("aria-current", "page");else
    button.removeAttribute("aria-current");
  });
}

function syncSubscriberOnlyTools() {
  const subscribed = hasConfirmedSubscription();
  subscriberToolNavigationButtons.forEach((button) => {
    const label = button.querySelector("span")?.textContent?.trim() || button.textContent.trim();
    button.classList.toggle("is-subscription-locked", !subscribed);
    button.setAttribute("aria-disabled", subscribed ? "false" : "true");
    I18n.bind(button, "title", () => subscribed ? "" : T("interface.value_disponible_con_suscripcion", { v0: I18n.label(label) }));
  });
  const atlas3DNav = document.getElementById("private-atlas-3d-link");
  const atlas3DAllowed = subscribed && currentUser?.canAccessAtlas3D === true;
  if (atlas3DNav) {
    atlas3DNav.classList.toggle("is-subscription-locked", !atlas3DAllowed);
    atlas3DNav.setAttribute("aria-disabled", atlas3DAllowed ? "false" : "true");
    I18n.bind(atlas3DNav, "title", () => atlas3DAllowed ? "" : T("atlas.subscriptionRequired"));
  }
  if (!atlas3DAllowed) {
    destroyPrivateAtlas3D(true);
    if (activePrivateSection === "atlas3d") showPrivateSection("list", { replaceRoute: true });
  }
  syncObservatoryNavigation();
  syncTimelineNavigation();
}

function syncPrivateTrainingNavigationState(section = activePrivateSection) {
  privateTrainingRouteButtons.forEach((button) => {
    const active = section === "training" && button.dataset.privateTrainingRoute === activePrivateTrainingView;
    button.classList.toggle("active", active);
    if (active) button.setAttribute("aria-current", "page");else
    button.removeAttribute("aria-current");
  });
}

function mountPrivateToolHelp(root, context, { heading, method } = {}) {
  if (!window.ToolHelp?.mount || !root || root.querySelector('[data-tool-help]')) return null;
  const header = root.querySelector(heading);
  if (!header) return null;
  const host = document.createElement('div');header.after(host);
  const slot = method ? document.createComment('Tool help original note') : null;
  if (slot) method.before(slot);
  function focus(target) {
    if (!target || target.disabled) return;
    target.closest('details')?.setAttribute('open', '');
    if (!target.matches('a,button,input,select,textarea,summary,[tabindex]')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView?.({ block: 'center', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth' });
  }
  const help = window.ToolHelp.mount(host, { language: document.documentElement.lang, method, onAction(action) {
      const selectors = { 'atlas-content': '.atlas-contexts [role="tab"],.atlas-sign,.atlas-card,.atlas-reading', 'aspect-setup': '#aspect-finder-planet-a', 'aspect-result': '#aspect-finder-result', 'natal-setup': '#natal-aspect-finder-transit-planet', 'natal-result': '#natal-aspect-finder-result' };
      if (action === 'atlas-search') {
        const input = root.querySelector('#atlas-query');
        if (input) focus(input);else root.querySelector('.atlas-breadcrumb a')?.click();
      } else if (action === 'natal-chart') root.querySelector('#natal-aspect-finder-person-picker')?.click();else
      if (action === 'atlas3d-chart') root.querySelector('.atlas3d-person-card [data-atlas3d-action="choose-person"]')?.click();else
      if (action === 'atlas3d-sign') {
        const control = root.querySelector('[data-atlas3d-sign]');
        const mobile = root.querySelector('[data-atlas3d-action="open-tools"]');
        if (mobile && window.getComputedStyle(mobile).display !== 'none') mobile.click();
        focus(control);
      } else if (action === 'atlas3d-guide') {
        root.querySelector('[data-atlas3d-pane="reading"]')?.click();
        const guide = root.querySelector('.atlas3d-reading-guide');
        if (guide) {guide.open = true;focus(guide.querySelector('summary'));}
      } else if (selectors[action]) focus(root.querySelector(selectors[action]));
    } });
  help.setContext(context);
  return { context, destroy() {if (slot?.parentNode) {slot.before(method);slot.remove();}help.destroy();host.remove();} };
}

function syncPrivateSearchHelp(view) {
  if (!privateToolsSection || !window.ToolHelp?.mount) return;
  const context = view === 'natal' ? 'natal-search' : 'aspect-search';
  if (privateToolsSection._toolHelp?.context === context) return;
  privateToolsSection._toolHelp?.destroy();
  const panel = privateToolsSection.querySelector(`[data-tools-view-panel="${view}"]`);
  privateToolsSection._toolHelp = mountPrivateToolHelp(privateToolsSection, context, { heading: '.private-tools-header', method: panel?.querySelector('.aspect-finder-intro') });
}

function loadPrivateAtlasAssets() {
  if (!privateAtlasAssetsPromise) {
    privateAtlasAssetsPromise = Promise.all([
    new Promise((resolve, reject) => {
      if (window.AtlasPage) return resolve();
      const script = document.createElement("script");
      script.src = "/atlas/assets/atlas.js";
      script.onload = () => {script.remove();resolve();};
      script.onerror = () => {script.remove();reject(new Error(T("atlas.loadError")));};
      document.head.append(script);
    }),
    new Promise((resolve, reject) => {
      const existing = document.getElementById("private-atlas-styles");
      if (existing?.sheet) return resolve();
      existing?.remove();
      const link = document.createElement("link");
      link.id = "private-atlas-styles";
      link.rel = "stylesheet";
      link.href = "/atlas/assets/atlas.css";
      link.onload = resolve;
      link.onerror = () => {link.remove();reject(new Error(T("atlas.loadError")));};
      document.head.append(link);
    })]
    ).catch((error) => {privateAtlasAssetsPromise = null;throw error;});
  }
  return privateAtlasAssetsPromise;
}

async function loadPrivateAtlasPage(path = "/private/atlas") {
  if (!(currentUser?.canAccessAtlas || currentUser?.canAccessAtlas3D === true) || activePrivateSection !== "atlas") return;
  if (privateAtlasController && !privateAtlasController.canLeave()) return;
  const route = new URL(path, window.location.origin);
  if (route.origin !== window.location.origin || !/^\/private\/atlas(?:\/|$)/.test(route.pathname)) return;
  privateAtlasRequest?.abort();
  const request = new AbortController();
  privateAtlasRequest = request;
  privateAtlasController?.destroy();
  privateAtlasController = null;
  privateAtlasPath = route.pathname + route.search;
  if (I18n.routePath() + window.location.search !== privateAtlasPath) I18n.pushState(null, "", privateAtlasPath);
  let section = document.getElementById("private-atlas-section");
  if (!section) {
    section = document.createElement("section");
    section.id = "private-atlas-section";
    section.className = "private-space-section private-atlas-section";
    section.dataset.privateSection = "atlas";
    I18n.bind(section, "@aria-label", () => T("atlas.name"));
    privateMapsSection.after(section);
    section.addEventListener("click", (event) => {
      const link = event.target.closest("a[href]");
      if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || link.target === "_blank") return;
      const target = new URL(link.href);
      if (target.origin === window.location.origin && /^\/private\/atlas(?:\/|$)/.test(target.pathname)) {
        event.preventDefault();
        void loadPrivateAtlasPage(target.pathname + target.search);
      }
    });
    section.addEventListener("submit", (event) => {
      if (!event.target.matches(".atlas-search")) return;
      event.preventDefault();
      void loadPrivateAtlasPage("/private/atlas?" + new URLSearchParams(new FormData(event.target)));
    });
  }
  section.classList.remove("is-hidden");
  section.setAttribute("aria-busy", "true");
  I18n.replaceChildren(section);
  const status = document.createElement("p");
  status.setAttribute("role", "status");
  I18n.bind(status, "textContent", () => T("atlas.loading"));
  section.append(status);
  try {
    await loadPrivateAtlasAssets();
    if (request.signal.aborted) return;
    const response = await I18n.fetch(`/api/atlas/page?path=${encodeURIComponent(privateAtlasPath)}`, { credentials: "same-origin", cache: "no-store", signal: request.signal });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || T("atlas.loadError"));
    if (request.signal.aborted || !(currentUser?.canAccessAtlas || currentUser?.canAccessAtlas3D === true) || activePrivateSection !== "atlas") return;
    I18n.bind(section, "innerHTML", () => result.html);
    const controller = window.AtlasPage.mount(section, { navigate: loadPrivateAtlasPage });
    const help = section.querySelector('#atlas-editor') ? null : mountPrivateToolHelp(section, 'atlas', { heading: '.atlas-header' });
    privateAtlasController = { ...controller, destroy() {help?.destroy();controller.destroy();} };
    resetPrivateSectionScroll();
    const heading = section.querySelector("h1");
    heading?.setAttribute("tabindex", "-1");
    heading?.focus({ preventScroll: true });
  } catch (error) {
    if (request.signal.aborted) return;
    I18n.bind(status, "textContent", () => error.message || T("atlas.loadError"));
    status.setAttribute("role", "alert");
  } finally {
    if (!request.signal.aborted) section.removeAttribute("aria-busy");
  }
}

function destroyPrivateAtlas3D(remove = false, options = {}) {
  privateAtlas3DRequest?.abort();
  privateAtlas3DRequest = null;
  privateAtlas3DSelectionRequest?.abort();
  privateAtlas3DSelectionRequest = null;
  if (!options.keepSelection) privateAtlas3DSelection = null;
  if (personSwitchRole === "atlas3d") closePersonSwitchModal({ restoreFocus: false });
  privateAtlas3DController?.destroy();
  privateAtlas3DController = null;
  const section = document.getElementById("private-atlas-3d-section");
  if (remove) section?.remove();else
  if (section) {
    I18n.replaceChildren(section);
    section.classList.add("is-hidden");
    section.removeAttribute("aria-busy");
  }
}

function loadPrivateToolAsset(tag, attributes, ready, signal, message) {
  return new Promise((resolve, reject) => {
    if (signal.aborted) return reject(new DOMException("Aborted", "AbortError"));
    if (ready()) return resolve();
    if (attributes.id) document.getElementById(attributes.id)?.remove();
    const element = Object.assign(document.createElement(tag), attributes);
    let settled = false;
    const finish = (error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      signal.removeEventListener("abort", abort);
      element.onload = element.onerror = null;
      if (error || tag === "script") element.remove();
      if (error) reject(error);else resolve();
    };
    const abort = () => finish(new DOMException("Aborted", "AbortError"));
    const timer = setTimeout(() => finish(new Error(message)), 20000);
    element.onload = () => finish();
    element.onerror = () => finish(new Error(message));
    signal.addEventListener("abort", abort, { once: true });
    document.head.append(element);
  });
}

function showPrivateToolLoadError(section, message, retry) {
  const status = document.createElement("p"),button = document.createElement("button");
  status.setAttribute("role", "alert");
  I18n.bind(status, "textContent", () => message);
  button.type = "button";
  I18n.bind(button, "textContent", () => T("navigation.toolRetry"));
  button.addEventListener("click", () => {button.disabled = true;void retry();}, { once: true });
  I18n.replaceChildren(section, status, button);
}

function withPrivateToolLoadTimeout(load, signal, message) {
  return new Promise((resolve, reject) => {
    const request = new AbortController();
    let settled = false;
    const finish = (error, result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      signal.removeEventListener("abort", abort);
      if (error) {request.abort();reject(error);} else resolve(result);
    };
    const abort = () => finish(new DOMException("Aborted", "AbortError"));
    const timer = setTimeout(() => finish(new Error(message)), 20000);
    if (signal.aborted) return abort();
    signal.addEventListener("abort", abort, { once: true });
    try {Promise.resolve(load(request.signal)).then((result) => finish(null, result), (error) => finish(error));}
    catch (error) {finish(error);}
  });
}

function loadPrivateAtlas3DAssets(signal) {
  const load = (tag, attributes, ready) => loadPrivateToolAsset(tag, attributes, ready, signal, T("atlas.loadError"));
  const style = document.getElementById("private-atlas-3d-styles");
  if (style && !style.sheet) style.remove();
  return Promise.all([
  load("script", { src: "/atlas/assets/explorer-3d.js" }, () => Boolean(window.Atlas3D)),
  load("link", { id: "private-atlas-3d-styles", rel: "stylesheet", href: "/atlas/assets/explorer-3d.css" }, () => Boolean(document.getElementById("private-atlas-3d-styles")?.sheet))]
  );
}

function getPrivateAtlas3DChart(calculation = privateAtlas3DSelection?.ownerId === currentUser?.id ? privateAtlas3DSelection?.calculation : null) {
  if (currentUser?.canAccessAtlas3D !== true || !Array.isArray(calculation?.charts?.tropical?.planets)) return null;
  const views = {};
  for (const [type, labelKey] of [["tropical", "atlas.chart3dLabel"], ["memoria", "atlas.chart3dMemoryLabel"], ["sideral", "atlas.chart3dSiderealLabel"]]) {
    const chart = calculation.charts[type];
    if (!Array.isArray(chart?.planets)) continue;
    const planets = chart.planets.
    filter((planet) => typeof planet.key === "string" && Number.isFinite(planet.longitude) && (
    CHART_PLANET_ORDER.includes(planet.key) || planet.key === "midpoint" || planet.key === "tierra") &&
    isChartPlanetVisible(planet.key)).
    map((planet) => ({ key: planet.key, label: planet.label || planet.key, longitude: (planet.longitude % 360 + 360) % 360,
      ...(Number.isInteger(planet.house) && planet.house >= 1 && planet.house <= 12 ? { house: planet.house } : {}) }));
    const angleLongitude = (point) => Number.isFinite(point?.longitude) ? (point.longitude % 360 + 360) % 360 : null;
    const ascendant = angleLongitude(chart.ascendant);
    const midheaven = angleLongitude(chart.midheaven);
    const descendant = angleLongitude(chart.descendant) ?? (ascendant === null ? null : (ascendant + 180) % 360);
    const imumCoeli = angleLongitude(chart.imumCoeli) ?? (midheaven === null ? null : (midheaven + 180) % 360);
    // Use each calculated chart's actual angles, including the memory Ascendant.
    for (const [key, label, longitude] of [
    ["Ascendant", "Ascendente", ascendant],
    ["Descendant", "Descendente", descendant],
    ["Midheaven", "Medio cielo", midheaven],
    ["ImumCoeli", "Bajo cielo", imumCoeli]])
    {
      if (longitude !== null) planets.push({ key, label, longitude });
    }
    views[type] = { get label() {return T(labelKey);}, type, planets };
  }
  return { ...views.tropical, views };
}

function getPrivateAtlas3DPerson(calculation, person) {
  if (currentUser?.canAccessAtlas3D !== true) return null;
  if (arguments.length === 0) {
    const selection = privateAtlas3DSelection?.ownerId === currentUser.id ? privateAtlas3DSelection : null;
    calculation = selection?.calculation;
    person = selection?.person;
  }
  const profile = calculation?.profile || {};
  if (!person && !profile.name) return null;
  const source = person || {};
  const date = profile.birthDate || (source.year && source.month && source.day ? `${source.year}-${pad(source.month)}-${pad(source.day)}` : "");
  const time = normalizeUniversalClock(profile.birthTime || (source.hour !== undefined && source.minute !== undefined ? `${pad(source.hour)}:${pad(source.minute)}` : "")).slice(0, 5);
  const location = profile.location || {};
  return {
    id: String(source.id || source.personId || profile.personId || ""),
    name: String(source.name || profile.name || ""),
    dateTime: [formatContextDate(date), time].filter(Boolean).join(" · "),
    place: [location.name || source.city, location.countryName || source.countryName || location.country || source.country].filter(Boolean).join(", "),
    universalTime: calculation ? getUniversalTimeDisplay({ ...profile, birthDate: date }) : "",
    weekday: formatWeekdayFromDateText(date)
  };
}

function openPrivateAtlas3DPersonPicker({ trigger } = {}) {
  if (currentUser?.canAccessAtlas3D !== true || activePrivateSection !== "atlas3d" || !privateAtlas3DController) return;
  void openPersonSwitchModal({ role: "atlas3d", trigger });
}

// Only the saved person's identifier is persisted, scoped to the signed-in account.
// Map/chat state is independent; all three exploration tools share this preference.
function getToolPersonId() {
  if (!currentUser?.id) return "";
  try {
    const id = localStorage.getItem(`astroanamnesis.toolPerson:${currentUser.id}`) || "";
    return savedPeople.some((person) => String(person.id) === id) ? id : "";
  } catch {return "";}
}

function rememberToolPerson(id) {
  if (!currentUser?.id) return;
  const selected = savedPeople.find((person) => String(person.id) === String(id));
  try {localStorage.setItem(`astroanamnesis.toolPerson:${currentUser.id}`, selected ? String(selected.id) : "");} catch {}
  window.WorkDashboard?.remember();
}

function getToolWorkspaceState(workspace) {
  if (!currentUser?.id || !["observatory", "timeline"].includes(workspace)) return undefined;
  try {
    const raw = localStorage.getItem(`astroanamnesis.toolWorkspace:${currentUser.id}:${workspace}:v1`);
    if (!raw || raw.length > 4096) return undefined;
    const value = JSON.parse(raw);
    return value?.version === 1 && value.state && typeof value.state === "object" && !Array.isArray(value.state) ? value.state : undefined;
  } catch {return undefined;}
}

function rememberToolWorkspaceState(workspace, state, ownerId) {
  if (!ownerId || currentUser?.id !== ownerId || !["observatory", "timeline"].includes(workspace)) return;
  try {
    // Only view controls are retained; no calculations, names, notes or prompts.
    const safe = workspace === "timeline" ?
    { planet: state.planet, startDate: state.startDate, endDate: state.endDate, orb: state.orb, aspects: state.aspects } :
    { mode: state.mode, sky: { days: state.sky?.days, filters: { rhythm: state.sky?.filters?.rhythm, planet: state.sky?.filters?.planet, aspect: state.sky?.filters?.aspect } }, thread: { planet: state.thread?.planet, map: state.thread?.map, aspects: state.thread?.aspects } };
    const value = JSON.stringify({ version: 1, state: safe });
    if (value.length <= 4096) localStorage.setItem(`astroanamnesis.toolWorkspace:${ownerId}:${workspace}:v1`, value);
  } catch {}
}

function openToolPersonPicker({ trigger } = {}) {
  if (!["observatory", "timeline"].includes(activePrivateSection)) return;
  void openPersonSwitchModal({ role: "tool", trigger });
}

function selectToolPerson(person) {
  const controller = activePrivateSection === "observatory" ? privateObservatoryController :
  activePrivateSection === "timeline" ? privateTimelineController : null;
  if (controller) void controller.selectPerson(person ? String(person.id) : "");
}

async function selectPrivateAtlas3DPerson(person) {
  if (currentUser?.canAccessAtlas3D !== true || activePrivateSection !== "atlas3d" || !privateAtlas3DController) return;
  if (person === null) {
    rememberToolPerson("");
    privateAtlas3DSelectionRequest?.abort();
    privateAtlas3DSelectionRequest = null;
    privateAtlas3DSelection = null;
    privateAtlas3DController.updateChart({ chart: null, person: null, loading: false, error: null });
    return;
  }
  if (!person || !savedPeople.some((item) => String(item.id) === String(person.id))) return;
  rememberToolPerson(person.id);
  privateAtlas3DSelectionRequest?.abort();
  const request = new AbortController();
  privateAtlas3DSelectionRequest = request;
  const ownerId = currentUser.id;
  const controller = privateAtlas3DController;
  privateAtlas3DSelection = { ownerId, person: { ...person }, calculation: null };
  controller.updateChart({ chart: null, person: getPrivateAtlas3DPerson(null, person), loading: true, error: null });
  const isCurrent = () => !request.signal.aborted && privateAtlas3DSelectionRequest === request && currentUser?.canAccessAtlas3D === true && currentUser.id === ownerId && activePrivateSection === "atlas3d" && privateAtlas3DController === controller;
  try {
    const calculation = await calculateBirthCharts(profileFromSavedPerson(person), chartHouseSystemKey, { signal: request.signal });
    if (!isCurrent()) return;
    const chart = getPrivateAtlas3DChart(calculation);
    if (!chart) throw new Error(T("atlas.person3dError"));
    privateAtlas3DSelection = { ownerId, person: { ...person }, calculation };
    controller.updateChart({ chart, person: getPrivateAtlas3DPerson(calculation, person), loading: false, error: null });
  } catch (error) {
    if (!isCurrent()) return;
    controller.updateChart({ chart: null, person: getPrivateAtlas3DPerson(null, person), loading: false, get error() {return error.message || T("atlas.person3dError");} });
  } finally {
    if (privateAtlas3DSelectionRequest === request) privateAtlas3DSelectionRequest = null;
  }
}

function navigateFromPrivateAtlas3D(path) {
  const route = new URL(path, window.location.origin);
  if (route.origin !== window.location.origin || !/^\/private\/atlas(?:\/|$)/.test(route.pathname)) return;
  showPrivateSection("atlas", { atlasPath: route.pathname + route.search, updateRoute: false });
}

async function loadPrivateAtlas3DPage() {
  if (currentUser?.canAccessAtlas3D !== true || activePrivateSection !== "atlas3d") return;
  if (currentUser.isAdmin && !(await window.AdminSecurity?.ensure())) {
    showPrivateSection("admin");
    return;
  }
  if (currentUser?.canAccessAtlas3D !== true || activePrivateSection !== "atlas3d") return;
  if (privateAtlas3DController && !privateAtlas3DController.canLeave()) return;
  destroyPrivateAtlas3D(false, { keepSelection: true });
  const request = new AbortController();
  privateAtlas3DRequest = request;
  const ownerId = currentUser.id;
  let section = document.getElementById("private-atlas-3d-section");
  if (!section) {
    section = document.createElement("section");
    section.id = "private-atlas-3d-section";
    section.className = "private-space-section";
    section.dataset.privateSection = "atlas3d";
    I18n.bind(section, "@aria-label", () => T("atlas.name3d"));
    privateMapsSection.after(section);
  }
  section.classList.remove("is-hidden");
  section.setAttribute("aria-busy", "true");
  const status = document.createElement("p");
  status.setAttribute("role", "status");
  I18n.bind(status, "textContent", () => T("atlas.loading3d"));
  I18n.replaceChildren(section, status);
  try {
    // Fetch the protected fragment before loading its runtime or structural data.
    const { response, result } = await withPrivateToolLoadTimeout(async (signal) => {
      const response = await I18n.fetch("/api/atlas/3d-page", { credentials: "same-origin", cache: "no-store", signal });
      return { response, result: await response.json() };
    }, request.signal, T("atlas.loadError"));
    if (!response.ok) throw new Error(result.error || T("atlas.loadError"));
    if (request.signal.aborted || currentUser?.canAccessAtlas3D !== true || currentUser.id !== ownerId || activePrivateSection !== "atlas3d") return;
    await Promise.all([loadPrivateAtlas3DAssets(request.signal), savedPeople.length ? Promise.resolve() : withPrivateToolLoadTimeout((signal) => loadPeople({ signal, ownerId }), request.signal, T("atlas.loadError"))]);
    if (request.signal.aborted || currentUser?.canAccessAtlas3D !== true || currentUser.id !== ownerId || activePrivateSection !== "atlas3d") return;
    I18n.bind(section, "innerHTML", () => result.html);
    const root = section.querySelector("#atlas-3d-root");
    if (!root || !window.Atlas3D?.mount) throw new Error(T("atlas.loadError"));
    const controller = window.Atlas3D.mount(root, {
      navigate: navigateFromPrivateAtlas3D,
      chart: getPrivateAtlas3DChart(),
      person: getPrivateAtlas3DPerson(),
      onChoosePerson: openPrivateAtlas3DPersonPicker
    });
    const help = mountPrivateToolHelp(root, 'atlas3d', { heading: '.atlas3d-header' });
    privateAtlas3DController = { ...controller, destroy() {help?.destroy();controller.destroy();} };
    const rememberedPerson = savedPeople.find((person) => String(person.id) === getToolPersonId());
    if (rememberedPerson && (!privateAtlas3DSelection?.calculation || String(privateAtlas3DSelection.person?.id) !== String(rememberedPerson.id))) void selectPrivateAtlas3DPerson(rememberedPerson);
    resetPrivateSectionScroll();
    const heading = section.querySelector("h1");
    heading?.setAttribute("tabindex", "-1");
    heading?.focus({ preventScroll: true });
  } catch (error) {
    if (request.signal.aborted) return;
    privateAtlas3DController?.destroy();
    privateAtlas3DController = null;
    showPrivateToolLoadError(section, error.message || T("atlas.loadError"), loadPrivateAtlas3DPage);
  } finally {
    if (!request.signal.aborted) section.removeAttribute("aria-busy");
  }
}

function syncObservatoryNavigation() {
  const link = document.getElementById("private-observatory-link");
  const allowed = currentUser?.canAccessObservatory === true && hasConfirmedSubscription();
  if (link) {
    link.classList.toggle("is-subscription-locked", !allowed);
    link.setAttribute("aria-disabled", allowed ? "false" : "true");
    I18n.bind(link, "title", () => allowed ? "" : T("observatory.subscriptionRequired"));
  }
  if (!allowed) {
    destroyPrivateObservatory(true);
    if (activePrivateSection === "observatory") showPrivateSection("list", { replaceRoute: true });
  }
}

function destroyPrivateObservatory(remove = false) {
  if (personSwitchRole === "tool") closePersonSwitchModal({ restoreFocus: false });
  privateObservatoryRequest?.abort();
  privateObservatoryRequest = null;
  privateObservatoryCalculationRequest?.abort();
  privateObservatoryCalculationRequest = null;
  privateObservatoryController?.destroy();
  privateObservatoryController = null;
  const section = document.getElementById("private-observatory-section");
  if (remove) section?.remove();else
  if (section) {I18n.replaceChildren(section);section.classList.add("is-hidden");}
}

function getObservatoryCalculation(calculation) {
  const charts = {};
  for (const type of ["tropical", "memoria", "sideral"]) {
    const chart = calculation?.charts?.[type];
    if (!chart) continue;
    const houses = chartDisplayHouses(chart);
    const aspectPoints = Object.fromEntries(CHART_ANGLE_POINT_KEYS.filter(isChartPlanetVisible).
    map((key) => [key, chartAngleAspectPoint(chart, key)]).filter(([, point]) => point));
    const aspects = chartPanelAspects(chart).map((aspect) => ({ ...aspect, color: chartAspectColorForAngle(aspect.angle) }));
    charts[type] = { ...chart, houses, aspectPoints, aspects, planets: (chart.planets || []).
      filter((planet) => isChartPlanetVisible(planet.key)).
      map((planet) => ({ ...planet, house: houses.length ?
        chartPlanetHouseForInteraction(planet, houses, type === "memoria") : null })) };
  }
  return { charts };
}

async function loadPrivateObservatoryPage() {
  if (!(currentUser?.canAccessObservatory === true && hasConfirmedSubscription()) || activePrivateSection !== "observatory") return;
  destroyPrivateObservatory();
  const request = new AbortController(),ownerId = currentUser.id;
  privateObservatoryRequest = request;
  const isCurrent = () => !request.signal.aborted && currentUser?.id === ownerId &&
  currentUser?.canAccessObservatory === true && hasConfirmedSubscription() && activePrivateSection === "observatory";
  let section = document.getElementById("private-observatory-section");
  if (!section) {
    section = document.createElement("section");
    section.id = "private-observatory-section";
    section.dataset.privateSection = "observatory";
    section.className = "private-space-section";
    privateMapsSection.after(section);
  }
  section.classList.remove("is-hidden");
  section.setAttribute("aria-busy", "true");
  I18n.bind(section, "textContent", () => T("observatory.loading"));
  function asset(tag, attributes, ready) {
    return loadPrivateToolAsset(tag, attributes, ready, request.signal, T("observatory.loadError"));
  }
  try {
    if (currentUser?.isAdmin && !(await window.AdminSecurity.ensure())) throw new Error(T("observatory.loadError"));
    if (!isCurrent()) return;
    await Promise.all([
    asset("script", { src: "/observatory/observatory.js?v=c591279febfa" }, () => Boolean(window.Observatory)),
    asset("link", { id: "observatory-style", rel: "stylesheet", href: "/observatory/observatory.css?v=c591279febfa" }, () => Boolean(document.getElementById("observatory-style")?.sheet)),
    savedPeople.length ? Promise.resolve() : withPrivateToolLoadTimeout((signal) => loadPeople({ signal, ownerId }), request.signal, T("observatory.loadError"))]
    );
    if (!isCurrent()) return;
    I18n.replaceChildren(section);const root = document.createElement("div");section.append(root);
    privateObservatoryController = window.Observatory.mount(root, {
      language: document.documentElement.lang,
      initialNotebook: privateNotebookTarget?.ownerId === ownerId ? privateNotebookTarget : undefined,
      initialPersonId: getToolPersonId(),
      initialState: getToolWorkspaceState("observatory"),
      onStateChange: (state) => {if (isCurrent()) rememberToolWorkspaceState("observatory", state, ownerId);},
      onPersonChange: rememberToolPerson,
      onChoosePerson: openToolPersonPicker,
      people: savedPeople.map((person) => ({ id: person.id, name: person.name, dateTime: formatPersonDate(person), place: person.city })), get
      loadLunations() {return currentUser.canAccessTimeline ? async (input, signal) => {if (!isCurrent()) throw new DOMException("Aborted", "AbortError");let response;for (let attempt = 0; attempt < 3; attempt++) {response = await I18n.fetch("/api/timeline/lunations", { method: "POST", credentials: "same-origin", cache: "no-store", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...input, houseSystem: chartHouseSystemKey }), signal });if (response.status !== 429 || attempt === 2) break;await new Promise((resolve, reject) => {const abort = () => {clearTimeout(timer);reject(new DOMException("Aborted", "AbortError"));};const timer = setTimeout(() => {signal.removeEventListener("abort", abort);resolve();}, 1000);if (signal.aborted) abort();else signal.addEventListener("abort", abort, { once: true });});}const result = await response.json();if (!isCurrent()) throw new DOMException("Aborted", "AbortError");if (!response.ok) throw new Error(result.error || T("timeline.error"));return result;} : undefined;}, get










      loadSky() {return currentUser.canAccessTimeline ? async (input, signal) => {if (!isCurrent()) throw new DOMException("Aborted", "AbortError");const response = await I18n.fetch(input.month ? "/api/timeline/month" : "/api/timeline/sky", { method: "POST", credentials: "same-origin", cache: "no-store", headers: { "Content-Type": "application/json" }, body: JSON.stringify(input), signal });const result = await response.json();if (!isCurrent()) throw new DOMException("Aborted", "AbortError");if (!response.ok) throw new Error(result.error || T("timeline.error"));return result;} : undefined;},





      openJourney(input) {
        if (!isCurrent() || !currentUser.canAccessTimeline) return;
        privateTimelineSelection = { ...input, ownerId };showPrivateSection("timeline");
      },
      onCancel() {privateObservatoryCalculationRequest?.abort();privateObservatoryCalculationRequest = null;},
      async onSelectPerson(id) {
        if (!isCurrent()) throw new DOMException("Aborted", "AbortError");
        const person = savedPeople.find((p) => String(p.id) === String(id));
        if (!person) throw new Error(T("observatory.personError"));
        privateObservatoryCalculationRequest?.abort();
        const calculationRequest = new AbortController();privateObservatoryCalculationRequest = calculationRequest;
        request.signal.addEventListener("abort", () => calculationRequest.abort(), { once: true });
        const calculation = await calculateBirthCharts(profileFromSavedPerson(person), chartHouseSystemKey, { signal: calculationRequest.signal });
        if (!isCurrent() || calculationRequest.signal.aborted) throw new DOMException("Aborted", "AbortError");
        return getObservatoryCalculation(calculation);
      }
    });
    if (privateNotebookTarget?.ownerId === ownerId) privateNotebookTarget = null;
    resetPrivateSectionScroll();
  } catch (error) {
    if (request.signal.aborted) return;
    showPrivateToolLoadError(section, error.message || T("observatory.loadError"), loadPrivateObservatoryPage);
  } finally {if (isCurrent()) section.removeAttribute("aria-busy");}
}

function syncTimelineNavigation() {
  const link = document.getElementById("private-timeline-link");
  const allowed = currentUser?.canAccessTimeline === true && hasConfirmedSubscription();
  if (link) {
    link.classList.toggle("is-subscription-locked", !allowed);
    link.setAttribute("aria-disabled", allowed ? "false" : "true");
    I18n.bind(link, "title", () => allowed ? "" : T("timeline.subscriptionRequired"));
  }
  if (!allowed) {
    privateTimelineSelection = null;
    destroyPrivateTimeline(true);
    if (activePrivateSection === "timeline") showPrivateSection("list", { replaceRoute: true });
  }
}

function destroyPrivateTimeline(remove = false) {
  if (personSwitchRole === "tool") closePersonSwitchModal({ restoreFocus: false });
  privateTimelineRequest?.abort();privateTimelineRequest = null;
  privateTimelineController?.destroy();privateTimelineController = null;
  const section = document.getElementById("private-timeline-section");
  if (remove) section?.remove();else if (section) {I18n.replaceChildren(section);section.classList.add("is-hidden");}
}

async function loadPrivateTimelinePage() {
  if (!(currentUser?.canAccessTimeline === true && hasConfirmedSubscription()) || activePrivateSection !== "timeline") return;
  destroyPrivateTimeline();const request = new AbortController(),ownerId = currentUser.id;privateTimelineRequest = request;
  const initialSelection = privateTimelineSelection?.ownerId === ownerId ? privateTimelineSelection : null;privateTimelineSelection = null;
  const isCurrent = () => !request.signal.aborted && currentUser?.id === ownerId && currentUser?.canAccessTimeline === true && hasConfirmedSubscription() && activePrivateSection === "timeline";
  let section = document.getElementById("private-timeline-section");
  if (!section) {section = document.createElement("section");section.id = "private-timeline-section";section.className = "private-space-section";section.dataset.privateSection = "timeline";privateMapsSection.after(section);}
  section.classList.remove("is-hidden");section.setAttribute("aria-busy", "true");I18n.bind(section, "textContent", () => T("timeline.loading"));
  function asset(tag, attributes, ready) {
    return loadPrivateToolAsset(tag, attributes, ready, request.signal, T("timeline.error"));
  }
  try {
    if (currentUser.isAdmin && !(await window.AdminSecurity.ensure())) throw new Error(T("timeline.error"));
    if (!isCurrent()) return;
    await Promise.all([
    asset("script", { src: "/timeline/timeline.js?v=34bdfdbf3e7c" }, () => Boolean(window.PersonalTimeline)),
    asset("link", { id: "personal-timeline-style", rel: "stylesheet", href: "/timeline/timeline.css?v=34bdfdbf3e7c" }, () => Boolean(document.getElementById("personal-timeline-style")?.sheet)),
    savedPeople.length ? Promise.resolve() : withPrivateToolLoadTimeout((signal) => loadPeople({ signal, ownerId }), request.signal, T("timeline.error"))]
    );
    if (!isCurrent()) return;
    I18n.replaceChildren(section);const root = document.createElement("div");section.append(root);
    privateTimelineController = window.PersonalTimeline.mount(root, {
      language: document.documentElement.lang,
      initialPersonId: initialSelection?.personId || getToolPersonId(),
      initialState: getToolWorkspaceState("timeline"),
      onStateChange: (state) => {if (isCurrent()) rememberToolWorkspaceState("timeline", state, ownerId);},
      onPersonChange: rememberToolPerson,
      onChoosePerson: openToolPersonPicker,
      people: savedPeople.map((p) => ({ id: p.id, name: p.name, dateTime: formatPersonDate(p), place: p.city, birthDate: p.birthDate, timeZone: p.tz })),
      async onCalculate(input, signal) {
        if (!isCurrent()) throw new DOMException("Aborted", "AbortError");
        const response = await I18n.fetch("/api/timeline/calculate", { method: "POST", credentials: "same-origin", cache: "no-store", headers: { "Content-Type": "application/json" }, body: JSON.stringify(input), signal });
        const result = await response.json();
        if (!isCurrent()) throw new DOMException("Aborted", "AbortError");
        if (!response.ok) throw new Error(result.error || T("timeline.error"));return result;
      }
    });if (initialSelection) void privateTimelineController.openJourney(initialSelection);resetPrivateSectionScroll();
  } catch (error) {if (request.signal.aborted) return;showPrivateToolLoadError(section, error.message || T("timeline.error"), loadPrivateTimelinePage);} finally
  {if (isCurrent()) section.removeAttribute("aria-busy");}
}

function showPrivateSection(section = "list", options = {}) {
  hideTrainingBanner();
  if (activePrivateSection === "atlas" && section !== "atlas" && privateAtlasController && !privateAtlasController.canLeave()) return;
  if (activePrivateSection === "atlas3d" && section !== "atlas3d" && privateAtlas3DController && !privateAtlas3DController.canLeave()) return;
  closePrivateAccountMenu();
  let normalized = ["space", "list", "maps", "atlas", "atlas3d", "observatory", "timeline", "tools", "training", "sessions", "plans", "reports", "store", "prognosis", "transits", "admin"].includes(section) ? section : "list";
  if (normalized === "timeline" && !(currentUser?.canAccessTimeline === true && hasConfirmedSubscription())) {
    setPrivateStatus(() => T("timeline.subscriptionRequired"), true);
    return;
  }
  if (normalized === "observatory" && !(currentUser?.canAccessObservatory === true && hasConfirmedSubscription())) {
    setPrivateStatus(() => T("observatory.subscriptionRequired"), true);
    return;
  }
  if (normalized === "atlas" && !(currentUser?.canAccessAtlas || currentUser?.canAccessAtlas3D === true)) normalized = "list";
  if (normalized === "atlas3d" && !(currentUser?.canAccessAtlas3D === true && hasConfirmedSubscription())) {
    setPrivateStatus(() => T("atlas.subscriptionRequired"), true);
    return;
  }
  if (normalized === "admin" && !currentUser?.isAdmin) {
    setPrivateStatus(() => T("interface.no_tienes_permisos_de_administracion"), true);
    normalized = "list";
  }
  if (["tools", "transits"].includes(normalized) && !hasConfirmedSubscription()) {
    setPrivateStatus(() => T("interface.las_herramientas_astrologicas_estan_disponibles_con_una_suscripcion_activa"), true);
    normalized = "list";
  }
  const sectionModuleKey = PRIVATE_SECTION_MODULE_MAP[normalized];
  if (sectionModuleKey && !isModuleEnabled(sectionModuleKey)) {
    setPrivateStatus(() => T("interface.este_apartado_esta_oculto_temporalmente_puedes_activarlo_desde_el_panel_de_administra"));
    normalized = "list";
  }
  if (normalized === "tools") {
    const routeTargetsTools = isPrivateRoutePath(I18n.routePath()) &&
    getPrivateSectionFromRoute(I18n.routePath()) === "tools";
    activePrivateToolsView = options.toolsView === "natal" ?
    "natal" :
    options.toolsView === "transits" ?
    "transits" :
    routeTargetsTools ?
    getPrivateToolsViewFromRoute(I18n.routePath()) :
    activePrivateToolsView;
    privateToolsMenuExpanded = true;
  }
  if (["atlas", "atlas3d", "observatory", "timeline", "transits"].includes(normalized)) privateToolsMenuExpanded = true;
  if (normalized === "training") {
    const routeTargetsTraining = isPrivateRoutePath(I18n.routePath()) &&
    getPrivateSectionFromRoute(I18n.routePath()) === "training";
    activePrivateTrainingView = Object.hasOwn(PRIVATE_TRAINING_VIEW_ROUTES, options.trainingView) ?
    options.trainingView :
    routeTargetsTraining ?
    getPrivateTrainingViewFromRoute(I18n.routePath()) :
    activePrivateTrainingView;
  }
  const previousSection = activePrivateSection;
  activePrivateSection = normalized;
  if (["maps", "observatory", "timeline"].includes(normalized) && !privateSidebarCollapsed && localStorage.getItem("privateSidebarPinned") !== "true") {
    privateSidebarCollapsed = true;
    applyPrivateSidebarState();
  }
  if (normalized !== "list") closePersonForm();
  if (options.updateRoute !== false && !(normalized === "atlas" && getPrivateSectionFromRoute() === "atlas")) {
    updatePrivateSectionRoute(normalized, {
      replace: Boolean(options.replaceRoute),
      toolsView: activePrivateToolsView,
      trainingView: activePrivateTrainingView
    });
  }

  privateSpaceTabs.forEach((button) => {
    const active = button.dataset.privateSectionTab === normalized;
    button.classList.toggle("active", active);
    if (active) {
      button.setAttribute("aria-current", "page");
    } else {
      button.removeAttribute("aria-current");
    }
  });
  if (normalized !== "tools") {privateToolsSection?._toolHelp?.destroy();if (privateToolsSection) privateToolsSection._toolHelp = null;}
  syncPrivateToolsNavigationState(normalized);
  const observatoryNav = document.getElementById("private-observatory-link");
  observatoryNav?.classList.toggle("active", normalized === "observatory");
  if (normalized === "observatory") observatoryNav?.setAttribute("aria-current", "page");else observatoryNav?.removeAttribute("aria-current");
  if (normalized !== "observatory") destroyPrivateObservatory();
  const timelineNav = document.getElementById("private-timeline-link");
  timelineNav?.classList.toggle("active", normalized === "timeline");
  if (normalized === "timeline") timelineNav?.setAttribute("aria-current", "page");else timelineNav?.removeAttribute("aria-current");
  if (normalized !== "timeline") destroyPrivateTimeline();
  const atlasNav = document.getElementById("private-atlas-link");
  atlasNav?.classList.toggle("active", normalized === "atlas");
  if (normalized === "atlas") atlasNav?.setAttribute("aria-current", "page");else
  atlasNav?.removeAttribute("aria-current");
  const atlas3DNav = document.getElementById("private-atlas-3d-link");
  atlas3DNav?.classList.toggle("active", normalized === "atlas3d");
  if (normalized === "atlas3d") atlas3DNav?.setAttribute("aria-current", "page");else
  atlas3DNav?.removeAttribute("aria-current");
  if (normalized !== "atlas3d") destroyPrivateAtlas3D();
  document.getElementById("private-atlas-section")?.classList.toggle("is-hidden", normalized !== "atlas");
  if (normalized !== "atlas") {
    privateAtlasRequest?.abort();
    privateAtlasController?.destroy();
    privateAtlasController = null;
  }
  syncPrivateTrainingNavigationState(normalized);
  updatePrivateQuickNavState(normalized);

  if (previousSection !== normalized) setBillingStatus("");
  privateScreen?.classList.toggle("private-maps-active", normalized === "maps");
  privateDashboardSection?.classList.toggle("is-hidden", normalized !== "space");
  window.WorkDashboard?.remember({ explicit: previousSection !== normalized });
  window.WorkDashboard?.sync();
  privateListSection?.classList.toggle("is-hidden", normalized !== "list");
  privateMapsSection?.classList.toggle("is-hidden", normalized !== "maps");
  privateToolsSection?.classList.toggle("is-hidden", normalized !== "tools");
  privateTrainingSection?.classList.toggle("is-hidden", normalized !== "training");
  privateSessionsSection?.classList.toggle("is-hidden", normalized !== "sessions");
  privatePrognosisSection?.classList.toggle("is-hidden", normalized !== "prognosis");
  privateTransitsSection?.classList.toggle("is-hidden", normalized !== "transits");
  privateAdminSection?.classList.toggle("is-hidden", normalized !== "admin");
  billingPanel?.classList.toggle("is-hidden", !["plans", "reports", "store"].includes(normalized) || !currentUser);
  privateMapContext?.classList.toggle("is-hidden", normalized !== "maps");
  syncPrivateMapContextPlacement();
  renderBillingUI();
  updatePrivateMapOffer();

  if (previousSection !== normalized) {
    resetPrivateSectionScroll();
  }

  if (normalized === "maps") {
    preparePrivateMapsSection().catch((error) => {
      setPrivateStatus(() => error.message || T("interface.no_se_pudieron_preparar_los_mapas"), true);
    });
  }

  if (normalized === "tools") {
    preparePrivateToolsSection().catch((error) => {
      setPrivateStatus(() => error.message || T("interface.no_se_pudieron_preparar_las_herramientas"), true);
    });
  }

  if (normalized === "atlas") void loadPrivateAtlasPage(options.atlasPath || I18n.routePath() + window.location.search);
  if (normalized === "atlas3d") void loadPrivateAtlas3DPage();
  if (normalized === "observatory") void loadPrivateObservatoryPage();
  if (normalized === "timeline") void loadPrivateTimelinePage();

  if (normalized === "training") {
    prepareTrainingSection(activePrivateTrainingView).catch((error) => {
      setTrainingStatus(() => error.message || T("interface.no_se_pudo_cargar_la_formacion"), true);
    });
  }

  if (normalized === "transits") {
    preparePrivateTransitsSection().catch((error) => {
      setPrivateTransitStatus(() => error.message || T("interface.no_se_pudieron_preparar_los_transitos"), true);
    });
  }

  if (normalized === "admin" && currentUser?.isAdmin) {
    showAdminTab(activeAdminTab);
    loadAdminPanel(activeAdminTab).catch((error) => {
      setAdminStatus(() => error.message || T("interface.no_se_pudo_cargar_el_panel"), true);
    });
  }

  if (["plans", "reports", "store"].includes(normalized) && currentUser && !billingSummary) {
    loadBillingSummary({ silent: true }).
    catch(() => setBillingStatus(() => T("interface.no_se_pudo_cargar_esta_seccion_ahora"), true));
  }
}

function resetPrivateSectionScroll() {
  if (privatePanel) {
    privatePanel.scrollTop = 0;
    privatePanel.scrollLeft = 0;
  }

  if (!privateSidebarMobileQuery.matches) return;
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
}

const ASPECT_FINDER_NAMES = {
  0: "Conjunción",
  60: "Sextil",
  72: "Quintil",
  90: "Cuadratura",
  120: "Trígono",
  150: "Quincuncio",
  180: "Oposición"
};

async function prepareAspectFinderSection() {
  if (!aspectFinderForm) return;
  syncAspectFinderPlanetSelectsAppearance();
  syncAspectFinderAspectSelectAppearance(aspectFinderAngle);
  await countriesPromise?.catch(() => null);
  if (aspectFinderCountry && aspectFinderCountry.options.length <= 1 && countriesCache.length) {
    populateCountryOptions(aspectFinderCountry, countriesCache, "Selecciona país");
  }
  if (aspectFinderInitialized) return;

  const activePlace = aspectMomentActivePlace();
  if (activePlace?.id && activePlace?.country && activePlace?.tz) {
    aspectFinderSelectedPlace = activePlace;
    if (aspectFinderCountry) aspectFinderCountry.value = activePlace.country;
    if (aspectFinderCity) {
      aspectFinderCity.disabled = false;
      aspectFinderCity.value = activePlace.name || "";
      I18n.bind(aspectFinderCity, "placeholder", () => T("interface.buscar_ciudad"));
    }
    setAspectFinderLocationStatus(aspectFinderLocationLabel(activePlace));
  } else {
    setAspectFinderLocationStatus(() => T("interface.selecciona_un_pais_y_una_ciudad_para_continuar"), true);
  }
  initializeAspectFinderDateControls(aspectFinderDate, aspectFinderTime, null, activePlace?.tz);
  aspectFinderInitialized = true;
}

function aspectFinderLocationLabel(place = aspectFinderSelectedPlace) {
  if (!place) return "";
  const locationName = [place.name, place.countryName || place.country].filter(Boolean).join(", ");
  return `${locationName || T("interface.ciudad_seleccionada")} · ${place.tz || T("interface.zona_horaria_no_disponible")}`;
}

function setAspectFinderLocationStatus(message = "", isError = false) {
  if (!aspectFinderLocationStatus) return;
  I18n.bind(aspectFinderLocationStatus, "textContent", () => message);
  aspectFinderLocationStatus.classList.toggle("error", Boolean(isError));
}

async function searchAspectFinderCities() {
  const country = clean(aspectFinderCountry?.value);
  const query = clean(aspectFinderCity?.value);
  if (!aspectFinderCityResults) return;
  I18n.clear(aspectFinderCityResults, "innerHTML");
  if (!country || query.length < 2) return;

  try {
    const params = new URLSearchParams({ country, q: query });
    const response = await I18n.fetch(`/api/locations/cities?${params}`);
    if (!response.ok) throw new Error(T("interface.no_se_pudieron_cargar_las_ciudades"));
    const cities = await response.json();
    const matches = (Array.isArray(cities) ? cities : []).slice(0, 8);
    I18n.bind(aspectFinderCityResults, "innerHTML", () => matches.length ? matches.map((city) => `
        <button type="button" data-place-id="${escapeHtml(city.id)}" data-place-name="${escapeHtml(city.name)}" data-place-lat="${escapeHtml(city.lat)}" data-place-lon="${escapeHtml(city.lon)}" data-place-tz="${escapeHtml(city.tz || "")}">
          <strong>${escapeHtml(city.name)}</strong><span>${escapeHtml(city.tz || "")}</span>
        </button>
      `).join("") : `<span class="aspect-finder-city-empty">${T("interface.no_se_encontraron_ciudades")}</span>`);



    aspectFinderCityResults.querySelectorAll("button[data-place-id]").forEach((button) => {
      button.addEventListener("click", () => selectAspectFinderCity(button));
    });
  } catch (error) {
    I18n.bind(aspectFinderCityResults, "innerHTML", () => `<span class="aspect-finder-city-empty">${escapeHtml(error.message || T("interface.no_se_pudieron_cargar_las_ciudades"))}</span>`);
  }
}

function selectAspectFinderCity(button) {
  const countryOption = aspectFinderCountry?.selectedOptions?.[0];
  aspectFinderSelectedPlace = {
    id: button.dataset.placeId || "",
    name: button.dataset.placeName || "",
    country: aspectFinderCountry?.value || "",
    countryName: countryOption?.textContent?.trim() || aspectFinderCountry?.value || "",
    lat: Number(button.dataset.placeLat),
    lon: Number(button.dataset.placeLon),
    tz: button.dataset.placeTz || ""
  };
  if (aspectFinderCity) aspectFinderCity.value = aspectFinderSelectedPlace.name;
  if (aspectFinderCityResults) I18n.clear(aspectFinderCityResults, "innerHTML");
  setAspectFinderLocationStatus(aspectFinderLocationLabel(aspectFinderSelectedPlace));
}

function initializeAspectFinderDateControls(dateInput, timeInput, timezoneSelect, preferredTimeZone = "") {
  const now = new Date();
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Madrid";
  let initialDate = localDateInputValue(now);
  let initialTime = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  if (preferredTimeZone) {
    try {
      const activeLocal = dateTimeInputPartsForZone(now, preferredTimeZone);
      initialDate = activeLocal.date;
      initialTime = activeLocal.time;
    } catch {

      // Keep the browser-local fallback if the saved time zone is invalid.
    }}
  if (dateInput) dateInput.value = dateInput.value || initialDate;
  if (timeInput) timeInput.value = timeInput.value || initialTime;
  if (timezoneSelect && !Array.from(timezoneSelect.options).some((option) => option.value === browserTimeZone)) {
    timezoneSelect.add(new Option(browserTimeZone, browserTimeZone));
  }
  if (timezoneSelect) timezoneSelect.value = browserTimeZone;
}

async function preparePrivateToolsSection() {
  await showPrivateToolsView(activePrivateToolsView, { updateRoute: false });
}

async function showPrivateToolsView(view = "transits", options = {}) {
  if (!hasConfirmedSubscription()) {
    showPrivateSection("list");
    return;
  }
  const normalized = view === "natal" ? "natal" : "transits";
  const workspaceOwnerId = currentUser?.id;
  activePrivateToolsView = normalized;
  const meta = PRIVATE_TOOLS_VIEW_META[normalized];
  if (privateToolsEyebrow) I18n.bind(privateToolsEyebrow, "textContent", () => Object.freeze({ get transits() {return { get eyebrow() {return T("interface.herramientas_aspectos");}, get title() {return T("navigation.aspectFinder");}, get subtitle() {return T("interface.localiza_el_proximo_aspecto_exacto_entre_dos_planetas_en_transito");} };}, get natal() {return { get eyebrow() {return T("interface.herramientas_carta_natal");}, get title() {return T("navigation.natalTransitFinder");}, get subtitle() {return T("interface.localiza_el_proximo_transito_exacto_sobre_una_posicion_de_la_carta_tropical_natal_de_");} };} })[normalized].eyebrow);
  if (privateToolsTitle) I18n.bind(privateToolsTitle, "textContent", () => Object.freeze({ get transits() {return { get eyebrow() {return T("interface.herramientas_aspectos");}, get title() {return T("navigation.aspectFinder");}, get subtitle() {return T("interface.localiza_el_proximo_aspecto_exacto_entre_dos_planetas_en_transito");} };}, get natal() {return { get eyebrow() {return T("interface.herramientas_carta_natal");}, get title() {return T("navigation.natalTransitFinder");}, get subtitle() {return T("interface.localiza_el_proximo_transito_exacto_sobre_una_posicion_de_la_carta_tropical_natal_de_");} };} })[normalized].title);
  if (privateToolsSubtitle) I18n.bind(privateToolsSubtitle, "textContent", () => Object.freeze({ get transits() {return { get eyebrow() {return T("interface.herramientas_aspectos");}, get title() {return T("navigation.aspectFinder");}, get subtitle() {return T("interface.localiza_el_proximo_aspecto_exacto_entre_dos_planetas_en_transito");} };}, get natal() {return { get eyebrow() {return T("interface.herramientas_carta_natal");}, get title() {return T("navigation.natalTransitFinder");}, get subtitle() {return T("interface.localiza_el_proximo_transito_exacto_sobre_una_posicion_de_la_carta_tropical_natal_de_");} };} })[normalized].subtitle);
  privateToolsSection?.setAttribute("aria-label", meta.title);
  privateToolsViewPanels.forEach((panel) => {
    panel.classList.toggle("is-hidden", panel.dataset.toolsViewPanel !== normalized);
  });
  syncPrivateSearchHelp(normalized);
  syncPrivateToolsNavigationState("tools");
  if (options.updateRoute !== false && activePrivateSection === "tools") {
    updatePrivateSectionRoute("tools", {
      replace: Boolean(options.replaceRoute),
      toolsView: normalized
    });
  }

  if (normalized === "natal") {
    await prepareNatalAspectFinderSection();
  } else {
    await prepareAspectFinderSection();
  }
  if (currentUser?.id === workspaceOwnerId && activePrivateSection === "tools" && activePrivateToolsView === normalized) window.WorkDashboard?.remember();
}

async function prepareNatalAspectFinderSection() {
  if (!natalAspectFinderForm) return;
  syncAspectFinderPlanetSelectAppearance(natalAspectFinderTransitPlanet);
  syncAspectFinderPlanetSelectAppearance(natalAspectFinderNatalPlanet);
  syncAspectFinderAspectSelectAppearance(natalAspectFinderAngle);
  await countriesPromise?.catch(() => null);
  if (natalAspectFinderCountry && natalAspectFinderCountry.options.length <= 1 && countriesCache.length) {
    populateCountryOptions(natalAspectFinderCountry, countriesCache, "Selecciona país");
  }
  if (!savedPeople.length) await loadPeople();
  renderNatalAspectFinderPeopleOptions();
  if (!natalAspectFinderInitialized) {
    const defaultPlace = setNatalAspectFinderDefaultPlaceForPerson();
    initializeAspectFinderDateControls(natalAspectFinderDate, natalAspectFinderTime, null, defaultPlace?.tz);
    natalAspectFinderInitialized = true;
  }
  syncNatalAspectFinderBirthLimits();
}

function renderNatalAspectFinderPeopleOptions() {
  if (!natalAspectFinderPerson) return;
  const previousValue = natalAspectFinderPerson.value;
  const preferredId = previousValue || activePersonId || birthProfile?.personId || savedPeople[0]?.id || "";
  const options = savedPeople.map((person) => `
    <option value="${escapeHtml(person.id)}">${escapeHtml(person.name)} · ${escapeHtml(formatPersonDate(person))}</option>
  `);
  I18n.bind(natalAspectFinderPerson, "innerHTML", ((__i18nSnapshot0) => () => [`<option value="">${__i18nSnapshot0.length ? T("interface.selecciona_una_persona") : T("interface.no_hay_cartas_guardadas")}</option>`, ...options].join(""))(savedPeople));



  natalAspectFinderPerson.value = savedPeople.some((person) => String(person.id) === String(preferredId)) ?
  String(preferredId) :
  "";
  natalAspectFinderPerson.disabled = savedPeople.length === 0;
  syncNatalAspectFinderBirthLimits();
  if (natalAspectFinderPersonPicker) {
    I18n.bind(natalAspectFinderPersonPicker, "textContent", () => natalAspectFinderPerson.selectedOptions[0]?.textContent.trim() || T("interface.selecciona_una_persona"));
    natalAspectFinderPersonPicker.disabled = savedPeople.length === 0;
  }
  if (!savedPeople.length) {
    setNatalAspectFinderStatus(() => T("interface.primero_guarda_una_persona_en_mi_lista_para_utilizar_su_carta_natal"), true);
  } else if (natalAspectFinderStatus?.classList.contains("error")) {
    setNatalAspectFinderStatus("");
  }
}

function natalAspectFinderPersonPlace(personId = natalAspectFinderPerson?.value) {
  const person = savedPeople.find((item) => String(item.id) === String(personId));
  const placeId = person?.placeId || person?.place_id || "";
  if (!person || !placeId) return null;
  return {
    id: String(placeId),
    name: person.city || "Ciudad natal",
    country: person.country || "",
    countryName: person.countryName || "",
    lat: Number(person.lat),
    lon: Number(person.lon),
    tz: person.tz || person.timezone || ""
  };
}

function syncNatalAspectFinderBirthLimits() {
  if (!natalAspectFinderDate || !natalAspectFinderTime) return false;
  const person = savedPeople.find((item) => String(item.id) === String(natalAspectFinderPerson?.value));
  const birthDate = person?.birthDate || "";
  const birthTime = (person?.birthTime || "").slice(0, 5);
  // Civil date/time limits are valid only in the natal zone. Other reference
  // zones are compared authoritatively in UTC on the server, not guessed here.
  const sameZone = Boolean(person?.tz && person.tz === natalAspectFinderSelectedPlace?.tz);
  const hasBirth = sameZone && /^\d{4}-\d{2}-\d{2}$/.test(birthDate) && /^\d{2}:\d{2}$/.test(birthTime);
  if (hasBirth) natalAspectFinderDate.min = birthDate;else
  natalAspectFinderDate.removeAttribute("min");
  if (hasBirth && natalAspectFinderDate.value === birthDate) natalAspectFinderTime.min = birthTime;else
  natalAspectFinderTime.removeAttribute("min");
  const dateBeforeBirth = hasBirth && natalAspectFinderDate.value && natalAspectFinderDate.value < birthDate;
  const timeBeforeBirth = hasBirth && natalAspectFinderDate.value === birthDate && natalAspectFinderTime.value && natalAspectFinderTime.value < birthTime;
  const message = I18n.label("La fecha y hora de inicio no pueden ser anteriores al nacimiento.");
  I18n.validity(natalAspectFinderDate, () => dateBeforeBirth ? message : "");
  I18n.validity(natalAspectFinderTime, () => timeBeforeBirth ? message : "");
  return Boolean(dateBeforeBirth || timeBeforeBirth);
}

function setNatalAspectFinderDefaultPlaceForPerson() {
  const place = natalAspectFinderPersonPlace();
  natalAspectFinderSelectedPlace = place;
  if (natalAspectFinderCountry) natalAspectFinderCountry.value = place?.country || "";
  if (natalAspectFinderCity) {
    natalAspectFinderCity.value = place?.name || "";
    natalAspectFinderCity.disabled = !place?.country;
    I18n.bind(natalAspectFinderCity, "placeholder", () => place?.country ? T("interface.buscar_ciudad") : T("interface.selecciona_primero_un_pais"));
  }
  if (natalAspectFinderCityResults) I18n.clear(natalAspectFinderCityResults, "innerHTML");
  if (place?.id && place?.tz) {
    setNatalAspectFinderLocationStatus(aspectFinderLocationLabel(place));
  } else {
    setNatalAspectFinderLocationStatus(() => T("interface.selecciona_un_pais_y_una_ciudad_para_continuar"), true);
  }
  syncNatalAspectFinderBirthLimits();
  return place;
}

function setNatalAspectFinderLocationStatus(message = "", isError = false) {
  if (!natalAspectFinderLocationStatus) return;
  I18n.bind(natalAspectFinderLocationStatus, "textContent", () => message);
  natalAspectFinderLocationStatus.classList.toggle("error", Boolean(isError));
}

async function searchNatalAspectFinderCities() {
  const country = clean(natalAspectFinderCountry?.value);
  const query = clean(natalAspectFinderCity?.value);
  if (!natalAspectFinderCityResults) return;
  I18n.clear(natalAspectFinderCityResults, "innerHTML");
  if (!country || query.length < 2) return;

  try {
    const params = new URLSearchParams({ country, q: query });
    const response = await I18n.fetch(`/api/locations/cities?${params}`);
    if (!response.ok) throw new Error(T("interface.no_se_pudieron_cargar_las_ciudades"));
    const cities = await response.json();
    const matches = (Array.isArray(cities) ? cities : []).slice(0, 8);
    I18n.bind(natalAspectFinderCityResults, "innerHTML", () => matches.length ? matches.map((city) => `
        <button type="button" data-place-id="${escapeHtml(city.id)}" data-place-name="${escapeHtml(city.name)}" data-place-lat="${escapeHtml(city.lat)}" data-place-lon="${escapeHtml(city.lon)}" data-place-tz="${escapeHtml(city.tz || "")}">
          <strong>${escapeHtml(city.name)}</strong><span>${escapeHtml(city.tz || "")}</span>
        </button>
      `).join("") : `<span class="aspect-finder-city-empty">${T("interface.no_se_encontraron_ciudades")}</span>`);



    natalAspectFinderCityResults.querySelectorAll("button[data-place-id]").forEach((button) => {
      button.addEventListener("click", () => selectNatalAspectFinderCity(button));
    });
  } catch (error) {
    I18n.bind(natalAspectFinderCityResults, "innerHTML", () => `<span class="aspect-finder-city-empty">${escapeHtml(error.message || T("interface.no_se_pudieron_cargar_las_ciudades"))}</span>`);
  }
}

function selectNatalAspectFinderCity(button) {
  const countryOption = natalAspectFinderCountry?.selectedOptions?.[0];
  natalAspectFinderSelectedPlace = {
    id: button.dataset.placeId || "",
    name: button.dataset.placeName || "",
    country: natalAspectFinderCountry?.value || "",
    countryName: countryOption?.textContent?.trim() || natalAspectFinderCountry?.value || "",
    lat: Number(button.dataset.placeLat),
    lon: Number(button.dataset.placeLon),
    tz: button.dataset.placeTz || ""
  };
  if (natalAspectFinderCity) natalAspectFinderCity.value = natalAspectFinderSelectedPlace.name;
  if (natalAspectFinderCityResults) I18n.clear(natalAspectFinderCityResults, "innerHTML");
  setNatalAspectFinderLocationStatus(aspectFinderLocationLabel(natalAspectFinderSelectedPlace));
  syncNatalAspectFinderBirthLimits();
}

async function handleNatalAspectFinderSubmit(event) {
  event.preventDefault();
  if (!hasConfirmedSubscription()) {
    showPrivateSection("list");
    return;
  }
  await prepareNatalAspectFinderSection();

  const personId = natalAspectFinderPerson?.value || "";
  if (!personId) {
    setNatalAspectFinderStatus(() => T("interface.selecciona_una_carta_natal_guardada"), true);
    natalAspectFinderPersonPicker?.focus();
    return;
  }

  const selectedPlace = natalAspectFinderSelectedPlace;
  if (!selectedPlace?.id || !selectedPlace?.tz) {
    setNatalAspectFinderStatus(() => T("interface.selecciona_un_pais_y_una_ciudad_antes_de_buscar_el_transito"), true);
    (natalAspectFinderCountry?.value ? natalAspectFinderCity : natalAspectFinderCountry)?.focus();
    return;
  }

  if (syncNatalAspectFinderBirthLimits()) {
    setNatalAspectFinderStatus(() => T("server.la_fecha_y_hora_de_inicio_no_pueden_ser_anteriores_al_nacimiento"), true);
    const input = natalAspectFinderDate?.validity.customError ? natalAspectFinderDate : natalAspectFinderTime;
    input?.focus();
    input?.reportValidity();
    return;
  }

  const payload = {
    personId,
    transitPlanet: natalAspectFinderTransitPlanet?.value || "",
    natalPlanet: natalAspectFinderNatalPlanet?.value || "",
    aspectAngle: Number(natalAspectFinderAngle?.value),
    orb: Number(natalAspectFinderOrb?.value),
    startDate: natalAspectFinderDate?.value || localDateInputValue(),
    startTime: natalAspectFinderTime?.value || "00:00",
    placeId: selectedPlace.id,
    timeZone: selectedPlace.tz,
    horizonYears: Number(natalAspectFinderHorizon?.value || 5),
    limit: 3
  };

  setNatalAspectFinderBusy(true);
  setNatalAspectFinderStatus(() => T("interface.calculando_la_carta_natal_y_recorriendo_las_efemerides"));
  try {
    const response = await I18n.fetch("/api/tools/natal-aspects", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || T("interface.no_se_pudo_calcular_el_transito_natal"));

    latestNatalAspectFinderResult = result;
    renderAspectFinderResult(result, {
      target: natalAspectFinderResult,
      planetASelect: natalAspectFinderTransitPlanet,
      planetBSelect: natalAspectFinderNatalPlanet,
      angleSelect: natalAspectFinderAngle,
      orbInput: natalAspectFinderOrb,
      showMomentChart: true,
      momentChartDataAttribute: "data-natal-transit-chart",
      momentChartLabel: "Ver carta con tránsitos",
      momentChartTitle: "Ver carta Tropical natal con tránsitos"
    });
    const count = Array.isArray(result.occurrences) ? result.occurrences.length : 0;
    setNatalAspectFinderStatus(() => count ? T("interface.transito_natal_calculado_con_precision_de_minuto") : T("interface.no_se_encontro_una_perfeccion_en_el_periodo_consultado")

    );
  } catch (error) {
    latestNatalAspectFinderResult = null;
    setNatalAspectFinderStatus(() => error.message || T("interface.no_se_pudo_calcular_el_transito_natal"), true);
    renderAspectFinderError(error.message || "Revisa los datos e inténtalo de nuevo.", natalAspectFinderResult);
  } finally {
    setNatalAspectFinderBusy(false);
  }
}

function setNatalAspectFinderBusy(isBusy) {
  if (natalAspectFinderForm) {
    Array.from(natalAspectFinderForm.elements).forEach((element) => {
      element.disabled = Boolean(isBusy);
    });
  }
  if (!isBusy && natalAspectFinderCity) {
    natalAspectFinderCity.disabled = !natalAspectFinderCountry?.value;
  }
  if (natalAspectFinderSubmit) {
    natalAspectFinderSubmit.classList.toggle("is-loading", Boolean(isBusy));
    const label = natalAspectFinderSubmit.querySelector("span");
    if (label) I18n.bind(label, "textContent", () => isBusy ? T("interface.calculando_transito") : T("interface.buscar_transito_natal"));
  }
  natalAspectFinderResult?.setAttribute("aria-busy", String(Boolean(isBusy)));
}

function setNatalAspectFinderStatus(message = "", isError = false) {
  if (!natalAspectFinderStatus) return;
  I18n.bind(natalAspectFinderStatus, "textContent", () => message);
  natalAspectFinderStatus.classList.toggle("error", Boolean(isError));
}

async function handleAspectFinderSubmit(event) {
  event.preventDefault();
  if (!hasConfirmedSubscription()) {
    showPrivateSection("list");
    return;
  }
  await prepareAspectFinderSection();

  const selectedPlace = aspectFinderSelectedPlace;
  if (!selectedPlace?.id || !selectedPlace?.tz) {
    setAspectFinderStatus(() => T("interface.selecciona_un_pais_y_una_ciudad_antes_de_buscar_aspectos"), true);
    (aspectFinderCountry?.value ? aspectFinderCity : aspectFinderCountry)?.focus();
    return;
  }

  const planetA = aspectFinderPlanetA?.value || "";
  const planetB = aspectFinderPlanetB?.value || "";
  if (!planetA || !planetB || planetA === planetB) {
    setAspectFinderStatus(() => T("interface.selecciona_dos_planetas_distintos"), true);
    (planetA === planetB ? aspectFinderPlanetB : aspectFinderPlanetA)?.focus();
    return;
  }

  const payload = {
    planetA,
    planetB,
    aspectAngle: Number(aspectFinderAngle?.value),
    orb: Number(aspectFinderOrb?.value),
    startDate: aspectFinderDate?.value || localDateInputValue(),
    startTime: aspectFinderTime?.value || "00:00",
    placeId: selectedPlace.id,
    timeZone: selectedPlace.tz,
    horizonYears: Number(aspectFinderHorizon?.value || 25),
    limit: 3
  };

  setAspectFinderBusy(true);
  setAspectFinderStatus(() => T("interface.recorriendo_las_efemerides_y_refinando_la_hora_exacta"));

  try {
    const response = await I18n.fetch("/api/tools/next-aspect", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || T("interface.no_se_pudo_calcular_el_proximo_aspecto"));

    latestAspectFinderResult = result;
    renderAspectFinderResult(result);
    const count = Array.isArray(result.occurrences) ? result.occurrences.length : 0;
    setAspectFinderStatus(() => count ? T("interface.calculo_completado_con_precision_de_minuto") : T("interface.no_se_encontro_una_perfeccion_en_el_periodo_consultado"));
  } catch (error) {
    latestAspectFinderResult = null;
    setAspectFinderStatus(() => error.message || T("interface.no_se_pudo_calcular_el_proximo_aspecto"), true);
    renderAspectFinderError(error.message || "Revisa los datos e inténtalo de nuevo.");
  } finally {
    setAspectFinderBusy(false);
  }
}

function setAspectFinderBusy(isBusy) {
  if (aspectFinderForm) {
    Array.from(aspectFinderForm.elements).forEach((element) => {
      element.disabled = Boolean(isBusy);
    });
  }
  if (!isBusy && aspectFinderCity) {
    aspectFinderCity.disabled = !aspectFinderCountry?.value;
  }
  if (aspectFinderSubmit) {
    aspectFinderSubmit.classList.toggle("is-loading", Boolean(isBusy));
    const label = aspectFinderSubmit.querySelector("span");
    if (label) I18n.bind(label, "textContent", () => isBusy ? T("interface.calculando_efemerides") : T("interface.buscar_proximo_aspecto"));
  }
  aspectFinderResult?.setAttribute("aria-busy", String(Boolean(isBusy)));
}

function setAspectFinderStatus(message = "", isError = false) {
  if (!aspectFinderStatus) return;
  I18n.bind(aspectFinderStatus, "textContent", () => message);
  aspectFinderStatus.classList.toggle("error", Boolean(isError));
}

function renderAspectFinderResult(result = {}, options = {}) {
  const resultElement = options.target || aspectFinderResult;
  if (!resultElement) return;
  const planetASelect = options.planetASelect || aspectFinderPlanetA;
  const planetBSelect = options.planetBSelect || aspectFinderPlanetB;
  const angleSelect = options.angleSelect || aspectFinderAngle;
  const orbInput = options.orbInput || aspectFinderOrb;
  const timezoneSelect = options.timezoneSelect || null;
  const showMomentChart = options.showMomentChart !== false;
  const momentChartDataAttribute = options.momentChartDataAttribute === "data-natal-transit-chart" ?
  "data-natal-transit-chart" :
  "data-aspect-moment-chart";
  const momentChartLabel = options.momentChartLabel || T("interface.ver_carta_del_momento");
  const momentChartTitle = options.momentChartTitle || momentChartLabel;
  const query = result.query || {};
  const isNatalSearch = query.mode === "natal";
  const occurrences = Array.isArray(result.occurrences) ? result.occurrences : [];
  if (!occurrences.length) {
    const searchedUntil = formatAspectFinderSearchLimit(result.searchedUntil);
    I18n.bind(resultElement, "innerHTML", () => `
      <div class="aspect-finder-no-results">
        <div class="aspect-finder-empty-orbit" aria-hidden="true"><span></span></div>
        <p class="eyebrow">${T("interface.02_sin_coincidencias")}</p>
        <h3>${T("interface.no_hay_una_perfeccion_dentro_del_horizonte_seleccionado")}</h3>
        <p>${searchedUntil ? `Se han revisado las efemérides hasta ${escapeHtml(searchedUntil)}.` : T("interface.se_ha_completado_el_periodo_de_busqueda")} ${isNatalSearch ? T("interface.prueba_a_ampliar_el_horizonte_de_busqueda") : T("interface.prueba_a_ampliarlo_si_has_elegido_dos_planetas_lentos")}</p>
      </div>
    `);
    return;
  }

  const first = occurrences[0];
  const planetA = query.planetA?.key || query.planetA || planetASelect?.value || "";
  const planetB = query.planetB?.key || query.planetB || planetBSelect?.value || "";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? angleSelect?.value ?? 0);
  const orb = Number(query.orbDegrees ?? query.orb ?? first.orbWindow?.orbDegrees ?? orbInput?.value ?? 0);
  const aspectName = query.aspect?.label || ASPECT_FINDER_NAMES[angle] || `Aspecto de ${formatAspectFinderDegrees(angle)}`;
  const planetALabel = query.planetA?.label || PROMPT_PLANET_LABELS[planetA] || planetA;
  const planetBLabel = query.planetB?.label || PROMPT_PLANET_LABELS[planetB] || planetB;
  const planetASymbol = PLANET_SYMBOLS[planetA] || "•";
  const planetBSymbol = PLANET_SYMBOLS[planetB] || "•";
  const aspectSymbol = ASPECT_SYMBOLS[angle] || "•";
  const planetAColor = chartPlanetColorCssValue(planetA, "var(--text)");
  const planetBColor = chartPlanetColorCssValue(planetB, "var(--text)");
  const aspectColor = chartAspectColorCssValue(angle);
  const exact = aspectFinderLocalDisplay(first.exactLocal, first.exactUtc);
  const entry = aspectFinderLocalDisplay(first.orbWindow?.entryLocal, first.orbWindow?.entryUtc);
  const exit = aspectFinderLocalDisplay(first.orbWindow?.exitLocal, first.orbWindow?.exitUtc);
  const timeZone = first.exactLocal?.timeZone || query.timeZone || timezoneSelect?.value || "";
  const exactOrb = Number(first.exactOrbDegrees);
  const movementText = aspectFinderMovementText(result.initialMovement);
  const extraPasses = occurrences.slice(1);

  I18n.bind(resultElement, "innerHTML", () => `
    <article class="aspect-finder-result-card">
      <div class="aspect-finder-result-hero">
        <div
          class="aspect-finder-result-glyph"
          style="--result-planet-a:${planetAColor};--result-aspect:${aspectColor};--result-planet-b:${planetBColor}"
          aria-hidden="true"
        >
          <span class="aspect-finder-result-planet aspect-finder-result-planet-a">${escapeHtml(planetASymbol)}</span>
          <span class="aspect-finder-result-aspect">${escapeHtml(aspectSymbol)}</span>
          <span class="aspect-finder-result-planet aspect-finder-result-planet-b">${escapeHtml(planetBSymbol)}</span>
        </div>
        <div class="aspect-finder-result-summary">
          <p class="aspect-finder-result-kicker">02 · ${isNatalSearch ? T("interface.proximo_transito_natal") : T("interface.proxima_perfeccion")}</p>
          <h3 class="aspect-finder-result-title">${escapeHtml(I18n.label(planetALabel))} ${escapeHtml(I18n.label(aspectName.toLowerCase()))} ${escapeHtml(I18n.label(planetBLabel))}</h3>
          <p class="aspect-finder-result-date">${escapeHtml(exact.dateLabel)}</p>
          <strong>${escapeHtml(exact.timeLabel)}</strong>
          <div class="aspect-finder-result-meta">
            ${isNatalSearch && query.person?.name ? `<span>${T("interface.carta_de_value", { v0: escapeHtml(query.person.name) })}</span>` : ""}
            <span>${escapeHtml(timeZone)}</span>
            <span>${T("interface.orbe_exacto_value", { v14: Number.isFinite(exactOrb) ? formatAspectFinderOrb(exactOrb) : "0°00′" })}</span>
            <span>${T("interface.ventana_value", { v15: escapeHtml(formatAspectFinderDegrees(orb, 1)) })}</span>
          </div>
        </div>
      </div>

      <div class="aspect-finder-timeline" aria-label="${T("interface.ventana_temporal_del_aspecto")}">
        ${aspectFinderTimelineItem(T("interface.entrada_en_orbe"), entry, "entry")}
        ${aspectFinderTimelineItem(T("interface.perfeccion_exacta"), exact, "exact")}
        ${aspectFinderTimelineItem(T("interface.salida_del_orbe"), exit, "exit")}
      </div>

      ${renderAspectFinderExactPositions(first, { planetA, planetB })}

      ${movementText ? `<p class="aspect-finder-method-note">${escapeHtml(movementText)}</p>` : ""}

      ${extraPasses.length ? `
        <div class="aspect-finder-passes">
          <div>
            <p class="aspect-finder-result-kicker">${T("interface.siguientes_perfecciones")}</p>
            <h4>${T("interface.proximas_fechas_del_mismo_aspecto")}</h4>
          </div>
          ${extraPasses.map((occurrence, index) => aspectFinderPassMarkup(occurrence, index + 2, index + 1, { showMomentChart, momentChartDataAttribute, momentChartTitle: options.momentChartTitle || options.momentChartLabel || T("interface.ver_carta_del_momento") })).join("")}
        </div>
      ` : ""}

      <div class="aspect-finder-actions">
        ${showMomentChart ? `<button class="aspect-finder-moment-chart" type="button" ${momentChartDataAttribute}="0" title="${escapeHtml(options.momentChartTitle || options.momentChartLabel || T("interface.ver_carta_del_momento"))}">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"></circle><circle cx="12" cy="12" r="2"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path></svg>
          ${escapeHtml(options.momentChartLabel || T("interface.ver_carta_del_momento"))}
        </button>` : ""}
        <button class="aspect-finder-calendar" type="button" data-aspect-finder-calendar>
          <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M8 3v4M16 3v4M3 10h18"></path></svg>
          ${T("interface.anadir_al_calendario")}
        </button>
        <p>${T("interface.evento_de_30_minutos_en_la_hora_exacta_la_ventana_del_orbe_se_incluye_en_la_descripci")}</p>
      </div>
    </article>
  `);




}

function renderAspectFinderError(message = "", target = aspectFinderResult) {
  if (!target) return;
  I18n.bind(target, "innerHTML", () => `
    <div class="aspect-finder-no-results is-error">
      <p class="eyebrow">${T("interface.no_se_pudo_completar")}</p>
      <h3>${T("interface.revisa_la_busqueda")}</h3>
      <p>${escapeHtml(message)}</p>
    </div>
  `);
}

function aspectFinderTimelineItem(label, value, type) {
  return `
    <div class="aspect-finder-timeline-item is-${type}">
      <span class="aspect-finder-timeline-dot" aria-hidden="true"></span>
      <span class="aspect-finder-timeline-label">${escapeHtml(I18n.label(label))}</span>
      <strong class="aspect-finder-timeline-value">${escapeHtml(value.dateShort)} · ${escapeHtml(value.timeLabel)}</strong>
    </div>
  `;
}

function renderAspectFinderExactPositions(occurrence, keys = {}) {
  const positionA = occurrence?.positions?.planetA;
  const positionB = occurrence?.positions?.planetB;
  if (!positionA || !positionB) return "";
  return `
    <section class="aspect-finder-exact-positions" aria-label="${T("interface.posiciones_exactas_de_los_planetas")}">
      <div class="aspect-finder-exact-positions-heading">
        <p class="aspect-finder-result-kicker">${T("interface.posiciones_en_la_perfeccion")}</p>
        <span>${T("interface.longitud_tropical_exacta")}</span>
      </div>
      <div class="aspect-finder-position-grid">
        ${aspectFinderPositionMarkup(positionA, keys.planetA)}
        ${aspectFinderPositionMarkup(positionB, keys.planetB)}
      </div>
    </section>
  `;
}

function aspectFinderPositionMarkup(position = {}, fallbackKey = "") {
  const key = position.key || fallbackKey;
  const label = position.label || PROMPT_PLANET_LABELS[key] || key;
  const symbol = PLANET_SYMBOLS[key] || "•";
  const rawSignIndex = Number(position.signIndex);
  const signIndex = Number.isFinite(rawSignIndex) ? (rawSignIndex % 12 + 12) % 12 : -1;
  const signSymbol = ZODIAC_SYMBOLS[signIndex] || "";
  const signSymbolMarkup = signSymbol ?
  `<span class="aspect-finder-position-zodiac-symbol" aria-hidden="true" style="--position-zodiac-color:${ZODIAC_LIGHT_GLYPH_COLORS[signIndex] || ZODIAC_TABLE_COLORS[signIndex] || "var(--text)"};--position-zodiac-dark-color:${ZODIAC_GLYPH_COLORS[signIndex] || ZODIAC_LIGHT_GLYPH_COLORS[signIndex] || "var(--text)"}">${escapeHtml(signSymbol)}</span>` :
  "";
  const precisePosition = Number.isFinite(Number(position.degree)) ?
  `${position.degree}° ${pad(position.minute || 0)}′ ${pad(position.second || 0)}″` :
  position.formatted || "—";
  const decanateIndex = Number(position.decanate?.index);
  const dodecatemoriaIndex = Number(position.dodecatemoria?.index);
  return `
    <article class="aspect-finder-position-card" style="--planet-color:${chartPlanetColorCssValue(key, "var(--accent)")}">
      <div class="aspect-finder-position-identity">
        <span class="aspect-finder-position-symbol" aria-hidden="true">${escapeHtml(symbol)}</span>
        <div>
          <strong>${escapeHtml(I18n.label(label))}</strong>
          <span>${position.retrograde ? T("interface.retrogrado") : T("interface.directo")}</span>
        </div>
      </div>
      <div class="aspect-finder-position-main">
        <strong>${signSymbolMarkup}${signSymbolMarkup ? " " : ""}${escapeHtml(I18n.label(position.sign || ""))}</strong>
        <span>${escapeHtml(precisePosition)}</span>
      </div>
      <dl>
        ${position.houseLabel ? `<div><dt>${T("interface.casa")}</dt><dd>${escapeHtml(position.houseLabel)}</dd></div>` : ""}
        <div><dt>${T("interface.decanato")}</dt><dd>${Number.isFinite(decanateIndex) ? decanateIndex + 1 : "—"}${position.decanate?.sign ? ` · ${escapeHtml(position.decanate.sign)}` : ""}</dd></div>
        <div><dt>${T("interface.dodecatemoria")}</dt><dd>${Number.isFinite(dodecatemoriaIndex) ? dodecatemoriaIndex + 1 : "—"}${position.dodecatemoria?.sign ? ` · ${escapeHtml(position.dodecatemoria.sign)}` : ""}</dd></div>
      </dl>
    </article>
  `;
}

function aspectFinderPassMarkup(occurrence, passNumber, occurrenceIndex, options = {}) {
  const local = aspectFinderLocalDisplay(occurrence.exactLocal, occurrence.exactUtc);
  const showMomentChart = options.showMomentChart !== false;
  const momentChartDataAttribute = options.momentChartDataAttribute === "data-natal-transit-chart" ?
  "data-natal-transit-chart" :
  "data-aspect-moment-chart";
  const momentChartTitle = options.momentChartTitle || T("interface.ver_carta_del_momento");
  return `
    <div class="aspect-finder-pass">
      <span class="aspect-finder-pass-index">${passNumber}</span>
      <div class="aspect-finder-pass-copy">
        <span>${T("interface.perfeccion_exacta")}</span>
        <strong class="aspect-finder-pass-date">${escapeHtml(local.dateLabel)} · ${escapeHtml(local.timeLabel)}</strong>
      </div>
      ${showMomentChart ? `<button class="aspect-finder-pass-chart" type="button" ${momentChartDataAttribute}="${occurrenceIndex}" aria-label="${T("interface.value_de_la_perfeccion_value", { v2: escapeHtml(momentChartTitle), v3: passNumber })}" title="${escapeHtml(momentChartTitle)}">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"></circle><circle cx="12" cy="12" r="2"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path></svg>
      </button>` : ""}
    </div>
  `;
}

function aspectFinderLocalDisplay(localValue, utcValue) {
  let date = localValue?.date || "";
  let time = localValue?.time || "";
  if ((!date || !time) && localValue?.dateTime) {
    [date, time = ""] = String(localValue.dateTime).split("T");
  }
  if ((!date || !time) && utcValue) {
    const parsed = new Date(utcValue);
    if (!Number.isNaN(parsed.getTime())) {
      date = parsed.toISOString().slice(0, 10);
      time = parsed.toISOString().slice(11, 16);
    }
  }
  const normalizedTime = String(time || "--:--").slice(0, 5);
  return {
    date,
    time: normalizedTime,
    dateLabel: formatAspectFinderDate(date) || "Fecha no disponible",
    dateShort: formatAspectFinderDate(date, true) || "—",
    timeLabel: normalizedTime === "--:--" ? normalizedTime : `${normalizedTime} h`
  };
}

function formatAspectFinderDate(value, compact = false) {
  const [year, month, day] = String(value || "").split("-").map(Number);
  if (!year || !month || !day) return "";
  return new Intl.DateTimeFormat(I18n.locale(), compact ?
  { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" } :
  { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }
  ).format(new Date(Date.UTC(year, month - 1, day)));
}

function formatAspectFinderSearchLimit(value) {
  if (!value) return "";
  const text = String(value);
  const datePart = text.slice(0, 10);
  return formatAspectFinderDate(datePart) || text;
}

function formatAspectFinderDegrees(value, maximumFractionDigits = 2) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return `${new Intl.NumberFormat("es-ES", { maximumFractionDigits }).format(Math.abs(amount))}°`;
}

function formatAspectFinderOrb(value) {
  const amount = Math.abs(Number(value));
  if (!Number.isFinite(amount)) return "—";
  const totalSeconds = Math.round(amount * 3600);
  const degrees = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return seconds ? `${degrees}°${pad(minutes)}′${pad(seconds)}″` : `${degrees}°${pad(minutes)}′`;
}

function aspectFinderMovementText(movement) {
  if (!movement) return "";
  const state = String(movement.state || movement.status || movement.phase || movement).toLowerCase();
  if (state.includes("app")) return "En la fecha inicial, el aspecto está aplicando hacia la perfección.";
  if (state.includes("sep")) return "En la fecha inicial, el aspecto está separando de una perfección anterior.";
  if (state.includes("inside") || state.includes("within") || state.includes("orb")) return "En la fecha inicial, ambos planetas ya están dentro del orbe elegido.";
  return "";
}

function aspectMomentActivePlace() {
  const location = chartCalculation?.profile?.location || null;
  const placeId = location?.id || birthProfile?.placeId || birthProfile?.place_id || "";
  if (!placeId) return null;
  return {
    id: String(placeId),
    personId: String(activePersonId || birthProfile?.personId || ""),
    name: location?.name || birthProfile?.city || "Ubicación de la carta activa",
    country: location?.country || birthProfile?.country || "",
    countryName: location?.countryName || birthProfile?.countryName || "",
    lat: Number(location?.lat ?? birthProfile?.lat),
    lon: Number(location?.lon ?? birthProfile?.lon),
    tz: location?.tz || birthProfile?.tz || birthProfile?.timezone || ""
  };
}

function aspectFinderResultPlace(result = latestAspectFinderResult) {
  const reference = result?.query?.spatialReference;
  if (reference?.placeId && reference?.timeZone) {
    return {
      id: String(reference.placeId), get
      name() {return reference.city || T("interface.ciudad_seleccionada");},
      country: reference.country || "",
      countryName: reference.countryName || "",
      lat: Number(reference.lat),
      lon: Number(reference.lon),
      tz: reference.timeZone
    };
  }
  return aspectFinderSelectedPlace;
}

function syncAspectMomentFullscreenState(dialog = document.querySelector("#aspect-moment-dialog")) {
  if (!dialog) return;

  const isActive = document.fullscreenElement === dialog ||
  dialog.classList.contains("is-aspect-moment-fallback-fullscreen");
  const button = dialog.querySelector("[data-aspect-moment-fullscreen]");
  if (!button) return;

  const label = isActive ? T("interface.salir_de_pantalla_completa") : T("interface.ver_en_pantalla_completa");
  I18n.bind(button, "@aria-label", () => isActive ? T("interface.salir_de_pantalla_completa") : T("interface.ver_en_pantalla_completa"));
  button.setAttribute("aria-pressed", String(isActive));
  I18n.bind(button, "title", () => isActive ? T("interface.salir_de_pantalla_completa") : T("interface.ver_en_pantalla_completa"));
}

function ensureAspectMomentDialog() {
  let dialog = document.querySelector("#aspect-moment-dialog");
  if (dialog) return dialog;

  dialog = document.createElement("dialog");
  dialog.id = "aspect-moment-dialog";
  dialog.className = "aspect-moment-dialog";
  dialog.setAttribute("aria-labelledby", "aspect-moment-title");
  I18n.bind(dialog, "innerHTML", () => `
    <div class="aspect-moment-modal">
      <header class="aspect-moment-header">
        <div>
          <p class="aspect-moment-eyebrow" data-aspect-moment-eyebrow>${T("interface.carta_del_momento_exacto")}</p>
          <h2 id="aspect-moment-title" data-aspect-moment-title>${T("interface.perfeccion_del_aspecto")}</h2>
          <p data-aspect-moment-subtitle></p>
        </div>
        <div class="aspect-moment-header-actions">
          <button type="button" class="aspect-moment-icon-button" data-aspect-moment-fullscreen aria-label="${T("interface.ver_en_pantalla_completa")}" title="${T("interface.pantalla_completa")}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"></path></svg>
          </button>
          <button type="button" class="aspect-moment-icon-button" data-aspect-moment-close aria-label="${T("interface.cerrar_carta_del_momento")}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"></path></svg>
          </button>
        </div>
      </header>

      <div class="aspect-moment-location-bar">
        <div class="aspect-moment-location-copy">
          <strong data-aspect-moment-location-title>${T("interface.referencia_espacial")}</strong>
          <span data-aspect-moment-location-note>${T("interface.el_aspecto_planetario_es_global_esta_ubicacion_solo_determina_las_casas_el_ascendente")}</span>
        </div>
      </div>

      <div class="aspect-moment-content" data-aspect-moment-content aria-live="polite"></div>
    </div>
  `);
  document.body.appendChild(dialog);

  dialog.querySelector("[data-aspect-moment-close]")?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener("close", () => {
    dialog.classList.remove("is-aspect-moment-fallback-fullscreen");
    if (document.fullscreenElement === dialog) document.exitFullscreen?.().catch(() => {});
    syncAspectMomentFullscreenState(dialog);
  });
  dialog.querySelector("[data-aspect-moment-fullscreen]")?.addEventListener("click", async () => {
    const isFallbackFullscreen = dialog.classList.contains("is-aspect-moment-fallback-fullscreen");

    if (document.fullscreenElement === dialog) {
      await document.exitFullscreen?.().catch(() => {});
    } else if (isFallbackFullscreen) {
      dialog.classList.remove("is-aspect-moment-fallback-fullscreen");
    } else {
      let nativeFullscreenActive = false;
      if (dialog.requestFullscreen) {
        try {
          await dialog.requestFullscreen();
          nativeFullscreenActive = document.fullscreenElement === dialog;
        } catch {
          nativeFullscreenActive = false;
        }
      }
      if (!nativeFullscreenActive) {
        dialog.classList.add("is-aspect-moment-fallback-fullscreen");
      }
    }

    syncAspectMomentFullscreenState(dialog);
  });
  return dialog;
}

async function openAspectMomentDialog(occurrenceIndex = 0) {
  const occurrences = Array.isArray(latestAspectFinderResult?.occurrences) ? latestAspectFinderResult.occurrences : [];
  if (!occurrences.length) throw new Error(T("interface.primero_realiza_una_busqueda_de_aspectos"));
  const selectedPlace = aspectFinderResultPlace();
  if (!selectedPlace?.id) {
    throw new Error(T("interface.selecciona_un_pais_y_una_ciudad_antes_de_abrir_la_carta_del_momento"));
  }
  activeAspectMomentOccurrenceIndex = Math.max(0, Math.min(occurrences.length - 1, Number(occurrenceIndex) || 0));

  const dialog = ensureAspectMomentDialog();
  const eyebrow = dialog.querySelector("[data-aspect-moment-eyebrow]");
  const locationNote = dialog.querySelector("[data-aspect-moment-location-note]");
  if (eyebrow) I18n.bind(eyebrow, "textContent", () => T("interface.carta_del_momento_exacto"));
  if (locationNote) I18n.bind(locationNote, "textContent", () => T("interface.el_aspecto_planetario_es_global_esta_ubicacion_solo_determina_las_casas_el_ascendente"));
  updateAspectMomentHeader(dialog);
  updateAspectMomentLocationReference(dialog, selectedPlace);
  if (!dialog.open) dialog.showModal();
  await loadAspectMomentChart();
}

function updateAspectMomentHeader(dialog = ensureAspectMomentDialog(), chartData = null) {
  const result = latestAspectFinderResult || {};
  const query = result.query || {};
  const occurrence = result.occurrences?.[activeAspectMomentOccurrenceIndex] || {};
  const planetA = query.planetA?.key || query.planetA || "";
  const planetB = query.planetB?.key || query.planetB || "";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? 0);
  const title = `${query.planetA?.label || PROMPT_PLANET_LABELS[planetA] || planetA} ${(query.aspect?.label || ASPECT_FINDER_NAMES[angle] || "aspecto").toLowerCase()} ${query.planetB?.label || PROMPT_PLANET_LABELS[planetB] || planetB}`;
  const local = chartData ?
  aspectFinderLocalDisplay(chartData.localMoment, chartData.utcDateTime) :
  aspectFinderLocalDisplay(occurrence.exactLocal, occurrence.exactUtc);
  const timeZone = chartData?.timeZone || occurrence.exactLocal?.timeZone || query.timeZone || "UTC";
  const titleElement = dialog.querySelector("[data-aspect-moment-title]");
  const subtitleElement = dialog.querySelector("[data-aspect-moment-subtitle]");
  if (titleElement) I18n.bind(titleElement, "textContent", () => title);
  if (subtitleElement) I18n.bind(subtitleElement, "textContent", () => `${local.dateLabel} · ${local.timeLabel} · ${timeZone}`);
}

function updateAspectMomentLocationReference(dialog = ensureAspectMomentDialog(), place = aspectFinderResultPlace()) {
  const title = dialog.querySelector("[data-aspect-moment-location-title]");
  if (title) I18n.bind(title, "textContent", () => T("interface.referencia_espacial_value", { get v0() {return aspectFinderLocationLabel(place) || T("interface.sin_ciudad");} }));
}

async function loadAspectMomentChart() {
  const dialog = ensureAspectMomentDialog();
  const content = dialog.querySelector("[data-aspect-moment-content]");
  const occurrence = latestAspectFinderResult?.occurrences?.[activeAspectMomentOccurrenceIndex];
  if (!content || !occurrence?.exactUtc) return;
  const place = aspectFinderResultPlace();
  if (!place?.id) throw new Error(T("interface.selecciona_un_pais_y_una_ciudad_antes_de_abrir_la_carta_del_momento"));

  content.setAttribute("aria-busy", "true");
  I18n.bind(content, "innerHTML", () => `
    <div class="aspect-moment-loading">
      <span aria-hidden="true"></span>
      <strong>${T("interface.calculando_la_carta_tropical_exacta")}</strong>
      <p>${T("interface.swiss_ephemeris_esta_situando_los_planetas_en_el_instante_de_la_perfeccion")}</p>
    </div>
  `);
  try {
    const response = await I18n.fetch("/api/tools/aspect-moment-chart", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        exactUtc: occurrence.exactUtc,
        timeZone: occurrence.exactLocal?.timeZone || latestAspectFinderResult?.query?.timeZone || "UTC",
        placeId: place?.id || ""
      })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || T("interface.no_se_pudo_calcular_la_carta_del_momento"));
    renderAspectMomentChart(data, occurrence, content);
  } catch (error) {
    I18n.bind(content, "innerHTML", () => `
      <div class="aspect-moment-error">
        <strong>${T("interface.no_se_pudo_cargar_la_carta")}</strong>
        <p>${escapeHtml(error.message || T("interface.intentalo_de_nuevo"))}</p>
        <button type="button" data-aspect-moment-retry>${T("navigation.toolRetry")}</button>
      </div>
    `);
    content.querySelector("[data-aspect-moment-retry]")?.addEventListener("click", loadAspectMomentChart);
  } finally {
    content.setAttribute("aria-busy", "false");
  }
}

function renderAspectMomentChart(data, occurrence, content) {
  const query = latestAspectFinderResult?.query || {};
  const planetA = query.planetA?.key || query.planetA || "";
  const planetB = query.planetB?.key || query.planetB || "";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? 0);
  const planets = Array.isArray(data.planets) ? data.planets : [];
  const chart = {
    type: "tropical", get
    label() {return T("interface.carta_tropical_del_momento_exacto");},
    planets,
    planetsByKey: data.planetsByKey || Object.fromEntries(planets.map((planet) => [planet.key, planet])),
    aspects: Array.isArray(data.aspects) ? data.aspects : [],
    houses: Array.isArray(data.houses) ? data.houses : [],
    ascendant: data.ascendant || null,
    midheaven: data.midheaven || null,
    highlightedAspect: { planetA, planetB, angle }
  };
  const local = aspectFinderLocalDisplay(data.localMoment, data.utcDateTime);
  const selectedA = chart.planetsByKey[planetA] || occurrence.positions?.planetA;
  const selectedB = chart.planetsByKey[planetB] || occurrence.positions?.planetB;
  const locationLabel = `${data.location?.name || aspectFinderResultPlace()?.name || T("interface.ciudad_seleccionada")}${data.location?.countryName ? `, ${data.location.countryName}` : ""}`;
  const mapModeLabel = T("interface.carta_tropical_con_casas");
  updateAspectMomentHeader(ensureAspectMomentDialog(), data);

  I18n.bind(content, "innerHTML", ((__i18nSnapshot0) => () => `
    <div class="aspect-moment-chart-stage">
      <div class="aspect-moment-chart-caption">
        <span>${escapeHtml(T("interface.carta_tropical_con_casas"))}</span>
        <strong>${escapeHtml(`${data.location?.name || aspectFinderResultPlace()?.name || T("interface.ciudad_seleccionada")}${data.location?.countryName ? `, ${data.location.countryName}` : ""}`)}</strong>
      </div>
      <div class="aspect-moment-chart-wheel has-highlighted-aspect">
        ${renderChartSvg({ type: "tropical", get label() {return T("interface.carta_tropical_del_momento_exacto");}, planets, planetsByKey: data.planetsByKey || Object.fromEntries(planets.map((planet) => [planet.key, planet])), aspects: Array.isArray(data.aspects) ? data.aspects : [], houses: Array.isArray(data.houses) ? data.houses : [], ascendant: data.ascendant || null, midheaven: data.midheaven || null, highlightedAspect: { planetA, planetB, angle } }, { hideHouses: false, panelPrefix: `aspect-moment-${__i18nSnapshot0}` })}
      </div>
      <p class="aspect-moment-chart-legend"><i></i> ${T("interface.el_aspecto_buscado_aparece_resaltado_las_demas_lineas_se_mantienen_como_contexto")}</p>
    </div>
    <aside class="aspect-moment-details">
      <div class="aspect-moment-details-intro">
        <p class="aspect-moment-eyebrow">${T("interface.lectura_tecnica")}</p>
        <h3>${escapeHtml(I18n.label(query.aspect?.label || ASPECT_FINDER_NAMES[angle] || `Aspecto ${angle}°`))}</h3>
        <p>${escapeHtml(local.dateLabel)} · ${escapeHtml(local.timeLabel)} · ${escapeHtml(data.timeZone || "UTC")}</p>
      </div>
      <div class="aspect-moment-selected-positions">
        ${aspectFinderPositionMarkup({ type: "tropical", get label() {return T("interface.carta_tropical_del_momento_exacto");}, planets, planetsByKey: data.planetsByKey || Object.fromEntries(planets.map((planet) => [planet.key, planet])), aspects: Array.isArray(data.aspects) ? data.aspects : [], houses: Array.isArray(data.houses) ? data.houses : [], ascendant: data.ascendant || null, midheaven: data.midheaven || null, highlightedAspect: { planetA, planetB, angle } }.planetsByKey[planetA] || occurrence.positions?.planetA, planetA)}
        ${aspectFinderPositionMarkup({ type: "tropical", get label() {return T("interface.carta_tropical_del_momento_exacto");}, planets, planetsByKey: data.planetsByKey || Object.fromEntries(planets.map((planet) => [planet.key, planet])), aspects: Array.isArray(data.aspects) ? data.aspects : [], houses: Array.isArray(data.houses) ? data.houses : [], ascendant: data.ascendant || null, midheaven: data.midheaven || null, highlightedAspect: { planetA, planetB, angle } }.planetsByKey[planetB] || occurrence.positions?.planetB, planetB)}
      </div>
      <dl class="aspect-moment-facts">
        <div><dt>${T("interface.separacion")}</dt><dd>${escapeHtml(formatAspectFinderOrb(occurrence.separationDegrees))}</dd></div>
        <div><dt>${T("interface.orbe_exacto")}</dt><dd>${escapeHtml(formatAspectFinderOrb(occurrence.exactOrbDegrees))}</dd></div>
        ${data.ascendant ? `<div><dt>${T("interface.ascendente")}</dt><dd>${escapeHtml(I18n.label(data.ascendant.formatted || data.ascendant.sign || "—"))}</dd></div>` : ""}
        ${data.midheaven ? `<div><dt>${T("interface.medio_cielo")}</dt><dd>${escapeHtml(I18n.label(data.midheaven.formatted || data.midheaven.sign || "—"))}</dd></div>` : ""}
      </dl>
      <p class="aspect-moment-method">${T("interface.el_aspecto_entre_planetas_es_global_la_ubicacion_seleccionada_solo_se_utiliza_para_ca")}</p>
    </aside>
  `)(activeAspectMomentOccurrenceIndex));
}

function natalAspectFinderResultPlace(result = latestNatalAspectFinderResult) {
  const reference = result?.query?.spatialReference;
  if (reference?.placeId && reference?.timeZone) {
    return {
      id: String(reference.placeId), get
      name() {return reference.city || T("interface.ciudad_seleccionada");},
      country: reference.country || "",
      countryName: reference.countryName || "",
      lat: Number(reference.lat),
      lon: Number(reference.lon),
      tz: reference.timeZone
    };
  }
  return natalAspectFinderSelectedPlace;
}

async function openNatalTransitMomentDialog(occurrenceIndex = 0) {
  const result = latestNatalAspectFinderResult || {};
  const occurrences = Array.isArray(result.occurrences) ? result.occurrences : [];
  if (!occurrences.length) throw new Error(T("interface.primero_realiza_una_busqueda_de_transitos_natales"));
  const selectedPlace = natalAspectFinderResultPlace(result);
  if (!selectedPlace?.id) {
    throw new Error(T("interface.selecciona_un_pais_y_una_ciudad_antes_de_abrir_la_carta_con_transitos"));
  }

  activeAspectMomentOccurrenceIndex = Math.max(0, Math.min(occurrences.length - 1, Number(occurrenceIndex) || 0));
  const dialog = ensureAspectMomentDialog();
  const eyebrow = dialog.querySelector("[data-aspect-moment-eyebrow]");
  const locationNote = dialog.querySelector("[data-aspect-moment-location-note]");
  if (eyebrow) I18n.bind(eyebrow, "textContent", () => T("interface.carta_tropical_natal_con_transitos"));
  if (locationNote) I18n.bind(locationNote, "textContent", () => T("interface.la_carta_tropical_natal_y_sus_casas_permanecen_fijas_la_referencia_seleccionada_deter"));
  updateNatalTransitMomentHeader(dialog);
  updateAspectMomentLocationReference(dialog, selectedPlace);
  if (!dialog.open) dialog.showModal();
  await loadNatalTransitMomentChart();
}

function updateNatalTransitMomentHeader(dialog = ensureAspectMomentDialog(), data = null) {
  const result = latestNatalAspectFinderResult || {};
  const query = result.query || {};
  const occurrence = result.occurrences?.[activeAspectMomentOccurrenceIndex] || {};
  const planetA = query.planetA?.key || query.planetA || "";
  const planetB = query.planetB?.key || query.planetB || "";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? 0);
  const transitLabel = query.planetA?.label || T("interface.value_en_transito", { v0: PROMPT_PLANET_LABELS[planetA] || planetA });
  const natalLabel = query.planetB?.label || T("interface.value_natal", { v0: PROMPT_PLANET_LABELS[planetB] || planetB });
  const title = `${transitLabel} ${(query.aspect?.label || ASPECT_FINDER_NAMES[angle] || "aspecto").toLowerCase()} ${natalLabel}`;
  const transits = data?.transits || null;
  const local = transits ?
  aspectFinderLocalDisplay(transits.localMoment, transits.utcDateTime) :
  aspectFinderLocalDisplay(occurrence.exactLocal, occurrence.exactUtc);
  const timeZone = transits?.timeZone || occurrence.exactLocal?.timeZone || query.timeZone || "UTC";
  const titleElement = dialog.querySelector("[data-aspect-moment-title]");
  const subtitleElement = dialog.querySelector("[data-aspect-moment-subtitle]");
  if (titleElement) I18n.bind(titleElement, "textContent", () => `${query.planetA?.label || T("interface.value_en_transito", { v0: PROMPT_PLANET_LABELS[planetA] || planetA })} ${(query.aspect?.label || ASPECT_FINDER_NAMES[angle] || "aspecto").toLowerCase()} ${query.planetB?.label || T("interface.value_natal", { v0: PROMPT_PLANET_LABELS[planetB] || planetB })}`);
  if (subtitleElement) I18n.bind(subtitleElement, "textContent", () => `${local.dateLabel} · ${local.timeLabel} · ${timeZone}`);
}

async function loadNatalTransitMomentChart() {
  const dialog = ensureAspectMomentDialog();
  const content = dialog.querySelector("[data-aspect-moment-content]");
  const result = latestNatalAspectFinderResult || {};
  const occurrence = result.occurrences?.[activeAspectMomentOccurrenceIndex];
  const place = natalAspectFinderResultPlace(result);
  const personId = result.query?.person?.id || natalAspectFinderPerson?.value || "";
  if (!content || !occurrence?.exactUtc) return;
  if (!personId) throw new Error(T("interface.no_se_encontro_la_carta_natal_seleccionada"));
  if (!place?.id) throw new Error(T("interface.selecciona_un_pais_y_una_ciudad_antes_de_abrir_la_carta_con_transitos"));

  content.setAttribute("aria-busy", "true");
  I18n.bind(content, "innerHTML", () => `
    <div class="aspect-moment-loading">
      <span aria-hidden="true"></span>
      <strong>${T("interface.calculando_la_carta_tropical_con_transitos")}</strong>
      <p>${T("interface.swiss_ephemeris_esta_superponiendo_los_transitos_del_instante_exacto_sobre_la_carta_n")}</p>
    </div>
  `);
  try {
    const response = await I18n.fetch("/api/tools/natal-transit-chart", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        personId,
        exactUtc: occurrence.exactUtc,
        placeId: place.id
      })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || T("interface.no_se_pudo_calcular_la_carta_con_transitos"));
    renderNatalTransitMomentChart(data, occurrence, content);
  } catch (error) {
    I18n.bind(content, "innerHTML", () => `
      <div class="aspect-moment-error">
        <strong>${T("interface.no_se_pudo_cargar_la_carta_con_transitos")}</strong>
        <p>${escapeHtml(error.message || T("interface.intentalo_de_nuevo"))}</p>
        <button type="button" data-natal-transit-retry>${T("navigation.toolRetry")}</button>
      </div>
    `);
    content.querySelector("[data-natal-transit-retry]")?.addEventListener("click", loadNatalTransitMomentChart);
  } finally {
    content.setAttribute("aria-busy", "false");
  }
}

function renderNatalTransitMomentChart(data, occurrence, content) {
  const query = latestNatalAspectFinderResult?.query || {};
  const planetA = query.planetA?.key || query.planetA || "";
  const planetB = query.planetB?.key || query.planetB || "";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? 0);
  const natalChart = data.natalChart || {};
  const transits = data.transits || {};
  natalChart.highlightedCrossAspect = { planetA, planetB, angle };
  const local = aspectFinderLocalDisplay(transits.localMoment, transits.utcDateTime);
  const selectedTransit = transits.planetsByKey?.[planetA] || occurrence.positions?.planetA;
  const selectedNatal = natalChart.planetsByKey?.[planetB] || occurrence.positions?.planetB;
  const transitNatalHouse = selectedTransit?.longitude === undefined ?
  null :
  houseNumberFromCuspsClient(selectedTransit.longitude, natalChart.houses || []);
  const selectedTransitPosition = selectedTransit ? {
    ...selectedTransit, get
    label() {return query.planetA?.label || T("interface.value_en_transito", { v0: PROMPT_PLANET_LABELS[planetA] || planetA });},
    house: transitNatalHouse,
    houseLabel: transitNatalHouse ? romanHouse(transitNatalHouse) : ""
  } : selectedTransit;
  const selectedNatalPosition = selectedNatal ? {
    ...selectedNatal, get
    label() {return query.planetB?.label || T("interface.value_natal", { v0: PROMPT_PLANET_LABELS[planetB] || planetB });}
  } : selectedNatal;
  const personName = data.person?.name || query.person?.name || "Persona seleccionada";
  const locationLabel = [transits.location?.name || natalAspectFinderResultPlace()?.name, transits.location?.countryName].
  filter(Boolean).
  join(", ");

  I18n.bind(content, "innerHTML", ((__i18nSnapshot0) => () => `
    <div class="aspect-moment-chart-stage">
      <div class="aspect-moment-chart-caption">
        <span>${T("interface.tropical_natal_con_transitos")}</span>
        <strong>${escapeHtml(personName)}</strong>
      </div>
      <div class="aspect-moment-chart-wheel has-highlighted-aspect is-natal-transit-chart">
        ${renderChartSvg(natalChart, { overlay: transits, interactivePlanets: true, get overlayLabel() {return T("interface.transitos");}, natalInteractionLabel: `Natal · ${personName}`, overlayClassName: "chart-planet-transit-overlay chart-planet-transit-primary", overlayOutwardDetails: true, overlayStackedLabels: false, overlayPerimeterLayout: true, natalClassName: "chart-planet-transit-natal", natalMinSpacing: 9.2, natalGroupThreshold: 14, overlayLabelMargin: 2, overlayLabelLaneOffsets: TROPICAL_TRANSIT_LABEL_VISUALS.transitLabelRadii, overlayMinSameLaneDistance: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelDistance, overlayReservedAxisDistance: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding, overlayProtectedAnglePadding: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding, overlayAllowAxisOverlap: false, overlayCollisionPadding: 8, overlaySectorSize: 14, overlayMinLabelGap: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX, overlayMinLabelGapX: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX, overlayMinLabelGapY: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapY, overlayMaxTangentialShift: TROPICAL_TRANSIT_LABEL_VISUALS.maxTangentialShift, overlayLeaderLineOpacity: TROPICAL_TRANSIT_LABEL_VISUALS.leaderLineOpacity, overlayTransitFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitFontSize, overlayTransitGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitGlyphFontSize, overlayTransitMajorGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitMajorGlyphFontSize, panelPrefix: `natal-transit-moment-${__i18nSnapshot0}` })}
      </div>
      <p class="aspect-moment-chart-legend"><i></i> ${T("interface.el_transito_buscado_aparece_resaltado_sobre_la_carta_tropical_natal")}</p>
    </div>
    <aside class="aspect-moment-details">
      <div class="aspect-moment-details-intro">
        <p class="aspect-moment-eyebrow">${T("interface.lectura_tecnica")}</p>
        <h3>${escapeHtml(I18n.label(query.aspect?.label || ASPECT_FINDER_NAMES[angle] || `Aspecto ${angle}°`))}</h3>
        <p>${escapeHtml(local.dateLabel)} · ${escapeHtml(local.timeLabel)} · ${escapeHtml(transits.timeZone || "UTC")}</p>
      </div>
      <div class="aspect-moment-selected-positions">
        ${aspectFinderPositionMarkup(selectedTransit ? { ...selectedTransit, get label() {return query.planetA?.label || T("interface.value_en_transito", { v0: PROMPT_PLANET_LABELS[planetA] || planetA });}, house: transitNatalHouse, houseLabel: transitNatalHouse ? romanHouse(transitNatalHouse) : "" } : selectedTransit, planetA)}
        ${aspectFinderPositionMarkup(selectedNatal ? { ...selectedNatal, get label() {return query.planetB?.label || T("interface.value_natal", { v0: PROMPT_PLANET_LABELS[planetB] || planetB });} } : selectedNatal, planetB)}
      </div>
      <dl class="aspect-moment-facts">
        <div><dt>${T("interface.carta_natal")}</dt><dd>${escapeHtml(personName)}</dd></div>
        <div><dt>${T("interface.separacion")}</dt><dd>${escapeHtml(formatAspectFinderOrb(occurrence.separationDegrees))}</dd></div>
        <div><dt>${T("interface.orbe_exacto")}</dt><dd>${escapeHtml(formatAspectFinderOrb(occurrence.exactOrbDegrees))}</dd></div>
      </dl>
      <p class="aspect-moment-method">${T("interface.la_carta_y_las_casas_son_las_natales_de_value_los_planetas_exteriores_corresponden_al", { v11: escapeHtml(personName), v12: locationLabel ? `, mostrado en la hora local de ${escapeHtml(locationLabel)}` : "" })}</p>
    </aside>
  `)(activeAspectMomentOccurrenceIndex));





























  updateNatalTransitMomentHeader(ensureAspectMomentDialog(), data);
}

function downloadAspectFinderCalendar(result = latestAspectFinderResult) {
  const occurrence = Array.isArray(result?.occurrences) ? result.occurrences[0] : null;
  if (!occurrence?.exactUtc) return;

  const query = result.query || {};
  const isNatalSearch = query.mode === "natal";
  const angle = Number(query.aspect?.angle ?? query.aspectAngle ?? (isNatalSearch ? natalAspectFinderAngle : aspectFinderAngle)?.value ?? 0);
  const planetA = query.planetA?.key || query.planetA || (isNatalSearch ? natalAspectFinderTransitPlanet : aspectFinderPlanetA)?.value || "";
  const planetB = query.planetB?.key || query.planetB || (isNatalSearch ? natalAspectFinderNatalPlanet : aspectFinderPlanetB)?.value || "";
  const planetALabel = query.planetA?.label || PROMPT_PLANET_LABELS[planetA] || planetA;
  const planetBLabel = query.planetB?.label || PROMPT_PLANET_LABELS[planetB] || planetB;
  const aspectName = query.aspect?.label || ASPECT_FINDER_NAMES[angle] || `Aspecto ${angle}°`;
  const start = new Date(occurrence.exactUtc);
  if (Number.isNaN(start.getTime())) return;
  const end = new Date(start.getTime() + 30 * 60 * 1000);
  const entry = aspectFinderLocalDisplay(occurrence.orbWindow?.entryLocal, occurrence.orbWindow?.entryUtc);
  const exit = aspectFinderLocalDisplay(occurrence.orbWindow?.exitLocal, occurrence.orbWindow?.exitUtc);
  const orb = Number(query.orbDegrees ?? query.orb ?? occurrence.orbWindow?.orbDegrees ?? 0);
  const title = `${planetALabel} ${aspectName.toLowerCase()} ${planetBLabel}`;
  const description = isNatalSearch ? T("interface.perfeccion_exacta_del_transito_sobre_la_carta_natalvalue_ventana_de_orbe_value_value_", { get v0() {return query.person?.name ? T("interface.de_value", { v0: query.person.name }) : "";}, v1: formatAspectFinderDegrees(orb, 1), v2: entry.dateShort, v3: entry.timeLabel, v4: exit.dateShort, v5: exit.timeLabel }) : T("interface.perfeccion_exacta_del_aspecto_geocentrico_tropical_ventana_de_orbe_value_value_value_", { v0: formatAspectFinderDegrees(orb, 1), v1: entry.dateShort, v2: entry.timeLabel, v3: exit.dateShort, v4: exit.timeLabel });


  const stamp = new Date();
  const ics = [
  "BEGIN:VCALENDAR",
  "VERSION:2.0",
  "PRODID:-//Astroanamnesis//Buscador de aspectos//ES",
  "CALSCALE:GREGORIAN",
  "METHOD:PUBLISH",
  "BEGIN:VEVENT",
  `UID:${start.getTime()}-${slugId(`${planetA}-${planetB}-${angle}`)}@astroanamnesis`,
  `DTSTAMP:${formatAspectFinderIcsDate(stamp)}`,
  `DTSTART:${formatAspectFinderIcsDate(start)}`,
  `DTEND:${formatAspectFinderIcsDate(end)}`,
  `SUMMARY:${escapeAspectFinderIcsText(title)}`,
  `DESCRIPTION:${escapeAspectFinderIcsText(description)}`,
  "END:VEVENT",
  "END:VCALENDAR"].
  join("\r\n");
  downloadBlob(new Blob([ics], { type: "text/calendar;charset=utf-8" }), `aspecto-${slugId(planetALabel)}-${slugId(planetBLabel)}-${start.toISOString().slice(0, 10)}.ics`);
}

function formatAspectFinderIcsDate(date) {
  return date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
}

function escapeAspectFinderIcsText(value) {
  return String(value || "").
  replaceAll("\\", "\\\\").
  replaceAll(";", "\\;").
  replaceAll(",", "\\,").
  replaceAll("\n", "\\n");
}

async function handlePrivateDashboardAction(action) {
  const moduleKey = PRIVATE_ACTION_MODULE_MAP[action];
  if (moduleKey && !isModuleEnabled(moduleKey)) {
    setPrivateStatus(() => T("interface.este_modulo_esta_oculto_temporalmente_puedes_activarlo_desde_el_panel_de_administraci"));
    showPrivateSection("list");
    return;
  }

  if (action === "maps") {
    showPrivateSection("maps");
    return;
  }

  if (action === "add-chart") {
    await openPrivateAddChart();
    return;
  }

  if (action === "saved-charts") {
    showPrivateSection("list");
    closePersonForm();
    setPrivateStatus("");
    return;
  }

  if (action === "plans") {
    showPrivateSection("plans");
    return;
  }

  if (action === "store") {
    showPrivateSection("store");
    return;
  }

  if (action === "admin") {
    await openAdminPanel();
    return;
  }

  if (action === "orders") {
    showPrivateSection("reports");
    return;
  }

  if (action === "settings") {
    openAccountSettings();
    return;
  }

  if (action === "prognosis") {
    showPrivateSection("prognosis");
    return;
  }

  if (action === "transits") {
    showPrivateSection("transits");
    return;
  }

  if (action === "lunar-phases") {
    showPrivateSection("prognosis");
    return;
  }

}

async function openPrivateAddChart() {
  showPrivateSection("list");
  await countriesPromise.catch(() => null);
  resetPersonForm();
  setPersonFormOpen(true);
  setPrivateStatus("");
  personForm.elements.name?.focus();
}

async function preparePrivateTransitsSection() {
  if (!privateTransitPersonSelect || !privateTransitDateInput || !privateTransitTable) return;

  const today = localDateInputValue();
  privateTransitDateInput.value = privateTransitDateInput.value || today;
  if (privateTransitsToday) {
    I18n.bind(privateTransitsToday, "textContent", () => T("interface.fecha_actual_value", { v0: formatLongDateForPrivateTransits(today, I18n.locale()) }));
  }

  renderDailyHoroscopeHistory();
  if (!savedPeople.length) await loadPeople();
  renderPrivateTransitPeopleOptions();
  await calculatePrivateTransits();
}

function renderPrivateTransitPeopleOptions() {
  if (!privateTransitPersonSelect) return;

  const previousValue = privateTransitPersonSelect.value;
  const preferredId = previousValue || activePersonId || birthProfile?.personId || savedPeople[0]?.id || "";
  const options = savedPeople.map((person) => `
    <option value="${escapeHtml(person.id)}">${escapeHtml(person.name)} - ${escapeHtml(formatPersonDate(person))}</option>
  `);
  I18n.bind(privateTransitPersonSelect, "innerHTML", () => [`<option value="">${T("interface.selecciona_una_carta")}</option>`, ...options].join(""));
  privateTransitPersonSelect.value = savedPeople.some((person) => String(person.id) === String(preferredId)) ?
  String(preferredId) :
  "";
  privateTransitPersonSelect.disabled = savedPeople.length === 0;
}

function privateTransitOrbLimit() {
  const value = privateTransitOrbFilterSelect?.value || privateTransitFilterOrb || "3";
  if (value === "all") return null;
  const limit = Number(value);
  return Number.isFinite(limit) ? limit : 3;
}

function privateTransitOrbFilterLabel() {
  const limit = privateTransitOrbLimit();
  return limit === null ? T("interface.todos_los_orbes") : T("interface.orbe_de_value_o_menos", { v0: limit });
}

function privateTransitRowsWithinOrb(rows = privateTransitRows) {
  const limit = privateTransitOrbLimit();
  if (limit === null) return rows;
  return rows.filter((row) => Number(row.aspect?.orb || 0) <= limit);
}

function filteredPrivateTransitRows() {
  const rows = privateTransitRowsWithinOrb().filter((row) => isHabitualChartAspect(row.aspect));
  return privateTransitFilterPlanet ?
  rows.filter((row) => row.transitPlanet.key === privateTransitFilterPlanet) :
  rows;
}

function normalizePrivateTransitPlanetFilter() {
  if (!privateTransitFilterPlanet) return;
  const hasPlanet = privateTransitRowsWithinOrb().
  filter((row) => isHabitualChartAspect(row.aspect)).
  some((row) => row.transitPlanet.key === privateTransitFilterPlanet);
  if (!hasPlanet) privateTransitFilterPlanet = "";
}

async function calculatePrivateTransits() {
  if (!privateTransitPersonSelect || !privateTransitDateInput || !privateTransitTable) return;

  const requestId = ++privateTransitRequestId;
  const personId = privateTransitPersonSelect.value;
  const person = savedPeople.find((item) => String(item.id) === String(personId));
  if (!person) {
    privateTransitRows = [];
    privateTransitRenderContext = null;
    privateTransitFilterPlanet = "";
    privateTransitFilterOrb = privateTransitOrbFilterSelect?.value || "3";
    if (privateTransitPlanetFilters) I18n.clear(privateTransitPlanetFilters, "innerHTML");
    I18n.clear(privateTransitTable, "innerHTML");
    renderFeaturedTransitFree(null);
    setPrivateTransitStatus(savedPeople.length ? "Selecciona una carta para calcular los tránsitos." : "Aún no tienes cartas guardadas.", savedPeople.length === 0);
    return;
  }

  const date = privateTransitDateInput.value || localDateInputValue();
  setPrivateTransitStatus("Calculando tránsitos personales...");
  I18n.clear(privateTransitTable, "innerHTML");
  if (featuredTransitFree) I18n.clear(featuredTransitFree, "innerHTML");

  const [natal, transits] = await Promise.all([
  getPrivateTransitNatalCalculation(person),
  fetchTransitCalculationForDate(date)]
  );
  if (requestId !== privateTransitRequestId) return;
  await ensureFreeTransitInterpretations();
  if (requestId !== privateTransitRequestId) return;

  const rows = buildPrivateTransitAspectRows(
    transits.planets || [],
    natal?.charts?.tropical?.planets || [],
    natal?.charts?.tropical?.houses || []
  );
  const featuredTransit = selectFeaturedFreeTransit(transits.planets || [], natal?.charts?.tropical?.planets || []);
  privateTransitRows = rows;
  privateTransitRenderContext = { person, date };
  privateTransitFilterOrb = privateTransitOrbFilterSelect?.value || "3";
  normalizePrivateTransitPlanetFilter();
  renderPrivateTransitPlanetFilters();
  renderPrivateTransitTableFromState();
  renderFeaturedTransitFree(featuredTransit, person, date);
  setPrivateTransitStatus(privateTransitStatusText());
}

async function getPrivateTransitNatalCalculation(person) {
  const cacheKey = String(person.id);
  if (privateTransitNatalCache.has(cacheKey)) return privateTransitNatalCache.get(cacheKey);

  const calculation = await calculateBirthCharts(profileFromSavedPerson(person));
  privateTransitNatalCache.set(cacheKey, calculation);
  return calculation;
}

async function fetchTransitCalculationForDate(date) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  const response = await I18n.fetch(`/api/chart/transits?${params}`);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_calcular_los_transitos"));
  return payload;
}

function buildPrivateTransitAspectRows(transitPlanets = [], natalPlanets = [], houseCusps = []) {
  const natalByOrder = CHART_PLANET_ORDER.
  map((key) => natalPlanets.find((planet) => planet.key === key)).
  filter(Boolean);

  return CHART_PLANET_ORDER.
  map((key) => transitPlanets.find((planet) => planet.key === key)).
  filter(Boolean).
  flatMap((transitPlanet) => natalByOrder.
  map((natalPlanet) => {
    const aspect = findAspectBetween(transitPlanet.longitude, natalPlanet.longitude, houseCusps);
    if (!aspect) return null;
    return {
      transitPlanet,
      natalPlanet,
      aspect
    };
  }).
  filter(Boolean));
}

async function loadFreeTransitInterpretations() {
  try {
    const module = await import("/transit-interpretations/index.js?v=saturn-transits-1");
    const interpretations = Array.isArray(module.transitInterpretations) ? module.transitInterpretations : [];
    const validation = module.validateTransitInterpretations?.(interpretations) || { ok: true, errors: [] };
    if (!validation.ok) {
      throw new Error(validation.errors.join(" "));
    }

    FREE_TRANSIT_INTERPRETATIONS = interpretations;
    FREE_TRANSIT_INTERPRETATION_INDEX = new Map(
      FREE_TRANSIT_INTERPRETATIONS.map((item) => [freeTransitInterpretationKey(item.transit_planet, item.natal_planet, item.aspect), item])
    );
    return FREE_TRANSIT_INTERPRETATIONS;
  } catch (error) {
    console.error("No se pudo cargar la base local de tránsitos.", error);
    FREE_TRANSIT_INTERPRETATIONS = [];
    FREE_TRANSIT_INTERPRETATION_INDEX = new Map();
    return FREE_TRANSIT_INTERPRETATIONS;
  }
}

async function ensureFreeTransitInterpretations() {
  await freeTransitInterpretationsReady;
}

// Calculo gratuito independiente: solo planetas personales/sociales,
// aspectos mayores y orbes estrechos definidos para esta muestra publica.
function selectFeaturedFreeTransit(transitPlanets = [], natalPlanets = []) {
  const exactCandidate = calculateFreeTransitCandidates(transitPlanets, natalPlanets).
  filter((candidate) => candidate.interpretation).
  sort((a, b) => b.totalScore - a.totalScore || a.orbUsed - b.orbUsed)[0] || null;
  if (exactCandidate) return exactCandidate;

  return calculateFreeTransitFallbackCandidates(transitPlanets, natalPlanets).
  sort((a, b) => b.totalScore - a.totalScore || a.orbUsed - b.orbUsed)[0] || null;
}

function calculateFreeTransitCandidates(transitPlanets = [], natalPlanets = []) {
  const natalByKey = Object.fromEntries(
    natalPlanets.
    filter((planet) => FREE_TRANSIT_PLANET_ORDER.includes(planet.key)).
    map((planet) => [planet.key, planet])
  );

  return transitPlanets.
  filter((planet) => FREE_TRANSIT_PLANET_ORDER.includes(planet.key)).
  flatMap((transitPlanet) => FREE_TRANSIT_PLANET_ORDER.map((natalKey) => {
    const natalPlanet = natalByKey[natalKey];
    if (!natalPlanet) return null;

    const aspect = detectFreeTransitAspect(transitPlanet, natalPlanet);
    if (!aspect) return null;

    const transitName = freeTransitPlanetName(transitPlanet.key);
    const natalName = freeTransitPlanetName(natalPlanet.key);
    const interpretation = FREE_TRANSIT_INTERPRETATION_INDEX.get(
      freeTransitInterpretationKey(transitName, natalName, aspect.key)
    );
    const maxOrb = FREE_TRANSIT_ORBS[transitPlanet.key];
    const exactnessScore = (1 - aspect.orbUsed / maxOrb) * 10;
    const totalScore =
    (FREE_TRANSIT_PLANET_SCORES[transitPlanet.key] || 0) + (
    FREE_NATAL_PLANET_SCORES[natalPlanet.key] || 0) +
    aspect.score +
    exactnessScore;

    return {
      transitPlanet,
      natalPlanet,
      aspect,
      interpretation,
      orbUsed: round(aspect.orbUsed, 2),
      exactnessScore: round(exactnessScore, 2),
      totalScore: round(totalScore, 2),
      intensity: freeTransitIntensity(totalScore),
      phase: "exact"
    };
  }).filter(Boolean));
}

function calculateFreeTransitFallbackCandidates(transitPlanets = [], natalPlanets = []) {
  const natalByKey = Object.fromEntries(
    natalPlanets.
    filter((planet) => FREE_TRANSIT_PLANET_ORDER.includes(planet.key)).
    map((planet) => [planet.key, planet])
  );

  return transitPlanets.
  filter((planet) => FREE_TRANSIT_PLANET_ORDER.includes(planet.key)).
  flatMap((transitPlanet) => FREE_TRANSIT_PLANET_ORDER.flatMap((natalKey) => {
    const natalPlanet = natalByKey[natalKey];
    if (!natalPlanet) return [];

    return FREE_TRANSIT_ASPECTS.map((baseAspect) => {
      const transitName = freeTransitPlanetName(transitPlanet.key);
      const natalName = freeTransitPlanetName(natalPlanet.key);
      const interpretation = FREE_TRANSIT_INTERPRETATION_INDEX.get(
        freeTransitInterpretationKey(transitName, natalName, baseAspect.key)
      );
      if (!interpretation) return null;

      const distance = angularDistance(transitPlanet.longitude, natalPlanet.longitude);
      const orbUsed = Math.abs(distance - baseAspect.angle);
      if (orbUsed > FREE_TRANSIT_FALLBACK_MAX_ORB) return null;

      const closenessScore = Math.max(0, 10 - orbUsed * 2);
      const fallbackScore =
      (FREE_TRANSIT_PLANET_SCORES[transitPlanet.key] || 0) + (
      FREE_NATAL_PLANET_SCORES[natalPlanet.key] || 0) +
      baseAspect.score +
      closenessScore;

      return {
        transitPlanet,
        natalPlanet,
        aspect: {
          ...baseAspect,
          distance,
          orbUsed
        },
        interpretation,
        orbUsed: round(orbUsed, 2),
        closenessScore: round(closenessScore, 2),
        totalScore: round(fallbackScore, 2),
        intensity: freeTransitIntensity(fallbackScore),
        phase: "fallback"
      };
    }).filter(Boolean);
  }));
}

function detectFreeTransitAspect(transitPlanet, natalPlanet) {
  const maxOrb = FREE_TRANSIT_ORBS[transitPlanet.key];
  if (!maxOrb) return null;

  const distance = angularDistance(transitPlanet.longitude, natalPlanet.longitude);
  return FREE_TRANSIT_ASPECTS.
  map((aspect) => ({
    ...aspect,
    distance,
    orbUsed: Math.abs(distance - aspect.angle)
  })).
  filter((aspect) => aspect.orbUsed <= maxOrb).
  sort((a, b) => a.orbUsed - b.orbUsed)[0] || null;
}

function angularDistance(longitudeA, longitudeB) {
  const rawDistance = Math.abs(normalizeDegrees(longitudeA) - normalizeDegrees(longitudeB));
  return Math.min(rawDistance, 360 - rawDistance);
}

function normalizeDegrees(value) {
  const normalized = Number(value) % 360;
  return normalized < 0 ? normalized + 360 : normalized;
}

function freeTransitPlanetName(key) {
  return FREE_TRANSIT_PLANET_NAMES[key] || PROMPT_PLANET_LABELS[key] || key;
}

function freeTransitInterpretationKey(transitPlanet, natalPlanet, aspect) {
  return [transitPlanet, natalPlanet, aspect].map(normalizeFreeTransitKeyPart).join("|");
}

function normalizeFreeTransitKeyPart(value) {
  return String(value || "").
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  toLowerCase().
  trim();
}

function freeTransitIntensity(score) {
  if (score >= 34) return "alta";
  if (score >= 26) return "media";
  return "baja";
}

function renderFeaturedTransitFree(featuredTransit, person, date) {
  if (!featuredTransitFree) return;

  const dateLabel = formatLongDateForPrivateTransits(date || localDateInputValue(), I18n.locale());
  if (!person) {
    I18n.clear(featuredTransitFree, "innerHTML");
    return;
  }

  if (!featuredTransit) {
    I18n.bind(featuredTransitFree, "innerHTML", () => `
      <article class="featured-transit-card featured-transit-empty">
        <div class="featured-transit-head">
          <div>
            <p class="eyebrow">${T("interface.transito_destacado_de_hoy")}</p>
            <h3>${escapeHtml(person.name)} - ${escapeHtml(formatLongDateForPrivateTransits(date || localDateInputValue(), I18n.locale()))}</h3>
          </div>
        </div>
        <p>${T("interface.hoy_no_hay_un_contacto_suficientemente_cercano_entre_los_transitos_gratuitos_y_tu_car")}</p>
        <small>${T("interface.esta_lectura_es_simbolica_y_orientativa_no_sustituye_asesoramiento_medico_psicologico")}</small>
      </article>
    `);
    return;
  }

  const { transitPlanet, natalPlanet, aspect, interpretation, intensity, totalScore, orbUsed } = featuredTransit;
  const isFallback = featuredTransit.phase === "fallback";
  const sectionTitle = I18n.label(isFallback ? "Tránsito cercano de hoy" : "Tránsito destacado de hoy");
  I18n.bind(featuredTransitFree, "innerHTML", () => `
    <article class="featured-transit-card">
      <div class="featured-transit-head">
        <div>
          <p class="eyebrow">${escapeHtml(I18n.label(isFallback ? "Tránsito cercano de hoy" : "Tránsito destacado de hoy"))}</p>
          <h3>${escapeHtml(I18n.transit(interpretation, "title"))}</h3>
          <p>${escapeHtml(person.name)} - ${escapeHtml(formatLongDateForPrivateTransits(date || localDateInputValue(), I18n.locale()))}</p>
        </div>
        <span class="featured-transit-intensity intensity-${escapeHtml(intensity)}">${escapeHtml(T('transitInterface.intensity', { get value() {return T('transitInterface.intensity_' + intensity);} }))}</span>
      </div>
      ${isFallback ? `<p class="featured-transit-note">${T("interface.hoy_no_hay_un_transito_exacto_dentro_del_orbe_gratuito_pero_este_es_el_contacto_mas_c")}</p>` : ""}
      <dl class="featured-transit-meta">
        <div>
          <dt>${T("interface.transito")}</dt>
          <dd style="color:${chartPlanetColorCssValue(transitPlanet.key, "var(--text)")}">${escapeHtml(planetGlyph(transitPlanet.key))} ${escapeHtml(I18n.label(I18n.label(freeTransitPlanetName(transitPlanet.key))))}</dd>
        </div>
        <div>
          <dt>${T("interface.aspecto")}</dt>
          <dd><span class="aspect-symbol" style="color:${chartAspectColorCssValue(aspect.angle)}">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || aspect.angle)}</span> ${escapeHtml(I18n.label(aspect.label))}</dd>
        </div>
        <div>
          <dt>${T("interface.natal")}</dt>
          <dd style="color:${chartPlanetColorCssValue(natalPlanet.key, "var(--text)")}">${escapeHtml(planetGlyph(natalPlanet.key))} ${escapeHtml(I18n.label(I18n.label(freeTransitPlanetName(natalPlanet.key))))}</dd>
        </div>
        <div>
          <dt>${T("interface.orbe")}</dt>
          <dd>${formatOrb(orbUsed)}º</dd>
        </div>
      </dl>
      <div class="featured-transit-copy">
        <section>
          <h4>${T("interface.tono")}</h4>
          <p>${escapeHtml(I18n.transit(interpretation, "tone"))}</p>
        </section>
        <section>
          <h4>${T("interface.mecanismo")}</h4>
          <p>${escapeHtml(I18n.transit(interpretation, "mechanism"))}</p>
        </section>
        <section>
          <h4>${T("interface.escena_posible")}</h4>
          <p>${escapeHtml(I18n.transit(interpretation, "scene"))}</p>
        </section>
        <section>
          <h4>${T("interface.pregunta_de_observacion")}</h4>
          <p>${escapeHtml(I18n.transit(interpretation, "question"))}</p>
        </section>
      </div>
      <p class="featured-transit-premium">${escapeHtml(I18n.transit(interpretation, "premium_hint"))}</p>
      <small>${T("interface.esta_lectura_es_simbolica_y_orientativa_no_sustituye_asesoramiento_medico_psicologico")}</small>
    </article>
  `);
}

function renderPrivateTransitPlanetFilters() {
  if (!privateTransitPlanetFilters) return;

  normalizePrivateTransitPlanetFilter();
  const rowsWithinOrb = privateTransitRowsWithinOrb().filter((row) => isHabitualChartAspect(row.aspect));
  const planets = CHART_PLANET_ORDER.
  map((key) => rowsWithinOrb.find((row) => row.transitPlanet.key === key)?.transitPlanet).
  filter(Boolean);

  if (!planets.length) {
    I18n.clear(privateTransitPlanetFilters, "innerHTML");
    return;
  }

  I18n.bind(privateTransitPlanetFilters, "innerHTML", ((__i18nSnapshot0) => () => `
    <button type="button" data-transit-planet-filter="" class="${__i18nSnapshot0 ? "" : "active"}">${T("common.all")}</button>
    ${planets.map((planet) => `
      <button type="button" data-transit-planet-filter="${escapeHtml(planet.key)}" class="${__i18nSnapshot0 === planet.key ? "active" : ""}" aria-label="${T("interface.filtrar_por_value", { v2: escapeHtml(I18n.label(I18n.label(planet.label))) })}" title="${escapeHtml(I18n.label(planet.label))}">
        <span style="color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}</span>
      </button>
    `).join("")}
  `)(privateTransitFilterPlanet));
}

function renderPrivateTransitTableFromState() {
  if (!privateTransitTable || !privateTransitRenderContext) return;

  normalizePrivateTransitPlanetFilter();
  const rows = filteredPrivateTransitRows();
  I18n.bind(privateTransitTable, "innerHTML", ((__i18nSnapshot0) => () => renderPrivateTransitAspectTable(rows, __i18nSnapshot0.person, __i18nSnapshot0.date))(privateTransitRenderContext));
  setPrivateTransitStatus(privateTransitStatusText());
}

function renderPrivateTransitAspectTable(rows, person, date) {
  const dateLabel = formatLongDateForPrivateTransits(date, I18n.locale());
  const orbLabel = privateTransitOrbFilterLabel();
  const filterLabel = privateTransitFilterPlanet ? T("interface.filtro_value", { v0: PROMPT_PLANET_LABELS[privateTransitFilterPlanet] || privateTransitFilterPlanet }) :

  "";
  const orbSummary = ` Mostrando ${orbLabel}.`;
  const body = rows.length ?
  rows.map(({ transitPlanet, natalPlanet, aspect }) => `
      <tr>
        <td style="color:${chartPlanetColorCssValue(transitPlanet.key, "var(--text)")}"><span class="table-planet-glyph${balancedPlanetGlyphClass(transitPlanet.key)}">${escapeHtml(planetGlyph(transitPlanet.key))}</span> ${escapeHtml(I18n.label(transitPlanet.label))}</td>
        <td><span class="aspect-symbol" style="color:${chartAspectColorCssValue(aspect.angle)}">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || aspect.angle)}</span> ${escapeHtml(I18n.label(aspect.name))}</td>
        <td style="color:${chartPlanetColorCssValue(natalPlanet.key, "var(--text)")}"><span class="table-planet-glyph${balancedPlanetGlyphClass(natalPlanet.key)}">${escapeHtml(planetGlyph(natalPlanet.key))}</span> ${escapeHtml(I18n.label(natalPlanet.label))}</td>
        <td>${formatOrb(aspect.orb)}º</td>
      </tr>
    `).join("") : `<tr><td colspan="4">${T("interface.no_hay_aspectos_mayores_que_coincidan_con_los_filtros_actuales")}</td></tr>`;


  return `
    <section class="private-transit-results">
      <div>
        <h3>${escapeHtml(person.name)} - ${escapeHtml(dateLabel)}</h3>
        <p>${T("interface.aspectos_de_los_planetas_en_transito_a_la_carta_natal_tropical_valuevalue", { v2: escapeHtml(orbSummary), v3: escapeHtml(filterLabel) })}</p>
      </div>
      <div class="private-transit-table-wrap">
        <table>
          <thead>
            <tr>
              <th>${T("interface.transito")}</th>
              <th>${T("interface.aspecto")}</th>
              <th>${T("interface.natal")}</th>
              <th>${T("interface.orbe")}</th>
            </tr>
          </thead>
          <tbody>${body}</tbody>
        </table>
      </div>
    </section>
  `;
}

function privateTransitStatusText() {
  if (!privateTransitRows.length) return "No hay aspectos mayores para esta fecha.";

  const filteredCount = filteredPrivateTransitRows().length;
  const totalCount = privateTransitRows.length;
  const planetLabel = privateTransitFilterPlanet ?
  ` y ${PROMPT_PLANET_LABELS[privateTransitFilterPlanet] || privateTransitFilterPlanet}` :
  "";
  return `${filteredCount} de ${totalCount} aspectos mostrados con ${privateTransitOrbFilterLabel()}${planetLabel}.`;
}

function setPrivateTransitStatus(text, isError = false) {
  if (!privateTransitStatus) return;
  I18n.bind(privateTransitStatus, "textContent", () => text || "");
  privateTransitStatus.classList.toggle("error", Boolean(isError));
}

async function generateDailyHoroscope() {
  if (!currentUser) throw new Error(T("interface.inicia_sesion_para_consultar_los_transitos_personales"));
  if (!privateTransitRenderContext) throw new Error(T("interface.primero_selecciona_una_persona_y_calcula_sus_transitos"));

  const { person, date } = privateTransitRenderContext;
  const aspects = filteredPrivateTransitRows().
  slice().
  sort((a, b) => Number(a.aspect.orb || 0) - Number(b.aspect.orb || 0)).
  slice(0, 12).
  map(({ transitPlanet, natalPlanet, aspect }) => ({
    transitPlanet: transitPlanet.key,
    transitPlanetLabel: transitPlanet.label,
    natalPlanet: natalPlanet.key,
    natalPlanetLabel: natalPlanet.label,
    aspectName: aspect.name,
    angle: aspect.angle,
    orb: aspect.orb
  }));

  generateDailyHoroscopeButton.disabled = true;
  setPrivateTransitStatus(() => T("interface.consultando_transitos_personales"));
  if (dailyHoroscopeUsage) I18n.clear(dailyHoroscopeUsage, "textContent");

  try {
    const response = await I18n.fetch("/api/private/daily-horoscope", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        personId: person.id,
        personName: person.name,
        date,
        dateLabel: formatLongDateForPrivateTransits(date),
        modelLevel: "balanced",
        aspects
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_consultar_los_transitos_personales"));

    const horoscope = {
      id: `horoscope-${Date.now()}`, get
      title() {return payload.title || T("interface.transitos_personales_value", { v0: person.name });},
      personId: String(person.id),
      personName: person.name,
      date,
      dateLabel: payload.dateLabel || formatLongDateForPrivateTransits(date),
      content: payload.content || "",
      usage: payload.usage || null,
      createdAt: new Date().toISOString()
    };
    if (payload.usage) {
      applyUsageUpdate(payload.usage);
      if (dailyHoroscopeUsage) I18n.clear(dailyHoroscopeUsage, "textContent");
    }
    openDailyHoroscopeModal(horoscope);
    setPrivateTransitStatus(() => T("interface.transitos_personales_generados"));
  } finally {
    generateDailyHoroscopeButton.disabled = false;
  }
}

function openDailyHoroscopeModal(horoscope, options = {}) {
  currentDailyHoroscope = horoscope;
  if (dailyHoroscopeSubtitle) {
    I18n.bind(dailyHoroscopeSubtitle, "textContent", () => `${horoscope.personName} · ${horoscope.dateLabel || formatLongDateForPrivateTransits(horoscope.date)}`);
  }
  if (dailyHoroscopeContent) {
    I18n.bind(dailyHoroscopeContent, "textContent", () => horoscope.content || "");
  }
  if (saveDailyHoroscopeButton) saveDailyHoroscopeButton.disabled = Boolean(options.fromHistory);
  dailyHoroscopeDialog?.showModal();
}

function saveDailyHoroscopeToHistory(horoscope) {
  const history = readDailyHoroscopeHistory();
  const next = [
  { ...horoscope, savedAt: new Date().toISOString() },
  ...history.filter((entry) => entry.id !== horoscope.id)].
  slice(0, 30);
  localStorage.setItem(dailyHoroscopeHistoryKey(), JSON.stringify(next));
  renderDailyHoroscopeHistory();
  if (saveDailyHoroscopeButton) saveDailyHoroscopeButton.disabled = true;
}

function readDailyHoroscopeHistory() {
  try {
    return JSON.parse(localStorage.getItem(dailyHoroscopeHistoryKey()) || "[]");
  } catch {
    return [];
  }
}

function renderDailyHoroscopeHistory() {
  if (!dailyHoroscopeHistoryList) return;
  const history = readDailyHoroscopeHistory();
  if (clearDailyHoroscopeHistoryButton) clearDailyHoroscopeHistoryButton.disabled = history.length === 0;
  I18n.bind(dailyHoroscopeHistoryList, "innerHTML", () => history.length ? history.map((item) => `
      <li>
        <button type="button" data-horoscope-history-id="${escapeHtml(item.id)}">
          <span>${escapeHtml(item.personName || T("interface.transitos_personales"))}</span>
          <small>${escapeHtml(item.dateLabel || formatLongDateForPrivateTransits(item.date))} · ${escapeHtml(formatChatDate(item.createdAt || item.savedAt || ""))}</small>
        </button>
      </li>
    `).join("") : `<li class="daily-horoscope-empty">${T("interface.aun_no_has_guardado_transitos_personales")}</li>`);


}

function dailyHoroscopeHistoryKey() {
  return `dailyHoroscopeHistory:${currentUser?.id || currentUser?.email || "local"}`;
}

function downloadDailyHoroscope(horoscope) {
  const text = [
  horoscope.title || "Tránsitos personales",
  `${horoscope.personName || ""} · ${horoscope.dateLabel || formatLongDateForPrivateTransits(horoscope.date)}`,
  "",
  horoscope.content || ""].
  join("\n");
  const filename = `transitos-personales-${slugId(horoscope.personName || "eliseo")}-${slugId(horoscope.date || localDateInputValue())}.txt`;
  downloadBlob(new Blob([text], { type: "text/plain;charset=utf-8" }), filename);
}

function localDateInputValue(date = new Date()) {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
}

function formatLongDateForPrivateTransits(value, locale = "es-ES") {
  const [year, month, day] = String(value || localDateInputValue()).split("-").map(Number);
  if (!year || !month || !day) return "";
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(new Date(year, month - 1, day));
}

function renderBillingUI() {
  if (!billingContent || !billingMode || !billingPanel) return;
  const authenticated = Boolean(currentUser);
  const isBillingSection = ["plans", "reports", "store"].includes(activePrivateSection);
  billingPanel.classList.toggle("is-hidden", !authenticated || !isBillingSection);
  billingPanel.classList.toggle("is-store-section", authenticated && activePrivateSection === "store");
  billingPanel.classList.toggle("is-subscription-section", authenticated && activePrivateSection === "plans");
  if (activePrivateSection === "store") {
    const storedCart = loadStoreCart();
    storeCart = storedCart.filter(isStoreCartItemAvailable);
    if (storeCart.length !== storedCart.length) saveStoreCart();
  }
  syncStoreCartHeader();

  if (!authenticated) {
    I18n.clear(billingContent, "innerHTML");
    I18n.clear(billingMode, "textContent");
    return;
  }

  if (!isBillingSection) return;

  const sectionCopy = { get
    reports() {return { get eyebrow() {return T("public-offers.reports");}, get title() {return T("public-offers.reports");}, loading: "Cargando informes...", get subtitle() {return T("interface.solicita_informes_preparados_para_revision_profesional_cuando_necesites_una_lectura_m");} };}, get





    store() {return { get eyebrow() {return T("public-offers.store");}, get title() {return T("interface.tienda_astroanamnesis");}, loading: "Cargando tienda...", get subtitle() {return T("interface.libros_y_productos_para_acompanar_la_practica_de_astroanamnesis");} };}, get





    plans() {return { get eyebrow() {return T("public-offers.subscription");}, get title() {return T("public-offers.subscription");}, loading: "Cargando suscripción...", get subtitle() {return T("interface.conoce_las_funciones_previstas_para_ampliar_tu_espacio_de_trabajo");} };}





  }[activePrivateSection];

  if (billingEyebrow) I18n.bind(billingEyebrow, "textContent", ((__i18nSnapshot0) => () => ({ get reports() {return { get eyebrow() {return T("public-offers.reports");}, get title() {return T("public-offers.reports");}, loading: "Cargando informes...", get subtitle() {return T("interface.solicita_informes_preparados_para_revision_profesional_cuando_necesites_una_lectura_m");} };}, get store() {return { get eyebrow() {return T("public-offers.store");}, get title() {return T("interface.tienda_astroanamnesis");}, loading: "Cargando tienda...", get subtitle() {return T("interface.libros_y_productos_para_acompanar_la_practica_de_astroanamnesis");} };}, get plans() {return { get eyebrow() {return T("public-offers.subscription");}, get title() {return T("public-offers.subscription");}, loading: "Cargando suscripción...", get subtitle() {return T("interface.conoce_las_funciones_previstas_para_ampliar_tu_espacio_de_trabajo");} };} })[__i18nSnapshot0].eyebrow)(activePrivateSection));
  if (billingTitle) I18n.bind(billingTitle, "textContent", ((__i18nSnapshot0) => () => ({ get reports() {return { get eyebrow() {return T("public-offers.reports");}, get title() {return T("public-offers.reports");}, loading: "Cargando informes...", get subtitle() {return T("interface.solicita_informes_preparados_para_revision_profesional_cuando_necesites_una_lectura_m");} };}, get store() {return { get eyebrow() {return T("public-offers.store");}, get title() {return T("interface.tienda_astroanamnesis");}, loading: "Cargando tienda...", get subtitle() {return T("interface.libros_y_productos_para_acompanar_la_practica_de_astroanamnesis");} };}, get plans() {return { get eyebrow() {return T("public-offers.subscription");}, get title() {return T("public-offers.subscription");}, loading: "Cargando suscripción...", get subtitle() {return T("interface.conoce_las_funciones_previstas_para_ampliar_tu_espacio_de_trabajo");} };} })[__i18nSnapshot0].title)(activePrivateSection));

  if (!billingSummary) {
    I18n.bind(billingMode, "textContent", ((__i18nSnapshot0) => () => ({ get reports() {return { get eyebrow() {return T("public-offers.reports");}, get title() {return T("public-offers.reports");}, loading: "Cargando informes...", get subtitle() {return T("interface.solicita_informes_preparados_para_revision_profesional_cuando_necesites_una_lectura_m");} };}, get store() {return { get eyebrow() {return T("public-offers.store");}, get title() {return T("interface.tienda_astroanamnesis");}, loading: "Cargando tienda...", get subtitle() {return T("interface.libros_y_productos_para_acompanar_la_practica_de_astroanamnesis");} };}, get plans() {return { get eyebrow() {return T("public-offers.subscription");}, get title() {return T("public-offers.subscription");}, loading: "Cargando suscripción...", get subtitle() {return T("interface.conoce_las_funciones_previstas_para_ampliar_tu_espacio_de_trabajo");} };} })[__i18nSnapshot0].loading)(activePrivateSection));
    I18n.clear(billingContent, "innerHTML");
    return;
  }

  I18n.bind(billingMode, "textContent", ((__i18nSnapshot0) => () => ({ get reports() {return { get eyebrow() {return T("public-offers.reports");}, get title() {return T("public-offers.reports");}, loading: "Cargando informes...", get subtitle() {return T("interface.solicita_informes_preparados_para_revision_profesional_cuando_necesites_una_lectura_m");} };}, get store() {return { get eyebrow() {return T("public-offers.store");}, get title() {return T("interface.tienda_astroanamnesis");}, loading: "Cargando tienda...", get subtitle() {return T("interface.libros_y_productos_para_acompanar_la_practica_de_astroanamnesis");} };}, get plans() {return { get eyebrow() {return T("public-offers.subscription");}, get title() {return T("public-offers.subscription");}, loading: "Cargando suscripción...", get subtitle() {return T("interface.conoce_las_funciones_previstas_para_ampliar_tu_espacio_de_trabajo");} };} })[__i18nSnapshot0].subtitle)(activePrivateSection));

  if (activePrivateSection === "reports") {
    I18n.bind(billingContent, "innerHTML", () => renderReportsSection());
    return;
  }

  if (activePrivateSection === "store") {
    I18n.bind(billingContent, "innerHTML", () => renderStoreSection());
    renderStoreCartDialog();
    return;
  }

  I18n.bind(billingContent, "innerHTML", () => renderSubscriptionPanel());
}

function renderReportsSection() {
  const visibleProducts = billingSummary.serviceProducts.filter((product) => {
    const moduleKey = REPORT_VISIBILITY_MODULES[product.key];
    return !moduleKey || isModuleEnabled(moduleKey);
  });
  const hasUpcomingProducts = visibleProducts.some((product) => product.available === false);

  return `
    <section class="billing-section reports-section">
      ${hasUpcomingProducts ? `
        <div class="reports-availability-notice" role="note">
          <span class="reports-availability-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false">
              <circle cx="12" cy="12" r="8.5"></circle>
              <path d="M12 7.5v5l3.5 2"></path>
            </svg>
          </span>
          <div>
            <strong>${T("interface.nuevos_informes_en_preparacion")}</strong>
            <p>${T("interface.los_informes_identificados_como_proximamente_todavia_no_admiten_solicitudes")}</p>
          </div>
        </div>
      ` : ""}
      <div class="billing-grid reports-grid">
        ${visibleProducts.map((product) => {
    const isComingSoon = product.available === false;
    return `
          <article class="commerce-card report-card${isComingSoon ? " is-coming-soon" : ""}" data-report-product="${escapeHtml(product.key)}">
            <div class="report-card-copy">
              ${isComingSoon ? `<span class="report-card-status">${escapeHtml(I18n.label(I18n.label(product.availabilityLabel) || T("public-offers.soon")))}</span>` : ""}
              <b>${escapeHtml(I18n.label(product.label))}</b>
              <small>${escapeHtml(I18n.label(I18n.label(product.description)))}</small>
            </div>
            ${isComingSoon ? `
              <button class="btn-small report-card-action report-card-action-disabled" type="button" disabled>${T("interface.aun_no_disponible")}</button>
            ` : `
              <span class="report-card-price">${escapeHtml(I18n.label(I18n.label(product.priceLabel)))}</span>
              <button class="btn-small report-card-action" type="button" data-purchase-kind="service" data-purchase-key="${escapeHtml(product.key)}">${T("interface.comprar_informe")}</button>
            `}
          </article>
        `;
  }).join("")}
      </div>
    </section>
  `;
}

function storeProductHasDetails(product) {
  return Boolean(product?.showDetails || product?.longDescription?.length || product?.gallery?.length);
}

function renderStoreSection() {
  const products = (billingSummary.storeProducts || []).filter(isStoreProductVisible);
  const cartEnabled = isModuleEnabled("storeCart");

  return `
    <section class="store-section" aria-label="${T("interface.productos_de_astroanamnesis")}">
      <div class="store-grid">
        ${products.map((product) => `
          <article class="store-card ${storeProductHasDetails(product) ? "has-details" : ""}${product.available === false ? " is-coming-soon" : ""}" data-store-product="${escapeHtml(product.key)}" data-store-category="${escapeHtml(I18n.label(product.category))}">
              ${T("interface.value_class_store_card_media_value", { v4: storeProductHasDetails(product) ? "button" : "div", get v5() {return storeProductHasDetails(product) ? `type="button" data-store-product-details="${escapeHtml(product.key)}" aria-label="${escapeHtml(T('products.viewDetails', { value: I18n.label(product.label) }))}"` : "";} })}
                <img data-store-product-image src="${escapeHtml(product.image)}" alt="${escapeHtml(I18n.label(product.label))}">
              </${storeProductHasDetails(product) ? "button" : "div"}>
              <div class="store-card-copy">
                <span>${escapeHtml(I18n.label(I18n.label(product.category)))}</span>
                <h3>
                  ${storeProductHasDetails(product) ? `<button type="button" class="store-card-title-button" data-store-product-details="${escapeHtml(product.key)}">${escapeHtml(I18n.label(product.label))}</button>` : escapeHtml(product.label)}
                </h3>
                ${product.subtitle ? `<b>${escapeHtml(I18n.label(I18n.label(product.subtitle)))}</b>` : ""}
                ${product.author ? `<small>${T("interface.por_value", { v0: escapeHtml(product.author) })}</small>` : ""}
                <p>${escapeHtml(I18n.label(I18n.label(product.description)))}</p>
                ${storeProductHasDetails(product) ? `
                  <button class="store-product-details-button" type="button" data-store-product-details="${escapeHtml(product.key)}">${product.category === "Libro" ? T("interface.ver_detalles_del_libro") : T("interface.ver_detalles_del_producto")}</button>
                ` : ""}
              </div>
              ${(product.optionGroups || []).length ? `
                <div class="store-option-grid">
                  ${product.optionGroups.map((group) => `
                    <label class="store-option-field">
                      <span>${escapeHtml(I18n.label(group.label))}</span>
                      <select data-store-option="${escapeHtml(group.key)}" ${group.required ? "required" : ""}>
                        ${group.key === "design" ? "" : `<option value="">${T("interface.seleccionar")}</option>`}
                        ${(group.options || []).map((option, optionIndex) => `
                          <option
                            value="${escapeHtml(option.value)}"
                            ${option.image ? `data-option-image="${escapeHtml(option.image)}"` : ""}
                            ${group.key === "design" && optionIndex === 0 ? "selected" : ""}
                          >${escapeHtml(I18n.label(option.label))}</option>
                        `).join("")}
                      </select>
                    </label>
                  `).join("")}
                </div>
              ` : ""}
              ${product.available === false ? `
                <div class="store-card-footer store-card-footer--upcoming">
                  <span class="store-card-availability">${escapeHtml(I18n.label(I18n.label(product.availabilityLabel) || T("public-offers.soon")))}</span>
                </div>
              ` : product.externalPurchaseUrl ? `
                <div class="store-card-footer store-card-footer--external">
                  <a
                    class="btn-small store-external-purchase-link"
                    href="${escapeHtml(product.externalPurchaseUrl)}"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="${T("interface.comprar_value_en_amazon_se_abre_en_una_pestana_nueva", { v1: escapeHtml(I18n.label(I18n.label(product.label))) })}"
                  >${T("interface.comprar_en_amazon")}</a>
                </div>
              ` : cartEnabled ? `
                <div class="store-purchase-controls">
                  <label class="store-quantity-field">
                    <span>${T("interface.cantidad")}</span>
                    <span class="store-quantity-control">
                      <button type="button" data-store-card-quantity-change="-1" aria-label="${T("interface.reducir_cantidad")}">−</button>
                      <input type="number" min="1" max="99" value="1" inputmode="numeric" data-store-card-quantity aria-label="${T("interface.cantidad_de_value", { v0: escapeHtml(I18n.label(I18n.label(product.label))) })}">
                      <button type="button" data-store-card-quantity-change="1" aria-label="${T("interface.aumentar_cantidad")}">+</button>
                    </span>
                  </label>
                </div>
                <div class="store-card-footer">
                  <strong>${escapeHtml(I18n.label(I18n.label(product.priceLabel)))}</strong>
                  <button class="btn-small" type="button" data-store-cart-add>${T("interface.anadir_al_carrito")}</button>
                </div>
              ` : `
                <div class="store-card-footer">
                  <strong>${escapeHtml(I18n.label(I18n.label(product.priceLabel)))}</strong>
                </div>
              `}
          </article>
        `).join("")}
      </div>
    </section>
  `;





}

function storeCartStorageKey() {
  const accountKey = currentUser?.id || currentUser?.email || "guest";
  return `${STORE_CART_STORAGE_PREFIX}:${encodeURIComponent(String(accountKey).toLowerCase())}`;
}

function loadStoreCart() {
  try {
    const stored = JSON.parse(localStorage.getItem(storeCartStorageKey()) || "[]");
    if (!Array.isArray(stored)) return [];
    return stored.slice(0, 40).map((item) => ({
      productKey: String(item?.productKey || ""),
      quantity: Math.min(99, Math.max(1, Number.parseInt(item?.quantity, 10) || 1)),
      options: item?.options && typeof item.options === "object" && !Array.isArray(item.options) ?
      { ...item.options } :
      {}
    })).filter((item) => item.productKey);
  } catch {
    return [];
  }
}

function saveStoreCart() {
  try {
    localStorage.setItem(storeCartStorageKey(), JSON.stringify(storeCart));
  } catch {

    // El carrito sigue disponible en memoria si el navegador bloquea localStorage.
  }}

function storeCartLineSignature(item) {
  const options = Object.entries(item.options || {}).
  sort(([left], [right]) => left.localeCompare(right)).
  map(([key, value]) => `${key}:${value}`).
  join("|");
  return `${item.productKey}|${options}`;
}

function getStoreProduct(productKey) {
  return (billingSummary?.storeProducts || []).find((product) =>
  product.key === productKey && isStoreProductVisible(product)
  );
}

function storeCategoryModuleKey(category = "") {
  const normalizedCategory = String(category || "").
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  trim().
  toLowerCase();
  return STORE_CATEGORY_VISIBILITY_MODULES[normalizedCategory] || "";
}

function isStoreProductVisible(product) {
  const moduleKey = storeCategoryModuleKey(product?.category);
  return !moduleKey || isModuleEnabled(moduleKey);
}

function isStoreCartItemAvailable(item) {
  const product = getStoreProduct(item?.productKey);
  if (!product || product.externalPurchaseUrl || product.available === false) return false;

  return (product.optionGroups || []).every((group) => {
    const selectedValue = String(item?.options?.[group.key] || "");
    const isValidOption = (group.options || []).some((option) => option.value === selectedValue);
    return group.required ? isValidOption : !selectedValue || isValidOption;
  });
}

function openStoreProductDetails(productKey, options = {}) {
  const product = getStoreProduct(productKey);
  if (!product || !storeProductDialog || !storeProductDialogContent) return;
  const gallery = product.gallery?.length ?
  product.gallery :
  [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }];
  const initialImagePath = new URL(options.initialImage || gallery[0].src, window.location.href).pathname;
  const initialImageIndex = Math.max(0, gallery.findIndex((image) =>
  new URL(image.src, window.location.href).pathname === initialImagePath
  ));
  const initialImage = gallery[initialImageIndex];
  const descriptionParagraphs = product.longDescription || [product.description];

  I18n.bind(storeProductDialogContent, "innerHTML", () => `
    <article class="store-product-modal">
      <button class="store-product-modal-close" type="button" data-store-product-close aria-label="${T("interface.cerrar_detalles")}" title="${T("public-offers.close")}">×</button>
      <div class="store-product-modal-media">
        <button
          class="store-product-modal-image-stage"
          type="button"
          data-store-product-image-zoom
          aria-label="${T("interface.ampliar_value_de_value", { v0: escapeHtml(I18n.label(I18n.label((product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[Math.max(0, (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).findIndex((image) => new URL(image.src, window.location.href).pathname === new URL(options.initialImage || (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[0].src, window.location.href).pathname))].label.toLowerCase()))), v1: escapeHtml(I18n.label(I18n.label(product.label))) })}"
        >
          <span class="store-product-modal-image-frame ${product.category === "LIBRO" ? "is-book" : ""}">
            <img
              class="store-product-modal-main-image"
              data-store-product-detail-image
              src="${escapeHtml((product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[Math.max(0, (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).findIndex((image) => new URL(image.src, window.location.href).pathname === new URL(options.initialImage || (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[0].src, window.location.href).pathname))].src)}"
              alt="${T("interface.value_de_value", { v4: escapeHtml(I18n.label(I18n.label((product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[Math.max(0, (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).findIndex((image) => new URL(image.src, window.location.href).pathname === new URL(options.initialImage || (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[0].src, window.location.href).pathname))].label))), v5: escapeHtml(I18n.label(I18n.label(product.label))) })}"
            >
            <span class="store-product-image-zoom-hint" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="11" cy="11" r="7"></circle>
                <path d="m20 20-4-4"></path>
              </svg>
            </span>
          </span>
        </button>
        ${(product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).length > 1 ? `
          <div class="store-product-media-toolbar">
            <div class="store-product-gallery" aria-label="${T("interface.imagenes_de_value", { v0: escapeHtml(I18n.label(I18n.label(product.label))) })}">
              ${(product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).map((image, index) => `
                <button
                  type="button"
                  data-store-product-gallery-image="${escapeHtml(image.src)}"
                  data-store-product-gallery-label="${escapeHtml(image.label)} de ${escapeHtml(product.label)}"
                  aria-label="${T("interface.ver_value", { v3: escapeHtml(I18n.label(I18n.label(image.label.toLowerCase()))) })}"
                  aria-pressed="${index === Math.max(0, (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }]).findIndex((image) => new URL(image.src, window.location.href).pathname === new URL(options.initialImage || (product.gallery?.length ? product.gallery : [{ src: product.image, get label() {return product.category === "Libro" ? T("interface.portada") : product.label;} }])[0].src, window.location.href).pathname))}"
                >
                  <img src="${escapeHtml(image.src)}" alt="">
                </button>
              `).join("")}
            </div>
          </div>
        ` : ""}
      </div>
      <div class="store-product-modal-body">
        <div class="store-product-modal-scroll">
          <header>
            <span>${escapeHtml(I18n.label(I18n.label(product.category)))}</span>
            <h2 id="store-product-dialog-title">${escapeHtml(I18n.label(product.label))}</h2>
            ${product.subtitle ? `<strong>${escapeHtml(I18n.label(I18n.label(product.subtitle)))}</strong>` : ""}
            ${product.author ? `<p>${T("interface.por_value", { v0: escapeHtml(product.author) })}</p>` : ""}
          </header>
          ${(product.details || []).length ? `
            <dl class="store-product-facts">
              ${product.details.map((detail) => `
                <div>
                  <dt>${escapeHtml(I18n.label(detail.label))}</dt>
                  <dd>${escapeHtml(I18n.label(I18n.label(detail.value)))}</dd>
                </div>
              `).join("")}
            </dl>
          ` : ""}
          <div class="store-product-description">
            ${product.lead ? `<p class="store-product-lead">${escapeHtml(I18n.label(I18n.label(product.lead)))}</p>` : ""}
            ${descriptionParagraphs[0] ? `<p>${escapeHtml(I18n.label(I18n.label(descriptionParagraphs[0])))}</p>` : ""}
            ${(product.highlights || []).length ? `
              <ul class="store-product-highlights">
                ${product.highlights.map((highlight) => `
                  <li>
                    <b>${escapeHtml(I18n.label(I18n.label(highlight.title)))}</b>
                    <span>${escapeHtml(I18n.label(I18n.label(highlight.description)))}</span>
                  </li>
                `).join("")}
              </ul>
            ` : ""}
            ${descriptionParagraphs.slice(1).map((paragraph) => `<p>${escapeHtml(I18n.label(I18n.label(paragraph)))}</p>`).join("")}
            ${product.disclaimer ? `<p class="store-product-disclaimer">${escapeHtml(I18n.label(I18n.label(product.disclaimer)))}</p>` : ""}
          </div>
        </div>
        <footer class="store-product-modal-footer ${product.externalPurchaseUrl ? "store-product-modal-footer--external" : ""}${product.available === false ? " store-product-modal-footer--upcoming" : ""}">
          ${product.available === false ? `
            <span class="store-card-availability">${escapeHtml(I18n.label(I18n.label(product.availabilityLabel) || T("public-offers.soon")))}</span>
          ` : product.externalPurchaseUrl ? `
            <a
              class="primary-action store-external-purchase-link"
              href="${escapeHtml(product.externalPurchaseUrl)}"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="${T("interface.comprar_value_en_amazon_se_abre_en_una_pestana_nueva", { v1: escapeHtml(I18n.label(I18n.label(product.label))) })}"
            >${T("interface.comprar_en_amazon")}</a>
          ` : isModuleEnabled("storeCart") ? `
            <strong>${escapeHtml(I18n.label(I18n.label(product.priceLabel)))}</strong>
            <button class="primary-action" type="button" data-store-product-detail-add="${escapeHtml(product.key)}">${T("interface.anadir_al_carrito")}</button>
          ` : `
            <strong>${escapeHtml(I18n.label(I18n.label(product.priceLabel)))}</strong>
          `}
        </footer>
      </div>
    </article>
  `);
  storeProductDialog.showModal();
}

function getStoreOptionLabels(product, selections = {}) {
  return (product?.optionGroups || []).map((group) => {
    const selected = (group.options || []).find((option) => option.value === selections[group.key]);
    return selected ? `${I18n.label(group.label)}: ${I18n.label(selected.label)}` : "";
  }).filter(Boolean);
}

function getStoreLineImage(product, selections = {}) {
  let image = product?.image || "";
  (product?.optionGroups || []).forEach((group) => {
    const selected = (group.options || []).find((option) => option.value === selections[group.key]);
    if (selected?.image) image = selected.image;
  });
  return image;
}

function syncStoreCartHeader() {
  if (!storeCartHeaderButton || !storeCartHeaderCount) return;
  const visible = Boolean(isModuleEnabled("storeCart") && currentUser && activePrivateSection === "store");
  const totalQuantity = storeCart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  storeCartHeaderButton.classList.toggle("is-hidden", !visible);
  storeCartHeaderButton.setAttribute("aria-expanded", String(Boolean(storeCartDialog?.open)));
  I18n.bind(storeCartHeaderCount, "textContent", () => formatNumber(totalQuantity));
  if (!visible && storeCartDialog?.open) storeCartDialog.close();
}

function renderStoreCartDialog() {
  if (!storeCartDialogContent) return;
  if (!isModuleEnabled("storeCart")) {
    I18n.clear(storeCartDialogContent, "innerHTML");
    syncStoreCartHeader();
    return;
  }
  const products = (billingSummary?.storeProducts || []).filter(isStoreProductVisible);
  I18n.bind(storeCartDialogContent, "innerHTML", () => renderStoreCart(products));
  syncStoreCartHeader();
}

function openStoreCartDialog() {
  if (!isModuleEnabled("storeCart") || !storeCartDialog || !currentUser || activePrivateSection !== "store") return;
  renderStoreCartDialog();
  if (!storeCartDialog.open) storeCartDialog.showModal();
  syncStoreCartHeader();
}

function closeStoreCartDialog() {
  storeCartDialog?.close();
  syncStoreCartHeader();
}

function renderStoreCart(products) {
  const validLines = storeCart.map((item, index) => ({
    item,
    index,
    product: products.find((product) => product.key === item.productKey)
  })).filter((line) => line.product && !line.product.externalPurchaseUrl);
  const totalQuantity = validLines.reduce((sum, line) => sum + line.item.quantity, 0);

  return `
    <aside class="store-cart-panel" aria-label="${T("interface.carrito_de_compra")}">
      <header class="store-cart-head">
        <div>
          <span>${T("interface.tu_seleccion")}</span>
          <h3>${T("interface.carrito")}</h3>
        </div>
        <button type="button" class="store-cart-close" data-store-cart-close aria-label="${T("interface.cerrar_carrito")}" title="${T("interface.cerrar_carrito")}">×</button>
      </header>

      ${validLines.length ? `
        <div class="store-cart-lines">
          ${validLines.map(({ item, index, product }) => {const optionLabels = getStoreOptionLabels(product, item.options);return `
              <article class="store-cart-line" data-store-cart-category="${escapeHtml(I18n.label(product.category))}">
                <img src="${escapeHtml(getStoreLineImage(product, item.options))}" alt="">
                <div class="store-cart-line-copy">
                  <b>${escapeHtml(I18n.label(product.label))}</b>
                  ${product.subtitle ? `<small>${escapeHtml(I18n.label(I18n.label(product.subtitle)))}</small>` : ""}
                  ${optionLabels.length ? `<small>${escapeHtml(optionLabels.join(" · "))}</small>` : ""}
                  <div class="store-cart-line-actions">
                    <span class="store-quantity-control store-quantity-control--compact">
                      <button type="button" data-store-cart-quantity-change="-1" data-store-cart-index="${index}" aria-label="${T("interface.reducir_cantidad")}">−</button>
                      <input type="number" min="1" max="99" value="${item.quantity}" inputmode="numeric" data-store-cart-quantity data-store-cart-index="${index}" aria-label="${T("interface.cantidad_de_value_2", { v8: escapeHtml(I18n.label(I18n.label(product.label))) })}">
                      <button type="button" data-store-cart-quantity-change="1" data-store-cart-index="${index}" aria-label="${T("interface.aumentar_cantidad")}">+</button>
                    </span>
                    <button type="button" class="store-cart-remove" data-store-cart-remove data-store-cart-index="${index}">${T("interface.quitar")}</button>
                  </div>
                </div>
              </article>
            `;}).join("")}
        </div>
        <footer class="store-cart-footer">
          <div>
            <span>${T("interface.total_del_pedido")}</span>
            <strong>${formatNumber(totalQuantity)} ${totalQuantity === 1 ? T("interface.articulo") : T("interface.articulos")}</strong>
          </div>
          <small>${T("interface.compra_simulada_no_se_solicitaran_datos_de_pago")}</small>
          <button class="primary-action" type="button" data-store-cart-checkout>${T("interface.finalizar_pedido_de_prueba")}</button>
        </footer>
      ` : `
        <div class="store-cart-empty">
          <b>${T("interface.el_carrito_esta_vacio")}</b>
          <p>${T("interface.anade_productos_configurados_para_preparar_el_pedido")}</p>
        </div>
      `}
    </aside>
  `;



}

function setStoreQuantity(input, value) {
  if (!input) return 1;
  const quantity = Math.min(99, Math.max(1, Number.parseInt(value, 10) || 1));
  input.value = String(quantity);
  return quantity;
}

function addStoreItemToCart(product, quantity = 1, options = {}) {
  if (!isModuleEnabled("storeCart") || !product || product.externalPurchaseUrl) return;
  const nextItem = {
    productKey: product.key,
    quantity: Math.min(99, Math.max(1, Number.parseInt(quantity, 10) || 1)),
    options: { ...options }
  };
  const signature = storeCartLineSignature(nextItem);
  const existing = storeCart.find((item) => storeCartLineSignature(item) === signature);

  if (existing) {
    existing.quantity = Math.min(99, existing.quantity + nextItem.quantity);
  } else {
    storeCart.push(nextItem);
  }
  saveStoreCart();
  setBillingStatus(() => T("interface.value_anadido_al_carrito", { v0: I18n.label(product.label) }));
  renderBillingUI();
  openStoreCartDialog();
}

function addStoreCardToCart(card) {
  const product = getStoreProduct(card?.dataset.storeProduct);
  if (!card || !product) return;

  const options = {};
  const optionFields = Array.from(card.querySelectorAll("[data-store-option]"));
  for (const field of optionFields) {
    if (field.required && !field.value) {
      field.reportValidity();
      return;
    }
    if (field.value) options[field.dataset.storeOption] = field.value;
  }

  const quantity = setStoreQuantity(card.querySelector("[data-store-card-quantity]"), card.querySelector("[data-store-card-quantity]")?.value);
  addStoreItemToCart(product, quantity, options);
}

function updateStoreCartQuantity(index, value) {
  if (!isModuleEnabled("storeCart")) return;
  const item = storeCart[index];
  if (!item) return;
  item.quantity = Math.min(99, Math.max(1, Number.parseInt(value, 10) || 1));
  saveStoreCart();
  renderStoreCartDialog();
}

async function checkoutStoreCart() {
  if (!isModuleEnabled("storeCart")) return;
  const visibleCart = storeCart.filter(isStoreCartItemAvailable);
  if (visibleCart.length !== storeCart.length) {
    storeCart = visibleCart;
    saveStoreCart();
  }
  if (!storeCart.length) {
    setBillingStatus(() => T("interface.el_carrito_esta_vacio_2"), true);
    return;
  }
  const payload = await purchaseBillingItem("store-cart", "cart", { items: storeCart });
  if (!payload) return;

  storeCart = [];
  saveStoreCart();
  closeStoreCartDialog();
  renderBillingUI();
}

function getSubscriptionWaitlistState() {
  return billingSummary?.subscriptionWaitlist || {
    active: false,
    status: "not_requested",
    email: currentUser?.email || ""
  };
}

function maskAccountEmail(value) {
  const email = String(value || "").trim();
  const separatorIndex = email.lastIndexOf("@");
  if (separatorIndex <= 0) return email;
  const localPart = email.slice(0, separatorIndex);
  const domain = email.slice(separatorIndex + 1);
  const visibleLength = Math.min(2, localPart.length);
  const maskedLength = Math.max(3, localPart.length - visibleLength);
  return `${localPart.slice(0, visibleLength)}${"•".repeat(maskedLength)}@${domain}`;
}

function setSubscriptionWaitlistDialogStatus(message = "", isError = false) {
  if (!subscriptionWaitlistStatus) return;
  I18n.bind(subscriptionWaitlistStatus, "textContent", () => message);
  subscriptionWaitlistStatus.classList.toggle("error", isError);
}

function syncSubscriptionWaitlistDialog() {
  const consentChecked = Boolean(subscriptionWaitlistConsentInput?.checked);
  if (subscriptionWaitlistConfirmButton) {
    subscriptionWaitlistConfirmButton.disabled = subscriptionWaitlistBusy || !consentChecked;
    I18n.bind(subscriptionWaitlistConfirmButton, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0 ? T("interface.guardando") : T("interface.confirmar_aviso"))(subscriptionWaitlistBusy));
  }
  if (subscriptionWaitlistCloseButton) subscriptionWaitlistCloseButton.disabled = subscriptionWaitlistBusy;
  if (subscriptionWaitlistCancelButton) subscriptionWaitlistCancelButton.disabled = subscriptionWaitlistBusy;
}

function openSubscriptionWaitlistDialog() {
  if (!currentUser || !subscriptionWaitlistDialog || getSubscriptionWaitlistState().active) return;
  subscriptionWaitlistBusy = false;
  if (subscriptionWaitlistConsentInput) subscriptionWaitlistConsentInput.checked = false;
  if (subscriptionWaitlistEmail) {
    I18n.bind(subscriptionWaitlistEmail, "textContent", ((__i18nSnapshot0) => () => maskAccountEmail(__i18nSnapshot0.email))(currentUser));
  }
  setSubscriptionWaitlistDialogStatus("");
  syncSubscriptionWaitlistDialog();
  if (!subscriptionWaitlistDialog.open) subscriptionWaitlistDialog.showModal();
}

function closeSubscriptionWaitlistDialog() {
  if (subscriptionWaitlistBusy) return;
  subscriptionWaitlistDialog?.close();
}

async function submitSubscriptionWaitlist() {
  if (!currentUser || subscriptionWaitlistBusy) return;
  if (!subscriptionWaitlistConsentInput?.checked) {
    setSubscriptionWaitlistDialogStatus(() => T("interface.confirma_que_quieres_recibir_el_aviso_por_correo"), true);
    return;
  }

  subscriptionWaitlistBusy = true;
  setSubscriptionWaitlistDialogStatus("");
  syncSubscriptionWaitlistDialog();

  try {
    const response = await I18n.fetch("/api/subscription-waitlist", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ consent: true })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

    if (billingSummary) billingSummary.subscriptionWaitlist = payload.waitlist;
    subscriptionWaitlistBusy = false;
    subscriptionWaitlistDialog?.close();
    renderBillingUI();
    setBillingStatus(() => T("interface.aviso_activado_para_value", { v0: maskAccountEmail(payload.waitlist?.email || currentUser.email) }));
  } catch (error) {
    subscriptionWaitlistBusy = false;
    setSubscriptionWaitlistDialogStatus(() => error.message || T("interface.no_se_pudo_activar_el_aviso"), true);
    syncSubscriptionWaitlistDialog();
  }
}

async function cancelSubscriptionWaitlist(button) {
  if (!currentUser || subscriptionWaitlistBusy) return;
  subscriptionWaitlistBusy = true;
  const previousLabel = button?.textContent || T("interface.cancelar_aviso");
  if (button) {
    button.disabled = true;
    I18n.bind(button, "textContent", () => T("interface.cancelando"));
  }

  try {
    const response = await I18n.fetch("/api/subscription-waitlist", { method: "DELETE" });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

    if (billingSummary) billingSummary.subscriptionWaitlist = payload.waitlist;
    subscriptionWaitlistBusy = false;
    renderBillingUI();
    setBillingStatus(() => T("interface.aviso_cancelado_puedes_volver_a_activarlo_cuando_quieras"));
  } catch (error) {
    subscriptionWaitlistBusy = false;
    if (button) {
      button.disabled = false;
      I18n.bind(button, "textContent", () => button?.textContent || T("interface.cancelar_aviso"));
    }
    setBillingStatus(() => error.message || T("interface.no_se_pudo_cancelar_el_aviso"), true);
  }
}

function renderSubscriptionPanel() {
  const capabilities = getCapabilities();
  const subscribed = isSubscribedUser();
  const name = currentUser?.name || currentUser?.email || T("interface.usuario");
  const email = currentUser?.email || "";
  if (!subscribed) {
    const waitlist = getSubscriptionWaitlistState();
    const waitlistEmail = maskAccountEmail(waitlist.email || email);
    return `
      <section class="subscription-conversion is-payment-hidden" aria-label="${T("interface.informacion_de_suscripcion")}">
        <article class="subscription-value-card">
          <span class="subscription-status is-upcoming">${T("public-offers.soon")}</span>
          <span class="subscription-kicker">${T("public-offers.professional")}</span>
          <h3>${T("interface.mas_herramientas_para_tu_practica_profesional")}</h3>
          <p>${T("interface.amplia_tu_espacio_de_trabajo_con_mayor_capacidad_herramientas_avanzadas_y_acceso_inte")}</p>
          <ul class="subscription-benefits-list">
            <li>${T("interface.hasta")} <strong>${T("interface.value_personas", { v0: new Intl.NumberFormat("es-ES", { useGrouping: "always" }).format(SUBSCRIPTION_MAX_PEOPLE) })}</strong> ${T("interface.guardadas")}</li>
            <li><strong>${T("interface.prompts_personalizados")}</strong> ${T("interface.para_adaptar_cada_consulta_a_tu_forma_de_trabajar")}</li>
            <li>${T("interface.acceso_al")} <strong>${T("public-offers.gpt")}</strong>${T("interface.creado_por_el_astrologo_eliseo_gallardo")}</li>
            <li><strong>${T("interface.herramientas_extra_y_mapas_exclusivos")}</strong></li>
          </ul>
          ${waitlist.active ? `
            <div class="subscription-waitlist-active" role="status">
              <div>
                <strong>${T("interface.aviso_activado")}</strong>
                <p>${T("interface.te_avisaremos_en_value_cuando_el_plan_este_disponible", { v0: escapeHtml(waitlistEmail) })}</p>
              </div>
              <button class="secondary-action" type="button" data-subscription-waitlist-cancel>${T("interface.cancelar_aviso")}</button>
            </div>
          ` : `
            <div class="subscription-waitlist-actions">
              <button
                class="primary-action subscription-waitlist-cta"
                type="button"
                data-subscription-waitlist-open
                aria-describedby="subscription-availability-note"
              >${T("interface.avisame_cuando_este_disponible")}</button>
              <p id="subscription-availability-note" class="subscription-availability-note">${T("interface.todavia_no_se_puede_contratar_este_plan_no_se_realizara_ningun_cobro")}</p>
            </div>
          `}
        </article>
      </section>
    `;
  }

  return `
    <section class="subscription-panel" aria-label="${T("interface.estado_de_suscripcion")}">
      <article class="subscription-card subscription-card-main">
        <span class="subscription-status is-subscribed">${T("interface.suscripcion_activa")}</span>
        <div>
          <h3>${escapeHtml(name)}</h3>
          <p>${escapeHtml(email)}</p>
        </div>
        <dl class="subscription-details">
          <div>
            <dt>${T("interface.capacidad")}</dt>
            <dd>${T("interface.value_personas_guardadas_2", { v2: formatNumber(capabilities.maxPeople) })}</dd>
          </div>
          <div>
            <dt>${T("interface.prompts")}</dt>
            <dd>${T("interface.extraccion_configurable_activa")}</dd>
          </div>
        </dl>
      </article>
      <article class="subscription-card">
        <div>
          <h3>${T("interface.todo_preparado_para_trabajar")}</h3>
          <p>${T("interface.tu_cuenta_tiene_acceso_a_las_herramientas_profesionales_incluidas_en_la_suscripcion")}</p>
        </div>
        <ul class="subscription-benefits-list">
          <li>${T("interface.value_personas_guardadas_en_base_de_datos", { v3: formatNumber(capabilities.maxPeople) })}</li>
          <li>${T("interface.acceso_al_gpt_especializado_del_sistema_astroanamnesis_creado_por_el_astrologo_eliseo")}</li>
          <li>${T("interface.acceso_a_prompts_configurables_desde_las_vistas_de_carta")}</li>
          <li>${T("interface.preparacion_de_lecturas_profesionales_desde_el_apartado_de_mapas")}</li>
        </ul>
        <p class="subscription-note">${T("interface.activacion_de_prueba_aplicada_a_value", { v4: escapeHtml(email) })}</p>
      </article>
    </section>
  `;
}

function renderBillingUsageSection() {
  return "";
}

async function purchaseBillingItem(kind, itemKey, options = {}) {
  if (!currentUser) {
    setBillingStatus(() => T("interface.inicia_sesion_para_comprar"), true);
    return null;
  }

  setBillingStatus(() => T("interface.procesando_compra_de_prueba"));
  setBillingButtonsBusy(true);

  try {
    const response = await I18n.fetch("/api/billing/purchase", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kind,
        itemKey,
        context: options.context || {},
        items: options.items || []
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

    billingSummary = payload;
    currentUser.plan = payload.plan;
    currentUser.capabilities = payload.capabilities;
    currentUser.billing = payload.account;
    syncAllowedModelLevel(true);
    updateChartDataButton();
    renderAuthState();
    renderBillingUI();
    updatePrivateMapOffer();
    renderCreditWidgets();
    syncPeopleLimitState();
    if (!privateScreen.classList.contains("is-hidden")) {
      await loadPeople().catch(() => null);
    }
    const successMessages = {
      subscription: "Suscripción de prueba activada.",
      service: "Solicitud de informe registrada.",
      store: "Pedido de tienda registrado.",
      "store-cart": "Pedido de tienda registrado.",
      plan: "Plan de prueba activado."
    };
    setBillingStatus(() => successMessages[kind] || T("interface.compra_de_prueba_aplicada"));
    return payload;
  } catch (error) {
    setBillingStatus(() => error.message || T("interface.no_se_pudo_procesar_la_compra"), true);
    return null;
  } finally {
    setBillingButtonsBusy(false);
  }
}

function setBillingButtonsBusy(busy) {
  privateMapOfferBusy = Boolean(busy);
  billingContent.querySelectorAll("button[data-purchase-kind], button[data-store-cart-checkout]").forEach((button) => {
    button.disabled = busy || button.textContent.trim() === "Activo";
  });
  storeCartDialogContent?.querySelectorAll("button[data-store-cart-checkout]").forEach((button) => {
    button.disabled = busy;
  });
  const mapOfferButton = privateMapOffer?.querySelector("[data-map-offer-purchase]");
  if (mapOfferButton) mapOfferButton.disabled = busy;
  if (privateMapOffer && !privateMapOffer.classList.contains("is-hidden")) updatePrivateMapOffer();
}

function setBillingStatus(text, isError = false) {
  I18n.bind(billingStatus, "textContent", () => text || "");
  billingStatus.classList.toggle("error", Boolean(isError));
}

function renderPeopleList() {
  renderPeopleInitialFilter();
  const query = clean(peopleSearchInput.value).toLowerCase();
  const filtered = sortPeopleByFavorite(savedPeople.filter((person) => {
    const name = clean(person.name).toLowerCase();
    const solarSignIndex = getApproxSolarSignIndex(person);
    const matchesName = !query || name.includes(query);
    const matchesSolarSign = activePeopleSolarSign === "" || String(solarSignIndex) === activePeopleSolarSign;
    const matchesInitial = !activePeopleInitial || getPersonInitial(person) === activePeopleInitial;
    return matchesName && matchesInitial && matchesSolarSign;
  }));

  peopleEmpty.hidden = filtered.length > 0;
  I18n.bind(peopleListEl, "innerHTML", () => filtered.map((person) => `
    <li class="people-item${person.isFavorite ? " is-favorite" : ""}" data-id="${person.id}" tabindex="0" aria-label="${T("interface.usar_carta_de_value", { v2: escapeHtml(person.name) })}" style="--people-solar-color:${getPersonSolarColor(person)}">
      ${renderPersonSolarWatermark(person)}
      <div class="people-info">
        <div class="people-name-row">
          <b>${escapeHtml(person.name)}</b>
          <button
            class="person-favorite-button${person.isFavorite ? " is-favorite" : ""}"
            type="button"
            data-action="favorite"
            data-id="${person.id}"
            aria-label="${person.isFavorite ? T("interface.quitar_de_favoritas") : T("interface.anadir_a_favoritas")}: ${escapeHtml(person.name)}"
            aria-pressed="${person.isFavorite ? "true" : "false"}"
            title="${person.isFavorite ? T("interface.quitar_de_favoritas") : T("interface.anadir_a_favoritas")}"
          ><span aria-hidden="true">${person.isFavorite ? "★" : "☆"}</span></button>
        </div>
        <small>${formatPersonDate(person)} · ${escapeHtml(person.city)}, ${escapeHtml(person.countryName || person.country)}${renderPersonSolarLabel(person)}</small>
      </div>
      <div class="people-actions">
        <button class="btn-small" type="button" data-action="use" data-id="${person.id}">${T("common.use")}</button>
        <button class="btn-small" type="button" data-action="edit" data-id="${person.id}">${T("common.edit")}</button>
        <button class="btn-small danger" type="button" data-action="delete" data-id="${person.id}">${T("common.delete")}</button>
      </div>
    </li>
  `).join(""));

  renderPeopleSolarFilter();
}

function sortPeopleByFavorite(people) {
  return [...people].sort((a, b) => {
    const favoriteOrder = Number(Boolean(b?.isFavorite)) - Number(Boolean(a?.isFavorite));
    if (favoriteOrder !== 0) return favoriteOrder;
    return clean(a?.name).localeCompare(clean(b?.name), "es", { sensitivity: "base" });
  });
}

function getApproxSolarSignIndex(person) {
  const day = Number(person?.day);
  const month = Number(person?.month);
  if (!Number.isFinite(day) || !Number.isFinite(month)) return null;

  const starts = [
  { month: 1, day: 20, signIndex: 10 },
  { month: 2, day: 19, signIndex: 11 },
  { month: 3, day: 21, signIndex: 0 },
  { month: 4, day: 20, signIndex: 1 },
  { month: 5, day: 21, signIndex: 2 },
  { month: 6, day: 21, signIndex: 3 },
  { month: 7, day: 23, signIndex: 4 },
  { month: 8, day: 23, signIndex: 5 },
  { month: 9, day: 23, signIndex: 6 },
  { month: 10, day: 23, signIndex: 7 },
  { month: 11, day: 22, signIndex: 8 },
  { month: 12, day: 22, signIndex: 9 }];


  let signIndex = 9;
  for (const start of starts) {
    if (month > start.month || month === start.month && day >= start.day) {
      signIndex = start.signIndex;
    }
  }
  return signIndex;
}

function getPersonSolarColor(person) {
  const signIndex = getApproxSolarSignIndex(person);
  return PEOPLE_SOLAR_COLORS[signIndex] || "var(--accent)";
}

function renderPersonSolarLabel(person) {
  const signIndex = getApproxSolarSignIndex(person);
  const sign = window.I18n?.label(PROMPT_SIGNS[signIndex]) || PROMPT_SIGNS[signIndex];
  return sign ? T("interface.sol_en_value", { v0: escapeHtml(I18n.label(sign)) }) : "";
}

function renderPersonSolarWatermark(person) {
  const signIndex = getApproxSolarSignIndex(person);
  const symbol = ZODIAC_SYMBOLS[signIndex];
  const sign = PROMPT_SIGNS[signIndex];
  if (!symbol || !sign) return "";

  return `
    <span class="people-solar-watermark" aria-hidden="true">
      <svg viewBox="0 0 180 180" focusable="false">
        <g class="people-solar-card">
          <circle cx="90" cy="90" r="78"></circle>
          <circle cx="90" cy="90" r="63"></circle>
          <circle cx="90" cy="90" r="25"></circle>
          <path d="M90 12v53M90 115v53M12 90h53M115 90h53"></path>
          <path d="M34.8 34.8 72.3 72.3M107.7 107.7l37.5 37.5M145.2 34.8l-37.5 37.5M72.3 107.7l-37.5 37.5"></path>
          <path d="M90 12v53" transform="rotate(30 90 90)"></path>
          <path d="M90 12v53" transform="rotate(60 90 90)"></path>
          <path d="M90 12v53" transform="rotate(120 90 90)"></path>
          <path d="M90 12v53" transform="rotate(150 90 90)"></path>
          <circle cx="90" cy="12" r="2.4"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(30 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(60 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(90 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(120 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(150 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(180 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(210 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(240 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(270 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(300 90 90)"></circle>
          <circle cx="90" cy="12" r="2.4" transform="rotate(330 90 90)"></circle>
        </g>
        <text x="90" y="110" text-anchor="middle">${escapeHtml(symbol)}</text>
      </svg>
    </span>
  `;
}

function getPersonInitial(person) {
  const initial = Array.from(clean(person.name).normalize("NFC").toUpperCase())[0] || "";
  // Group accented vowels with their base letter, retaining the Spanish Ñ.
  return initial === "Ñ" ? initial : initial.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

function renderPeopleInitialFilter() {
  const letters = Array.from(new Set(savedPeople.
  map(getPersonInitial).
  filter(Boolean))).
  sort((a, b) => a.localeCompare(b, "es"));

  if (activePeopleInitial && !letters.includes(activePeopleInitial)) activePeopleInitial = "";
  peopleInitialFilter.hidden = letters.length < 2;
  I18n.clear(peopleInitialFilter, "innerHTML");
  if (letters.length < 2) return;

  const current = activePeopleInitial;
  const allButton = document.createElement("button");
  allButton.type = "button";
  allButton.dataset.letter = "all";
  I18n.bind(allButton, "textContent", () => T("common.all"));
  allButton.setAttribute("aria-pressed", current === "" ? "true" : "false");
  peopleInitialFilter.appendChild(allButton);

  for (const letter of letters) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.letter = letter;
    I18n.bind(button, "textContent", () => letter);
    button.setAttribute("aria-pressed", current === letter ? "true" : "false");
    peopleInitialFilter.appendChild(button);
  }
}

function renderPeopleSolarFilter() {
  const signs = Array.from(new Set(savedPeople.
  map((person) => getApproxSolarSignIndex(person)).
  filter((signIndex) => Number.isInteger(signIndex)))).
  sort((a, b) => a - b);

  peopleSolarFilter.hidden = signs.length === 0;
  I18n.clear(peopleSolarFilter, "innerHTML");
  if (signs.length === 0) {
    activePeopleSolarSign = "";
    return;
  }

  const availableSigns = new Set(signs.map(String));
  if (activePeopleSolarSign && !availableSigns.has(activePeopleSolarSign)) {
    activePeopleSolarSign = "";
  }

  const allButton = document.createElement("button");
  allButton.type = "button";
  allButton.dataset.solarSign = "all";
  I18n.bind(allButton, "textContent", () => T("common.all"));
  allButton.setAttribute("aria-pressed", activePeopleSolarSign === "" ? "true" : "false");
  peopleSolarFilter.appendChild(allButton);

  for (const signIndex of signs) {
    const button = document.createElement("button");
    const symbol = ZODIAC_SYMBOLS[signIndex] || "";
    const sign = PROMPT_SIGNS[signIndex] || T("interface.signo");
    button.type = "button";
    button.className = "people-solar-filter-button";
    button.dataset.solarSign = String(signIndex);
    I18n.bind(button, "textContent", () => symbol);
    I18n.bind(button, "title", () => PROMPT_SIGNS[signIndex] || T("interface.signo"));
    button.style.setProperty("--people-solar-filter-color", PEOPLE_SOLAR_COLORS[signIndex] || "var(--accent)");
    I18n.bind(button, "@aria-label", () => T("interface.filtrar_por_sol_en_value", { v0: I18n.label(PROMPT_SIGNS[signIndex] || T("interface.signo")) }));
    button.setAttribute("aria-pressed", activePeopleSolarSign === String(signIndex) ? "true" : "false");
    peopleSolarFilter.appendChild(button);
  }
}

async function openPersonSwitchModal(options = {}) {
  if (!currentUser) {
    setStatus(() => T("interface.inicia_sesion_con_google_para_cambiar_entre_personas_guardadas"));
    return;
  }

  if (options.role === "atlas3d" && (currentUser.canAccessAtlas3D !== true || activePrivateSection !== "atlas3d")) return;
  personSwitchLoadRequest?.abort();
  const sequence = ++personSwitchOpenSequence;
  const ownerId = currentUser.id;
  personSwitchRole = ["partner", "natal-transit", "atlas3d", "tool"].includes(options.role) ? options.role : "subject";
  const isAtlas3D = personSwitchRole === "atlas3d";
  const isTool = personSwitchRole === "tool";
  personSwitchReturnFocus = isAtlas3D || isTool ? options.trigger || document.activeElement : null;
  personSwitchLoadRequest = isAtlas3D || isTool ? new AbortController() : null;
  const request = personSwitchLoadRequest;
  const isNatalTransit = personSwitchRole === "natal-transit";
  const isPartner = personSwitchRole === "partner";
  const isRelational = !isNatalTransit && !isAtlas3D && !isTool && isRelationalChartType();
  if (personSwitchEyebrow) {
    I18n.bind(personSwitchEyebrow, "textContent", () => isAtlas3D ? T("atlas.name3d") : isNatalTransit ? T("interface.carta_natal") : isRelational ? T("interface.personas_de_la_carta") : T("interface.carta_activa"));
  }
  if (personSwitchTitle) {
    I18n.bind(personSwitchTitle, "textContent", () => isPartner ? T("interface.cambiar_persona_b") : isRelational ? T("interface.cambiar_persona_a") : T("interface.cambiar_persona"));




  }
  personSwitchDialog.dataset.personRole = personSwitchRole;
  personSwitchSearch.value = "";
  I18n.bind(personSwitchStatus, "textContent", () => T("interface.cargando_personas"));
  I18n.clear(personSwitchList, "innerHTML");
  personSwitchDialog.showModal();

  try {
    if (!savedPeople.length) await loadPeople(isAtlas3D || isTool ? { signal: request.signal, ownerId } : {});
    if (sequence !== personSwitchOpenSequence || !personSwitchDialog.open || currentUser?.id !== ownerId || request?.signal.aborted) return;
    I18n.clear(personSwitchStatus, "textContent");
    renderPersonSwitchList();
    personSwitchSearch.focus();
  } catch (error) {
    if (sequence !== personSwitchOpenSequence || !personSwitchDialog.open || currentUser?.id !== ownerId || request?.signal.aborted) return;
    I18n.bind(personSwitchStatus, "textContent", () => error.message || T("interface.no_se_pudieron_cargar_las_personas"));
  }
}

function closePersonSwitchModal(options = {}) {
  ++personSwitchOpenSequence;
  personSwitchLoadRequest?.abort();
  personSwitchLoadRequest = null;
  personSwitchDialog.close();
  const trigger = personSwitchReturnFocus;
  personSwitchReturnFocus = null;
  if (options.restoreFocus !== false && trigger?.isConnected) trigger.focus({ preventScroll: true });
}

function renderPersonSwitchList() {
  const query = clean(personSwitchSearch.value).toLowerCase();
  const subjectId = String(activePersonId || birthProfile?.personId || "");
  const partnerId = String(chartSynastryPersonSelect?.value || "");
  const isPartner = personSwitchRole === "partner";
  const isNatalTransit = personSwitchRole === "natal-transit";
  const isAtlas3D = personSwitchRole === "atlas3d";
  const isTool = personSwitchRole === "tool";
  const selectedId = isTool ? getToolPersonId() : isAtlas3D ?
  privateAtlas3DSelection?.calculation ? String(privateAtlas3DSelection.person.id) : "" :
  isNatalTransit ? String(natalAspectFinderPerson?.value || "") : isPartner ? partnerId : subjectId;
  const blockedId = isNatalTransit || isAtlas3D || isTool ? "" : isPartner ?
  subjectId :
  isRelationalChartType() ?
  partnerId :
  "";
  const filtered = savedPeople.filter((person) => {
    const haystack = `${clean(person.name)} ${clean(person.city)} ${clean(person.countryName || person.country)}`.toLowerCase();
    return !query || haystack.includes(query);
  });

  const noChartOption = isTool && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ?
  `<li><button class="person-switch-item ${!selectedId ? "active" : ""}" type="button" data-tool-clear-person ${!selectedId ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!selectedId ? T("interface.actual") : T("common.use")}</em></button></li>` :
  isAtlas3D && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ?
  `<li><button class="person-switch-item ${!privateAtlas3DSelection ? "active" : ""}" type="button" data-atlas3d-clear-person ${!privateAtlas3DSelection ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!privateAtlas3DSelection ? T("interface.actual") : T("common.use")}</em></button></li>` :
  "";
  if (!filtered.length) {
    I18n.bind(personSwitchList, "innerHTML", ((__i18nSnapshot0) => () => (isTool && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ? `<li><button class="person-switch-item ${!selectedId ? "active" : ""}" type="button" data-tool-clear-person ${!selectedId ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!selectedId ? T("interface.actual") : T("common.use")}</em></button></li>` : isAtlas3D && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ? `<li><button class="person-switch-item ${!__i18nSnapshot0 ? "active" : ""}" type="button" data-atlas3d-clear-person ${!__i18nSnapshot0 ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!__i18nSnapshot0 ? T("interface.actual") : T("common.use")}</em></button></li>` : "") + `<li class="person-switch-empty">${T("interface.no_hay_personas_guardadas_que_coincidan")}</li>`)(privateAtlas3DSelection));
    return;
  }

  I18n.bind(personSwitchList, "innerHTML", ((__i18nSnapshot0) => () => (isTool && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ? `<li><button class="person-switch-item ${!selectedId ? "active" : ""}" type="button" data-tool-clear-person ${!selectedId ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!selectedId ? T("interface.actual") : T("common.use")}</em></button></li>` : isAtlas3D && (!query || T("atlas.noChart3d").toLowerCase().includes(query)) ? `<li><button class="person-switch-item ${!__i18nSnapshot0 ? "active" : ""}" type="button" data-atlas3d-clear-person ${!__i18nSnapshot0 ? "disabled" : ""}><span><b>${escapeHtml(T("atlas.noChart3d"))}</b></span><em>${!__i18nSnapshot0 ? T("interface.actual") : T("common.use")}</em></button></li>` : "") + filtered.map((person) => {const personId = String(person.id);const isActive = personId === selectedId;const isBlocked = Boolean(blockedId) && personId === blockedId;const itemLabel = isActive ? T("interface.actual") : isBlocked ? isPartner ? T("interface.persona_a") : T("interface.persona_b") : T("common.use");return `
      <li>
        <button class="person-switch-item ${isActive ? "active" : ""}" type="button" data-person-id="${person.id}" ${isActive || isBlocked ? "disabled" : ""}>
          <span>
            <b>${escapeHtml(person.name)}</b>
            <small>${formatPersonDate(person)} · ${escapeHtml(person.city)}, ${escapeHtml(person.countryName || person.country)}</small>
          </span>
          <em>${itemLabel}</em>
        </button>
      </li>
    `;}).join(""))(privateAtlas3DSelection));










}

function syncPeopleLimitState() {
  const capabilities = getCapabilities();
  const peopleLimitReached = savedPeople.length >= capabilities.maxPeople;
  const formOpen = isPersonFormOpen();
  togglePersonFormButton.disabled = peopleLimitReached && !formOpen;
  I18n.bind(togglePersonFormButton, "title", () => peopleLimitReached && !formOpen ? T("interface.has_alcanzado_el_limite_de_value_personas_de_tu_cuenta", { v0: capabilities.maxPeople }) : formOpen ? T("interface.cerrar_formulario") : T("interface.anadir_carta"));




}

async function useSavedPerson(person) {
  const workOwnerId = currentUser?.id;
  await countriesPromise.catch(() => null);
  if (currentUser?.id !== workOwnerId) return;
  setPrivateStatus(() => T("interface.calculando_carta_de_value", { v0: person.name }));

  activePersonId = String(person.id || "");
  activeChatId = "";
  conversationId = "";
  chartCalculation = null;
  solarReturnCalculation = null;
  transitCalculation = null;
  progressedCalculation = null;
  synastryCalculation = null;
  compositeCalculation = null;
  chatContextPreloaded = false;
  knowledgeStatusLoaded = false;
  I18n.clear(messagesEl, "innerHTML");
  updateEmptyChatState();

  birthProfile = {
    ...person,
    personId: activePersonId
  };

  localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
  localStorage.setItem("activePersonId", activePersonId);
  localStorage.removeItem("birthChartCalculation");
  localStorage.removeItem("conversationId");
  localStorage.removeItem("activeChatId");
  fillBirthForm(birthProfile);

  try {
    const calculation = await calculateBirthCharts(birthProfile);
    if (currentUser?.id !== workOwnerId) return;
    birthProfile = {
      ...birthProfile,
      lat: String(calculation.profile.location.lat),
      lon: String(calculation.profile.location.lon),
      tz: calculation.profile.location.tz,
      city: calculation.profile.location.name,
      country: calculation.profile.location.country,
      countryName: calculation.profile.location.countryName || birthProfile.countryName
    };
    chartCalculation = calculation;
    localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
    localStorage.setItem("birthChartCalculation", JSON.stringify(chartCalculation));
    fillBirthForm(birthProfile);

    setPrivateStatus(() => T("interface.preparando_consulta"));
    await preloadChatContext().catch(() => {
      chatContextPreloaded = false;
    });

    if (currentUser?.id !== workOwnerId) return;
    setPrivateStatus("");
    showPrivateSection("maps");
  } catch (error) {
    if (currentUser?.id !== workOwnerId) return;
    showIntake();
    I18n.pushState(null, "", "/");
    setPrivateStatus("");
    setFormStatus(() => error.message || T("interface.no_se_pudieron_calcular_las_cartas"), true);
  }
}

async function editSavedPerson(person) {
  await countriesPromise.catch(() => null);
  fillPersonForm(person);
  setPersonFormOpen(true);
  personForm.elements.name.focus();
  setPrivateStatus("");
}

async function toggleSavedPersonFavorite(person) {
  const favorite = !Boolean(person.isFavorite);
  const actionLabel = favorite ? T("interface.anadiendo_a_favoritas") : T("interface.quitando_de_favoritas");
  setPrivateStatus(actionLabel);

  try {
    const response = await I18n.fetch(`/api/people/${person.id}/favorite`, {
      method: "PATCH",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ favorite })
    });
    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(payload.error || T("interface.no_se_pudo_actualizar_el_favorito"));
    }

    savedPeople = sortPeopleByFavorite(savedPeople.map((item) =>
    String(item.id) === String(person.id) ? payload.person : item
    ));
    renderPeopleList();
    renderPrivateTransitPeopleOptions();
    setPrivateStatus(() => favorite ? T("interface.value_aparece_ahora_al_principio_de_la_lista", { v0: person.name }) : T("interface.value_ya_no_esta_entre_las_favoritas", { v0: person.name }));
  } catch (error) {
    setPrivateStatus(() => error.message || T("interface.no_se_pudo_actualizar_el_favorito"), true);
  }
}

async function deleteSavedPerson(person) {
  if (!(await confirmDeletePerson(person))) return;

  setPrivateStatus(() => T("interface.eliminando_carta"));
  const response = await I18n.fetch(`/api/people/${person.id}`, { method: "DELETE" });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setPrivateStatus(() => payload.error || T("interface.no_se_pudo_eliminar_la_carta"), true);
    return;
  }

  await loadPeople();
  setPrivateStatus(() => T("interface.carta_eliminada"));
}

function confirmDeletePerson(person) {
  return confirmDestructiveAction({ get
    title() {return T("interface.eliminar_persona");}, get
    message() {return T("interface.vas_a_eliminar_la_carta_y_los_datos_guardados_de_value", { v0: person.name });},
    warning: "Se eliminarán la carta y los datos guardados de esta persona. Esta acción no se puede deshacer.", get
    confirmLabel() {return T("interface.eliminar_persona");}
  });
}

function confirmDestructiveAction({ title, message, warning, confirmLabel = T("common.delete") }) {
  if (!destructiveConfirmDialog ||
  !destructiveConfirmTitle ||
  !destructiveConfirmMessage ||
  !destructiveConfirmWarning ||
  !destructiveConfirmSubmitButton) {
    return Promise.resolve(window.confirm(`${message} ${warning}`));
  }

  I18n.bind(destructiveConfirmTitle, "textContent", () => title);
  I18n.bind(destructiveConfirmMessage, "textContent", () => message);
  I18n.bind(destructiveConfirmWarning, "textContent", () => warning);
  I18n.bind(destructiveConfirmSubmitButton, "textContent", () => confirmLabel);
  destructiveConfirmDialog.showModal();
  return new Promise((resolve) => {
    pendingDestructiveConfirmResolve = resolve;
  });
}

function resolveDestructiveConfirmDialog(value) {
  if (destructiveConfirmDialog?.open) destructiveConfirmDialog.close();
  const resolve = pendingDestructiveConfirmResolve;
  pendingDestructiveConfirmResolve = null;
  if (resolve) resolve(Boolean(value));
}

function confirmChartDownload(format) {
  const isPdf = format === "pdf";
  const title = isPdf ? T("interface.descargar_pdf") : T("interface.descargar_imagen");
  const message = isPdf ? T("interface.quieres_descargar_la_carta_actual_como_documento_pdf") : T("interface.quieres_descargar_la_carta_actual_como_imagen_png");


  const confirmLabel = isPdf ? T("interface.descargar_pdf") : T("interface.descargar_imagen");

  if (!downloadConfirmDialog ||
  !downloadConfirmTitle ||
  !downloadConfirmMessage ||
  !downloadConfirmSubmitButton) {
    return Promise.resolve(window.confirm(message));
  }

  I18n.bind(downloadConfirmTitle, "textContent", () => isPdf ? T("interface.descargar_pdf") : T("interface.descargar_imagen"));
  I18n.bind(downloadConfirmMessage, "textContent", () => isPdf ? T("interface.quieres_descargar_la_carta_actual_como_documento_pdf") : T("interface.quieres_descargar_la_carta_actual_como_imagen_png"));
  I18n.bind(downloadConfirmSubmitButton, "textContent", () => isPdf ? T("interface.descargar_pdf") : T("interface.descargar_imagen"));
  downloadConfirmDialog.showModal();
  return new Promise((resolve) => {
    pendingDownloadConfirmResolve = resolve;
  });
}

function resolveDownloadConfirmDialog(value) {
  if (downloadConfirmDialog?.open) downloadConfirmDialog.close();
  const resolve = pendingDownloadConfirmResolve;
  pendingDownloadConfirmResolve = null;
  if (resolve) resolve(Boolean(value));
}

async function loadChatHistory() {
  if (!currentUser) {
    chatHistory = [];
    chatHistoryLoaded = false;
    renderChatHistory();
    return;
  }

  const response = await I18n.fetch("/api/chat-history");
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));

  chatHistory = payload.chats || [];
  chatHistoryLoaded = true;
  if (currentUser && payload.capabilities) currentUser.capabilities = payload.capabilities;
  chatHistoryLimit = payload.limit || getCapabilities().maxChatsPerPerson;
  syncAllowedModelLevel(false);
  updateChartDataButton();
  renderChatHistory();
}

async function canCreateNewChat() {
  if (!currentUser) return true;

  await loadChatHistory().catch(() => null);
  if (chatHistory.length < chatHistoryLimit) return true;

  const message = T("interface.has_alcanzado_el_limite_de_value_chats_en_tu_cuenta_para_el_plan_value_borra_un_chat_", { v0: chatHistoryLimit, v1: getCapabilities().plan.label });
  setStatus(message);
  return false;
}

async function canSendCurrentMessage() {
  if (currentUser) {
    const summary = await loadBillingSummary({ silent: true }).catch(() => null);
    const balance = summary?.account?.balance ?? getBillingAccount().balance;
    if (Number(balance || 0) <= 0) {
      setStatus(() => T("interface.no_hay_saldo_suficiente_para_esta_consulta_puedes_anadir_lumens_desde_configuracion_o"));
      input.focus();
      return false;
    }
    if (summary?.account?.lowBalance && ["deep", "premium", "thinking_standard"].includes(modelLevelSelect.value)) {
      setStatus(() => T("interface.te_quedan_pocos_lumens_este_modelo_consume_mas_que_el_nivel_equilibrado"));
    } else if (summary?.account?.lowBalance) {
      setStatus(() => T("interface.te_quedan_pocos_lumens_puedes_anadir_mas_desde_configuracion_o_mi_espacio"));
    }
  }

  if (activeChatId) return true;

  if (!currentUser) return true;

  await loadChatHistory().catch(() => null);
  if (chatHistory.length < chatHistoryLimit) return true;

  const message = T("interface.has_alcanzado_el_limite_de_value_chats_en_tu_cuenta_para_el_plan_value_borra_un_chat__2", { v0: chatHistoryLimit, v1: getCapabilities().plan.label });
  setStatus(message);
  input.focus();
  return false;
}

function renderChatHistory() {
  const visible = Boolean(currentUser && birthProfile);
  chatFoldersPanel?.classList.toggle("is-hidden", !visible);
  chatHistoryPanel.classList.toggle("is-hidden", !visible);
  if (!visible) {
    renderCollapsedChatList();
    syncChatModalSidebar();
    return;
  }

  if (chatHistoryLoaded) normalizeChatFolderState();
  renderChatFolders();
  const visibleChats = filteredAndSortedChats();
  I18n.bind(chatHistoryCount, "textContent", ((__i18nSnapshot0, __i18nSnapshot1) => () => `${__i18nSnapshot0.length}/${__i18nSnapshot1}`)(chatHistory, chatHistoryLimit));
  toggleChatHistoryButton?.setAttribute("aria-expanded", chatHistoryCollapsed ? "false" : "true");
  chatHistoryPanel.classList.toggle("is-collapsed", chatHistoryCollapsed);
  chatHistoryEmpty.hidden = chatHistoryCollapsed || visibleChats.length > 0;
  I18n.bind(chatHistoryEmpty, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0 === "all" ? T("interface.sin_chats_guardados") : T("interface.esta_carpeta_no_tiene_chats"))(activeChatFolderId));


  I18n.bind(chatHistoryList, "innerHTML", ((__i18nSnapshot0, __i18nSnapshot1, __i18nSnapshot2) => () => __i18nSnapshot0 ? "" : visibleChats.map((chat) => `
    <li class="chat-history-item ${String(chat.id) === String(__i18nSnapshot1) ? "active" : ""} ${isPinnedChat(chat.id) ? "is-pinned" : ""}">
      <button class="chat-history-load" type="button" data-action="load" data-id="${chat.id}">
        <span>${escapeHtml(chat.title)}</span>
        <em>${escapeHtml(chatHistoryContextLine(chat))}</em>
        <small>${formatChatDate(chat.updatedAt)}</small>
      </button>
      <button class="chat-history-menu-button" type="button" data-action="menu" data-id="${chat.id}" aria-label="${T("interface.opciones_de_chat")}">...</button>
      ${__i18nSnapshot2 === String(chat.id) ? renderChatHistoryMenu(chat) : ""}
    </li>
  `).join(""))(chatHistoryCollapsed, activeChatId, openChatMenuId));
  renderCollapsedChatList();
  syncChatModalSidebar();
}

function renderCollapsedChatList() {
  if (!collapsedChatPopover || !collapsedChatList) return;
  const visible = Boolean(chatSidebarCollapsed && collapsedChatPopoverOpen && currentUser && birthProfile);
  collapsedChatPopover.classList.toggle("is-hidden", !visible);
  if (!visible) return;

  const chats = filteredAndSortedChats();
  if (collapsedChatCount) I18n.bind(collapsedChatCount, "textContent", () => String(chats.length));
  collapsedChatEmpty.hidden = chats.length > 0;
  I18n.bind(collapsedChatEmpty, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0 === "all" ? T("interface.sin_chats_guardados") : T("interface.esta_carpeta_no_tiene_chats"))(activeChatFolderId));


  I18n.bind(collapsedChatList, "innerHTML", ((__i18nSnapshot0) => () => chats.map((chat) => `
    <li class="collapsed-chat-item ${String(chat.id) === String(__i18nSnapshot0) ? "active" : ""}">
      <button type="button" data-chat-id="${chat.id}">
        <span>${escapeHtml(chat.title)}</span>
        <em>${escapeHtml(chatHistoryContextLine(chat))}</em>
        <small>${formatChatDate(chat.updatedAt)}</small>
      </button>
    </li>
  `).join(""))(activeChatId));
}

function closeCollapsedChatPopover() {
  collapsedChatPopoverOpen = false;
  collapsedChatPopover?.classList.add("is-hidden");
}

function renderChatFolders() {
  if (!chatFoldersList) return;
  const folders = [
  { id: "all", name: "Todos", count: chatHistory.length },
  ...chatFolders.map((folder) => ({
    ...folder,
    count: chatHistory.filter((chat) => chatFolderAssignments[String(chat.id)] === folder.id).length
  }))];


  I18n.bind(chatFoldersList, "innerHTML", ((__i18nSnapshot0, __i18nSnapshot1) => () => folders.map((folder) => `
    <li class="chat-folder-row ${folder.id === __i18nSnapshot0 ? "active" : ""}">
      <button class="chat-folder-item ${folder.id === __i18nSnapshot0 ? "active" : ""}" type="button" data-folder-id="${escapeHtml(folder.id)}">
        <span>${folder.id === "all" ? folderIconSvg() : folderIconSvg(false)} ${escapeHtml(folder.name)}</span>
        <small>${folder.count}</small>
      </button>
      ${folder.id === "all" ? "" : `
        <button class="chat-folder-menu-button" type="button" data-folder-action="menu" data-folder-id="${escapeHtml(folder.id)}" aria-label="${T("interface.opciones_de_carpeta")}">...</button>
        ${__i18nSnapshot1 === folder.id ? `
          <div class="chat-folder-menu" role="menu">
            <button type="button" data-folder-action="delete" data-folder-id="${escapeHtml(folder.id)}" role="menuitem">${T("interface.eliminar_carpeta")}</button>
          </div>
        ` : ""}
      `}
    </li>
  `).join(""))(activeChatFolderId, openFolderMenuId));
  syncChatModalSidebar();
}

function renderChatHistoryMenu(chat) {
  const pinned = isPinnedChat(chat.id);
  return `
    <div class="chat-history-menu" role="menu">
      <button type="button" data-action="pin" data-id="${chat.id}" role="menuitem">${pinned ? T("interface.desfijar_chat") : T("interface.fijar_chat")}</button>
      <button type="button" data-action="rename" data-id="${chat.id}" role="menuitem">${T("interface.renombrar")}</button>
      <button type="button" data-action="move" data-id="${chat.id}" role="menuitem">${T("interface.mover_a")}</button>
      <button type="button" data-action="download" data-id="${chat.id}" role="menuitem">${T("interface.descargar_chat")}</button>
      <button type="button" data-action="delete" data-id="${chat.id}" role="menuitem" class="danger">${T("common.delete")}</button>
    </div>
    ${openMoveChatId === String(chat.id) ? renderMoveChatPanel(chat) : ""}
  `;
}

function renderMoveChatPanel(chat) {
  const currentFolderId = chatFolderAssignments[String(chat.id)] || "";
  const folderRows = chatFolders.map((folder) => `
    <button type="button" data-action="move-to-folder" data-id="${chat.id}" data-folder-id="${escapeHtml(folder.id)}" role="menuitem">
      <span>${folderIconSvg(false)} ${escapeHtml(folder.name)}</span>
      ${currentFolderId === folder.id ? `<b aria-label="${T("interface.seleccionada")}">✓</b>` : ""}
    </button>
  `).join("");

  return `
    <div class="chat-history-move-panel" role="menu" aria-label="${T("interface.mover_chat_a_carpeta")}">
      <p>${T("interface.mover_a_2")}</p>
      <button type="button" data-action="move-to-folder" data-id="${chat.id}" data-folder-id="" role="menuitem">
        <span>${T("interface.value_sin_carpeta", { v1: folderIconSvg() })}</span>
        ${currentFolderId ? "" : `<b aria-label="${T("interface.seleccionada")}">✓</b>`}
      </button>
      ${folderRows || `<small class="chat-move-empty">${T("interface.no_hay_carpetas_creadas")}</small>`}
      <i aria-hidden="true"></i>
      <button type="button" data-action="create-folder-and-move" data-id="${chat.id}" role="menuitem" class="chat-create-folder-option">
        <span>${T("interface.crear_nueva_carpeta")}</span>
      </button>
    </div>
  `;
}

function filteredAndSortedChats() {
  return chatHistory.
  filter((chat) => activeChatFolderId === "all" || chatFolderAssignments[String(chat.id)] === activeChatFolderId).
  sort((a, b) => {
    const pinnedDelta = Number(isPinnedChat(b.id)) - Number(isPinnedChat(a.id));
    if (pinnedDelta) return pinnedDelta;
    return new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0);
  });
}

function normalizeChatFolderState() {
  const before = JSON.stringify(getChatUiPreferenceState());
  const validChatIds = new Set(chatHistory.map((chat) => String(chat.id)));
  const validFolderIds = new Set(chatFolders.map((folder) => folder.id));
  chatFolderAssignments = Object.fromEntries(
    Object.entries(chatFolderAssignments).
    filter(([chatId, folderId]) => validChatIds.has(chatId) && validFolderIds.has(folderId))
  );
  pinnedChatIds = pinnedChatIds.filter((chatId) => validChatIds.has(String(chatId))).map(String);
  if (activeChatFolderId !== "all" && !validFolderIds.has(activeChatFolderId)) activeChatFolderId = "all";
  if (before !== JSON.stringify(getChatUiPreferenceState())) saveChatUiPreferences();
}

function isPinnedChat(chatId) {
  return pinnedChatIds.includes(String(chatId));
}

function togglePinnedChat(chatId) {
  const id = String(chatId);
  pinnedChatIds = isPinnedChat(id) ?
  pinnedChatIds.filter((item) => item !== id) :
  [id, ...pinnedChatIds];
  openChatMenuId = "";
  openMoveChatId = "";
  saveChatUiPreferences();
  renderChatHistory();
}

async function createChatFolder(defaultName = "") {
  const name = await openFolderNameDialog(defaultName);
  if (!name) return null;
  const existing = chatFolders.find((folder) => folder.name.toLowerCase() === name.toLowerCase());
  if (existing) {
    activeChatFolderId = existing.id;
    await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.no_se_pudo_guardar_la_carpeta_en_la_cuenta")));
    renderChatHistory();
    return existing;
  }
  const folder = { id: `folder-${Date.now()}`, name: name.slice(0, 40) };
  chatFolders = [...chatFolders, folder];
  activeChatFolderId = folder.id;
  await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.no_se_pudo_guardar_la_carpeta_en_la_cuenta")));
  renderChatHistory();
  return folder;
}

function openFolderNameDialog(defaultName = "") {
  if (!chatFolderDialog || !chatFolderNameInput) {
    return Promise.resolve(clean(window.prompt("Nombre de la carpeta", defaultName)));
  }

  chatFolderNameInput.value = defaultName || "";
  if (chatFolderStatus) I18n.clear(chatFolderStatus, "textContent");
  chatFolderDialog.showModal();
  window.setTimeout(() => {
    chatFolderNameInput.focus();
    chatFolderNameInput.select();
  }, 40);

  return new Promise((resolve) => {
    pendingFolderResolve = resolve;
  });
}

function resolveFolderDialog(value) {
  if (chatFolderDialog?.open) chatFolderDialog.close();
  const resolve = pendingFolderResolve;
  pendingFolderResolve = null;
  if (resolve) resolve(value ? value.slice(0, 40) : null);
}

async function moveChatToFolder(chatId, folderId = "") {
  const id = String(chatId);
  if (!folderId) {
    delete chatFolderAssignments[String(chatId)];
  } else {
    const folder = chatFolders.find((item) => item.id === folderId);
    if (!folder) return;
    chatFolderAssignments[id] = folder.id;
    activeChatFolderId = folder.id;
  }

  openChatMenuId = "";
  openMoveChatId = "";
  await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.no_se_pudo_guardar_el_movimiento_del_chat")));
  renderChatHistory();
}

async function createFolderAndMoveChat(chatId) {
  const chat = chatHistory.find((item) => String(item.id) === String(chatId));
  const folder = await createChatFolder(chat?.personName || birthProfile?.name || "");
  if (!folder) return;
  chatFolderAssignments[String(chatId)] = folder.id;
  activeChatFolderId = folder.id;
  openChatMenuId = "";
  openMoveChatId = "";
  await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.no_se_pudo_guardar_el_movimiento_del_chat")));
  renderChatHistory();
}

async function deleteChatFolder(folderId) {
  const folder = chatFolders.find((item) => item.id === folderId);
  if (!folder) return;

  const chatIds = chatHistory.
  filter((chat) => chatFolderAssignments[String(chat.id)] === folder.id).
  map((chat) => String(chat.id));
  const confirmed = await confirmDeleteFolder(folder, chatIds.length);
  if (!confirmed) {
    openFolderMenuId = "";
    renderChatFolders();
    return;
  }

  setStatus(() => T("interface.eliminando_carpeta_value", { v0: folder.name }));
  try {
    for (const chatId of chatIds) {
      const response = await I18n.fetch(`/api/chat-history/${chatId}`, { method: "DELETE" });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_eliminar_todos_los_chats_de_la_carpeta"));
    }

    chatFolders = chatFolders.filter((item) => item.id !== folder.id);
    for (const chatId of chatIds) delete chatFolderAssignments[chatId];
    pinnedChatIds = pinnedChatIds.filter((chatId) => !chatIds.includes(String(chatId)));
    if (activeChatFolderId === folder.id) activeChatFolderId = "all";
    openFolderMenuId = "";
    openChatMenuId = "";
    openMoveChatId = "";

    if (chatIds.includes(String(activeChatId))) {
      activeChatId = "";
      conversationId = "";
      localStorage.removeItem("activeChatId");
      localStorage.removeItem("conversationId");
      chatContextPreloaded = false;
      knowledgeStatusLoaded = false;
      I18n.clear(messagesEl, "innerHTML");
      setChatContextNotice();
    }

    await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.la_carpeta_se_elimino_pero_no_se_pudo_actualizar_la_organizacion_en_la_cuenta")));
    await loadChatHistory();
    setStatus(() => chatIds.length ? T("interface.carpeta_eliminada_junto_con_value_chatvalue", { v0: chatIds.length, v1: chatIds.length === 1 ? "" : "s" }) : T("interface.carpeta_eliminada")

    );
  } catch (error) {
    setStatus(() => error.message || T("interface.no_se_pudo_eliminar_la_carpeta"));
    renderChatHistory();
  }
}

function confirmDeleteFolder(folder, chatCount) {
  if (!deleteFolderDialog || !deleteFolderMessage) {
    return Promise.resolve(window.confirm(`¿Eliminar la carpeta "${folder.name}"? También se eliminarán ${chatCount} chats.`));
  }

  I18n.bind(deleteFolderMessage, "textContent", () => chatCount ? T("interface.vas_a_eliminar_value_y_value_chatvalue_guardadovalue_dentro", { v0: folder.name, v1: chatCount, v2: chatCount === 1 ? "" : "s", v3: chatCount === 1 ? "" : "s" }) : T("interface.vas_a_eliminar_value_no_contiene_chats_guardados", { v0: folder.name }));


  deleteFolderDialog.showModal();
  return new Promise((resolve) => {
    pendingDeleteFolderResolve = resolve;
  });
}

function resolveDeleteFolderDialog(value) {
  if (deleteFolderDialog?.open) deleteFolderDialog.close();
  const resolve = pendingDeleteFolderResolve;
  pendingDeleteFolderResolve = null;
  if (resolve) resolve(Boolean(value));
}

function chatHistoryContextLine(chat) {
  if (chat.contextSummary?.detail) return chat.contextSummary.detail;
  const personName = chat.personName || birthProfile?.name || "Persona";
  return `${personName} · Memoria, Tropical y Sideral`;
}

async function loadSavedChat(chatId) {
  const response = await I18n.fetch(`/api/chat-history/${chatId}`);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setStatus(() => payload.error || T("interface.no_se_pudo_cargar_el_chat"));
    return;
  }

  const chat = payload.chat;
  activeChatId = String(chat.id);
  conversationId = chat.conversationId;
  localStorage.setItem("activeChatId", activeChatId);
  localStorage.setItem("conversationId", conversationId);

  if (chat.profile) {
    birthProfile = normalizeProfileLocationDisplay(chat.profile);
    localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
    activePersonId = String(birthProfile.personId || activePersonId || "");
    if (activePersonId) localStorage.setItem("activePersonId", activePersonId);
  }

  if (chat.calculation && isFreshChartCalculation(chat.calculation)) {
    chartCalculation = chat.calculation;
    localStorage.setItem("birthChartCalculation", JSON.stringify(chartCalculation));
  } else if (chat.calculation) {
    chartCalculation = null;
    localStorage.removeItem("birthChartCalculation");
  }
  progressedCalculation = null;

  I18n.clear(messagesEl, "innerHTML");
  for (const message of chat.messages || []) {
    addMessage(message.role, message.content, { feedback: message.feedback || "" });
  }

  chatContextPreloaded = true;
  knowledgeStatusLoaded = true;
  renderBirthSummary();
  ensureFreshChartCalculation();
  updateChartDataButton();
  await loadChatHistory().catch(() => null);
  updateEmptyChatState();
  input.focus();
}

async function renameSavedChat(chatId) {
  const chat = chatHistory.find((item) => String(item.id) === String(chatId));
  if (!chat) return;

  const title = window.prompt("Nombre del chat", chat.title);
  if (title === null) return;
  const cleanTitle = clean(title);
  if (!cleanTitle) return;

  const response = await I18n.fetch(`/api/chat-history/${chatId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title: cleanTitle })
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setStatus(() => payload.error || T("interface.no_se_pudo_renombrar_el_chat"));
    return;
  }

  await loadChatHistory();
}

async function deleteSavedChat(chatId) {
  const chat = chatHistory.find((item) => String(item.id) === String(chatId));
  if (!chat) return;
  const confirmed = await confirmDestructiveAction({ get
    title() {return T("interface.eliminar_chat");}, get
    message() {return T("interface.vas_a_eliminar_el_chat_value", { v0: chat.title });},
    warning: "El chat desaparecerá del historial y no podrá recuperarse. Esta acción no se puede deshacer.", get
    confirmLabel() {return T("interface.eliminar_chat");}
  });
  if (!confirmed) return;

  const response = await I18n.fetch(`/api/chat-history/${chatId}`, { method: "DELETE" });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setStatus(() => payload.error || T("interface.no_se_pudo_eliminar_el_chat"));
    return;
  }

  delete chatFolderAssignments[String(chatId)];
  pinnedChatIds = pinnedChatIds.filter((item) => item !== String(chatId));
  openChatMenuId = "";
  openMoveChatId = "";
  await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.el_chat_se_elimino_pero_no_se_pudo_actualizar_la_organizacion_en_la_cuenta")));

  if (String(activeChatId) === String(chatId)) {
    activeChatId = "";
    conversationId = "";
    localStorage.removeItem("activeChatId");
    localStorage.removeItem("conversationId");
    chatContextPreloaded = false;
    knowledgeStatusLoaded = false;
    I18n.clear(messagesEl, "innerHTML");
    setChatContextNotice();
    setStatus(() => T("interface.chat_eliminado_nuevo_chat_listo"));
    updateEmptyChatState();
  }

  await loadChatHistory();
}

async function downloadSavedChat(chatId) {
  const response = await I18n.fetch(`/api/chat-history/${chatId}`);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    setStatus(() => payload.error || T("interface.no_se_pudo_descargar_el_chat"));
    return;
  }

  const chat = payload.chat;
  const lines = [
  `Eliseo - ${chat.title || "Chat"}`,
  chat.personName ? T("documents.person", { value: chat.personName }) : "",
  chat.contextSummary?.detail ? T("documents.chart", { value: chat.contextSummary.detail }) : "",
  chat.updatedAt ? T("documents.updated", { value: formatChatDate(chat.updatedAt, false) }) : "",
  "",
  ...(chat.messages || []).map((message) => {
    const label = message.role === "user" ? T("interface.usuario") : message.role === "assistant" ? "Eliseo" : T("interface.sistema");
    return `${label}:\n${message.content}`;
  })].
  filter((line) => line !== null && line !== undefined);

  const blob = new Blob([lines.join("\n\n")], { type: "text/plain;charset=utf-8" });
  downloadBlob(blob, `eliseo-chat-${slugId(chat.title || chat.id)}.txt`);
  openChatMenuId = "";
  renderChatHistory();
}

async function saveActiveChat(firstUserMessage = "") {
  if (!currentUser || !birthProfile || !conversationId) return;

  const personKey = getCurrentPersonKey();
  if (!personKey) return;
  const isNewChat = !activeChatId;

  const payload = {
    personKey,
    personName: birthProfile.name || "Persona",
    title: getActiveChatTitle() || inferChatTitle(firstUserMessage),
    conversationId,
    context: buildBirthContext(),
    profile: {
      ...birthProfile,
      personId: activePersonId || birthProfile.personId || ""
    },
    calculation: chartCalculation,
    messages: collectVisibleMessages()
  };

  const response = await I18n.fetch(activeChatId ? `/api/chat-history/${activeChatId}` : "/api/chat-history", {
    method: activeChatId ? "PUT" : "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    if (result.code === "CHAT_LIMIT_REACHED") {
      throw new Error(result.error || T("interface.limite_de_value_chats_alcanzado_en_tu_cuenta", { v0: chatHistoryLimit }));
    }
    throw new Error(result.error || T("interface.no_se_pudo_guardar_el_chat"));
  }

  activeChatId = String(result.chat.id);
  localStorage.setItem("activeChatId", activeChatId);
  if (isNewChat && activeChatFolderId !== "all" && chatFolders.some((folder) => folder.id === activeChatFolderId)) {
    chatFolderAssignments[activeChatId] = activeChatFolderId;
    await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.el_chat_se_guardo_pero_no_se_pudo_conservar_la_carpeta_seleccionada")));
  }
  await loadChatHistory();
}

function getCurrentPersonKey() {
  if (activePersonId || birthProfile?.personId) return `person:${activePersonId || birthProfile.personId}`;
  if (!birthProfile) return "";
  return [
  "profile",
  clean(birthProfile.name).toLowerCase(),
  pad(birthProfile.day),
  pad(birthProfile.month),
  birthProfile.year,
  pad(birthProfile.hour),
  pad(birthProfile.minute),
  birthProfile.placeId || ""].
  join(":");
}

function getActiveChatTitle() {
  return chatHistory.find((chat) => String(chat.id) === String(activeChatId))?.title || "";
}

function inferChatTitle(content) {
  return clean(content).replace(/\s+/g, " ").slice(0, 48) || T("interface.nueva_consulta");
}

function collectVisibleMessages() {
  return Array.from(messagesEl.querySelectorAll(".message")).
  map((message) => {
    const role = message.classList.contains("user") ?
    "user" :
    message.classList.contains("assistant") ?
    "assistant" :
    "system";
    const item = { role, content: getMessageText(message).trim() };
    if (role === "assistant" && message.dataset.feedback) item.feedback = message.dataset.feedback;
    return item;
  }).
  filter((message) => message.content);
}

function normalizeCountrySearch(value) {
  return String(value || "").
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  toLowerCase().
  trim();
}

function bindCountrySearch(control, clearCity) {
  control.input.addEventListener("focus", () => {
    renderCountrySuggestions("", { showAll: true }, control);
    if (control.select.value) window.requestAnimationFrame(() => control.input.select());
  });
  control.input.addEventListener("click", () => {
    if (control.results.hidden) renderCountrySuggestions("", { showAll: true }, control);
  });
  control.input.addEventListener("input", () => {
    if (control.select.value && normalizeCountrySearch(control.input.value) !== normalizeCountrySearch(selectedCountryName(control))) {
      control.select.value = "";
      clearCity();
      control.city.disabled = true;
    }
    I18n.validity(control.input, () => "");
    renderCountrySuggestions(control.input.value, {}, control);
  });
  control.input.addEventListener("keydown", (event) => handleCountryKeydown(event, control));
}

function selectedCountryName(control = personCountryControl) {
  const option = control.select.selectedOptions[0];
  return option?.value ? option.textContent.trim() : "";
}

function syncCountryCombobox(control = personCountryControl) {
  const selectedName = selectedCountryName(control);
  control.input.value = selectedName;
  I18n.validity(control.input, () => "");
}

function closeCountrySuggestions(control = personCountryControl) {
  control.results.hidden = true;
  I18n.clear(control.results, "innerHTML");
  control.matches = [];
  control.activeIndex = -1;
  control.input.setAttribute("aria-expanded", "false");
  control.input.removeAttribute("aria-activedescendant");
}

function countryMatchScore(country, query) {
  const name = normalizeCountrySearch(country.name);
  const code = normalizeCountrySearch(country.code);
  if (name === query || code === query) return 0;
  if (name.startsWith(query) || code.startsWith(query)) return 1;
  if (name.split(/\s+/).some((word) => word.startsWith(query))) return 2;
  return 3;
}

function setCountryActiveIndex(index, control = personCountryControl) {
  if (!control.matches.length) {
    control.activeIndex = -1;
    control.input.removeAttribute("aria-activedescendant");
    return;
  }

  control.activeIndex = Math.max(0, Math.min(index, control.matches.length - 1));
  const options = Array.from(control.results.querySelectorAll(".country-combobox-option"));
  options.forEach((option, optionIndex) => option.classList.toggle("is-active", optionIndex === control.activeIndex));
  const activeOption = options[control.activeIndex];
  if (!activeOption) return;
  control.input.setAttribute("aria-activedescendant", activeOption.id);
  activeOption.scrollIntoView({ block: "nearest" });
}

function renderCountrySuggestions(value = "", options = {}, control = personCountryControl) {
  const query = normalizeCountrySearch(value);
  const showAll = Boolean(options.showAll);
  const indexedCountries = sortCountriesByName(countriesCache).map((country, index) => ({ country, index }));
  const matches = (showAll || !query ?
  indexedCountries :
  indexedCountries.filter(({ country }) => {
    const name = normalizeCountrySearch(country.name);
    const code = normalizeCountrySearch(country.code);
    return name.includes(query) || code.includes(query);
  }).sort((left, right) => {
    const scoreDifference = countryMatchScore(left.country, query) - countryMatchScore(right.country, query);
    return scoreDifference || left.index - right.index;
  })).
  map(({ country }) => country);

  I18n.clear(control.results, "innerHTML");
  control.matches = matches;
  control.results.hidden = false;
  control.input.setAttribute("aria-expanded", "true");

  if (!matches.length) {
    const empty = document.createElement("div");
    empty.className = "country-combobox-empty";
    empty.setAttribute("role", "status");
    I18n.bind(empty, "textContent", ((__i18nSnapshot0) => () => __i18nSnapshot0.length ? T("interface.no_se_encontraron_paises") : T("interface.cargando_paises"))(countriesCache));
    control.results.appendChild(empty);
    setCountryActiveIndex(-1, control);
    return;
  }

  for (const country of matches) {
    const option = document.createElement("button");
    const isSelected = country.code === control.select.value;
    option.id = `${control.select.id}-option-${String(country.code).toLowerCase().replace(/[^a-z0-9_-]/g, "")}`;
    option.type = "button";
    option.tabIndex = -1;
    option.className = "country-combobox-option";
    option.setAttribute("role", "option");
    option.setAttribute("aria-selected", String(isSelected));

    const name = document.createElement("span");
    name.className = "country-combobox-option-name";
    I18n.bind(name, "textContent", () => country.name);

    const code = document.createElement("span");
    code.className = "country-combobox-option-code";
    I18n.bind(code, "textContent", () => country.code);

    const check = document.createElement("span");
    check.className = "country-combobox-option-check";
    check.setAttribute("aria-hidden", "true");
    I18n.bind(check, "textContent", () => isSelected ? "✓" : "");

    option.append(name, code, check);
    option.addEventListener("click", () => selectCountry(country, control));
    control.results.appendChild(option);
  }

  const selectedIndex = matches.findIndex((country) => country.code === control.select.value);
  setCountryActiveIndex(selectedIndex >= 0 ? selectedIndex : 0, control);
}

function selectCountry(country, control = personCountryControl) {
  if (!country) return;
  const changed = control.select.value !== country.code;
  control.select.value = country.code;
  control.input.value = country.name;
  I18n.validity(control.input, () => "");
  closeCountrySuggestions(control);

  if (changed) {
    control.select.dispatchEvent(new Event("change", { bubbles: true }));
  } else {
    control.city.disabled = false;
    control.city.focus();
  }
}

function handleCountryKeydown(event, control = personCountryControl) {
  if (event.key === "Escape") {
    if (!control.results.hidden) {
      event.preventDefault();
      event.stopPropagation();
      syncCountryCombobox(control);
      closeCountrySuggestions(control);
    }
    return;
  }

  if (event.key === "Tab") {
    closeCountrySuggestions(control);
    return;
  }

  if (!["ArrowDown", "ArrowUp", "Home", "End", "Enter"].includes(event.key)) return;
  event.preventDefault();

  if (control.results.hidden) {
    const selectedName = selectedCountryName(control);
    const showAll = !control.input.value.trim() ||
    normalizeCountrySearch(control.input.value) === normalizeCountrySearch(selectedName);
    renderCountrySuggestions(showAll ? "" : control.input.value, { showAll }, control);
  }

  if (!control.matches.length) return;
  if (event.key === "ArrowDown") {
    setCountryActiveIndex(control.activeIndex + 1, control);
  } else if (event.key === "ArrowUp") {
    setCountryActiveIndex(control.activeIndex - 1, control);
  } else if (event.key === "Home") {
    setCountryActiveIndex(0, control);
  } else if (event.key === "End") {
    setCountryActiveIndex(control.matches.length - 1, control);
  } else if (event.key === "Enter") {
    selectCountry(control.matches[Math.max(0, control.activeIndex)], control);
  }
}

function formatChatDate(value, includePrefix = true) {
  if (!value) return "";
  const date = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return "";
  const day = date.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit" });
  const time = date.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  return includePrefix ? T("documents.updatedDate", { day, time }) : `${day} · ${time}`;
}

function getPersonProfileFromForm(data) {
  return {
    name: clean(data.get("name")),
    gender: clean(data.get("gender")),
    genderOther: clean(data.get("genderOther")),
    day: clean(data.get("day")),
    month: clean(data.get("month")),
    year: clean(data.get("year")),
    hour: clean(data.get("hour")),
    minute: clean(data.get("minute")),
    country: clean(data.get("country")),
    countryName: personCountrySelect.selectedOptions[0]?.textContent.trim() || clean(data.get("country")),
    city: clean(data.get("city")),
    placeId: clean(data.get("placeId")),
    lat: clean(data.get("lat")),
    lon: clean(data.get("lon")),
    tz: clean(data.get("tz"))
  };
}

function isValidPersonProfile(profile) {
  I18n.validity(personForm.elements.day, () => "");
  I18n.validity(personCountrySearchInput, () => "");
  I18n.validity(personCityInput, () => "");
  I18n.validity(personGenderOtherInput, () => "");
  setPrivateStatus("");

  const date = new Date(Number(profile.year), Number(profile.month) - 1, Number(profile.day));
  const validDate = date.getFullYear() === Number(profile.year) &&
  date.getMonth() === Number(profile.month) - 1 &&
  date.getDate() === Number(profile.day);

  if (!validDate) {
    I18n.validity(personForm.elements.day, () => T("interface.revisa_la_fecha_de_nacimiento"));
    personForm.reportValidity();
    return false;
  }

  if (!profile.country) {
    I18n.validity(personCountrySearchInput, () => T("interface.selecciona_un_pais_de_la_lista"));
    personForm.reportValidity();
    return false;
  }

  if (!/^\d+$/.test(profile.placeId)) {
    I18n.validity(personCityInput, () => T("interface.selecciona_la_ciudad_desde_la_lista_de_sugerencias"));
    personForm.reportValidity();
    return false;
  }

  if (profile.gender === "otro" && !profile.genderOther) {
    I18n.validity(personGenderOtherInput, () => T("server.especifica_el_genero"));
    personForm.reportValidity();
    return false;
  }

  return personForm.reportValidity();
}

function fillPersonForm(person) {
  resetPersonForm();
  personIdInput.value = person.id || "";
  for (const [key, value] of Object.entries(person)) {
    const field = personForm.elements[key];
    if (field) field.value = value;
  }

  personPlaceIdInput.value = person.placeId || "";
  personLatInput.value = person.lat || "";
  personLonInput.value = person.lon || "";
  personTzInput.value = person.tz || "";
  syncCountryCombobox();
  personCityInput.disabled = !person.country;
  personGenderSelect.dispatchEvent(new Event("change"));
}

function resetPersonForm() {
  personForm.reset();
  personIdInput.value = "";
  personPlaceIdInput.value = "";
  personLatInput.value = "";
  personLonInput.value = "";
  personTzInput.value = "";
  syncCountryCombobox();
  closeCountrySuggestions();
  I18n.clear(personCityResults, "innerHTML");
  personCityInput.disabled = !personCountrySelect.value;
  personGenderSelect.dispatchEvent(new Event("change"));
  renderLegalConsentState();
}

function openNewPersonForm() {
  if (!personForm || !personFormWrap || !togglePersonFormButton) return;
  if (togglePersonFormButton.disabled && !isPersonFormOpen()) {
    setPrivateStatus(() => T("interface.has_alcanzado_el_limite_de_value_personas_de_tu_cuenta", { v0: getCapabilities().maxPeople }), true);
    return;
  }
  if (!isPersonFormOpen()) {
    resetPersonForm();
    setPersonFormOpen(true);
  }
  window.requestAnimationFrame(() => {
    personFormWrap.scrollIntoView({
      block: "start",
      behavior: accountReduceMotion ? "auto" : "smooth"
    });
    personForm.elements.name?.focus({ preventScroll: true });
  });
}

function isPersonFormOpen() {
  return Boolean(personFormWrap && !personFormWrap.classList.contains("is-hidden"));
}

function syncPersonFormToggleState() {
  if (!togglePersonFormButton) return;
  const formOpen = isPersonFormOpen();
  const label = togglePersonFormButton.querySelector("[data-person-form-toggle-label]");
  const icon = togglePersonFormButton.querySelector(".private-add-icon");

  togglePersonFormButton.setAttribute("aria-expanded", String(formOpen));
  togglePersonFormButton.classList.toggle("primary-action", !formOpen);
  togglePersonFormButton.classList.toggle("secondary-action", formOpen);
  togglePersonFormButton.classList.toggle("is-form-open", formOpen);
  if (label) I18n.bind(label, "textContent", () => formOpen ? T("interface.cerrar_formulario") : T("interface.anadir_carta"));
  if (icon) I18n.bind(icon, "textContent", () => formOpen ? "×" : "+");
}

function setPersonFormOpen(open) {
  if (!personFormWrap) return;
  personFormWrap.classList.toggle("is-hidden", !open);
  syncPersonFormToggleState();
  syncPeopleLimitState();
}

function closePersonForm() {
  if (!personForm || !personFormWrap) return;
  resetPersonForm();
  setPersonFormOpen(false);
}

async function loadPrivateCities(country, query = "") {
  const selectedCountry = clean(country);
  if (!selectedCountry) {
    privateCityList = [];
    privateLastCountry = "";
    return;
  }

  const params = new URLSearchParams({ country: selectedCountry });
  if (query) params.set("q", query);

  const response = await I18n.fetch(`/api/locations/cities?${params}`);
  if (!response.ok) {
    privateCityList = [];
    return;
  }

  privateCityList = await response.json();
  privateLastCountry = selectedCountry;
}

function renderPrivateCitySuggestions(query) {
  const normalized = query.trim().toLowerCase();
  I18n.clear(personCityResults, "innerHTML");

  if (!normalized || !privateCityList.length) return;

  privateCityList.
  filter((city) => city.name.toLowerCase().startsWith(normalized)).
  slice(0, 10).
  forEach((city) => {
    const option = document.createElement("button");
    option.type = "button";
    option.className = "city-suggestion";
    I18n.bind(option, "textContent", () => `${city.name} · ${city.tz}`);
    option.addEventListener("click", () => selectPrivateCity(city));
    personCityResults.appendChild(option);
  });
}

function selectPrivateCity(city) {
  personCityInput.value = city.name;
  personPlaceIdInput.value = city.id;
  personLatInput.value = city.lat;
  personLonInput.value = city.lon;
  personTzInput.value = city.tz;
  I18n.clear(personCityResults, "innerHTML");
  I18n.validity(personCityInput, () => "");
}

function clearPrivateSelectedCity() {
  personCityInput.value = "";
  personCityInput.disabled = true;
  personPlaceIdInput.value = "";
  personLatInput.value = "";
  personLonInput.value = "";
  personTzInput.value = "";
  I18n.clear(personCityResults, "innerHTML");
}

function setPrivateStatus(text, isError = false) {
  I18n.bind(privateStatus, "textContent", () => text || "");
  privateStatus.classList.toggle("error", Boolean(isError));
}

function applyTheme(theme, options = {}) {
  const normalizedTheme = THEME_KEYS.includes(theme) ? theme : DEFAULT_THEME;
  document.documentElement.dataset.theme = normalizedTheme;
  const previewingTheme = options.preview ? normalizedTheme : null;

  if (options.persist) {
    savedTheme = normalizedTheme;
    try {
      localStorage.setItem("eliseoTheme", normalizedTheme);
      localStorage.setItem("eliseoThemeVersion", THEME_STORAGE_VERSION);
    } catch {

      // Ignore storage errors; the visual change still applies in this session.
    }queueAccountPreferencesSave();
  }

  themeButtons.forEach((button) => {
    const isActive = button.dataset.themeChoice === savedTheme;
    const isPreviewed = button.dataset.themeChoice === previewingTheme && !isActive;
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.classList.toggle("is-previewed", isPreviewed);
  });
}

function previewTheme(theme) {
  applyTheme(theme, { persist: false, preview: true });
}

function restoreSavedTheme() {
  applyTheme(savedTheme, { persist: false });
}

function initLandingAstroDiagramLayout() {
  if (!landingAstroDiagram) return;

  const syncViewBox = () => {
    const viewBox = landingAstroMobileQuery.matches ?
    landingAstroDiagram.dataset.mobileViewBox :
    landingAstroDiagram.dataset.desktopViewBox;
    if (viewBox) landingAstroDiagram.setAttribute("viewBox", viewBox);
  };

  syncViewBox();
  if (typeof landingAstroMobileQuery.addEventListener === "function") {
    landingAstroMobileQuery.addEventListener("change", syncViewBox);
  } else {
    landingAstroMobileQuery.addListener(syncViewBox);
  }
}

function initLandingReveals() {
  if (!landingScreen) return;

  const revealTargets = [
  ".landing-hero-inner",
  ".landing-astro-preview",
  ".landing-astroanamnesis-inner",
  ".landing-origin-copy",
  ".landing-origin-visual",
  ".landing-band .landing-section-head",
  ".landing-pro .landing-section-head",
  ".landing-pro-grid article",
  ".landing-audience .landing-section-head",
  ".landing-audience-grid article",
  ".landing-audience-note",
  ".landing-cta"];

  const elements = Array.from(landingScreen.querySelectorAll(revealTargets.join(",")));
  if (!elements.length) return;

  const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  const compactReveal = window.matchMedia?.(
    "(max-width: 720px), (max-height: 500px) and (pointer: coarse)"
  )?.matches;
  const show = (element) => {
    element.classList.add("is-visible");
    element.closest(".landing-pro-grid")?.classList.add("is-flow-visible");
  };
  const pending = [];
  elements.forEach((element, index) => {
    const rect = element.getBoundingClientRect();
    // The HTML may already have been painted while the application bundle was
    // loading. Never hide that content to start an entrance animation later.
    const alreadyVisible = element.matches(".landing-hero-inner") ||
    element.classList.contains("is-visible") ||
    rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    const visible = alreadyVisible || reduceMotion || !("IntersectionObserver" in window);
    element.classList.add("landing-reveal", ...(visible ? ["is-visible"] : []));
    if (visible) show(element);else
    pending.push(element);
    const revealDelay = compactReveal ?
    Math.min(index * 20, 120) :
    Math.min(index * 45, 260);
    element.style.setProperty("--reveal-delay", `${revealDelay}ms`);
  });

  if (!pending.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      show(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: compactReveal ? "0px 0px -4% 0px" : "0px 0px -12% 0px",
    threshold: compactReveal ? 0.08 : 0.14
  });

  pending.forEach((element) => observer.observe(element));
}

function getInitialTheme() {
  try {
    const storedTheme = localStorage.getItem("eliseoTheme");
    const storedThemeVersion = localStorage.getItem("eliseoThemeVersion");
    if (storedThemeVersion) return storedTheme || DEFAULT_THEME;
    if (!storedTheme || storedTheme === "teal") return DEFAULT_THEME;
    return storedTheme;
  } catch {
    return DEFAULT_THEME;
  }
}

function setAuthStatus(text, isError = false) {
  I18n.bind(authStatus, "textContent", () => text || "");
  authStatus.classList.toggle("error", Boolean(isError));
  if (landingAuthStatus) {
    I18n.bind(landingAuthStatus, "textContent", () => text || "");
    landingAuthStatus.classList.toggle("error", Boolean(isError));
  }
}

function setPersonBusy(busy) {
  const peopleLimitReached = savedPeople.length >= getCapabilities().maxPeople;
  personSaveButton.disabled = busy;
  togglePersonFormButton.disabled = busy || peopleLimitReached;
  I18n.bind(personSaveButton, "textContent", () => busy ? T("interface.guardando") : T("interface.guardar_carta"));
  if (!busy) syncPeopleLimitState();
}

function formatPersonDate(person) {
  return `${pad(person.day)}/${pad(person.month)}/${person.year} · ${pad(person.hour)}:${pad(person.minute)}`;
}

function getAuthErrorMessage(code) {
  return { get
    google_not_configured() {return T("interface.google_oauth_aun_no_esta_configurado_en_el_backend");}, get
    google_rejected() {return T("interface.google_cancelo_o_rechazo_el_inicio_de_sesion");}, get
    google_state() {return T("interface.la_solicitud_de_google_ha_caducado_intentalo_de_nuevo");}, get
    google_email() {return T("interface.google_no_devolvio_un_email_verificado");}, get
    google_failed() {return T("interface.no_se_pudo_iniciar_sesion_con_google");}
  }[code] || T("interface.no_se_pudo_iniciar_sesion_con_google");
}

function getBirthProfileFromForm(data) {
  return {
    name: clean(data.get("name")),
    gender: clean(data.get("gender")),
    genderOther: clean(data.get("genderOther")),
    day: clean(data.get("day")),
    month: clean(data.get("month")),
    year: clean(data.get("year")),
    hour: clean(data.get("hour")),
    minute: clean(data.get("minute")),
    country: clean(data.get("country")),
    countryName: countrySelect.selectedOptions[0]?.textContent.trim() || clean(data.get("country")),
    city: clean(data.get("city")),
    placeId: clean(data.get("placeId")),
    lat: clean(data.get("lat")),
    lon: clean(data.get("lon")),
    tz: clean(data.get("tz"))
  };
}

function isValidBirthProfile(profile) {
  I18n.validity(birthForm.elements.day, () => "");
  I18n.validity(cityInput, () => "");
  setFormStatus("");

  const date = new Date(Number(profile.year), Number(profile.month) - 1, Number(profile.day));
  const validDate = date.getFullYear() === Number(profile.year) &&
  date.getMonth() === Number(profile.month) - 1 &&
  date.getDate() === Number(profile.day);

  if (!validDate) {
    I18n.validity(birthForm.elements.day, () => T("interface.revisa_la_fecha_de_nacimiento"));
    birthForm.reportValidity();
    return false;
  }

  if (!/^\d+$/.test(profile.placeId)) {
    I18n.validity(cityInput, () => T("interface.selecciona_la_ciudad_desde_la_lista_de_sugerencias"));
    birthForm.reportValidity();
    return false;
  }

  if (profile.gender === "otro" && !profile.genderOther) {
    I18n.validity(genderOtherInput, () => T("server.especifica_el_genero"));
    birthForm.reportValidity();
    return false;
  }

  I18n.validity(genderOtherInput, () => "");

  return birthForm.reportValidity();
}

async function calculateBirthCharts(profile, houseSystem = chartHouseSystemKey, options = {}) {
  const response = await fetch("/api/chart/calculate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...profile, houseSystem }),
    ...(options.signal ? { signal: options.signal } : {})
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `El servidor respondió ${response.status}`);
  }

  return payload;
}

async function preloadChatContext() {
  const context = buildBirthContext().trim();
  if (!context) return "";

  const response = await I18n.fetch("/api/chat/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      conversationId,
      context
    })
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || T("interface.el_servidor_respondio_value", { v0: response.status }));
  }

  conversationId = payload.conversationId;
  localStorage.setItem("conversationId", conversationId);
  chatContextPreloaded = true;
  return conversationId;
}

function fillBirthForm(profile) {
  for (const [key, value] of Object.entries(profile)) {
    const field = birthForm.elements[key];
    if (field) field.value = value;
  }

  if (profile.placeId) placeIdInput.value = profile.placeId;
  if (profile.lat) latInput.value = profile.lat;
  if (profile.lon) lonInput.value = profile.lon;
  if (profile.tz) tzInput.value = profile.tz;
  cityInput.disabled = !profile.country;
  genderSelect.dispatchEvent(new Event("change"));
}

function readBirthProfile() {
  try {
    return normalizeProfileLocationDisplay(JSON.parse(localStorage.getItem("birthProfile") || "null"));
  } catch {
    return null;
  }
}

function readChartCalculation() {
  try {
    const calculation = normalizeCalculationLocationDisplay(
      JSON.parse(localStorage.getItem("birthChartCalculation") || "null")
    );
    if (calculation && !isFreshChartCalculation(calculation)) {
      localStorage.removeItem("birthChartCalculation");
      return null;
    }
    return calculation;
  } catch {
    return null;
  }
}

function locationDisplayCityName(placeId, fallbackName = "") {
  return LOCATION_DISPLAY_NAMES[String(placeId || "")] || fallbackName;
}

function normalizeProfileLocationDisplay(profile) {
  if (!profile || typeof profile !== "object") return profile;
  const city = locationDisplayCityName(profile.placeId, profile.city);
  return city === profile.city ? profile : { ...profile, city };
}

function normalizeCalculationLocationDisplay(calculation) {
  const location = calculation?.profile?.location;
  if (!location) return calculation;
  const name = locationDisplayCityName(location.id, location.name);
  if (name === location.name) return calculation;
  return {
    ...calculation,
    profile: {
      ...calculation.profile,
      location: { ...location, name }
    }
  };
}

function isFreshChartCalculation(calculation) {
  const memoriaRule = calculation?.technical?.memoriaRule || "";
  return /ayanamsa din[aá]mico/i.test(memoriaRule);
}

function ensureFreshChartCalculation() {
  if (!birthProfile || chartCalculation) return;

  setFormStatus(() => T("interface.actualizando_carta_con_calculo_de_memoria_corregido"));
  calculateBirthCharts(birthProfile).
  then((calculation) => {
    chartCalculation = calculation;
    progressedCalculation = null;
    birthProfile = {
      ...birthProfile,
      lat: String(calculation.profile.location.lat),
      lon: String(calculation.profile.location.lon),
      tz: calculation.profile.location.tz,
      city: calculation.profile.location.name,
      country: calculation.profile.location.country,
      countryName: calculation.profile.location.countryName || birthProfile.countryName
    };
    localStorage.setItem("birthProfile", JSON.stringify(birthProfile));
    localStorage.setItem("birthChartCalculation", JSON.stringify(chartCalculation));
    renderBirthSummary();
    updateChartDataButton();
    syncChartWheelControls();
    syncChatChartContextControls();
    renderSelectedChartWheel();
    setFormStatus("");
  }).
  catch((error) => {
    setFormStatus(() => error.message || T("interface.no_se_pudo_actualizar_la_carta"), true);
  });
}

function normalizeUniversalClock(value) {
  const match = String(value || "").trim().match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return "";
  return `${match[1].padStart(2, "0")}:${match[2]}:${match[3] || "00"}`;
}

function getProfileUniversalDate(profile = chartCalculation?.profile) {
  if (!profile) return null;

  if (profile.utcDateTime) {
    const explicitDate = new Date(profile.utcDateTime);
    if (Number.isFinite(explicitDate.getTime())) return explicitDate;
  }

  const datePart = profile.utcDate || profile.birthDate || (
  birthProfile ? `${birthProfile.year}-${pad(birthProfile.month)}-${pad(birthProfile.day)}` : "");

  const timePart = normalizeUniversalClock(profile.utcTimeUsed || profile.utcTime || "");
  if (!datePart || !timePart) return null;

  const utcDate = new Date(`${datePart}T${timePart}Z`);
  return Number.isFinite(utcDate.getTime()) ? utcDate : null;
}

function getUniversalTimeDisplay(profile = chartCalculation?.profile) {
  const utcDate = getProfileUniversalDate(profile);
  if (utcDate) {
    const time = utcDate.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC"
    });
    return `${time} UT`;
  }

  const fallbackTime = normalizeUniversalClock(profile?.utcTimeUsed || profile?.utcTime || "");
  return fallbackTime ? `${fallbackTime.slice(0, 5)} UT` : "";
}

function getUniversalWeekdayLabel(profile = chartCalculation?.profile) {
  const utcDate = getProfileUniversalDate(profile);
  if (!utcDate) return "";

  const weekday = utcDate.toLocaleDateString("es-ES", {
    weekday: "long",
    timeZone: "UTC"
  });
  return weekday ? weekday.charAt(0).toUpperCase() + weekday.slice(1) : "";
}

function normalizePromptPlanetKey(value = "") {
  const normalized = String(value).
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  toLowerCase();
  return {
    sol: "Sun",
    sun: "Sun",
    luna: "Moon",
    moon: "Moon",
    mercurio: "Mercury",
    mercury: "Mercury",
    venus: "Venus",
    marte: "Mars",
    mars: "Mars",
    jupiter: "Jupiter",
    saturno: "Saturn",
    saturn: "Saturn"
  }[normalized] || value;
}

function getWeekdayPlanetByLabel(label = "") {
  const normalized = String(label).
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  toLowerCase();
  return {
    domingo: "Sun",
    lunes: "Moon",
    martes: "Mars",
    miercoles: "Mercury",
    jueves: "Jupiter",
    viernes: "Venus",
    sabado: "Saturn"
  }[normalized] || "";
}

function getLocalBirthWeekdayInfo(profile = chartCalculation?.profile) {
  const source = profile || {};
  const fallback = birthProfile || {};
  const birthDate = fallback.year && fallback.month && fallback.day ?
  `${fallback.year}-${pad(fallback.month)}-${pad(fallback.day)}` :
  source.birthDate || "";
  const match = String(birthDate).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!match) {
    const label = fallback.weekday?.label || source.weekday?.label || "";
    return { label, planet: getWeekdayPlanetByLabel(label) || normalizePromptPlanetKey(source.weekday?.planet || "") };
  }

  const [, year, month, day] = match;
  const localDate = new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0);
  const weekday = localDate.toLocaleDateString("es-ES", { weekday: "long" });
  const label = weekday ? weekday.charAt(0).toUpperCase() + weekday.slice(1) : "";
  return { label, planet: getWeekdayPlanetByLabel(label) };
}

function renderBirthSummary() {
  if (!birthProfile) {
    I18n.clear(birthSummary, "textContent");
    renderPrivateMapActiveCard();
    updateChartDataButton();
    return;
  }

  const time = `${pad(birthProfile.hour)}:${pad(birthProfile.minute)}`;
  const place = [birthProfile.city, birthProfile.countryName || birthProfile.country].filter(Boolean).join(", ");
  const profile = chartCalculation?.profile;
  const universalTime = getUniversalTimeDisplay(profile);
  const localWeekday = getLocalBirthWeekdayInfo(profile).label;
  const weekday = activeChartViewType === "sideral" ?
  getUniversalWeekdayLabel(profile) || localWeekday :
  localWeekday;
  const chartContext = chartCalculation ? birthSummaryChartContextLabel() : "";
  I18n.bind(birthSummary, "innerHTML", ((__i18nSnapshot0, __i18nSnapshot1) => () => `
    <article class="birth-active-card">
      <div class="birth-active-head">
        <div class="birth-active-identity">
          <span class="birth-active-eyebrow">${T("interface.carta_activa")}</span>
          <span class="birth-active-name"><strong>${escapeHtml(__i18nSnapshot0.name)}</strong></span>
        </div>
        ${__i18nSnapshot1 ? `<button class="person-switch-button" type="button" id="switch-person" aria-label="${T("interface.cambiar_persona")}">${T("interface.cambiar_persona")}</button>` : ""}
      </div>
      <div class="birth-active-meta">
        <span>${pad(__i18nSnapshot0.day)}/${pad(__i18nSnapshot0.month)}/${__i18nSnapshot0.year} &middot; ${time}</span>
        ${universalTime ? `<span>${T("interface.tiempo_universal_value", { v0: escapeHtml(universalTime) })}</span>` : ""}
        ${place ? `<span>${escapeHtml(place)}</span>` : ""}
        ${weekday ? `<span>${escapeHtml(I18n.label(weekday))}</span>` : ""}
      </div>
      ${chartContext ? `<p class="birth-active-context">${escapeHtml(chartContext)}</p>` : ""}
    </article>
  `)(birthProfile, currentUser));
  updateChartDataButton();
  renderPrivateMapActiveCard();
  syncChatModalSidebar();
  syncChatChartContextControls();
}

function renderPrivateMapActiveCard() {
  if (!privateMapActiveCard) return;

  if (!birthProfile) {
    I18n.bind(privateMapActiveCard, "innerHTML", () => `
      <span class="private-map-eyebrow">${T("interface.carta_activa")}</span>
      <strong>${T("interface.sin_carta_seleccionada")}</strong>
      <p>${T("interface.elige_una_persona_de_mi_lista_para_cargar_sus_mapas")}</p>
      <button class="person-switch-button" type="button" data-private-map-action="list">${T("interface.ir_a_mi_lista")}</button>
    `);
    if (privateMapsSubtitle) I18n.bind(privateMapsSubtitle, "textContent", () => T("interface.selecciona_una_persona_guardada_para_ver_sus_mapas"));
    return;
  }

  const time = `${pad(birthProfile.hour)}:${pad(birthProfile.minute)}`;
  const place = [birthProfile.city, birthProfile.countryName || birthProfile.country].filter(Boolean).join(", ");
  const profile = chartCalculation?.profile;
  const universalTime = getUniversalTimeDisplay(profile);
  const weekday = getLocalBirthWeekdayInfo(profile).label;
  const chartContext = I18n.label(chartCalculation ? birthSummaryChartContextLabel() : "Memoria, Tropical y Sideral");
  const dateTime = `${pad(birthProfile.day)}/${pad(birthProfile.month)}/${birthProfile.year} · ${time}`;

  I18n.bind(privateMapActiveCard, "innerHTML", ((__i18nSnapshot0) => () => `
    <div class="private-map-active-head">
      <div>
        <span class="private-map-eyebrow">${T("interface.carta_activa")}</span>
        <button class="active-person-trigger" type="button" data-private-map-action="switch" aria-label="${T("interface.cambiar_persona_activa")}" aria-haspopup="dialog" title="${T("interface.cambiar_persona")}">
          <span class="active-person-trigger-name">${escapeHtml(__i18nSnapshot0.name)}</span>
          <svg class="active-person-trigger-icon" aria-hidden="true" viewBox="0 0 24 24" focusable="false">
            <path d="M6 9l6 6 6-6"></path>
          </svg>
        </button>
      </div>
    </div>
    <div class="private-map-active-meta">
      <span>${escapeHtml(dateTime)}${universalTime ? `<span class="private-map-mobile-optional"> | ${escapeHtml(universalTime)}</span>` : ""}</span>
      ${place ? `<span>${escapeHtml(place)}${weekday ? `<span class="private-map-mobile-optional"> | ${escapeHtml(I18n.label(weekday))}</span>` : ""}</span>` : ""}
    </div>
  `)(birthProfile));
  if (privateMapsSubtitle) {
    I18n.bind(privateMapsSubtitle, "textContent", ((__i18nSnapshot0, __i18nSnapshot1) => () => `${__i18nSnapshot0.name} · ${I18n.label(__i18nSnapshot1 ? birthSummaryChartContextLabel() : "Memoria, Tropical y Sideral")}`)(birthProfile, chartCalculation));
  }
}

function buildPrivateMapPurchaseContext() {
  const profile = chartCalculation?.profile || {};
  const birthDate = birthProfile?.year && birthProfile?.month && birthProfile?.day ?
  `${birthProfile.year}-${pad(birthProfile.month)}-${pad(birthProfile.day)}` :
  profile.birthDate || "";
  const birthTime = birthProfile?.hour !== undefined && birthProfile?.minute !== undefined ?
  `${pad(birthProfile.hour)}:${pad(birthProfile.minute)}` :
  profile.birthTime || "";
  const location = profile.location || {};
  return {
    source: "maps",
    personId: activePersonId || birthProfile?.personId || "",
    personName: birthProfile?.name || chartCalculation?.profile?.name || "",
    chartViewType: "multiple",
    chartLabel: "Astroanamnesis",
    gender: birthProfile?.gender || "",
    genderOther: birthProfile?.genderOther || "",
    birthDate,
    birthTime,
    city: birthProfile?.city || location.name || "",
    country: birthProfile?.country || location.country || "",
    countryName: birthProfile?.countryName || location.countryName || "",
    lat: birthProfile?.lat || location.lat || "",
    lon: birthProfile?.lon || location.lon || "",
    tz: birthProfile?.tz || location.tz || ""
  };
}

function updatePrivateMapOffer() {
  if (!privateMapOffer) return;
  const currentType = activeChartViewType || chartWheelTypeSelect?.value || "";
  const shouldShow = Boolean(
    isModuleEnabled("mapCompleteReading") &&
    currentUser &&
    chartCalculation &&
    currentType === "multiple"
  );
  privateMapOffer.classList.toggle("is-hidden", !shouldShow);
  if (!shouldShow) {
    I18n.clear(privateMapOffer, "innerHTML");
    return;
  }

  const purchaseContext = buildPrivateMapPurchaseContext();
  const nextContextKey = [
  currentUser?.id || currentUser?.email || "",
  purchaseContext.personId || purchaseContext.personName || "",
  purchaseContext.birthDate || "",
  purchaseContext.birthTime || ""].
  join("|");
  if (nextContextKey !== privateMapOfferContextKey) {
    privateMapOfferContextKey = nextContextKey;
    privateMapOfferRequested = false;
    privateMapOfferStatus = "";
  }

  const product = billingSummary?.serviceProducts?.find((item) => item.key === "complete-reading") || { get
    label() {return T("interface.informe_de_lectura_completa");}, get
    description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");},
    available: false,
    availabilityLabel: "Próximamente"
  };
  const personName = birthProfile?.name || chartCalculation?.profile?.name || "la carta activa";
  const isTestMode = billingSummary?.testMode !== false;
  const isComingSoon = product.available === false;
  const isDisabled = isComingSoon || privateMapOfferBusy || privateMapOfferRequested;
  const ctaLabel = isComingSoon ?
  product.availabilityLabel || T("public-offers.soon") :
  privateMapOfferBusy ?
  isTestMode ? T("interface.generando_informe") : T("interface.procesando_solicitud") :
  privateMapOfferRequested ? T("interface.informe_solicitado") :

  isTestMode ? T("interface.generar_informe_gratis") : T("interface.obtener_informe_completo");


  I18n.bind(privateMapOffer, "innerHTML", ((__i18nSnapshot0, __i18nSnapshot1, __i18nSnapshot2, __i18nSnapshot3) => () => `
    <div class="private-map-offer-header">
      <span class="private-map-offer-kicker">${T("interface.lectura_completa")}</span>
      <span class="private-map-offer-badge">${T("interface.3_mapas")}</span>
    </div>
    <div class="private-map-offer-heading">
      <strong>${T("interface.comprende_el_mecanismo_completo")}</strong>
      <span>${T("interface.lectura_personalizada_de_value", { v0: escapeHtml(personName) })}</span>
    </div>
    <p class="private-map-offer-description">${T("interface.una_lectura_personalizada_para_observar_que_programa_inconsciente_se_repite_como_lo_s")}</p>
    <dl class="private-map-offer-maps" aria-label="${T("interface.mapas_incluidos_en_la_lectura")}">
      <div><dt>${T("interface.memoria")}</dt><dd>${T("interface.programa_inconsciente")}</dd></div>
      <div><dt>${T("interface.tropical")}</dt><dd>${T("interface.personaje_adaptativo")}</dd></div>
      <div><dt>${T("interface.sideral")}</dt><dd>${T("interface.cualidad_esencial")}</dd></div>
    </dl>
    ${(__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).available === false || isTestMode ? "" : `<p class="private-map-offer-price">${escapeHtml(I18n.label(I18n.label((__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).priceLabel)))}</p>`}
    <button
      class="btn-small private-map-offer-cta"
      type="button"
      ${__i18nSnapshot1 || (__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).available === false ? "" : "data-map-offer-purchase"}
      ${(__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).available === false || __i18nSnapshot2 || __i18nSnapshot1 ? "disabled" : ""}
      aria-busy="${__i18nSnapshot2 ? "true" : "false"}"
    >
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <path d="M14 2v6h6"></path>
        <path d="M8 14h8"></path>
        <path d="M8 18h5"></path>
      </svg>
      <span>${(__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).available === false ? (__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).availabilityLabel || T("public-offers.soon") : __i18nSnapshot2 ? isTestMode ? T("interface.generando_informe") : T("interface.procesando_solicitud") : __i18nSnapshot1 ? T("interface.informe_solicitado") : isTestMode ? T("interface.generar_informe_gratis") : T("interface.obtener_informe_completo")}</span>
    </button>
    ${(__i18nSnapshot0?.serviceProducts?.find((item) => item.key === "complete-reading") || { get label() {return T("interface.informe_de_lectura_completa");}, get description() {return T("interface.lectura_completa_de_memoria_tropical_y_sideral_revisada_desde_el_metodo_astroanamnesi");}, available: false, availabilityLabel: "Próximamente" }).available === false ? `<small class="private-map-offer-note">${T("interface.este_informe_esta_en_preparacion_y_todavia_no_admite_solicitudes")}</small>` : isTestMode ? `<small class="private-map-offer-note">${T("interface.modo_prueba_no_se_realizara_ningun_cobro")}</small>` : ""}
    ${__i18nSnapshot3 ? `<output class="private-map-offer-status">${escapeHtml(__i18nSnapshot3)}</output>` : ""}
  `)(billingSummary, privateMapOfferRequested, privateMapOfferBusy, privateMapOfferStatus));




}

function isChartViewTypeAvailable(type = "") {
  const requested = String(type || "").trim();
  if (!requested) return false;
  if (SUBSCRIBER_ONLY_CHART_VIEW_TYPES.has(requested) && !hasConfirmedSubscription()) return false;
  if (OPTIONAL_CHART_MODULES.includes(requested) && !isModuleEnabled(requested)) return false;
  if (!chartWheelTypeSelect) return true;
  return Array.from(chartWheelTypeSelect.options).some((option) =>
  option.value === requested && !option.disabled && !option.hidden
  );
}

function syncSubscriberOnlyChartViews() {
  const subscribed = hasConfirmedSubscription();
  [chartWheelTypeSelect, chatChartContextTypeSelect].forEach((select) => {
    select?.querySelectorAll("option[data-subscriber-only]").forEach((option) => {
      const label = option.dataset.subscriberLabel || option.textContent.trim();
      option.disabled = !subscribed;
      I18n.bind(option, "textContent", () => subscribed ? label : T("interface.value_suscripcion", { v0: I18n.label(label) }));
      I18n.bind(option, "@aria-label", () => subscribed ? label : T("interface.value_disponible_con_suscripcion", { v0: I18n.label(label) }));



    });
  });

  if (!subscribed && SUBSCRIBER_ONLY_CHART_VIEW_TYPES.has(activeChartViewType)) {
    setActiveChartViewType("multiple", { syncControls: true });
  }
}

function hasConfirmedSubscription(user = currentUser) {
  return Boolean(user?.capabilities?.isSubscribed);
}

async function authorizeChartViewType(type = "") {
  const requested = String(type || "").trim();
  if (!SUBSCRIBER_ONLY_CHART_VIEW_TYPES.has(requested)) return true;

  const response = await I18n.fetch("/api/chart/view-access", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ viewType: requested })
  });
  const payload = await response.json().catch(() => ({}));

  if (currentUser && payload.capabilities) {
    currentUser.capabilities = payload.capabilities;
    syncSubscriberOnlyChartViews();
    renderSidebarAccount();
  }

  if (!response.ok) {
    compositeCalculation = null;
    throw new Error(payload.error || T("interface.no_tienes_acceso_a_esta_vista_de_carta"));
  }
  return true;
}

function safeChartViewType(type = "") {
  return isChartViewTypeAvailable(type) ? String(type).trim() : "multiple";
}

function restoreChartViewTypeSelection() {
  const storedType = localStorage.getItem(CHART_VIEW_TYPE_STORAGE_KEY) || activeChartViewType || chartWheelTypeSelect?.value || "multiple";
  setActiveChartViewType(storedType, { syncControls: true, persist: false });
}

function setActiveChartViewType(type = "multiple", options = {}) {
  const previousType = activeChartViewType;
  activeChartViewType = safeChartViewType(type || "multiple");
  if (previousType !== activeChartViewType) privateMapOfferStatus = "";
  if (options.persist !== false) {
    localStorage.setItem(CHART_VIEW_TYPE_STORAGE_KEY, activeChartViewType);
    queueAccountPreferencesSave();
  }

  if (options.syncControls) {
    if (chartWheelTypeSelect) chartWheelTypeSelect.value = activeChartViewType;
    if (chatChartContextTypeSelect) chatChartContextTypeSelect.value = activeChartViewType;
  }
  updatePrivateMapOffer();
}

function birthSummaryChartContextLabel() {
  if (activeChartViewType) return chartViewSummaryLabel(activeChartViewType);

  const selected = getActiveChatContextSelection();
  if (!selected) return T("interface.memoria_tropical_y_sideral");

  if (selected.type === "transits") {
    const date = formatContextDate(selected.metadata?.transitDate);
    return date ? `${selected.label} (${date})` : selected.label;
  }

  if (selected.type === "synastry") {
    const subjectName = selected.metadata?.subjectName || birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = selected.metadata?.partnerName || "Persona B";
    return `${selected.label}: ${subjectName} y ${partnerName}`;
  }

  if (selected.type === "composite" || selected.type === "compositeMultiple") {
    const subjectName = selected.metadata?.subjectName || birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = selected.metadata?.partnerName || "Persona B";
    return `${selected.label}: ${subjectName} + ${partnerName}`;
  }

  return selected.label || chartContextLabel(selected.type);
}

function chartViewSummaryLabel(type) {
  const label = chartContextLabel(type || "multiple");

  if (type === "transits") {
    const moment = transitLocalMoment(transitCalculation);
    return moment.label ? `${label} (${moment.label})` : label;
  }

  if (type === "progressed") {
    const moment = progressedLocalMoment(progressedCalculation);
    return moment.label ? `${label} (${moment.label})` : label;
  }

  if (type === "solarReturn") {
    const year = chartSolarReturnYearInput?.value || solarReturnCalculation?.targetYear || "";
    return year ? `${label} ${year}` : label;
  }

  if (type === "synastry") {
    const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = synastryCalculation?.profile?.name || getSelectedSynastryPersonName();
    return partnerName ? `${label}: ${subjectName} y ${partnerName}` : label;
  }

  if (type === "composite" || type === "compositeMultiple") {
    const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = compositeCalculation?.partner?.profile?.name || getSelectedSynastryPersonName();
    return partnerName ? `${label}: ${subjectName} + ${partnerName}` : label;
  }

  return label;
}

function canUseChartWheel() {
  return canAccessGptIa();
}

function buildBirthContext() {
  const selected = getActiveChatContextSelection();
  if (selected?.context) return selected.context;
  return buildDefaultBirthContext();
}

function buildDefaultBirthContext() {
  if (!birthProfile) return "";
  if (chartCalculation) return buildGuiaInternaPromptText();

  const lines = [
  "DATOS NATALES APORTADOS POR EL USUARIO:",
  `Nombre: ${birthProfile.name}`,
  `Género: ${birthProfile.gender}${birthProfile.genderOther ? ` (${birthProfile.genderOther})` : ""}`,
  `Fecha de nacimiento: ${pad(birthProfile.day)}/${pad(birthProfile.month)}/${birthProfile.year}`,
  `Hora de nacimiento: ${pad(birthProfile.hour)}:${pad(birthProfile.minute)}`,
  `Lugar de nacimiento: ${birthProfile.city}, ${birthProfile.countryName || birthProfile.country}`,
  `Código país: ${birthProfile.country}`,
  `GeoNames place_id: ${birthProfile.placeId}`,
  `Latitud: ${birthProfile.lat}`,
  `Longitud: ${birthProfile.lon}`,
  `Zona horaria: ${birthProfile.tz}`,
  ""];


  lines.push("Estos datos no equivalen por sí solos a Carta Tropical, Carta de Memoria ni Carta Sideral calculadas. Si faltan cartas, grados, casas o aspectos, marca el límite técnico y no completes mapas por inferencia.");

  return lines.join("\n");
}

function readChatContextSelection() {
  try {
    return JSON.parse(localStorage.getItem("chatContextSelection") || "null");
  } catch {
    return null;
  }
}

function saveChatContextSelection(selection) {
  chatContextSelection = selection;
  if (selection) {
    localStorage.setItem("chatContextSelection", JSON.stringify(selection));
  } else {
    localStorage.removeItem("chatContextSelection");
  }
}

function getActiveChatContextSelection() {
  if (!chatContextSelection?.context) return null;
  if (chatContextSelection.signature !== currentChartContextSignature()) return null;
  return chatContextSelection;
}

function currentChartContextSignature() {
  const profile = chartCalculation?.profile;
  return [
  getCurrentPersonKey(),
  profile?.birthDate || `${birthProfile?.year || ""}-${pad(birthProfile?.month || "")}-${pad(birthProfile?.day || "")}`,
  profile?.birthTime || `${pad(birthProfile?.hour || "")}:${pad(birthProfile?.minute || "")}`,
  profile?.utcTimeUsed || "",
  profile?.location?.name || birthProfile?.city || "",
  profile?.location?.country || birthProfile?.country || ""].
  join("|");
}

function chartContextLabel(type) {
  const labels = { get
    multiple() {return T("interface.memoria_tropical_y_sideral");}, get
    customChart() {return T("custom_chart.title");}, get
    tropical() {return T("interface.tropical_avatar");}, get
    memoria() {return T("interface.memoria_inconsciente");}, get
    sideral() {return T("interface.sideral_self");}, get
    nodal() {return T("interface.esquema_nodal_2");}, get
    transits() {return T("interface.tropical_con_transitos");}, get
    progressed() {return T("interface.tropical_progresada");}, get
    solarReturn() {return T("interface.revolucion_solar_2");}, get
    synastry() {return T("interface.sinastria_tropical");}, get
    composite() {return T("interface.carta_compuesta_2");}, get
    compositeMultiple() {return T("interface.carta_compuesta_astroanamnesis");}
  };
  return labels[type] || T("interface.carta");
}

function chartContextDescription(type) {
  const descriptions = { get
    multiple() {return T("charts.multipleDescription");}, get
    customChart() {return T("custom_chart.description");}, get
    tropical() {return T("charts.tropicalDescription");}, get
    memoria() {return T("charts.memoryDescription");}, get
    sideral() {return T("charts.siderealDescription");}, get
    nodal() {return T("charts.nodalDescription");}, get
    transits() {return T("charts.transitDescription");}, get
    progressed() {return T("charts.progressionDescription");}, get
    solarReturn() {return T("charts.solarDescription");}, get
    synastry() {return T("charts.synastryDescription");}, get
    composite() {return T("charts.compositeDescription");}, get
    compositeMultiple() {return T("charts.compositeMultipleDescription");}
  };
  return descriptions[type] || T("interface.muestra_las_posiciones_casas_ejes_y_aspectos_disponibles_en_esta_vista_de_carta");
}

function updateChartTypeHelp() {
  if (!chartTypeHelpText || !chartWheelTypeSelect) return;
  I18n.bind(chartTypeHelpText, "textContent", () => window.I18n?.label(chartContextDescription(chartWheelTypeSelect.value)) || chartContextDescription(chartWheelTypeSelect.value));
}

function isRelationalChartType(type = activeChartViewType || chartWheelTypeSelect?.value || "") {
  return ["synastry", "composite", "compositeMultiple"].includes(type);
}

function getSelectedSynastryPersonName() {
  const personId = chartSynastryPersonSelect?.value || "";
  const person = savedPeople.find((item) => String(item.id) === String(personId));
  if (person?.name) return person.name;
  const selectedText = chartSynastryPersonSelect?.selectedOptions?.[0]?.textContent || "";
  return clean(selectedText.split(" - ")[0]);
}

function relatedPersonStorageKey() {
  const userScope = currentUser?.id || currentUser?.email || "anonymous";
  const subjectScope = activePersonId || birthProfile?.personId || chartCalculation?.profile?.personId || "current";
  return `${CHART_RELATED_PERSON_STORAGE_PREFIX}:${encodeURIComponent(String(userScope))}:${encodeURIComponent(String(subjectScope))}`;
}

function readStoredRelatedPersonId() {
  return localStorage.getItem(relatedPersonStorageKey()) || "";
}

function persistSelectedRelatedPerson() {
  const personId = String(chartSynastryPersonSelect?.value || "");
  const storageKey = relatedPersonStorageKey();
  if (personId) {
    localStorage.setItem(storageKey, personId);
  } else {
    localStorage.removeItem(storageKey);
  }
}

function selectedChartContextMetadata(type) {
  if (type === "customChart") {
    return { charts: normalizeCustomChartSelection(customChartSelection) };
  }
  if (type === "transits") {
    const moment = transitLocalMoment(transitCalculation);
    return {
      transitDate: moment.date,
      transitTime: moment.time,
      transitTimeZone: moment.timeZone
    };
  }

  if (type === "progressed") {
    const moment = progressedLocalMoment(progressedCalculation);
    return {
      targetDate: moment.date,
      targetTime: moment.time,
      targetTimeZone: moment.timeZone,
      ageYears: progressedCalculation?.ageYears || "",
      progressedDate: progressedCalculation?.dateUsedBySwetest || "",
      progressedTime: progressedCalculation?.utTimeUsedBySwetest || "",
      houseMethod: progressedCalculation?.technical?.houseMethod || "Naibod",
      natalRetrogradeCount: progressedCalculation?.progressedStations?.natalRetrogradeCount || 0,
      directAtTargetCount: progressedCalculation?.progressedStations?.directAtTargetCount || 0
    };
  }

  if (type === "solarReturn") {
    return {
      targetYear: solarReturnCalculation?.targetYear || chartSolarReturnYearInput?.value || "",
      returnDate: solarReturnCalculation?.dateUsedBySwetest || "",
      returnTime: solarReturnCalculation?.utTimeUsedBySwetest || ""
    };
  }

  if (type === "synastry") {
    return {
      subjectName: birthProfile?.name || chartCalculation?.profile?.name || "Persona A",
      partnerName: synastryCalculation?.profile?.name || getSelectedSynastryPersonName() || "Persona B"
    };
  }

  if (type === "composite" || type === "compositeMultiple") {
    return {
      subjectName: birthProfile?.name || chartCalculation?.profile?.name || "Persona A",
      partnerName: compositeCalculation?.partner?.profile?.name || getSelectedSynastryPersonName() || "Persona B"
    };
  }

  return {};
}

function formatContextDate(value) {
  const text = String(value || "").trim();
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return text;
  return `${match[3]}/${match[2]}/${match[1]}`;
}

function formatWeekdayFromDateText(value) {
  const text = String(value || "").trim();
  const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const slashMatch = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  const year = isoMatch ? isoMatch[1] : slashMatch?.[3];
  const month = isoMatch ? isoMatch[2] : slashMatch?.[2];
  const day = isoMatch ? isoMatch[3] : slashMatch?.[1];
  if (!year || !month || !day) return "";
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12));
  const weekday = date.toLocaleDateString("es-ES", { weekday: "long", timeZone: "UTC" });
  return weekday ? weekday.charAt(0).toUpperCase() + weekday.slice(1) : "";
}

function buildChatContextNotice() {
  const selected = getActiveChatContextSelection();

  if (!selected) {
    return chartCalculation ? T("interface.contexto_cargado_memoria_tropical_y_sideral_escribe_tu_consulta_para_iniciar_la_lectu") : T("interface.datos_natales_registrados_escribe_tu_consulta_para_iniciar_la_lectura");


  }

  if (selected.type === "transits") {
    const date = formatContextDate(selected.metadata?.transitDate);
    const time = selected.metadata?.transitTime || "";
    const timeZone = selected.metadata?.transitTimeZone || "";
    const detail = date ? ` (${[date, time, timeZone].filter(Boolean).join(" · ")})` : "";
    return T("interface.contexto_cargado_valuevalue_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label), v1: detail });
  }

  if (selected.type === "progressed") {
    const date = formatContextDate(selected.metadata?.targetDate);
    const time = selected.metadata?.targetTime || "";
    const timeZone = selected.metadata?.targetTimeZone || "";
    const age = Number(selected.metadata?.ageYears);
    const ageLabel = Number.isFinite(age) ? T("interface.value_anos_3", { v0: age.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }) :

    "";
    const detail = [date, time, timeZone, ageLabel].filter(Boolean).join(" · ");
    return T("interface.contexto_cargado_valuevalue_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label), v1: detail ? ` (${detail})` : "" });
  }

  if (selected.type === "solarReturn") {
    const year = selected.metadata?.targetYear ? ` ${selected.metadata.targetYear}` : "";
    const date = formatContextDate(selected.metadata?.returnDate);
    const time = selected.metadata?.returnTime ? ` ${selected.metadata.returnTime} UT` : "";
    const detail = date ? ` (${date}${time})` : "";
    return T("interface.contexto_cargado_valuevaluevalue_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label), v1: year, v2: detail });
  }

  if (selected.type === "synastry") {
    const subjectName = selected.metadata?.subjectName || birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = selected.metadata?.partnerName || "Persona B";
    return T("interface.contexto_cargado_value_value_y_value_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label), v1: subjectName, v2: partnerName });
  }

  if (selected.type === "composite" || selected.type === "compositeMultiple") {
    const subjectName = selected.metadata?.subjectName || birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = selected.metadata?.partnerName || "Persona B";
    return T("interface.contexto_cargado_value_value_value_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label), v1: subjectName, v2: partnerName });
  }

  return T("interface.contexto_cargado_value_escribe_tu_consulta_para_iniciar_la_lectura", { v0: I18n.label(selected.label) });
}

function setChatContextNotice() {
  const text = buildChatContextNotice();
  const firstMessage = messagesEl.firstElementChild;

  if (firstMessage?.classList.contains("system")) {
    I18n.bind(firstMessage, "textContent", () => text);
    updateEmptyChatState();
    return firstMessage;
  }

  const message = document.createElement("div");
  message.className = "message system";
  I18n.bind(message, "textContent", () => text);
  messagesEl.insertBefore(message, firstMessage || null);
  if (!isStreaming || !autoScrollLocked) scrollToBottom();
  updateEmptyChatState();
  return message;
}

function updateChatContextNotice() {
  const firstMessage = messagesEl.firstElementChild;
  if (firstMessage?.classList.contains("system")) I18n.bind(firstMessage, "textContent", () => buildChatContextNotice());
  updateEmptyChatState();
}

function updateEmptyChatState() {
  const hasConversationMessages = Array.from(messagesEl.querySelectorAll(".message")).
  some((message) => !message.classList.contains("system"));
  const isEmpty = !hasConversationMessages;
  chatScreen?.classList.toggle("chat-is-empty", isEmpty);
  emptyChatHero?.classList.toggle("is-hidden", !isEmpty);
}

function appendPromptHeader(lines, title, mapsLine, options = {}) {
  const profile = chartCalculation.profile;
  const age = calculateAgeYears(profile.birthDate);
  const universalTime = getUniversalTimeDisplay(profile) || profile.utcTimeUsed;
  const universalWeekday = getUniversalWeekdayLabel(profile);
  const localWeekday = getLocalBirthWeekdayInfo(profile).label || profile.weekday?.label || "";
  const promptWeekday = options.includeSideralBirthDay ?
  universalWeekday || localWeekday :
  localWeekday;

  lines.push(`MAPAS RECIBIDOS EXPLICITAMENTE EN LA SESION: ${mapsLine}.`);
  lines.push(`TIPO DE CONTEXTO DEL PROMPT EXPORTABLE: ${title}.`);
  lines.push("Estos datos proceden del formulario natal y del cálculo seleccionado en Gráficos de carta.");
  lines.push("");
  lines.push(`CASO (Paciente ${profile.name})`);
  lines.push(`- Edad: ${age}`);
  lines.push(`- Fecha de nacimiento: ${formatDateForPrompt(profile.birthDate)} | Hora: ${profile.birthTime}`);
  lines.push(`- Tiempo Universal: ${universalTime}`);
  lines.push(`- Lugar: ${profile.location.name}(${profile.location.countryName || profile.location.country})`);
  lines.push(`- Dia Nacimiento: ${promptWeekday}`);
  lines.push("");
  appendPromptPreferences(lines);
}

function promptConfigCardSelection() {
  const selected = {
    memoria: chartPromptIncludeMemoria?.checked !== false,
    tropical: chartPromptIncludeTropical?.checked !== false,
    sideral: chartPromptIncludeSideral?.checked !== false
  };

  if (!selected.memoria && !selected.tropical && !selected.sideral) {
    selected.memoria = true;
    if (chartPromptIncludeMemoria) chartPromptIncludeMemoria.checked = true;
  }

  return selected;
}

function promptConfigIsDefault(selection = promptConfigCardSelection()) {
  return Boolean(selection.memoria && selection.tropical && selection.sideral);
}

function selectedPromptMode() {
  const mode = chartPromptProfileSelect?.value || "multiple";
  return ["multiple", "report", "custom", "sessions"].includes(mode) ? mode : "multiple";
}

function setPromptPreferenceDefaults(key, selectedValues) {
  const values = new Set(selectedValues);
  document.querySelectorAll(`[data-prompt-preference="${key}"]`).forEach((input) => {
    input.checked = values.has(input.value);
  });
}

function syncPromptAstrologyLanguageContext() {
  if (!chartPromptExtraInfo || !chartPromptAstrologyLanguageSelect) return;

  const withoutAstrology = chartPromptAstrologyLanguageSelect.value === "Sin lenguaje astrológico";
  setPromptPreferenceDefaults(
    "style",
    withoutAstrology ? PROMPT_ASTROLOGY_HIDDEN_STYLES : PROMPT_ASTROLOGY_VISIBLE_STYLES
  );
  const desiredContext = withoutAstrology ?
  PROMPT_NO_ASTROLOGY_LANGUAGE_CONTEXT :
  PROMPT_ASTROLOGY_TECHNICAL_CONTEXT;
  const replacedContext = withoutAstrology ?
  PROMPT_ASTROLOGY_TECHNICAL_CONTEXT :
  PROMPT_NO_ASTROLOGY_LANGUAGE_CONTEXT;
  const currentContext = chartPromptExtraInfo.value || "";

  if (currentContext.includes(replacedContext)) {
    chartPromptExtraInfo.value = currentContext.replace(replacedContext, desiredContext);
  } else if (!currentContext.includes(desiredContext)) {
    chartPromptExtraInfo.value = currentContext.trim() ?
    `${currentContext.trimEnd()}\n\n${desiredContext}` :
    desiredContext;
  }
}

function applyAstroanamnesisPromptDefaults() {
  setPromptPreferenceDefaults("style", PROMPT_ASTROLOGY_VISIBLE_STYLES);
  setPromptPreferenceDefaults("tone", [
  "Directo",
  "Honesto",
  "Cálido, preciso y no complaciente"]
  );
  setPromptPreferenceDefaults("reportType", ["Autoconocimiento", "Relaciones"]);

  if (chartPromptEnablePreferences) chartPromptEnablePreferences.checked = true;
  if (chartPromptSizeSelect) chartPromptSizeSelect.value = "Largo";
  if (chartPromptAstrologyLanguageSelect) {
    chartPromptAstrologyLanguageSelect.value = "Con lenguaje astrológico";
  }
  if (chartPromptNarrativeSelect) chartPromptNarrativeSelect.value = "Segunda persona";
  if (chartPromptOtherStyleInput) chartPromptOtherStyleInput.value = "";
  if (chartPromptOtherToneInput) chartPromptOtherToneInput.value = "";
  if (chartPromptExtraInfo) chartPromptExtraInfo.value = PROMPT_ASTROANAMNESIS_CONTEXT;
  if (chartPromptProfileSelect) chartPromptProfileSelect.dataset.astroDefaultsInitialized = "true";
}

function ensureAstroanamnesisPromptDefaults() {
  if (currentChartDataType() !== "multiple" || selectedPromptMode() !== "multiple") return;
  if (chartPromptProfileSelect?.dataset.astroDefaultsInitialized === "true") return;
  applyAstroanamnesisPromptDefaults();
}

function promptModeLabel(mode = selectedPromptMode()) {
  return {
    multiple: "Astroanamnesis", get
    report() {return T("interface.informe");}, get
    custom() {return T("interface.personalizado");}, get
    sessions() {return T("interface.preparar_sesiones");}
  }[mode] || "Astroanamnesis";
}

function promptModeMetadata(mode = selectedPromptMode()) {
  return {
    multiple: "multiple",
    report: "informe",
    custom: "personalizado",
    sessions: "preparar_sesiones"
  }[mode] || "multiple";
}

function checkedPromptPreferenceValues(key) {
  return Array.from(document.querySelectorAll(`[data-prompt-preference="${key}"]:checked`)).
  map((input) => input.value).
  filter(Boolean);
}

function promptPreferenceValuesWithOther(key, otherInput) {
  const values = checkedPromptPreferenceValues(key);
  const otherValue = (otherInput?.value || "").trim();
  return values.map((value) => value === "Otro" && otherValue ? `Otro (${otherValue})` : value);
}

function buildPromptPreferencesPayload() {
  const enabled = Boolean(chartPromptEnablePreferences?.checked);
  return {
    enabled,
    style: promptPreferenceValuesWithOther("style", chartPromptOtherStyleInput),
    tone: promptPreferenceValuesWithOther("tone", chartPromptOtherToneInput),
    language: chartPromptLanguageSelect?.value || "Español",
    size: chartPromptSizeSelect?.value || "Mediano",
    reportType: checkedPromptPreferenceValues("reportType"),
    astrologyLanguage: chartPromptAstrologyLanguageSelect?.value || "Con lenguaje astrológico",
    narrative: chartPromptNarrativeSelect?.value || "Segunda persona",
    extraInfo: (chartPromptExtraInfo?.value || "").trim(),
    reportOrder: currentChartDataType() === "multiple" && selectedPromptMode() === "report" ?
    PROMPT_REPORT_ORDER :
    ""
  };
}

function appendPromptPreferences(lines) {
  const preferences = buildPromptPreferencesPayload();
  if (!preferences.enabled) return;

  lines.push("PREFERENCIAS DEL INFORME:");
  if (preferences.style.length) lines.push(`- Estilo: ${preferences.style.join(", ")}.`);
  if (preferences.tone.length) lines.push(`- Tono: ${preferences.tone.join(", ")}.`);
  lines.push(`- Idioma: ${preferences.language}.`);
  lines.push(`- Tamaño: ${preferences.size}.`);
  if (preferences.reportType.length) lines.push(`- Foco de interpretación: ${preferences.reportType.join(", ")}.`);
  lines.push(`- Lenguaje astrológico: ${preferences.astrologyLanguage}.`);
  lines.push(`- Narrativa: ${preferences.narrative}.`);
  if (preferences.extraInfo) lines.push(`- Información extra del usuario: ${preferences.extraInfo}`);
  if (preferences.reportOrder) {
    lines.push("ORDEN DEL INFORME:");
    lines.push(preferences.reportOrder);
  }
  lines.push("Aplica estas preferencias a la redacción interpretativa sin alterar los datos técnicos de las cartas.");
  lines.push("");
}

function syncPromptConfigUi() {
  const type = currentChartDataType();
  const isMultiple = type === "multiple";
  const profileField = chartPromptProfileSelect?.closest(".chart-prompt-profile");
  chartPromptMultipleOptions?.classList.toggle("is-hidden", !isMultiple);
  profileField?.classList.toggle("is-hidden", !isMultiple);
  if (chartPromptProfileSelect) chartPromptProfileSelect.disabled = !isMultiple;
  const preferencesEnabled = Boolean(chartPromptEnablePreferences?.checked);
  chartPromptPreferencesPanel?.classList.toggle("is-hidden", !preferencesEnabled);
  if (chartPromptEnablePreferencesLabel) {
    I18n.bind(chartPromptEnablePreferencesLabel, "textContent", () => preferencesEnabled ? T("interface.activadas") : T("interface.desactivadas"));


  }
  const showOtherStyle = Boolean(document.querySelector('[data-prompt-preference="style"][value="Otro"]')?.checked);
  const showOtherTone = Boolean(document.querySelector('[data-prompt-preference="tone"][value="Otro"]')?.checked);
  chartPromptOtherStyleField?.classList.toggle("is-hidden", !showOtherStyle);
  chartPromptOtherToneField?.classList.toggle("is-hidden", !showOtherTone);

  const selection = promptConfigCardSelection();
  const isDefault = isMultiple ? promptConfigIsDefault(selection) : true;
  if (chartPromptProfileSelect) {
    const mode = selectedPromptMode();
    if (!isMultiple || !["multiple", "report", "custom", "sessions"].includes(mode)) {
      chartPromptProfileSelect.value = isDefault ? "multiple" : "custom";
    }
  }
  if (chartPromptProfileLabel) {
    I18n.bind(chartPromptProfileLabel, "textContent", () => isMultiple ? promptModeLabel() : chartViewSummaryLabel(type));


  }
}

function buildChartContextForType(type) {
  if (type === "customChart" && chartCalculation) {
    return buildGuiaInternaPromptText({ cards: customChartCardSelection(), mode: selectedPromptMode() });
  }
  if (!chartCalculation) return buildDefaultBirthContext();

  if (type === "multiple") {
    return buildGuiaInternaPromptText({
      cards: promptConfigCardSelection(),
      mode: selectedPromptMode()
    });
  }

  const { tropical, memoria, sideral } = chartCalculation.charts;
  const lines = [];

  if (type === "tropical") {
    appendPromptHeader(lines, "Tropical / Avatar", "Carta Tropical");
    lines.push("Con los datos aportados solo puedo leer Tropical / Avatar. No voy a completar Memoria ni Sideral por inferencia.");
    lines.push("");
    appendTropicalPrompt(lines, tropical, { useNatalDisplayHouseShift: true });
    return lines.join("\n");
  }

  if (type === "memoria") {
    appendPromptHeader(lines, "Memoria Inconsciente", "Carta de Memoria");
    lines.push("Con los datos aportados solo puedo leer Memoria Inconsciente. No voy a completar Tropical ni Sideral por inferencia.");
    lines.push("");
    appendMemoriaPrompt(lines, memoria);
    return lines.join("\n");
  }

  if (type === "sideral") {
    appendPromptHeader(lines, "Sideral / Self", "Carta Sideral", { includeSideralBirthDay: true });
    lines.push("Con los datos aportados solo puedo leer Sideral / Self. No voy a completar Tropical ni Memoria por inferencia.");
    lines.push("");
    appendSideralPrompt(lines, sideral);
    return lines.join("\n");
  }

  if (type === "nodal") return buildNodalPromptText(buildNodalSchema(tropical), nodalAvailableContextCharts());
  if (type === "transits") return buildTransitPromptText(tropical, transitCalculation);
  if (type === "progressed") return buildSecondaryProgressedPromptText(tropical, progressedCalculation);
  if (type === "solarReturn") return buildSolarReturnPromptText(tropical, solarReturnCalculation);
  if (type === "synastry") return buildSynastryPromptText(tropical, synastryCalculation);
  if (type === "composite") return buildCompositePromptText(compositeCalculation);
  if (type === "compositeMultiple") return buildCompositeMultiplePromptText(compositeCalculation);

  return buildGuiaInternaPromptText();
}

// Serialize only maps already calculated for this person, without generating missing maps.
function nodalAvailableContextCharts(charts = chartCalculation?.charts || {}) {
  return Object.fromEntries(["tropical", "memoria", "sideral"].
  filter((type) => charts[type]?.planetsByKey && Object.keys(charts[type].planetsByKey).length).
  map((type) => [type, charts[type]]));
}

function nodalContextPositionText(point) {
  const parts = [point.sign, positionTinyText(point)].filter(Boolean);
  if (point.decanate?.sign) parts.push(`decanato ${point.decanate.sign}`);
  if (point.dodecatemoria?.sign) parts.push(`dodecatemoria ${point.dodecatemoria.sign}`);
  return parts.join(", ");
}

function visibleNodalContextChart(chart) {
  return {
    ...chart,
    planets: (chart.planets || []).filter((point) => isChartPlanetVisible(point.key)),
    planetsByKey: Object.fromEntries(Object.entries(chart.planetsByKey || {}).filter(([key]) => isChartPlanetVisible(key))),
    aspects: (chart.aspects || []).filter((aspect) => isChartPlanetVisible(aspect.planetA) && isChartPlanetVisible(aspect.planetB)),
    rulers: Object.fromEntries(Object.entries(chart.rulers || {}).filter(([, ruler]) => ruler?.position && isChartPlanetVisible(ruler.ruler))),
    ...(chart.nodalAgePoint ? { nodalAgePoint: {
        ...chart.nodalAgePoint,
        aspects: (chart.nodalAgePoint.aspects || []).filter((aspect) => isChartPlanetVisible(aspect.planetB))
      } } : {})
  };
}

function appendNodalContextChart(lines, chart, type, label) {
  chart = visibleNodalContextChart(chart);
  lines.push("", `${label} — contexto complementario:`);
  if (chart.ascendant && isChartPlanetVisible(CHART_ASCENDANT_KEY)) lines.push(`Ascendente: ${nodalContextPositionText(chart.ascendant)}.`);
  for (const key of [...CHART_PLANET_ORDER, "midpoint", "tierra"]) {
    const point = chart.planetsByKey[key];
    if (!point) continue;
    const name = PROMPT_PLANET_LABELS[key] || point.label || key;
    const house = chartHasVisibleHouses(chart) && point.house != null ?
    `, casa ${point.house}${type === "sideral" ? " (Whole Sign)" : ""}` : "";
    lines.push(`${name}: ${nodalContextPositionText(point)}${house}.`);
    const aspects = (chart.aspects || []).filter((aspect) => aspect.planetA === key || aspect.planetB === key);
    if (aspects.length) {
      lines.push(`Aspectos: ${aspects.map((aspect) => {
        const other = aspect.planetA === key ? aspect.planetB : aspect.planetA;
        const orb = type !== "sideral" && Number.isFinite(aspect.orb) ? `, orbe ${formatOrb(aspect.orb)}º` : "";
        return `${name} ${aspect.name || aspectNameForAngle(aspect.angle)} ${PROMPT_PLANET_LABELS[other] || other} (${aspect.angle}º${orb})`;
      }).join("; ")}.`);
    }
  }
  for (const [key, ruler] of Object.entries(chart.rulers || {})) {
    if (!ruler?.position) continue;
    lines.push(`Regente ${key}: ${ruler.rulerLabel || ruler.ruler}, ${nodalContextPositionText(ruler.position)}.`);
  }
  const houses = chartDisplayHouses(chart);
  appendVisibleChartAnglesPrompt(lines, chart);
  if (houses.length) lines.push("Cúspides de las casas:");
  for (const house of houses) {
    lines.push(`Casa ${romanHouse(house.number)}: ${nodalContextPositionText(house)}.`);
  }
}

function buildNodalPromptText(nodal, contextCharts = {}) {
  const lines = [];
  const pointLabel = nodal.isCurrentAge ? "actual" : "consultado";
  const availableCharts = nodalAvailableContextCharts(contextCharts);
  const mapLabels = { tropical: "Carta Tropical", memoria: "Carta de Memoria", sideral: "Carta Sideral" };
  appendPromptHeader(lines, "Esquema nodal", ["Esquema nodal", ...Object.keys(availableCharts).map((key) => mapLabels[key])].join(" + "));
  lines.push(`Fecha del punto de edad ${pointLabel}: ${formatDateForPrompt(nodal.referenceDate)}.`);
  lines.push(`Edad del punto nodal ${pointLabel}: ${nodal.ageText} anos.`);
  lines.push(`Punto de edad ${pointLabel}: ${nodalContextPositionText(enrichChartPointClient("Punto de edad", nodal.currentAgeDegree))}, casa nodal ${romanHouse(nodalHouseNumber(nodal.currentAgeDegree, nodal.nodalAsc))}, edad ${nodal.ageText} anos.`);
  lines.push("");
  lines.push("Planetas del esquema nodal:");
  for (const key of [...CHART_PLANET_ORDER, "midpoint", "tierra"]) {
    const planetItem = nodal.chart.planetsByKey[key];
    if (!planetItem || !isChartPlanetVisible(key)) continue;
    lines.push(`${PROMPT_PLANET_LABELS[key] || planetItem.label}: ${nodalContextPositionText(planetItem)}, casa ${planetItem.houseLabel}, edad ${nodalYearText(planetItem.longitude, nodal.nodalAsc, 1)} anos.`);
  }
  lines.push("");
  lines.push("Cúspides y edades de casas nodales:");
  for (const house of nodal.chart.houses) {
    lines.push(`Casa ${romanHouse(house.number)}: ${nodalContextPositionText(house)}, edad ${nodalHouseYearText(Number(house.number))}.`);
  }
  lines.push("");
  lines.push(`Aspectos del punto de edad ${pointLabel}:`);
  const visibleAspectRows = nodal.aspectRows.filter((row) => isChartPlanetVisible(row.planet.key));
  lines.push(visibleAspectRows.length ?
  visibleAspectRows.map((row) => `Punto de edad ${aspectNameForAngle(row.angle)} ${row.planet.label} (orbe ${formatOrb(row.orb)}º)`).join(" ") :
  `No hay aspectos calculados al punto de edad ${pointLabel}.`);
  appendVisibleChartAnglesPrompt(lines, nodal.chart, CHART_ANGLE_POINT_KEYS);
  for (const [type, chart] of Object.entries(availableCharts)) {
    appendNodalContextChart(lines, chart, type, mapLabels[type]);
  }
  return lines.join("\n");
}

function buildTransitPromptText(natalChart, transits) {
  const lines = [];
  appendPromptHeader(lines, "Tropical con tránsitos", "Carta Tropical + Tránsitos");
  appendTropicalPrompt(lines, natalChart, { useNatalDisplayHouseShift: true });
  lines.push("");
  const localMoment = transitLocalMoment(transits, { useControls: false });
  const technicalUtc = [transits?.dateUsedBySwetest, transits?.utTimeUsedBySwetest].
  filter(Boolean).
  join(" ");
  lines.push(`TRANSITOS CARGADOS: ${localMoment.label || "fecha no determinada"}${technicalUtc ? ` (equivale a ${technicalUtc} UT para el cálculo)` : ""}.`);
  lines.push("Posiciones de transito sobre casas tropicales natales:");
  for (const planetItem of transits?.planets || []) {
    if (!isChartPlanetVisible(planetItem.key)) continue;
    const house = houseNumberFromCuspsClient(planetItem.longitude, natalChart.houses);
    lines.push(`${PROMPT_PLANET_LABELS[planetItem.key] || planetItem.label}: ${positionTinyText(planetItem)}${planetItem.retrograde ? "R" : ""}, casa ${romanHouse(house)}.`);
  }
  const matrix = buildAspectMatrix({
    rowPlanets: transits?.planets || [],
    columnPlanets: natalChart.planets || [],
    rowLabel: "Transito",
    columnLabel: "Natal",
    houseCusps: natalChart.houses
  });
  appendAspectMatrixPrompt(lines, matrix, "Aspectos transito-natal");
  return lines.join("\n");
}

function buildSecondaryProgressedPromptText(natalChart, progression) {
  const chart = progression?.chart;
  const targetMoment = progressedLocalMoment(progression, { useControls: false });
  const lines = [];
  appendPromptHeader(lines, "Tropical progresada", "Carta Tropical natal + Progresión secundaria");
  lines.push("Método: progresión secundaria clásica, 1 día de efemérides por cada año tropical de vida.");
  lines.push(`Momento local de progresión seleccionado: ${targetMoment.label || "no determinado"}.`);
  if (Number.isFinite(Number(progression?.ageYears))) {
    lines.push(`Edad simbólica calculada: ${Number(progression.ageYears).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} años.`);
  }
  lines.push(`Fecha de efemérides progresada: ${progression?.dateUsedBySwetest || "no determinada"} ${progression?.utTimeUsedBySwetest || ""} UT.`);
  lines.push("Casas y ejes: clave de Naibod aplicada al ARMC natal.");
  const stationItems = Array.isArray(progression?.progressedStations?.items) ?
  progression.progressedStations.items :
  [];
  const visibleStationItems = stationItems.filter((item) => isChartPlanetVisible(item.planet));
  if (visibleStationItems.length) {
    lines.push("Estaciones directas de planetas retrógrados natales:");
    visibleStationItems.forEach((item) => {
      const planetLabel = PROMPT_PLANET_LABELS[item.planet] || item.label || item.planet;
      if (!item.stationFound) {
        lines.push(`- ${planetLabel}: permanece retrógrado al menos hasta los ${progression.progressedStations.maxAgeYears || 120} años simbólicos.`);
        return;
      }
      lines.push(`- ${planetLabel}: estación directa a los ${formatProgressedStationAge(item.stationAgeYears)}, fecha personal ${formatContextDate(item.stationLifeDate)} ${item.stationLifeTime || ""} ${item.stationTimeZone || ""}, en ${progressedStationPosition(item)}. En la fecha elegida está ${item.statusAtTarget === "direct" ? "directo" : "retrógrado"}.`);
    });
  } else {
    lines.push("No hay planetas retrógrados natales visibles entre Mercurio y Plutón.");
  }
  lines.push("");
  lines.push("Carta Tropical natal:");
  appendTropicalPrompt(lines, natalChart, { useNatalDisplayHouseShift: true });

  if (!chart) {
    lines.push("");
    lines.push("No hay carta tropical progresada calculada.");
    return lines.join("\n");
  }

  lines.push("");
  lines.push("Carta Tropical progresada:");
  appendTropicalPrompt(lines, chart);

  const matrix = buildAspectMatrix({
    rowPlanets: chart.planets || [],
    columnPlanets: natalChart.planets || [],
    rowLabel: "Progresada",
    columnLabel: "Natal",
    houseCusps: natalChart.houses
  });
  appendAspectMatrixPrompt(lines, matrix, "Aspectos progresada-natal");
  return lines.join("\n");
}

function buildSolarReturnPromptText(natalChart, solarReturn) {
  const chart = solarReturn?.chart;
  const returnWeekday = formatWeekdayFromDateText(solarReturn?.dateUsedBySwetest);
  const lines = [];
  appendPromptHeader(lines, "Revolución solar", "Carta Tropical natal + Revolución solar");
  appendTropicalPrompt(lines, natalChart, { useNatalDisplayHouseShift: true });
  lines.push("");
  lines.push(`REVOLUCION SOLAR CARGADA: año ${solarReturn?.targetYear || "no determinado"}.`);
  lines.push(`Instante exacto del retorno solar: ${solarReturn?.dateUsedBySwetest || "fecha no determinada"} ${solarReturn?.utTimeUsedBySwetest || ""} UT.`);
  if (returnWeekday) {
    lines.push(`Día de la semana de la revolución solar: ${returnWeekday}.`);
  }
  if (solarReturn?.natalSun?.formatted) {
    lines.push(`Longitud solar natal objetivo: ${solarReturn.natalSun.formatted} ${solarReturn.natalSun.sign}.`);
  }
  if (!chart) {
    lines.push("No hay carta de revolución solar calculada.");
    return lines.join("\n");
  }

  lines.push("");
  lines.push("Carta de revolución solar:");
  appendTropicalPrompt(lines, chart);

  const matrix = buildAspectMatrix({
    rowPlanets: chart.planets || [],
    columnPlanets: natalChart.planets || [],
    rowLabel: "Revolución solar",
    columnLabel: "Natal",
    houseCusps: natalChart.houses
  });
  appendAspectMatrixPrompt(lines, matrix, "Aspectos revolución solar-natal");
  return lines.join("\n");
}

function buildSynastryPromptText(natalChart, partnerCalculation) {
  const partnerChart = partnerCalculation?.charts?.tropical;
  const partnerName = partnerCalculation?.profile?.name || "Otra persona";
  const subjectName = birthProfile?.name || chartCalculation.profile.name;
  const lines = [];
  appendPromptHeader(lines, `Sinastría tropical con ${partnerName}`, "Carta Tropical propia + Carta Tropical de la otra persona");
  lines.push(`Persona A: ${subjectName}.`);
  appendTropicalPrompt(lines, natalChart, { useNatalDisplayHouseShift: true });
  lines.push("");
  lines.push(`Persona B: ${partnerName}.`);
  if (partnerChart) {
    appendTropicalPrompt(lines, partnerChart);
    const matrix = buildAspectMatrix({
      rowPlanets: partnerChart.planets || [],
      columnPlanets: natalChart.planets || [],
      rowLabel: partnerName,
      columnLabel: subjectName,
      houseCusps: natalChart.houses
    });
    appendAspectMatrixPrompt(lines, matrix, "Aspectos de sinastria");
    lines.push("");
    lines.push("Planetas en casas de la otra carta:");
    const houseRows = [
    ...synastryHouseRows(partnerChart.planets, natalChart.houses, partnerName, subjectName),
    ...synastryHouseRows(natalChart.planets, partnerChart.houses, subjectName, partnerName)];

    for (const row of houseRows) {
      if (!isChartPlanetVisible(row.key)) continue;
      lines.push(`${row.owner} ${PROMPT_PLANET_LABELS[row.key] || row.key} cae en casa ${romanHouse(row.house)} de ${row.houseOwner}.`);
    }
  } else {
    lines.push("No hay carta de sinastria calculada.");
  }
  return lines.join("\n");
}

function buildCompositePromptText(compositeData) {
  const compositeChart = compositeData?.charts?.tropical || compositeData?.chart;
  const partnerCalculation = compositeData?.partner;
  const partnerName = partnerCalculation?.profile?.name || getSelectedSynastryPersonName() || "Persona B";
  const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
  const lines = [];

  appendPromptHeader(lines, `Carta compuesta con ${partnerName}`, "Carta compuesta tropical por puntos medios");
  lines.push(`Persona A: ${subjectName}.`);
  lines.push(`Persona B: ${partnerName}.`);
  lines.push("Metodo: puntos medios circulares entre las posiciones tropicales de ambas cartas. Las casas se construyen promediando los offsets de cúspides respecto al Ascendente, siguiendo el criterio de guiaInterna.");
  lines.push("Esta carta describe la dinámica simbólica del vínculo; no sustituye la lectura individual ni promete resultados relacionales.");
  lines.push("");

  if (compositeChart) {
    lines.push("Carta compuesta:");
    for (const key of ["Sun", "Moon", "tierra", "midpoint", "true Node", "south Node"]) {
      if (compositeChart.planetsByKey?.[key] && isChartPlanetVisible(key)) lines.push(pointLine(compositeChart, key));
    }
    lines.push("");
    lines.push("Planetas y aspectos de la compuesta:");
    appendPlanetAspectLines(lines, compositeChart, promptSecondaryPlanetKeys(compositeChart));
    lines.push("");
    appendCuspLines(lines, compositeChart, "tropical", false);
    appendVisibleChartAnglesPrompt(lines, compositeChart, [CHART_ASCENDANT_KEY]);
  } else {
    lines.push("No hay carta compuesta calculada.");
  }

  return lines.join("\n");
}

function compositePromptChart(chart, cuspMode = "tropical") {
  if (!chart || cuspMode !== "memoria") return chart;

  const displayHouses = chartDisplayHouses({ ...chart, type: "memoria" });
  const houseForPoint = (point) => {
    const longitude = Number(point?.longitude);
    if (!Number.isFinite(longitude)) return point?.house;
    if (displayHouses.length) return houseNumberFromReverseCuspsClient(longitude, displayHouses);
    return point?.house;
  };
  const planetsByKey = Object.fromEntries(
    Object.entries(chart.planetsByKey || {}).map(([key, point]) => [
    key,
    { ...point, house: houseForPoint(point) }]
    )
  );
  const planets = Array.isArray(chart.planets) ?
  chart.planets.map((point) => ({ ...point, house: houseForPoint(point) })) :
  chart.planets;

  return {
    ...chart,
    type: "memoria",
    houses: displayHouses,
    planets,
    planetsByKey,
    aspects: calculateClientOrbAspects(planetsByKey, displayHouses)
  };
}

function appendCompositeChartPrompt(lines, title, chart, cuspMode = "tropical", options = {}) {
  lines.push(options.heading || `${title}:`);

  if (!chart) {
    lines.push("No calculada.");
    lines.push("");
    return;
  }

  const promptChart = compositePromptChart(chart, cuspMode);
  const promptCuspMode = cuspMode === "memoria" ? "tropical" : cuspMode;

  for (const key of ["Sun", "Moon", "tierra", "midpoint", "true Node", "south Node"]) {
    if (promptChart.planetsByKey?.[key] && isChartPlanetVisible(key)) lines.push(pointLine(promptChart, key));
  }
  lines.push("");
  lines.push(`Planetas y aspectos (${title.toLowerCase()}):`);
  appendPlanetAspectLines(lines, promptChart, promptSecondaryPlanetKeys(promptChart));
  lines.push("");
  appendCuspLines(lines, promptChart, promptCuspMode, false);
  appendVisibleChartAnglesPrompt(lines, promptChart, [CHART_ASCENDANT_KEY]);
  lines.push("");
}

function buildCompositeMultiplePromptText(compositeData) {
  const partnerCalculation = compositeData?.partner;
  const partnerName = partnerCalculation?.profile?.name || getSelectedSynastryPersonName() || "Persona B";
  const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
  const charts = compositeData?.charts || {};
  const lines = [];

  appendPromptHeader(lines, `Carta compuesta Astroanamnesis con ${partnerName}`, "Compuesta tropical + compuesta de memoria + compuesta sideral por puntos medios");
  lines.push(`Persona A: ${subjectName}.`);
  lines.push(`Persona B: ${partnerName}.`);
  lines.push("Metodo: puntos medios circulares aplicados por separado a Tropical, Memoria Inconsciente y Sideral.");
  lines.push("Esta vista permite observar la dinámica del vínculo en los tres niveles sin mezclar cartas individuales ni completar datos por inferencia.");
  lines.push("");

  appendCompositeChartPrompt(
    lines,
    "Carta compuesta tropical",
    charts.tropical || compositeData?.chart,
    "tropical",
    { heading: "A) Tropical:" }
  );
  appendCompositeChartPrompt(
    lines,
    "Carta compuesta de memoria",
    charts.memoria,
    "memoria",
    { heading: "B) Memoria inconsciente:" }
  );
  appendCompositeChartPrompt(
    lines,
    "Carta compuesta sideral",
    charts.sideral,
    "sideral",
    { heading: "C) Sideral:" }
  );

  return lines.join("\n").trim();
}

function appendAspectMatrixPrompt(lines, matrix, title) {
  lines.push("");
  lines.push(`${title}:`);
  if (!matrix?.count) {
    lines.push("No hay aspectos mayores calculados.");
    return;
  }

  matrix.rows.forEach((row) => {
    row.cells.forEach((cell, index) => {
      if (!cell) return;
      const column = matrix.columns[index];
      lines.push(`${row.label} ${cell.symbol} ${column.label}, orbe ${cell.orb}º.`);
    });
  });
}

function buildGuiaInternaPromptText(options = {}) {
  const profile = chartCalculation.profile;
  const tropical = chartCalculation.charts.tropical;
  const memoria = chartCalculation.charts.memoria;
  const sideral = chartCalculation.charts.sideral;
  const cards = {
    memoria: options.cards?.memoria !== false,
    tropical: options.cards?.tropical !== false,
    sideral: options.cards?.sideral !== false
  };
  if (!cards.memoria && !cards.tropical && !cards.sideral) cards.memoria = true;
  const isDefaultMultiple = cards.memoria && cards.tropical && cards.sideral;
  const localWeekday = getLocalBirthWeekdayInfo(profile);
  const dayLabel = localWeekday.label || profile.weekday?.label || "";
  const dayPlanet = localWeekday.planet || normalizePromptPlanetKey(profile.weekday?.planet || "");
  const dayPlanetLabel = PROMPT_PLANET_LABELS[dayPlanet] || dayPlanet;
  const age = calculateAgeYears(profile.birthDate);
  const lines = [];
  const selectedMapLabels = [
  cards.memoria ? "Carta de Memoria" : "",
  cards.tropical ? "Carta Tropical" : "",
  cards.sideral ? "Carta Sideral" : ""].
  filter(Boolean);

  if (options.mode === "report") {
    lines.push("Informe");
    lines.push("");
  }
  lines.push(`MAPAS RECIBIDOS EXPLICITAMENTE EN LA SESION: ${selectedMapLabels.join(" + ")}.`);
  lines.push("Estos datos proceden del formulario natal y del cálculo múltiple previo al chat.");
  lines.push("");
  lines.push(`CASO (Paciente ${profile.name})`);
  lines.push(`- Edad: ${age}`);
  lines.push(`- Fecha de nacimiento: ${formatDateForPrompt(profile.birthDate)} | Hora: ${profile.birthTime}`);
  lines.push(`- Tiempo Universal: ${getUniversalTimeDisplay(profile) || profile.utcTimeUsed}`);
  lines.push(`- Lugar: ${profile.location.name}(${profile.location.countryName || profile.location.country})`);
  lines.push(`- Dia Nacimiento: ${dayLabel}`);
  lines.push("");
  appendPromptPreferences(lines);

  const dayPlanetItem = planet(tropical, dayPlanet);
  if ((isDefaultMultiple || cards.tropical) && dayLabel && dayPlanetItem && isChartPlanetVisible(dayPlanet)) {
    lines.push(`${dayLabel} (${dayPlanetLabel}). ${dayPlanetLabel} se encuentra en ${dayPlanetItem.sign}, decanato de ${dayPlanetItem.decanate.sign}, dodecatemoria de ${dayPlanetItem.dodecatemoria.sign}, en la casa ${displayHouseForTropical(dayPlanet)}.`);
    lines.push(`Los aspectos a ${dayPlanetLabel} son: ${aspectsForPlanetText(tropical, dayPlanet)}.`);
    lines.push("");
  }

  if (cards.tropical) {
    appendTropicalPrompt(lines, tropical, {
      useNatalDisplayHouseShift: true,
      heading: "A) Tropical:"
    });
    lines.push("");
  }
  if (cards.memoria) {
    appendMemoriaPrompt(lines, memoria, { heading: "B) Memoria inconsciente:" });
    lines.push("");
  }
  if (cards.sideral) {
    appendSideralPrompt(lines, sideral, cards.tropical ? tropical : null);
  }

  return lines.join("\n").trimEnd();
}

function promptSecondaryPlanetKeys(chart) {
  const primaryPoints = new Set(["Sun", "Moon", "tierra", "midpoint", "true Node", "south Node"]);
  return [...new Set([...PROMPT_PRIMARY_PLANET_ORDER.slice(2), ...PROMPT_OPTIONAL_BODY_ORDER, ...Object.keys(chart?.planetsByKey || {})])].
  filter((key) => !primaryPoints.has(key) && !CHART_ANGLE_POINT_KEYS.includes(key));
}

function appendVisiblePointLine(lines, chart, key, label, houseOverride) {
  if (!isChartPlanetVisible(key) || !chart?.planetsByKey?.[key]) return;
  lines.push(pointLine(chart, key, label, houseOverride));
}

function appendMemoriaPrompt(lines, chart, options = {}) {
  lines.push(options.heading || "A) Memoria inconsciente:");
  if (isChartPlanetVisible("Sun")) {
    lines.push(pointLine(chart, "Sun"));
    lines.push(`Los aspectos al Sol son: ${aspectsForPlanetText(chart, "Sun")}.`);
    lines.push(equivalentCuspLine(chart, "memoria"));
    if (isChartPlanetVisible(chart.rulers?.solar?.ruler)) lines.push(rulerLine(chart, "solar", "solar"));
    lines.push(`La cuspide de la casa 5(la casa del sol) se encuentra en ${cuspText(chart, "memoria", 5)}.`);
  }
  if (isChartPlanetVisible("Moon")) {
    lines.push(pointLine(chart, "Moon", "Luna"));
    lines.push(`Los aspectos a la luna son: ${aspectsForPlanetText(chart, "Moon")}.`);
    if (isChartPlanetVisible(chart.rulers?.lunar?.ruler)) lines.push(rulerLine(chart, "lunar", "lunar"));
    lines.push(`La cuspide de la casa 4(la casa de la luna) se encuentra en ${cuspText(chart, "memoria", 4)}.`);
  }
  if (isChartPlanetVisible(CHART_ASCENDANT_KEY)) lines.push(`Ascendente(Cuspide casa 1) en ${chart.ascendant.sign}, decanato ${chart.ascendant.decanate.sign}, dodecatemoria ${chart.ascendant.dodecatemoria.sign}, grado ${chart.ascendant.degree}º, minuto ${chart.ascendant.minute}.`);
  appendVisiblePointLine(lines, chart, "tierra", "Tierra");
  appendVisiblePointLine(lines, chart, "midpoint", "Punto medio Sol-Luna");
  appendVisiblePointLine(lines, chart, "true Node", "Nodo norte");
  appendVisiblePointLine(lines, chart, "south Node", "Nodo sur");
  lines.push("");
  lines.push("Planetas y aspectos en Memoria Inconsciente(reubicacion de los aspectos tropicales):");
  appendPlanetAspectLines(lines, chart, promptSecondaryPlanetKeys(chart));
  lines.push("");
  appendCuspLines(lines, chart, "memoria", false);
}

function appendTropicalPrompt(lines, chart, options = {}) {
  const displayHouse = (key) => options.useNatalDisplayHouseShift ? displayHouseForTropical(key) : undefined;
  lines.push(options.heading || "B) Tropical:");
  if (isChartPlanetVisible("Sun")) {
    lines.push(pointLine(chart, "Sun", "Sol", displayHouse("Sun")));
    lines.push(`Los aspectos al Sol son: ${aspectsForPlanetText(chart, "Sun")}.`);
    lines.push(equivalentCuspLine(chart, "tropical"));
    if (isChartPlanetVisible(chart.rulers?.solar?.ruler)) {
      lines.push(rulerLine(chart, "solar", "solar", options.useNatalDisplayHouseShift));
      lines.push(`Los aspectos al planeta regente del signo solar (${chart.rulers.solar.rulerLabel}) son: ${aspectsForPlanetText(chart, chart.rulers.solar.ruler)}.`);
    }
    lines.push(`La cuspide de la casa 5 se encuentra en ${cuspText(chart, "tropical", 5)}.`);
  }
  if (isChartPlanetVisible("Moon")) {
    lines.push(pointLine(chart, "Moon", "Luna", displayHouse("Moon")));
    lines.push(`Los aspectos a la luna son: ${aspectsForPlanetText(chart, "Moon")}.`);
    if (isChartPlanetVisible(chart.rulers?.lunar?.ruler)) {
      lines.push(rulerLine(chart, "lunar", "lunar", options.useNatalDisplayHouseShift));
      lines.push(`Los aspectos al planeta regente del signo lunar(${chart.rulers.lunar.rulerLabel}) son: ${aspectsForPlanetText(chart, chart.rulers.lunar.ruler)}.`);
    }
    lines.push(`La cuspide de la casa 4(la casa de la luna) se encuentra en ${cuspText(chart, "tropical", 4)}.`);
  }
  if (isChartPlanetVisible(CHART_ASCENDANT_KEY)) lines.push(`Ascendente(Cuspide casa 1) en ${chart.ascendant.sign}, decanato ${chart.ascendant.decanate.sign}, dodecatemoria ${chart.ascendant.dodecatemoria.sign}, grado ${chart.ascendant.degree}º, minuto ${chart.ascendant.minute}.`);
  appendVisiblePointLine(lines, chart, "tierra", "Tierra", displayHouse("tierra"));
  appendVisiblePointLine(lines, chart, "midpoint", "Punto medio Sol-Luna", displayHouse("midpoint"));
  appendVisiblePointLine(lines, chart, "true Node", "Nodo norte", displayHouse("true Node"));
  appendVisiblePointLine(lines, chart, "south Node", "Nodo sur", displayHouse("south Node"));
  lines.push("");
  lines.push("Planetas y sus aspectos:");
  appendPlanetAspectLines(lines, chart, promptSecondaryPlanetKeys(chart), options.useNatalDisplayHouseShift);
  lines.push("");
  appendCuspLines(lines, chart, "tropical", false);
}

function appendSideralPrompt(lines, chart, tropical = null) {
  lines.push("C) Sideral:");
  if (isChartPlanetVisible("Sun")) {
    lines.push(pointLine(chart, "Sun"));
    lines.push(`Los aspectos al Sol son: ${aspectsForPlanetText(chart, "Sun", true)}.`);
    lines.push(equivalentCuspLine(chart, "sideral"));
    if (isChartPlanetVisible(chart.rulers?.solar?.ruler)) lines.push(rulerLine(chart, "solar", "solar"));
    lines.push(`La cuspide de la casa 5 se encuentra en ${cuspSignText(chart, "sideral", 5)}.`);
  }
  if (isChartPlanetVisible("Moon")) {
    lines.push(pointLine(chart, "Moon", "Luna"));
    lines.push(`Los aspectos a la Luna son: ${aspectsForPlanetText(chart, "Moon", true)}.`);
    if (isChartPlanetVisible(chart.rulers?.lunar?.ruler)) lines.push(rulerLine(chart, "lunar", "lunar"));
    lines.push(`La cuspide de la casa 4(la casa de la luna) se encuentra en ${cuspSignText(chart, "sideral", 4)}.`);
  }
  if (isChartPlanetVisible(CHART_ASCENDANT_KEY)) lines.push(`Ascendente(Cuspide casa 1) en ${chart.ascendant.sign}.`);
  appendVisiblePointLine(lines, chart, "tierra", "Tierra");
  appendVisiblePointLine(lines, chart, "midpoint", "Punto medio Sol-Luna");
  appendVisiblePointLine(lines, chart, "true Node", "Nodo norte");
  appendVisiblePointLine(lines, chart, "south Node", "Nodo sur");
  if (tropical && (isChartPlanetVisible("Sun") || isChartPlanetVisible("Moon"))) {
    lines.push("");
    lines.push("Comparativa de tropical a sideral:");
    if (isChartPlanetVisible("Sun")) lines.push(`Sol pasa de ${pointLine(tropical, "Sun", "Sol", displayHouseForTropical("Sun")).replace(/\.$/, "")}. A ${pointLine(chart, "Sun", "Sol").replace(/\.$/, "")}.`);
    if (isChartPlanetVisible("Moon")) lines.push(`Luna pasa de ${pointLine(tropical, "Moon", "Luna", displayHouseForTropical("Moon")).replace(/\.$/, "")}. A ${pointLine(chart, "Moon", "Luna").replace(/\.$/, "")}.`);
  }
  lines.push("");
  lines.push("Planetas y aspectos Siderales (sin orbes, por naturaleza):");
  appendPlanetAspectLines(lines, chart, promptSecondaryPlanetKeys(chart), false, true);
  lines.push("");
  appendCuspLines(lines, chart, "sideral", true);
}

function appendPlanetAspectLines(lines, chart, keys, useTropicalHouseShift = false, sideralAspects = false) {
  for (const key of keys) {
    if (!isChartPlanetVisible(key) || !chart?.planetsByKey?.[key]) continue;
    const house = useTropicalHouseShift ? displayHouseForTropical(key) : undefined;
    lines.push(pointLine(chart, key, PROMPT_PLANET_LABELS[key], house));
    lines.push(`Los aspectos a ${PROMPT_PLANET_LABELS[key]} son: ${aspectsForPlanetText(chart, key, sideralAspects)}.`);
  }
}

function appendVisibleChartAnglesPrompt(lines, chart, keys = CHART_ANGLE_POINT_KEYS.filter((key) => key !== CHART_ASCENDANT_KEY)) {
  for (const key of keys) {
    if (!isChartPlanetVisible(key)) continue;
    const point = chartAspectPlanet(chart, key);
    if (!point) continue;
    lines.push(`${point.label || key}: ${nodalContextPositionText(point)}.`);
  }
}

function appendCuspLines(lines, chart, type, onlySign) {
  appendVisibleChartAnglesPrompt(lines, chart);
  lines.push("Cúspides de las casas:");
  for (const house of PROMPT_CUSP_HOUSES) {
    const value = onlySign ? cuspSignText(chart, type, house) : cuspText(chart, type, house);
    lines.push(`La cuspide de la casa ${house} se encuentra en ${value}.`);
  }
}

function pointLine(chart, key, label = PROMPT_PLANET_LABELS[key] || key, houseOverride) {
  const item = planet(chart, key);
  const house = houseOverride ?? item.house;
  return `${label} en ${item.sign}, decanato ${item.decanate.sign}, dodecatemoria ${item.dodecatemoria.sign}, grado ${item.degree}º, minuto ${item.minute}, en casa ${house}.`;
}

function rulerLine(chart, rulerType, label, useTropicalHouseShift = false) {
  const ruler = chart.rulers?.[rulerType];
  if (!ruler?.position) return `Planeta regente del signo ${label} no determinable.`;
  const house = useTropicalHouseShift ? displayHouseForTropical(ruler.ruler) : ruler.position.house;
  return `Planeta regente del signo ${label} es ${ruler.rulerLabel} y se encuentra en ${ruler.position.sign}, decanato de ${ruler.position.decanate.sign}, dodecatemoria de ${ruler.position.dodecatemoria.sign}, en la casa ${house}.`;
}

function equivalentCuspLine(chart, type) {
  const house = planet(chart, "Sun").signIndex + 1;
  if (type === "sideral") {
    return `Signo de la cuspide de la casa equivalente al signo donde se encuentra el sol: Cuspide de la casa ${house} se encuentra en ${cuspSignText(chart, type, house)}.`;
  }

  const cusp = promptCusp(chart, type, house);
  return `Signo de la cuspide de la casa equivalente al signo donde se encuentra el sol: Cuspide de la casa ${house} se encuentra en ${cusp.sign}, decanato de ${cusp.decanate.sign}, dodecatemoria de ${cusp.dodecatemoria.sign}.`;
}

function cuspText(chart, type, house) {
  const cusp = promptCusp(chart, type, house);
  return `${cusp.sign}, decanato de ${cusp.decanate.sign}, dodecatemoria de ${cusp.dodecatemoria.sign}, grado ${cusp.degree}º, minuto ${cusp.minute}`;
}

function cuspSignText(chart, type, house) {
  if (type === "sideral") return sideralWholeSignCuspSign(chart, house);
  return promptCusp(chart, type, house).sign;
}

function promptCusp(chart, type, house) {
  const sourceHouse = type === "memoria" ? MEMORIA_CUSP_REMAP[house] || house : house;
  return chart.houses.find((item) => Number(item.number) === Number(sourceHouse)) || chart.houses[0];
}

function sideralWholeSignCuspSign(chart, house) {
  const ascendantSign = chart.ascendant?.signIndex ?? promptCusp(chart, "sideral", 1)?.signIndex ?? 0;
  return PROMPT_SIGNS[(ascendantSign + Number(house) - 1 + 12) % 12];
}

function aspectsForPlanetText(chart, key, sideral = false) {
  const allowed = new Set(aspectOrderForChart(chart));
  const rows = chartAspectsIncludingAngles(chart).filter((aspect) => {
    const touchesPlanet = aspect.planetA === key || aspect.planetB === key;
    return isEnabledAspect(aspect) &&
    isAspectConsistentWithCurrentRules(chart, aspect) &&
    isChartAspectTypeVisible(aspect.angle) &&
    touchesPlanet &&
    allowed.has(aspect.planetA) &&
    allowed.has(aspect.planetB) &&
    isChartPlanetVisible(aspect.planetA) &&
    isChartPlanetVisible(aspect.planetB) &&
    isChartPlanetAspectVisible(aspect.planetA) &&
    isChartPlanetAspectVisible(aspect.planetB);
  });

  if (!rows.length) return `${PROMPT_PLANET_LABELS[key] || key} no tiene aspectos${sideral ? " (sideral)" : ""}`;

  return rows.map((aspect) => {
    const other = aspect.planetA === key ? aspect.planetB : aspect.planetA;
    const base = `${PROMPT_PLANET_LABELS[key] || key} ${aspect.name} ${PROMPT_PLANET_LABELS[other] || other} (${aspect.angle}º`;
    return sideral ? `${base})` : `${base}, orbe ${formatOrb(aspect.orb)}º)`;
  }).join(" ");
}

function displayHouseForTropical(key) {
  const item = chartCalculation?.charts?.tropical?.planetsByKey?.[key];
  const houses = chartCalculation?.charts?.tropical?.houses || [];
  if (!item) return "";

  const nextHouse = Number(item.house) % 12 + 1;
  const nextCusp = houses.find((house) => Number(house.number) === nextHouse);
  if (nextCusp && nextCusp.signIndex === item.signIndex && nextCusp.decanate.absoluteIndex === item.decanate.absoluteIndex) {
    return nextHouse;
  }

  return item.house;
}

function planet(chart, key) {
  return chart.planetsByKey[key];
}

function formatDateForPrompt(date) {
  const [year, month, day] = String(date || "").split("-");
  return `${Number(day)}/${pad(month)}/${year}`;
}

function calculateAgeYears(date) {
  const birth = new Date(`${date}T00:00:00`);
  if (Number.isNaN(birth.getTime())) return "";
  const seconds = (Date.now() - birth.getTime()) / 1000;
  return Math.floor(seconds / (365.2422 * 24 * 60 * 60));
}

function formatOrb(value) {
  if (value === null || value === undefined) return "";
  return Number(value).toFixed(2).replace(/\.?0+$/, "");
}

function aspectNameForAngle(angle) {
  return ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === Number(angle))?.name || `${angle}º`;
}

function renderPromptSuggestions() {
  if (!promptSuggestions) return;
  promptSuggestions.hidden = true;
  I18n.clear(promptSuggestions, "innerHTML");
}

function syncModelLevelWithMessage(content) {
  if (modelLevelSelect.value !== "quick" || !requestsCompleteReading(content)) return;
  modelLevelSelect.value = isModelLevelAllowed("balanced") ? "balanced" : getCapabilities().allowedModelLevels[0] || "quick";
  localStorage.setItem("modelLevel", modelLevelSelect.value);
  setStatus(() => T("interface.lectura_completa_nivel_cambiado_a_value", { v0: modelLevelSelect.selectedOptions[0]?.textContent || modelLevelSelect.value }));
}

function requestsCompleteReading(content) {
  const text = String(content || "").toLowerCase();
  return [
  "lectura completa",
  "lectura de los tres mapas",
  "profundidad total",
  "integracion global",
  "integración global"].
  some((pattern) => text.includes(pattern));
}

async function openChartWheelModal() {
  if (!chartCalculation) {
    setStatus(() => T("interface.primero_calcula_las_cartas_para_abrir_mapas"));
    return;
  }
  if (!canUseChartWheel()) {
    setStatus(() => T("interface.esta_vista_esta_disponible_con_la_suscripcion_de_astroanamnesis"));
    return;
  }

  if (activePrivateSection !== "maps" || privateScreen?.classList.contains("is-hidden")) {
    await openPrivateArea();
    showPrivateSection("maps");
  }
  setPrivateMapsView("charts");
}

function closeChartWheelModal() {
  if (chatIaDialog?.open) chatIaDialog.close();
  if (activePrivateSection === "maps" && privateMapsView === "chat") {
    setPrivateMapsView("charts");
  }
}

function activeTransitTimeZone(type = chartWheelTypeSelect?.value || activeChartViewType) {
  return birthProfile?.tz || chartCalculation?.profile?.location?.tz || "UTC";
}

function dateTimeInputPartsForZone(date, timeZone) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
  const parts = Object.fromEntries(formatter.formatToParts(date).
  filter((part) => part.type !== "literal").
  map((part) => [part.type, part.value]));
  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    time: `${parts.hour}:${parts.minute}`
  };
}

function syncTransitControlsToActiveTimeZone() {
  if (!chartTransitField || !chartTransitDateInput || !chartTransitTimeInput) return;

  const type = chartWheelTypeSelect?.value || activeChartViewType || "transits";
  const timeZone = activeTransitTimeZone(type);
  const personKey = getCurrentPersonKey();
  const scope = `${type}|${personKey}|${timeZone}`;
  const locationName = birthProfile?.city || chartCalculation?.profile?.location?.name || "la carta activa";

  if (chartTransitLegend) {
    I18n.bind(chartTransitLegend, "textContent", () => timeZone === "UTC" ? T("interface.transitos_ut") : T("interface.transitos_hora_local_de_value", { v0: locationName }));


    I18n.bind(chartTransitLegend, "title", () => timeZone);
  }

  if (
  chartTransitField.dataset.transitScope !== scope ||
  !chartTransitDateInput.value ||
  !chartTransitTimeInput.value)
  {
    const current = dateTimeInputPartsForZone(new Date(), timeZone);
    chartTransitDateInput.value = current.date;
    chartTransitTimeInput.value = current.time;
  }

  chartTransitField.dataset.transitScope = scope;
  chartTransitField.dataset.timezone = timeZone;
}

function syncProgressedControls() {
  if (!chartProgressedField || !chartProgressedDateInput || !chartProgressedTimeInput) return;

  const timeZone = birthProfile?.tz || chartCalculation?.profile?.location?.tz || "UTC";
  const profileBirthDate = birthProfile?.year && birthProfile?.month && birthProfile?.day ?
  `${birthProfile.year}-${pad(birthProfile.month)}-${pad(birthProfile.day)}` :
  "";
  const birthDate = chartCalculation?.profile?.birthDate || profileBirthDate;
  const profileBirthTime = birthProfile?.hour !== undefined && birthProfile?.minute !== undefined ?
  `${pad(birthProfile.hour)}:${pad(birthProfile.minute)}` :
  "";
  const birthTime = String(chartCalculation?.profile?.birthTime || profileBirthTime).slice(0, 5);
  const scope = `${getCurrentPersonKey()}|${birthDate}|${birthTime}|${timeZone}`;

  if (birthDate) chartProgressedDateInput.min = birthDate;
  if (
  chartProgressedField.dataset.progressedScope !== scope ||
  !chartProgressedDateInput.value ||
  !chartProgressedTimeInput.value)
  {
    const current = dateTimeInputPartsForZone(new Date(), timeZone);
    const useBirthMoment = Boolean(birthDate && current.date < birthDate);
    chartProgressedDateInput.value = useBirthMoment ? birthDate : current.date;
    chartProgressedTimeInput.value = useBirthMoment ? birthTime || "00:00" : current.time;
    progressedCalculation = null;
  }

  chartProgressedField.dataset.progressedScope = scope;
  chartProgressedField.dataset.timezone = timeZone;
  chartProgressedField.dataset.birthDate = birthDate;
  chartProgressedField.dataset.birthTime = birthTime;
  if (chartProgressedNote) {
    const zoneLabel = timeZone === "UTC" ? "UT" : timeZone;
    I18n.bind(chartProgressedNote, "textContent", () => T("interface.hora_local_value_clave_clasica_1_dia_1_ano", { v0: zoneLabel }));
  }
  syncProgressedTimeMinimum();
}

function syncProgressedTimeMinimum() {
  if (!chartProgressedField || !chartProgressedDateInput || !chartProgressedTimeInput) return;
  const birthDate = chartProgressedField.dataset.birthDate || "";
  const birthTime = chartProgressedField.dataset.birthTime || "";
  const isBirthDate = Boolean(birthDate && chartProgressedDateInput.value === birthDate);
  if (isBirthDate && birthTime) {
    chartProgressedTimeInput.min = birthTime;
    if (!chartProgressedTimeInput.value || chartProgressedTimeInput.value < birthTime) {
      chartProgressedTimeInput.value = birthTime;
    }
  } else {
    chartProgressedTimeInput.removeAttribute("min");
  }
}

function progressedLocalMoment(progression = progressedCalculation, options = {}) {
  const useControls = options.useControls !== false;
  const date = progression?.targetDate || (useControls ? chartProgressedDateInput?.value : "") || "";
  const time = String(
    progression?.targetTime || (useControls ? chartProgressedTimeInput?.value : "") || ""
  ).slice(0, 5);
  const timeZone = progression?.targetTimeZone || chartProgressedField?.dataset.timezone || activeTransitTimeZone("progressed");
  const zoneLabel = timeZone === "UTC" ? "UT" : timeZone;

  return {
    date,
    time,
    timeZone,
    label: [formatContextDate(date), time, zoneLabel].filter(Boolean).join(" · ")
  };
}

function transitLocalMoment(transits, options = {}) {
  const useControls = options.useControls !== false;
  const date = transits?.localDateUsed || (useControls ? chartTransitDateInput?.value : "") || "";
  const time = String(
    transits?.localTimeUsed || (useControls ? chartTransitTimeInput?.value : "") || ""
  ).slice(0, 5);
  const timeZone = transits?.timeZoneUsed || chartTransitField?.dataset.timezone || activeTransitTimeZone();
  const dateLabel = formatContextDate(date);
  const zoneLabel = timeZone === "UTC" ? "UT" : timeZone;

  return {
    date,
    time,
    timeZone,
    label: [dateLabel, time, zoneLabel].filter(Boolean).join(" · ")
  };
}

async function refreshPrimaryChartWheel() {
  if (!chartCalculation || !chartWheelStage) {
    if (chartWheelStage) {
      I18n.bind(chartWheelStage, "innerHTML", () => `
        <div class="chart-wheel-empty">
          <h3>${T("interface.calcula_una_carta_para_ver_los_graficos")}</h3>
          <p>${T("interface.al_completar_el_formulario_natal_las_cartas_apareceran_aqui")}</p>
        </div>
      `);
    }
    return;
  }

  I18n.clear(chartWheelStatus, "textContent");
  chartWheelStatus.classList.remove("error");
  syncTransitControlsToActiveTimeZone();
  syncProgressedControls();
  if (chartSolarReturnYearInput) chartSolarReturnYearInput.value = chartSolarReturnYearInput.value || String(new Date().getFullYear());
  syncSolarReturnLocationDefaults(true);
  await populateSynastryPeople().catch(() => null);
  applyChartTypeModuleVisibility();
  restoreChartViewTypeSelection();
  syncChartWheelControls();
  syncChatChartContextControls();
  await renderSelectedChartWheel();
}

function syncChartWheelControls() {
  applyChartTypeModuleVisibility();
  applyGuestChartLimits();
  const type = chartWheelTypeSelect.value;
  chartTransitField.classList.toggle("is-hidden", type !== "transits");
  if (type === "transits") syncTransitControlsToActiveTimeZone();
  chartProgressedField?.classList.toggle("is-hidden", type !== "progressed");
  if (type === "progressed") syncProgressedControls();
  chartSolarReturnField?.classList.toggle("is-hidden", type !== "solarReturn");
  syncSolarReturnNatalControl();
  if (type === "solarReturn" && chartSolarReturnYearInput && !chartSolarReturnYearInput.value) {
    chartSolarReturnYearInput.value = String(new Date().getFullYear());
  }
  syncSolarReturnLocationControls();
  const usesRelatedPerson = ["synastry", "composite", "compositeMultiple"].includes(type);
  chartSynastryField.classList.toggle("is-hidden", !usesRelatedPerson);
  const relatedLabel = chartSynastryField.querySelector("span");
  if (relatedLabel) I18n.bind(relatedLabel, "textContent", () => type === "composite" || type === "compositeMultiple" ? T("interface.persona_para_compuesta") : T("interface.otra_persona"));
  updateChartTypeHelp();
}

function syncChatChartContextControls() {
  if (!chatChartContextTools || !chatChartContextTypeSelect) return;

  chatChartContextTools.classList.toggle("is-hidden", !chartCalculation);
  if (chartWheelTypeSelect && chatChartContextTypeSelect.value !== chartWheelTypeSelect.value) {
    chatChartContextTypeSelect.value = chartWheelTypeSelect.value;
  }
  if (chatChartContextHelpText) {
    I18n.bind(chatChartContextHelpText, "textContent", () => chartContextDescription(chatChartContextTypeSelect.value));
  }
}

async function renderSelectedChartWheel(options = {}) {
  if (!chartCalculation) return;
  const renderSequence = ++chartWheelRenderSequence;

  applyChartTypeModuleVisibility();
  applyGuestChartLimits();
  const requestedType = chartWheelTypeSelect?.value || activeChartViewType || "multiple";
  let type = "multiple";
  try {
    if (!options.accessVerified) await authorizeChartViewType(requestedType);
    if (renderSequence !== chartWheelRenderSequence) return;
    type = safeChartViewType(requestedType);
    setActiveChartViewType(type, { syncControls: true });
    syncChartWheelControls();
  } catch (error) {
    if (renderSequence !== chartWheelRenderSequence) return;
    setActiveChartViewType("multiple", { syncControls: true });
    setChartWheelStatus(() => error.message || T("interface.no_tienes_acceso_a_esta_vista_de_carta"), true);
    return;
  }
  const usesSolarComparison = type === "solarReturn" && solarReturnComparisonVisible && Boolean(chartCalculation?.charts?.tropical?.planets?.length);
  const usesMultipleLayout = ["multiple", "compositeMultiple", "customChart"].includes(type) || usesSolarComparison;
  chartWheelStage.classList.toggle("is-full-chart", !usesMultipleLayout);
  chartWheelStage.classList.toggle("is-multiple-chart", usesMultipleLayout);
  chartWheelStage.classList.toggle("is-custom-chart", type === "customChart");
  chartWheelStage.classList.toggle("is-solar-comparison", usesSolarComparison);
  chartWheelStage.classList.toggle("is-nodal-chart", type === "nodal");
  chartWheelStage.classList.toggle("is-temporal-overlay-chart", type === "transits" || type === "progressed");
  const chartTypesWithExteriorLabels = ["transits", "progressed", "synastry"];
  const chartTypesWithOuterContent = [
  "transits",
  "progressed",
  "solarReturn",
  "composite",
  "synastry"];

  const hasOuterChartContent = chartTypesWithOuterContent.includes(type);
  chartWheelStage.classList.toggle("has-exterior-chart-labels", chartTypesWithExteriorLabels.includes(type) ||
  type === "solarReturn" && solarReturnNatalVisible);
  chartWheelStage.classList.toggle("has-chart-containment-space", hasOuterChartContent);
  const requiresCalculation = ["transits", "progressed", "solarReturn", "synastry", "composite", "compositeMultiple"].includes(type);
  const typeLabel = chartContextLabel(type);
  const fullscreenSurface = activeChartFullscreenSurface();
  if (fullscreenSurface) {
    fullscreenSurface.classList.add("is-chart-person-switch-loading");
    fullscreenSurface.setAttribute("aria-busy", "true");
  }
  setChartWheelStatus(() => requiresCalculation ? T("interface.calculando_value_2", { v0: typeLabel.toLowerCase() }) : "");
  if (requiresCalculation && !fullscreenSurface) {
    I18n.bind(chartWheelStage, "innerHTML", () => `
      <div class="chart-wheel-empty chart-wheel-loading" role="status">
        <h3>${T("interface.calculando_value", { v0: escapeHtml(typeLabel) })}</h3>
        <p>${T("interface.preparando_posiciones_casas_y_aspectos")}</p>
      </div>
    `);
  }
  if (renderChartWheelButton) renderChartWheelButton.disabled = true;

  try {
    if (type === "transits") transitCalculation = await fetchTransitCalculation();
    if (type === "progressed") progressedCalculation = await fetchSecondaryProgressedCalculation();
    if (type === "solarReturn") solarReturnCalculation = await fetchSolarReturnCalculation();
    if (type === "synastry") synastryCalculation = await fetchSynastryCalculation();
    if (type === "composite" || type === "compositeMultiple") compositeCalculation = await fetchCompositeCalculation(type);
    if (renderSequence !== chartWheelRenderSequence) return;

    setChartWheelStageContent(() => buildChartWheelContent(type), { preserveFullscreen: true });
    arrangeFloatingPanels(chartWheelStage.querySelector(".chart-wheel-workspace"));
    initChartToolsScrollHints(chartWheelStage);
    applyChartPlanetVisibility(chartWheelStage);
    setChartWheelStatus("");
  } catch (error) {
    if (renderSequence !== chartWheelRenderSequence) return;
    const message = error.message || T("interface.no_se_pudo_calcular_el_grafico");
    const errorFullscreenSurface = activeChartFullscreenSurface();
    if (errorFullscreenSurface) {
      showChartFullscreenFeedback(errorFullscreenSurface, message);
    } else {
      I18n.bind(chartWheelStage, "innerHTML", () => `
        <div class="chart-wheel-empty chart-wheel-error" role="alert">
          <h3>${T("interface.no_se_pudo_mostrar_value", { v0: escapeHtml(typeLabel) })}</h3>
          <p>${escapeHtml(error.message || T("interface.no_se_pudo_calcular_el_grafico"))}</p>
        </div>
      `);
    }
    setChartWheelStatus(message, true);
  } finally {
    initChartViewportFit(chartWheelStage);
    const currentFullscreenSurface = activeChartFullscreenSurface();
    currentFullscreenSurface?.classList.remove("is-chart-person-switch-loading");
    currentFullscreenSurface?.removeAttribute("aria-busy");
    if (renderSequence === chartWheelRenderSequence && renderChartWheelButton) {
      renderChartWheelButton.disabled = false;
    }
  }
}

function activeChartFullscreenSurface() {
  const nativeSurface = document.fullscreenElement;
  if (
  nativeSurface &&
  chartWheelStage?.contains(nativeSurface) &&
  nativeSurface.matches?.(".chart-wheel-workspace, .chart-wheel-card"))
  {
    return nativeSurface;
  }

  return chartWheelStage?.querySelector(
    ".chart-wheel-workspace.is-chart-card-fallback-fullscreen, .chart-wheel-card.is-chart-card-fallback-fullscreen"
  ) || null;
}

function showChartFullscreenFeedback(surface, message) {
  if (!surface || !message) return;
  surface.querySelector(".chart-fullscreen-feedback")?.remove();
  const feedback = document.createElement("div");
  feedback.className = "chart-fullscreen-feedback";
  feedback.setAttribute("role", "alert");
  I18n.bind(feedback, "innerHTML", () => `
    <span class="chart-fullscreen-feedback-icon" aria-hidden="true">!</span>
    <span>${escapeHtml(message)}</span>
  `);
  surface.append(feedback);
  window.setTimeout(() => feedback.remove(), 7000);
}

function setChartWheelStageContent(content, options = {}) {
  I18n.track(chartWheelStage, "innerHTML", content);
  hideChartPlanetTooltip({ force: true });
  const fullscreenSurface = options.preserveFullscreen ? activeChartFullscreenSurface() : null;

  if (!fullscreenSurface) {
    I18n.bind(chartWheelStage, "innerHTML", () => content());
    chartWheelStage.scrollTop = 0;
    chartWheelStage.scrollLeft = 0;
    const nextWorkspace = chartWheelStage.querySelector(".chart-wheel-workspace");
    if (nextWorkspace) {
      nextWorkspace.scrollTop = 0;
      nextWorkspace.scrollLeft = 0;
    }
    return;
  }

  const template = document.createElement("template");
  I18n.bind(template, "innerHTML", () => content().trim());
  const surfaceIsWorkspace = fullscreenSurface.classList.contains("chart-wheel-workspace");
  const nextSurface = template.content.querySelector(
    surfaceIsWorkspace ? ".chart-wheel-workspace" : ".chart-wheel-card"
  );
  if (!nextSurface) {
    I18n.bind(chartWheelStage, "innerHTML", () => content());
    return;
  }

  const isFallbackFullscreen = fullscreenSurface.classList.contains("is-chart-card-fallback-fullscreen");
  restoreMobileFullscreenLongitudePanel();
  fullscreenSurface.className = nextSurface.className;
  if (isFallbackFullscreen) fullscreenSurface.classList.add("is-chart-card-fallback-fullscreen");
  I18n.replaceChildren(fullscreenSurface, ...Array.from(nextSurface.childNodes));
  fullscreenSurface.scrollTop = 0;
  fullscreenSurface.scrollLeft = 0;
  prepareMobileFullscreenLongitudePanel(fullscreenSurface);
  syncChartCardFullscreenState();
}

async function loadSelectedChartContextIntoChat(typeOverride = "") {
  if (!chartCalculation) {
    setChartContextLoadStatus(() => T("interface.primero_calcula_las_cartas"), true);
    return;
  }

  let type = typeOverride || activeChartViewType || chartWheelTypeSelect.value;
  try {
    await authorizeChartViewType(type);
  } catch (error) {
    setActiveChartViewType(activeChartViewType || "multiple", { syncControls: true });
    setChartContextLoadStatus(() => error.message || T("interface.no_tienes_acceso_a_esta_vista_de_carta"), true);
    return;
  }
  type = safeChartViewType(type);
  if (OPTIONAL_CHART_MODULES.includes(type) && !isModuleEnabled(type)) {
    type = "multiple";
  }
  if (chartWheelTypeSelect && chartWheelTypeSelect.value !== type) {
    chartWheelTypeSelect.value = type;
    syncChartWheelControls();
    await renderSelectedChartWheel();
  }
  if (chatChartContextTypeSelect && chatChartContextTypeSelect.value !== type) {
    chatChartContextTypeSelect.value = type;
  }
  const label = chartContextLabel(type);
  setChartContextLoadStatus(() => T("interface.cargando_value_en_el_chat", { v0: I18n.label(label) }));
  if (chatLoadChartContextButton) chatLoadChartContextButton.disabled = true;

  try {
    if (type === "transits") transitCalculation = await fetchTransitCalculation();
    if (type === "progressed") progressedCalculation = await fetchSecondaryProgressedCalculation();
    if (type === "solarReturn") solarReturnCalculation = await fetchSolarReturnCalculation();
    if (type === "synastry") synastryCalculation = await fetchSynastryCalculation();
    if (type === "composite" || type === "compositeMultiple") compositeCalculation = await fetchCompositeCalculation(type);

    const context = buildChartContextForType(type).trim();
    if (!context) throw new Error(T("interface.no_se_pudo_generar_el_contexto_de_la_carta_seleccionada"));

    saveChatContextSelection({
      type,
      label,
      metadata: selectedChartContextMetadata(type),
      context,
      signature: currentChartContextSignature(),
      loadedAt: new Date().toISOString()
    });

    const startedNewChat = resetChatForLoadedChartContext();
    await preloadChatContext();
    if (chartDataDialog.open) renderChartDataModal();
    setChatContextNotice();
    renderBirthSummary();
    renderChatHistory();

    setChartContextLoadStatus(() => T("interface.value_cargado_en_datos_de_prompt_value", { v0: I18n.label(label), get v1() {return startedNewChat ? T("interface.nuevo_contexto_iniciado") : "";} }));
    setStatus("");
    setPrivateMapsView("charts");
    input?.focus();
  } catch (error) {
    setChartContextLoadStatus(() => error.message || T("interface.no_se_pudo_cargar_el_contexto_en_el_chat"), true);
  } finally {
    if (chatLoadChartContextButton) chatLoadChartContextButton.disabled = false;
  }
}

function setChartContextLoadStatus(text, isError = false) {
  if (chatChartContextStatus) {
    I18n.bind(chatChartContextStatus, "textContent", () => text || "");
    chatChartContextStatus.classList.toggle("error", Boolean(isError));
  }
  setChartWheelStatus(text, isError);
}

function resetChatForLoadedChartContext() {
  const hadConversation = Boolean(
    activeChatId ||
    conversationId ||
    messagesEl.querySelector(".message.user, .message.assistant")
  );

  conversationId = "";
  activeChatId = "";
  localStorage.removeItem("conversationId");
  localStorage.removeItem("activeChatId");
  chatContextPreloaded = false;
  knowledgeStatusLoaded = false;
  I18n.clear(messagesEl, "innerHTML");
  updateEmptyChatState();
  return hadConversation;
}

async function populateSynastryPeople() {
  if (!currentUser) {
    I18n.bind(chartSynastryPersonSelect, "innerHTML", () => `<option value="">${T("interface.inicia_sesion_para_usar_cartas_relacionales")}</option>`);
    chartSynastryPersonSelect.disabled = true;
    return;
  }

  if (!savedPeople.length) {
    const response = await I18n.fetch("/api/people");
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_cargar_las_cartas_guardadas"));
    savedPeople = payload.people || [];
    if (currentUser && payload.capabilities) currentUser.capabilities = payload.capabilities;
  }

  const currentId = String(activePersonId || birthProfile?.personId || "");
  const relatedPeople = savedPeople.filter((person) => String(person.id) !== currentId);
  const storedPersonId = readStoredRelatedPersonId();
  const selectedPersonId = storedPersonId || String(chartSynastryPersonSelect.value || "");
  const options = relatedPeople.
  map((person) => `<option value="${person.id}">${escapeHtml(person.name)} - ${escapeHtml(formatPersonDate(person))}</option>`);

  chartSynastryPersonSelect.disabled = options.length === 0;
  I18n.bind(chartSynastryPersonSelect, "innerHTML", () => [`<option value="">${T("interface.selecciona_una_carta")}</option>`, ...options].join(""));
  if (relatedPeople.some((person) => String(person.id) === selectedPersonId)) {
    chartSynastryPersonSelect.value = selectedPersonId;
    if (!storedPersonId) persistSelectedRelatedPerson();
  } else if (selectedPersonId) {
    localStorage.removeItem(relatedPersonStorageKey());
  }
}

async function fetchTransitCalculation() {
  const params = new URLSearchParams();
  if (chartTransitDateInput.value) params.set("date", chartTransitDateInput.value);
  if (chartTransitTimeInput?.value) params.set("time", chartTransitTimeInput.value);
  params.set("tz", activeTransitTimeZone());
  const response = await I18n.fetch(`/api/chart/transits?${params}`);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudieron_calcular_los_transitos"));
  return payload;
}

async function fetchSecondaryProgressedCalculation() {
  syncProgressedControls();
  const targetDate = chartProgressedDateInput?.value || "";
  const targetTime = chartProgressedTimeInput?.value || "";
  if (!targetDate) throw new Error(T("interface.selecciona_una_fecha_de_progresion_valida"));
  if (!targetTime) throw new Error(T("interface.selecciona_una_hora_de_progresion_valida"));

  const response = await I18n.fetch("/api/chart/secondary-progressed", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      profile: birthProfile,
      targetDate,
      targetTime,
      houseSystem: chartHouseSystemKey
    })
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_calcular_la_carta_tropical_progresada"));
  return payload;
}

async function fetchSolarReturnCalculation() {
  const year = Number(chartSolarReturnYearInput?.value || new Date().getFullYear());
  if (!Number.isInteger(year) || year < 1800 || year > 2200) {
    throw new Error(T("interface.introduce_un_ano_valido_para_la_revolucion_solar"));
  }
  if (chartSolarReturnCustomLocationInput?.checked) {
    const hasLocation = await resolveSolarReturnLocationSelection();
    if (!hasLocation) {
      throw new Error(T("interface.selecciona_el_pais_y_la_ciudad_de_la_revolucion_desde_la_lista"));
    }
  }
  const solarReturnLocation = getSolarReturnLocationPayload();

  const response = await I18n.fetch("/api/chart/solar-return", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      profile: birthProfile,
      targetYear: year,
      solarReturnLocation,
      houseSystem: chartHouseSystemKey
    })
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_calcular_la_revolucion_solar"));
  return payload;
}

function getSolarReturnLocationPayload() {
  if (!chartSolarReturnCustomLocationInput?.checked) return null;
  const country = clean(chartSolarReturnCountrySelect?.value);
  const city = clean(chartSolarReturnCityInput?.value);
  const placeId = clean(chartSolarReturnPlaceIdInput?.value);
  const lat = cleanDatasetValue(chartSolarReturnPlaceIdInput?.dataset.lat);
  const lon = cleanDatasetValue(chartSolarReturnPlaceIdInput?.dataset.lon);
  const timezone = cleanDatasetValue(chartSolarReturnPlaceIdInput?.dataset.timezone);

  if (!country || !city) {
    throw new Error(T("interface.selecciona_el_pais_y_la_ciudad_de_la_revolucion"));
  }

  const payload = {
    country,
    countryName: chartSolarReturnCountrySelect?.selectedOptions?.[0]?.textContent.trim() || country,
    city
  };

  if (placeId && lat && lon && hasValidSolarReturnPlaceSelection(country, city)) {
    payload.placeId = placeId;
    payload.lat = lat;
    payload.lon = lon;
    payload.timezone = timezone;
  }

  return payload;
}

async function fetchSynastryCalculation() {
  const personId = chartSynastryPersonSelect.value;
  const person = savedPeople.find((item) => String(item.id) === String(personId));
  if (!person) throw new Error(T("interface.selecciona_una_carta_guardada_para_calcular_la_sinastria"));
  return calculateBirthCharts(profileFromSavedPerson(person));
}

async function fetchCompositeCalculation(type = activeChartViewType || chartWheelTypeSelect?.value || "composite") {
  await authorizeChartViewType(type);
  const personId = chartSynastryPersonSelect.value;
  const person = savedPeople.find((item) => String(item.id) === String(personId));
  if (!person) throw new Error(T("interface.selecciona_una_carta_guardada_para_calcular_la_carta_compuesta"));

  const partner = await calculateBirthCharts(profileFromSavedPerson(person));
  const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
  const partnerName = partner?.profile?.name || person.name || "Persona B";
  const baseMetadata = { subjectName, partnerName };
  const charts = {
    tropical: buildCompositeMidpointChart(chartCalculation?.charts?.tropical, partner?.charts?.tropical, {
      ...baseMetadata,
      chartType: "tropical",
      chartLabel: "Tropical"
    })
  };
  if (type === "compositeMultiple") {
    charts.sideral = buildCompositeMidpointChart(chartCalculation?.charts?.sideral, partner?.charts?.sideral, {
      ...baseMetadata,
      chartType: "sideral",
      chartLabel: "Sideral"
    });
    charts.memoria = buildCompositeMidpointChart(chartCalculation?.charts?.memoria, partner?.charts?.memoria, {
      ...baseMetadata,
      chartType: "memoria",
      chartLabel: "Memoria"
    });
  }

  return {
    ok: true,
    source: "Carta compuesta por puntos medios circulares",
    partner,
    charts,
    chart: charts.tropical
  };
}

function profileFromSavedPerson(person) {
  return {
    name: person.name,
    gender: person.gender,
    genderOther: person.genderOther || "",
    day: person.day,
    month: person.month,
    year: person.year,
    hour: person.hour,
    minute: person.minute,
    country: person.country,
    countryName: person.countryName,
    city: person.city,
    placeId: person.placeId
  };
}

function buildCompositeMidpointChart(subjectChart, partnerChart, metadata = {}) {
  if (!subjectChart?.planetsByKey || !partnerChart?.planetsByKey) {
    throw new Error(T("interface.no_se_pudo_calcular_la_compuesta_falta_una_de_las_cartas_necesarias"));
  }

  const chartType = metadata.chartType || "composite";
  const subjectHouseChart = compositeHouseSourceChart(subjectChart, chartType);
  const partnerHouseChart = compositeHouseSourceChart(partnerChart, chartType);
  const planetKeys = [
  ...PROMPT_PRIMARY_PLANET_ORDER,
  "true Node",
  ...PROMPT_OPTIONAL_BODY_ORDER];

  const rawPlanets = {};

  planetKeys.forEach((key) => {
    const subjectPlanet = subjectChart.planetsByKey?.[key];
    const partnerPlanet = partnerChart.planetsByKey?.[key];
    if (!subjectPlanet || !partnerPlanet) return;
    rawPlanets[key] = circularMidpointClient(subjectPlanet.longitude, partnerPlanet.longitude);
  });

  if (rawPlanets["true Node"] !== undefined) rawPlanets["south Node"] = norm360Client(rawPlanets["true Node"] + 180);
  if (rawPlanets.Sun !== undefined && rawPlanets.Moon !== undefined) {
    rawPlanets.midpoint = circularMidpointClient(rawPlanets.Sun, rawPlanets.Moon);
  }
  if (rawPlanets.Sun !== undefined) rawPlanets.tierra = norm360Client(rawPlanets.Sun + 180);

  const ascendantLongitude = compositeAscendantLongitude(subjectHouseChart, partnerHouseChart);
  const subjectMc = Number(subjectHouseChart?.midheaven?.longitude);
  const partnerMc = Number(partnerHouseChart?.midheaven?.longitude);
  const midheavenLongitude = Number.isFinite(subjectMc) && Number.isFinite(partnerMc) ?
  circularMidpointClient(subjectMc, partnerMc) :
  null;
  const rawHouses = chartType === "sideral" && ascendantLongitude !== null ?
  buildSideralCompositeHouses(ascendantLongitude) :
  buildCompositeHouses(subjectHouseChart, partnerHouseChart, ascendantLongitude);
  const houses = rawHouses.map((house) => ({
    ...enrichChartPointClient(`Casa ${house.number}`, house.longitude),
    number: house.number,
    label: romanHouse(house.number)
  }));
  const displayHouses = chartType === "memoria" ?
  memoriaDisplayHouses({
    type: "memoria",
    ascendant: ascendantLongitude === null ? null : { longitude: ascendantLongitude },
    houses
  }) :
  houses;

  const planetOrder = [...CHART_PLANET_ORDER, "midpoint", "tierra"];
  const planets = planetOrder.
  filter((key) => rawPlanets[key] !== undefined).
  map((key) => {
    const point = enrichChartPointClient(key, rawPlanets[key]);
    const house = chartType === "memoria" ?
    houseNumberFromReverseCuspsClient(point.longitude, displayHouses) :
    houseNumberFromCuspsClient(point.longitude, displayHouses);
    return {
      key,
      label: PROMPT_PLANET_LABELS[key] || key,
      ...point,
      house,
      houseLabel: romanHouse(house),
      retrograde: false
    };
  });
  const planetsByKey = Object.fromEntries(planets.map((planet) => [planet.key, planet]));

  return {
    type: chartType === "memoria" ? "memoria" : "composite", get
    label() {return metadata.chartLabel ? T("interface.compuesta_value", { v0: metadata.chartLabel }) : T("interface.compuesta");},
    composite: { ...metadata, chartType }, get
    houseSystem() {return subjectChart.houseSystem || { key: chartHouseSystemKey, get label() {return Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[chartHouseSystemKey]?.label || T("interface.placidus");}, hasHouses: chartHouseSystemKey !== "none" };},




    ascendant: ascendantLongitude === null ? null : enrichChartPointClient("Ascendant", ascendantLongitude),
    midheaven: midheavenLongitude === null ? null : enrichChartPointClient("Midheaven", midheavenLongitude),
    referenceAscendant: null,
    planets,
    planetsByKey,
    houses,
    aspects: chartType === "sideral" ?
    calculateClientSignAspects(planetsByKey) :
    calculateClientOrbAspects(planetsByKey, displayHouses),
    rulers: {}
  };
}

function compositeHouseSourceChart(chart, chartType) {
  if (chartType !== "memoria") return chart;
  const houses = memoriaDisplayHouses(chart);
  const firstHouse = houses.find((house) => Number(house.number) === 1);
  if (!firstHouse) return { ...chart, houses };
  return {
    ...chart,
    type: "memoria",
    houses,
    ascendant: {
      ...(chart.ascendant || {}),
      key: chart.ascendant?.key || "Ascendant",
      name: chart.ascendant?.name || "Ascendente",
      longitude: firstHouse.longitude,
      sign: firstHouse.sign ?? zodiacSignFromLongitude(firstHouse.longitude),
      signIndex: firstHouse.signIndex ?? Math.floor(norm360Client(firstHouse.longitude) / 30),
      degree: firstHouse.degree ?? degreeInSign(firstHouse.longitude),
      formatted: firstHouse.formatted ?? formatPositionText(firstHouse.longitude)
    }
  };
}

function circularMidpointClient(degreeA, degreeB) {
  const start = norm360Client(degreeA);
  const end = norm360Client(degreeB);
  let diff = norm360Client(end - start);
  if (diff > 180) diff -= 360;
  return norm360Client(start + diff / 2);
}

function compositeAscendantLongitude(subjectChart, partnerChart) {
  const subjectAsc = Number(subjectChart?.ascendant?.longitude ?? subjectChart?.houses?.find((house) => Number(house.number) === 1)?.longitude);
  const partnerAsc = Number(partnerChart?.ascendant?.longitude ?? partnerChart?.houses?.find((house) => Number(house.number) === 1)?.longitude);
  return Number.isFinite(subjectAsc) && Number.isFinite(partnerAsc) ?
  circularMidpointClient(subjectAsc, partnerAsc) :
  null;
}

function buildSideralCompositeHouses(ascendantLongitude) {
  const firstHouseLongitude = Math.floor(norm360Client(ascendantLongitude) / 30) * 30;
  return Array.from({ length: 12 }, (_, index) => ({
    number: index + 1,
    longitude: norm360Client(firstHouseLongitude + index * 30)
  }));
}

function buildCompositeHouses(subjectChart, partnerChart, ascendantLongitude) {
  const subjectHouses = subjectChart?.houses || [];
  const partnerHouses = partnerChart?.houses || [];
  const subjectAsc = Number(subjectChart?.ascendant?.longitude ?? subjectHouses.find((house) => Number(house.number) === 1)?.longitude);
  const partnerAsc = Number(partnerChart?.ascendant?.longitude ?? partnerHouses.find((house) => Number(house.number) === 1)?.longitude);
  const subjectOffsets = Number.isFinite(subjectAsc) ? houseOffsetsFromAscClient(subjectHouses, subjectAsc) : [];
  const partnerOffsets = Number.isFinite(partnerAsc) ? houseOffsetsFromAscClient(partnerHouses, partnerAsc) : [];

  if (ascendantLongitude !== null && subjectOffsets.length === 12 && partnerOffsets.length === 12) {
    return Array.from({ length: 12 }, (_, index) => {
      const houseNumber = index + 1;
      const offset = (subjectOffsets[index] + partnerOffsets[index]) / 2;
      return {
        number: houseNumber,
        longitude: houseNumber === 1 ? ascendantLongitude : norm360Client(ascendantLongitude + offset)
      };
    });
  }

  return Array.from({ length: 12 }, (_, index) => {
    const houseNumber = index + 1;
    const subjectHouse = subjectHouses.find((house) => Number(house.number) === houseNumber);
    const partnerHouse = partnerHouses.find((house) => Number(house.number) === houseNumber);
    const longitude = subjectHouse && partnerHouse ?
    circularMidpointClient(subjectHouse.longitude, partnerHouse.longitude) :
    houseNumber === 1 && ascendantLongitude !== null ?
    ascendantLongitude :
    null;
    return longitude === null ? null : { number: houseNumber, longitude };
  }).filter(Boolean);
}

function houseOffsetsFromAscClient(houses = [], ascendantLongitude) {
  const offsets = [];
  let previousOffset = -1;

  for (let houseNumber = 1; houseNumber <= 12; houseNumber += 1) {
    const house = houses.find((item) => Number(item.number) === houseNumber);
    if (!house) return [];
    let offset = houseNumber === 1 ? 0 : norm360Client(Number(house.longitude) - Number(ascendantLongitude));
    while (offset <= previousOffset) offset += 360;
    offsets.push(offset);
    previousOffset = offset;
  }

  return offsets;
}

function chartFullscreenPersonTrigger(role, name, roleLabel) {
  const safeName = clean(name) || (role === "partner" ? "Seleccionar persona" : "Persona activa");
  const actionLabel = role === "partner" ? T("interface.persona_b") : roleLabel || T("interface.persona");
  return `
    <button
      class="chart-multiple-person-trigger chart-fullscreen-person-trigger"
      type="button"
      data-chart-action="switch-person"
      data-person-role="${role}"
      aria-label="${T("interface.cambiar_value_actual_value", { v1: escapeHtml(actionLabel), v2: escapeHtml(safeName) })}"
      aria-haspopup="dialog"
      title="${T("interface.cambiar_value", { v3: escapeHtml(actionLabel) })}"
    >
      <span class="chart-person-role">${escapeHtml(actionLabel)}</span>
      <span class="chart-multiple-participants">${escapeHtml(safeName)}</span>
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M6 9l6 6 6-6"></path>
      </svg>
    </button>
  `;
}

function chartFullscreenPeopleControls(type = activeChartViewType || chartWheelTypeSelect?.value || "") {
  if (!currentUser) return "";
  const subjectName = currentChartPersonName();
  if (!isRelationalChartType(type)) {
    return `
      <div class="chart-fullscreen-people" role="group" aria-label="${T("interface.carta_activa")}">
        ${chartFullscreenPersonTrigger("subject", subjectName, T("interface.carta_activa_2"))}
      </div>
    `;
  }

  const partnerName = type === "synastry" ?
  synastryCalculation?.profile?.name || getSelectedSynastryPersonName() :
  compositeCalculation?.partner?.profile?.name || getSelectedSynastryPersonName();
  return `
    <div class="chart-fullscreen-people chart-fullscreen-people-relational" role="group" aria-label="${T("interface.personas_de_la_carta")}">
      ${chartFullscreenPersonTrigger("subject", subjectName, T("interface.persona_a"))}
      <span class="chart-person-connector" aria-hidden="true">+</span>
      ${chartFullscreenPersonTrigger("partner", partnerName, T("interface.persona_b"))}
    </div>
  `;
}

function chartGuestSubjectSummary() {
  if (currentUser || !birthProfile) return "";

  const profile = chartCalculation?.profile;
  const date = birthProfile.day && birthProfile.month && birthProfile.year ?
  `${pad(birthProfile.day)}/${pad(birthProfile.month)}/${birthProfile.year}` :
  "";
  const localTime = birthProfile.hour !== undefined && birthProfile.minute !== undefined ?
  `${pad(birthProfile.hour)}:${pad(birthProfile.minute)}` :
  "";
  const universalTime = getUniversalTimeDisplay(profile);
  const place = [birthProfile.city, birthProfile.countryName || birthProfile.country].filter(Boolean).join(", ");
  const weekday = getLocalBirthWeekdayInfo(profile).label;
  const birthDetails = [date, localTime, universalTime].filter(Boolean).join(" · ");
  const placeDetails = [place, weekday].filter(Boolean).join(" · ");

  return `
    <div class="chart-guest-subject" aria-label="${T("interface.datos_de_la_carta_activa")}">
      <span class="chart-guest-subject-eyebrow">${T("interface.carta_activa")}</span>
      <strong class="chart-guest-subject-name">${escapeHtml(currentChartPersonName())}</strong>
      ${birthDetails ? `<span class="chart-guest-subject-meta">${escapeHtml(birthDetails)}</span>` : ""}
      ${placeDetails ? `<span class="chart-guest-subject-meta">${escapeHtml(placeDetails)}</span>` : ""}
    </div>
  `;
}

function buildChartWheelContent(type) {
  if (type === "customChart") return buildCustomChartView();
  if (type === "multiple") {
    const charts = [
    { get title() {return T("interface.tropical_avatar");}, chart: chartCalculation.charts.tropical, position: "left", options: { panelPrefix: "tropical", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true } },
    { get title() {return T("interface.sideral_self");}, chart: chartCalculation.charts.sideral, position: "top", options: { panelPrefix: "sideral", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true } },
    { get title() {return T("interface.memoria_inconsciente");}, chart: chartCalculation.charts.memoria, position: "right", options: { panelPrefix: "memoria", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true } }];


    return chartWorkspace(`
      <div class="chart-wheel-triple">
        <div class="chart-multiple-topbar chart-multiple-topbar-subject">
          ${chartGuestSubjectSummary()}
          ${chartFullscreenPeopleControls("multiple")}
          <div class="chart-multiple-topbar-actions">
            ${multipleLongitudeLinks()}
            ${chartCardActions("chart-card-actions-multiple")}
          </div>
        </div>
        ${charts.map((item) => `
          <section class="chart-triple-slot chart-triple-slot-${item.position}">
            ${chartPanel(item.title, item.chart, {
      ...item.options,
      titlePosition: item.position === "top" ? "bottom" : "top",
      headerNoticeHtml: chartPatternSummary(item.chart, item.options.panelPrefix)
    })}
          </section>
        `).join("")}
      </div>
    `, charts.flatMap((item) => [
    multipleLongitudePanel(item.title, item.chart, item.position, item.options.panelPrefix),
    chartAspectPatternPanel(item.chart, {
      ...item.options,
      panelTitle: item.title,
      multiplePosition: item.position
    })]
    ), { multiple: true });
  }

  if (type === "compositeMultiple") {
    const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona A";
    const partnerName = compositeCalculation?.partner?.profile?.name || getSelectedSynastryPersonName() || "Persona B";
    const charts = [
    { get title() {return T("interface.compuesta_tropical");}, chart: compositeCalculation?.charts?.tropical || compositeCalculation?.chart, position: "left", options: { panelPrefix: "compuesta-tropical", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true, detailMode: "composite", partnerName } },
    { get title() {return T("interface.compuesta_sideral");}, chart: compositeCalculation?.charts?.sideral, position: "top", options: { panelPrefix: "compuesta-sideral", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true, detailMode: "composite", partnerName } },
    { get title() {return T("interface.compuesta_memoria");}, chart: compositeCalculation?.charts?.memoria, position: "right", options: { panelPrefix: "compuesta-memoria", multiple: true, hideTools: true, hideActions: true, hideSubtitle: true, detailMode: "composite", partnerName } }];


    if (charts.some((item) => !item.chart)) {
      return chartWorkspace(`<div class="chart-wheel-empty"><h3>${T("interface.no_hay_carta_compuesta_astroanamnesis_calculada")}</h3><p>${T("interface.selecciona_otra_persona_para_generar_las_tres_cartas_compuestas")}</p></div>`);
    }

    return chartWorkspace(`
      <div class="chart-wheel-triple">
        <div class="chart-multiple-topbar chart-multiple-topbar-composite">
          <strong class="chart-composite-participants">${escapeHtml(subjectName)} + ${escapeHtml(partnerName)}</strong>
          ${chartFullscreenPeopleControls("compositeMultiple")}
          <div class="chart-multiple-topbar-actions">
            ${multipleLongitudeLinks(charts)}
            ${chartCardActions("chart-card-actions-multiple")}
          </div>
        </div>
        ${charts.map((item) => `
          <section class="chart-triple-slot chart-triple-slot-${item.position}">
            ${chartPanel(item.title, item.chart, { ...item.options, titlePosition: item.position === "top" ? "bottom" : "top" })}
          </section>
        `).join("")}
      </div>
    `, charts.flatMap((item) => [
    multipleLongitudePanel(`${item.title}: ${subjectName} + ${partnerName}`, item.chart, item.position, item.options.panelPrefix),
    chartAspectPatternPanel(item.chart, {
      ...item.options,
      panelTitle: `${item.title}: ${subjectName} + ${partnerName}`,
      multiplePosition: item.position
    })]
    ), { multiple: true });
  }

  if (type === "nodal") {
    const nodal = buildNodalSchema(chartCalculation.charts.tropical);
    return chartWorkspace(nodalChartPanel(nodal), nodalTechnicalPanels(nodal));
  }

  if (type === "transits") {
    const natal = chartCalculation.charts.tropical;
    const transitAspectMatrix = buildAspectMatrix({
      rowPlanets: transitCalculation?.planets || [],
      columnPlanets: natal.planets || [],
      rowLabel: "Tránsitos",
      columnLabel: currentChartPersonName(),
      houseCusps: natal.houses
    });
    const options = {
      overlay: transitCalculation,
      overlayStationUtc: transitCalculation?.timestamp,
      overlayStationTimeZone: transitCalculation?.timeZoneUsed || "UTC",
      overlayLabel: "Tránsitos",
      natalInteractionLabel: `Natal · ${currentChartPersonName()}`,
      detailMode: "transits",
      panelPrefix: "transitos",
      overlayClassName: "chart-planet-transit-overlay chart-planet-transit-primary",
      overlayOutwardDetails: true,
      overlayStackedLabels: false,
      overlayPerimeterLayout: true,
      natalClassName: "chart-planet-transit-natal",
      natalMinSpacing: 9.2,
      natalGroupThreshold: 14,
      technicalLinks: [
      ["longitud", "Longitud natal"],
      ["longitud-transitos", "Longitud tránsitos"],
      ["cuspides", "Cúspides Casas"],
      ["aspectos", "Aspectos tránsito-natal"],
      ["modos", "Modos"],
      ["elementos", "Elementos"],
      ["distribucion", "Distribución"]],

      groupSecondaryTechnicalLinks: true,
      primaryTechnicalKeys: ["longitud", "longitud-transitos", "aspectos"],
      overlayLabelMargin: 2,
      overlayLabelLaneOffsets: TROPICAL_TRANSIT_LABEL_VISUALS.transitLabelRadii,
      overlayMinSameLaneDistance: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelDistance,
      overlayReservedAxisDistance: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
      overlayProtectedAnglePadding: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
      overlayAllowAxisOverlap: false,
      overlayCollisionPadding: 8,
      overlaySectorSize: 14,
      overlayMinLabelGap: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapX: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapY: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapY,
      overlayMaxTangentialShift: TROPICAL_TRANSIT_LABEL_VISUALS.maxTangentialShift,
      overlayLeaderLineOpacity: TROPICAL_TRANSIT_LABEL_VISUALS.leaderLineOpacity,
      overlayTransitFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitFontSize,
      overlayTransitGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitGlyphFontSize,
      overlayTransitMajorGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitMajorGlyphFontSize,
      aspectPanelHtml: aspectListPanelFromMatrix(
        "Aspectos tránsito-natal",
        `${transitLocalMoment(transitCalculation).label} - ${currentChartPersonName()}`,
        transitAspectMatrix,
        "transitos-aspectos",
        "left"
      )
    };
    return chartWorkspace(chartPanel("Tropical con tránsitos", natal, options), [
    transitLongitudePanel(transitCalculation, natal, { panelId: "transitos-longitud-transitos" }),
    ...chartTechnicalPanels(natal, options)]
    );
  }

  if (type === "progressed") {
    const chart = progressedCalculation?.chart;
    const natal = chartCalculation.charts.tropical;
    if (!chart) {
      return chartWorkspace(`<div class="chart-wheel-empty"><h3>${T("interface.no_hay_carta_tropical_progresada_calculada")}</h3><p>${T("interface.selecciona_una_fecha_valida_para_generar_la_progresion_secundaria")}</p></div>`);
    }
    const targetMoment = progressedLocalMoment(progressedCalculation, { useControls: false }).label;
    const progressedNatalAspects = buildAspectMatrix({
      rowPlanets: chart.planets || [],
      columnPlanets: natal.planets || [],
      rowLabel: "Progresada",
      columnLabel: "Natal",
      houseCusps: natal.houses
    });
    const options = {
      overlay: chart,
      overlayStationMode: "progressed",
      overlayStationUtc: progressedCalculation?.progressedUtc,
      overlayStationBirthUtc: progressedCalculation?.natalUtc,
      overlayStationTimeZone: progressedCalculation?.targetTimeZone || "UTC",
      overlayLabel: "Planetas progresados",
      natalInteractionLabel: `Natal · ${currentChartPersonName()}`,
      panelPrefix: "tropical-progresada",
      detailMode: "progressed",
      overlayClassName: "chart-planet-transit-overlay chart-planet-progressed-overlay",
      overlayOutwardDetails: true,
      overlayStackedLabels: false,
      overlayPerimeterLayout: true,
      natalClassName: "chart-planet-transit-natal",
      natalMinSpacing: 9.2,
      natalGroupThreshold: 14,
      technicalLinks: [
      ["progresion", "Progresión"],
      ["estaciones", "Planeta estacionario progresado"],
      ["longitud", "Longitud natal"],
      ["longitud-progresada", "Longitud progresada"],
      ["cuspides", "Cúspides Casas"],
      ["aspectos", "Aspectos prog.-natal"],
      ["modos", "Modos"],
      ["elementos", "Elementos"],
      ["distribucion", "Distribución"]],

      groupSecondaryTechnicalLinks: true,
      primaryTechnicalKeys: ["longitud", "longitud-progresada", "aspectos"],
      longitudePanelTitle: "Longitud natal",
      longitudePanelSubtitle: `${currentChartPersonName()} · Carta tropical natal`,
      overlayLabelMargin: 2,
      overlayLabelLaneOffsets: TROPICAL_TRANSIT_LABEL_VISUALS.transitLabelRadii,
      overlayMinSameLaneDistance: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelDistance,
      overlayReservedAxisDistance: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
      overlayProtectedAnglePadding: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
      overlayAllowAxisOverlap: false,
      overlayCollisionPadding: 8,
      overlaySectorSize: 14,
      overlayMinLabelGap: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapX: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapY: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapY,
      overlayMaxTangentialShift: TROPICAL_TRANSIT_LABEL_VISUALS.maxTangentialShift,
      overlayLeaderLineOpacity: TROPICAL_TRANSIT_LABEL_VISUALS.leaderLineOpacity,
      overlayTransitFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitFontSize,
      overlayTransitGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitGlyphFontSize,
      overlayTransitMajorGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitMajorGlyphFontSize,
      aspectPanelHtml: aspectListPanelFromMatrix(
        "Aspectos progresada-natal",
        `${targetMoment || "Momento seleccionado"} - ${currentChartPersonName()}`,
        progressedNatalAspects,
        "tropical-progresada-aspectos",
        "left"
      )
    };
    return chartWorkspace(chartPanel("Tropical progresada", natal, options), [
    progressionInformationPanel(progressedCalculation),
    progressedStationsPanel(progressedCalculation),
    progressedLongitudePanel(progressedCalculation, natal, { panelId: "tropical-progresada-longitud-progresada" }),
    ...chartTechnicalPanels(natal, options)]
    );
  }

  if (type === "solarReturn") {
    return buildSolarReturnView();
  }

  if (type === "synastry") {
    const natal = chartCalculation.charts.tropical;
    const partner = synastryCalculation?.charts?.tropical;
    const partnerName = synastryCalculation?.profile?.name || "Otra persona";
    const personName = currentChartPersonName();
    const synastryAspectMatrix = buildAspectMatrix({
      rowPlanets: partner?.planets || [],
      columnPlanets: natal.planets || [],
      rowLabel: partnerName,
      columnLabel: personName,
      houseCusps: natal.houses
    });
    const options = {
      overlay: partner,
      overlayLabel: partnerName,
      natalInteractionLabel: personName,
      detailMode: "synastry",
      panelPrefix: "sinastria",
      natalColor: "#2f6fbe",
      natalClassName: "chart-planet-synastry-natal",
      overlayColor: "#b94747",
      overlayClassName: "chart-planet-synastry-overlay",
      overlayOutwardDetails: true,
      overlayLabelMargin: 64,
      overlayLabelLaneOffsets: SYNASTRY_EXTERIOR_LABEL_VISUALS.labelRadii,
      overlayMinSameLaneDistance: SYNASTRY_EXTERIOR_LABEL_VISUALS.minLabelDistance,
      overlayReservedAxisDistance: 0,
      overlayProtectedAnglePadding: 0,
      overlayAllowAxisOverlap: true,
      overlayCollisionPadding: 8,
      overlaySectorSize: 14,
      overlayMinLabelGap: SYNASTRY_EXTERIOR_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapX: SYNASTRY_EXTERIOR_LABEL_VISUALS.minLabelGapX,
      overlayMinLabelGapY: SYNASTRY_EXTERIOR_LABEL_VISUALS.minLabelGapY,
      overlayMaxTangentialShift: SYNASTRY_EXTERIOR_LABEL_VISUALS.maxTangentialShift,
      overlayLeaderLineOpacity: SYNASTRY_EXTERIOR_LABEL_VISUALS.leaderLineOpacity,
      overlayTransitFontSize: SYNASTRY_EXTERIOR_LABEL_VISUALS.fontSize,
      technicalLinks: [
      ["longitud", "Longitud"],
      ["cuspides", "Cúspides Casas"],
      ["aspectos", "Aspectos sinastría"],
      ["casas", "Planetas en casas"],
      ["modos", "Modos"],
      ["elementos", "Elementos"],
      ["distribucion", "Distribución"]],

      aspectPanelHtml: aspectMatrixPanel("Aspectos de sinastría", `${partnerName} sobre ${personName}`, synastryAspectMatrix, "sinastria-aspectos", "left")
    };
    return chartWorkspace(chartPanel(`Sinastría tropical: ${partnerName}`, natal, options), [
    ...chartTechnicalPanels(natal, options),
    synastryHousePanel(natal, partner, partnerName, "sinastria-casas")]
    );
  }

  if (type === "composite") {
    const chart = compositeCalculation?.chart;
    const partnerName = compositeCalculation?.partner?.profile?.name || getSelectedSynastryPersonName() || "Otra persona";
    const subjectName = birthProfile?.name || chartCalculation?.profile?.name || "Persona";
    const options = {
      panelPrefix: "compuesta",
      panelTitle: "Compuesta",
      detailMode: "composite",
      partnerName,
      technicalLinks: [
      ["longitud", "Longitud"],
      ["cuspides", "Cúspides Casas"],
      ["aspectos", "Aspectos"],
      ["modos", "Modos"],
      ["elementos", "Elementos"],
      ["distribucion", "Distribución"]],

      groupSecondaryTechnicalLinks: true,
      primaryTechnicalKeys: ["longitud", "cuspides", "aspectos"]
    };
    return chart ?
    chartWorkspace(chartPanel(`Compuesta: ${subjectName} + ${partnerName}`, chart, options), chartTechnicalPanels(chart, options)) :
    chartWorkspace(`<div class="chart-wheel-empty"><h3>${T("interface.no_hay_carta_compuesta_calculada")}</h3><p>${T("interface.selecciona_otra_persona_para_generar_la_compuesta")}</p></div>`);
  }

  const chart = chartCalculation.charts[type] || chartCalculation.charts.tropical;
  const options = {
    panelPrefix: type,
    groupSecondaryTechnicalLinks: ["tropical", "sideral", "memoria"].includes(type),
    technicalActionHtml: type === "tropical" ? natalRetrogradeStationLink(chart) : ""
  };
  return chartWorkspace(chartPanel(chart.label || type, chart, options), chartTechnicalPanels(chart, options));
}

function normalizeCustomChartSelection(value) {
  const keys = Array.isArray(value) ?
  [...new Set(value.filter((key) => ["tropical", "sideral", "memoria"].includes(key)))].slice(0, 2) :
  [];
  return keys.length ? keys : ["tropical", "memoria"];
}

function loadCustomChartSelection() {
  try {
    return normalizeCustomChartSelection(JSON.parse(localStorage.getItem(CUSTOM_CHART_SELECTION_STORAGE_KEY)));
  } catch (_) {
    return normalizeCustomChartSelection();
  }
}

function persistCustomChartSelection() {
  try {
    localStorage.setItem(CUSTOM_CHART_SELECTION_STORAGE_KEY, JSON.stringify(customChartSelection));
  } catch (_) {

    // Keep the current composition usable when browser storage is unavailable.
  }queueAccountPreferencesSave();
}

function customChartCardSelection() {
  const selected = normalizeCustomChartSelection(customChartSelection);
  return Object.fromEntries(["tropical", "memoria", "sideral"].map((key) => [key, selected.includes(key)]));
}

function handleCustomChartChange(event) {
  const select = event.target.closest?.("select[data-custom-chart-slot]");
  if (!select) return;
  const slot = Number(select.dataset.customChartSlot);
  if (![0, 1].includes(slot)) return;
  const previous = normalizeCustomChartSelection(customChartSelection);
  const value = select.value;
  if (!["tropical", "sideral", "memoria"].includes(value) && !(slot === 1 && value === "")) return;
  const next = [...previous];
  if (slot === 0 && next[1] === value) next[1] = previous[0];
  if (slot === 1 && value === next[0]) return;
  next[slot] = value;
  customChartSelection = normalizeCustomChartSelection(next);
  persistCustomChartSelection();
  setChartWheelStageContent(() => buildCustomChartView(), { preserveFullscreen: true });
  initChartToolsScrollHints(chartWheelStage);
  applyChartPlanetVisibility(chartWheelStage);
  initChartViewportFit(chartWheelStage);
  chartWheelStage.querySelector(`[data-custom-chart-slot="${slot}"]`)?.focus({ preventScroll: true });
}

function buildCustomChartView() {
  const selected = normalizeCustomChartSelection(customChartSelection);
  const choices = [
  ["tropical", I18n.label("Tropical")],
  ["sideral", I18n.label("Sideral")],
  ["memoria", I18n.label("Memoria")]];

  const controls = [0, 1].map((slot) => `
    <label class="chart-custom-choice">
      <span>${slot === 0 ? I18n.label(T("custom_chart.first")) : I18n.label(T("custom_chart.second"))}</span>
      <select data-custom-chart-slot="${slot}">
        ${slot === 1 ? `<option value=""${!selected[1] ? " selected" : ""}>${escapeHtml(I18n.label(I18n.label(T("custom_chart.none"))))}</option>` : ""}
        ${choices.map(([key, label]) => `<option value="${key}"${selected[slot] === key ? " selected" : ""}${slot === 1 && selected[0] === key ? " disabled" : ""}>${escapeHtml(I18n.label(label))}</option>`).join("")}
      </select>
    </label>
  `).join("");
  const charts = selected.map((key) => ({
    key,
    title: I18n.label(chartContextLabel(key)),
    chart: chartCalculation?.charts?.[key],
    options: {
      panelPrefix: `personalizada-${key}`,
      viewportPadding: 64,
      hideActions: true,
      hidePeopleControls: true,
      hideSubtitle: true,
      groupSecondaryTechnicalLinks: true,
      primaryTechnicalKeys: ["longitud", "aspectos"]
    }
  }));
  return chartWorkspace(`
    <div class="chart-custom-layout">
      <div class="chart-custom-toolbar">
        <div class="chart-custom-choices" role="group" aria-label="${T("custom_chart.combination")}">${controls}</div>
        ${chartFullscreenPeopleControls("customChart")}
        ${chartCardActions("chart-card-actions-multiple")}
      </div>
      <div class="chart-custom-grid${selected.length === 1 ? " chart-custom-grid-single" : ""}">
        ${charts.map((item) => item.chart ? chartPanel(item.title, item.chart, item.options) : `<div class="chart-wheel-empty"><h3>${escapeHtml(item.title)}</h3><p>${T("custom_chart.missing")}</p></div>`).join("")}
      </div>
    </div>
  `,

    charts.filter((item) => item.chart).flatMap((item) => chartTechnicalPanels(item.chart, item.options)), { multiple: true, custom: true });
}

function multipleLongitudeLinks(items = null) {
  const links = Array.isArray(items) && items.length ?
  items.map((item) => [`${item.options.panelPrefix}-longitud`, `Longitud ${item.title}`]) :
  [
  ["tropical-longitud", "Longitud Tropical"],
  ["sideral-longitud", "Longitud Sideral"],
  ["memoria-longitud", "Longitud Memoria"]];


  return `
    <nav class="chart-tools chart-tools-multiple" aria-label="${T("interface.tablas_de_longitud")}">
      ${links.map(([id, label]) => `
        <button class="chart-tool-link" type="button" data-panel-action="show" data-panel-id="${id}" aria-label="${escapeHtml(I18n.label(label))}" aria-pressed="false">
          ${escapeHtml(I18n.label(window.I18n?.label(label) || label))}
        </button>
      `).join("")}
    </nav>
  `;
}

function natalRetrogradePlanets(chart) {
  return CHART_PLANET_ORDER.
  slice(2, 10).
  map((key) => chart?.planetsByKey?.[key]).
  filter((planet) => Boolean(planet?.retrograde));
}

function natalRetrogradeStationLink(chart) {
  if (isGuestMapsMode()) return "";
  const retrogrades = natalRetrogradePlanets(chart);
  if (!retrogrades.length) return "";

  const label = retrogrades.length === 1 ? T("interface.1_planeta_retrogrado_natal") : T("interface.value_planetas_retrogrados_natales", { v0: retrogrades.length });


  return `
    <button
      class="chart-tool-link"
      type="button"
      data-chart-action="open-progressed-stations"
      aria-label="${T("interface.value_ver_estaciones_progresadas", { v0: escapeHtml(I18n.label(I18n.label(label))) })}"
      title="${T("interface.value_ver_estaciones_progresadas_2", { v1: escapeHtml(I18n.label(I18n.label(label))) })}"
    >
      ${T("interface.retrogrados")}
    </button>
  `;
}

function solarReturnChartOptions() {
  const natal = chartCalculation?.charts?.tropical;
  const options = {
    panelPrefix: "revolucion-solar",
    detailMode: "solarReturn",
    longitudePanelTitle: I18n.label("Longitud de la revolución solar"),
    natalInteractionLabel: "Revolución solar",
    technicalLinks: [
    ["longitud", I18n.label("Longitud")],
    ["cuspides", I18n.label("Cúspides Casas")],
    ["aspectos", I18n.label("Aspectos")],
    ...(natal?.planets?.length ? [["aspectos-natal", I18n.label("Aspectos revolución solar · natal tropical")]] : []),
    ["modos", I18n.label("Modos")],
    ["elementos", I18n.label("Elementos")],
    ["distribucion", I18n.label("Distribución")]],

    groupSecondaryTechnicalLinks: true,
    primaryTechnicalKeys: ["longitud", "cuspides", "aspectos"]
  };
  return options;
}

function solarReturnNatalChartOptions() {
  const natal = chartCalculation?.charts?.tropical;
  const solar = solarReturnCalculation?.chart;
  const options = {
    panelPrefix: "revolucion-solar-natal",
    detailMode: "solarReturn",
    longitudePanelTitle: I18n.label("Longitud natal"),
    natalInteractionLabel: "Natal tropical",
    groupSecondaryTechnicalLinks: true,
    primaryTechnicalKeys: ["longitud", "aspectos"], get
    technicalActionHtml() {return `
      <button class="chart-tool-link" type="button" data-panel-action="show" data-panel-id="revolucion-solar-longitud" aria-pressed="false">${escapeHtml(I18n.label(I18n.label(T("solar_return.solar_longitude"))))}</button>
      <button class="chart-tool-link" type="button" data-panel-action="show" data-panel-id="revolucion-solar-aspectos-natal" aria-pressed="false">${escapeHtml(I18n.label(I18n.label(T("solar_return.natal_aspects_title"))))}</button>`;}
  };
  if (!solarReturnNatalVisible || !natal?.planets?.length || !solar?.planets?.length) return options;

  // Display the return outside the natal wheel, projecting return points into
  // natal houses without mutating either source chart or its calculations.
  const houses = chartDisplayHouses(natal);
  const solarKeys = new Set(solar.planets.map((planet) => planet.key));
  const angles = CHART_ANGLE_POINT_KEYS.filter((key) => !solarKeys.has(key)).
  map((key) => chartAngleAspectPoint(solar, key)).filter(Boolean);
  const planets = [...solar.planets, ...angles].map((planet) => {
    const house = houses.length ? houseNumberFromCuspsClient(planet.longitude, houses) : null;
    return { ...planet, house, houseLabel: house ? romanHouse(house) : "" };
  });
  return {
    ...options,
    overlay: { ...solar, planets, planetsByKey: Object.fromEntries(planets.map((planet) => [planet.key, planet])) },
    overlayLabel: "Revolución solar · casas natales",
    overlayClassName: "chart-planet-transit-overlay",
    overlayIncludeAngles: true,
    overlayOutwardDetails: true,
    overlayStackedLabels: false,
    overlayPerimeterLayout: true,
    overlayLabelMargin: 2,
    overlayLabelLaneOffsets: TROPICAL_TRANSIT_LABEL_VISUALS.transitLabelRadii,
    overlayMinSameLaneDistance: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelDistance,
    overlayReservedAxisDistance: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
    overlayProtectedAnglePadding: TROPICAL_TRANSIT_LABEL_VISUALS.protectedAnglePadding,
    overlayAllowAxisOverlap: false,
    overlayCollisionPadding: 8,
    overlaySectorSize: 14,
    overlayMinLabelGap: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
    overlayMinLabelGapX: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapX,
    overlayMinLabelGapY: TROPICAL_TRANSIT_LABEL_VISUALS.minLabelGapY,
    overlayMaxTangentialShift: TROPICAL_TRANSIT_LABEL_VISUALS.maxTangentialShift,
    overlayLeaderLineOpacity: TROPICAL_TRANSIT_LABEL_VISUALS.leaderLineOpacity,
    overlayTransitFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitFontSize,
    overlayTransitGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitGlyphFontSize,
    overlayTransitMajorGlyphFontSize: TROPICAL_TRANSIT_LABEL_VISUALS.transitMajorGlyphFontSize
  };
}

function syncSolarReturnNatalControl() {
  document.querySelectorAll("[data-solar-return-natal], [data-solar-return-comparison]").forEach((input) => {
    input.checked = input.hasAttribute("data-solar-return-comparison") ? solarReturnComparisonVisible : solarReturnNatalVisible;
    input.disabled = !chartCalculation?.charts?.tropical?.planets?.length;
  });
}

function solarReturnFullscreenNatalControl() {
  return `
    <div class="chart-solar-view-controls">
      <label class="chart-solar-natal-toggle chart-solar-natal-toggle-fullscreen" title="${escapeHtml(I18n.label(I18n.label(T("solar_return.comparison_title"))))}">
        <input type="checkbox" data-solar-return-comparison aria-label="${escapeHtml(I18n.label("Ver ambas cartas"))}"${solarReturnComparisonVisible ? " checked" : ""}${chartCalculation?.charts?.tropical?.planets?.length ? "" : " disabled"}>
        <span>${escapeHtml(I18n.label(I18n.label(T("solar_return.comparison_label"))))}</span>
      </label>
      <label class="chart-solar-natal-toggle chart-solar-natal-toggle-fullscreen" title="${escapeHtml(I18n.label(I18n.label(T("solar_return.layers"))))}">
        <input type="checkbox" data-solar-return-natal aria-label="${escapeHtml(I18n.label(I18n.label(T("solar_return.toggle_label"))))}" aria-describedby="chart-solar-natal-fullscreen-help"${solarReturnNatalVisible ? " checked" : ""}${chartCalculation?.charts?.tropical?.planets?.length ? "" : " disabled"}>
        <span>${escapeHtml(I18n.label(I18n.label(T("solar_return.toggle_label"))))}</span>
        <span id="chart-solar-natal-fullscreen-help" class="sr-only">${escapeHtml(I18n.label(I18n.label(T("solar_return.layers"))))}</span>
      </label>
    </div>
  `;
}

function solarReturnChartViews() {
  const solar = solarReturnCalculation?.chart;
  if (!solar) return [];
  const natal = chartCalculation?.charts?.tropical;
  const year = solarReturnCalculation?.targetYear || chartSolarReturnYearInput?.value || "";
  const solarItem = { title: `${I18n.label("Revolución solar")} ${year}`, chart: solar, options: solarReturnChartOptions() };
  if (!natal?.planets?.length) return [solarItem];
  const natalItem = {
    title: solarReturnNatalVisible ? I18n.label("Natal tropical + Solar superpuesta") : I18n.label("Natal tropical"),
    chart: natal,
    options: solarReturnNatalChartOptions()
  };
  if (solarReturnComparisonVisible) return [natalItem, solarItem];
  return solarReturnNatalVisible ? [natalItem] : [solarItem];
}

function solarReturnMainHtml() {
  const charts = solarReturnChartViews();
  if (!charts.length) return `<div class="chart-wheel-empty"><h3>${T("interface.no_hay_revolucion_solar_calculada")}</h3><p>${T("interface.selecciona_un_ano_valido_para_generar_la_carta")}</p></div>`;
  if (charts.length === 1) return chartPanel(charts[0].title, charts[0].chart, charts[0].options);
  return `
    <div class="chart-custom-layout chart-solar-comparison-layout">
      <div class="chart-custom-toolbar chart-solar-comparison-toolbar">
        <span class="chart-solar-comparison-title">${escapeHtml(I18n.label(I18n.label(T("solar_return.comparison_title"))))}</span>
        ${chartFullscreenPeopleControls("solarReturn")}
        ${solarReturnFullscreenNatalControl()}
        ${chartCardActions("chart-card-actions-multiple")}
      </div>
      <div class="chart-custom-grid">
        ${charts.map((item) => chartPanel(item.title, item.chart, { ...item.options, viewportPadding: 64, hideSubtitle: true, hideActions: true, hidePeopleControls: true, hideSolarReturnControls: true })).join("")}
      </div>
    </div>`;



}

function buildSolarReturnView() {
  const solar = solarReturnCalculation?.chart;
  const natal = chartCalculation?.charts?.tropical;
  const comparison = solarReturnChartViews().length === 2;
  return chartWorkspace(solarReturnMainHtml(), solar ? [
  ...chartTechnicalPanels(solar, solarReturnChartOptions()),
  ...(natal?.planets?.length ? chartTechnicalPanels(natal, solarReturnNatalChartOptions()) : []),
  solarReturnNatalAspectPanel()] :
  [], { multiple: comparison, custom: comparison });
}

function solarReturnNatalAspects() {
  const chart = solarReturnCalculation?.chart;
  const natal = chartCalculation?.charts?.tropical;
  if (!chart || !natal?.planets?.length) return [];

  // Use the same points, orbs, house-cusp rules and filters as the drawing,
  // regardless of whether the natal layer is currently displayed.
  const planets = aspectOrderForChart(natal).
  map((key) => chartAspectPlanet(natal, key)).filter(Boolean);
  const order = aspectOrderForChart(chart);
  return crossChartAspects(chart, { ...natal, planets }).map((aspect) => ({
    ...aspect,
    planetA: aspect.planetB,
    planetB: aspect.planetA,
    planetALabel: aspect.planetBLabel,
    planetBLabel: aspect.planetALabel,
    longitudeA: aspect.longitudeB,
    longitudeB: aspect.longitudeA
  })).sort((a, b) =>
  order.indexOf(a.planetA) - order.indexOf(b.planetA) ||
  order.indexOf(a.planetB) - order.indexOf(b.planetB)
  );
}

function solarReturnNatalAspectPanel() {
  if (!solarReturnCalculation?.chart || !chartCalculation?.charts?.tropical?.planets?.length) return "";
  const aspects = solarReturnNatalAspects().map((aspect) => ({
    ...aspect,
    name: I18n.label(ASPECT_CONFIGS.find((config) => Number(config.angle) === Number(aspect.angle))?.label || aspect.name)
  }));
  return floatingPanel(
    "revolucion-solar-aspectos-natal",
    I18n.label("Aspectos revolución solar · natal tropical"),
    I18n.label("A: Revolución solar · B: Natal tropical"),
    renderFloatingAspectTable(aspects),
    "left",
    { className: "floating-chart-panel-solar-natal-aspects" }
  );
}

function handleSolarReturnNatalChange(event) {
  const input = event.target.closest?.("[data-solar-return-natal], [data-solar-return-comparison]");
  if (!input || input.disabled) return;
  if (input.hasAttribute("data-solar-return-comparison")) solarReturnComparisonVisible = input.checked;else
  solarReturnNatalVisible = input.checked;
  syncSolarReturnNatalControl();
  if (!solarReturnCalculation?.chart) return;
  const workspace = chartWheelStage.querySelector(".chart-wheel-workspace");
  const main = workspace?.querySelector(":scope > .chart-wheel-main");
  if (!main) return;
  const focused = document.activeElement;
  const fullscreen = activeChartFullscreenSurface() === workspace;
  restoreMobileFullscreenLongitudePanel();
  const comparison = solarReturnChartViews().length === 2;
  chartWheelStage.classList.toggle("is-full-chart", !comparison);
  chartWheelStage.classList.toggle("is-multiple-chart", comparison);
  chartWheelStage.classList.toggle("is-solar-comparison", comparison);
  chartWheelStage.classList.toggle("has-exterior-chart-labels", Boolean(solarReturnNatalChartOptions().overlay));
  workspace.classList.toggle("chart-wheel-workspace-multiple", comparison);
  workspace.classList.toggle("chart-wheel-workspace-custom", comparison);
  hideChartPlanetTooltip({ force: true });
  main.querySelectorAll(".chart-svg-wrap").forEach((wrap) => resetChartTouchZoom(chartTouchZoomStates.get(wrap)));
  // Keep the fullscreen workspace, both sets of technical panels, and the
  // focused controls alive. View changes never fetch or recalculate charts.
  const controls = main.querySelector(".chart-solar-view-controls");
  I18n.track(main, "innerHTML", solarReturnMainHtml);
  I18n.bind(main, "innerHTML", () => solarReturnMainHtml());
  if (controls) main.querySelector(".chart-solar-view-controls")?.replaceWith(controls);
  workspace.querySelectorAll(".floating-chart-panel").forEach((panel) => {
    const launchers = [...main.querySelectorAll("button[data-panel-id]")].filter((button) => button.dataset.panelId === panel.id);
    syncFloatingPanelLaunchers(launchers, !panel.hidden && !panel.classList.contains("is-panel-hidden"));
  });
  if (fullscreen) prepareMobileFullscreenLongitudePanel(workspace);
  if (focused === input) input.focus({ preventScroll: true });
  syncChartCardFullscreenState();
  initChartToolsScrollHints(chartWheelStage);
  applyChartPlanetVisibility(chartWheelStage);
  initChartViewportFit(chartWheelStage);
}

function chartPanel(title, chart, options = {}) {
  if (!chartHasVisibleHouses(chart)) {
    const technicalLinks = (options.technicalLinks || [
    ["longitud", "Longitud"],
    ["cuspides", "Cúspides Casas"],
    ["aspectos", "Aspectos"],
    ["modos", "Modos"],
    ["elementos", "Elementos"],
    ["distribucion", "Distribución"]]).
    filter(([key]) => !["cuspides", "distribucion"].includes(key));
    options = { ...options, technicalLinks, hideHouses: true, hideHouseColumns: true, hideHouseTechnicalPanels: true };
  }
  const panelPrefix = chartPanelPrefix(title, chart, options);
  const technicalLinks = chartTechnicalLinksWithPatterns(chart, options);
  const interactiveOptions = { ...options, interactivePlanets: true };
  const chartOptions = options.multiple ? { ...interactiveOptions, compact: false } : interactiveOptions;
  const chartBody = options.multiple ?
  `<div class="chart-svg-wrap chart-svg-wrap-triple">${renderChartSvg(chart, chartOptions)}</div>` :
  options.compact ?
  `<div class="chart-svg-wrap">${renderChartSvg(chart, interactiveOptions)}</div>` :
  `
      <div class="chart-svg-wrap chart-svg-wrap-only">
        ${renderChartSvg(chart, interactiveOptions)}
      </div>
    `;
  const cardClass = [
  "chart-wheel-card",
  options.detailMode === "solarReturn" ? "chart-wheel-card-solar-return" : "",
  options.multiple ? "chart-wheel-card-triple" : "",
  options.multiple && options.titlePosition === "bottom" ? "chart-wheel-card-triple-title-bottom" : "",
  options.overlayOutwardDetails ? "chart-wheel-card-exterior-labels" : "",
  options.overlayPerimeterLayout ? "chart-wheel-card-temporal-overlay" : ""].
  filter(Boolean).join(" ");
  const toolbarPatternSummary = !options.hideTools && !options.multiple ?
  chartPatternSummary(chart, panelPrefix, options) :
  "";
  const toolbarTechnicalLinks = toolbarPatternSummary ?
  technicalLinks.filter(([key]) => key !== "figuras") :
  technicalLinks;
  const actionHtml = [
  options.hideTools ? "" : chartTechnicalLinks(
    panelPrefix,
    toolbarTechnicalLinks,
    options.technicalActionHtml,
    {
      leadingHtml: toolbarPatternSummary,
      groupSecondary: options.groupSecondaryTechnicalLinks,
      primaryKeys: chartPatternPrimaryTechnicalKeys(options.primaryTechnicalKeys, chart, options)
    }
  ),
  options.hideActions ? "" : chartCardActions()].
  filter(Boolean).join("");
  const subtitleCandidate = options.hideSubtitle ? "" : chartWheelSubtitle(chart, options);
  const normalizedTitle = String(title || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("es-ES");
  const normalizedSubtitle = String(subtitleCandidate || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("es-ES");
  const subtitle = normalizedSubtitle && normalizedSubtitle !== normalizedTitle ? subtitleCandidate : "";
  const compactSummary = options.multiple ? chartMobileSummary(title, subtitle) : "";
  const headerNoticeHtml = options.headerNoticeHtml ?? (
  options.multiple ? chartPatternSummary(chart, panelPrefix, options) : "");


  return `
    <article class="${cardClass}">
      <header class="chart-card-header">
        <div class="chart-card-identity">
          <h3>${escapeHtml(title)}</h3>
          ${chartCardSubtitle(subtitle, options)}
          ${headerNoticeHtml}
          ${compactSummary ? `<p class="chart-card-mobile-summary">${escapeHtml(compactSummary)}</p>` : ""}
        </div>
        ${options.multiple || options.hidePeopleControls ? "" : chartFullscreenPeopleControls()}
        ${options.detailMode === "solarReturn" && !options.hideSolarReturnControls ? solarReturnFullscreenNatalControl() : ""}
        ${actionHtml ? `<div class="chart-card-header-actions">${actionHtml}</div>` : ""}
      </header>
      ${chartBody}
    </article>
  `;
}

function chartCardSubtitle(subtitle, options = {}) {
  if (!subtitle) return "";
  const fullSubtitle = `<p class="chart-card-subtitle">${escapeHtml(subtitle)}</p>`;
  if (options.multiple || !["transits", "progressed", "solarReturn"].includes(options.detailMode)) return fullSubtitle;
  return `
    <div class="chart-card-context">
      ${fullSubtitle}
      <details class="chart-card-context-details">
        <summary>
          <span class="chart-card-context-person">${escapeHtml(currentChartPersonName())}</span>
          <span class="chart-card-context-trigger">${T("charts.contextDetails")}
            <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="m6 9 6 6 6-6"></path></svg>
          </span>
        </summary>
        <div class="chart-card-context-popover">${escapeHtml(subtitle)}</div>
      </details>
    </div>`;
}

function handleChartContextDismiss(event) {
  const escape = event.type === "keydown" && event.key === "Escape";
  if (event.type === "keydown" && !escape) return;
  chartWheelStage.querySelectorAll(".chart-card-context-details[open]").forEach((details) => {
    if (escape || !details.contains(event.target)) {
      details.open = false;
      if (escape) {
        event.preventDefault();
        event.stopPropagation();
        details.querySelector("summary")?.focus({ preventScroll: true });
      }
    }
  });
}

function chartCardActions(extraClass = "", options = {}) {
  const className = ["chart-card-actions", extraClass].filter(Boolean).join(" ");
  const canExportChart = chartWheelSurface !== "guest-maps";
  const interpretAction = canAccessGptIa() ? `
      <button class="chart-card-action-button chart-card-interpret-button" type="button" data-chart-card-action="interpret" aria-label="${T("interface.interpretar_carta")}" title="${T("interface.interpretar_carta")}">
        ${chartActionIcon("interpret")}
        <span>${T("interface.interpretar_carta")}</span>
      </button>` :

  "";
  const planetVisibilityAction = options.planetVisibility === false ?
  "" : `
      <button class="chart-card-action-button chart-planet-visibility-button" type="button" data-chart-card-action="planet-visibility" aria-label="${T("interface.abrir_configuracion_del_mapa")}" title="${T("common.settings")}">
        ${chartActionIcon("planets")}
      </button>`;

  const exportActions = canExportChart ? `
      <button class="chart-card-action-button chart-card-action-direct-export" type="button" data-chart-card-action="export-png" aria-label="${T("interface.descargar_png")}" title="${T("interface.descargar_png")}">
        ${chartActionIcon("image")}
      </button>
      <button class="chart-card-action-button chart-card-action-direct-export" type="button" data-chart-card-action="export-pdf" aria-label="${T("interface.descargar_pdf")}" title="${T("interface.descargar_pdf")}">
        ${chartActionIcon("pdf")}
      </button>
      <details class="chart-card-more-menu">
        <summary class="chart-card-action-button" aria-label="${T("interface.mas_opciones")}" title="${T("interface.mas_opciones")}">
          ${chartActionIcon("more")}
        </summary>
        <div class="chart-card-more-popover" role="menu" aria-label="${T("interface.opciones_de_exportacion")}">
          <button type="button" data-chart-card-action="export-png" role="menuitem">
            ${chartActionIcon("image")}
            <span>${T("interface.descargar_imagen")}</span>
          </button>
          <button type="button" data-chart-card-action="export-pdf" role="menuitem">
            ${chartActionIcon("pdf")}
            <span>${T("interface.exportar_pdf")}</span>
          </button>
        </div>
      </details>` :

  "";
  return `
    <div class="${className}" aria-label="${T("interface.acciones_de_carta")}">
      ${interpretAction}
      ${planetVisibilityAction}
      <button class="chart-card-action-button" type="button" data-chart-card-action="fullscreen" aria-label="${T("interface.pantalla_completa")}" title="${T("interface.pantalla_completa")}">
        ${chartActionIcon("fullscreen")}
      </button>
      ${exportActions}
    </div>
  `;
}

function chartActionIcon(type) {
  if (type === "interpret") {
    return `
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M14.5 4H7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.5L12 21l2.5-3H17a3 3 0 0 0 3-3v-3.5"></path>
        <path d="m8 9 2 2-2 2"></path>
        <path d="M12 13h2.5"></path>
        <path d="M19 2.5c.3 1.75 1.25 2.7 3 3-1.75.3-2.7 1.25-3 3-.3-1.75-1.25-2.7-3-3 1.75-.3 2.7-1.25 3-3Z"></path>
      </svg>
    `;
  }

  if (type === "planets") {
    return `
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M4 7h10"></path>
        <path d="M18 7h2"></path>
        <circle cx="16" cy="7" r="2"></circle>
        <path d="M4 17h2"></path>
        <path d="M10 17h10"></path>
        <circle cx="8" cy="17" r="2"></circle>
      </svg>
    `;
  }

  if (type === "more") {
    return `
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <circle cx="5" cy="12" r="1.5" fill="currentColor" stroke="none"></circle>
        <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"></circle>
        <circle cx="19" cy="12" r="1.5" fill="currentColor" stroke="none"></circle>
      </svg>
    `;
  }

  if (type === "fullscreen") {
    return `
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M8 3H3v5"></path>
        <path d="M16 3h5v5"></path>
        <path d="M8 21H3v-5"></path>
        <path d="M16 21h5v-5"></path>
      </svg>
    `;
  }

  if (type === "pdf") {
    return `
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <path d="M14 2v6h6"></path>
        <path d="M8 14h8"></path>
        <path d="M8 18h5"></path>
      </svg>
    `;
  }

  return `
    <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
      <rect x="3" y="5" width="18" height="14" rx="2"></rect>
      <circle cx="8.5" cy="10" r="1.5"></circle>
      <path d="M21 15l-4.5-4.5L8 19"></path>
      <path d="M12 13l2.5 2.5"></path>
    </svg>
  `;
}

function loadChartVisiblePlanetKeys() {
  try {
    const storedKeys = JSON.parse(window.localStorage.getItem(CHART_PLANET_VISIBILITY_STORAGE_KEY) || "null");
    if (Array.isArray(storedKeys)) {
      const visibleKeys = new Set(storedKeys.filter((key) => CHART_SELECTABLE_PLANETS.includes(key)));
      const storedSchema = window.localStorage.getItem(CHART_PLANET_VISIBILITY_SCHEMA_STORAGE_KEY);
      if (storedSchema !== CHART_PLANET_VISIBILITY_SCHEMA_VERSION) {
        PROMPT_TECHNICAL_POINT_ORDER.forEach((key) => visibleKeys.add(key));
        CHART_ANGLE_POINT_KEYS.forEach((key) => visibleKeys.add(key));
        window.localStorage.setItem(CHART_PLANET_VISIBILITY_STORAGE_KEY, JSON.stringify(Array.from(visibleKeys)));
        window.localStorage.setItem(CHART_PLANET_VISIBILITY_SCHEMA_STORAGE_KEY, CHART_PLANET_VISIBILITY_SCHEMA_VERSION);
      }
      return visibleKeys;
    }
  } catch (_error) {

    // La carta conserva la selección completa si el almacenamiento no está disponible.
  }return new Set(CHART_DEFAULT_VISIBLE_PLANETS);
}

function defaultChartPlanetColorsMap() {
  return new Map(CHART_PLANET_COLOR_KEYS.map((key) => [key, CHART_DEFAULT_PLANET_COLORS[key]]));
}

function normalizeChartPlanetColor(key, value) {
  const fallback = CHART_DEFAULT_PLANET_COLORS[key] || "#111827";
  const candidate = String(value || "").trim().toLowerCase();
  if (/^#[0-9a-f]{6}$/.test(candidate)) return candidate;
  if (/^#[0-9a-f]{3}$/.test(candidate)) {
    return `#${candidate.slice(1).split("").map((character) => character.repeat(2)).join("")}`;
  }
  return fallback;
}

function chartPlanetColorPropertyName(key) {
  const slug = String(key || "").
  trim().
  toLowerCase().
  replace(/[^a-z0-9]+/g, "-").
  replace(/^-|-$/g, "");
  return `--chart-planet-user-${slug}`;
}

function loadChartPlanetColors() {
  let stored = null;
  try {
    stored = JSON.parse(window.localStorage.getItem(CHART_PLANET_COLORS_STORAGE_KEY) || "null");
  } catch (_error) {
    stored = null;
  }
  return new Map(CHART_PLANET_COLOR_KEYS.map((key) => [
  key,
  normalizeChartPlanetColor(key, stored?.[key])]
  ));
}

function chartPlanetColorForKey(key) {
  return normalizeChartPlanetColor(key, chartPlanetColors?.get(key));
}

function chartPlanetColorCssValue(key, fallback = "var(--text)") {
  if (!CHART_DEFAULT_PLANET_COLORS[key]) return fallback;
  return `var(${chartPlanetColorPropertyName(key)}, ${CHART_DEFAULT_PLANET_COLORS[key]})`;
}

function chartUsesDefaultPlanetColors(colors = chartPlanetColors) {
  return CHART_PLANET_COLOR_KEYS.every((key) =>
  normalizeChartPlanetColor(key, colors?.get(key)) === CHART_DEFAULT_PLANET_COLORS[key]
  );
}

function applyChartPlanetColorVariables() {
  CHART_PLANET_COLOR_KEYS.forEach((key) => {
    document.documentElement.style.setProperty(chartPlanetColorPropertyName(key), chartPlanetColorForKey(key));
  });
  syncAspectFinderPlanetSelectsAppearance();
}

function persistChartPlanetColors() {
  const values = Object.fromEntries(CHART_PLANET_COLOR_KEYS.map((key) => [key, chartPlanetColorForKey(key)]));
  try {
    window.localStorage.setItem(CHART_PLANET_COLORS_STORAGE_KEY, JSON.stringify(values));
  } catch (_error) {

    // Los colores personalizados siguen activos durante esta sesión.
  }queueAccountPreferencesSave();
}

function setChartPlanetColor(key, value, options = {}) {
  if (!CHART_DEFAULT_PLANET_COLORS[key]) return;
  const color = normalizeChartPlanetColor(key, value);
  chartPlanetColors.set(key, color);
  applyChartPlanetColorVariables();
  syncChartPlanetColorControls();
  updateChartPlanetVisibilityStatus();
  if (options.announce && chartPlanetColorStatus) {
    const label = PROMPT_PLANET_LABELS[key] || key;
    I18n.bind(chartPlanetColorStatus, "textContent", () => T("interface.color_de_value_actualizado_a_value", { v0: I18n.label(label), v1: color.toUpperCase() }));
  }
}

function renderChartPlanetColorPalette() {
  if (!chartPlanetColorPalette || chartPlanetColorPalette.childElementCount) return;
  I18n.bind(chartPlanetColorPalette, "innerHTML", () => Object.freeze([Object.freeze({ value: "#ff0000", get label() {return T("interface.rojo");} }), Object.freeze({ value: "#1e4f8f", get label() {return T("interface.azul");} }), Object.freeze({ value: "#2f8f46", get label() {return T("interface.verde");} }), Object.freeze({ value: "#8b5a2b", get label() {return T("interface.tierra");} }), Object.freeze({ value: "#f505f0", get label() {return T("interface.magenta");} }), Object.freeze({ value: "#6d28d9", get label() {return T("interface.violeta");} }), Object.freeze({ value: "#0f766e", get label() {return T("interface.turquesa");} }), Object.freeze({ value: "#b7791f", get label() {return T("interface.ocre");} }), Object.freeze({ value: "#c2410c", get label() {return T("interface.naranja");} }), Object.freeze({ value: "#111827", get label() {return T("interface.tinta");} })]).map((preset) => `
    <button
      type="button"
      class="chart-aspect-color-swatch"
      data-planet-color-value="${preset.value}"
      style="--aspect-swatch-color:${preset.value}"
      aria-label="${escapeHtml(I18n.label(preset.label))}, ${preset.value.toUpperCase()}"
      title="${escapeHtml(I18n.label(preset.label))}"
      aria-pressed="false"
    ><span aria-hidden="true"></span></button>
  `).join(""));
}

function syncChartPlanetColorControls() {
  renderChartPlanetColorPalette();
  const editorOpen = Boolean(chartPlanetColorEditor && !chartPlanetColorEditor.hidden);
  document.querySelectorAll("[data-planet-color-trigger]").forEach((trigger) => {
    const key = trigger.dataset.planetColorTrigger;
    const color = chartPlanetColorForKey(key);
    trigger.style.setProperty("--aspect-option-color", chartPlanetColorCssValue(key));
    I18n.bind(trigger, "@aria-label", () => T("interface.cambiar_el_color_de_value_color_actual_value_2", { v0: PROMPT_PLANET_LABELS[key] || key, v1: color.toUpperCase() }));
    trigger.setAttribute("aria-expanded", editorOpen && activeChartPlanetColorKey === key ? "true" : "false");
    trigger.closest("[data-chart-planet-color-row]")?.style.setProperty("--planet-option-color", chartPlanetColorCssValue(key));
  });

  const customCount = CHART_PLANET_COLOR_KEYS.filter((key) =>
  chartPlanetColorForKey(key) !== CHART_DEFAULT_PLANET_COLORS[key]
  ).length;
  if (chartPlanetColorRestoreAllButton) chartPlanetColorRestoreAllButton.disabled = customCount === 0;
  if (!editorOpen || !activeChartPlanetColorKey) return;

  const key = activeChartPlanetColorKey;
  const label = PROMPT_PLANET_LABELS[key] || key;
  const glyph = planetGlyph(key);
  const color = chartPlanetColorForKey(key);
  if (chartPlanetColorEditorTitle) I18n.bind(chartPlanetColorEditorTitle, "textContent", () => T("interface.color_de_value", { v0: I18n.label(label) }));
  if (chartPlanetColorEditorSymbol) {
    I18n.bind(chartPlanetColorEditorSymbol, "textContent", () => glyph);
    chartPlanetColorEditorSymbol.style.setProperty("--aspect-option-color", chartPlanetColorCssValue(key));
    chartPlanetColorEditorSymbol.classList.toggle("chart-planet-color-editor-symbol-text", glyph.replace(/\uFE0E/g, "").length > 1);
  }
  if (chartPlanetCustomColorInput && chartPlanetCustomColorInput.value !== color) {
    chartPlanetCustomColorInput.value = color;
  }
  if (chartPlanetCustomColorValue) chartPlanetCustomColorValue.value = color.toUpperCase();
  if (chartPlanetColorRestoreCurrentButton) {
    chartPlanetColorRestoreCurrentButton.disabled = color === CHART_DEFAULT_PLANET_COLORS[key];
  }
  chartPlanetColorPalette?.querySelectorAll("[data-planet-color-value]").forEach((swatch) => {
    swatch.setAttribute("aria-pressed", swatch.dataset.planetColorValue.toLowerCase() === color ? "true" : "false");
  });
}

function openChartPlanetColorEditor(key, trigger = null) {
  if (!chartPlanetColorEditor || !CHART_DEFAULT_PLANET_COLORS[key]) return;
  activeChartPlanetColorKey = key;
  chartPlanetColorReturnFocus = trigger || null;
  chartPlanetColorEditor.hidden = false;
  syncChartPlanetColorControls();
  chartPlanetColorEditor.scrollIntoView({ block: "nearest" });
}

function closeChartPlanetColorEditor(options = {}) {
  if (!chartPlanetColorEditor) return;
  const returnFocus = chartPlanetColorReturnFocus;
  chartPlanetColorEditor.hidden = true;
  activeChartPlanetColorKey = null;
  chartPlanetColorReturnFocus = null;
  syncChartPlanetColorControls();
  if (options.restoreFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
}

function restoreChartPlanetColorsBeforeDialog() {
  if (!(chartPlanetColorsBeforeDialog instanceof Map)) return;
  chartPlanetColors = new Map(chartPlanetColorsBeforeDialog);
  chartPlanetColorsBeforeDialog = null;
  applyChartPlanetColorVariables();
}

function loadChartAspectPlanetKeys() {
  try {
    const storedKeys = JSON.parse(window.localStorage.getItem(CHART_PLANET_ASPECT_VISIBILITY_STORAGE_KEY) || "null");
    if (Array.isArray(storedKeys)) {
      const aspectKeys = new Set(storedKeys.filter((key) => CHART_SELECTABLE_PLANETS.includes(key)));
      const storedSchema = window.localStorage.getItem(CHART_PLANET_ASPECT_VISIBILITY_SCHEMA_STORAGE_KEY);
      if (storedSchema !== CHART_PLANET_VISIBILITY_SCHEMA_VERSION) {
        window.localStorage.setItem(CHART_PLANET_ASPECT_VISIBILITY_STORAGE_KEY, JSON.stringify(Array.from(aspectKeys)));
        window.localStorage.setItem(CHART_PLANET_ASPECT_VISIBILITY_SCHEMA_STORAGE_KEY, CHART_PLANET_VISIBILITY_SCHEMA_VERSION);
      }
      return aspectKeys;
    }
  } catch (_error) {

    // Los aspectos principales permanecen visibles si el almacenamiento no está disponible.
  }return new Set(CHART_DEFAULT_ASPECT_PLANETS);
}

function loadChartVisibleAspectAngles() {
  try {
    const storedAngles = JSON.parse(window.localStorage.getItem(CHART_ASPECT_TYPE_VISIBILITY_STORAGE_KEY) || "null");
    if (Array.isArray(storedAngles)) {
      const angles = storedAngles.map(Number).filter((angle) => VISUAL_ASPECT_ANGLES.has(angle));
      const storedSchema = window.localStorage.getItem(CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_STORAGE_KEY);
      const usesLegacyDefaults = storedSchema !== CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_VERSION &&
      angles.length === CHART_LEGACY_DEFAULT_VISIBLE_ASPECT_ANGLES.length &&
      CHART_LEGACY_DEFAULT_VISIBLE_ASPECT_ANGLES.every((angle) => angles.includes(angle));
      const normalizedAngles = usesLegacyDefaults ? CHART_DEFAULT_VISIBLE_ASPECT_ANGLES : angles;
      window.localStorage.setItem(CHART_ASPECT_TYPE_VISIBILITY_STORAGE_KEY, JSON.stringify(normalizedAngles));
      window.localStorage.setItem(CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_STORAGE_KEY, CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_VERSION);
      return new Set(normalizedAngles);
    }
  } catch (_error) {

    // Se conserva la selección habitual si el almacenamiento no está disponible.
  }return new Set(CHART_DEFAULT_VISIBLE_ASPECT_ANGLES);
}

function normalizeChartAspectOrb(angle, value) {
  const fallback = Number(CHART_DEFAULT_ASPECT_ORBS[Number(angle)] ?? 0);
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : fallback;
  const clamped = Math.max(CHART_ASPECT_ORB_MIN, Math.min(CHART_ASPECT_ORB_MAX, safeValue));
  return round(Math.round(clamped / CHART_ASPECT_ORB_STEP) * CHART_ASPECT_ORB_STEP, 1);
}

function loadChartAspectOrbs() {
  let stored = null;
  try {
    stored = JSON.parse(window.localStorage.getItem(CHART_ASPECT_ORBS_STORAGE_KEY) || "null");
  } catch (_error) {
    stored = null;
  }
  return new Map(ASPECT_CONFIGS.map((aspect) => [
  Number(aspect.angle),
  normalizeChartAspectOrb(aspect.angle, stored?.[aspect.angle])]
  ));
}

function defaultChartAspectColorsMap() {
  return new Map(ASPECT_CONFIGS.map((aspect) => [
  Number(aspect.angle),
  CHART_DEFAULT_ASPECT_COLORS[aspect.angle]]
  ));
}

function normalizeChartAspectColor(angle, value) {
  const fallback = CHART_DEFAULT_ASPECT_COLORS[Number(angle)] || "#245fbd";
  const candidate = String(value || "").trim().toLowerCase();
  if (/^#[0-9a-f]{6}$/.test(candidate)) return candidate;
  if (/^#[0-9a-f]{3}$/.test(candidate)) {
    return `#${candidate.slice(1).split("").map((character) => character.repeat(2)).join("")}`;
  }
  return fallback;
}

function loadChartAspectColors() {
  let stored = null;
  try {
    stored = JSON.parse(window.localStorage.getItem(CHART_ASPECT_COLORS_STORAGE_KEY) || "null");
  } catch (_error) {
    stored = null;
  }
  return new Map(ASPECT_CONFIGS.map((aspect) => [
  Number(aspect.angle),
  normalizeChartAspectColor(aspect.angle, stored?.[aspect.angle])]
  ));
}

function chartAspectColorForAngle(angle) {
  const numericAngle = Number(angle);
  return normalizeChartAspectColor(numericAngle, chartAspectColors?.get(numericAngle));
}

function chartAspectColorCssValue(angle) {
  const numericAngle = Number(angle);
  const fallback = ASPECT_COLORS[numericAngle] || "var(--accent)";
  return `var(--chart-aspect-user-${numericAngle}, ${fallback})`;
}

function chartUsesDefaultAspectColors(colors = chartAspectColors) {
  return ASPECT_CONFIGS.every((aspect) =>
  normalizeChartAspectColor(aspect.angle, colors?.get(Number(aspect.angle))) === CHART_DEFAULT_ASPECT_COLORS[aspect.angle]
  );
}

function applyChartAspectColorVariables() {
  ASPECT_CONFIGS.forEach((aspect) => {
    document.documentElement.style.setProperty(
      `--chart-aspect-user-${aspect.angle}`,
      chartAspectColorForAngle(aspect.angle)
    );
  });
  syncAspectFinderAspectSelectAppearance();
}

function persistChartAspectColors() {
  const values = Object.fromEntries(ASPECT_CONFIGS.map((aspect) => [
  aspect.angle,
  chartAspectColorForAngle(aspect.angle)]
  ));
  try {
    window.localStorage.setItem(CHART_ASPECT_COLORS_STORAGE_KEY, JSON.stringify(values));
  } catch (_error) {

    // Los colores personalizados siguen activos durante esta sesión.
  }queueAccountPreferencesSave();
}

function setChartAspectColor(angle, value, options = {}) {
  const numericAngle = Number(angle);
  if (!VISUAL_ASPECT_ANGLES.has(numericAngle)) return;
  const color = normalizeChartAspectColor(numericAngle, value);
  chartAspectColors.set(numericAngle, color);
  applyChartAspectColorVariables();
  syncChartAspectColorControls();
  updateChartPlanetVisibilityStatus();
  if (options.announce && chartAspectColorStatus) {
    const label = ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === numericAngle)?.label || T("interface.aspecto_de_value", { v0: numericAngle });
    I18n.bind(chartAspectColorStatus, "textContent", () => T("interface.color_de_value_actualizado_a_value", { v0: I18n.label(ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === numericAngle)?.label || T("interface.aspecto_de_value", { v0: numericAngle })), v1: color.toUpperCase() }));
  }
}

function renderChartAspectColorPalette() {
  if (!chartAspectColorPalette || chartAspectColorPalette.childElementCount) return;
  I18n.bind(chartAspectColorPalette, "innerHTML", () => Object.freeze([Object.freeze({ value: "#d97706", get label() {return T("interface.ambar");} }), Object.freeze({ value: "#245fbd", get label() {return T("interface.azul");} }), Object.freeze({ value: "#187044", get label() {return T("interface.verde");} }), Object.freeze({ value: "#d92d2d", get label() {return T("interface.rojo");} }), Object.freeze({ value: "#7c3aed", get label() {return T("interface.violeta");} }), Object.freeze({ value: "#5579a8", get label() {return T("interface.azul_pizarra");} }), Object.freeze({ value: "#b84b5f", get label() {return T("interface.carmin");} })]).map((preset) => `
    <button
      type="button"
      class="chart-aspect-color-swatch"
      data-aspect-color-value="${preset.value}"
      style="--aspect-swatch-color:${preset.value}"
      aria-label="${escapeHtml(I18n.label(preset.label))}, ${preset.value.toUpperCase()}"
      title="${escapeHtml(I18n.label(preset.label))}"
      aria-pressed="false"
    ><span aria-hidden="true"></span></button>
  `).join(""));
}

function syncChartAspectColorControls() {
  renderChartAspectColorPalette();
  const editorOpen = Boolean(chartAspectColorEditor && !chartAspectColorEditor.hidden);
  document.querySelectorAll("[data-aspect-color-trigger]").forEach((trigger) => {
    const angle = Number(trigger.dataset.aspectColorTrigger);
    const config = ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === angle);
    const color = chartAspectColorForAngle(angle);
    trigger.style.setProperty("--aspect-option-color", chartAspectColorCssValue(angle));
    I18n.bind(trigger, "@aria-label", () => T("interface.cambiar_el_color_de_value_color_actual_value_2", { get v0() {return config?.label || T("interface.aspecto_de_value", { v0: angle });}, v1: color.toUpperCase() }));
    trigger.setAttribute("aria-expanded", editorOpen && activeChartAspectColorAngle === angle ? "true" : "false");
    trigger.closest("[data-chart-aspect-color-row]")?.style.setProperty("--aspect-option-color", chartAspectColorCssValue(angle));
  });

  const customCount = ASPECT_CONFIGS.filter((aspect) =>
  chartAspectColorForAngle(aspect.angle) !== CHART_DEFAULT_ASPECT_COLORS[aspect.angle]
  ).length;
  if (chartAspectColorRestoreAllButton) chartAspectColorRestoreAllButton.disabled = customCount === 0;
  if (!editorOpen || !Number.isFinite(activeChartAspectColorAngle)) return;

  const config = ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === activeChartAspectColorAngle);
  if (!config) return;
  const color = chartAspectColorForAngle(activeChartAspectColorAngle);
  const defaultColor = CHART_DEFAULT_ASPECT_COLORS[activeChartAspectColorAngle];
  if (chartAspectColorEditorTitle) I18n.bind(chartAspectColorEditorTitle, "textContent", () => T("interface.color_de_value", { v0: I18n.label(config.label) }));
  if (chartAspectColorEditorSymbol) {
    I18n.bind(chartAspectColorEditorSymbol, "textContent", () => ASPECT_SYMBOLS[config.angle] || String(config.angle));
    chartAspectColorEditorSymbol.style.setProperty("--aspect-option-color", chartAspectColorCssValue(config.angle));
  }
  if (chartAspectCustomColorInput && chartAspectCustomColorInput.value !== color) {
    chartAspectCustomColorInput.value = color;
  }
  if (chartAspectCustomColorValue) chartAspectCustomColorValue.value = color.toUpperCase();
  if (chartAspectColorRestoreCurrentButton) chartAspectColorRestoreCurrentButton.disabled = color === defaultColor;
  chartAspectColorPalette?.querySelectorAll("[data-aspect-color-value]").forEach((swatch) => {
    swatch.setAttribute("aria-pressed", swatch.dataset.aspectColorValue.toLowerCase() === color ? "true" : "false");
  });
}

function openChartAspectColorEditor(angle, trigger = null) {
  const numericAngle = Number(angle);
  if (!chartAspectColorEditor || !VISUAL_ASPECT_ANGLES.has(numericAngle)) return;
  activeChartAspectColorAngle = numericAngle;
  chartAspectColorReturnFocus = trigger || null;
  chartAspectColorEditor.hidden = false;
  syncChartAspectColorControls();
  chartAspectColorEditor.scrollIntoView({ block: "nearest" });
}

function closeChartAspectColorEditor(options = {}) {
  if (!chartAspectColorEditor) return;
  const returnFocus = chartAspectColorReturnFocus;
  chartAspectColorEditor.hidden = true;
  activeChartAspectColorAngle = null;
  chartAspectColorReturnFocus = null;
  syncChartAspectColorControls();
  if (options.restoreFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
}

function restoreChartAspectColorsBeforeDialog() {
  if (!(chartAspectColorsBeforeDialog instanceof Map)) return;
  chartAspectColors = new Map(chartAspectColorsBeforeDialog);
  chartAspectColorsBeforeDialog = null;
  applyChartAspectColorVariables();
}

function chartAspectOrbForAngle(angle) {
  const numericAngle = Number(angle);
  return normalizeChartAspectOrb(numericAngle, chartAspectOrbs.get(numericAngle));
}

function chartUsesDefaultAspectOrbs(orbs = chartAspectOrbs) {
  return ASPECT_CONFIGS.every((aspect) =>
  Number(orbs.get(Number(aspect.angle))) === Number(CHART_DEFAULT_ASPECT_ORBS[aspect.angle])
  );
}

function loadChartHouseSystemKey() {
  try {
    const storedKey = window.localStorage.getItem(CHART_HOUSE_SYSTEM_STORAGE_KEY) || DEFAULT_CHART_HOUSE_SYSTEM;
    return CHART_HOUSE_SYSTEMS[storedKey] ? storedKey : DEFAULT_CHART_HOUSE_SYSTEM;
  } catch (_error) {
    return DEFAULT_CHART_HOUSE_SYSTEM;
  }
}

function persistChartVisiblePlanetKeys() {
  try {
    window.localStorage.setItem(CHART_PLANET_VISIBILITY_STORAGE_KEY, JSON.stringify(Array.from(chartVisiblePlanetKeys)));
    window.localStorage.setItem(CHART_PLANET_VISIBILITY_SCHEMA_STORAGE_KEY, CHART_PLANET_VISIBILITY_SCHEMA_VERSION);
  } catch (_error) {

    // La selección sigue activa durante la sesión aunque no se pueda persistir.
  }queueAccountPreferencesSave();
  if (privateAtlas3DController && privateAtlas3DSelection?.calculation) {
    privateAtlas3DController.updateChart({ chart: getPrivateAtlas3DChart() });
  }
}

function persistChartAspectPlanetKeys() {
  try {
    window.localStorage.setItem(CHART_PLANET_ASPECT_VISIBILITY_STORAGE_KEY, JSON.stringify(Array.from(chartAspectPlanetKeys)));
    window.localStorage.setItem(CHART_PLANET_ASPECT_VISIBILITY_SCHEMA_STORAGE_KEY, CHART_PLANET_VISIBILITY_SCHEMA_VERSION);
  } catch (_error) {

    // La selección sigue activa durante la sesión aunque no se pueda persistir.
  }queueAccountPreferencesSave();
}

function persistChartVisibleAspectAngles() {
  try {
    window.localStorage.setItem(
      CHART_ASPECT_TYPE_VISIBILITY_STORAGE_KEY,
      JSON.stringify(Array.from(chartVisibleAspectAngles).sort((a, b) => a - b))
    );
    window.localStorage.setItem(
      CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_STORAGE_KEY,
      CHART_ASPECT_TYPE_VISIBILITY_SCHEMA_VERSION
    );
  } catch (_error) {

    // La selección sigue activa durante la sesión aunque no se pueda persistir.
  }queueAccountPreferencesSave();
}

function persistChartAspectOrbs() {
  const values = Object.fromEntries(ASPECT_CONFIGS.map((aspect) => [
  aspect.angle,
  chartAspectOrbForAngle(aspect.angle)]
  ));
  try {
    window.localStorage.setItem(CHART_ASPECT_ORBS_STORAGE_KEY, JSON.stringify(values));
  } catch (_error) {

    // Los orbes personalizados siguen activos durante esta sesión.
  }queueAccountPreferencesSave();
}

function persistChartHouseSystemKey() {
  try {
    window.localStorage.setItem(CHART_HOUSE_SYSTEM_STORAGE_KEY, chartHouseSystemKey);
  } catch (_error) {

    // El sistema seleccionado sigue activo durante la sesión.
  }queueAccountPreferencesSave();
}

function isChartPlanetVisible(planetKey) {
  return !CHART_SELECTABLE_PLANETS.includes(planetKey) || chartVisiblePlanetKeys.has(planetKey);
}

function chartPlanetVisibilityClass(planetKey) {
  return isChartPlanetVisible(planetKey) ? "" : " is-chart-planet-hidden";
}

function isChartPlanetAspectVisible(planetKey) {
  return !CHART_SELECTABLE_PLANETS.includes(planetKey) || chartAspectPlanetKeys.has(planetKey);
}

function isChartAspectTypeVisible(angle) {
  return chartVisibleAspectAngles.has(Number(angle));
}

function isHighlightedChartAspect(chart, aspect) {
  const highlighted = chart?.highlightedAspect;
  if (!highlighted || !aspect) return false;
  const samePlanets =
  aspect.planetA === highlighted.planetA && aspect.planetB === highlighted.planetB ||
  aspect.planetA === highlighted.planetB && aspect.planetB === highlighted.planetA;

  return Boolean(samePlanets && Number(aspect.angle) === Number(highlighted.angle));
}

function isHighlightedCrossChartAspect(chart, aspect) {
  const highlighted = chart?.highlightedCrossAspect;
  if (!highlighted || !aspect) return false;
  return Boolean(
    aspect.planetA === highlighted.planetA &&
    aspect.planetB === highlighted.planetB &&
    Number(aspect.angle) === Number(highlighted.angle)
  );
}

function isChartAspectVisible(aspect) {
  return isChartAspectTypeVisible(aspect?.angle) &&
  isChartPlanetVisible(aspect?.planetA) &&
  isChartPlanetVisible(aspect?.planetB) &&
  isChartPlanetAspectVisible(aspect?.planetA) &&
  isChartPlanetAspectVisible(aspect?.planetB);
}

function chartAspectVisibilityClass(aspect) {
  return isChartAspectVisible(aspect) ? "" : " is-chart-planet-hidden";
}

function chartAspectAnchorVisibilityClass(planetKey) {
  return isChartPlanetVisible(planetKey) && isChartPlanetAspectVisible(planetKey) ?
  "" :
  " is-chart-planet-hidden";
}

function applyChartPlanetVisibility(root = chartWheelStage) {
  if (!root) return;
  const selectedCount = chartVisiblePlanetKeys.size;
  root.querySelectorAll("[data-chart-planet-key]").forEach((element) => {
    element.classList.toggle("is-chart-planet-hidden", !isChartPlanetVisible(element.dataset.chartPlanetKey));
  });
  root.querySelectorAll("[data-chart-aspect-planets]").forEach((element) => {
    const planetKeys = String(element.dataset.chartAspectPlanets || "").split("|").filter(Boolean);
    const aspectAngle = Number(element.dataset.chartAspectAngle);
    const aspectTypeHidden = Number.isFinite(aspectAngle) &&
    !element.classList.contains("is-highlighted") &&
    !isChartAspectTypeVisible(aspectAngle);
    element.classList.toggle("is-chart-planet-hidden", aspectTypeHidden || planetKeys.some((key) =>
    !isChartPlanetVisible(key) || !isChartPlanetAspectVisible(key)
    ));
  });
  root.querySelectorAll("[data-chart-aspect-anchor-key]").forEach((element) => {
    const planetKey = element.dataset.chartAspectAnchorKey;
    element.classList.toggle("is-chart-planet-hidden",
    !isChartPlanetVisible(planetKey) || !isChartPlanetAspectVisible(planetKey)
    );
  });
  root.querySelectorAll("[data-chart-card-action='planet-visibility']").forEach((button) => {
    const usesHabitualAspects = CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.length === chartVisibleAspectAngles.size &&
    CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.every((angle) => chartVisibleAspectAngles.has(angle));
    const customAspectColorCount = ASPECT_CONFIGS.filter((aspect) =>
    chartAspectColorForAngle(aspect.angle) !== CHART_DEFAULT_ASPECT_COLORS[aspect.angle]
    ).length;
    const customPlanetColorCount = CHART_PLANET_COLOR_KEYS.filter((key) =>
    chartPlanetColorForKey(key) !== CHART_DEFAULT_PLANET_COLORS[key]
    ).length;
    const isFiltered = selectedCount < CHART_SELECTABLE_PLANETS.length ||
    !usesHabitualAspects ||
    !chartUsesDefaultAspectOrbs() ||
    !chartUsesDefaultAspectColors() ||
    !chartUsesDefaultPlanetColors() ||
    chartHouseSystemKey !== DEFAULT_CHART_HOUSE_SYSTEM;
    button.classList.toggle("is-filtered", isFiltered);
    I18n.bind(button, "@aria-label", ((__i18nSnapshot0, __i18nSnapshot1) => () => T("interface.configuracion_del_mapa_value_cuerpos_visibles_value_tipos_de_aspectovaluevalue_y_valu", { v0: selectedCount, v1: __i18nSnapshot0.size, get v2() {return customAspectColorCount ? `, ${customAspectColorCount} ${customAspectColorCount === 1 ? T("interface.color_de_aspecto_personalizado") : T("interface.colores_de_aspecto_personalizados")}` : "";}, get v3() {return customPlanetColorCount ? `, ${customPlanetColorCount} ${customPlanetColorCount === 1 ? T("interface.color_de_cuerpo_personalizado") : T("interface.colores_de_cuerpos_personalizados")}` : "";}, get v4() {return Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[__i18nSnapshot1]?.label || T("interface.placidus");} }))(chartVisibleAspectAngles, chartHouseSystemKey));



    I18n.bind(button, "@title", () => T("common.settings"));
  });
}

function rerenderChartWheelForPlanetVisibility() {
  if (!chartCalculation || !chartWheelStage) return;
  const type = safeChartViewType(activeChartViewType || chartWheelTypeSelect?.value || "multiple");
  hideChartPlanetTooltip({ force: true });
  I18n.bind(chartWheelStage, "innerHTML", () => buildChartWheelContent(type));
  arrangeFloatingPanels(chartWheelStage.querySelector(".chart-wheel-workspace"));
  initChartToolsScrollHints(chartWheelStage);
  initChartViewportFit(chartWheelStage);
  applyChartPlanetVisibility(chartWheelStage);
}

function chartAspectOrbDraftMap() {
  return new Map(ASPECT_CONFIGS.map((aspect) => {
    const input = chartAspectOrbList?.querySelector(`input[name='chart-aspect-orb'][data-aspect-angle='${aspect.angle}']`);
    return [
    Number(aspect.angle),
    normalizeChartAspectOrb(aspect.angle, input?.dataset.orbValue ?? input?.value ?? chartAspectOrbForAngle(aspect.angle))];

  }));
}

function updateChartAspectOrbSummary() {
  if (!chartAspectOrbSummary) return;
  const draftOrbs = chartAspectOrbDraftMap();
  const customCount = ASPECT_CONFIGS.filter((aspect) =>
  Number(draftOrbs.get(Number(aspect.angle))) !== Number(CHART_DEFAULT_ASPECT_ORBS[aspect.angle])
  ).length;
  const sideralOnly = safeChartViewType(activeChartViewType || chartWheelTypeSelect?.value) === "sideral";
  I18n.bind(chartAspectOrbSummary, "textContent", () => sideralOnly ? T("interface.no_se_aplica_en_sideral") : customCount ? T("interface.value_personalizadovalue", { v0: customCount, v1: customCount === 1 ? "" : "s" }) : T("interface.valores_habituales"));




  if (chartAspectOrbToggleLabel) {
    I18n.bind(chartAspectOrbToggleLabel, "textContent", () => chartAspectOrbSettings?.open ? T("interface.ocultar_ajustes") : T("interface.mostrar_ajustes"));
  }
  if (chartAspectOrbRestoreDefaultsButton) {
    chartAspectOrbRestoreDefaultsButton.disabled = sideralOnly || customCount === 0;
  }
  const conjunctionEnabled = Boolean(
    chartAspectVisibilityList?.querySelector("input[name='chart-visible-aspect'][value='0']:checked")
  );
  const conjunctionCuspLimit = Math.min(3, Number(draftOrbs.get(0)) || 0);
  if (chartConjunctionCuspLimit) {
    I18n.bind(chartConjunctionCuspLimit, "textContent", () => sideralOnly ? T("interface.no_se_aplica_en_sideral") : conjunctionEnabled ? T("interface.maximo_con_cuspide_value", { v0: formatOrb(conjunctionCuspLimit) }) : T("interface.conjuncion_desactivada"));




  }
  chartConjunctionCuspRule?.classList.toggle("is-sign-mode", sideralOnly);
  chartConjunctionCuspRule?.classList.toggle("is-conjunction-disabled", !conjunctionEnabled);
}

function syncChartAspectOrbControls() {
  if (!chartAspectOrbList) return;
  const selectedAngles = new Set(Array.from(
    chartAspectVisibilityList?.querySelectorAll("input[name='chart-visible-aspect']:checked") || []
  ).map((input) => Number(input.value)));
  const sideralOnly = safeChartViewType(activeChartViewType || chartWheelTypeSelect?.value) === "sideral";
  let visibleCount = 0;
  chartAspectOrbList.querySelectorAll("[data-chart-aspect-orb-row]").forEach((row) => {
    const angle = Number(row.dataset.chartAspectOrbRow);
    const selected = selectedAngles.has(angle);
    row.hidden = !selected;
    row.classList.toggle("is-disabled", sideralOnly);
    const input = row.querySelector("input[name='chart-aspect-orb']");
    if (input) input.disabled = !selected || sideralOnly;
    if (selected) visibleCount += 1;
  });
  chartAspectOrbList.classList.toggle("is-empty", visibleCount === 0);
  if (chartAspectOrbSettings) {
    chartAspectOrbSettings.classList.toggle("is-sign-mode", sideralOnly);
    chartAspectOrbSettings.setAttribute("aria-disabled", sideralOnly ? "true" : "false");
  }
  if (chartAspectOrbHelp) {
    I18n.bind(chartAspectOrbHelp, "textContent", () => sideralOnly ? T("interface.la_carta_sideral_determina_los_aspectos_por_signo_y_no_utiliza_orbes_estos_valores_se") : visibleCount ? T("interface.un_orbe_mayor_incluye_mas_aspectos_uno_menor_exige_mayor_exactitud_puedes_usar_valore") : T("interface.activa_al_menos_un_tipo_de_aspecto_para_ajustar_su_orbe"));




  }
  updateChartAspectOrbSummary();
}

function renderChartAspectOrbOptions() {
  if (!chartAspectOrbList) return;
  I18n.bind(chartAspectOrbList, "innerHTML", () => ASPECT_CONFIGS.map((aspect) => {const orb = chartAspectOrbForAngle(aspect.angle);return `
      <div class="chart-aspect-orb-row" data-chart-aspect-orb-row="${aspect.angle}" data-chart-aspect-color-row style="--aspect-option-color:${chartAspectColorCssValue(aspect.angle)}">
        <button class="chart-aspect-color-trigger chart-aspect-orb-symbol" type="button" data-aspect-color-trigger="${aspect.angle}" aria-controls="chart-aspect-color-editor" aria-expanded="false">
          <span aria-hidden="true">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || String(aspect.angle))}</span>
        </button>
        <span class="chart-aspect-orb-name">${escapeHtml(I18n.label(aspect.label))}</span>
        <span class="chart-aspect-orb-angle">${aspect.angle}°</span>
        <label class="chart-aspect-orb-field">
          <span class="sr-only">${T("interface.orbe_de_value", { v6: escapeHtml(I18n.label(I18n.label(aspect.label))) })}</span>
          <input
            type="number"
            name="chart-aspect-orb"
            data-aspect-angle="${aspect.angle}"
            data-orb-value="${orb}"
            value="${orb}"
            min="${CHART_ASPECT_ORB_MIN}"
            max="${CHART_ASPECT_ORB_MAX}"
            step="${CHART_ASPECT_ORB_STEP}"
            inputmode="decimal"
            aria-describedby="${Number(aspect.angle) === 0 ? "chart-aspect-orb-help chart-conjunction-cusp-rule-text" : "chart-aspect-orb-help"}"
          >
          <span aria-hidden="true">°</span>
        </label>
      </div>
    `;}).join(""));



  syncChartAspectOrbControls();
}

function renderChartPlanetVisibilityOptions() {
  if (!chartPlanetVisibilityList || !chartAspectVisibilityList) return;
  I18n.bind(chartPlanetVisibilityList, "innerHTML", ((__i18nSnapshot0, __i18nSnapshot1) => () => [...CHART_SELECTABLE_PLANETS, "tierra"].map((planetKey) => {const label = PROMPT_PLANET_LABELS[planetKey] || planetKey;const color = chartPlanetColorCssValue(planetKey, "var(--accent)");const currentColor = chartPlanetColorForKey(planetKey).toUpperCase();const symbolClass = CHART_ANGLE_POINT_KEYS.includes(planetKey) ? " chart-planet-visibility-symbol-text" : "";const visibilityControls = planetKey === "tierra" ? `<span class="chart-planet-visibility-fixed">${T("interface.siempre_visible")}</span>` : `
        <label class="chart-planet-visibility-check">
          <span>${T("interface.mapa")}</span>
          <input type="checkbox" name="chart-visible-planet" value="${escapeHtml(planetKey)}"${__i18nSnapshot0.has(planetKey) ? " checked" : ""}>
        </label>
        <label class="chart-planet-visibility-check chart-planet-aspect-check">
          <span>${T("interface.aspectos")}</span>
          <input type="checkbox" name="chart-aspect-planet" value="${escapeHtml(planetKey)}"${__i18nSnapshot1.has(planetKey) && __i18nSnapshot0.has(planetKey) ? " checked" : ""}${__i18nSnapshot0.has(planetKey) ? "" : " disabled"}>
        </label>
      `;return `
      <div class="chart-planet-visibility-option" data-chart-planet-color-row style="--planet-option-color:${color}">
        <button class="chart-aspect-color-trigger chart-planet-visibility-symbol${symbolClass}" type="button" data-planet-color-trigger="${escapeHtml(planetKey)}" aria-controls="chart-planet-color-editor" aria-expanded="false" aria-label="${T("interface.cambiar_el_color_de_value_color_actual_value", { v3: escapeHtml(I18n.label(I18n.label(label))), v4: currentColor })}" style="--aspect-option-color:${color}">
          <span aria-hidden="true">${escapeHtml(planetGlyph(planetKey))}</span>
        </button>
        <span class="chart-planet-visibility-label">${escapeHtml(I18n.label(label))}</span>
        ${visibilityControls}
      </div>
    `;}).join(""))(chartVisiblePlanetKeys, chartAspectPlanetKeys));











  syncChartPlanetColorControls();
  I18n.bind(chartAspectVisibilityList, "innerHTML", ((__i18nSnapshot0) => () => ["principal", "menor"].map((group) => {const items = ASPECT_CONFIGS.filter((aspect) => aspect.group === group);const groupLabel = group === "principal" ? T("interface.principales") : T("interface.menores");const groupDescription = group === "principal" ? T("interface.estructuras_fundamentales_de_la_carta") : T("interface.matices_y_dinamicas_mas_especificas");return `
      <fieldset class="chart-aspect-visibility-group">
        <legend>
          <strong>${groupLabel}</strong>
          <small>${groupDescription}</small>
        </legend>
        <div class="chart-aspect-visibility-grid">
          ${items.map((aspect) => `
            <div class="chart-aspect-visibility-option" data-chart-aspect-color-row style="--aspect-option-color:${chartAspectColorCssValue(aspect.angle)}">
              <input id="chart-visible-aspect-${aspect.angle}" type="checkbox" name="chart-visible-aspect" value="${aspect.angle}"${__i18nSnapshot0.has(aspect.angle) ? " checked" : ""}>
              <button class="chart-aspect-color-trigger chart-aspect-visibility-symbol" type="button" data-aspect-color-trigger="${aspect.angle}" aria-controls="chart-aspect-color-editor" aria-expanded="false">
                <span aria-hidden="true">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || String(aspect.angle))}</span>
              </button>
              <label class="chart-aspect-visibility-copy" for="chart-visible-aspect-${aspect.angle}">
                <strong>${escapeHtml(I18n.label(aspect.label))}</strong>
                <small>${aspect.angle}°</small>
              </label>
            </div>
          `).join("")}
        </div>
      </fieldset>
    `;}).join(""))(chartVisibleAspectAngles));







  renderChartAspectOrbOptions();
  syncChartAspectColorControls();
  if (chartHouseSystemSelect) chartHouseSystemSelect.value = chartHouseSystemKey;
  renderChartHouseSystemPreview(chartHouseSystemKey);
  updateChartPlanetVisibilityStatus();
}

function renderChartHouseSystemPreview(houseSystemKey = chartHouseSystemKey) {
  if (!chartHouseSystemPreview) return;
  const system = CHART_HOUSE_SYSTEMS[houseSystemKey] || CHART_HOUSE_SYSTEMS[DEFAULT_CHART_HOUSE_SYSTEM];
  I18n.bind(chartHouseSystemPreview, "innerHTML", () => `
    <span aria-hidden="true">${houseSystemKey === "none" ? "—" : "12"}</span>
    <div>
      <strong>${escapeHtml(I18n.label((Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[houseSystemKey] || Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[DEFAULT_CHART_HOUSE_SYSTEM]).label))}</strong>
      <p>${escapeHtml((Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[houseSystemKey] || Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[DEFAULT_CHART_HOUSE_SYSTEM]).description)}</p>
    </div>
  `);
}

function updateChartPlanetVisibilityStatus() {
  if (!chartPlanetVisibilityList || !chartAspectVisibilityList || !chartPlanetVisibilityStatus) return;
  const inputs = Array.from(chartPlanetVisibilityList.querySelectorAll("input[name='chart-visible-planet']"));
  const selectedCount = inputs.filter((input) => input.checked).length;
  const aspectInputs = Array.from(chartPlanetVisibilityList.querySelectorAll("input[name='chart-aspect-planet']"));
  const aspectCount = aspectInputs.filter((input) => input.checked && !input.disabled).length;
  const selectedAspectTypeCount = chartAspectVisibilityList.querySelectorAll("input[name='chart-visible-aspect']:checked").length;
  const orbDrafts = chartAspectOrbDraftMap();
  const customOrbCount = ASPECT_CONFIGS.filter((aspect) =>
  Number(orbDrafts.get(Number(aspect.angle))) !== Number(CHART_DEFAULT_ASPECT_ORBS[aspect.angle])
  ).length;
  const customColorCount = ASPECT_CONFIGS.filter((aspect) =>
  chartAspectColorForAngle(aspect.angle) !== CHART_DEFAULT_ASPECT_COLORS[aspect.angle]
  ).length;
  chartPlanetVisibilityStatus.classList.remove("error");
  const selectedHouseSystem = CHART_HOUSE_SYSTEMS[chartHouseSystemSelect?.value] || CHART_HOUSE_SYSTEMS[chartHouseSystemKey];
  I18n.bind(chartPlanetVisibilityStatus, "textContent", ((__i18nSnapshot0) => () => T("interface.value_de_value_cuerpos_visibles_value_con_aspectos_value_tipos_de_aspectovaluevalue_v", { v0: selectedCount, v1: CHART_SELECTABLE_PLANETS.length, v2: aspectCount, v3: selectedAspectTypeCount, get v4() {return customOrbCount ? ` · ${customOrbCount} ${customOrbCount === 1 ? T("interface.orbe_personalizado") : T("interface.orbes_personalizados_2")}` : "";}, get v5() {return customColorCount ? ` · ${customColorCount} ${customColorCount === 1 ? T("interface.color_personalizado_2") : T("interface.colores_personalizados")}` : "";}, v6: I18n.label((Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[chartHouseSystemSelect?.value] || Object.freeze({ get placidus() {return { get label() {return T("interface.placidus");}, get description() {return T("interface.division_temporal_tradicional_y_sistema_predeterminado");} };}, get koch() {return { get label() {return T("interface.koch");}, get description() {return T("interface.sistema_temporal_basado_en_el_movimiento_diurno");} };}, get alcabitius() {return { get label() {return T("interface.alcabitius");}, get description() {return T("interface.sistema_historico_que_divide_los_semiarcos_diurnos");} };}, get topocentric() {return { get label() {return T("interface.topocentrico");}, get description() {return T("interface.metodo_topocentrico_de_polich_y_page");} };}, get porphyry() {return { get label() {return T("interface.porphyrius");}, get description() {return T("interface.divide_cada_cuadrante_del_mapa_en_tres_partes_iguales");} };}, get regiomontanus() {return { get label() {return T("interface.regiomontanus");}, get description() {return T("interface.division_espacial_basada_en_el_ecuador_celeste");} };}, get campanus() {return { get label() {return T("interface.campanus");}, get description() {return T("interface.division_espacial_basada_en_el_primer_vertical");} };}, get polarEquatorial() {return { get label() {return T("interface.poli_ecuatorial");}, get description() {return T("interface.sistema_poli_ecuatorial_desarrollado_por_carter");} };}, get equal() {return { get label() {return T("interface.casas_iguales");}, get description() {return T("interface.doce_casas_exactas_de_30_a_partir_del_ascendente");} };}, get wholeSignAries() {return { get label() {return T("interface.signos_enteros_aries");}, get description() {return T("interface.aries_comienza_la_casa_i_y_cada_signo_completo_ocupa_una_casa");} };}, get wholeSignAscendant() {return { get label() {return T("interface.signos_enteros_ac");}, get description() {return T("interface.el_signo_que_contiene_el_ascendente_ocupa_integramente_la_casa_i");} };}, get vehlow() {return { get label() {return T("interface.vehlow");}, get description() {return T("interface.casas_iguales_con_el_ascendente_situado_en_el_centro_de_la_casa_i");} };}, get morinus() {return { get label() {return T("interface.morinus");}, get description() {return T("interface.proyecta_sobre_la_ecliptica_divisiones_iguales_del_ecuador_celeste");} };}, get none() {return { get label() {return T("interface.sin_casas");}, get description() {return T("interface.oculta_cuspides_numeros_de_casa_y_ejes_angulares_del_mapa");} };} })[__i18nSnapshot0]).label) }))(chartHouseSystemKey));
  if (chartPlanetVisibilityClearAllButton) {
    chartPlanetVisibilityClearAllButton.disabled = selectedCount === 0;
  }
  if (chartAspectRestoreDefaultsButton) {
    const currentAngles = Array.from(chartAspectVisibilityList.querySelectorAll("input[name='chart-visible-aspect']:checked")).
    map((input) => Number(input.value));
    chartAspectRestoreDefaultsButton.disabled = currentAngles.length === CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.length &&
    CHART_DEFAULT_VISIBLE_ASPECT_ANGLES.every((angle) => currentAngles.includes(angle));
  }
}

function setChartSettingsTab(tabName = "bodies") {
  if (!chartPlanetVisibilityDialog) return;
  activeChartSettingsTab = ["bodies", "aspects", "houses"].includes(tabName) ? tabName : "bodies";
  chartPlanetVisibilityDialog.querySelectorAll("[data-chart-settings-tab]").forEach((button) => {
    const active = button.dataset.chartSettingsTab === activeChartSettingsTab;
    button.setAttribute("aria-selected", active ? "true" : "false");
    button.tabIndex = active ? 0 : -1;
  });
  chartPlanetVisibilityDialog.querySelectorAll("[data-chart-settings-panel]").forEach((panel) => {
    panel.hidden = panel.dataset.chartSettingsPanel !== activeChartSettingsTab;
  });
  chartPlanetVisibilityDialog.querySelector(".chart-map-settings-scroll")?.scrollTo({ top: 0 });
}

function openChartPlanetVisibilityDialog() {
  if (!chartPlanetVisibilityDialog) return;
  const calculatedHouseSystemKey = chartCalculation?.charts?.tropical?.houseSystem?.key;
  if (CHART_HOUSE_SYSTEMS[calculatedHouseSystemKey] && calculatedHouseSystemKey !== chartHouseSystemKey) {
    chartHouseSystemKey = calculatedHouseSystemKey;
    persistChartHouseSystemKey();
  }
  chartPlanetColorsBeforeDialog = new Map(chartPlanetColors);
  chartAspectColorsBeforeDialog = new Map(chartAspectColors);
  renderChartPlanetVisibilityOptions();
  setChartSettingsTab(activeChartSettingsTab);
  if (!chartPlanetVisibilityDialog.open) chartPlanetVisibilityDialog.showModal();
  window.requestAnimationFrame(() => {
    chartPlanetVisibilityDialog.querySelector(".icon-close")?.focus({ preventScroll: true });
  });
}

function closeChartPlanetVisibilityDialog() {
  if (chartPlanetVisibilityDialog?.open) chartPlanetVisibilityDialog.close();
}

function chartWorkspace(mainHtml, panels = [], options = {}) {
  const panelHtml = panels.filter(Boolean).join("");
  const launcherHtml = Array.from(panelHtml.matchAll(/<button class="floating-panel-launcher[\s\S]*?<\/button>/g)).
  map((match) => match[0]).
  join("");
  const floatingPanelHtml = panelHtml.replace(/<button class="floating-panel-launcher[\s\S]*?<\/button>/g, "");
  const launcherBlock = launcherHtml ? `<div class="floating-launchers">${launcherHtml}</div>` : "";
  const workspaceClass = [
  "chart-wheel-workspace",
  launcherHtml ? "" : "chart-wheel-workspace-clean",
  options.multiple ? "chart-wheel-workspace-multiple" : "",
  options.custom ? "chart-wheel-workspace-custom" : ""].
  filter(Boolean).join(" ");

  return `
    <div class="${workspaceClass}">
      ${launcherBlock}
      <div class="chart-wheel-main">${mainHtml}</div>
      ${floatingPanelHtml}
    </div>
  `;
}

function chartPanelPrefix(title, chart, options = {}) {
  return slugId(options.panelPrefix || chart?.type || title || "chart");
}

function slugId(value) {
  return String(value || "chart").
  toLowerCase().
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  replace(/[^a-z0-9]+/g, "-").
  replace(/^-+|-+$/g, "") || "chart";
}

function chartPatternSources(chart, options = {}) {
  if (!chart || options.disableAspectPatterns === true) return [];
  if (chart.type === "nodal" || isSideralAspectChart(chart)) return [];
  const detailMode = String(options.detailMode || "").toLowerCase();
  const temporalOverlay = ["transits", "progressed"].includes(detailMode);
  if (detailMode === "synastry" || options.overlay && !temporalOverlay && detailMode !== "solarreturn") return [];
  const sources = [{ chart, layer: "base", get label() {return temporalOverlay ? T("interface.natal") : "";} }];
  if (temporalOverlay && options.overlay) {
    sources.push({
      chart: options.overlay,
      layer: "overlay", get
      label() {return detailMode === "progressed" ? T("interface.progresada") : T("interface.transitos");}
    });
  }
  return sources.filter((source) => PROMPT_PRIMARY_PLANET_ORDER.every((key) => {
    const longitude = chartAspectPlanet(source.chart, key)?.longitude;
    if (longitude === null || longitude === undefined) return false;
    if (typeof longitude === "string" && !longitude.trim()) return false;
    return Number.isFinite(Number(longitude));
  }));
}

function chartSupportsAspectPatterns(chart, options = {}) {
  return chartPatternSources(chart, options).length > 0;
}

function chartAspectPatterns(chart, options = {}) {
  const detector = globalThis.AstroAspectPatterns?.detectAspectPatterns;
  if (typeof detector !== "function") return [];
  const orbs = Object.fromEntries([60, 90, 120, 150, 180].map((angle) => [
  angle,
  chartAspectOrbForAngle(angle)]
  ));

  try {
    return chartPatternSources(chart, options).flatMap((source) => {
      const planets = PROMPT_PRIMARY_PLANET_ORDER.map((key) => ({
        key,
        longitude: Number(chartAspectPlanet(source.chart, key)?.longitude)
      }));
      return detector(planets, { orbs, suppressContained: true }).map((pattern) => ({
        ...pattern,
        id: source.layer === "base" ? pattern.id : `${source.layer}:${pattern.id}`,
        layer: source.layer,
        sourceLabel: source.label,
        sourceChart: source.chart
      }));
    });
  } catch (error) {
    console.warn("No se pudieron detectar las figuras de aspectos.", error);
    return [];
  }
}

function chartTechnicalLinksWithPatterns(chart, options = {}) {
  const links = (options.technicalLinks || [
  ["longitud", "Longitud"],
  ["cuspides", "Cúspides Casas"],
  ["aspectos", "Aspectos"],
  ["modos", "Modos"],
  ["elementos", "Elementos"],
  ["distribucion", "Distribución"]]).
  map((link) => [...link]);
  const patterns = chartAspectPatterns(chart, options);
  if (!patterns.length) return links.filter(([key]) => key !== "figuras");
  const label = T("interface.figuras_value", { v0: patterns.length });
  const existingIndex = links.findIndex(([key]) => key === "figuras");
  if (existingIndex >= 0) {
    links[existingIndex][1] = label;
    return links;
  }

  const aspectIndex = links.findIndex(([key]) => key === "aspectos");
  links.splice(aspectIndex >= 0 ? aspectIndex + 1 : links.length, 0, ["figuras", label]);
  return links;
}

function chartPatternPrimaryTechnicalKeys(primaryKeys, chart, options = {}) {
  return Array.isArray(primaryKeys) && primaryKeys.length ?
  [...primaryKeys] :
  ["longitud", "cuspides", "aspectos"];
}

function chartPatternSummary(chart, panelPrefix, options = {}) {
  const patternOptions = { ...options, panelPrefix };
  const patterns = chartAspectPatterns(chart, patternOptions);
  if (!patterns.length) return "";
  const label = patterns.length === 1 ? patterns[0].label : T("interface.value_figuras", { v0: patterns.length });
  return `
    <button
      class="chart-pattern-summary"
      type="button"
      data-panel-action="toggle"
      data-panel-id="${escapeHtml(panelPrefix)}-figuras"
      aria-label="${patterns.length === 1 ? `Ver figura detectada: ${escapeHtml(label)}` : `Ver ${patterns.length} figuras detectadas`}"
      aria-controls="${escapeHtml(panelPrefix)}-figuras"
      aria-expanded="false"
      aria-pressed="false"
      title="${escapeHtml(I18n.label(patterns.map((pattern) => [pattern.sourceLabel, pattern.label].filter(Boolean).join(": ")).join(" · ")))}"
    >
      <span class="chart-pattern-summary-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 3 20 17H4L12 3Z"></path>
          <circle cx="12" cy="3" r="1.5"></circle>
          <circle cx="20" cy="17" r="1.5"></circle>
          <circle cx="4" cy="17" r="1.5"></circle>
        </svg>
      </span>
      <span>${T("interface.figuras")}</span>
      <span class="chart-pattern-summary-count" aria-hidden="true">${patterns.length}</span>
    </button>
  `;
}

function chartTechnicalLinks(panelPrefix, customLinks, technicalActionHtml = "", linkOptions = {}) {
  const links = customLinks || [
  ["longitud", "Longitud"],
  ["cuspides", "Cúspides Casas"],
  ["aspectos", "Aspectos"],
  ["modos", "Modos"],
  ["elementos", "Elementos"],
  ["distribucion", "Distribución"]];

  const renderLinks = (items) => items.map(([key, label]) => `
    <button class="chart-tool-link" type="button" data-panel-action="show" data-panel-id="${escapeHtml(panelPrefix)}-${key}">
      ${escapeHtml(I18n.label(label))}
    </button>
  `).join("");

  if (linkOptions.groupSecondary) {
    const primaryKeys = new Set(
      Array.isArray(linkOptions.primaryKeys) && linkOptions.primaryKeys.length ?
      linkOptions.primaryKeys :
      ["longitud", "cuspides", "aspectos"]
    );
    const primaryLinks = links.filter(([key]) => primaryKeys.has(key));
    const secondaryLinks = links.filter(([key]) => !primaryKeys.has(key));
    const secondaryHtml = `${renderLinks(secondaryLinks)}${technicalActionHtml || ""}`;

    return `
      <nav class="chart-tools" aria-label="${T("interface.tablas_tecnicas_principales")}">
        ${linkOptions.leadingHtml || ""}
        ${renderLinks(primaryLinks)}
      </nav>
      ${secondaryHtml ? `
        <details class="chart-technical-more-menu">
          <summary class="chart-technical-more-button" aria-label="${T("interface.mas_tablas")}" title="${T("interface.mas_tablas")}">
            <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
              <path d="M8 6h12"></path>
              <path d="M8 12h12"></path>
              <path d="M8 18h12"></path>
              <circle cx="4" cy="6" r="1"></circle>
              <circle cx="4" cy="12" r="1"></circle>
              <circle cx="4" cy="18" r="1"></circle>
            </svg>
          </summary>
          <div class="chart-technical-more-popover" role="group" aria-label="${T("interface.tablas_adicionales")}">
            ${secondaryHtml}
          </div>
        </details>
      ` : ""}
    `;
  }

  return `
    <nav class="chart-tools" aria-label="${T("interface.tablas_tecnicas")}">
      ${linkOptions.leadingHtml || ""}
      ${renderLinks(links)}
      ${technicalActionHtml || ""}
    </nav>
  `;
}

const chartToolsResizeObserver = typeof ResizeObserver === "function" ?
new ResizeObserver((entries) => {
  entries.forEach(({ target }) => {
    if (target.isConnected) syncChartToolsScrollHint(target);
  });
}) :
null;

function syncChartToolsScrollHint(tools) {
  if (!tools) return;
  const parent = tools.parentElement;
  if (!parent) return;

  parent.querySelectorAll(
    ".chart-tools-scroll-hint:not(.chart-tools-scroll-hint-prev):not(.chart-tools-scroll-hint-next)"
  ).forEach((hint) => hint.remove());

  const ensureHint = (direction) => {
    let hint = parent.querySelector(`.chart-tools-scroll-hint-${direction}`);
    if (hint) return hint;

    const isPrevious = direction === "prev";
    hint = document.createElement("button");
    hint.type = "button";
    hint.className = `chart-tools-scroll-hint chart-tools-scroll-hint-${direction}`;
    I18n.bind(hint, "@aria-label", () => isPrevious ? T("interface.mostrar_tablas_anteriores") : T("interface.mostrar_mas_tablas"));
    I18n.bind(hint, "@title", () => isPrevious ? T("interface.mostrar_tablas_anteriores") : T("interface.mostrar_mas_tablas"));
    hint.addEventListener("click", () => {
      const maxScroll = Math.max(0, tools.scrollWidth - tools.clientWidth);
      const step = Math.max(100, Math.round(tools.clientWidth * 0.68));
      tools.scrollTo({
        left: Math.max(0, Math.min(maxScroll, tools.scrollLeft + (isPrevious ? -step : step))),
        behavior: "smooth"
      });
    });
    tools.insertAdjacentElement(isPrevious ? "beforebegin" : "afterend", hint);
    return hint;
  };

  const previousHint = ensureHint("prev");
  const nextHint = ensureHint("next");
  // Reserve both arrows while links overflow, also in multiple-chart views.
  // Temporarily removing them to measure the toolbar clamps scrollLeft and
  // makes the final link unreachable when their width is restored.
  const gap = Number.parseFloat(window.getComputedStyle(parent).columnGap) || 0;
  const reservedWidth = [previousHint, nextHint].reduce((total, hint) => {
    const width = hint.getBoundingClientRect().width;
    return total + (width > 0 ? width + gap : 0);
  }, 0);
  const hasOverflow = tools.scrollWidth > tools.clientWidth + reservedWidth + 4;
  previousHint.classList.toggle("is-visible", hasOverflow);
  nextHint.classList.toggle("is-visible", hasOverflow);
  const maxScroll = Math.max(0, tools.scrollWidth - tools.clientWidth);
  previousHint.disabled = !hasOverflow || tools.scrollLeft <= 4;
  nextHint.disabled = !hasOverflow || tools.scrollLeft >= maxScroll - 4;
  tools.classList.toggle("has-scroll-overflow", hasOverflow);
  tools.classList.toggle("has-scroll-right", hasOverflow && !nextHint.disabled);
}

function initChartToolsScrollHints(root = chartWheelStage) {
  if (!root) return;
  chartToolsResizeObserver?.disconnect();
  root.querySelectorAll(".chart-tools").forEach((tools) => {
    if (tools.dataset.scrollHintReady !== "true") {
      tools.dataset.scrollHintReady = "true";
      tools.addEventListener("scroll", () => syncChartToolsScrollHint(tools), { passive: true });
    }
    chartToolsResizeObserver?.observe(tools);
    window.requestAnimationFrame(() => syncChartToolsScrollHint(tools));
  });
}

let chartViewportFitFrame = 0;
const chartViewportFitResizeObserver = typeof ResizeObserver === "function" ?
new ResizeObserver(() => scheduleChartViewportFit()) :
null;

function scheduleChartViewportFit() {
  if (chartViewportFitFrame) window.cancelAnimationFrame(chartViewportFitFrame);
  chartViewportFitFrame = window.requestAnimationFrame(() => {
    chartViewportFitFrame = 0;
    syncChartViewportFit();
  });
}

function clearChartViewportFit(stage = chartWheelStage, retainedWorkspace = null) {
  if (!stage) return;
  stage.classList.remove("has-adaptive-chart-fit", "requires-chart-fit-scroll", "is-stacked-chart-fit");
  stage.querySelectorAll(".chart-wheel-workspace-multiple").forEach((workspace) => {
    if (workspace === retainedWorkspace) return;
    workspace.classList.remove("is-stacked-chart-fit", "has-adaptive-multiple-fit");
    workspace.style.removeProperty("--chart-fullscreen-multiple-card-width");
  });
  stage.style.removeProperty("--chart-viewport-fit-size");
  stage.style.removeProperty("--chart-multiple-top-offset");
  stage.style.removeProperty("--chart-multiple-lower-top");
  stage.style.removeProperty("--chart-multiple-canvas-height");
}

function multipleChartCompositionNeedsStack({ canvasWidth, cardSize, topOffset, lowerTop, sideInset }) {
  if (![canvasWidth, cardSize, topOffset, lowerTop, sideInset].every(Number.isFinite) || cardSize <= 0) return true;
  const requiredGap = Math.max(28, cardSize * 0.05);
  const topWheel = {
    x: canvasWidth / 2,
    y: topOffset + cardSize / 2
  };
  const leftWheel = {
    x: sideInset + cardSize / 2,
    y: lowerTop + cardSize / 2
  };
  const rightWheel = {
    x: canvasWidth - sideInset - cardSize / 2,
    y: lowerTop + cardSize / 2
  };
  const hasEnoughSeparation = (first, second) =>
  Math.hypot(first.x - second.x, first.y - second.y) >= cardSize + requiredGap;

  return !hasEnoughSeparation(topWheel, leftWheel) ||
  !hasEnoughSeparation(topWheel, rightWheel) ||
  !hasEnoughSeparation(leftWheel, rightWheel);
}

function fitMultipleChartTriangleSize(options) {
  const preferredSize = Math.max(0, Number(options?.cardSize) || 0);
  if (!preferredSize || !multipleChartCompositionNeedsStack(options)) return preferredSize;

  const fitsAtSize = (cardSize) => !multipleChartCompositionNeedsStack({ ...options, cardSize });
  if (!fitsAtSize(1)) return 0;

  let lower = 1;
  let upper = preferredSize;
  for (let index = 0; index < 18; index += 1) {
    const middle = (lower + upper) / 2;
    if (fitsAtSize(middle)) lower = middle;else
    upper = middle;
  }
  return Math.max(0, Math.floor(lower));
}

function syncChartViewportFit(stage = chartWheelStage) {
  if (!stage) return;
  if (stage.classList.contains("is-custom-chart") || stage.classList.contains("is-solar-comparison")) {
    clearChartViewportFit(stage);
    syncCustomChartViewportFit(stage);
    return;
  }
  const fullscreenSurface = activeChartFullscreenSurface();
  if (fullscreenSurface?.querySelector(".chart-wheel-card-temporal-overlay, .chart-wheel-card-solar-return")) {
    clearChartViewportFit(stage);
    syncOverlayFullscreenChartFit(fullscreenSurface);
    return;
  }
  const fullscreenMultipleWorkspace = stage.classList.contains("is-multiple-chart") &&
  fullscreenSurface?.matches?.(".chart-wheel-workspace-multiple") ?
  fullscreenSurface :
  null;
  if (fullscreenMultipleWorkspace) {
    const usesTriangularLayout = window.matchMedia?.("(min-width: 861px) and (orientation: landscape)").matches;
    if (!usesTriangularLayout) {
      clearChartViewportFit(stage);
      return;
    }
    // Keep the current fullscreen layout while measuring. Removing it first
    // changes the observed headers and can restart the resize cycle itself.
    clearChartViewportFit(stage, fullscreenMultipleWorkspace);
    const workspaceStyle = window.getComputedStyle(fullscreenMultipleWorkspace);
    const readPixel = (property) => Number.parseFloat(workspaceStyle.getPropertyValue(property)) || 0;
    const availableWidth = Math.max(0, fullscreenMultipleWorkspace.clientWidth - readPixel("padding-left") - readPixel("padding-right"));
    const availableHeight = Math.max(0, fullscreenMultipleWorkspace.clientHeight - readPixel("padding-top") - readPixel("padding-bottom"));
    const cardSize = Math.min(900, Math.max(280, Math.min(availableWidth * 0.35, availableHeight * 0.62)));
    const canvasWidth = Math.max(availableWidth, cardSize * 2 + 28);
    const topOffset = 44;
    const lowerTop = Math.min(345, Math.max(150, availableHeight * 0.31));
    const sideInset = Math.min(72, Math.max(24, availableWidth * 0.028));
    const triangleOptions = {
      canvasWidth,
      cardSize,
      topOffset,
      lowerTop,
      sideInset
    };
    const needsCompactFit = multipleChartCompositionNeedsStack(triangleOptions);
    const compactCardSize = fitMultipleChartTriangleSize(triangleOptions);
    const canKeepTriangle = !needsCompactFit || compactCardSize >= 480;
    fullscreenMultipleWorkspace.classList.toggle("is-stacked-chart-fit", !canKeepTriangle);
    fullscreenMultipleWorkspace.classList.toggle("has-adaptive-multiple-fit", canKeepTriangle);
    if (canKeepTriangle) {
      fullscreenMultipleWorkspace.style.setProperty(
        "--chart-fullscreen-multiple-card-width",
        `${Math.min(cardSize, compactCardSize)}px`
      );
    } else {
      fullscreenMultipleWorkspace.style.removeProperty("--chart-fullscreen-multiple-card-width");
    }
    return;
  }
  const isEligible = Boolean(
    window.matchMedia?.("(min-width: 861px)").matches && (
    stage.closest(".private-screen.private-maps-active.sidebar-collapsed") ||
    stage.classList.contains("is-multiple-chart") &&
    stage.closest(".guest-maps-screen.private-maps-active")) && (
    stage.classList.contains("is-full-chart") || stage.classList.contains("is-multiple-chart")) &&
    !activeChartFullscreenSurface()
  );
  if (!isEligible) {
    clearChartViewportFit(stage);
    return;
  }

  const pixelValue = (style, property) => {
    const value = Number.parseFloat(style.getPropertyValue(property));
    return Number.isFinite(value) ? value : 0;
  };
  const applyFitSize = (fittedSize, minimumReadableSize) => {
    const chartSize = Math.max(minimumReadableSize, Math.floor(fittedSize));
    if (!Number.isFinite(chartSize) || chartSize <= 0) {
      clearChartViewportFit(stage);
      return false;
    }
    stage.classList.add("has-adaptive-chart-fit");
    stage.style.setProperty("--chart-viewport-fit-size", `${chartSize}px`);
    stage.classList.toggle("requires-chart-fit-scroll", fittedSize < minimumReadableSize);
    return true;
  };

  if (stage.classList.contains("is-multiple-chart")) {
    const usesTriangularLayout = window.matchMedia?.("(min-width: 861px) and (min-height: 601px) and (orientation: landscape)").matches;
    const workspace = stage.querySelector(".chart-wheel-workspace-multiple:not(:fullscreen):not(.is-chart-card-fallback-fullscreen)");
    const triple = workspace?.querySelector(".chart-wheel-triple");
    const topbar = triple?.querySelector(":scope > .chart-multiple-topbar");
    if (!usesTriangularLayout || !workspace || !triple || !topbar || stage.clientHeight <= 0) {
      clearChartViewportFit(stage);
      return;
    }

    const stageStyle = window.getComputedStyle(stage);
    const stageHorizontalInset = pixelValue(stageStyle, "padding-left") + pixelValue(stageStyle, "padding-right");
    const stageVerticalInset = pixelValue(stageStyle, "padding-top") + pixelValue(stageStyle, "padding-bottom");
    const availableWidth = Math.max(0, stage.clientWidth - stageHorizontalInset);
    const availableHeight = Math.max(0, stage.clientHeight - stageVerticalInset);
    const topOffset = Math.max(44, Math.ceil(topbar.getBoundingClientRect().height + 6));
    const horizontalFit = Math.max(0, (availableWidth - 28) / 2);
    const maximumSize = 900;
    const minimumReadableSize = Math.min(280, horizontalFit, maximumSize);
    let fittedSize = Math.min(horizontalFit, maximumSize, Math.max(0, (availableHeight - 30) / 1.22));
    let lowerTop = Math.max(topOffset + 10, Math.min(280, Math.max(132, fittedSize * 0.22)));
    if (lowerTop + fittedSize + 30 > availableHeight) {
      fittedSize = Math.max(0, availableHeight - lowerTop - 30);
      lowerTop = Math.max(topOffset + 10, Math.min(280, Math.max(132, fittedSize * 0.22)));
      fittedSize = Math.min(fittedSize, Math.max(0, availableHeight - lowerTop - 30));
    }
    const naturalLowerTop = lowerTop;
    const triangleOptions = {
      canvasWidth: Math.max(availableWidth, fittedSize * 2 + 28),
      cardSize: fittedSize,
      topOffset,
      lowerTop: naturalLowerTop,
      sideInset: Math.min(40, Math.max(8, window.innerWidth * 0.025))
    };
    const needsCompactFit = multipleChartCompositionNeedsStack(triangleOptions);
    const compactCardSize = fitMultipleChartTriangleSize(triangleOptions);
    const canKeepTriangle = !needsCompactFit || compactCardSize >= 480;
    if (canKeepTriangle) fittedSize = Math.min(fittedSize, compactCardSize);

    if (!applyFitSize(fittedSize, minimumReadableSize)) return;
    const appliedSize = Number.parseFloat(stage.style.getPropertyValue("--chart-viewport-fit-size")) || fittedSize;
    // Keep the vertical offset used to calculate the collision-safe size. If
    // it is reduced again with the fitted wheel, the diagonal gap disappears
    // and the same composition is incorrectly switched back to one column.
    lowerTop = naturalLowerTop;
    const canvasWidth = Math.max(availableWidth, appliedSize * 2 + 28);
    const sideInset = Math.min(40, Math.max(8, window.innerWidth * 0.025));
    stage.classList.toggle("is-stacked-chart-fit", !canKeepTriangle || multipleChartCompositionNeedsStack({
      canvasWidth,
      cardSize: appliedSize,
      topOffset,
      lowerTop,
      sideInset
    }));
    stage.style.setProperty("--chart-multiple-top-offset", `${topOffset}px`);
    stage.style.setProperty("--chart-multiple-lower-top", `${Math.round(lowerTop)}px`);
    stage.style.setProperty("--chart-multiple-canvas-height", `${Math.ceil(Math.max(availableHeight, lowerTop + appliedSize + 30))}px`);
    return;
  }

  const workspace = stage.querySelector(".chart-wheel-workspace:not(.chart-wheel-workspace-multiple)");
  const card = workspace?.querySelector(".chart-wheel-card:not(.chart-wheel-card-triple)");
  const header = card?.querySelector(":scope > .chart-card-header");
  if (stage.classList.contains("is-nodal-chart")) {
    const layout = card?.querySelector(".nodal-schema-layout");
    const stack = layout?.querySelector(".nodal-wheel-stack");
    if (!workspace || !card || !header || !layout || !stack || stage.clientHeight <= 0) {
      clearChartViewportFit(stage);
      return;
    }

    const cardStyle = window.getComputedStyle(card);
    const layoutStyle = window.getComputedStyle(layout);
    const stackStyle = window.getComputedStyle(stack);
    const cardVerticalInset = pixelValue(cardStyle, "padding-top") +
    pixelValue(cardStyle, "padding-bottom") +
    pixelValue(cardStyle, "border-top-width") +
    pixelValue(cardStyle, "border-bottom-width");
    const cardHorizontalInset = pixelValue(cardStyle, "padding-left") + pixelValue(cardStyle, "padding-right");
    const cardGap = pixelValue(cardStyle, "row-gap") || pixelValue(cardStyle, "gap");
    const layoutVerticalInset = pixelValue(layoutStyle, "padding-top") + pixelValue(layoutStyle, "padding-bottom");
    const layoutHorizontalInset = pixelValue(layoutStyle, "padding-left") + pixelValue(layoutStyle, "padding-right");
    const stackVerticalMargin = pixelValue(stackStyle, "margin-top") + pixelValue(stackStyle, "margin-bottom");
    const availableWidth = Math.max(0, card.clientWidth - cardHorizontalInset - layoutHorizontalInset);
    const availableHeight = Math.max(0, stage.clientHeight -
    header.getBoundingClientRect().height -
    cardVerticalInset -
    cardGap -
    layoutVerticalInset -
    stackVerticalMargin);
    const maximumSize = 1160;
    const minimumReadableSize = Math.min(640, availableWidth, maximumSize);
    applyFitSize(Math.min(availableWidth, availableHeight, maximumSize), minimumReadableSize);
    return;
  }

  const wrap = card?.querySelector(".chart-svg-wrap-only");
  const svg = wrap?.querySelector(".chart-wheel-svg");
  if (!workspace || !card || !header || !wrap || !svg || stage.clientHeight <= 0) {
    clearChartViewportFit(stage);
    return;
  }

  // Adaptive mode changes the wrapper padding. Activate it before measuring
  // so the first render uses the same available space as subsequent resizes.
  stage.classList.add("has-adaptive-chart-fit");
  const cardStyle = window.getComputedStyle(card);
  const wrapStyle = window.getComputedStyle(wrap);
  const cardVerticalInset = pixelValue(cardStyle, "padding-top") +
  pixelValue(cardStyle, "padding-bottom") +
  pixelValue(cardStyle, "border-top-width") +
  pixelValue(cardStyle, "border-bottom-width");
  const cardGap = pixelValue(cardStyle, "row-gap") || pixelValue(cardStyle, "gap");
  const wrapVerticalInset = pixelValue(wrapStyle, "padding-top") + pixelValue(wrapStyle, "padding-bottom");
  const wrapHorizontalInset = pixelValue(wrapStyle, "padding-left") + pixelValue(wrapStyle, "padding-right");
  const availableWidth = Math.max(0, card.clientWidth - wrapHorizontalInset - pixelValue(cardStyle, "padding-left") - pixelValue(cardStyle, "padding-right"));
  const availableHeight = Math.max(0, stage.clientHeight - header.getBoundingClientRect().height - cardVerticalInset - cardGap - wrapVerticalInset);
  const maximumSize = stage.classList.contains("has-exterior-chart-labels") ? 1220 : 1160;
  const minimumReadableSize = Math.min(640, availableWidth, maximumSize);
  const fittedSize = Math.floor(Math.min(availableWidth, availableHeight, maximumSize));
  applyFitSize(fittedSize, minimumReadableSize);
}

function syncOverlayFullscreenChartFit(surface) {
  // Measure the fullscreen surface, not the smaller stage behind it. Header
  // wrapping and the real exterior-label reserves are part of the fit.
  if (!window.matchMedia?.("(min-width: 861px)").matches) return;
  const card = surface.matches(".chart-wheel-card") ? surface : surface.querySelector(".chart-wheel-card");
  const header = card?.querySelector(":scope > .chart-card-header");
  const wrap = card?.querySelector(".chart-svg-wrap-only");
  if (!card || !header || !wrap || surface.clientHeight <= 0) return;
  const pixels = (style, property) => Number.parseFloat(style.getPropertyValue(property)) || 0;
  const inset = (style, names) => names.reduce((sum, name) => sum + pixels(style, name), 0);
  const horizontal = ["padding-left", "padding-right"];
  const vertical = ["padding-top", "padding-bottom"];
  const surfaceStyle = window.getComputedStyle(surface);
  const cardStyle = window.getComputedStyle(card);
  const wrapStyle = window.getComputedStyle(wrap);
  const width = card.clientWidth - inset(cardStyle, horizontal) - inset(wrapStyle, horizontal);
  const height = surface.clientHeight - (surface === card ? 0 : inset(surfaceStyle, vertical)) -
  inset(cardStyle, vertical) - pixels(cardStyle, "border-top-width") - pixels(cardStyle, "border-bottom-width") -
  header.getBoundingClientRect().height - pixels(cardStyle, "row-gap") -
  inset(wrapStyle, vertical);
  const size = Math.floor(Math.min(width, 1220, Math.max(Math.min(width, 480), height)));
  if (Number.isFinite(size) && size > 0) surface.style.setProperty("--chart-fullscreen-wheel-size", `${size}px`);
}

function syncCustomChartViewportFit(stage = chartWheelStage) {
  const workspace = stage?.querySelector(".chart-wheel-workspace-custom");
  const layout = workspace?.querySelector(".chart-custom-layout");
  const grid = layout?.querySelector(".chart-custom-grid");
  const toolbar = layout?.querySelector(".chart-custom-toolbar");
  const cards = Array.from(grid?.querySelectorAll(":scope > .chart-wheel-card") || []);
  if (!workspace || !layout || !toolbar || !cards.length) return;
  const pixels = (style, property) => Number.parseFloat(style.getPropertyValue(property)) || 0;
  const insets = (style, axis) => axis.reduce((sum, property) => sum + pixels(style, property), 0);
  const vertical = ["padding-top", "padding-bottom", "border-top-width", "border-bottom-width"];
  const horizontal = ["padding-left", "padding-right", "border-left-width", "border-right-width"];
  const layoutStyle = window.getComputedStyle(layout);
  const workspaceStyle = window.getComputedStyle(workspace);
  const stageStyle = window.getComputedStyle(stage);
  const fullscreen = activeChartFullscreenSurface() === workspace;
  const availableHeight = (fullscreen ? workspace.clientHeight : stage.clientHeight - insets(stageStyle, vertical)) -
  insets(workspaceStyle, vertical) - insets(layoutStyle, vertical) -
  toolbar.getBoundingClientRect().height - pixels(layoutStyle, "row-gap");
  const stacked = cards.length > 1 && window.getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length === 1;
  const fitHeight = !stacked && window.matchMedia?.("(min-width: 861px)").matches;
  const sizes = cards.map((card) => {
    const style = window.getComputedStyle(card);
    const wrap = card.querySelector(".chart-svg-wrap");
    const header = card.querySelector(":scope > .chart-card-header");
    const wrapStyle = window.getComputedStyle(wrap);
    const width = card.clientWidth - insets(style, horizontal) - insets(wrapStyle, horizontal);
    const height = availableHeight - insets(style, vertical) - pixels(style, "row-gap") - (
    header?.getBoundingClientRect().height || 0) - insets(wrapStyle, vertical);
    // Match the individual views' readable minimum, allowing local scroll on
    // short screens instead of reducing a chart to a thumbnail.
    const minimum = Math.min(width, cards.length === 1 ? 640 : 480);
    return Math.min(width, 1160, fitHeight ? Math.max(minimum, height) : width);
  });
  const size = Math.floor(Math.min(...sizes));
  if (Number.isFinite(size) && size > 0) workspace.style.setProperty("--chart-custom-wheel-size", `${size}px`);
}

function initChartViewportFit(root = chartWheelStage) {
  chartViewportFitResizeObserver?.disconnect();
  if (!root) return;
  chartViewportFitResizeObserver?.observe(root);
  root.querySelectorAll(".chart-custom-toolbar, .chart-multiple-topbar, .chart-wheel-card:not(.chart-wheel-card-triple) > .chart-card-header, .chart-wheel-card-triple > .chart-card-header").
  forEach((element) => chartViewportFitResizeObserver?.observe(element));
  scheduleChartViewportFit();
}

function chartMobileSummary(title, subtitle) {
  if (!subtitle) return title;
  const [subject, ...details] = subtitle.split(" - ");
  return [subject, title, ...details].filter(Boolean).join(" · ");
}

function solarReturnDisplayMoment(solarReturn) {
  const utTime = solarReturn?.utTimeUsedBySwetest || "";
  const fallback = {
    date: solarReturn?.dateUsedBySwetest || "",
    label: [solarReturn?.dateUsedBySwetest, utTime ? `${utTime} UT` : ""].filter(Boolean).join(" ")
  };
  const instant = new Date(solarReturn?.returnUtc || "");
  const timeZone = solarReturn?.profile?.location?.tz;
  if (!timeZone || !Number.isFinite(instant.getTime())) return fallback;
  try {
    // Format the calculated instant in the return location, never in the
    // browser's zone or using the natal date/offset. Calculation inputs stay intact.
    const parts = Object.fromEntries(new Intl.DateTimeFormat("en-CA", {
      timeZone, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit"
    }).formatToParts(instant).map((part) => [part.type, part.value]));
    const date = `${parts.year}-${parts.month}-${parts.day}`;
    const localTime = `${parts.hour}:${parts.minute}:${parts.second}`;
    const utcDate = instant.toISOString().slice(0, 10);
    const utcTime = utTime || instant.toISOString().slice(11, 19);
    // Include the UT date too if the local civil day differs.
    const utcLabel = [date !== utcDate ? formatContextDate(utcDate) : "", `${utcTime} UT`].
    filter(Boolean).join(" · ");
    return { date, label: `${formatContextDate(date)} · ${localTime} | ${utcLabel}` };
  } catch (_error) {
    return fallback;
  }
}

function chartWheelSubtitle(chart, options = {}) {
  const personName = currentChartPersonName();

  if (options.detailMode === "transits") {
    const transitMoment = transitLocalMoment(transitCalculation).label;
    return T("interface.value_natal_tropical_transitosvalue", { v0: personName, v1: transitMoment ? ` ${transitMoment}` : "" });
  }

  if (options.detailMode === "progressed") {
    const targetMoment = progressedLocalMoment(progressedCalculation, { useControls: false }).label;
    const age = Number(progressedCalculation?.ageYears);
    const ageLabel = Number.isFinite(age) ? T("interface.value_anos_3", { v0: age.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }) :

    "";
    const details = [targetMoment, ageLabel].filter(Boolean).join(" · ");
    return T("interface.value_natal_tropical_progresion_secundariavalue", { v0: personName, v1: details ? ` · ${details}` : "" });
  }

  if (options.detailMode === "solarReturn") {
    const moment = solarReturnDisplayMoment(solarReturnCalculation);
    const returnWeekday = I18n.label(formatWeekdayFromDateText(moment.date));
    const returnDetails = [moment.label, returnWeekday].filter(Boolean).join(" · ");
    return T("interface.value_revolucion_solarvalue", { v0: personName, v1: returnDetails ? ` ${returnDetails}` : "" });
  }

  if (options.detailMode === "synastry") {
    const partnerName = options.overlayLabel || synastryCalculation?.profile?.name || T("interface.otra_persona");
    return T("interface.value_value_sinastria_tropical", { v0: personName, v1: partnerName });
  }

  if (options.detailMode === "composite") {
    const partnerName = options.partnerName || compositeCalculation?.partner?.profile?.name || T("interface.otra_persona");
    if (options.multiple) return `${personName} + ${partnerName}`;
    return T("interface.value_value_compuesta_por_puntos_medios", { v0: personName, v1: partnerName });
  }

  const birthWeekday = options.multiple ? "" : getLocalBirthWeekdayInfo(chartCalculation?.profile).label;
  return T("interface.value_ascendente_valuevalue", { v0: personName, get v1() {return chart.ascendant?.sign || T("interface.no_determinable");}, v2: birthWeekday ? ` · ${birthWeekday}` : "" });
}

function currentChartPersonName() {
  return birthProfile?.name || chartCalculation?.profile?.name || "Persona";
}

function renderChartSvg(chart, options = {}) {
  if (!chartHasVisibleHouses(chart)) options = { ...options, hideHouses: true };
  const interactivePlanets = options.interactivePlanets === true;
  const overlay = options.overlay;
  const simpleRings = Boolean(options.simpleRings);
  const hasExteriorOverlayLabels = Boolean(options.overlayOutwardDetails && overlay?.planets?.length && !options.compact);
  const showHouses = !options.hideHouses;
  const displayHouses = showHouses ? chartDisplayHouses(chart) : [];
  const svgSize = options.compact ? 538 : hasExteriorOverlayLabels ? 1120 : 1040;
  const viewportPadding = Math.max(0, Number(options.viewportPadding) || 0);
  const center = svgSize / 2;
  const chartZero = options.hideHouses ? 0 : chartCoordinateReference(chart);
  const outer = center - (hasExteriorOverlayLabels ? 132 : 112);
  const dodecatemoriaOuter = outer;
  const dodecatemoriaInner = simpleRings ? dodecatemoriaOuter : dodecatemoriaOuter - (options.compact ? 18 : 24);
  const decanateOuter = dodecatemoriaInner;
  const decanateInner = simpleRings ? decanateOuter : decanateOuter - (options.compact ? 26 : 34);
  const zodiacOuter = decanateInner;
  const zodiacInner = zodiacOuter - (simpleRings ? options.compact ? 76 : 90 : options.compact ? 50 : 66);
  const tickOuter = zodiacInner;
  const tickInner = tickOuter - (options.compact ? 24 : 34);
  const exteriorRingGap = options.compact ? 7 : 11;
  const exteriorRing = dodecatemoriaOuter + exteriorRingGap * 1.7;
  const houseLineOuter = exteriorRing + (options.compact ? 12 : 20);
  const houseRing = exteriorRing + (options.compact ? 18 : 30);
  const cuspLabelRadius = dodecatemoriaOuter + (options.compact ? 42 : 65);
  const planetRadius = tickInner - (options.compact ? 18 : 22);
  const overlayRadius = exteriorRing + (options.compact ? 18 : 30);
  const aspectRadius = Math.max(options.compact ? 58 : 78, planetRadius - (options.compact ? 64 : 86));
  const zodiacSegments = renderZodiacSegments(center, zodiacInner, zodiacOuter, chartZero);
  const decanateRing = simpleRings ? "" : renderDecanateRing(center, decanateInner, decanateOuter, chartZero, !options.compact);
  const dodecatemoriaRing = simpleRings ? "" : renderDodecatemoriaRing(center, dodecatemoriaInner, dodecatemoriaOuter, chartZero, !options.compact);
  const degreeTicks = Array.from({ length: 360 }, (_, degree) => {
    if (simpleRings && degree % 5 !== 0) return "";
    const isDecan = degree % 10 === 0;
    const isFive = degree % 5 === 0;
    const length = isDecan ? 12 : isFive ? 8 : 4;
    const pointA = chartPoint(center, center, tickOuter - length, degree, chartZero);
    const pointB = chartPoint(center, center, tickOuter, degree, chartZero);
    const className = isDecan ? "chart-degree-tick chart-degree-tick-major" : isFive ? "chart-degree-tick chart-degree-tick-mid" : "chart-degree-tick";
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="${className}"></line>`;
  }).join("");
  const signs = PROMPT_SIGNS.map((sign, index) => {
    const mid = index * 30 + 15;
    const point = chartPoint(center, center, (zodiacInner + zodiacOuter) / 2, mid, chartZero);
    return renderZodiacGlyph(point, ZODIAC_SYMBOLS[index], ZODIAC_COLORS[index], "chart-sign-symbol", ZODIAC_GLYPH_COLORS[index]);
  }).join("");
  const signLines = Array.from({ length: 12 }, (_, index) => {
    const pointA = chartPoint(center, center, zodiacInner, index * 30, chartZero);
    const pointB = chartPoint(center, center, simpleRings ? zodiacOuter : dodecatemoriaOuter, index * 30, chartZero);
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-sign-line"></line>`;
  }).join("");
  const houseLines = displayHouses.map((house) => {
    const isAngle = [1, 4, 7, 10].includes(Number(house.number));
    const anglePoint = isAngle ? CHART_ANGLE_POINT_BY_HOUSE.get(Number(house.number)) : null;
    const innerRadius = zodiacInner;
    const pointA = chartPoint(center, center, innerRadius, house.longitude, chartZero);
    const outerRadius = isAngle ? houseLineOuter : cuspLabelRadius - (options.compact ? 13 : 18);
    const pointB = chartPoint(center, center, outerRadius, house.longitude, chartZero);
    const visibilityClass = anglePoint ? chartPlanetVisibilityClass(anglePoint.key) : "";
    const visibilityAttribute = anglePoint ?
    ` data-chart-planet-key="${escapeHtml(anglePoint.key)}" data-chart-planet-id="${escapeHtml(chartPlanetInteractionId("base", anglePoint.key))}"` :
    "";
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="${isAngle ? "chart-house-line chart-house-line-angle" : "chart-house-line"}${visibilityClass}"${visibilityAttribute}></line>`;
  }).join("");
  const houseLabels = displayHouses.map((house, index, houses) => {
    const next = houses[(index + 1) % houses.length] || houses[0];
    const mid = chart.type === "memoria" ?
    midpointLongitudeReverse(house.longitude, next.longitude) :
    midpointLongitude(house.longitude, next.longitude);
    const labelChartZero = chart.type === "nodal" ? chartReferenceValue(chartZero) : chartZero;
    const point = chartPoint(center, center, houseRing, mid, labelChartZero);
    const label = chart.type === "nodal" ?
    romanHouse(13 - Number(next.number || 1)) :
    house.label || house.number;
    return `<text x="${point.x}" y="${point.y}" class="chart-house-label" text-anchor="middle" dominant-baseline="middle">${escapeHtml(I18n.label(label))}</text>`;
  }).join("");
  const shouldRenderAngleMarkers = showHouses && (
  !options.hideAngleMarkers || options.interactiveAngleMarkers === true);

  const configuredAngleMarkerRadius = Number(options.angleMarkerOuterRadius);
  const angleMarkerOuterRadius = Number.isFinite(configuredAngleMarkerRadius) ?
  configuredAngleMarkerRadius :
  houseRing + (options.compact ? 18 : 30);
  const angleMarkers = shouldRenderAngleMarkers ?
  renderAngleMarkers(chart, center, zodiacInner, angleMarkerOuterRadius, chartZero, displayHouses, options) :
  "";
  const aspects = renderAspectLines(chart, center, aspectRadius, chartZero, "base");
  const overlayPatternLines = renderOverlayPatternLines(chart, options, center, aspectRadius, chartZero);
  const nodalAgeAspects = renderNodalCurrentAgeAspectLines(chart, center, aspectRadius, chartZero);
  const nodalAgeDegreeMarks = renderNodalCurrentAgeDegreeMarks(chart, center, chartZero, {
    aspectRadius,
    outerDegreeInner: dodecatemoriaOuter,
    outerDegreeOuter: exteriorRing
  });
  const interactionAspects = interactivePlanets && overlay?.planets?.length ?
  renderCrossChartAspectLines(chart, overlay, center, aspectRadius, chartZero) :
  "";
  const aspectAnchors = renderAspectAnchors(
    chart,
    center,
    aspectRadius,
    chartZero,
    interactivePlanets ? overlay : null,
    chartPatternSources(chart, options).some((source) => source.layer === "overlay")
  );
  const cuspLabels = showHouses && !options.hideCuspLabels ?
  renderHouseCuspLabels(displayHouses, center, cuspLabelRadius, chartZero, options.compact, chart.type === "nodal") :
  "";
  const overlayObstacleBoxes = hasExteriorOverlayLabels && showHouses ?
  chartExteriorLabelObstacleBoxes(
    displayHouses,
    center,
    houseRing,
    cuspLabelRadius,
    chartZero,
    chart.type,
    angleMarkerOuterRadius
  ) :
  [];
  const highlightedPlanetKeys = new Set([
  chart?.highlightedAspect?.planetA,
  chart?.highlightedAspect?.planetB,
  chart?.highlightedCrossAspect?.planetA,
  chart?.highlightedCrossAspect?.planetB].
  filter(Boolean));
  const glyphReferenceSize = options.multiple ? 50 : /chart-planet-transit-natal/.test(options.natalClassName || "") ? 44 : 41;
  const planets = renderPlanetMarkers(chart.planets, center, planetRadius, "natal", chartZero, {
    glyphReferenceSize,
    tickOuter,
    outerDegreeInner: simpleRings ? zodiacOuter : dodecatemoriaOuter,
    outerDegreeOuter: exteriorRing,
    hidePlanetDetails: simpleRings,
    labelOffset: simpleRings ? 4 : undefined,
    minSpacing: options.natalMinSpacing,
    groupThreshold: options.natalGroupThreshold,
    colorOverride: options.natalColor,
    className: options.natalClassName,
    interactionLayer: "base",
    stationMode: "natal",
    stationUtc: chart === chartCalculation?.charts?.tropical && chart.type === "tropical" && !chart.composite && options.detailMode !== "composite" ?
    chartCalculation?.profile?.utcDateTime : undefined,
    stationTimeZone: chartCalculation?.profile?.location?.tz || "UTC",
    interactionContext: options.natalInteractionLabel || chart.label || "Carta base",
    nodalAsc: chart.type === "nodal" ? Number(chart.ascendant?.longitude) : Number.NaN,
    houseCusps: displayHouses,
    reverseHouses: chart.type === "memoria",
    useNatalDisplayHouseShift: chart === chartCalculation?.charts?.tropical &&
    chart.type === "tropical" && !chart.composite && options.detailMode !== "composite",
    hideHouses: !showHouses,
    interactivePlanets,
    highlightedPlanetKeys
  });
  const overlayPlanets = overlay?.planets ? renderPlanetMarkers(overlay.planets, center, overlayRadius, "overlay", chartZero, {
    glyphReferenceSize,
    tickOuter: exteriorRing + 14,
    colorOverride: options.overlayColor,
    className: options.overlayClassName,
    outwardDetails: options.overlayOutwardDetails,
    svgSize,
    labelMargin: options.overlayLabelMargin,
    transitLabelLaneOffsets: options.overlayLabelLaneOffsets,
    minSameLaneDistance: options.overlayMinSameLaneDistance,
    reservedAxisDistance: options.overlayReservedAxisDistance,
    collisionPadding: options.overlayCollisionPadding,
    sectorSize: options.overlaySectorSize,
    minLabelGap: options.overlayMinLabelGap,
    minLabelGapX: options.overlayMinLabelGapX,
    minLabelGapY: options.overlayMinLabelGapY,
    maxTangentialShift: options.overlayMaxTangentialShift,
    protectedAnglePadding: options.overlayProtectedAnglePadding,
    allowAxisOverlap: options.overlayAllowAxisOverlap,
    obstacleBoxes: overlayObstacleBoxes,
    leaderLineOpacity: options.overlayLeaderLineOpacity,
    transitFontSize: options.overlayTransitFontSize,
    transitGlyphFontSize: options.overlayTransitGlyphFontSize,
    transitMajorGlyphFontSize: options.overlayTransitMajorGlyphFontSize,
    stackedExteriorLabels: options.overlayStackedLabels,
    perimeterLayout: options.overlayPerimeterLayout,
    interactionLayer: "overlay",
    stationMode: options.overlayStationMode || "transit",
    stationBirthUtc: options.overlayStationBirthUtc,
    stationUtc: options.overlayStationUtc,
    stationTimeZone: options.overlayStationTimeZone,
    interactionContext: options.overlayLabel || "Carta exterior",
    includeAnglePoints: options.overlayIncludeAngles,
    houseCusps: displayHouses,
    reverseHouses: chart.type === "memoria",
    hideHouses: !showHouses,
    interactivePlanets
  }) : "";
  const isSideralChart = isSideralChartClient(chart);
  const centerSymbolScale = 0.6;
  const centerCircleRadius = (options.compact ? 27 : 37.5) * centerSymbolScale;
  const meditationHeight = (options.compact ? 40.5 : 57) * centerSymbolScale;
  const meditationWidth = round(meditationHeight * (38 / 50), 2);
  const meditationX = round(center - meditationWidth / 2, 2);
  const meditationY = round(center - meditationHeight / 2, 2);
  const meditationMaskId = `chart-sideral-meditation-${slugId(options.panelPrefix || chart?.label || chart?.type || "chart")}`;
  const meditationMask = isSideralChart ? `
        <mask id="${meditationMaskId}" maskUnits="userSpaceOnUse" x="${meditationX}" y="${meditationY}" width="${meditationWidth}" height="${meditationHeight}" mask-type="alpha">
          <image href="/assets/sideral-meditacion.png?v=1" x="${meditationX}" y="${meditationY}" width="${meditationWidth}" height="${meditationHeight}" preserveAspectRatio="xMidYMid meet"></image>
        </mask>
  ` : "";
  const meditationFigure = isSideralChart ? `
      <g class="chart-sideral-meditation" aria-hidden="true">
        <ellipse cx="${center}" cy="${center}" rx="${round(meditationWidth / 2 + 2 * centerSymbolScale, 2)}" ry="${round(meditationHeight / 2 + 2 * centerSymbolScale, 2)}" class="chart-sideral-meditation-backdrop"></ellipse>
        <rect x="${meditationX}" y="${meditationY}" width="${meditationWidth}" height="${meditationHeight}" class="chart-sideral-meditation-fill" mask="url(#${meditationMaskId})"></rect>
      </g>
  ` : "";

  return `
    <svg class="chart-wheel-svg" viewBox="${-viewportPadding} ${-viewportPadding} ${svgSize + viewportPadding * 2} ${svgSize + viewportPadding * 2}" role="${interactivePlanets ? "group" : "img"}" aria-label="${escapeHtml(I18n.label(chart.label || T("interface.carta")))}${interactivePlanets ? T("interface.selecciona_un_planeta_o_punto_para_destacar_sus_aspectos") : ""}" data-chart-type="${escapeHtml(chart.type || "tropical")}" data-chart-base-type="${escapeHtml(chart.composite?.chartType || chart.type || "tropical")}" data-chart-overlay-type="${escapeHtml(overlay?.composite?.chartType || overlay?.type || (options.detailMode === "transits" ? "transits" : ""))}" data-chart-panel-prefix="${escapeHtml(slugId(options.panelPrefix || chart?.type || chart?.label || "chart"))}" data-chart-aspect-mode="${isSideralChart ? "sign" : "orb"}"${interactivePlanets && overlay?.planets?.length ? ' data-chart-has-cross-aspects="true"' : ""}>
      <defs>
        <radialGradient id="${escapeHtml(slugId(options.panelPrefix || chart?.type || "chart"))}-glow" cx="50%" cy="48%" r="56%">
          <stop offset="0%" stop-color="var(--surface)" stop-opacity="1"></stop>
          <stop offset="72%" stop-color="var(--accent-soft)" stop-opacity="0.72"></stop>
          <stop offset="100%" stop-color="var(--surface)" stop-opacity="1"></stop>
        </radialGradient>
        ${meditationMask}
      </defs>
      <circle cx="${center}" cy="${center}" r="${exteriorRing}" class="chart-bg"></circle>
      ${zodiacSegments}
      ${decanateRing}
      ${dodecatemoriaRing}
      <circle cx="${center}" cy="${center}" r="${exteriorRing}" class="chart-exterior-ring"></circle>
      ${simpleRings ? "" : `<circle cx="${center}" cy="${center}" r="${dodecatemoriaOuter}" class="chart-outer"></circle>`}
      ${simpleRings ? "" : `<circle cx="${center}" cy="${center}" r="${decanateOuter}" class="chart-ring-line"></circle>`}
      ${simpleRings ? "" : `<circle cx="${center}" cy="${center}" r="${decanateInner}" class="chart-ring-line"></circle>`}
      <circle cx="${center}" cy="${center}" r="${zodiacOuter}" class="chart-zodiac"></circle>
      <circle cx="${center}" cy="${center}" r="${zodiacInner}" class="chart-zodiac-inner"></circle>
      <circle cx="${center}" cy="${center}" r="${tickOuter}" class="chart-tick-ring"></circle>
      <circle cx="${center}" cy="${center}" r="${aspectRadius}" class="chart-inner"></circle>
      ${signLines}
      ${degreeTicks}
      ${houseLines}
      ${aspects}
      ${overlayPatternLines}
      ${nodalAgeAspects}
      ${interactionAspects}
      ${aspectAnchors}
      ${nodalAgeDegreeMarks}
      ${houseLabels}
      ${signs}
      ${cuspLabels}
      ${angleMarkers}
      ${planets}
      ${overlayPlanets ? `<g class="transit-label-layer">${overlayPlanets}</g>` : ""}
      <circle cx="${center}" cy="${center}" r="${centerCircleRadius}" class="chart-mini-center"></circle>
      <circle cx="${center}" cy="${center}" r="${4 * centerSymbolScale}" class="chart-center-dot"></circle>
      ${meditationFigure}
    </svg>
  `;
}

function renderZodiacSegments(center, innerRadius, outerRadius, chartZero) {
  return PROMPT_SIGNS.map((sign, index) => {
    const start = index * 30;
    const end = start + 30;
    return `
      <path class="chart-zodiac-segment" style="--segment-color:${ZODIAC_COLORS[index]}" d="
        ${chartRingSectorPath(center, innerRadius, outerRadius, start, end, chartZero)}
      "></path>
    `;
  }).join("");
}

function renderDecanateRing(center, innerRadius, outerRadius, chartZero, showSymbols = true) {
  const segments = Array.from({ length: 36 }, (_, index) => {
    const signIndex = index % 12;
    const start = index * 10;
    const end = start + 10;
    const mid = start + 5;
    const point = chartPoint(center, center, (innerRadius + outerRadius) / 2, mid, chartZero);
    return `
      <path class="chart-decanate-segment" style="--segment-color:${ZODIAC_COLORS[signIndex]}" d="${chartRingSectorPath(center, innerRadius, outerRadius, start, end, chartZero)}"></path>
      <line class="chart-decanate-line" x1="${chartPoint(center, center, innerRadius, start, chartZero).x}" y1="${chartPoint(center, center, innerRadius, start, chartZero).y}" x2="${chartPoint(center, center, outerRadius, start, chartZero).x}" y2="${chartPoint(center, center, outerRadius, start, chartZero).y}"></line>
      ${showSymbols ? renderZodiacGlyph(point, ZODIAC_SYMBOLS[signIndex], ZODIAC_COLORS[signIndex], "chart-decanate-symbol", ZODIAC_GLYPH_COLORS[signIndex]) : ""}
    `;
  });
  return `<g class="chart-decanate-ring">${segments.join("")}</g>`;
}

function renderDodecatemoriaRing(center, innerRadius, outerRadius, chartZero, showSymbols = true) {
  const segments = Array.from({ length: 144 }, (_, index) => {
    const signIndex = Math.floor(index / 12);
    const innerIndex = index % 12;
    const zodiacIndex = (signIndex + innerIndex) % 12;
    const start = index * 2.5;
    const end = start + 2.5;
    const mid = start + 1.25;
    const point = chartPoint(center, center, (innerRadius + outerRadius) / 2, mid, chartZero);
    const lineA = chartPoint(center, center, innerRadius, start, chartZero);
    const lineB = chartPoint(center, center, outerRadius, start, chartZero);
    return `
      <path class="chart-dodecatemoria-segment" style="--segment-color:${ZODIAC_COLORS[zodiacIndex]}" d="${chartRingSectorPath(center, innerRadius, outerRadius, start, end, chartZero)}"></path>
      <line class="chart-dodecatemoria-line" x1="${lineA.x}" y1="${lineA.y}" x2="${lineB.x}" y2="${lineB.y}"></line>
      ${showSymbols ? renderZodiacGlyph(point, ZODIAC_SYMBOLS[zodiacIndex], ZODIAC_COLORS[zodiacIndex], "chart-dodecatemoria-symbol", ZODIAC_GLYPH_COLORS[zodiacIndex]) : ""}
    `;
  });
  return `<g class="chart-dodecatemoria-ring">${segments.join("")}</g>`;
}

function renderZodiacGlyph(point, symbol, color, className, inkColor = color) {
  return `<text x="${point.x}" y="${point.y}" class="${className} chart-zodiac-glyph" text-anchor="middle" dominant-baseline="middle" alignment-baseline="middle" style="--zodiac-color:${color};--zodiac-ink:${inkColor}">${symbol}</text>`;
}

function renderHouseCuspLabels(houses = [], center, radius, chartZero, compact = false, showNodalCuspTicks = false) {
  return houses.map((house) => {
    if ([1, 4, 7, 10].includes(Number(house.number))) return "";
    const point = chartPoint(center, center, radius, house.longitude, chartZero);
    const position = Number.isFinite(Number(house.signIndex)) ?
    house :
    enrichChartPointClient(`house-${house.number}`, house.longitude);
    const signIndex = Number(position.signIndex) || 0;
    const degree = Number.isFinite(Number(position.degree)) ? Number(position.degree) : 0;
    const minute = Number.isFinite(Number(position.minute)) ? Number(position.minute) : 0;
    const symbol = ZODIAC_SYMBOLS[signIndex] || "";
    const color = ZODIAC_COLORS[signIndex] || "#111827";
    const vividColor = ZODIAC_GLYPH_COLORS[signIndex] || color;
    const lightColor = ZODIAC_LIGHT_GLYPH_COLORS[signIndex] || vividColor;
    const signX = compact ? -7 : -10;
    const dataX = compact ? 9 : 14;
    let nodalCuspTick = "";
    if (showNodalCuspTicks) {
      const labelWidth = compact ? 42 : 52;
      const labelHeight = compact ? 30 : 36;
      const labelBox = {
        x: point.x - labelWidth / 2,
        y: point.y - labelHeight / 2,
        width: labelWidth,
        height: labelHeight
      };
      const labelEdge = rectEdgePointFromCenter(center, center, point, labelBox);
      const directionX = (point.x - center) / radius;
      const directionY = (point.y - center) / radius;
      const radialHalfExtent = Math.hypot(point.x - labelEdge.x, point.y - labelEdge.y);
      const tickGap = compact ? 4 : 5;
      const tickLength = compact ? 5 : 6;
      const tickStart = {
        x: round(point.x + directionX * (radialHalfExtent + tickGap), 2),
        y: round(point.y + directionY * (radialHalfExtent + tickGap), 2)
      };
      const tickEnd = {
        x: round(tickStart.x + directionX * tickLength, 2),
        y: round(tickStart.y + directionY * tickLength, 2)
      };
      nodalCuspTick = `<line x1="${tickStart.x}" y1="${tickStart.y}" x2="${tickEnd.x}" y2="${tickEnd.y}" class="chart-cusp-age-tick" aria-hidden="true"></line>`;
    }
    return `
      ${nodalCuspTick}
      <g class="chart-cusp-label" transform="translate(${point.x} ${point.y})" style="--cusp-sign-color:${color};--cusp-sign-vivid:${vividColor};--cusp-sign-light:${lightColor}">
        <text x="${signX}" y="0" class="chart-cusp-label-sign" text-anchor="middle" dominant-baseline="middle" alignment-baseline="middle">${symbol}</text>
        <text x="${dataX}" y="${compact ? -3 : -4}" class="chart-cusp-label-degree" text-anchor="middle" dominant-baseline="middle">${degree}º</text>
        <text x="${dataX}" y="${compact ? 10 : 14}" class="chart-cusp-label-minute" text-anchor="middle" dominant-baseline="middle">${pad(minute)}'</text>
      </g>
    `;
  }).join("");
}

function chartExteriorLabelObstacleBoxes(
houses = [],
center,
houseRadius,
cuspRadius,
chartZero,
chartType = "",
angleRadius = houseRadius + 30)
{
  const boxes = [];
  houses.forEach((house, index) => {
    const next = houses[(index + 1) % houses.length] || houses[0];
    const midpoint = chartType === "memoria" ?
    midpointLongitudeReverse(house.longitude, next.longitude) :
    midpointLongitude(house.longitude, next.longitude);
    const housePoint = chartPoint(center, center, houseRadius, midpoint, chartZero);
    boxes.push(orbitalLabelBox(housePoint, { width: 38, height: 28 }));

    const houseNumber = Number(house.number);
    if ([1, 4, 7, 10].includes(houseNumber)) {
      const anglePoint = chartPoint(center, center, angleRadius, house.longitude, chartZero);
      const isHorizontalAngle = houseNumber === 1 || houseNumber === 7;
      const labelCenter = isHorizontalAngle ?
      {
        x: anglePoint.x + (houseNumber === 1 ? -34 : 34),
        y: anglePoint.y - 21
      } :
      anglePoint;
      boxes.push({
        ...orbitalLabelBox(labelCenter, {
          width: isHorizontalAngle ? 106 : 86,
          height: isHorizontalAngle ? 54 : 58
        }),
        primaryAngle: true
      });
      return;
    }
    const cuspPoint = chartPoint(center, center, cuspRadius, house.longitude, chartZero);
    boxes.push(orbitalLabelBox(cuspPoint, { width: 66, height: 48 }));
  });
  return boxes;
}

function renderableChartAspects(chart) {
  const visualPlanets = new Set(aspectOrderForChart(chart));
  return chartAspectsIncludingAngles(chart).filter((aspect) =>
  isEnabledAspect(aspect) &&
  isAspectConsistentWithCurrentRules(chart, aspect) &&
  VISUAL_ASPECT_ANGLES.has(Number(aspect.angle)) &&
  visualPlanets.has(aspect.planetA) &&
  visualPlanets.has(aspect.planetB) &&
  chartAspectPlanet(chart, aspect.planetA) &&
  chartAspectPlanet(chart, aspect.planetB)
  );
}

function visualChartAspects(chart) {
  return renderableChartAspects(chart).filter((aspect) =>
  isChartAspectTypeVisible(aspect.angle) || isHighlightedChartAspect(chart, aspect)
  );
}

function chartPlanetInteractionId(layer, planetKey) {
  return `${layer || "base"}:${planetKey || ""}`;
}

function chartAspectInteractionAttributes(aspect, options = {}) {
  const layerA = options.layerA || "base";
  const layerB = options.layerB || "base";
  const context = options.context || "base";
  const config = ASPECT_CONFIGS.find((item) => Number(item.angle) === Number(aspect?.angle));
  const label = config?.label || aspect?.label || aspect?.name || T("interface.aspecto_value", { v0: aspect?.angle || 0 });
  const orb = aspect?.orb === null || aspect?.orb === undefined || aspect?.orb === "" ?
  Number.NaN :
  Number(aspect.orb);
  return [
  `data-chart-aspect-endpoint-a="${escapeHtml(chartPlanetInteractionId(layerA, aspect?.planetA))}"`,
  `data-chart-aspect-endpoint-b="${escapeHtml(chartPlanetInteractionId(layerB, aspect?.planetB))}"`,
  `data-chart-aspect-context="${escapeHtml(context)}"`,
  `data-chart-aspect-name="${escapeHtml(label)}"`,
  `data-chart-aspect-orb="${Number.isFinite(orb) ? escapeHtml(String(orb)) : ""}"`].
  join(" ");
}

function renderAspectLines(chart, center, radius, chartZero, interactionLayer = "base") {
  const lineRadius = Math.max(28, radius - 15);
  return renderableChartAspects(chart).map((aspect) => {
    const planetA = chartAspectPlanet(chart, aspect.planetA);
    const planetB = chartAspectPlanet(chart, aspect.planetB);
    const pointA = chartPoint(center, center, lineRadius, planetA.longitude, chartZero);
    const pointB = chartPoint(center, center, lineRadius, planetB.longitude, chartZero);
    const isHighlighted = isHighlightedChartAspect(chart, aspect);
    const visibilityClass = isHighlighted ? "" : chartAspectVisibilityClass(aspect);
    const interactionAttributes = chartAspectInteractionAttributes(aspect, {
      layerA: interactionLayer,
      layerB: interactionLayer,
      context: "base"
    });
    const isExactHighlightedConjunction = isHighlighted &&
    Number(aspect.angle) === 0 &&
    angularDistanceClient(planetA.longitude, planetB.longitude) < 0.001;
    if (isExactHighlightedConjunction) {
      const axisStart = chartPoint(center, center, Math.max(24, lineRadius - 9), planetA.longitude, chartZero);
      const axisEnd = chartPoint(center, center, lineRadius + 9, planetA.longitude, chartZero);
      const planetALabel = PROMPT_PLANET_LABELS[aspect.planetA] || aspect.planetA;
      const planetBLabel = PROMPT_PLANET_LABELS[aspect.planetB] || aspect.planetB;
      return `
        <g class="chart-aspect chart-aspect-0 is-highlighted chart-conjunction-highlight" data-chart-aspect-planets="${escapeHtml(aspect.planetA)}|${escapeHtml(aspect.planetB)}" data-chart-aspect-angle="0" ${interactionAttributes}>
          <title>${escapeHtml(I18n.label(`${planetALabel} y ${planetBLabel} comparten la misma longitud tropical`))}</title>
          <line x1="${axisStart.x}" y1="${axisStart.y}" x2="${axisEnd.x}" y2="${axisEnd.y}" class="chart-conjunction-highlight-axis" aria-hidden="true"></line>
        </g>
      `;
    }
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-aspect chart-aspect-${aspect.angle}${visibilityClass}${isHighlighted ? " is-highlighted" : ""}" data-chart-aspect-planets="${escapeHtml(aspect.planetA)}|${escapeHtml(aspect.planetB)}" data-chart-aspect-angle="${aspect.angle}" ${interactionAttributes} aria-hidden="true"></line>`;
  }).join("");
}

function renderNodalCurrentAgeAspectLines(chart, center, radius, chartZero) {
  const agePoint = chart?.nodalAgePoint;
  if (chart?.type !== "nodal" || !agePoint || !Array.isArray(agePoint.aspects)) return "";
  const lineRadius = Math.max(28, radius - 15);
  const pointA = chartPoint(center, center, lineRadius, agePoint.longitude, chartZero);

  return agePoint.aspects.
  filter((aspect) => isChartPlanetVisible(aspect.planetB) && isChartPlanetAspectVisible(aspect.planetB)).
  map((aspect) => {
    const target = chartAspectPlanet(chart, aspect.planetB);
    if (!target) return "";
    const pointB = chartPoint(center, center, lineRadius, target.longitude, chartZero);
    const interactionAttributes = chartAspectInteractionAttributes(aspect, {
      layerA: "base",
      layerB: "base",
      context: "base"
    });
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-aspect chart-aspect-${aspect.angle} chart-aspect-focus-only nodal-current-age-aspect" data-chart-aspect-planets="current-age|${escapeHtml(aspect.planetB)}" data-chart-aspect-angle="${aspect.angle}" ${interactionAttributes} aria-hidden="true"></line>`;
  }).
  join("");
}

function renderNodalCurrentAgeDegreeMarks(chart, center, chartZero, options = {}) {
  const agePoint = chart?.nodalAgePoint;
  if (chart?.type !== "nodal" || !agePoint || !Number.isFinite(Number(agePoint.longitude))) return "";
  const aspectRadius = Number(options.aspectRadius);
  const outerDegreeInner = Number(options.outerDegreeInner);
  const outerDegreeOuter = Number(options.outerDegreeOuter);
  if (![aspectRadius, outerDegreeInner, outerDegreeOuter].every(Number.isFinite)) return "";

  const innerStart = chartPoint(center, center, aspectRadius - 15, agePoint.longitude, chartZero);
  const innerEnd = chartPoint(center, center, aspectRadius - 2, agePoint.longitude, chartZero);
  const outerStart = chartPoint(center, center, outerDegreeInner, agePoint.longitude, chartZero);
  const outerEnd = chartPoint(center, center, outerDegreeOuter, agePoint.longitude, chartZero);
  const ageId = chartPlanetInteractionId("base", "current-age");

  return `
    <g class="chart-aspect-anchor nodal-current-age-aspect-anchor" data-chart-aspect-anchor-id="${escapeHtml(ageId)}" style="--planet-color:#dc2626" aria-hidden="true">
      <line x1="${innerStart.x}" y1="${innerStart.y}" x2="${innerEnd.x}" y2="${innerEnd.y}"></line>
    </g>
    <line x1="${outerStart.x}" y1="${outerStart.y}" x2="${outerEnd.x}" y2="${outerEnd.y}" class="chart-planet-degree-mark-outer nodal-current-age-degree-mark-outer" style="--planet-color:#dc2626" aria-hidden="true"></line>
  `;
}

function crossChartAspects(chart, overlay) {
  if (!chart || !Array.isArray(overlay?.planets)) return [];
  const baseKeys = aspectOrderForChart(chart);
  const overlayKeys = [...PROMPT_ASPECT_ORDER, ...CHART_ANGLE_POINT_KEYS];
  const houseCusps = normalizeAspectHouseCuspsClient(chartDisplayHouses(chart));
  const aspects = [];
  const highlighted = chart?.highlightedCrossAspect || null;

  overlayKeys.forEach((overlayKey) => {
    const isHighlightedOverlay = highlighted?.planetA === overlayKey;
    if (!isHighlightedOverlay && (!isChartPlanetVisible(overlayKey) || !isChartPlanetAspectVisible(overlayKey))) return;
    const overlayPlanet = overlay.planets.find((planet) => planet.key === overlayKey);
    if (!overlayPlanet || !Number.isFinite(Number(overlayPlanet.longitude))) return;

    baseKeys.forEach((baseKey) => {
      const isHighlightedPair = isHighlightedOverlay && highlighted?.planetB === baseKey;
      if (!isHighlightedPair && (!isChartPlanetVisible(baseKey) || !isChartPlanetAspectVisible(baseKey))) return;
      const basePlanet = chartAspectPlanet(chart, baseKey);
      if (!basePlanet || !Number.isFinite(Number(basePlanet.longitude))) return;
      const aspect = findAspectBetween(overlayPlanet.longitude, basePlanet.longitude, houseCusps);
      if (!aspect) return;
      const isHighlighted = isHighlightedCrossChartAspect(chart, { ...aspect, planetA: overlayKey, planetB: baseKey });
      if (!isHighlighted && (!isEnabledAspect(aspect) || !isChartAspectTypeVisible(aspect.angle))) return;
      aspects.push({
        ...aspect,
        planetA: overlayKey,
        planetB: baseKey,
        planetALabel: PROMPT_PLANET_LABELS[overlayKey] || overlayPlanet.label || overlayKey,
        planetBLabel: PROMPT_PLANET_LABELS[baseKey] || basePlanet.label || baseKey,
        longitudeA: Number(overlayPlanet.longitude),
        longitudeB: Number(basePlanet.longitude)
      });
    });
  });

  return aspects;
}

function renderCrossChartAspectLines(chart, overlay, center, radius, chartZero) {
  const lineRadius = Math.max(28, radius - 15);
  return crossChartAspects(chart, overlay).map((aspect) => {
    const pointA = chartPoint(center, center, lineRadius, aspect.longitudeA, chartZero);
    const pointB = chartPoint(center, center, lineRadius, aspect.longitudeB, chartZero);
    const interactionAttributes = chartAspectInteractionAttributes(aspect, {
      layerA: "overlay",
      layerB: "base",
      context: "cross"
    });
    const isHighlighted = isHighlightedCrossChartAspect(chart, aspect);
    const isExactHighlightedConjunction = isHighlighted &&
    Number(aspect.angle) === 0 &&
    angularDistanceClient(aspect.longitudeA, aspect.longitudeB) < 0.001;
    if (isExactHighlightedConjunction) {
      const axisStart = chartPoint(center, center, Math.max(24, lineRadius - 9), aspect.longitudeA, chartZero);
      const axisEnd = chartPoint(center, center, lineRadius + 9, aspect.longitudeA, chartZero);
      return `
        <g class="chart-aspect chart-aspect-0 chart-aspect-cross chart-aspect-focus-only is-highlighted chart-conjunction-highlight" data-chart-aspect-planets="${escapeHtml(aspect.planetA)}|${escapeHtml(aspect.planetB)}" data-chart-aspect-angle="0" ${interactionAttributes}>
          <line x1="${axisStart.x}" y1="${axisStart.y}" x2="${axisEnd.x}" y2="${axisEnd.y}" class="chart-conjunction-highlight-axis" aria-hidden="true"></line>
        </g>
      `;
    }
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-aspect chart-aspect-${aspect.angle} chart-aspect-cross chart-aspect-focus-only${isHighlighted ? " is-highlighted" : ""}" data-chart-aspect-planets="${escapeHtml(aspect.planetA)}|${escapeHtml(aspect.planetB)}" data-chart-aspect-angle="${aspect.angle}" ${interactionAttributes} aria-hidden="true"></line>`;
  }).join("");
}

function renderOverlayPatternLines(chart, options, center, radius, chartZero) {
  const patterns = chartAspectPatterns(chart, options).filter((pattern) => pattern.layer === "overlay");
  const edges = new Map();
  patterns.forEach((pattern) => pattern.edges.forEach((edge) => {
    const key = [...[edge.planetA, edge.planetB].sort(), edge.angle].join("|");
    edges.set(key, edge);
  }));
  const lineRadius = Math.max(28, radius - 15);
  return Array.from(edges.values()).map((edge) => {
    const planetA = chartAspectPlanet(options.overlay, edge.planetA);
    const planetB = chartAspectPlanet(options.overlay, edge.planetB);
    const pointA = chartPoint(center, center, lineRadius, planetA.longitude, chartZero);
    const pointB = chartPoint(center, center, lineRadius, planetB.longitude, chartZero);
    const attributes = chartAspectInteractionAttributes(edge, { layerA: "overlay", layerB: "overlay", context: "overlay" });
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-aspect chart-aspect-${edge.angle} chart-pattern-only" data-chart-aspect-planets="${escapeHtml(edge.planetA)}|${escapeHtml(edge.planetB)}" data-chart-aspect-angle="${edge.angle}" ${attributes} aria-hidden="true"></line>`;
  }).join("");
}

function renderAspectAnchors(chart, center, radius, chartZero, overlay = null, includeOverlayPatterns = false) {
  const anchorsById = new Map();
  const addAnchor = (layer, point, focusOnly = false) => {
    if (!point?.key || !Number.isFinite(Number(point.longitude))) return;
    const id = chartPlanetInteractionId(layer, point.key);
    const existing = anchorsById.get(id);
    if (existing) {
      if (!focusOnly) existing.focusOnly = false;
      return;
    }
    anchorsById.set(id, { id, layer, point, focusOnly });
  };

  // Keep anchors for every renderable aspect in the SVG so a detected figure
  // can reveal its exact degree marks even when that aspect type is hidden in
  // the ordinary map configuration. Visible aspects upgrade their anchors
  // from focus-only to normally visible.
  renderableChartAspects(chart).forEach((aspect) => {
    addAnchor("base", chartAspectPlanet(chart, aspect.planetA), true);
    addAnchor("base", chartAspectPlanet(chart, aspect.planetB), true);
  });

  visualChartAspects(chart).forEach((aspect) => {
    addAnchor("base", chartAspectPlanet(chart, aspect.planetA));
    addAnchor("base", chartAspectPlanet(chart, aspect.planetB));
  });

  if (Array.isArray(overlay?.planets)) {
    if (includeOverlayPatterns) {
      PROMPT_PRIMARY_PLANET_ORDER.forEach((key) => addAnchor("overlay", chartAspectPlanet(overlay, key), true));
    }
    const overlayByKey = new Map(overlay.planets.map((planet) => [planet.key, planet]));
    crossChartAspects(chart, overlay).forEach((aspect) => {
      addAnchor("overlay", overlayByKey.get(aspect.planetA), true);
      addAnchor("base", chartAspectPlanet(chart, aspect.planetB), true);
    });
  }

  return Array.from(anchorsById.values()).
  map(({ id, point: planet, focusOnly }) => {
    const color = chartPlanetColorCssValue(planet.key, "var(--text)");
    const inner = chartPoint(center, center, radius - 15, planet.longitude, chartZero);
    const outer = chartPoint(center, center, radius - 2, planet.longitude, chartZero);
    return `
        <g class="chart-aspect-anchor${focusOnly ? " chart-aspect-anchor-focus-only" : ""}${chartAspectAnchorVisibilityClass(planet.key)}" data-chart-aspect-anchor-key="${escapeHtml(planet.key)}" data-chart-aspect-anchor-id="${escapeHtml(id)}" style="--planet-color:${color}">
          <line x1="${inner.x}" y1="${inner.y}" x2="${outer.x}" y2="${outer.y}"></line>
        </g>
      `;
  }).join("");
}

function chartPlanetHouseForInteraction(planet, houseCusps = [], reverseHouses = false) {
  const hasLongitude = planet?.longitude != null && planet.longitude !== "" && Number.isFinite(Number(planet.longitude));
  if (hasLongitude && Array.isArray(houseCusps) && houseCusps.length >= 2) {
    // Memory houses run in the opposite direction to tropical houses.
    return reverseHouses ?
    houseNumberFromReverseCuspsClient(Number(planet.longitude), houseCusps) :
    houseNumberFromCuspsClient(Number(planet.longitude), houseCusps);
  }
  const explicitHouse = Number(planet?.house ?? planet?.houseLabel);
  if (Number.isInteger(explicitHouse) && explicitHouse >= 1 && explicitHouse <= 12) return explicitHouse;
  return null;
}

function chartPlanetStationAttributes(planet, options = {}) {
  const supported = ["Mercury", "Venus", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune", "Pluto", "Chiron", "Pholus", "Ceres", "Pallas", "Juno", "Vesta", "Chariklo", "Eros", "Eris", "Icarus", "Nessus", "Psyche", "true Node", "south Node"];
  if (!planet.retrograde || !supported.includes(planet.key) || !options.stationUtc) return [];
  const instant = Date.parse(options.stationUtc);
  const mode = options.stationMode || "transit";
  if (!Number.isFinite(instant) || !["transit", "natal", "progressed"].includes(mode)) return [];
  const at = new Date(Math.floor(instant / 1000) * 1000).toISOString();
  if (mode === "progressed") {
    const birth = Date.parse(options.stationBirthUtc);
    const age = (instant - birth) / 86400000;
    if (!Number.isFinite(age) || age < 0 || age > 120) return [];
  }
  return [
  `data-chart-station-utc="${escapeHtml(at)}"`,
  `data-chart-station-mode="${mode}"`,
  `data-chart-station-zone="${escapeHtml(options.stationTimeZone || "UTC")}"`,
  ...(mode === "progressed" ? [`data-chart-station-birth="${escapeHtml(options.stationBirthUtc)}"`] : [])];

}


function chartPlanetInteractionAttributes(planet, options = {}) {
  if (options.interactivePlanets !== true) return "";
  const layer = options.interactionLayer || "base";
  const title = PROMPT_PLANET_LABELS[planet.key] || planet.label || planet.key;
  const sign = planet.sign || PROMPT_SIGNS[Number(planet.signIndex)] || "";
  const degree = Number.isFinite(Number(planet.degree)) ? Number(planet.degree) : "";
  const minute = Number.isFinite(Number(planet.minute)) ? Number(planet.minute) : "";
  const second = Number.isFinite(Number(planet.second)) ? Number(planet.second) : "";
  const house = options.hideHouses ? null : chartPlanetHouseForInteraction(planet, options.houseCusps, options.reverseHouses);
  const promptHouse = options.useNatalDisplayHouseShift && house ?
  Number(displayHouseForTropical(planet.key)) : null;
  const hasPromptHouseShift = promptHouse === house % 12 + 1 && promptHouse !== Number(planet.house);
  const decanate = planet.decanate?.sign || "";
  const dodecatemoria = planet.dodecatemoria?.sign || "";
  const rawDecanateIndexValue = planet.decanate?.signIndex ?? planet.decanate?.absoluteIndex;
  const rawDecanateSignIndex = rawDecanateIndexValue === null || rawDecanateIndexValue === "" ?
  Number.NaN :
  Number(rawDecanateIndexValue);
  const decanateSignIndex = Number.isFinite(rawDecanateSignIndex) ?
  (rawDecanateSignIndex % 12 + 12) % 12 :
  "";
  const rawDodecatemoriaIndexValue = planet.dodecatemoria?.signIndex ?? planet.dodecatemoria?.absoluteIndex;
  const rawDodecatemoriaSignIndex = rawDodecatemoriaIndexValue === null || rawDodecatemoriaIndexValue === "" ?
  Number.NaN :
  Number(rawDodecatemoriaIndexValue);
  const dodecatemoriaSignIndex = Number.isFinite(rawDodecatemoriaSignIndex) ?
  (rawDodecatemoriaSignIndex % 12 + 12) % 12 :
  "";
  const context = options.interactionContext || (layer === "overlay" ? "Carta exterior" : "Carta base");
  const nodalAsc = Number(options.nodalAsc);
  const nodalAges = Number.isFinite(nodalAsc) ?
  nodalYearText(planet.longitude, nodalAsc, 1) :
  "";
  const positionLabel = degree === "" ?
  sign : T("interface.value_grados_value_minutos_de_value", { v0: degree, v1: minute === "" ? 0 : minute, v2: I18n.label(sign) });

  const nodalAgeAria = nodalAges ?
  `, ${nodalAges.split("|").join(" y ")} años nodales` :
  "";
  const ariaLabel = T('charts.planetPosition', { context: house ? 'house' : '', body: I18n.label(title), degree, minute: minute === '' ? 0 : minute, sign: I18n.label(sign), house }) + (
  planet.retrograde ? ' ' + T('charts.retrograde') : '') + (
  nodalAges ? ' ' + T('charts.nodalAge', { ages: nodalAges }) : '');

  return [
  `data-chart-planet-id="${escapeHtml(chartPlanetInteractionId(layer, planet.key))}"`,
  `data-chart-planet-layer="${escapeHtml(layer)}"`,
  `data-chart-planet-context="${escapeHtml(context)}"`,
  `data-chart-planet-sign="${escapeHtml(sign)}"`,
  `data-chart-planet-sign-index="${Number.isFinite(Number(planet.signIndex)) ? Number(planet.signIndex) : ""}"`,
  `data-chart-planet-degree="${escapeHtml(String(degree))}"`,
  `data-chart-planet-minute="${escapeHtml(String(minute))}"`,
  `data-chart-planet-second="${escapeHtml(String(second))}"`,
  `data-chart-planet-house="${house || ""}"`,
  ...(hasPromptHouseShift ? [`data-chart-planet-prompt-house="${promptHouse}"`] : []),
  `data-chart-planet-decanate="${escapeHtml(decanate)}"`,
  `data-chart-planet-decanate-index="${decanateSignIndex}"`,
  `data-chart-planet-dodecatemoria="${escapeHtml(dodecatemoria)}"`,
  `data-chart-planet-dodecatemoria-index="${dodecatemoriaSignIndex}"`,
  nodalAges ? `data-chart-planet-nodal-ages="${escapeHtml(nodalAges)}"` : "",
  `data-chart-planet-retrograde="${planet.retrograde ? "true" : "false"}"`,
  ...chartPlanetStationAttributes(planet, options),
  `data-chart-planet-aspects-enabled="${isChartPlanetAspectVisible(planet.key) ? "true" : "false"}"`,
  `role="button"`,
  `tabindex="0"`,
  `focusable="true"`,
  `aria-pressed="false"`,
  `aria-label="${escapeHtml(ariaLabel)}"`].
  join(" ");
}

// Font em sizes are not comparable across astronomical characters (or fallback
// fonts). Measure the ink, then match every symbol to the Sun/Moon reference.
function chartGlyphMetrics(key, referenceSize = 41) {
  // Mercury's tall, narrow silhouette needs a small optical lift on phones.
  if (key === "Mercury" && typeof window !== "undefined" &&
  window.matchMedia?.("(max-width: 860px), (pointer: coarse)").matches) {
    referenceSize *= 1.1;
  }
  if (!chartGlyphMetrics.cache) chartGlyphMetrics.cache = new Map();
  const glyph = planetGlyph(key);
  let metrics = chartGlyphMetrics.cache.get(glyph);
  if (!metrics) {
    const context = typeof document !== "undefined" ? document.createElement("canvas").getContext("2d") : null;
    if (context) context.font = '400 100px "Astro Jupiter", Arial, "Segoe UI Symbol", "Noto Sans Symbols 2", sans-serif';
    const measure = (text) => {
      const value = context?.measureText(text);
      const width = Number(value?.actualBoundingBoxLeft) + Number(value?.actualBoundingBoxRight);
      const height = Number(value?.actualBoundingBoxAscent) + Number(value?.actualBoundingBoxDescent);
      return {
        width: width > 0 ? width : 72,
        height: height > 0 ? height : 72,
        advance: Number(value?.width) || 72,
        centerX: value && width > 0 ? (value.width + value.actualBoundingBoxLeft - value.actualBoundingBoxRight) / 2 : 0,
        baselineY: value && height > 0 ? (value.actualBoundingBoxAscent - value.actualBoundingBoxDescent) / 2 : 0,
        measured: Boolean(value && width > 0 && height > 0)
      };
    };
    const sun = measure(planetGlyph("Sun"));
    const moon = measure(planetGlyph("Moon"));
    const reference = (Math.max(sun.width, sun.height) + Math.max(moon.width, moon.height)) / 2;
    const ink = measure(glyph);
    const scale = reference / Math.max(ink.width, ink.height);
    metrics = { scale, width: ink.width * scale / 100, height: ink.height * scale / 100, advance: ink.advance * scale / 100,
      centerX: ink.centerX * scale / 100, baselineY: ink.baselineY * scale / 100, measured: ink.measured };
    chartGlyphMetrics.cache.set(glyph, metrics);
  }
  return {
    fontSize: round(referenceSize * metrics.scale, 3),
    width: referenceSize * metrics.width,
    height: referenceSize * metrics.height,
    advance: referenceSize * metrics.advance,
    centerX: referenceSize * metrics.centerX,
    baselineY: referenceSize * metrics.baselineY,
    measured: metrics.measured
  };
}

function renderPlanetMarkers(planets = [], center, radius, variant, chartZero, options = {}) {
  const hidePlanetDetails = Boolean(options.hidePlanetDetails);
  const outwardDetails = variant === "overlay" && Boolean(options.outwardDetails);
  const stackedExteriorLabels = outwardDetails && Boolean(options.stackedExteriorLabels);
  const arrangedPlanets = outwardDetails ?
  placeTransitLabels(planets, center, radius, chartZero, options) :
  arrangePlanetMarkers(planets, radius, variant, options);

  return arrangedPlanets.
  map((planet) => {
    const labelPoint = planet.labelPoint || chartPoint(center, center, planet.labelRadius, planet.displayLongitude, chartZero);
    const color = options.colorOverride || chartPlanetColorCssValue(planet.key, "var(--accent)");
    const planetTitle = PROMPT_PLANET_LABELS[planet.key] || planet.label || planet.key;
    const vector = unitVector(center, center, labelPoint.x, labelPoint.y);
    const compactLabel = outwardDetails ? exteriorPlanetLabel(planet) : "";
    const exteriorLabelParts = outwardDetails ? exteriorPlanetLabelParts(planet) : null;
    const exteriorDataFontSize = Number(options.transitFontSize) || 11.2;
    const glyphMetrics = chartGlyphMetrics(planet.key, Number(options.glyphReferenceSize) || 41);
    const glyphStyle = `font-size:${glyphMetrics.fontSize}px !important`;
    const exteriorGlyphFontSize = glyphMetrics.height;
    const stackedGlyphY = round(labelPoint.y - (exteriorDataFontSize + 3) / 2, 2);
    const stackedDataY = round(labelPoint.y + (exteriorGlyphFontSize + 3) / 2, 2);
    const outwardStyle = outwardDetails ?
    `--planet-color:${color};--transit-leader-opacity:${Number(options.leaderLineOpacity) || 0.48};--transit-font-size:${Number(options.transitFontSize) || 11.2}px;--transit-glyph-size:${Number(options.transitGlyphFontSize) || Number(options.transitFontSize) || 11.2}px;--transit-major-glyph-size:${Number(options.transitMajorGlyphFontSize) || Number(options.transitGlyphFontSize) || Number(options.transitFontSize) || 11.2}px` :
    `--planet-color:${color}`;
    const glyphPoint = offsetPoint(labelPoint, vector, outwardDetails ? -14 : variant === "overlay" ? 6 : 6);
    const degreePoint = offsetPoint(labelPoint, vector, outwardDetails ? 12 : variant === "overlay" ? -21 : -30);
    const minutePoint = offsetPoint(labelPoint, vector, outwardDetails ? 29 : variant === "overlay" ? -64 : -80);
    const signPoint = offsetPoint(labelPoint, vector, outwardDetails ? 38 : variant === "overlay" ? -43 : -55);
    const retroPoint = {
      x: round(glyphPoint.x + glyphMetrics.width / 2 + 4, 2),
      y: round(glyphPoint.y - glyphMetrics.height / 2, 2)
    };
    const degreeMark = options.tickOuter ?
    `<line x1="${chartPoint(center, center, options.tickOuter - 16, planet.longitude, chartZero).x}" y1="${chartPoint(center, center, options.tickOuter - 16, planet.longitude, chartZero).y}" x2="${chartPoint(center, center, options.tickOuter, planet.longitude, chartZero).x}" y2="${chartPoint(center, center, options.tickOuter, planet.longitude, chartZero).y}" class="chart-planet-degree-mark" style="--planet-color:${color}"></line>` :
    "";
    const outerDegreeMark = options.outerDegreeInner && options.outerDegreeOuter ?
    `<line x1="${chartPoint(center, center, options.outerDegreeInner, planet.longitude, chartZero).x}" y1="${chartPoint(center, center, options.outerDegreeInner, planet.longitude, chartZero).y}" x2="${chartPoint(center, center, options.outerDegreeOuter, planet.longitude, chartZero).x}" y2="${chartPoint(center, center, options.outerDegreeOuter, planet.longitude, chartZero).y}" class="chart-planet-degree-mark-outer" style="--planet-color:${color}"></line>` :
    "";
    const connectorStart = options.tickOuter ?
    chartPoint(center, center, options.tickOuter - (outwardDetails ? 0 : 16), planet.longitude, chartZero) :
    chartPoint(center, center, planet.markerRadius, planet.longitude, chartZero);
    const glyphClearance = Math.max(glyphMetrics.width, glyphMetrics.height) / 2 + 3;
    const connectorEnd = outwardDetails ?
    rectEdgePointFromCenter(center, center, labelPoint, planet.collisionBox || transitLabelBox(labelPoint, vector, compactLabel)) :
    insetConnectorEnd(connectorStart, glyphPoint, glyphClearance);
    const connectorClass = outwardDetails ? "chart-planet-connector transit-leader-line" : "chart-planet-connector";
    const placedConnectorSegments = outwardDetails && planet.usePlacedConnectorSegments && Array.isArray(planet.connectorSegments) ?
    planet.connectorSegments :
    [];
    const connectorDistance = placedConnectorSegments.length ?
    placedConnectorSegments.reduce((distance, segment) => distance + pointDistance(segment.start, segment.end), 0) :
    pointDistance(connectorStart, connectorEnd);
    const connector = outwardDetails && connectorDistance < 18 ?
    "" :
    placedConnectorSegments.length ?
    renderPlacedPlanetConnector(placedConnectorSegments, connectorClass, color) :
    renderPlanetConnector(connectorStart, connectorEnd, center, connectorClass, color, outwardDetails);
    const focusPoint = variant === "overlay" ? labelPoint : glyphPoint;
    const isTouchPointer = window.matchMedia ?
    window.matchMedia("(pointer: coarse)").matches || window.matchMedia("(hover: none)").matches :
    false;
    const hitRadius = outwardDetails ?
    Math.max(18, (planet.collisionBox?.width || 44) / 2, (planet.collisionBox?.height || 36) / 2) :
    variant === "overlay" ? 18 : 24;
    const pointerFriendlyHitRadius = isTouchPointer ? Math.max(hitRadius, 28) : hitRadius;
    const exteriorHitPadding = isTouchPointer ? 8 : 4;
    const exteriorHitBox = outwardDetails && planet.collisionBox ?
    {
      x: round(planet.collisionBox.x - exteriorHitPadding, 2),
      y: round(planet.collisionBox.y - exteriorHitPadding, 2),
      width: round(planet.collisionBox.width + exteriorHitPadding * 2, 2),
      height: round(planet.collisionBox.height + exteriorHitPadding * 2, 2)
    } :
    null;
    const extraClass = options.className ? ` ${escapeHtml(options.className)}` : "";
    const highlightedClass = options.highlightedPlanetKeys?.has(planet.key) ?
    " is-highlighted-aspect-planet" :
    "";
    const visibilityClass = highlightedClass ? "" : chartPlanetVisibilityClass(planet.key);
    const interactionAttributes = chartPlanetInteractionAttributes(planet, options);
    const debugBox = options.showTransitLabelDebug && planet.collisionBox ?
    `<rect x="${planet.collisionBox.x}" y="${planet.collisionBox.y}" width="${planet.collisionBox.width}" height="${planet.collisionBox.height}" class="transit-label-debug-box"></rect>` :
    "";
    if (outwardDetails) {
      const exteriorLabel = stackedExteriorLabels ?
      `<text x="${labelPoint.x}" y="${labelPoint.y}" text-anchor="middle" dominant-baseline="middle" class="chart-planet-exterior-label chart-planet-exterior-label-stacked"><tspan x="${labelPoint.x}" y="${stackedGlyphY}" style="${glyphStyle}" class="chart-planet-optical-glyph chart-planet-exterior-glyph${planet.key === "Sun" || planet.key === "Moon" ? " chart-planet-exterior-glyph-major" : ""}${balancedPlanetGlyphClass(planet.key)}">${escapeHtml(exteriorLabelParts?.glyph || "")}</tspan><tspan x="${labelPoint.x}" y="${stackedDataY}" class="chart-planet-exterior-data">${escapeHtml(exteriorLabelParts?.data || "")}</tspan></text>` :
      `<text x="${labelPoint.x}" y="${labelPoint.y}" text-anchor="middle" dominant-baseline="middle" class="chart-planet-exterior-label"><tspan style="${glyphStyle}" class="chart-planet-optical-glyph chart-planet-exterior-glyph${planet.key === "Sun" || planet.key === "Moon" ? " chart-planet-exterior-glyph-major" : ""}${balancedPlanetGlyphClass(planet.key)}">${escapeHtml(exteriorLabelParts?.glyph || "")}</tspan><tspan class="chart-planet-exterior-data">&#160;${escapeHtml(exteriorLabelParts?.data || "")}</tspan></text>`;
      return `
          <g class="chart-planet chart-planet-${variant}${extraClass}${highlightedClass}${visibilityClass}" data-chart-planet-key="${escapeHtml(planet.key)}" data-planet-title="${escapeHtml(planetTitle)}" data-chart-label-layout="${planet.perimeterFallback ? `polar-fallback:${escapeHtml(planet.perimeterFallback)}` : "perimeter"}" ${interactionAttributes} style="${outwardStyle}">
            ${debugBox}
            ${degreeMark}
            ${connector}
            ${exteriorLabel}
            ${exteriorHitBox ?
      `<rect x="${exteriorHitBox.x}" y="${exteriorHitBox.y}" width="${exteriorHitBox.width}" height="${exteriorHitBox.height}" rx="8" class="chart-planet-hit" data-planet-title="${escapeHtml(planetTitle)}"></rect>` :
      `<circle cx="${focusPoint.x}" cy="${focusPoint.y}" r="${pointerFriendlyHitRadius}" class="chart-planet-hit" data-planet-title="${escapeHtml(planetTitle)}"></circle>`}
          </g>
        `;
    }
    return `
          <g class="chart-planet chart-planet-${variant}${extraClass}${highlightedClass}${visibilityClass}" data-chart-planet-key="${escapeHtml(planet.key)}" data-planet-title="${escapeHtml(planetTitle)}" ${interactionAttributes} style="${outwardStyle}">
          ${debugBox}
          ${outerDegreeMark}
          ${degreeMark}
          ${connector}
          <text x="${round(focusPoint.x + glyphMetrics.centerX, 3)}" y="${round(focusPoint.y + glyphMetrics.baselineY, 3)}" text-anchor="middle" dominant-baseline="${glyphMetrics.measured ? "alphabetic" : "middle"}" style="${glyphStyle}" class="chart-planet-optical-glyph chart-planet-glyph ${planet.key === "Sun" || planet.key === "Moon" ? "chart-planet-glyph-major" : ""}${balancedPlanetGlyphClass(planet.key)}">${escapeHtml(planetGlyph(planet.key))}</text>
          ${planet.retrograde ? `<text x="${retroPoint.x}" y="${retroPoint.y}" text-anchor="middle" dominant-baseline="middle" class="chart-planet-retro">R</text>` : ""}
          ${hidePlanetDetails ? "" : `<text x="${degreePoint.x}" y="${degreePoint.y}" text-anchor="middle" dominant-baseline="middle" class="chart-planet-degree">${outwardDetails ? `${planet.degree}º ${pad(planet.minute)}'` : `${planet.degree}º`}</text>`}
          ${hidePlanetDetails ? "" : `<text x="${signPoint.x}" y="${signPoint.y}" text-anchor="middle" dominant-baseline="middle" alignment-baseline="middle" class="chart-planet-sign" style="--planet-sign-color:${ZODIAC_COLORS[planet.signIndex] || "#111827"};--planet-sign-vivid:${ZODIAC_GLYPH_COLORS[planet.signIndex] || ZODIAC_COLORS[planet.signIndex] || "#111827"};--planet-sign-light:${ZODIAC_LIGHT_GLYPH_COLORS[planet.signIndex] || ZODIAC_GLYPH_COLORS[planet.signIndex] || "#111827"}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</text>`}
          ${hidePlanetDetails || outwardDetails ? "" : `<text x="${minutePoint.x}" y="${minutePoint.y}" text-anchor="middle" dominant-baseline="middle" class="chart-planet-minute">${pad(planet.minute)}'</text>`}
          <circle cx="${focusPoint.x}" cy="${focusPoint.y}" r="${pointerFriendlyHitRadius}" class="chart-planet-hit" data-planet-title="${escapeHtml(planetTitle)}"></circle>
        </g>
      `;
  }).join("");
}

function renderPlanetConnector(start, end, center, className, color, outwardDetails = false) {
  return buildLeaderLine(start, end, {
    center,
    className,
    color,
    preferPolyline: outwardDetails
  });
}

function renderPlacedPlanetConnector(segments = [], className, color) {
  return segments.map((segment) =>
  `<line x1="${segment.start.x}" y1="${segment.start.y}" x2="${segment.end.x}" y2="${segment.end.y}" class="${className}" style="--planet-color:${color}"></line>`
  ).join("");
}

function insetConnectorEnd(start, end, clearance) {
  const distance = pointDistance(start, end);
  const inset = Math.min(Math.max(0, Number(clearance) || 0), Math.max(0, distance - 1));
  const towardStart = unitVector(end.x, end.y, start.x, start.y);
  return offsetPoint(end, towardStart, inset);
}

function placeTransitLabels(planets = [], center, baseRadius, chartZero, options = {}) {
  const sorted = planets.
  filter((planet) =>
  (CHART_PLANET_ORDER.includes(planet.key) || planet.key === "midpoint" || planet.key === "tierra" ||
  options.includeAnglePoints && CHART_ANGLE_POINT_KEYS.includes(planet.key)) &&
  isChartPlanetVisible(planet.key)
  ).
  sort((a, b) => Number(a.longitude) - Number(b.longitude));
  const markerRadius = baseRadius;
  const laneOffsets = Array.isArray(options.transitLabelLaneOffsets) ?
  options.transitLabelLaneOffsets :
  [38, 78, 118, 158];
  const laneRadii = options.transitLabelRadii || laneOffsets.map((offset) => baseRadius + offset);
  const svgSize = Number(options.svgSize) || center * 2;
  const configuredMargin = Number(options.labelMargin);
  const margin = Number.isFinite(configuredMargin) ? Math.max(0, configuredMargin) : 46;
  const group = options.orbitalLabelGroup || (String(options.className || "").includes("synastry") ? "synastryB" : "transit");
  const color = options.colorOverride || (group === "synastryB" ? "#b94747" : "#007a3d");

  /*
   * Historical fallback kept only for callers that pass absolute radii.
   * Default callers use lane offsets above so each chart variant can tune
   * the exterior label rhythm without changing planetary calculations.
   */
  if (!options.transitLabelRadii && !options.transitLabelLaneOffsets) {
    laneRadii.splice(0, laneRadii.length,
    baseRadius + 38,
    baseRadius + 78,
    baseRadius + 118,
    baseRadius + 158
    );
  }

  const labelInputs = sorted.map((planet, index) => ({
    id: planet.key || `planet-${index}`,
    angleDeg: Number(planet.longitude),
    group,
    glyph: planetGlyph(planet.key),
    signGlyph: ZODIAC_SYMBOLS[planet.signIndex] || "",
    degree: planet.degree,
    minute: planet.minute,
    retrograde: planet.retrograde,
    stacked: Boolean(options.stackedExteriorLabels),
    glyphFontSize: chartGlyphMetrics(planet.key, Number(options.glyphReferenceSize) || 41).fontSize,
    glyphMetrics: chartGlyphMetrics(planet.key, Number(options.glyphReferenceSize) || 41),
    color,
    // Preserve the visual order around the wheel. Planetary priority used to
    // let an early label jump across MC/BC and forced later leaders to cross.
    priority: index,
    source: planet
  }));

  const layoutOptions = {
    cx: center,
    cy: center,
    outerRadius: baseRadius,
    anchorRadius: Number(options.connectorAnchorRadius ?? options.tickOuter) || baseRadius,
    laneRadii,
    laneRadiiByGroup: options.laneRadiiByGroup,
    minLabelGapX: Number(options.minLabelGapX ?? options.minLabelGap ?? options.minSameLaneDistance) || 34,
    minLabelGapY: Number(options.minLabelGapY) || 22,
    maxTangentialShift: Number(options.maxTangentialShift) || 34,
    allowAxisOverlap: options.allowAxisOverlap !== false,
    protectedAnglePadding: Number(options.protectedAnglePadding ?? options.reservedAxisDistance) || 0,
    obstacleBoxes: options.obstacleBoxes,
    clampToViewBox: { width: svgSize, height: svgSize, margin },
    chartZero,
    showOrbitalLabelDebug: Boolean(options.showTransitLabelDebug),
    fontSize: Number(options.transitFontSize) || 11.2
  };
  const layouts = options.perimeterLayout ?
  placePerimeterOrbitalLabels(labelInputs, layoutOptions) :
  placeOrbitalLabels(labelInputs, layoutOptions);

  return layouts.map((layout) => ({
    ...layout.source,
    markerRadius,
    displayLongitude: layout.displayAngleDeg,
    labelRadius: layout.radius,
    labelPoint: layout.label,
    collisionBox: layout.box,
    transitLane: layout.laneIndex + 1,
    tangentialShift: layout.tangentialShift,
    connectorSegments: layout.connectorSegments,
    usePlacedConnectorSegments: Boolean(options.perimeterLayout),
    perimeterFallback: layout.perimeterFallback || ""
  }));
}

function orbitalPolarToCartesian(cx, cy, radius, angleDeg, chartZero = 0) {
  return chartPoint(cx, cy, radius, angleDeg, chartZero);
}

function formatOrbitalLabel(input = {}) {
  const retrograde = input.retrograde ? " ℞" : "";
  const degree = Number.isFinite(Number(input.degree)) ? Number(input.degree) : 0;
  const minute = Number.isFinite(Number(input.minute)) ? Number(input.minute) : 0;
  return `${input.glyph || ""}${retrograde} ${input.signGlyph || ""} ${degree}°${pad(minute)}′`;
}

function measureAstroLabelApprox(inputOrText, fontSize = 11.2) {
  const text = typeof inputOrText === "string" ? inputOrText : formatOrbitalLabel(inputOrText);
  const glyphFontSize = typeof inputOrText === "object" ? Number(inputOrText?.glyphFontSize) : 0;
  const stacked = typeof inputOrText === "object" && Boolean(inputOrText?.stacked);
  const glyphMetrics = typeof inputOrText === "object" ? inputOrText?.glyphMetrics : null;
  if (glyphFontSize > 0) {
    const dataLength = Math.max(0, String(text || "").length - String(inputOrText?.glyph || "").length);
    if (stacked) {
      return {
        width: round(Math.max(34, (glyphMetrics?.width ?? glyphFontSize * 0.84) + 8, dataLength * (fontSize * 0.54) + 8), 1),
        height: round(Math.max(32, (glyphMetrics?.height ?? glyphFontSize) + fontSize + 9), 1)
      };
    }
    const degree = Number.isFinite(Number(inputOrText?.degree)) ? Number(inputOrText.degree) : 0;
    const minute = Number.isFinite(Number(inputOrText?.minute)) ? Number(inputOrText.minute) : 0;
    const degreeText = `${degree}°${pad(minute)}′`;
    const dataWidth = fontSize * 0.82 +
    degreeText.length * fontSize * 0.5 + (
    inputOrText?.retrograde ? fontSize * 0.82 : 0);
    return {
      width: round(Math.max(46, (glyphMetrics?.advance ?? glyphFontSize * 0.72) + dataWidth + fontSize * 0.55 + 6), 1),
      height: round(Math.max(17, (glyphMetrics?.height ?? glyphFontSize) + 7), 1)
    };
  }
  return {
    width: round(Math.max(48, String(text || "").length * (fontSize * 0.54) + 12), 1),
    height: round(Math.max(17, fontSize + 7), 1)
  };
}

function getTangentialVector(cx, cy, point) {
  const radial = unitVector(cx, cy, point.x, point.y);
  return { x: -radial.y, y: radial.x };
}

function buildLeaderLine(start, end, options = {}) {
  const className = options.className || "chart-planet-connector";
  const color = options.color || "var(--accent)";
  const distance = pointDistance(start, end);
  const center = options.center || { x: 0, y: 0 };

  if (!options.preferPolyline || distance <= 44) {
    return `<line x1="${start.x}" y1="${start.y}" x2="${end.x}" y2="${end.y}" class="${className}" style="--planet-color:${color}"></line>`;
  }

  const vector = unitVector(center, center, start.x, start.y);
  const elbowDistance = Math.min(20, Math.max(11, distance * 0.32));
  const elbow = offsetPoint(start, vector, elbowDistance);
  return `<polyline points="${start.x},${start.y} ${elbow.x},${elbow.y} ${end.x},${end.y}" class="${className} transit-leader-line-bent" style="--planet-color:${color}"></polyline>`;
}

function placePerimeterOrbitalLabels(inputs = [], options = {}) {
  const cx = Number(options.cx) || 0;
  const cy = Number(options.cy) || 0;
  const anchorRadius = Number(options.anchorRadius ?? options.outerRadius) || 0;
  const chartZero = options.chartZero ?? 0;
  const fontSize = Number(options.fontSize) || 11.2;
  const bounds = options.clampToViewBox || {};
  const width = Number(bounds.width) || cx * 2;
  const height = Number(bounds.height) || cy * 2;
  const margin = Math.max(2, Number(bounds.margin) || 0);
  const protectedAnglePadding = Math.max(48, Number(options.protectedAnglePadding) || 0);
  const tangentGap = Math.max(9, Math.min(18, Number(options.minLabelGapX) || 12));
  const railGap = Math.max(8, Math.min(14, Number(options.minLabelGapY) || 10));
  const obstacleBoxes = Array.isArray(options.obstacleBoxes) ?
  options.obstacleBoxes.filter((box) => box && [box.x, box.y, box.width, box.height].every(Number.isFinite)) :
  [];
  const prepared = inputs.
  filter((input) => Number.isFinite(Number(input.angleDeg))).
  map((input, index) => {
    const anchor = orbitalPolarToCartesian(cx, cy, anchorRadius, input.angleDeg, chartZero);
    const labelSize = measureAstroLabelApprox(input, fontSize);
    const dx = anchor.x - cx;
    const dy = anchor.y - cy;
    const side = Math.abs(dx) > Math.abs(dy) * (options.perimeterSideRatio ?? 1) ?
    dx < 0 ? "left" : "right" :
    dy < 0 ? "top" : "bottom";
    return {
      ...input,
      inputIndex: index,
      anchor,
      labelSize,
      side,
      desiredTangent: side === "top" || side === "bottom" ? anchor.x : anchor.y
    };
  });

  if (!prepared.length) return [];

  const maxLabelWidth = Math.max(...prepared.map((item) => item.labelSize.width));
  const maxLabelHeight = Math.max(...prepared.map((item) => item.labelSize.height));
  const cornerInsetX = Math.min(
    Math.max(margin + maxLabelWidth / 2 + tangentGap, 54),
    Math.max(54, cx - protectedAnglePadding - 36)
  );
  const cornerInsetY = Math.min(
    options.perimeterExpanded ?
    Math.max(margin + maxLabelHeight / 2 + tangentGap, 54) :
    Math.max(margin + maxLabelHeight * 3 + railGap * 3, 76),
    Math.max(76, cy - protectedAnglePadding - 36)
  );
  const context = {
    cx,
    cy,
    width,
    height,
    margin,
    protectedAnglePadding,
    tangentGap,
    railGap,
    obstacleBoxes,
    maxLabelWidth,
    maxLabelHeight
  };
  const placements = [];
  let failed = false;
  let failedSide = "";

  ["top", "right", "bottom", "left"].forEach((side) => {
    if (failed) return;
    const sideItems = prepared.
    filter((item) => item.side === side).
    sort((a, b) => a.desiredTangent - b.desiredTangent || a.inputIndex - b.inputIndex);
    if (!sideItems.length) return;

    const horizontal = side === "top" || side === "bottom";
    const axisCenter = horizontal ? cx : cy;
    // Wide horizontal labels need more clearance near ASC/DSC. Derive the
    // reserved space from their inner edge so leader lines stay outside the
    // wheel even when a dense group borrows space nearer a corner.
    const sidePortOffset = Math.max(0, width / 2 - margin - maxLabelWidth - 2);
    const sideClearance = Math.sqrt(Math.max(0, (anchorRadius + 8) ** 2 - sidePortOffset ** 2));
    const axisPadding = horizontal || !options.perimeterExpanded ?
    protectedAnglePadding : Math.max(protectedAnglePadding, sideClearance);
    const tangentStart = horizontal ? cornerInsetX : cornerInsetY;
    const tangentEnd = horizontal ? width - cornerInsetX : height - cornerInsetY;
    const beforeAxis = sideItems.filter((item) => item.desiredTangent < axisCenter);
    const afterAxis = sideItems.filter((item) => item.desiredTangent >= axisCenter);
    let sidePlacements = [
    placePerimeterSegment(beforeAxis, side, tangentStart, axisCenter - axisPadding, context),
    placePerimeterSegment(afterAxis, side, axisCenter + axisPadding, tangentEnd, context)];


    // Cusp labels are secondary to the temporal overlay. If a very dense side
    // has no obstacle-free solution, retain the ordered perimeter (and thus
    // non-crossing leaders) instead of falling back to long polar diagonals.
    // The four principal angles remain protected in this relaxed pass.
    if (sidePlacements.some((result) => result === null)) {
      const relaxedContext = {
        ...context,
        obstacleBoxes: context.obstacleBoxes.filter((box) => box.primaryAngle === true)
      };
      sidePlacements = [
      placePerimeterSegment(beforeAxis, side, tangentStart, axisCenter - axisPadding, relaxedContext),
      placePerimeterSegment(afterAxis, side, axisCenter + axisPadding, tangentEnd, relaxedContext)];

    }

    if (sidePlacements.some((result) => result === null)) {
      failed = true;
      failedSide = `${side}:${sidePlacements[0] === null ? "before" : ""}${sidePlacements[1] === null ? "after" : ""}`;
      return;
    }
    sidePlacements.forEach((result) => placements.push(...result));
  });

  if (!failed && perimeterCandidateConflictReason(placements, "", {})) {
    routePerimeterConnectors(placements, context);
  }
  if (failed || placements.length !== prepared.length || perimeterCandidateConflictReason(placements, "", {})) {
    if (options.perimeterExpanded) return [];
    // Keep the transit perimeter layout for dense natal overlays too. Moving
    // the corner boundaries gives a crowded horizontal group access to the
    // taller side rails, without changing its order or its true anchors.
    for (const ratio of [1, 0.7, 0.45, 0.25, 0.1, 1.4, 2.2, 4, 10]) {
      const retry = placePerimeterOrbitalLabels(inputs, { ...options, perimeterExpanded: true, perimeterSideRatio: ratio });
      if (retry.length) return retry;
    }
    return placeOrbitalLabels(
      prepared.
      sort((a, b) => a.inputIndex - b.inputIndex).
      map(({ anchor, labelSize, side, desiredTangent, inputIndex, ...input }) => ({ ...input, priority: inputIndex })),
      options
    ).map((layout) => ({ ...layout, perimeterFallback: failedSide || "incomplete" }));
  }

  return placements.
  sort((a, b) => a.inputIndex - b.inputIndex).
  map(({ inputIndex, ...placement }) => placement);
}

function placePerimeterSegment(items = [], side, tangentMin, tangentMax, context) {
  if (!items.length) return [];
  if (!Number.isFinite(tangentMin) || !Number.isFinite(tangentMax) || tangentMax <= tangentMin) return null;

  const singleRail = packPerimeterRail(items, side, 0, tangentMin, tangentMax, context);
  if (singleRail) return singleRail;
  if (side === "left" || side === "right" || items.length < 2) return null;

  let best = null;
  let bestScore = Number.POSITIVE_INFINITY;
  const considerPartitions = (groups) => {
    const railCount = groups.length;
    const packedGroups = groups.map((group, index) =>
    packPerimeterRail(group, side, railCount - index - 1, tangentMin, tangentMax, context)
    );
    if (packedGroups.some((group) => !group)) return;

    // Each rail may reuse the available width. The groups remain contiguous;
    // geometry checks reject every leader crossing or leader-through-label
    // path, while the score still prefers the original angular order.
    const candidate = packedGroups.flat();
    const conflictReason = perimeterCandidateConflictReason(candidate, side, context);
    if (conflictReason) return;
    const score = candidate.reduce(
      (total, item) => total + Math.abs(item.tangentialShift) + item.laneIndex * 10,
      railCount * 24
    ) + perimeterOrderPenalty(candidate, side);
    if (score < bestScore) {
      best = candidate;
      bestScore = score;
    }
  };

  for (let split = 1; split < items.length; split += 1) {
    considerPartitions([items.slice(0, split), items.slice(split)]);
  }

  // Dense clusters around MC/BC need one additional compact row. Three
  // contiguous angular blocks still preserve the visual reading order while
  // using the vertical space that already exists outside the wheel.
  if (items.length >= 3) {
    for (let firstSplit = 1; firstSplit < items.length - 1; firstSplit += 1) {
      for (let secondSplit = firstSplit + 1; secondSplit < items.length; secondSplit += 1) {
        considerPartitions([
        items.slice(0, firstSplit),
        items.slice(firstSplit, secondSplit),
        items.slice(secondSplit)]
        );
      }
    }
  }
  return best;
}

function perimeterCandidateConflictReason(candidate = [], side, context = {}) {
  for (let index = 0; index < candidate.length; index += 1) {
    const current = candidate[index];
    const currentSegments = Array.isArray(current.connectorSegments) ? current.connectorSegments : [];
    if (context.obstacleBoxes?.some((box) =>
    currentSegments.some((segment) => segmentIntersectsLabelBox(segment, box, 2))
    )) return "obstacle";

    for (let otherIndex = index + 1; otherIndex < candidate.length; otherIndex += 1) {
      const other = candidate[otherIndex];
      if (detectLabelCollision(current.box, other.box, 1, 1)) return "label";
      if (orbitalConnectorConflictScore(currentSegments, current.box, other) > 0) return "connector";
    }
  }
  return "";
}

function perimeterOrderPenalty(candidate = [], side) {
  const horizontal = side === "top" || side === "bottom";
  let penalty = 0;
  for (let index = 1; index < candidate.length; index += 1) {
    const currentTangent = horizontal ? candidate[index].label.x : candidate[index].label.y;
    const previousTangent = horizontal ? candidate[index - 1].label.x : candidate[index - 1].label.y;
    if (currentTangent + 0.5 < previousTangent) {
      penalty += 80 + (previousTangent - currentTangent) * 3;
    }
  }
  return penalty;
}

function packPerimeterRail(items = [], side, railIndex, tangentMin, tangentMax, context) {
  if (!items.length) return [];
  const forward = packPerimeterRailDirection(items, side, railIndex, tangentMin, tangentMax, context, 1);
  const backward = packPerimeterRailDirection(items, side, railIndex, tangentMin, tangentMax, context, -1);
  const compact = packPerimeterRailCompact(items, side, railIndex, tangentMin, tangentMax, context);
  const score = (placements) => placements.reduce((total, item) => total + Math.abs(item.tangentialShift), 0);
  return [forward, backward, compact].
  filter(Boolean).
  sort((a, b) => score(a) - score(b))[0] || null;
}

function packPerimeterRailCompact(items, side, railIndex, tangentMin, tangentMax, context) {
  const horizontal = side === "top" || side === "bottom";
  const lengths = items.map((item) => horizontal ? item.labelSize.width : item.labelSize.height);
  const totalLength = lengths.reduce((sum, length) => sum + length, 0) + context.tangentGap * Math.max(0, items.length - 1);
  const availableLength = tangentMax - tangentMin;
  if (totalLength > availableLength) return null;

  const desiredCenter = items.reduce((sum, item) => sum + item.desiredTangent, 0) / items.length;
  const start = Math.min(
    tangentMax - totalLength,
    Math.max(tangentMin, desiredCenter - totalLength / 2)
  );
  let cursor = start;
  const placements = [];

  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    const halfTangent = lengths[index] / 2;
    const tangent = cursor + halfTangent;
    const label = perimeterLabelPoint(side, railIndex, tangent, context);
    const box = orbitalLabelBox(label, item.labelSize);
    if (context.obstacleBoxes.some((obstacle) => detectLabelCollision(box, obstacle, 1, 1))) return null;
    const end = perimeterConnectorEnd(side, label, box);
    placements.push({
      ...item,
      label,
      box,
      laneIndex: railIndex,
      radius: pointDistance({ x: context.cx, y: context.cy }, label),
      width: item.labelSize.width,
      height: item.labelSize.height,
      displayAngleDeg: Number(item.angleDeg),
      tangentialShift: round(tangent - item.desiredTangent, 2),
      connectorSegments: perimeterConnectorSegments(item.anchor, end, label, side, context)
    });
    cursor += lengths[index] + context.tangentGap;
  }

  return placements;
}

function packPerimeterRailDirection(items, side, railIndex, tangentMin, tangentMax, context, direction) {
  const horizontal = side === "top" || side === "bottom";
  const ordered = direction > 0 ? items : [...items].reverse();
  let cursor = direction > 0 ? tangentMin : tangentMax;
  const placements = [];

  for (const item of ordered) {
    const halfTangent = (horizontal ? item.labelSize.width : item.labelSize.height) / 2;
    let tangent = direction > 0 ?
    Math.max(item.desiredTangent, cursor + halfTangent) :
    Math.min(item.desiredTangent, cursor - halfTangent);
    let placement = null;

    for (let attempt = 0; attempt <= context.obstacleBoxes.length + 2; attempt += 1) {
      if (tangent - halfTangent < tangentMin || tangent + halfTangent > tangentMax) return null;
      const label = perimeterLabelPoint(side, railIndex, tangent, context);
      const box = orbitalLabelBox(label, item.labelSize);
      const collisions = context.obstacleBoxes.filter((obstacle) => detectLabelCollision(box, obstacle, 1, 1));
      if (!collisions.length) {
        const end = perimeterConnectorEnd(side, label, box);
        placement = {
          ...item,
          label,
          box,
          laneIndex: railIndex,
          radius: pointDistance({ x: context.cx, y: context.cy }, label),
          width: item.labelSize.width,
          height: item.labelSize.height,
          displayAngleDeg: Number(item.angleDeg),
          tangentialShift: round(tangent - item.desiredTangent, 2),
          connectorSegments: perimeterConnectorSegments(item.anchor, end, label, side, context)
        };
        break;
      }

      tangent = direction > 0 ?
      Math.max(...collisions.map((box) => horizontal ? box.x + box.width : box.y + box.height)) + context.tangentGap + halfTangent :
      Math.min(...collisions.map((box) => horizontal ? box.x : box.y)) - context.tangentGap - halfTangent;
    }

    if (!placement) return null;
    placements.push(placement);
    cursor = direction > 0 ?
    tangent + halfTangent + context.tangentGap :
    tangent - halfTangent - context.tangentGap;
  }

  return direction > 0 ? placements : placements.reverse();
}

function perimeterConnectorEnd(side, label, box) {
  if (side === "top") return { x: label.x, y: box.y + box.height + 2 };
  if (side === "bottom") return { x: label.x, y: box.y - 2 };
  if (side === "left") return { x: box.x + box.width + 2, y: label.y };
  return { x: box.x - 2, y: label.y };
}

function perimeterConnectorSegments(anchor, end, label, side, context) {
  // Align the incoming ends before the final short connection to each label;
  // glyphs of different widths must not make tightly spaced leaders cross.
  const port = side === "top" || side === "bottom" ?
  { x: label.x, y: label.y + (side === "top" ? 1 : -1) * (context.maxLabelHeight / 2 + 2) } :
  { x: label.x + (side === "left" ? 1 : -1) * (context.maxLabelWidth / 2 + 2), y: label.y };
  return [{ start: anchor, end: port }, { start: port, end }];
}

function routePerimeterConnectors(placements, context) {
  if (!placements.length) return;
  const center = { x: context.cx, y: context.cy };
  const ends = placements.map((item) => perimeterConnectorSegments(item.anchor,
  perimeterConnectorEnd(item.side, item.label, item.box), item.label, item.side, context)[0].end);
  const railRadius = Math.min(...ends.map((end) => pointDistance(center, end))) - 4;
  if (railRadius <= pointDistance(center, placements[0].anchor) + 2) return;
  // Fan congested leaders through a shared radius outside the wheel. Their
  // angular order stays intact before they continue to the perimeter rails.
  placements.forEach((item, index) => {
    const startAngle = Math.atan2(item.anchor.y - context.cy, item.anchor.x - context.cx);
    const endAngle = Math.atan2(ends[index].y - context.cy, ends[index].x - context.cx);
    const delta = Math.atan2(Math.sin(endAngle - startAngle), Math.cos(endAngle - startAngle));
    const startRadius = pointDistance(center, item.anchor);
    const points = [item.anchor];
    for (let step = 1; step <= 12; step += 1) {
      const t = step / 12;
      const angle = startAngle + delta * t;
      const radius = startRadius + (railRadius - startRadius) * t;
      points.push({ x: round(context.cx + radius * Math.cos(angle), 2), y: round(context.cy + radius * Math.sin(angle), 2) });
    }
    points.push(ends[index]);
    points.push(perimeterConnectorEnd(item.side, item.label, item.box));
    item.connectorSegments = points.slice(1).map((end, i) => ({ start: points[i], end }));
  });
}

function perimeterLabelPoint(side, railIndex, tangent, context) {
  if (side === "top") {
    return {
      x: round(tangent, 2),
      y: round(context.margin + context.maxLabelHeight / 2 + railIndex * (context.maxLabelHeight + context.railGap), 2)
    };
  }
  if (side === "bottom") {
    return {
      x: round(tangent, 2),
      y: round(context.height - context.margin - context.maxLabelHeight / 2 - railIndex * (context.maxLabelHeight + context.railGap), 2)
    };
  }
  if (side === "left") {
    return { x: round(context.margin + context.maxLabelWidth / 2, 2), y: round(tangent, 2) };
  }
  return { x: round(context.width - context.margin - context.maxLabelWidth / 2, 2), y: round(tangent, 2) };
}

function placeOrbitalLabels(inputs = [], options = {}) {
  const cx = Number(options.cx) || 0;
  const cy = Number(options.cy) || 0;
  const anchorRadius = Number(options.anchorRadius ?? options.outerRadius) || 0;
  const laneRadii = Array.isArray(options.laneRadii) ? options.laneRadii.map(Number).filter(Number.isFinite) : [];
  const minLabelGapX = Number(options.minLabelGapX) || 34;
  const minLabelGapY = Number(options.minLabelGapY) || 22;
  const maxTangentialShift = Number(options.maxTangentialShift) || 34;
  const fontSize = Number(options.fontSize) || 11.2;
  const chartZero = options.chartZero ?? 0;
  const protectedAnglePadding = Math.max(
    0,
    Number(options.protectedAnglePadding ?? options.reservedAxisDistance) || 0
  );
  const axisCollisionBoxes = options.allowAxisOverlap === false && protectedAnglePadding > 0 ?
  orbitalAxisCollisionBoxes({
    cx,
    cy,
    anchorRadius,
    width: Number(options.clampToViewBox?.width) || cx * 2,
    height: Number(options.clampToViewBox?.height) || cy * 2,
    padding: protectedAnglePadding
  }) :
  [];
  const obstacleBoxes = Array.isArray(options.obstacleBoxes) ?
  options.obstacleBoxes.filter((box) => box && [box.x, box.y, box.width, box.height].every(Number.isFinite)) :
  [];
  const occupied = [];
  const ordered = [...inputs].
  filter((input) => Number.isFinite(Number(input.angleDeg))).
  sort((a, b) => {
    const priorityA = Number.isFinite(Number(a.priority)) && Number(a.priority) >= 0 ? Number(a.priority) : 999;
    const priorityB = Number.isFinite(Number(b.priority)) && Number(b.priority) >= 0 ? Number(b.priority) : 999;
    return priorityA - priorityB || Number(a.angleDeg) - Number(b.angleDeg);
  });

  return ordered.map((input) => {
    const anchor = orbitalPolarToCartesian(cx, cy, anchorRadius, input.angleDeg, chartZero);
    const labelSize = measureAstroLabelApprox(input, fontSize);
    const radii = assignLabelLane(input, { ...options, laneRadii });
    const shifts = orbitalTangentialShifts(maxTangentialShift);
    let best = null;
    let bestScore = Number.POSITIVE_INFINITY;
    let bestHardCollisionCount = Number.POSITIVE_INFINITY;
    let bestHardOverlapArea = Number.POSITIVE_INFINITY;

    for (const [laneIndex, radius] of radii.entries()) {
      for (const shiftPx of shifts) {
        const angleShift = shiftPx / Math.max(1, radius) * (180 / Math.PI);
        const displayAngleDeg = norm360Client(Number(input.angleDeg) + angleShift);
        const point = orbitalPolarToCartesian(cx, cy, radius, displayAngleDeg, chartZero);
        const clamped = clampOrbitalLabelPoint(point, labelSize, options.clampToViewBox);
        const box = orbitalLabelBox(clamped, labelSize);
        const occupiedCollisions = occupied.filter((item) =>
        detectLabelCollision(box, item.box, minLabelGapX, minLabelGapY)
        );
        const axisCollisions = axisCollisionBoxes.filter((axisBox) =>
        detectLabelCollision(box, axisBox, 4, 4)
        );
        const obstacleCollisions = obstacleBoxes.filter((obstacleBox) =>
        detectLabelCollision(box, obstacleBox, 6, 5)
        );
        const hardCollisionCount = occupiedCollisions.length + axisCollisions.length + obstacleCollisions.length;
        const hardOverlapArea = occupiedCollisions.reduce((area, item) => area + rectOverlapArea(box, item.box, 0), 0) +
        axisCollisions.reduce((area, axisBox) => area + rectOverlapArea(box, axisBox, 0), 0) +
        obstacleCollisions.reduce((area, obstacleBox) => area + rectOverlapArea(box, obstacleBox, 0), 0);
        const collisionScore = occupiedCollisions.reduce((score, item) =>
        score + 12000 + rectOverlapArea(box, item.box, 0) + boxCenterDistance(box, item.box),
        0);
        const axisCollisionScore = axisCollisions.reduce((score, axisBox) =>
        score + 120000 + rectOverlapArea(box, axisBox, 0),
        0);
        const obstacleCollisionScore = obstacleCollisions.reduce((score, obstacleBox) =>
        score + 90000 + rectOverlapArea(box, obstacleBox, 0),
        0);
        const connectorSegments = orbitalConnectorSegments(anchor, clamped, box, cx, cy);
        const connectorConflictScore = occupied.reduce((score, item) =>
        score + orbitalConnectorConflictScore(connectorSegments, box, item),
        0);
        const clampPenalty = pointDistance(point, clamped) * 2.2;
        const shiftPenalty = Math.abs(shiftPx) * 0.12;
        const lanePenalty = laneIndex * 1.4;
        const score = collisionScore + axisCollisionScore + obstacleCollisionScore + connectorConflictScore + clampPenalty + shiftPenalty + lanePenalty;
        const candidate = {
          ...input,
          anchor,
          label: clamped,
          box,
          laneIndex,
          radius,
          width: labelSize.width,
          height: labelSize.height,
          displayAngleDeg,
          tangentialShift: shiftPx,
          connectorSegments
        };

        const improvesPlacement = hardCollisionCount < bestHardCollisionCount ||
        hardCollisionCount === bestHardCollisionCount && hardOverlapArea < bestHardOverlapArea ||
        hardCollisionCount === bestHardCollisionCount && hardOverlapArea === bestHardOverlapArea && score < bestScore;

        if (improvesPlacement) {
          best = candidate;
          bestScore = score;
          bestHardCollisionCount = hardCollisionCount;
          bestHardOverlapArea = hardOverlapArea;
        }

        if (hardCollisionCount === 0 && connectorConflictScore === 0 && clampPenalty === 0 && shiftPenalty === 0 && lanePenalty === 0) break;
      }
      if (bestHardCollisionCount === 0 && bestScore === 0) break;
    }

    const fallbackRadius = radii[0] || anchorRadius + 40;
    const fallbackLabel = orbitalPolarToCartesian(cx, cy, fallbackRadius, input.angleDeg, chartZero);
    const fallbackBox = orbitalLabelBox(fallbackLabel, labelSize);
    const fallbackConnectorSegments = orbitalConnectorSegments(anchor, fallbackLabel, fallbackBox, cx, cy);
    const placement = best || {
      ...input,
      anchor,
      label: fallbackLabel,
      box: fallbackBox,
      laneIndex: 0,
      radius: fallbackRadius,
      width: labelSize.width,
      height: labelSize.height,
      displayAngleDeg: Number(input.angleDeg),
      tangentialShift: 0,
      connectorSegments: fallbackConnectorSegments
    };

    occupied.push(placement);
    return placement;
  });
}

function orbitalAxisCollisionBoxes({ cx, cy, anchorRadius, width, height, padding }) {
  const safeWidth = Math.max(cx * 2, Number(width) || 0);
  const safeHeight = Math.max(cy * 2, Number(height) || 0);
  const halfBand = Math.max(34, Number(padding) || 0);
  const innerRadius = Math.max(0, Number(anchorRadius) - 18);
  const verticalEdge = Math.max(0, cy - innerRadius);
  const horizontalEdge = Math.max(0, cx - innerRadius);

  return [
  { x: cx - halfBand, y: 0, width: halfBand * 2, height: verticalEdge },
  { x: cx - halfBand, y: cy + innerRadius, width: halfBand * 2, height: Math.max(0, safeHeight - (cy + innerRadius)) },
  { x: 0, y: cy - halfBand, width: horizontalEdge, height: halfBand * 2 },
  { x: cx + innerRadius, y: cy - halfBand, width: Math.max(0, safeWidth - (cx + innerRadius)), height: halfBand * 2 }];

}

function assignLabelLane(input, options = {}) {
  const presets = options.laneRadiiByGroup || {};
  const groupRadii = presets[input.group];
  return Array.isArray(groupRadii) && groupRadii.length ? groupRadii : options.laneRadii || [];
}

function detectLabelCollision(a, b, minGapX = 34, minGapY = 22) {
  return !(
  a.x + a.width + minGapX <= b.x ||
  b.x + b.width + minGapX <= a.x ||
  a.y + a.height + minGapY <= b.y ||
  b.y + b.height + minGapY <= a.y);

}

function orbitalTangentialShifts(maxShiftPx = 34) {
  const maxShift = Math.max(0, Number(maxShiftPx) || 0);
  if (!maxShift) return [0];
  const step = Math.max(8, Math.min(12, maxShift / 3));
  const shifts = [0];
  for (let value = step; value < maxShift; value += step) {
    shifts.push(-round(value, 1), round(value, 1));
  }
  shifts.push(-maxShift, maxShift);
  return [...new Set(shifts)];
}

function orbitalLabelBox(point, size) {
  return {
    x: round(point.x - size.width / 2, 1),
    y: round(point.y - size.height / 2, 1),
    width: size.width,
    height: size.height
  };
}

function orbitalConnectorSegments(anchor, label, box, cx, cy) {
  const end = rectEdgePointFromCenter(cx, cy, label, box);
  const distance = pointDistance(anchor, end);
  if (distance <= 44) return [{ start: anchor, end }];

  const vector = unitVector(cx, cy, anchor.x, anchor.y);
  const elbowDistance = Math.min(20, Math.max(11, distance * 0.32));
  const elbow = offsetPoint(anchor, vector, elbowDistance);
  return [
  { start: anchor, end: elbow },
  { start: elbow, end }];

}

function orbitalConnectorConflictScore(candidateSegments, candidateBox, placedItem) {
  const placedSegments = Array.isArray(placedItem?.connectorSegments) ? placedItem.connectorSegments : [];
  let score = 0;

  candidateSegments.forEach((candidateSegment) => {
    placedSegments.forEach((placedSegment) => {
      if (segmentsCrossInside(candidateSegment.start, candidateSegment.end, placedSegment.start, placedSegment.end)) {
        score += 240000;
      }
    });
    if (segmentIntersectsLabelBox(candidateSegment, placedItem?.box, 3)) score += 180000;
  });

  placedSegments.forEach((placedSegment) => {
    if (segmentIntersectsLabelBox(placedSegment, candidateBox, 3)) score += 180000;
  });

  return score;
}

function segmentsCrossInside(a, b, c, d) {
  const denominator = (d.y - c.y) * (b.x - a.x) - (d.x - c.x) * (b.y - a.y);
  if (Math.abs(denominator) < 0.0001) return false;
  const uA = ((d.x - c.x) * (a.y - c.y) - (d.y - c.y) * (a.x - c.x)) / denominator;
  const uB = ((b.x - a.x) * (a.y - c.y) - (b.y - a.y) * (a.x - c.x)) / denominator;
  const endpointTolerance = 0.025;
  return uA > endpointTolerance && uA < 1 - endpointTolerance &&
  uB > endpointTolerance && uB < 1 - endpointTolerance;
}

function segmentIntersectsLabelBox(segment, box, padding = 0) {
  if (!box) return false;
  const left = box.x - padding;
  const right = box.x + box.width + padding;
  const top = box.y - padding;
  const bottom = box.y + box.height + padding;
  const inside = (point) => point.x > left && point.x < right && point.y > top && point.y < bottom;
  if (inside(segment.start) || inside(segment.end)) return true;

  const topLeft = { x: left, y: top };
  const topRight = { x: right, y: top };
  const bottomRight = { x: right, y: bottom };
  const bottomLeft = { x: left, y: bottom };
  return [
  [topLeft, topRight],
  [topRight, bottomRight],
  [bottomRight, bottomLeft],
  [bottomLeft, topLeft]].
  some(([start, end]) => segmentsCrossInside(segment.start, segment.end, start, end));
}

function clampOrbitalLabelPoint(point, size, bounds) {
  if (!bounds) return { x: round(point.x, 2), y: round(point.y, 2) };
  let x = Number(point.x);
  let y = Number(point.y);
  const margin = Number(bounds.margin) || 0;
  const halfWidth = size.width / 2;
  const halfHeight = size.height / 2;
  const minX = margin + halfWidth;
  const maxX = Number(bounds.width) - margin - halfWidth;
  const minY = margin + halfHeight;
  const maxY = Number(bounds.height) - margin - halfHeight;

  if (Number.isFinite(minX) && Number.isFinite(maxX) && minX <= maxX) {
    x = Math.min(maxX, Math.max(minX, x));
  }
  if (Number.isFinite(minY) && Number.isFinite(maxY) && minY <= maxY) {
    y = Math.min(maxY, Math.max(minY, y));
  }

  return { x: round(x, 2), y: round(y, 2) };
}

function exteriorPlanetLabel(planet) {
  const parts = exteriorPlanetLabelParts(planet);
  return `${parts.glyph} ${parts.data}`;
}

function exteriorPlanetLabelParts(planet) {
  const sign = ZODIAC_SYMBOLS[planet.signIndex] || "";
  const retrograde = planet.retrograde ? "℞ " : "";
  return {
    glyph: planetGlyph(planet.key),
    data: `${retrograde}${sign} ${planet.degree}°${pad(planet.minute)}′`
  };
}

function transitLabelBox(point, vector, label = "") {
  const { width, height } = measureAstroLabelApprox(label);
  const minX = point.x - width / 2;
  const maxX = point.x + width / 2;
  const minY = point.y - height / 2;
  const maxY = point.y + height / 2;
  return {
    x: round(minX, 1),
    y: round(minY, 1),
    width: round(maxX - minX, 1),
    height: round(maxY - minY, 1)
  };
}

function boxCenterDistance(a, b) {
  const ax = a.x + a.width / 2;
  const ay = a.y + a.height / 2;
  const bx = b.x + b.width / 2;
  const by = b.y + b.height / 2;
  return Math.sqrt((ax - bx) ** 2 + (ay - by) ** 2);
}

function pointDistance(a, b) {
  return Math.sqrt((Number(a.x) - Number(b.x)) ** 2 + (Number(a.y) - Number(b.y)) ** 2);
}

function arrangePlanetMarkers(planets = [], baseRadius, variant, options = {}) {
  const sorted = planets.
  filter((planet) =>
  (CHART_PLANET_ORDER.includes(planet.key) || planet.key === "midpoint" || planet.key === "tierra") &&
  isChartPlanetVisible(planet.key)
  ).
  sort((a, b) => Number(a.longitude) - Number(b.longitude));
  const groupThreshold = Number.isFinite(Number(options.groupThreshold)) ?
  Number(options.groupThreshold) :
  variant === "overlay" ? 8 : 12;
  const minSpacing = Number.isFinite(Number(options.minSpacing)) ?
  Number(options.minSpacing) :
  variant === "overlay" ? 5.6 : 7.8;
  const markerRadius = variant === "overlay" ? baseRadius : baseRadius - 4;
  const defaultLabelOffset = variant === "overlay" ? 26 : 18;
  const labelOffset = Number.isFinite(Number(options.labelOffset)) ? Number(options.labelOffset) : defaultLabelOffset;
  const labelRadius = baseRadius + labelOffset;
  const groups = [];

  sorted.forEach((planet) => {
    const current = groups[groups.length - 1];
    const previous = current?.[current.length - 1];
    if (!current || Number(planet.longitude) - Number(previous.longitude) > groupThreshold) {
      groups.push([planet]);
      return;
    }
    current.push(planet);
  });

  if (groups.length > 1) {
    const first = groups[0];
    const last = groups[groups.length - 1];
    const firstLongitude = Number(first[0].longitude);
    const lastLongitude = Number(last[last.length - 1].longitude);
    if (firstLongitude + 360 - lastLongitude <= groupThreshold) {
      groups[groups.length - 1] = [...last, ...first];
      groups.shift();
    }
  }

  return groups.flatMap((group) => {
    if (group.length === 1) {
      return [{ ...group[0], markerRadius, displayLongitude: Number(group[0].longitude), labelRadius }];
    }

    const unwrapped = [];
    group.forEach((planet, index) => {
      let longitude = Number(planet.longitude);
      if (index > 0) {
        // Equal longitudes are exact conjunctions, not a wrap through 0 degrees.
        while (longitude < unwrapped[index - 1]) longitude += 360;
      }
      unwrapped.push(longitude);
    });
    const naturalSpan = unwrapped[unwrapped.length - 1] - unwrapped[0];
    const spacing = Math.max(minSpacing, naturalSpan / Math.max(1, group.length - 1));
    const centerLongitude = unwrapped.reduce((sum, longitude) => sum + longitude, 0) / unwrapped.length;

    return group.map((planet, index) => ({
      ...planet,
      markerRadius,
      displayLongitude: norm360Client(centerLongitude + (index - (group.length - 1) / 2) * spacing),
      labelRadius
    }));
  });
}

function renderAngleMarkers(chart, center, innerRadius, outerRadius, chartZero, housesSource, options = {}) {
  const displayHouses = housesSource || chartDisplayHouses(chart);
  const proxyOnly = options.hideAngleMarkerVisuals === true;
  return CHART_ANGLE_POINTS.map((entry) => {
    const point = chartAngleAspectPoint(chart, entry.key);
    const house = displayHouses.find((item) => Number(item.number) === entry.house);
    const longitude = Number(point?.longitude ?? house?.longitude);
    if (!Number.isFinite(longitude)) return "";
    const pointA = chartPoint(center, center, innerRadius, longitude, chartZero);
    const pointB = chartPoint(center, center, outerRadius - 28, longitude, chartZero);
    const labelPoint = chartPoint(center, center, outerRadius, longitude, chartZero);
    const signSymbol = ZODIAC_SYMBOLS[point.signIndex] || "";
    const isHorizontalAngle = entry.house === 1 || entry.house === 7;
    const useMultipleMargins = Boolean(options.multiple);
    const textAnchor = entry.house === 1 ?
    "end" :
    entry.house === 7 ?
    "start" :
    "middle";
    const labelX = entry.house === 1 ?
    useMultipleMargins ? labelPoint.x + 22 : labelPoint.x + 12 :
    entry.house === 7 ?
    useMultipleMargins ? labelPoint.x - 22 : labelPoint.x - 18 :
    labelPoint.x;
    const labelY = isHorizontalAngle ? labelPoint.y - 28 : labelPoint.y;
    const hitX = proxyOnly ?
    labelPoint.x :
    entry.house === 1 ?
    labelX - (options.compact ? 24 : 31) :
    entry.house === 7 ?
    labelX + (options.compact ? 28 : 36) :
    labelPoint.x;
    const hitY = proxyOnly ?
    labelPoint.y :
    isHorizontalAngle ? labelY + (options.compact ? 5 : 7) : labelPoint.y;
    const hitRadius = proxyOnly ?
    options.compact ? 34 : 42 :
    options.multiple ?
    entry.house === 7 ?
    62 :
    entry.house === 1 ?
    56 :
    48 :
    options.compact ? 28 : 36;
    const angleLabelMarkup = `
      <tspan x="${isHorizontalAngle ? labelX : labelPoint.x}" dy="0" class="chart-angle-label-name">${escapeHtml(entry.key === "ImumCoeli" ? T("charts.imumCoeliAbbreviation") : entry.shortLabel)}</tspan>
      <tspan class="chart-angle-label-sign"> ${escapeHtml(signSymbol)}</tspan>
      <tspan x="${isHorizontalAngle ? labelX : labelPoint.x}" dy="1.18em" class="chart-angle-label-position">${point.degree}º ${pad(point.minute)}'</tspan>
    `;
    const labelMarkup = proxyOnly ?
    "" :
    isHorizontalAngle ?
    `
        <text x="${labelX}" y="${labelY}" class="chart-angle-label chart-angle-label-split" text-anchor="${textAnchor}">
          ${angleLabelMarkup}
        </text>
      ` :
    `<text x="${labelPoint.x}" y="${labelPoint.y}" class="chart-angle-label chart-angle-label-vertical" text-anchor="middle">${angleLabelMarkup}</text>`;
    const visibilityClass = chartPlanetVisibilityClass(entry.key);
    const interactionAttributes = chartPlanetInteractionAttributes(point, {
      interactivePlanets: options.interactivePlanets === true,
      interactionLayer: "base",
      interactionContext: options.natalInteractionLabel || chart.label || "Carta base",
      nodalAsc: chart.type === "nodal" ? Number(chart.ascendant?.longitude) : Number.NaN,
      houseCusps: displayHouses,
      reverseHouses: chart.type === "memoria"
    });
    return `
      <g class="chart-angle-marker chart-angle-planet chart-planet${proxyOnly ? " chart-angle-marker-proxy" : ""}${visibilityClass}" data-chart-planet-key="${escapeHtml(entry.key)}" data-planet-title="${escapeHtml(entry.label)}" ${interactionAttributes} style="--planet-color:${chartPlanetColorCssValue(entry.key, "var(--danger)")};--angle-sign-color:${ZODIAC_LIGHT_GLYPH_COLORS[point.signIndex] || ZODIAC_GLYPH_COLORS[point.signIndex] || "var(--danger)"};--angle-sign-dark-color:${ZODIAC_GLYPH_COLORS[point.signIndex] || ZODIAC_LIGHT_GLYPH_COLORS[point.signIndex] || "var(--danger)"};--angle-label-name-size:${options.compact ? 17 : 24}px;--angle-label-sign-size:${options.compact ? 17 : 23}px;--angle-label-position-size:${options.compact ? 13 : 16}px">
        ${proxyOnly ? "" : `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" class="chart-angle-line"></line>`}
        <circle cx="${hitX}" cy="${hitY}" r="${hitRadius}" class="chart-planet-hit chart-angle-hit"></circle>
        ${labelMarkup}
      </g>
    `;
  }).join("");
}

function renderChartSideStats(chart) {
  return `
    ${renderModeElementStats(chart, "mode")}
    ${renderModeElementStats(chart, "element")}
    ${renderMiniAspectGrid(chart)}
  `;
}

function renderModeElementStats(chart, kind) {
  const labels = kind === "mode" ?
  [
  { key: 0, get label() {return T("interface.cardinal");}, color: "#e9565f" },
  { key: 1, get label() {return T("interface.fijo");}, color: "#55a7e8" },
  { key: 2, get label() {return T("interface.mutable");}, color: "#f1b949" }] :

  [
  { key: 0, get label() {return T("interface.fuego");}, color: "#e9565f" },
  { key: 1, get label() {return T("interface.tierra");}, color: "#81c784" },
  { key: 2, get label() {return T("interface.aire");}, color: "#f1b949" },
  { key: 3, get label() {return T("interface.agua");}, color: "#55a7e8" }];

  const counts = Object.fromEntries(labels.map((item) => [item.key, 0]));
  const countedPlanets = (chart.planets || []).filter((planet) =>
  CHART_PLANET_ORDER.slice(0, 10).includes(planet.key) && isChartPlanetVisible(planet.key)
  );
  countedPlanets.forEach((planet) => {
    const index = kind === "mode" ? planet.signIndex % 3 : planet.signIndex % 4;
    counts[index] = (counts[index] || 0) + 1;
  });
  const max = Math.max(1, ...Object.values(counts));
  const rows = labels.map((item) => `
    <div class="chart-stat-row">
      <span>${escapeHtml(I18n.label(item.label))}</span>
      <b class="chart-stat-track"><i style="width:${counts[item.key] / max * 100}%; background:${item.color}"></i></b>
      <strong>${counts[item.key]}</strong>
    </div>
  `).join("");

  return `
    <section class="chart-stat-box">
      <h4>${kind === "mode" ? T("charts.tableModes") : T("charts.tableElements")}</h4>
      ${rows}
    </section>
  `;
}

function renderMiniAspectGrid(chart) {
  const planets = CHART_PLANET_ORDER.
  slice(0, 10).
  map((key) => chart.planetsByKey?.[key]).
  filter((planet) => Boolean(planet) && isChartPlanetVisible(planet.key));
  const aspects = filterEnabledAspects(chartAspectsIncludingAngles(chart)).
  filter((aspect) => isAspectConsistentWithCurrentRules(chart, aspect));
  if (planets.length < 2 || !aspects.length) return "";

  const aspectKey = (a, b) => [a, b].sort().join("|");
  const aspectMap = new Map(aspects.map((aspect) => [aspectKey(aspect.planetA, aspect.planetB), aspect]));
  const header = planets.map((planet) => `<th class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}</th>`).join("");
  const rows = planets.map((rowPlanet, rowIndex) => `
    <tr>
      <th class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(rowPlanet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(rowPlanet.key, "var(--text)")}">${escapeHtml(planetGlyph(rowPlanet.key))}</th>
      ${planets.map((columnPlanet, columnIndex) => {
    if (columnIndex >= rowIndex) return "<td></td>";
    const aspect = aspectMap.get(aspectKey(rowPlanet.key, columnPlanet.key));
    return aspect ?
    `<td><span style="color:${chartAspectColorCssValue(aspect.angle)}">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || aspect.angle)}</span><small>${aspect.orb === null || aspect.orb === undefined ? "" : formatOrb(aspect.orb)}</small></td>` :
    "<td></td>";
  }).join("")}
    </tr>
  `).join("");

  return `
    <section class="chart-stat-box chart-mini-aspects">
      <h4>${T("interface.aspectos")}</h4>
      <table class="chart-mini-aspect-grid">
        <thead><tr><th></th>${header}</tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </section>
  `;
}

function renderChartSideTables(chart) {
  return `
    <section class="chart-stat-box">
      <h4>${T("interface.cuspides_casas")}</h4>
      ${renderInlineCuspTable(chart)}
    </section>
    <section class="chart-stat-box">
      <h4>${T("interface.longitud_value", { v1: escapeHtml(chartShortLabel(chart)) })}</h4>
      ${renderInlineLongitudeTable(chart)}
    </section>
  `;
}

function progressionInformationPanel(calculation) {
  const targetMoment = progressedLocalMoment(calculation, { useControls: false }).label || "No determinado";
  const progressedDate = [calculation?.dateUsedBySwetest, calculation?.utTimeUsedBySwetest].
  filter(Boolean).
  join(" ") || T("interface.no_determinada");
  const age = Number(calculation?.ageYears);
  const ageLabel = Number.isFinite(age) ? T("interface.value_anos_3", { v0: age.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }) : T("interface.no_determinada");



  return floatingPanel(
    "tropical-progresada-progresion",
    "Progresión secundaria",
    currentChartPersonName(), `
      <dl class="chart-calculation-details">
        <div><dt>${T("interface.momento_de_progresion")}</dt><dd>${escapeHtml(targetMoment)}</dd></div>
        <div><dt>${T("interface.edad_simbolica")}</dt><dd>${escapeHtml(ageLabel)}</dd></div>
        <div><dt>${T("interface.fecha_de_efemerides")}</dt><dd>${T("interface.value_ut", { v2: escapeHtml(progressedDate) })}</dd></div>
        <div><dt>${T("interface.clave_planetaria")}</dt><dd>${T("interface.1_dia_por_1_ano_tropical")}</dd></div>
        <div><dt>${T("interface.casas_y_ejes")}</dt><dd>${T("interface.clave_de_naibod_sobre_el_armc_natal")}</dd></div>
        <div><dt>${T("interface.retrogrados_natales")}</dt><dd>${escapeHtml(calculation?.progressedStations?.natalRetrogradeCount || 0)}</dd></div>
        <div><dt>${T("interface.directos_en_esta_fecha")}</dt><dd>${escapeHtml(calculation?.progressedStations?.directAtTargetCount || 0)}</dd></div>
        <div><dt>${T("interface.zona_de_referencia")}</dt><dd>${escapeHtml(calculation?.targetTimeZone || "UTC")}</dd></div>
      </dl>
    `,

    "right"
  );
}

function formatProgressedStationAge(value) {
  const age = Number(value);
  if (!Number.isFinite(age) || age < 0) return "No determinada";
  const totalMonths = Math.max(0, Math.round(age * 12));
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  const yearLabel = `${years} ${years === 1 ? "año" : "años"}`;
  if (!months) return yearLabel;
  return `${yearLabel} y ${months} ${months === 1 ? "mes" : "meses"}`;
}

function progressedStationPosition(item) {
  const position = item?.stationPosition;
  if (!position) return "No determinada";
  return [
  position.sign,
  `${position.degree}º ${pad(position.minute)}' ${pad(position.second)}\"`].
  filter(Boolean).join(" · ");
}

function progressedStationsPanel(calculation) {
  const data = calculation?.progressedStations;
  const items = Array.isArray(data?.items) ? data.items : [];
  const targetMoment = progressedLocalMoment(calculation, { useControls: false }).label || "Fecha elegida";
  const maxAge = Number(data?.maxAgeYears) || 120;

  if (!items.length) {
    return floatingPanel(
      "tropical-progresada-estaciones",
      "Estaciones progresadas",
      currentChartPersonName(), `
        <div class="progressed-stations-empty">
          <span aria-hidden="true">✓</span>
          <strong>${T("interface.sin_planetas_retrogrados_natales")}</strong>
          <p>${T("interface.entre_mercurio_y_pluton_no_hay_planetas_retrogrados_que_necesiten_calcular_una_estaci")}</p>
        </div>
        ${progressedStationsMethodNote(maxAge)}
      `,

      "right",
      { className: "floating-chart-panel-stations" }
    );
  }

  const cards = items.map((item) => {
    const found = Boolean(item.stationFound);
    const isDirect = item.statusAtTarget === "direct";
    const ageLabel = found ? formatProgressedStationAge(item.stationAgeYears) : T("interface.no_antes_de_los_value_anos", { v0: maxAge });
    const lifeMoment = found ?
    [formatContextDate(item.stationLifeDate), item.stationLifeTime, item.stationTimeZone].filter(Boolean).join(" · ") :
    "Sin estación directa en el rango calculado";
    const statusLabel = found ?
    isDirect ? T("interface.directo_desde_los_value", { v0: ageLabel }) : T("interface.retrogrado_directo_a_los_value", { v0: ageLabel }) : T("interface.retrogrado_mas_alla_de_los_value_anos", { v0: maxAge });

    return `
      <article class="progressed-station-card ${isDirect ? "is-direct" : "is-retrograde"}">
        <header>
          <span class="progressed-station-planet astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(item.planet)}" style="--astro-table-color:${chartPlanetColorCssValue(item.planet, "var(--text)")}" aria-hidden="true">${escapeHtml(planetGlyph(item.planet))}</span>
          <div>
            <strong>${escapeHtml(I18n.label(PROMPT_PLANET_LABELS[item.planet] || item.label || item.planet))}</strong>
            <span>${T("interface.retrogrado_natal")}</span>
          </div>
          <b class="progressed-station-status">${escapeHtml(isDirect ? T("interface.directo") : T("interface.retrogrado"))}</b>
        </header>
        <p class="progressed-station-summary">${escapeHtml(statusLabel)}</p>
        <dl>
          <div><dt>${T("interface.estacion_directa")}</dt><dd>${escapeHtml(ageLabel)}</dd></div>
          <div><dt>${T("interface.fecha_personal")}</dt><dd>${escapeHtml(lifeMoment)}</dd></div>
          ${found ? `<div><dt>${T("interface.grado_de_estacion")}</dt><dd>${escapeHtml(progressedStationPosition(item))}</dd></div>` : ""}
          <div><dt>${T("interface.en_la_fecha_elegida")}</dt><dd>${escapeHtml(isDirect ? T("interface.directo") : T("interface.retrogrado"))}</dd></div>
        </dl>
      </article>
    `;
  }).join("");

  return floatingPanel(
    "tropical-progresada-estaciones",
    "Estaciones progresadas",
    `${items.length} retrógrado${items.length === 1 ? "" : "s"} natal${items.length === 1 ? "" : "es"} · ${targetMoment}`,
    `
      <div class="progressed-stations-list">${cards}</div>
      ${progressedStationsMethodNote(maxAge)}
    `,
    "right",
    { className: "floating-chart-panel-stations" }
  );
}

function progressedStationsMethodNote(maxAge) {
  return `
    <p class="progressed-stations-note">
      ${T("interface.edad_simbolica_segun_progresion_secundaria_clasica_1_dia_de_efemerides_equivale_a_1_a", { v0: escapeHtml(maxAge) })}
    </p>
  `;

}

function chartPatternOrbText(value) {
  const numeric = Math.max(0, Number(value) || 0);
  let degrees = Math.floor(numeric);
  let minutes = Math.round((numeric - degrees) * 60);
  if (minutes === 60) {
    degrees += 1;
    minutes = 0;
  }
  return `${degrees}°${pad(minutes)}′`;
}

function chartPatternPlanetLabel(key) {
  return PROMPT_PLANET_LABELS[key] || key;
}

function chartPatternRoleText(pattern) {
  const apex = pattern?.roles?.apex;
  if (apex) return `Ápice: ${chartPatternPlanetLabel(apex)}`;
  const focus = pattern?.roles?.focus;
  if (focus) return `Foco: ${chartPatternPlanetLabel(focus)}`;
  return "";
}

function chartPatternContainedText(pattern) {
  const contained = Array.isArray(pattern?.contains) ? pattern.contains : [];
  if (!contained.length) return "";
  const labels = [...new Set(contained.map((item) => item.label).filter(Boolean))];
  if (labels.length === 1 && contained.length > 1) {
    const label = contained[0]?.type === "t_square" ? T("interface.t_cuadradas") : labels[0];
    return `Integra ${contained.length} ${label}`;
  }
  return `Incluye ${labels.join(" y ")}`;
}

function chartPatternMiniature(pattern, chart) {
  const center = 24;
  const radius = 16;
  const points = new Map((pattern?.planets || []).map((key) => {
    const longitude = norm360Client(Number(chartAspectPlanet(chart, key)?.longitude) || 0);
    const radians = (longitude - 90) * Math.PI / 180;
    return [key, {
      x: round(center + Math.cos(radians) * radius, 2),
      y: round(center + Math.sin(radians) * radius, 2)
    }];
  }));
  const lines = (pattern?.edges || []).map((edge) => {
    const pointA = points.get(edge.planetA);
    const pointB = points.get(edge.planetB);
    if (!pointA || !pointB) return "";
    return `<line x1="${pointA.x}" y1="${pointA.y}" x2="${pointB.x}" y2="${pointB.y}" style="stroke:${chartAspectColorCssValue(edge.angle)}"></line>`;
  }).join("");
  const nodes = (pattern?.planets || []).map((key) => {
    const point = points.get(key);
    if (!point) return "";
    return `<circle cx="${point.x}" cy="${point.y}" r="2.25" style="fill:${chartPlanetColorCssValue(key, "var(--accent)")};stroke:var(--surface);stroke-width:1.1"></circle>`;
  }).join("");
  return `<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle cx="24" cy="24" r="16" opacity=".2"></circle>${lines}${nodes}</svg>`;
}

function renderChartPatternCard(pattern, chart, panelPrefix) {
  const edgeData = (pattern.edges || []).map((edge) =>
  `${edge.planetA}|${edge.planetB}|${Number(edge.angle)}`
  ).join(";");
  const planetData = (pattern.planets || []).join("|");
  const planetChips = (pattern.planets || []).map((key) => `
    <span class="chart-pattern-planet-chip">
      <span style="color:${chartPlanetColorCssValue(key, "var(--text)")}" aria-hidden="true">${escapeHtml(planetGlyph(key))}</span>
      ${escapeHtml(chartPatternPlanetLabel(key))}
    </span>
  `).join("");
  const roleText = chartPatternRoleText(pattern);
  const containedText = chartPatternContainedText(pattern);
  const accessibleLabel = [
  `Resaltar ${pattern.label} en la carta.`,
  pattern.sourceLabel ? `Carta ${pattern.sourceLabel}.` : "",
  pattern.description,
  `Planetas: ${(pattern.planets || []).map(chartPatternPlanetLabel).join(", ")}.`,
  `Orbe máximo ${chartPatternOrbText(pattern.maxOrb)}.`,
  roleText,
  containedText,
  pattern.dissociated ? "Figura disociada." : ""].
  filter(Boolean).join(" ");

  return `
    <button
      class="chart-pattern-card"
      type="button"
      data-chart-pattern-id="${escapeHtml(pattern.id)}"
      data-chart-pattern-prefix="${escapeHtml(panelPrefix)}"
      data-chart-pattern-layer="${escapeHtml(pattern.layer || "base")}"
      data-chart-pattern-planets="${escapeHtml(planetData)}"
      data-chart-pattern-edges="${escapeHtml(edgeData)}"
      aria-label="${escapeHtml(accessibleLabel)}"
      aria-pressed="false"
    >
      <span class="chart-pattern-card-visual">${chartPatternMiniature(pattern, pattern.sourceChart || chart)}</span>
      <span class="chart-pattern-card-copy">
        <span class="chart-pattern-card-heading">
          <strong class="chart-pattern-card-title">${escapeHtml(I18n.label(pattern.label))}</strong>
          ${pattern.sourceLabel ? `<span class="chart-pattern-card-badge">${escapeHtml(pattern.sourceLabel)}</span>` : ""}
          ${pattern.dissociated ? `<span class="chart-pattern-card-badge" title="${T("interface.la_geometria_es_valida_por_grados_aunque_no_mantiene_la_relacion_clasica_entre_signos")}">${T("interface.disociada")}</span>` : ""}
        </span>
        <span class="chart-pattern-card-description">${escapeHtml(I18n.label(pattern.description))}</span>
        <span class="chart-pattern-card-planets">${planetChips}</span>
        <span class="chart-pattern-card-meta">
          <span>${T("interface.orbe_max_value", { v12: escapeHtml(chartPatternOrbText(pattern.maxOrb)) })}</span>
          ${roleText ? `<span>${escapeHtml(roleText)}</span>` : ""}
          ${containedText ? `<span>${escapeHtml(containedText)}</span>` : ""}
        </span>
      </span>
    </button>
  `;
}

function renderChartPatternPanel(patterns, chart, panelPrefix, options = {}) {
  if (!patterns.length) {
    return `
      <div class="chart-pattern-panel">
        <div class="chart-pattern-empty">
          <strong>${T("interface.no_se_detectan_figuras_mayores")}</strong>
          <p>${T("interface.esta_carta_no_forma_una_gran_cruz_t_cuadrada_gran_trino_cometa_yod_dedo_de_dios_ni_re")}</p>
        </div>
      </div>
    `;
  }

  return `
    <div class="chart-pattern-panel">
      <p class="chart-pattern-intro">
        ${T("interface.configuraciones_formadas_por_los_diez_planetas_principales_selecciona_una_para_aislar", { get v0() {return ["transits", "progressed"].includes(options.detailMode) ? T("interface.las_figuras_natales_y_las_de_la_carta_de_la_fecha_seleccionada_se_calculan_por_separa") : "";} })}
      </p>
      <div class="chart-pattern-list">
        ${patterns.map((pattern) => renderChartPatternCard(pattern, chart, panelPrefix)).join("")}
      </div>
      <button class="chart-pattern-reset" type="button" data-chart-pattern-clear="true" data-chart-pattern-prefix="${escapeHtml(panelPrefix)}">
        ${T("interface.mostrar_la_carta_completa")}
      </button>
      <p class="chart-pattern-intro">${T("interface.criterio_estricto_de_orbes_sin_angulos_nodos_ni_puntos_matematicos")}</p>
    </div>
  `;

}

function chartAspectPatternPanel(chart, options = {}) {
  if (!chartSupportsAspectPatterns(chart, options)) return "";
  const prefix = chartPanelPrefix(options.panelTitle || chart?.label, chart, options);
  const patterns = chartAspectPatterns(chart, options);
  const countLabel = patterns.length === 1 ? T("interface.1_figura_detectada") : T("interface.value_figuras_detectadas", { v0: patterns.length });
  const multipleClass = options.multiplePosition ?
  ` floating-chart-panel-multiple-patterns floating-chart-panel-multiple-${options.multiplePosition}` :
  "";
  return floatingPanel(
    `${prefix}-figuras`,
    "Figuras de aspectos",
    `${countLabel} · ${chartShortLabel(chart)}`,
    renderChartPatternPanel(patterns, chart, prefix, options),
    "left",
    {
      kind: "figuras",
      slot: "left-middle",
      className: `floating-chart-panel-patterns${multipleClass}`
    }
  );
}

function chartTechnicalPanels(chart, options = {}) {
  if (!chartHasVisibleHouses(chart)) {
    options = { ...options, hideHouseColumns: true, hideHouseTechnicalPanels: true };
  }
  const prefix = chartPanelPrefix(options.panelTitle || chart?.label, chart, options);
  const label = chartShortLabel(chart);
  const links = [
  floatingPanel(
    `${prefix}-longitud`,
    options.longitudePanelTitle || `Longitud ${label}`,
    options.longitudePanelSubtitle || chart.label || label,
    renderInlineLongitudeTable(chart, options),
    "right"
  ),
  options.hideHouseTechnicalPanels ? "" : floatingPanel(`${prefix}-cuspides`, "Cúspides Casas", chart.label || label, renderInlineCuspTable(chart), "right"),
  options.aspectPanelHtml || floatingAspectPanel("Aspectos", chart.label || label, chartPanelAspects(chart), `${prefix}-aspectos`, "left"),
  chartAspectPatternPanel(chart, options),
  floatingPanel(`${prefix}-modos`, "Modos", chart.label || label, renderModeElementStats(chart, "mode"), "left"),
  floatingPanel(`${prefix}-elementos`, "Elementos", chart.label || label, renderModeElementStats(chart, "element"), "left"),
  options.hideHouseTechnicalPanels ? "" : floatingPanel(`${prefix}-distribucion`, "Distribución", chart.label || label, renderDistributionPanel(chart, options), "left")];

  return links.filter(Boolean);
}

function multipleLongitudePanel(title, chart, position, prefix) {
  const label = chartShortLabel(chart);
  return floatingPanel(
    `${prefix}-longitud`,
    `Longitud ${label}`,
    chart.label || title,
    renderInlineLongitudeTable(chart),
    "right",
    { className: `floating-chart-panel-multiple-longitud floating-chart-panel-multiple-${position}` }
  );
}

function chartPanelAspects(chart) {
  const allowed = new Set(aspectOrderForChart(chart));
  return chartAspectsIncludingAngles(chart).filter((aspect) =>
  isEnabledAspect(aspect) &&
  isAspectConsistentWithCurrentRules(chart, aspect) &&
  isChartAspectTypeVisible(aspect.angle) &&
  allowed.has(aspect.planetA) &&
  allowed.has(aspect.planetB) &&
  isChartPlanetVisible(aspect.planetA) &&
  isChartPlanetVisible(aspect.planetB) &&
  isChartPlanetAspectVisible(aspect.planetA) &&
  isChartPlanetAspectVisible(aspect.planetB)
  );
}

function chartAngleAspectPoint(chart, key) {
  const angleConfig = CHART_ANGLE_POINTS.find((point) => point.key === key);
  if (!angleConfig || !chartHasVisibleHouses(chart)) return null;
  const displayHouses = chartDisplayHouses(chart);
  const housePoint = displayHouses.find((house) => Number(house.number) === angleConfig.house) || null;
  const ascendantLongitude = Number(chart?.ascendant?.longitude);
  const midheavenLongitude = Number(chart?.midheaven?.longitude);
  const fallbackLongitude = key === CHART_ASCENDANT_KEY ?
  ascendantLongitude :
  key === "Midheaven" ?
  midheavenLongitude :
  key === "Descendant" && Number.isFinite(ascendantLongitude) ?
  norm360Client(ascendantLongitude + 180) :
  key === "ImumCoeli" && Number.isFinite(midheavenLongitude) ?
  norm360Client(midheavenLongitude + 180) :
  Number.NaN;
  const longitude = Number.isFinite(Number(housePoint?.longitude)) ?
  Number(housePoint.longitude) :
  fallbackLongitude;
  if (!Number.isFinite(longitude)) return null;
  const chartPointSource = key === CHART_ASCENDANT_KEY ?
  chart?.ascendant :
  key === "Midheaven" ?
  chart?.midheaven :
  null;
  const enriched = Number.isFinite(Number(housePoint?.signIndex)) ?
  housePoint :
  Number.isFinite(Number(chartPointSource?.signIndex)) ?
  chartPointSource :
  enrichChartPointClient(key, longitude);
  return {
    ...enriched,
    key,
    label: angleConfig.label,
    longitude: norm360Client(longitude),
    house: angleConfig.house,
    houseLabel: romanHouse(angleConfig.house),
    retrograde: false
  };
}

function chartAspectsIncludingAngles(chart) {
  const angleKeys = new Set(CHART_ANGLE_POINT_KEYS);
  const calculatedSourceAspects = isSideralAspectChart(chart) ?
  Array.isArray(chart?.aspects) ? chart.aspects : [] :
  chart?.planetsByKey ?
  calculateClientOrbAspects(chart.planetsByKey, chartDisplayHouses(chart)) :
  Array.isArray(chart?.aspects) ? chart.aspects : [];
  const sourceAspects = calculatedSourceAspects.filter((aspect) =>
  !angleKeys.has(aspect?.planetA) && !angleKeys.has(aspect?.planetB)
  );
  const generated = [];
  const houseCusps = normalizeAspectHouseCuspsClient(chartDisplayHouses(chart));

  CHART_ANGLE_POINT_KEYS.forEach((angleKey) => {
    if (!isChartPlanetVisible(angleKey) || !isChartPlanetAspectVisible(angleKey)) return;
    const anglePoint = chartAngleAspectPoint(chart, angleKey);
    if (!anglePoint) return;

    PROMPT_ASPECT_ORDER.forEach((planetKey) => {
      const planet = chartAspectPlanet(chart, planetKey);
      const longitude = Number(planet?.longitude);
      if (!Number.isFinite(longitude)) return;

      if (isSideralAspectChart(chart)) {
        const angle = aspectBySignClient(anglePoint.longitude, longitude);
        if (angle === null || !VISUAL_ASPECT_ANGLES.has(Number(angle))) return;
        const config = ASPECT_CONFIGS.find((item) => Number(item.angle) === Number(angle));
        generated.push({
          planetA: angleKey,
          planetB: planetKey,
          planetALabel: PROMPT_PLANET_LABELS[angleKey],
          planetBLabel: PROMPT_PLANET_LABELS[planetKey] || planetKey,
          angle,
          name: config?.name || "aspecto",
          orb: null,
          distance: round(angularDistanceClient(anglePoint.longitude, longitude), 2),
          rule: "signos_sin_orbe"
        });
        return;
      }

      const aspect = findAspectBetween(anglePoint.longitude, longitude, houseCusps);
      if (!aspect || !isEnabledAspect(aspect)) return;
      generated.push({
        planetA: angleKey,
        planetB: planetKey,
        planetALabel: PROMPT_PLANET_LABELS[angleKey],
        planetBLabel: PROMPT_PLANET_LABELS[planetKey] || planetKey,
        angle: aspect.angle,
        name: aspect.name,
        orb: aspect.orb
      });
    });
  });

  return [...sourceAspects, ...generated];
}

function chartAspectPlanet(chart, key) {
  if (!chart || !key) return null;
  if (CHART_ANGLE_POINT_KEYS.includes(key)) return chartAngleAspectPoint(chart, key);
  return chart.planetsByKey?.[key] || (
  Array.isArray(chart.planets) ? chart.planets.find((planet) => planet.key === key) : null) ||
  null;
}

function isAspectConsistentWithCurrentRules(chart, aspect) {
  if (!chart || !aspect) return true;

  const planetA = chartAspectPlanet(chart, aspect.planetA);
  const planetB = chartAspectPlanet(chart, aspect.planetB);
  const longitudeA = Number(planetA?.longitude);
  const longitudeB = Number(planetB?.longitude);

  if (!Number.isFinite(longitudeA) || !Number.isFinite(longitudeB)) return true;

  if (isSideralAspectChart(chart)) {
    return aspectBySignClient(longitudeA, longitudeB) === Number(aspect.angle);
  }

  const houseCusps = normalizeAspectHouseCuspsClient(chartDisplayHouses(chart));
  const recalculated = findAspectBetween(longitudeA, longitudeB, houseCusps);

  return Boolean(recalculated) && Number(recalculated.angle) === Number(aspect.angle);
}

function aspectOrderForChart(chart) {
  const order = chart?.type === "nodal" ? NODAL_ASPECT_ORDER : PROMPT_ASPECT_ORDER;
  return [...order, ...CHART_ANGLE_POINT_KEYS];
}

function renderInlineCuspTable(chart) {
  const rows = chartDisplayHouses(chart).map((house) => `
    <tr>
      <td>${escapeHtml(I18n.label(house.label || house.number))}</td>
      <td>${positionTinyText(house)}</td>
      <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(house.signIndex)}">${ZODIAC_SYMBOLS[house.signIndex] || ""}</td>
      <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(house.decanate?.absoluteIndex)}">${ZODIAC_SYMBOLS[house.decanate?.absoluteIndex % 12] || ""}</td>
      <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(house.dodecatemoria?.signIndex)}">${ZODIAC_SYMBOLS[house.dodecatemoria?.signIndex] || ""}</td>
    </tr>
  `).join("");

  return `
    <table class="chart-inline-table">
      <tbody>${rows}</tbody>
    </table>
  `;
}

function chartAtlasPosition(planet, chart, markup = positionTinyText(planet)) {
  if (!window.AtlasCharts) return markup;
  const house = !chartHasVisibleHouses(chart) ? null : chartPlanetHouseForInteraction(planet, chartDisplayHouses(chart), chart.type === "memoria");
  return window.AtlasCharts.positionEntry({ ...planet, house }, chart.composite?.chartType || chart.type,
  I18n.label(PROMPT_PLANET_LABELS[planet.key] || planet.key), markup, I18n.label(chart.label || "")) ?? markup;
}

function renderInlineLongitudeTable(chart, options = {}) {
  if (!chartHasVisibleHouses(chart)) options = { ...options, hideHouseColumns: true };
  const order = [...CHART_PLANET_ORDER, "midpoint", "tierra"];
  const rows = order.
  map((key) => chart.planetsByKey?.[key]).
  filter((planet) => Boolean(planet) && isChartPlanetVisible(planet.key)).
  map((planet) => `
      <tr>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}</td>
        <td>${chartAtlasPosition(planet, chart)}${retrogradeTableMark(planet)}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.signIndex)}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.decanate?.absoluteIndex)}">${ZODIAC_SYMBOLS[planet.decanate?.absoluteIndex % 12] || ""}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.dodecatemoria?.signIndex)}">${ZODIAC_SYMBOLS[planet.dodecatemoria?.signIndex] || ""}</td>
        ${options.hideHouseColumns ? "" : `<td>${escapeHtml(planet.houseLabel || planet.house || "")}</td>`}
      </tr>
    `).join("");

  return `
    <table class="chart-inline-table">
      <tbody>${rows}</tbody>
    </table>
  `;
}

function renderDistributionPanel(chart, options = {}) {
  const distribution = chartDistribution(chart);
  const houseRows = Array.from({ length: 12 }, (_, index) => {
    const house = index + 1;
    return `
      <tr>
        <td>${romanHouse(house)}</td>
        <td>${distribution.houseCounts[house] || 0}</td>
      </tr>
    `;
  }).join("");

  return `
    <div class="chart-distribution-panel">
      <div class="distribution-visuals" aria-label="${T("interface.distribucion_visual")}">
        <div class="distribution-circle distribution-quadrants" title="${T("interface.cuadrantes")}">
          <span>${distribution.quadrants.q4}</span>
          <span>${distribution.quadrants.q3}</span>
          <span>${distribution.quadrants.q1}</span>
          <span>${distribution.quadrants.q2}</span>
        </div>
        <div class="distribution-circle distribution-halves-vertical" title="${T("interface.hemisferio_superior_e_inferior")}">
          <span>${distribution.hemisphereUD.up}</span>
          <span>${distribution.hemisphereUD.down}</span>
        </div>
        <div class="distribution-circle distribution-halves-horizontal" title="${T("interface.hemisferio_izquierdo_y_derecho")}">
          <span>${distribution.hemisphereLR.left}</span>
          <span>${distribution.hemisphereLR.right}</span>
        </div>
      </div>
      ${options.hideHouseTechnicalPanels ? "" : `<table class="floating-table distribution-table">
        <thead><tr><th>${T("interface.casa")}</th><th>${T("interface.planetas")}</th></tr></thead>
        <tbody>${houseRows}</tbody>
      </table>`}
    </div>
  `;
}

function chartDisplayHouses(chart) {
  if (!chartHasVisibleHouses(chart)) return [];
  if (isSideralChartClient(chart)) return sideralWholeSignHouses(chart);
  if (chart?.type === "memoria") return memoriaDisplayHouses(chart);
  return chart?.houses || [];
}

function chartHasVisibleHouses(chart) {
  return chart?.noHouses !== true && chart?.houseSystem?.hasHouses !== false;
}

function isSideralChartClient(chart) {
  return chart?.type === "sideral" || chart?.composite?.chartType === "sideral";
}

function memoriaDisplayHouses(chart) {
  const houses = chart?.houses || [];
  if (!houses.length) return [];

  const firstHouse = houses.find((house) => Number(house.number) === 1);
  const ascendantLongitude = Number(chart?.ascendant?.longitude);
  if (firstHouse && Number.isFinite(ascendantLongitude) && angularDistanceClient(firstHouse.longitude, ascendantLongitude) < 0.05) {
    return houses;
  }

  return Array.from({ length: 12 }, (_, index) => {
    const targetHouse = index + 1;
    const sourceHouse = MEMORIA_CUSP_REMAP[targetHouse] || targetHouse;
    const house = houses.find((item) => Number(item.number) === sourceHouse) || houses[index] || houses[0];
    return {
      ...house,
      number: targetHouse,
      label: romanHouse(targetHouse)
    };
  }).filter(Boolean);
}

function sideralWholeSignHouses(chart) {
  const ascendantSignIndex = Number.isFinite(Number(chart?.ascendant?.signIndex)) ?
  Number(chart.ascendant.signIndex) :
  Math.floor(norm360Client(Number(chart?.ascendant?.longitude || chart?.houses?.[0]?.longitude || 0)) / 30);

  return Array.from({ length: 12 }, (_, index) => {
    const signIndex = (ascendantSignIndex + index) % 12;
    return {
      number: index + 1,
      label: romanHouse(index + 1),
      longitude: signIndex * 30,
      sign: PROMPT_SIGNS[signIndex],
      signIndex,
      degree: 0,
      minute: 0,
      second: 0,
      formatted: `0º 00' 00"`,
      decanate: {
        index: 0,
        sign: PROMPT_SIGNS[signIndex],
        absoluteIndex: signIndex * 3
      },
      dodecatemoria: {
        index: 0,
        sign: PROMPT_SIGNS[signIndex],
        signIndex
      }
    };
  });
}

function chartDistribution(chart) {
  const houseCounts = Object.fromEntries(Array.from({ length: 12 }, (_, index) => [index + 1, 0]));
  const quadrants = { q1: 0, q2: 0, q3: 0, q4: 0 };
  const hemisphereUD = { up: 0, down: 0 };
  const hemisphereLR = { left: 0, right: 0 };

  (chart.planets || []).
  filter((planet) =>
  CHART_PLANET_ORDER.slice(0, 10).includes(planet.key) && isChartPlanetVisible(planet.key)
  ).
  forEach((planet) => {
    const house = planetHouseNumber(planet);
    if (!houseCounts[house]) houseCounts[house] = 0;
    houseCounts[house] += 1;

    if (house <= 3) quadrants.q1 += 1;else
    if (house <= 6) quadrants.q2 += 1;else
    if (house <= 9) quadrants.q3 += 1;else
    quadrants.q4 += 1;

    if (house >= 7) hemisphereUD.up += 1;else
    hemisphereUD.down += 1;

    if (house >= 10 || house <= 3) hemisphereLR.left += 1;else
    hemisphereLR.right += 1;
  });

  return { houseCounts, quadrants, hemisphereUD, hemisphereLR };
}

function planetHouseNumber(planet) {
  const numeric = Number(planet.house);
  if (Number.isFinite(numeric) && numeric >= 1 && numeric <= 12) return numeric;
  return romanToHouse(planet.houseLabel) || 1;
}

function romanToHouse(value) {
  const normalized = String(value || "").trim().toUpperCase();
  return {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12
  }[normalized] || 0;
}

function chartShortLabel(chart) {
  if (chart?.type === "solarReturn") return T("interface.revolucion_solar_2");
  if (chart?.type === "composite") return T("interface.compuesta");
  if (chart?.type === "progressed") return T("interface.progresada");
  if (chart.type) return chart.type.charAt(0).toUpperCase() + chart.type.slice(1);
  return (chart.label || T("interface.carta")).split("/")[0].trim();
}

function positionTinyText(point) {
  return `${point.degree}º ${pad(point.minute)}' ${pad(point.second || 0)}"`;
}

function zodiacTableColor(index) {
  const value = Number(index);
  if (!Number.isFinite(value)) return "var(--text)";
  return ZODIAC_TABLE_COLORS[(value % 12 + 12) % 12] || "var(--text)";
}

function zodiacTableColorStyle(index) {
  const value = Number(index);
  if (!Number.isFinite(value)) {
    return "--astro-table-color:var(--text);--astro-table-chart-color:var(--text)";
  }
  const normalizedIndex = (value % 12 + 12) % 12;
  return `--astro-table-color:${ZODIAC_TABLE_COLORS[normalizedIndex] || "var(--text)"};--astro-table-chart-color:${ZODIAC_GLYPH_COLORS[normalizedIndex] || "var(--text)"}`;
}

function retrogradeTableMark(point) {
  return point?.retrograde ? `<span class="retro-mark" title="${T("interface.retrogrado")}">R</span>` : "";
}

function renderChartDetails(chart, options = {}) {
  const rows = (chart.planets || []).
  filter((planet) =>
  ["Sun", "Moon", "true Node", "south Node", "tierra"].includes(planet.key) &&
  isChartPlanetVisible(planet.key)
  ).
  map((planet) => `<li><b>${escapeHtml(I18n.label(planet.label))}</b><span>${T("interface.value_value_value_casa_value", { v1: escapeHtml(I18n.label(I18n.label(planet.sign))), v2: planet.degree, v3: pad(planet.minute), v4: escapeHtml(planet.houseLabel || planet.house || "-") })}</span></li>`).
  join("");
  const overlayRows = options.overlay?.planets ?
  (options.overlay.planets || []).
  filter((planet) =>
  ["Sun", "Moon", "true Node", "south Node"].includes(planet.key) &&
  isChartPlanetVisible(planet.key)
  ).
  map((planet) => `<li><b>${escapeHtml(options.overlayLabel || "Overlay")} ${escapeHtml(I18n.label(planet.label))}</b><span>${escapeHtml(I18n.label(planet.sign))} ${planet.degree}º${pad(planet.minute)}'</span></li>`).
  join("") :
  "";

  return `<div class="chart-wheel-details"><ul>${rows}${overlayRows}</ul></div>`;
}

function floatingPanel(id, title, subtitle, content, side = "right", options = {}) {
  if (!content) return "";
  const isOpen = Boolean(options.open);
  const extraClass = options.className ? ` ${options.className}` : "";
  const panelKind = options.kind || floatingPanelKind(id, title);
  const panelSlot = options.slot || floatingPanelSlot(panelKind, side);
  return `
    <section id="${escapeHtml(id)}" class="floating-chart-panel floating-chart-panel-${escapeHtml(side)}${escapeHtml(extraClass)} ${isOpen ? "" : "is-panel-hidden"}" data-floating-panel="1" data-panel-kind="${escapeHtml(panelKind)}" data-panel-slot="${escapeHtml(panelSlot)}" ${isOpen ? "" : "hidden"}>
      <header class="floating-panel-header" data-drag-handle="1">
        <div>
          <span>${T("interface.mover")}</span>
          <h3>${escapeHtml(title)}</h3>
          <p>${escapeHtml(subtitle || "")}</p>
        </div>
        <button type="button" data-panel-action="close" data-panel-id="${escapeHtml(id)}" aria-label="${T("interface.minimizar_value", { v10: escapeHtml(title) })}">x</button>
      </header>
      <div class="floating-panel-content">${content}</div>
      <span class="floating-resizer floating-resizer-n" data-resize-dir="n" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-e" data-resize-dir="e" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-s" data-resize-dir="s" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-w" data-resize-dir="w" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-ne" data-resize-dir="ne" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-se" data-resize-dir="se" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-sw" data-resize-dir="sw" aria-hidden="true"></span>
      <span class="floating-resizer floating-resizer-nw" data-resize-dir="nw" aria-hidden="true"></span>
    </section>
    ${options.includeLauncher ? `<button class="floating-panel-launcher floating-panel-launcher-${escapeHtml(side)}" type="button" data-panel-action="show" data-panel-id="${escapeHtml(id)}" ${isOpen ? "hidden" : ""}>+ ${escapeHtml(title)}</button>` : ""}
  `;
}

function floatingPanelKind(id, title) {
  const value = `${id || ""} ${title || ""}`;
  const normalized = slugId(value);
  if (normalized.includes("aspectos-personales")) return "aspectos-personales";
  if (normalized.includes("estaciones") || normalized.includes("stations")) return "estaciones";
  if (normalized.includes("longitud") || normalized.includes("longitude")) return "longitud";
  if (normalized.includes("cuspides") || normalized.includes("cusps")) return "cuspides";
  if (normalized.includes("figuras") || normalized.includes("patterns")) return "figuras";
  if (normalized.includes("aspectos") || normalized.includes("aspects")) return "aspectos";
  if (normalized.includes("modos") || normalized.includes("modes")) return "modos";
  if (normalized.includes("elementos") || normalized.includes("elements")) return "elementos";
  if (normalized.includes("distribucion") || normalized.includes("distribution")) return "distribucion";
  return "detalle";
}

function floatingPanelSlot(kind, side = "right") {
  return {
    longitud: "right-top",
    estaciones: "right-middle",
    cuspides: "right-middle",
    aspectos: "left-top",
    figuras: "left-middle",
    "aspectos-personales": "left-middle",
    modos: "left-middle",
    elementos: "left-bottom",
    distribucion: "right-bottom",
    detalle: `${side}-bottom`
  }[kind] || `${side}-bottom`;
}

function floatingAspectPanel(title, subtitle, aspects = [], id = "chart-aspects", side = "right") {
  return floatingPanel(id, title, subtitle, renderFloatingAspectTable(aspects), side);
}

function aspectListPanelFromMatrix(title, subtitle, matrix, id, side = "left") {
  const aspects = matrix.rows.flatMap((row) => row.cells.
  map((cell, columnIndex) => {
    if (!cell) return null;
    const column = matrix.columns[columnIndex];
    if (!column) return null;
    return {
      planetA: row.key,
      planetB: column.key,
      angle: cell.angle,
      name: cell.name || aspectNameForAngle(cell.angle),
      orb: cell.orbValue
    };
  }).
  filter(Boolean));

  return floatingPanel(
    id,
    title,
    `${subtitle} - ${aspects.length} aspectos`,
    renderFloatingAspectTable(aspects),
    side
  );
}

function renderFloatingAspectTable(aspects = []) {
  const visibleAspects = filterEnabledAspects(aspects).filter((aspect) =>
  isChartPlanetVisible(aspect.planetA) && isChartPlanetVisible(aspect.planetB)
  );
  const rows = visibleAspects.length ?
  visibleAspects.map((aspect) => `
      <tr>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(aspect.planetA)}" style="--astro-table-color:${chartPlanetColorCssValue(aspect.planetA, "var(--text)")}">${escapeHtml(planetGlyph(aspect.planetA))}</td>
        <td><span class="aspect-symbol" style="color:${chartAspectColorCssValue(aspect.angle)}">${escapeHtml(ASPECT_SYMBOLS[aspect.angle] || aspect.angle)}</span></td>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(aspect.planetB)}" style="--astro-table-color:${chartPlanetColorCssValue(aspect.planetB, "var(--text)")}">${escapeHtml(planetGlyph(aspect.planetB))}</td>
        <td>${escapeHtml(I18n.label(aspect.name))}</td>
        <td>${aspect.orb === null || aspect.orb === undefined ? "" : `${formatOrb(aspect.orb)}º`}</td>
      </tr>
    `).join("") : `<tr><td colspan="5">${T("interface.no_hay_aspectos_calculados")}</td></tr>`;


  return `
    <table class="floating-table floating-aspect-table">
      <thead><tr><th>A</th><th></th><th>B</th><th>${T("interface.aspecto")}</th><th>${T("interface.orbe")}</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
  `;
}

function transitLongitudePanel(transits, natalChart, options = {}) {
  const rows = (transits?.planets || []).
  filter((planet) => PROMPT_ASPECT_ORDER.includes(planet.key) && isChartPlanetVisible(planet.key)).
  map((planet) => {
    const house = options.hideHouses || !chartHasVisibleHouses(natalChart) || !natalChart.houses?.length ? null : houseNumberFromCuspsClient(planet.longitude, natalChart.houses);
    return `
        <tr>
          <td class="floating-planet astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}${planet.retrograde ? '<span class="retro-mark">R</span>' : ""}</td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.signIndex)}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</span></td>
          <td>${chartAtlasPosition({ ...planet, house }, { type: "transits", get label() {return T("charts.transitsNatalHouses");}, noHouses: options.hideHouses }, `${planet.degree}º ${pad(planet.minute)}' ${pad(planet.second)}"`)}</td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.decanate?.absoluteIndex)}">${ZODIAC_SYMBOLS[planet.decanate?.absoluteIndex % 12] || ""}</span></td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.dodecatemoria?.signIndex)}">${ZODIAC_SYMBOLS[planet.dodecatemoria?.signIndex] || ""}</span></td>
          ${options.hideHouses ? "" : `<td>${romanHouse(house)}</td>`}
        </tr>
      `;
  }).join("");

  const transitMoment = rows ? transitLocalMoment(transits).label : "Sin datos";
  const subtitle = options.hideHouses ? T("interface.value_sin_casas", { v0: transitMoment }) : T("interface.value_casas_sobre_tropical", { v0: transitMoment });


  return floatingPanel(options.panelId || "transit-longitudes", "Longitud de tránsitos", subtitle, `
    <table class="floating-table transit-position-table">
      <thead><tr><th>${T("interface.pl")}</th><th>${T("interface.signo")}</th><th>${T("interface.longitud")}</th><th>${T("interface.dec")}</th><th>${T("interface.dod")}</th>${options.hideHouses ? "" : `<th>${T("interface.casa")}</th>`}</tr></thead>
      <tbody>${rows || `<tr><td colspan="${options.hideHouses ? 5 : 6}">${T("interface.no_hay_transitos_disponibles")}</td></tr>`}</tbody>
    </table>
  `, "right");
}

function progressedLongitudePanel(calculation, natalChart, options = {}) {
  const progressedChart = calculation?.chart;
  const rows = (progressedChart?.planets || []).
  filter((planet) => PROMPT_ASPECT_ORDER.includes(planet.key) && isChartPlanetVisible(planet.key)).
  map((planet) => {
    const house = chartHasVisibleHouses(natalChart) && natalChart?.houses?.length ? houseNumberFromCuspsClient(planet.longitude, natalChart.houses) : null;
    return `
        <tr>
          <td class="floating-planet astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}${planet.retrograde ? '<span class="retro-mark">R</span>' : ""}</td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.signIndex)}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</span></td>
          <td>${chartAtlasPosition({ ...planet, house }, { ...progressedChart, houses: natalChart?.houses || [], get label() {return T("charts.progressedNatalHouses");} }, `${planet.degree}º ${pad(planet.minute)}' ${pad(planet.second)}"`)}</td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.decanate?.absoluteIndex)}">${ZODIAC_SYMBOLS[planet.decanate?.absoluteIndex % 12] || ""}</span></td>
          <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.dodecatemoria?.signIndex)}">${ZODIAC_SYMBOLS[planet.dodecatemoria?.signIndex] || ""}</span></td>
          <td>${romanHouse(house)}</td>
        </tr>
      `;
  }).join("");
  const targetMoment = rows ?
  progressedLocalMoment(calculation, { useControls: false }).label :
  "Sin datos";
  const age = Number(calculation?.ageYears);
  const ageLabel = Number.isFinite(age) ? T("interface.value_anos_3", { v0: age.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }) :

  "";
  const subtitle = [targetMoment, ageLabel, "casas sobre Tropical natal"].filter(Boolean).join(" · ");

  return floatingPanel(options.panelId || "progressed-longitudes", "Longitud progresada", subtitle, `
    <table class="floating-table transit-position-table">
      <thead><tr><th>${T("interface.pl")}</th><th>${T("interface.signo")}</th><th>${T("interface.longitud")}</th><th>${T("interface.dec")}</th><th>${T("interface.dod")}</th><th>${T("interface.casa_natal")}</th></tr></thead>
      <tbody>${rows || `<tr><td colspan="6">${T("interface.no_hay_posiciones_progresadas_disponibles")}</td></tr>`}</tbody>
    </table>
  `, "right");
}

function aspectMatrixPanel(title, subtitle, matrix, id, side = "left") {
  const header = matrix.columns.map((column) => `<th class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(column.key)}" title="${escapeHtml(I18n.label(column.label))}" style="--astro-table-color:${column.color}">${escapeHtml(column.symbol)}</th>`).join("");
  const rows = matrix.rows.map((row) => `
    <tr>
      <th class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(row.key)}" title="${escapeHtml(I18n.label(row.label))}" style="--astro-table-color:${row.color}">${escapeHtml(row.symbol)}</th>
      ${row.cells.map((cell) => cell ? `<td><span class="aspect-symbol" style="color:${cell.color}">${escapeHtml(cell.symbol)}</span><span>${cell.orb}º</span></td>` : "<td></td>").join("")}
    </tr>
  `


  ).join("");

  return floatingPanel(id, title, `${subtitle} - ${matrix.count} aspectos`, `
    <table class="floating-table aspect-matrix-table">
      <thead><tr><th>${escapeHtml(matrix.corner)}</th>${header}</tr></thead>
      <tbody>${rows || `<tr><td colspan="${matrix.columns.length + 1}">${T("interface.no_hay_aspectos_mayores")}</td></tr>`}</tbody>
    </table>
  `, side);
}

function synastryHousePanel(subjectChart, partnerChart, partnerName, id = "synastry-houses") {
  if (!partnerChart) return "";
  const subjectName = birthProfile?.name || "Persona A";
  const rows = [
  ...synastryHouseRows(partnerChart.planets, subjectChart.houses, partnerName, subjectName),
  ...synastryHouseRows(subjectChart.planets, partnerChart.houses, subjectName, partnerName)];


  const htmlRows = rows.map((row) => `
    <tr>
      <td>${escapeHtml(row.owner)}</td>
      <td class="floating-planet astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(row.key)}" style="--astro-table-color:${chartPlanetColorCssValue(row.key, "var(--text)")}">${escapeHtml(planetGlyph(row.key))}</td>
      <td><span class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(row.signIndex)}">${ZODIAC_SYMBOLS[row.signIndex] || ""}</span> ${row.degree}º ${pad(row.minute)}'</td>
      <td>${escapeHtml(row.houseOwner)}</td>
      <td>${romanHouse(row.house)}</td>
    </tr>
  `).join("");

  return floatingPanel(id, "Planetas en casas", `${subjectName} y ${partnerName}`, `
    <table class="floating-table synastry-house-table">
      <thead><tr><th>${T("interface.carta")}</th><th>${T("interface.pl")}</th><th>${T("interface.longitud")}</th><th>${T("interface.casas_de")}</th><th>${T("interface.casa")}</th></tr></thead>
      <tbody>${htmlRows}</tbody>
    </table>
  `, "right");
}

function buildAspectMatrix({ rowPlanets = [], columnPlanets = [], rowLabel = "A", columnLabel = "B", houseCusps = [] }) {
  const columns = PROMPT_ASPECT_ORDER.
  filter((key) => isChartPlanetVisible(key)).
  map((key) => columnPlanets.find((planet) => planet.key === key)).
  filter(Boolean).
  map((planet) => ({
    key: planet.key,
    label: planet.label,
    symbol: planetGlyph(planet.key),
    color: chartPlanetColorCssValue(planet.key, "var(--text)"),
    longitude: planet.longitude
  }));
  let count = 0;
  const rows = PROMPT_ASPECT_ORDER.
  filter((key) => isChartPlanetVisible(key)).
  map((key) => rowPlanets.find((planet) => planet.key === key)).
  filter(Boolean).
  map((planet) => {
    const cells = columns.map((column) => {
      const aspect = findAspectBetween(planet.longitude, column.longitude, houseCusps);
      if (!aspect || !isEnabledAspect(aspect) || !isChartAspectTypeVisible(aspect.angle)) return null;
      count++;
      return {
        angle: aspect.angle,
        name: aspect.name,
        symbol: ASPECT_SYMBOLS[aspect.angle] || String(aspect.angle),
        color: chartAspectColorCssValue(aspect.angle),
        orb: formatOrb(aspect.orb),
        orbValue: aspect.orb
      };
    });

    return {
      key: planet.key,
      label: planet.label,
      symbol: planetGlyph(planet.key),
      color: chartPlanetColorCssValue(planet.key, "var(--text)"),
      cells
    };
  });

  return {
    corner: `${rowLabel} \\ ${columnLabel}`,
    columns,
    rows,
    count
  };
}

const SIGN_CUSP_LONGITUDES_CLIENT = Array.from({ length: 12 }, (_, index) => index * 30);
const CONJUNCTION_CUSP_ORB_CLIENT = 3;
const ASPECT_CUSP_EDGE_TOLERANCE_CLIENT = 0.5;

function shortestSignedAspectDeltaClient(from, to) {
  let delta = norm360Client(to) - norm360Client(from);
  if (delta > 180) delta -= 360;
  if (delta < -180) delta += 360;
  return delta;
}

function hasAspectBoundaryBetweenClient(longitudeA, longitudeB, boundaries = []) {
  const start = norm360Client(longitudeA);
  const delta = shortestSignedAspectDeltaClient(start, longitudeB);
  if (!Number.isFinite(delta) || delta === 0) return false;

  const end = start + delta;
  const lower = Math.min(start, end);
  const upper = Math.max(start, end);

  return boundaries.some((boundary) => {
    const normalized = norm360Client(boundary);
    for (let offset = -360; offset <= 360; offset += 360) {
      const value = normalized + offset;
      if (value > lower && value < upper) return true;
      if (Math.min(Math.abs(value - lower), Math.abs(value - upper)) <= ASPECT_CUSP_EDGE_TOLERANCE_CLIENT) return true;
    }
    return false;
  });
}

function normalizeAspectHouseCuspsClient(houses = []) {
  if (!houses || typeof houses !== "object") return [];
  const values = Array.isArray(houses) ?
  houses :
  Object.entries(houses).map(([number, longitude]) =>
  longitude && typeof longitude === "object" ?
  { ...longitude, number } :
  { number, longitude }
  );

  return values.
  map((house) => {
    if (typeof house === "number") return house;
    return Number(house?.longitude ?? house?.cusp ?? house?.degree ?? house?.value);
  }).
  filter((value) => Number.isFinite(value)).
  map(norm360Client);
}

function aspectSignIndexClient(longitude) {
  const value = norm360Client(longitude);
  return Math.floor(value / 30);
}

function aspectHouseIndexClient(longitude, houseCusps = []) {
  const cusps = houseCusps.
  map((cusp) => Number(cusp)).
  filter((cusp) => Number.isFinite(cusp)).
  map(norm360Client);
  if (cusps.length < 2) return null;

  const degree = norm360Client(longitude);
  for (let index = 0; index < cusps.length; index++) {
    const current = cusps[index];
    const next = cusps[(index + 1) % cusps.length];
    const wraps = next < current;
    const inside = wraps ?
    degree >= current || degree < next :
    degree >= current && degree < next;
    if (inside) return index + 1;
  }

  return null;
}

function conjunctionCrossesCuspClient(longitudeA, longitudeB, houseCusps = []) {
  const signA = aspectSignIndexClient(longitudeA);
  const signB = aspectSignIndexClient(longitudeB);
  const houseA = aspectHouseIndexClient(longitudeA, houseCusps);
  const houseB = aspectHouseIndexClient(longitudeB, houseCusps);

  return signA !== signB ||
  houseA !== null && houseB !== null && houseA !== houseB ||
  hasAspectBoundaryBetweenClient(longitudeA, longitudeB, SIGN_CUSP_LONGITUDES_CLIENT) ||
  hasAspectBoundaryBetweenClient(longitudeA, longitudeB, houseCusps);
}

function aspectOrbLimitClient(aspect, longitudeA, longitudeB, houseCusps = []) {
  const configuredOrb = chartAspectOrbForAngle(aspect.angle);
  if (aspect.angle !== 0) return configuredOrb;
  return conjunctionCrossesCuspClient(longitudeA, longitudeB, houseCusps) ?
  Math.min(configuredOrb, CONJUNCTION_CUSP_ORB_CLIENT) :
  configuredOrb;
}

function findAspectBetween(longitudeA, longitudeB, houseCusps = []) {
  const distance = angularDistanceClient(longitudeA, longitudeB);
  const candidate = ASPECT_CONFIGS.
  map((aspect, index) => ({
    aspect,
    index,
    orb: Math.abs(distance - aspect.angle)
  })).
  filter(({ aspect, orb }) =>
  isEnabledAspect(aspect) &&
  orb <= aspectOrbLimitClient(aspect, longitudeA, longitudeB, houseCusps)
  ).
  sort((candidateA, candidateB) =>
  candidateA.orb - candidateB.orb ||
  Number(isHabitualChartAspect(candidateB.aspect)) - Number(isHabitualChartAspect(candidateA.aspect)) ||
  candidateA.index - candidateB.index
  )[0];

  return candidate ?
  { ...candidate.aspect, orb: round(candidate.orb, 2), distance } :
  null;
}

function synastryHouseRows(planets = [], houseCusps = [], owner, houseOwner) {
  return planets.
  filter((planet) => PROMPT_ASPECT_ORDER.includes(planet.key) && isChartPlanetVisible(planet.key)).
  map((planet) => ({
    owner,
    houseOwner,
    key: planet.key,
    signIndex: planet.signIndex,
    degree: planet.degree,
    minute: planet.minute,
    house: houseNumberFromCuspsClient(planet.longitude, houseCusps)
  }));
}

function toggleFloatingPanel(panelId, action, trigger = null, { preservePatternFocus = false } = {}) {
  const panel = Array.from(chartWheelStage.querySelectorAll(".floating-chart-panel")).
  find((item) => item.id === panelId);
  const launchers = Array.from(chartWheelStage.querySelectorAll('button[data-panel-action="show"], button[data-panel-action="toggle"]')).
  filter((item) => item.dataset.panelId === panelId);
  if (!panel) return;

  const isVisible = !panel.hidden && !panel.classList.contains("is-panel-hidden");
  const show = action === "toggle" ? !isVisible : action === "show";
  const workspace = panel.closest(".chart-wheel-workspace");
  const isMultipleWorkspace = workspace?.classList.contains("chart-wheel-workspace-multiple");
  panel.hidden = !show;
  panel.classList.toggle("is-panel-hidden", !show);
  if (show) {
    if (isMultipleWorkspace && (workspace.classList.contains("chart-wheel-workspace-custom") || ["longitud", "figuras"].includes(panel.dataset.panelKind))) {
      positionMultipleFloatingPanelInViewport(panel, trigger);
    }
    bringFloatingPanelToFront(panel);
    if (panel.dataset.panelKind === "figuras") {
      const firstPatternControl = panel.querySelector("[data-chart-pattern-id]") ||
      panel.querySelector('button[data-panel-action="close"]');
      firstPatternControl?.focus({ preventScroll: true });
    }
  } else if (panel.dataset.panelKind === "figuras" && !preservePatternFocus && isCompactChartPatternViewport()) {
    const prefix = panel.id.replace(/-figuras$/, "");
    const svg = chartPatternSvgForPrefix(workspace, prefix);
    if (svg) clearChartPatternFocus(svg);
  }

  syncFloatingPanelLaunchers(launchers, show);

  if (!show && (action === "close" || !trigger)) {
    const returnTarget = launchers.find((launcher) => launcher.classList.contains("chart-pattern-summary")) ||
    launchers.find((launcher) => !launcher.hidden);
    returnTarget?.focus({ preventScroll: true });
  }

  // The three-map views let every table keep its own screen position. Closing
  // or opening one panel must not re-anchor the other visible panels; a global
  // arrangement is only needed when the viewport itself changes.
  if (!isMultipleWorkspace) arrangeFloatingPanels(workspace);
}

function syncFloatingPanelLaunchers(launchers, show) {
  launchers.forEach((launcher) => {
    const isMultipleControl = Boolean(launcher.closest(".chart-tools-multiple"));
    const isPersistentControl = isMultipleControl || launcher.classList.contains("chart-pattern-summary");
    launcher.hidden = isPersistentControl ? false : show;
    launcher.classList.toggle("is-panel-hidden", !isPersistentControl && show);
    launcher.classList.toggle("is-active", isPersistentControl && show);
    if (isPersistentControl) launcher.setAttribute("aria-pressed", String(show));
    if (launcher.classList.contains("chart-pattern-summary")) {
      launcher.setAttribute("aria-expanded", String(show));
    }
  });

}

function positionMultipleFloatingPanelInViewport(panel, trigger = null) {
  if (!panel || panel.hidden || panel.classList.contains("is-panel-hidden")) return;

  const visualViewport = window.visualViewport;
  const viewportLeft = visualViewport?.offsetLeft || 0;
  const viewportTop = visualViewport?.offsetTop || 0;
  const viewportWidth = Math.max(280, visualViewport?.width || window.innerWidth || document.documentElement.clientWidth || 0);
  const viewportHeight = Math.max(240, visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);
  const inset = viewportWidth <= 640 ? 10 : 14;
  const availableWidth = Math.max(260, viewportWidth - inset * 2);
  const availableHeight = Math.max(190, viewportHeight - inset * 2);
  const panelWidth = Math.min(320, availableWidth);
  const panelHeight = Math.min(390, availableHeight);
  const triggerRect = trigger?.isConnected ? trigger.getBoundingClientRect() : null;

  panel.classList.add("is-viewport-anchored");
  delete panel.dataset.userPositioned;
  panel.style.width = `${panelWidth}px`;
  panel.style.height = `${panelHeight}px`;
  panel.style.maxHeight = `${availableHeight}px`;
  panel.style.right = "auto";
  panel.style.bottom = "auto";
  panel.style.transform = "none";

  let left = triggerRect ?
  triggerRect.left + triggerRect.width / 2 - panelWidth / 2 :
  viewportLeft + (viewportWidth - panelWidth) / 2;
  let top;
  if (viewportWidth <= 640) {
    top = viewportTop + viewportHeight - panelHeight - inset;
  } else if (triggerRect) {
    const below = triggerRect.bottom + 9;
    const above = triggerRect.top - panelHeight - 9;
    top = below + panelHeight <= viewportTop + viewportHeight - inset ? below : above;
  } else {
    const currentRect = panel.getBoundingClientRect();
    top = Number.isFinite(currentRect.top) ? currentRect.top : viewportTop + (viewportHeight - panelHeight) / 2;
  }

  left = Math.max(viewportLeft + inset, Math.min(viewportLeft + viewportWidth - panelWidth - inset, left));
  top = Math.max(viewportTop + inset, Math.min(viewportTop + viewportHeight - panelHeight - inset, top));
  panel.style.left = `${Math.round(left)}px`;
  panel.style.top = `${Math.round(top)}px`;
}

function isDesktopMapFloatingPanelContext(workspace) {
  if (!workspace || workspace.classList.contains("chart-wheel-workspace-multiple")) return false;
  const isDesktop = window.matchMedia ?
  window.matchMedia("(min-width: 861px)").matches :
  window.innerWidth >= 861;
  const header = workspace.querySelector(".chart-wheel-card:not(.chart-wheel-card-triple) > .chart-card-header") ||
  workspace.querySelector(".chart-card-header");
  const headerRect = header?.getBoundingClientRect();
  return Boolean(isDesktop && headerRect?.width > 0 && headerRect?.height > 0);
}

function clearMapToolbarFloatingPanelAnchor(panel) {
  if (!panel?.classList.contains("is-map-toolbar-anchored")) return;
  panel.classList.remove("is-map-toolbar-anchored", "is-viewport-anchored");
  delete panel.dataset.viewportSafeTop;
  delete panel.dataset.viewportSafeBottom;
}

function positionMapFloatingPanelBelowToolbar(panel, workspace) {
  if (!panel || !workspace || panel.hidden || panel.classList.contains("is-panel-hidden")) return;

  const stage = workspace.closest(".chart-wheel-stage");
  const header = workspace.querySelector(".chart-wheel-card:not(.chart-wheel-card-triple) > .chart-card-header") ||
  workspace.querySelector(".chart-card-header");
  const visualViewport = window.visualViewport;
  const viewportLeft = visualViewport?.offsetLeft || 0;
  const viewportTop = visualViewport?.offsetTop || 0;
  const viewportWidth = Math.max(320, visualViewport?.width || window.innerWidth || document.documentElement.clientWidth || 0);
  const viewportHeight = Math.max(260, visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);
  const viewportRight = viewportLeft + viewportWidth;
  const viewportBottom = viewportTop + viewportHeight;
  const workspaceRect = workspace.getBoundingClientRect();
  const stageRect = stage?.getBoundingClientRect() || workspaceRect;
  const workspaceFillsViewport = workspaceRect.left <= viewportLeft + 1 &&
  workspaceRect.right >= viewportRight - 1;
  const boundaryRect = workspaceFillsViewport ? workspaceRect : stageRect;
  const headerRect = header?.getBoundingClientRect();
  const inset = 12;
  const safeLeft = Math.max(viewportLeft + inset, boundaryRect.left + inset);
  const safeRight = Math.min(viewportRight - inset, boundaryRect.right - inset);
  const safeTop = Math.max(
    viewportTop + inset,
    boundaryRect.top + inset,
    (headerRect?.bottom || boundaryRect.top) + 10
  );
  const safeBottom = Math.max(
    safeTop + 96,
    Math.min(viewportBottom - inset, boundaryRect.bottom - inset)
  );
  const availableWidth = Math.max(220, safeRight - safeLeft);
  const availableHeight = Math.max(96, safeBottom - safeTop);
  const preferredWidth = Math.max(320, Math.min(420, panel.offsetWidth || 390));
  const panelWidth = Math.min(availableWidth, preferredWidth);

  panel.classList.add("is-viewport-anchored", "is-map-toolbar-anchored");
  delete panel.dataset.userPositioned;
  panel.style.width = `${Math.round(panelWidth)}px`;
  panel.style.height = "auto";
  panel.style.maxHeight = `${Math.round(availableHeight)}px`;
  panel.style.right = "auto";
  panel.style.bottom = "auto";
  panel.style.transform = "none";

  const desiredHeight = floatingPanelDesiredHeight(panel, Math.min(520, availableHeight));
  panel.style.height = `${Math.round(Math.min(desiredHeight, availableHeight))}px`;
  const opensOnLeft = (panel.dataset.panelSlot || "").startsWith("left") ||
  panel.classList.contains("floating-chart-panel-left");
  const left = opensOnLeft ? safeLeft : safeRight - panelWidth;
  panel.style.left = `${Math.round(Math.max(safeLeft, Math.min(safeRight - panelWidth, left)))}px`;
  panel.style.top = `${Math.round(safeTop)}px`;
  panel.dataset.viewportSafeTop = String(Math.round(safeTop));
  panel.dataset.viewportSafeBottom = String(Math.round(safeBottom));

  const currentZ = Number.parseInt(panel.style.zIndex || "0", 10) || 0;
  if (currentZ < 81) {
    floatingPanelZ = Math.max(floatingPanelZ, 80) + 1;
    panel.style.zIndex = String(floatingPanelZ);
  }
}

function bringFloatingPanelToFront(panel) {
  if (panel?.classList.contains("is-viewport-anchored")) {
    floatingPanelZ = Math.max(floatingPanelZ, 80);
  }
  floatingPanelZ += 1;
  panel.style.zIndex = String(floatingPanelZ);
}

function floatingPanelDesiredHeight(panel, maxHeight) {
  const header = panel.querySelector(".floating-panel-header");
  const content = panel.querySelector(".floating-panel-content");
  const headerHeight = header?.offsetHeight || 0;
  const contentHeight = content?.scrollHeight || 0;
  const borderHeight = Math.max(2, panel.offsetHeight - panel.clientHeight);
  return Math.min(maxHeight, Math.max(96, Math.ceil(headerHeight + contentHeight + borderHeight)));
}

function arrangeFloatingPanels(workspace) {
  if (!workspace) return;

  if (workspace.classList.contains("chart-wheel-workspace-multiple")) {
    Array.from(workspace.querySelectorAll(workspace.classList.contains("chart-wheel-workspace-custom") ?
    '.floating-chart-panel' : '.floating-chart-panel[data-panel-kind="longitud"], .floating-chart-panel[data-panel-kind="figuras"]')).
    filter((panel) => !panel.hidden && !panel.classList.contains("is-panel-hidden")).
    forEach((panel) => {
      const launcher = Array.from(workspace.querySelectorAll("button[data-panel-id]")).
      find((button) => button.dataset.panelId === panel.id && !button.hidden);
      positionMultipleFloatingPanelInViewport(panel, launcher || null);
    });
    return;
  }

  const isLargeScreen = window.matchMedia ? window.matchMedia("(min-width: 1680px)").matches : false;
  const allPanels = Array.from(workspace.querySelectorAll(".floating-chart-panel"));
  const visiblePanels = allPanels.
  filter((panel) => !panel.hidden && !panel.classList.contains("is-panel-hidden"));

  if (isDesktopMapFloatingPanelContext(workspace)) {
    visiblePanels.forEach((panel) => positionMapFloatingPanelBelowToolbar(panel, workspace));
    return;
  }

  allPanels.forEach(clearMapToolbarFloatingPanelAnchor);

  if (!isLargeScreen) {
    visiblePanels.forEach((panel) => {
      delete panel.dataset.userPositioned;
      panel.style.removeProperty("max-height");
      panel.style.removeProperty("height");
      panel.style.removeProperty("width");
      panel.style.removeProperty("left");
      panel.style.removeProperty("right");
      panel.style.removeProperty("top");
      panel.style.removeProperty("bottom");
      panel.style.removeProperty("transform");
    });
    return;
  }

  const automaticPanels = visiblePanels.filter((panel) => panel.dataset.userPositioned !== "1");
  const sides = {
    left: automaticPanels.filter((panel) => (panel.dataset.panelSlot || "").startsWith("left")),
    right: automaticPanels.filter((panel) => !(panel.dataset.panelSlot || "").startsWith("left"))
  };

  Object.entries(sides).forEach(([side, panels]) => {
    if (!panels.length) return;

    const topPadding = workspace.querySelector(".floating-launchers") ? 58 : 18;
    const bottomPadding = 18;
    const gap = 12;
    const availableHeight = Math.max(190, workspace.clientHeight - topPadding - bottomPadding - (panels.length - 1) * gap);
    const maxPanelHeight = Math.max(96, workspace.clientHeight - topPadding - bottomPadding);
    const sortedPanels = panels.
    sort((a, b) => floatingSlotRank(a.dataset.panelSlot) - floatingSlotRank(b.dataset.panelSlot));
    const desiredHeights = sortedPanels.map((panel) => floatingPanelDesiredHeight(panel, maxPanelHeight));
    const hasRoomForContent = desiredHeights.reduce((sum, height) => sum + height, 0) <= availableHeight;
    const sharedHeight = Math.max(96, Math.min(maxPanelHeight, Math.floor(availableHeight / panels.length)));

    sortedPanels.
    forEach((panel, index) => {
      const targetHeight = hasRoomForContent ? desiredHeights[index] : sharedHeight;
      panel.style.maxHeight = "none";
      panel.style.width = "";
      panel.style.height = `${targetHeight}px`;
      panel.style.transform = "none";
      panel.style.bottom = "auto";

      if (side === "left") {
        panel.style.left = "18px";
        panel.style.right = "auto";
      } else {
        panel.style.right = "18px";
        panel.style.left = "auto";
      }

      const measuredHeight = targetHeight;
      const slotRank = floatingSlotRank(panel.dataset.panelSlot);
      const preferredTop = slotRank === 3 ?
      workspace.clientHeight - bottomPadding - measuredHeight :
      slotRank === 2 ?
      Math.round((workspace.clientHeight - measuredHeight) / 2) :
      topPadding;
      const previousPanel = sortedPanels[index - 1];
      const previousBottom = previousPanel ?
      Number.parseFloat(previousPanel.style.top || `${topPadding}`) + previousPanel.offsetHeight + gap :
      topPadding;
      const nextTop = Math.max(topPadding, Math.max(preferredTop, previousBottom));
      const clampedTop = Math.min(nextTop, Math.max(topPadding, workspace.clientHeight - bottomPadding - measuredHeight));
      panel.style.top = `${clampedTop}px`;
    });
  });
}

function floatingSlotRank(slot = "") {
  if (slot.endsWith("bottom")) return 3;
  if (slot.endsWith("middle")) return 2;
  return 1;
}

const NODAL_MEAN_YEAR_MS = 365.2422 * 24 * 60 * 60 * 1000;
const NODAL_MAX_REFERENCE_AGE = 180;

function nodalReferenceProfileKey(profile = chartCalculation?.profile || {}) {
  return [
  activePersonId || birthProfile?.personId || profile.personId || "current",
  profile.birthDate || `${birthProfile?.year || ""}-${pad(birthProfile?.month || "")}-${pad(birthProfile?.day || "")}`].
  join("|");
}

function syncNodalReferenceProfile(profile = chartCalculation?.profile || {}) {
  const profileKey = nodalReferenceProfileKey(profile);
  if (nodalReferenceState.profileKey !== profileKey) {
    nodalReferenceState = { profileKey, date: "" };
  }
  return nodalReferenceState;
}

function nodalBirthDateValue(profile = chartCalculation?.profile || {}) {
  const value = profile.birthDate || (
  birthProfile?.year && birthProfile?.month && birthProfile?.day ?
  `${birthProfile.year}-${pad(birthProfile.month)}-${pad(birthProfile.day)}` :
  "");
  return /^\d{4}-\d{2}-\d{2}$/.test(String(value || "")) ? String(value) : "";
}

function nodalTodayDateValue() {
  const today = new Date();
  return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
}

function nodalDateValueFromInstant(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
}

function nodalBirthInstant(profile = chartCalculation?.profile || {}) {
  const utcTimestamp = Date.parse(profile.utcDateTime || "");
  if (Number.isFinite(utcTimestamp)) return new Date(utcTimestamp);
  const birthDate = nodalBirthDateValue(profile);
  const timestamp = Date.parse(`${birthDate}T00:00:00Z`);
  return Number.isFinite(timestamp) ? new Date(timestamp) : null;
}

function nodalMaximumReferenceDate(profile = chartCalculation?.profile || {}) {
  const birthDate = nodalBirthDateValue(profile);
  if (!birthDate) return "";
  const date = new Date(`${birthDate}T12:00:00Z`);
  date.setUTCFullYear(date.getUTCFullYear() + NODAL_MAX_REFERENCE_AGE);
  return nodalDateValueFromInstant(date);
}

function clampNodalReferenceDate(value, profile = chartCalculation?.profile || {}) {
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(String(value || "")) ? String(value) : "";
  if (!normalized) return "";
  const minimum = nodalBirthDateValue(profile);
  const maximum = nodalMaximumReferenceDate(profile);
  if (minimum && normalized < minimum) return minimum;
  if (maximum && normalized > maximum) return maximum;
  return normalized;
}

function nodalReferenceInstant(profile = chartCalculation?.profile || {}, dateValue = "") {
  if (!dateValue) return new Date();
  const timestamp = Date.parse(`${dateValue}T12:00:00Z`);
  return Number.isFinite(timestamp) ? new Date(timestamp) : new Date();
}

function nodalReferenceDateForAge(profile = chartCalculation?.profile || {}, ageValue = 0) {
  const birth = nodalBirthInstant(profile);
  const age = Math.max(0, Math.min(NODAL_MAX_REFERENCE_AGE, Number(ageValue)));
  if (!birth || !Number.isFinite(age)) return "";
  return clampNodalReferenceDate(
    nodalDateValueFromInstant(birth.getTime() + age * NODAL_MEAN_YEAR_MS),
    profile
  );
}

function setNodalReferenceDate(value, profile = chartCalculation?.profile || {}) {
  const state = syncNodalReferenceProfile(profile);
  const nextDate = clampNodalReferenceDate(value, profile);
  state.date = nextDate === nodalTodayDateValue() ? "" : nextDate;
}

async function refreshNodalReferenceView(focusSelector = "") {
  try {
    await renderSelectedChartWheel({ accessVerified: true });
    toggleFloatingPanel("nodal-aspectos-personales", "show");
    if (focusSelector) {
      window.requestAnimationFrame(() => {
        chartWheelStage.querySelector(focusSelector)?.focus({ preventScroll: true });
      });
    }
  } catch (error) {
    setChartWheelStatus(() => error.message || T("interface.no_se_pudo_actualizar_el_punto_de_edad_nodal"), true);
  }
}

function handleNodalReferenceControlChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  const profile = chartCalculation?.profile || {};

  if (target.matches("[data-nodal-reference-date]")) {
    if (!target.value) return;
    setNodalReferenceDate(target.value, profile);
    void refreshNodalReferenceView("[data-nodal-reference-date]");
    return;
  }

  if (target.matches("[data-nodal-reference-age]")) {
    const age = Number(target.value);
    if (!Number.isFinite(age)) return;
    const dateValue = nodalReferenceDateForAge(profile, age);
    if (!dateValue) return;
    setNodalReferenceDate(dateValue, profile);
    void refreshNodalReferenceView("[data-nodal-reference-age]");
  }
}

function handleNodalReferenceControlClick(event) {
  const button = event.target.closest?.("[data-nodal-reference-today]");
  if (!button || !chartWheelStage.contains(button)) return;
  const state = syncNodalReferenceProfile(chartCalculation?.profile || {});
  state.date = "";
  void refreshNodalReferenceView("[data-nodal-reference-date]");
}

function nodalChartPanel(nodal) {
  const panelPrefix = "nodal";
  const nodalLinks = [
  ["longitud", "Longitud"],
  ["aspectos", "Aspectos"],
  ["aspectos-personales", "Aspectos Personales"],
  ["cuspides", "Cúspides"],
  ["modos", "Modos"],
  ["elementos", "Elementos"],
  ["distribucion", "Distribución"]];


  return `
    <article class="chart-wheel-card chart-wheel-card-nodal">
      <header class="chart-card-header">
        <div class="chart-card-identity">
          <h3>${T("interface.esquema_nodal_2")}</h3>
          <p>${T("interface.value_value_value_anos_value", { v0: escapeHtml(currentChartPersonName()), get v1() {return nodal.isCurrentAge ? T("interface.edad_actual") : T("interface.punto_de_edad");}, v2: nodal.ageText, v3: escapeHtml(formatDateForPrompt(nodal.referenceDate)) })}</p>
        </div>
        ${chartFullscreenPeopleControls("nodal")}
        <div class="chart-card-header-actions">
          ${chartTechnicalLinks(panelPrefix, nodalLinks, "", { groupSecondary: true, primaryKeys: ["longitud", "aspectos-personales"] })}
          ${chartCardActions()}
        </div>
      </header>
      <div class="nodal-schema-layout">
        <div class="nodal-wheel-stack">
          ${renderChartSvg(nodal.chart, { hideAngleMarkers: true, interactiveAngleMarkers: true, hideAngleMarkerVisuals: true, angleMarkerOuterRadius: 1040 * (507 / 950), interactivePlanets: true })}
          <svg class="nodal-overlay-svg" viewBox="0 0 950 950" role="group" aria-label="${T("interface.edades_nodales_y_punto_de_edad_actual")}">
            ${renderNodalHouseYears(nodal)}
            ${renderNodalYearMarkers(nodal)}
          </svg>
        </div>
      </div>
    </article>
  `;









}

function nodalTechnicalPanels(nodal) {
  const prefix = "nodal";
  const label = T("interface.esquema_nodal");
  return [
  floatingPanel(`${prefix}-longitud`, "Longitud Esquema Nodal", label, renderNodalLongitudeTable(nodal), "right"),
  floatingPanel(`${prefix}-aspectos`, "Aspectos Esquema Nodal", label, renderNodalAspectPanel(nodal), "left"),
  floatingPanel(`${prefix}-aspectos-personales`, "Aspectos Personales", `${formatDateForPrompt(nodal.referenceDate)} · ${nodal.ageText} años`, renderNodalCurrentAspectTable(nodal), "left"),
  floatingPanel(`${prefix}-cuspides`, "Cúspides Casas", label, renderInlineCuspTable(nodal.chart), "right"),
  floatingPanel(`${prefix}-modos`, "Modos", label, renderModeElementStats(nodal.chart, "mode"), "left"),
  floatingPanel(`${prefix}-elementos`, "Elementos", label, renderModeElementStats(nodal.chart, "element"), "left"),
  floatingPanel(`${prefix}-distribucion`, "Distribución", label, renderDistributionPanel(nodal.chart), "left")];

}

function buildNodalSchema(tropicalChart) {
  const basePlanets = tropicalChart.planetsByKey || {};
  const nodalAsc = Number(basePlanets["true Node"]?.longitude ?? tropicalChart.ascendant?.longitude ?? 0);
  const tropicalAsc = Number(tropicalChart.ascendant?.longitude ?? nodalAsc);
  const profile = chartCalculation?.profile || {};
  const referenceState = syncNodalReferenceProfile(profile);
  const referenceDate = referenceState.date || nodalTodayDateValue();
  const isCurrentAge = !referenceState.date;
  const age = calculateDecimalAgeYears(profile, nodalReferenceInstant(profile, referenceState.date));
  const currentAgeDegree = norm360Client(nodalAsc + (72 - age) / 0.2);
  const houses = buildNodalHouses(nodalAsc);
  const planetOrder = [...CHART_PLANET_ORDER, "midpoint", "tierra"];
  const planets = planetOrder.
  map((key) => {
    const source = basePlanets[key];
    if (!source && key !== "south Node") return null;
    const longitude = key === "true Node" ?
    tropicalAsc :
    key === "south Node" ?
    norm360Client(tropicalAsc + 180) :
    Number(source.longitude);
    const point = enrichChartPointClient(key, longitude);
    return {
      ...point,
      label: PROMPT_PLANET_LABELS[key] || source?.label || key,
      key,
      retrograde: Boolean(source?.retrograde),
      house: nodalHouseNumber(longitude, nodalAsc),
      houseLabel: romanHouse(nodalHouseNumber(longitude, nodalAsc))
    };
  }).
  filter(Boolean);
  const planetsByKey = Object.fromEntries(planets.map((planet) => [planet.key, planet]));
  const chart = {
    type: "nodal", get
    label() {return T("interface.esquema_nodal");},
    ascendant: enrichChartPointClient("Ascendant", nodalAsc),
    planets,
    planetsByKey,
    houses,
    aspects: calculateClientOrbAspects(planetsByKey, houses)
  };
  const ageText = age.toFixed(2);
  const aspectRows = nodalCurrentAgeAspects(planets, currentAgeDegree);
  chart.nodalAgePoint = {
    longitude: currentAgeDegree,
    aspects: aspectRows.map((row) => ({
      planetA: "current-age",
      planetB: row.planet.key,
      angle: row.angle,
      orb: row.orb,
      label: ASPECT_CONFIGS.find((item) => Number(item.angle) === Number(row.angle))?.label || ""
    }))
  };

  return {
    chart,
    nodalAsc,
    age,
    ageText,
    referenceDate,
    isCurrentAge,
    referenceMinimumDate: nodalBirthDateValue(profile),
    referenceMaximumDate: nodalMaximumReferenceDate(profile),
    currentAgeDegree,
    planetOrder,
    aspectRows
  };
}

function buildNodalHouses(nodalAsc) {
  return Array.from({ length: 12 }, (_, index) => {
    const houseNumber = 12 - index;
    const longitude = norm360Client(nodalAsc + (index + 1) * 30);
    return {
      ...enrichChartPointClient(`Casa ${houseNumber}`, longitude),
      number: houseNumber,
      label: romanHouse(houseNumber)
    };
  });
}

function enrichChartPointClient(key, longitude) {
  const normalized = norm360Client(longitude);
  const signIndex = Math.floor(normalized / 30);
  const degInSign = normalized - signIndex * 30;
  const degree = Math.floor(degInSign);
  const minutesTotal = (degInSign - degree) * 60;
  const minute = Math.floor(minutesTotal);
  const second = Math.floor((minutesTotal - minute) * 60);
  const decanateIndex = Math.min(2, Math.floor(degInSign / 10));
  const dodecatemoriaIndex = Math.min(11, Math.floor(degInSign / 2.5));
  const decanateSignIndex = (signIndex * 3 + decanateIndex) % 12;
  const dodecatemoriaSignIndex = (signIndex + dodecatemoriaIndex) % 12;

  return {
    key,
    longitude: normalized,
    sign: PROMPT_SIGNS[signIndex],
    signIndex,
    degree,
    minute,
    second,
    formatted: `${degree}º ${pad(minute)}' ${pad(second)}"`,
    decanate: {
      index: decanateIndex,
      sign: PROMPT_SIGNS[decanateSignIndex],
      absoluteIndex: signIndex * 3 + decanateIndex
    },
    dodecatemoria: {
      index: dodecatemoriaIndex,
      sign: PROMPT_SIGNS[dodecatemoriaSignIndex],
      signIndex: dodecatemoriaSignIndex
    }
  };
}

function nodalHouseNumber(longitude, nodalAsc) {
  return Math.floor(norm360Client(Number(nodalAsc) - Number(longitude)) / 30) + 1;
}

function calculateDecimalAgeYears(profile = {}, referenceInstant = new Date()) {
  const birthTime = nodalBirthInstant(profile);
  const referenceTime = referenceInstant instanceof Date ? referenceInstant.getTime() : new Date(referenceInstant).getTime();
  const elapsed = referenceTime - birthTime?.getTime();
  if (!Number.isFinite(elapsed) || elapsed <= 0) return 0;
  return round(elapsed / NODAL_MEAN_YEAR_MS, 2);
}

function calculateClientOrbAspects(planetsByKey = {}, houses = []) {
  const keys = Object.keys(planetsByKey).filter((key) => key !== "tierra");
  const aspects = [];
  const houseCusps = normalizeAspectHouseCuspsClient(houses);

  keys.forEach((keyA, index) => {
    keys.slice(index + 1).forEach((keyB) => {
      const aspect = findAspectBetween(planetsByKey[keyA].longitude, planetsByKey[keyB].longitude, houseCusps);
      if (!aspect || !isEnabledAspect(aspect)) return;
      aspects.push({
        planetA: keyA,
        planetB: keyB,
        planetALabel: PROMPT_PLANET_LABELS[keyA] || keyA,
        planetBLabel: PROMPT_PLANET_LABELS[keyB] || keyB,
        angle: aspect.angle,
        name: aspect.name,
        orb: aspect.orb
      });
    });
  });

  return aspects;
}

function calculateClientSignAspects(planetsByKey = {}) {
  const keys = PROMPT_ASPECT_ORDER.filter((key) => planetsByKey[key]);
  const aspects = [];

  keys.forEach((keyA, index) => {
    keys.slice(index + 1).forEach((keyB) => {
      const longitudeA = Number(planetsByKey[keyA]?.longitude);
      const longitudeB = Number(planetsByKey[keyB]?.longitude);
      if (!Number.isFinite(longitudeA) || !Number.isFinite(longitudeB)) return;

      const angle = aspectBySignClient(longitudeA, longitudeB);
      if (angle === null) return;
      const config = ASPECT_CONFIGS.find((aspect) => Number(aspect.angle) === angle);

      aspects.push({
        planetA: keyA,
        planetB: keyB,
        planetALabel: PROMPT_PLANET_LABELS[keyA] || keyA,
        planetBLabel: PROMPT_PLANET_LABELS[keyB] || keyB,
        angle,
        name: config?.name || "aspecto",
        orb: null,
        distance: round(angularDistanceClient(longitudeA, longitudeB), 2),
        rule: "signos_sin_orbe"
      });
    });
  });

  return aspects;
}

function isSideralAspectChart(chart) {
  return chart?.type === "sideral" || chart?.composite?.chartType === "sideral";
}

function aspectBySignClient(longitudeA, longitudeB) {
  const signA = aspectSignIndexClient(longitudeA);
  const signB = aspectSignIndexClient(longitudeB);
  const delta = (signB - signA + 12) % 12;
  const elementA = signA % 4;
  const elementB = signB % 4;

  if (delta === 0) return 0;
  if (delta === 1 || delta === 11) return 30;
  if (delta === 6) return 180;
  if ((delta === 4 || delta === 8) && elementA === elementB) return 120;
  if ((delta === 2 || delta === 10) && isSextileCompatibleBySignClient(elementA, elementB)) return 60;
  if (delta === 3 || delta === 9) return 90;
  if (delta === 5 || delta === 7) return 150;
  return null;
}

function isSextileCompatibleBySignClient(elementA, elementB) {
  return elementA === 0 && elementB === 2 ||
  elementA === 2 && elementB === 0 ||
  elementA === 1 && elementB === 3 ||
  elementA === 3 && elementB === 1;
}

function nodalCurrentAgeAspects(planets, currentAgeDegree) {
  return planets.
  map((planet) => {
    const aspect = findAspectBetween(currentAgeDegree, planet.longitude);
    if (!aspect) return null;
    return {
      planet,
      angle: aspect.angle,
      symbol: ASPECT_SYMBOLS[aspect.angle] || aspect.angle,
      color: chartAspectColorCssValue(aspect.angle),
      orb: round(aspect.orb, 1)
    };
  }).
  filter((item) => Boolean(item) && isChartAspectTypeVisible(item.angle));
}

function nodalYearForDegree(longitude, nodalAsc) {
  const relative = norm360Client(Number(longitude) - Number(nodalAsc));
  return 72 - relative * 0.2;
}

function nodalYearText(longitude, nodalAsc, digits = 1) {
  const year = nodalYearForDegree(longitude, nodalAsc);
  let text = year.toFixed(digits);
  if (year >= 0 && year < 30) text += `|${(year + 72).toFixed(digits)}`;
  return text;
}

function nodalHouseYearText(houseNumber) {
  if (houseNumber === 1) return "72";
  let text = String((houseNumber - 1) * 6);
  if (houseNumber > 1 && houseNumber < 7) text += `|${72 + (houseNumber - 1) * 6}`;
  return text;
}

function renderNodalHouseYears(nodal) {
  const center = 475;
  const chartZero = nodalCoordinateReference(nodal);
  const labelRadius = 507;
  const lineInner = 324;
  const lineOuter = 425;
  const angleMap = new Map([
  [1, { key: "Ascendant", prefix: "ASC", suffix: "" }],
  [7, { key: "Descendant", prefix: "", suffix: "DESC" }],
  [10, { key: "Midheaven", prefix: "MC", suffix: "" }],
  [4, { key: "ImumCoeli", prefix: "", suffix: "BC" }]]
  );

  return nodal.chart.houses.map((house) => {
    const number = Number(house.number);
    const lineA = chartPoint(center, center, lineInner, house.longitude, chartZero);
    const lineB = chartPoint(center, center, lineOuter, house.longitude, chartZero);
    const labelPoint = chartPoint(center, center, labelRadius, house.longitude, chartZero);
    const age = nodalHouseYearText(number);
    const angle = angleMap.get(number);
    const isAngle = Boolean(angle);
    if (isAngle && !isChartPlanetVisible(angle.key)) return "";
    const text = angle ?
    `${angle.prefix ? `${angle.prefix} ` : ""}${age}${angle.suffix ? ` ${angle.key === "ImumCoeli" ? T("charts.imumCoeliAbbreviation") : angle.suffix}` : ""}` :
    age;
    const angleLine = isAngle ?
    `<line x1="${lineA.x}" y1="${lineA.y}" x2="${lineB.x}" y2="${lineB.y}" class="nodal-angle-line"></line>` :
    "";
    return `
      <g class="nodal-house-year ${isAngle ? "nodal-house-year-angle" : ""}" aria-hidden="true">
        ${angleLine}
        <text x="${labelPoint.x}" y="${labelPoint.y}" text-anchor="middle" dominant-baseline="middle">${escapeHtml(text)}</text>
      </g>
    `;
  }).join("");
}

function renderNodalYearMarkers(nodal) {
  const center = 475;
  const chartZero = nodalCoordinateReference(nodal);
  const currentAgePosition = enrichChartPointClient("current-age", nodal.currentAgeDegree);
  const currentAgeHouse = nodalHouseNumber(nodal.currentAgeDegree, nodal.nodalAsc);
  // The nodal overlay uses a 950 viewBox while the chart below uses 1040.
  // Radius 390 matches the chart's visible exterior ring in overlay space.
  const connectorStartRadius = 390;
  const occupiedBoxes = [
  ...nodalHouseYearCollisionBoxes(nodal, chartZero),
  ...nodalHouseCuspLabelCollisionBoxes(nodal, chartZero)];

  const planetItems = nodal.chart.planets.filter((planet) => isChartPlanetVisible(planet.key)).map((planet) => {
    const year = nodalYearForDegree(planet.longitude, nodal.nodalAsc);
    return {
      key: planet.key,
      className: "nodal-year-marker",
      color: chartPlanetColorCssValue(planet.key, "var(--text)"),
      glyph: planetGlyph(planet.key),
      value: nodalYearText(planet.longitude, nodal.nodalAsc, 1),
      fontSize: 16,
      longitude: planet.longitude,
      labelRadius: 473,
      connectorStartRadius,
      year
    };
  });
  const currentItem = {
    key: "current-age",
    className: "nodal-current-age-marker",
    color: "#dc2626",
    glyph: CURRENT_AGE_SYMBOL,
    value: nodal.ageText,
    fontSize: 17,
    longitude: nodal.currentAgeDegree,
    labelRadius: 479,
    connectorStartRadius,
    year: nodal.age
  };

  const placedAngles = [];
  const placements = nodalGroupYearMarkers([...planetItems, currentItem], 6).flatMap((group) => {
    const orderedGroup = [...group].sort((a, b) => Number(a.longitude) - Number(b.longitude));
    const count = orderedGroup.length;
    const step = Math.min(7.2, Math.max(4.8, 3.4 + count * 0.55));
    return orderedGroup.map((item, index) => {
      const adjustedLongitude = resolveClusteredNodalDegree(item.longitude, index, count, placedAngles, step, 5.9);
      const placement = placeNodalYearMarker({ ...item, displayLongitude: adjustedLongitude }, center, chartZero, occupiedBoxes);
      occupiedBoxes.push(placement.box);
      return placement;
    });
  });

  return placements.map(({ item, anchor, label, edge, box }) => {
    const glyphClass = item.className === "nodal-year-marker" ? ' class="nodal-marker-glyph"' : "";
    // Earth is always visible, so it is not in the configurable filter list.
    // Its exterior age label must still select the same point as the wheel.
    const planetKey = item.key === "tierra" || CHART_SELECTABLE_PLANETS.includes(item.key) ? item.key : "";
    const visibilityClass = planetKey ? chartPlanetVisibilityClass(planetKey) : "";
    const visibilityAttribute = planetKey ? ` data-chart-planet-key="${escapeHtml(planetKey)}"` : "";
    const isCurrentAge = item.key === "current-age";
    const isPlanetAge = !isCurrentAge && Boolean(planetKey);
    const planetAgeId = isPlanetAge ? chartPlanetInteractionId("base", planetKey) : "";
    const planetName = isPlanetAge ? PROMPT_PLANET_LABELS[planetKey] || planetKey : "";
    const interactionAttributes = isCurrentAge ?
    ` data-nodal-current-age-action data-nodal-current-age-id="${escapeHtml(chartPlanetInteractionId("base", "current-age"))}" data-nodal-current-age-value="${escapeHtml(item.value)}" data-nodal-current-age-date="${escapeHtml(nodal.referenceDate)}" data-nodal-current-age-sign="${escapeHtml(currentAgePosition.sign)}" data-nodal-current-age-sign-index="${currentAgePosition.signIndex}" data-nodal-current-age-degree="${currentAgePosition.degree}" data-nodal-current-age-minute="${currentAgePosition.minute}" data-nodal-current-age-second="${currentAgePosition.second}" data-nodal-current-age-house="${currentAgeHouse}" role="button" tabindex="0" focusable="true" aria-pressed="false" aria-label="Punto de edad ${escapeHtml(item.value)} años. Pulsa para destacar sus aspectos en el mapa."` :
    isPlanetAge ?
    ` data-nodal-planet-age-action data-nodal-planet-id="${escapeHtml(planetAgeId)}" role="button" tabindex="0" focusable="true" aria-pressed="false" aria-label="Edad nodal de ${escapeHtml(planetName)}, ${escapeHtml(item.value)} años. Pulsa para destacar los aspectos de ${escapeHtml(planetName)} en el mapa."` :
    ' aria-hidden="true"';
    return `
      <g class="${item.className}${visibilityClass}${isCurrentAge ? " nodal-current-age-action" : ""}${isPlanetAge ? " nodal-planet-age-action" : ""}"${visibilityAttribute}${interactionAttributes} style="--planet-color:${item.color}">
        ${isCurrentAge ? `<title>${T("interface.ver_y_destacar_los_aspectos_del_punto_de_edad_value_anos", { v0: escapeHtml(item.value) })}</title>` :

    isPlanetAge ? `<title>${T("interface.ver_y_destacar_los_aspectos_de_value_value_anos", { v0: escapeHtml(planetName), v1: escapeHtml(item.value) })}</title>` :

    ""}
        <line x1="${anchor.x}" y1="${anchor.y}" x2="${edge.x}" y2="${edge.y}"></line>
        <rect x="${box.x}" y="${box.y}" width="${box.width}" height="${box.height}" rx="4"></rect>
        <text x="${label.x}" y="${label.y}" text-anchor="middle" dominant-baseline="middle">
          <tspan${glyphClass}>${escapeHtml(item.glyph)}</tspan>
          <tspan dx="${item.className === "nodal-year-marker" ? 4 : 5}">${escapeHtml(item.value)}</tspan>
        </text>
      </g>
    `;
  }).join("");
}

function nodalGroupYearMarkers(items, minDistance) {
  const sorted = [...items].sort((a, b) => Number(a.longitude) - Number(b.longitude));
  const groups = [];
  const used = new Set();

  sorted.forEach((item) => {
    if (used.has(item.key)) return;
    const group = [item];
    used.add(item.key);

    sorted.forEach((other) => {
      if (item.key === other.key || used.has(other.key)) return;
      if (angularDistanceClient(item.longitude, other.longitude) < minDistance) {
        group.push(other);
        used.add(other.key);
      }
    });

    groups.push(group);
  });

  return groups;
}

function resolveClusteredNodalDegree(degree, index, count, placedAngles, spreadStep = 6.8, minSeparation = 8) {
  const normalized = norm360Client(degree);
  const offset = index - (count - 1) / 2;
  let adjusted = normalized + offset * spreadStep;

  if (placedAngles.length) {
    const previous = placedAngles[placedAngles.length - 1];
    while (adjusted <= previous - 180) adjusted += 360;
    while (adjusted > previous + 180) adjusted -= 360;
    const minimumAllowed = previous + minSeparation;
    if (adjusted < minimumAllowed) adjusted = minimumAllowed;
  }

  placedAngles.push(adjusted);
  return norm360Client(adjusted);
}

function placeNodalYearMarker(item, center, chartZero, occupiedBoxes) {
  const primaryRadiusOffsets = [0, -18, -34, -50, 14, 28, -64, 42];
  const fallbackRadiusOffsets = [56, -78, 70, 84, -92, 98];
  const primaryAngleOffsets = [0, -2.2, 2.2, -4.4, 4.4, -6, 6];
  const fallbackAngleOffsets = [-8, 8, -10, 10, -12, 12];
  const basePlacement = createNodalYearPlacement(item, center, chartZero, 0, 0);
  let bestPlacement = basePlacement;
  let bestScore = nodalPlacementCollisionScore(basePlacement.box, occupiedBoxes);

  for (const radiusOffsets of [primaryRadiusOffsets, fallbackRadiusOffsets]) {
    for (const radiusOffset of radiusOffsets) {
      for (const angleOffset of primaryAngleOffsets) {
        const placement = createNodalYearPlacement(item, center, chartZero, radiusOffset, angleOffset);
        const score = nodalPlacementCollisionScore(placement.box, occupiedBoxes);
        if (score < bestScore) {
          bestScore = score;
          bestPlacement = placement;
        }
        if (score === 0) {
          return placement;
        }
      }
    }
  }

  for (const radiusOffset of fallbackRadiusOffsets) {
    for (const angleOffset of fallbackAngleOffsets) {
      const placement = createNodalYearPlacement(item, center, chartZero, radiusOffset, angleOffset);
      const score = nodalPlacementCollisionScore(placement.box, occupiedBoxes);
      if (score < bestScore) {
        bestScore = score;
        bestPlacement = placement;
      }
      if (score === 0) {
        return placement;
      }
    }
  }

  return bestPlacement;
}

function nodalHouseYearCollisionBoxes(nodal, chartZero) {
  const center = 475;
  const labelRadius = 507;
  const angleMap = new Map([
  [1, { prefix: "ASC", suffix: "" }],
  [7, { prefix: "", suffix: "DESC" }],
  [10, { prefix: "MC", suffix: "" }],
  [4, { prefix: "", suffix: "BC" }]]
  );

  return nodal.chart.houses.map((house) => {
    const number = Number(house.number);
    const age = nodalHouseYearText(number);
    const angle = angleMap.get(number);
    const text = angle ?
    `${angle.prefix ? `${angle.prefix} ` : ""}${age}${angle.suffix ? ` ${angle.suffix}` : ""}` :
    age;
    const point = chartPoint(center, center, labelRadius, house.longitude, chartZero);
    const fontSize = angle ? 28 : 24;
    const width = Math.max(24, text.length * fontSize * 0.62 + 16);
    const height = fontSize + 12;
    return {
      x: round(point.x - width / 2, 1),
      y: round(point.y - height / 2, 1),
      width: round(width, 1),
      height: round(height, 1)
    };
  });
}

function nodalHouseCuspLabelCollisionBoxes(nodal, chartZero) {
  const center = 475;
  // The chart underneath uses a 1040 viewBox and places cusp labels at
  // radius 473. Convert that lane to the 950-unit nodal overlay so the
  // exterior age markers can reserve the same visible space.
  const cuspLabelRadius = 473 * (950 / 1040);
  return nodal.chart.houses.
  filter((house) => ![1, 4, 7, 10].includes(Number(house.number))).
  map((house) => {
    const point = chartPoint(center, center, cuspLabelRadius, house.longitude, chartZero);
    return orbitalLabelBox(point, { width: 72, height: 56 });
  });
}

function createNodalYearPlacement(item, center, chartZero, radiusOffset, angleOffset) {
  const labelRadius = Math.max(433, item.labelRadius + radiusOffset);
  const labelLongitude = norm360Client(Number(item.displayLongitude) + angleOffset);
  const label = chartPoint(center, center, labelRadius, labelLongitude, chartZero);
  const box = nodalMarkerBox(label.x, label.y, item.glyph, item.value, item.fontSize);
  const anchor = chartPoint(center, center, item.connectorStartRadius, item.longitude, chartZero);
  const edge = rectEdgePointFromCenter(center, center, label, box);

  return { item, anchor, label, edge, box };
}

function nodalPlacementCollisionScore(box, occupiedBoxes) {
  return occupiedBoxes.reduce((total, occupiedBox) => {
    if (!rectsOverlap(box, occupiedBox, 4)) return total;
    return total + 1 + rectOverlapArea(box, occupiedBox, 4);
  }, 0);
}

function rectEdgePointFromCenter(cx, cy, point, rect) {
  const vx = point.x - cx;
  const vy = point.y - cy;
  const length = Math.sqrt(vx * vx + vy * vy) || 1;
  const ux = vx / length;
  const uy = vy / length;
  const scaleX = Math.abs(ux) > 0.0001 ? rect.width / 2 / Math.abs(ux) : 1000000;
  const scaleY = Math.abs(uy) > 0.0001 ? rect.height / 2 / Math.abs(uy) : 1000000;
  const distance = Math.min(scaleX, scaleY);
  return {
    x: round(point.x - ux * distance, 2),
    y: round(point.y - uy * distance, 2)
  };
}

function rectsOverlap(a, b, padding = 0) {
  return !(
  a.x + a.width + padding <= b.x ||
  b.x + b.width + padding <= a.x ||
  a.y + a.height + padding <= b.y ||
  b.y + b.height + padding <= a.y);

}

function rectOverlapArea(a, b, padding = 0) {
  const left = Math.max(a.x, b.x - padding);
  const right = Math.min(a.x + a.width, b.x + b.width + padding);
  const top = Math.max(a.y, b.y - padding);
  const bottom = Math.min(a.y + a.height, b.y + b.height + padding);
  if (right <= left || bottom <= top) return 0;
  return (right - left) * (bottom - top);
}

function nodalMarkerBox(x, y, glyph, value, fontSize) {
  const glyphWidth = glyph ? fontSize * 1.05 : 0;
  const gap = glyph ? 6 : 0;
  const valueWidth = String(value || "").length * (fontSize * 0.58);
  const width = round(Math.max(62, glyphWidth + gap + valueWidth + 18), 1);
  const height = round(fontSize + 12, 1);
  return {
    x: round(x - width / 2, 1),
    y: round(y - height / 2, 1),
    width,
    height
  };
}

function renderNodalLongitudeTable(nodal) {
  const rows = nodal.planetOrder.
  map((key) => nodal.chart.planetsByKey[key]).
  filter((planet) => Boolean(planet) && isChartPlanetVisible(planet.key)).
  map((planet) => `
      <tr>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}</td>
        <td>${chartAtlasPosition(planet, nodal.chart)}${retrogradeTableMark(planet)}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.signIndex)}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.decanate?.absoluteIndex)}">${ZODIAC_SYMBOLS[planet.decanate?.absoluteIndex % 12] || ""}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.dodecatemoria?.signIndex)}">${ZODIAC_SYMBOLS[planet.dodecatemoria?.signIndex] || ""}</td>
        <td>${escapeHtml(planet.houseLabel || planet.house || "")}</td>
        <td class="nodal-year-cell" style="color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(nodalYearText(planet.longitude, nodal.nodalAsc, 1))}</td>
      </tr>
    `).join("");

  return `
    <table class="floating-table nodal-longitude-table">
      <thead><tr><th>${T("interface.pl")}</th><th>${T("interface.longitud")}</th><th>${T("interface.signo")}</th><th>${T("interface.dec")}</th><th>${T("interface.dod")}</th><th>${T("interface.casa")}</th><th>${T("interface.edad")}</th></tr></thead>
      <tbody>${rows || `<tr><td colspan="7">${T("interface.sin_datos_nodales")}</td></tr>`}</tbody>
    </table>
  `;
}

function renderNodalAspectPanel(nodal) {
  return `
    <section class="nodal-table-card">
      <h4>${T("interface.aspectos_del_mapa")}</h4>
      ${renderFloatingAspectTable(chartPanelAspects(nodal.chart))}
    </section>
  `;
}

function renderNodalSchemeTable(nodal) {
  const rows = nodal.planetOrder.
  map((key) => nodal.chart.planetsByKey[key]).
  filter((planet) => Boolean(planet) && isChartPlanetVisible(planet.key)).
  map((planet) => `
      <tr>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${escapeHtml(planetGlyph(planet.key))}</td>
        <td>${chartAtlasPosition(planet, nodal.chart)}</td>
        <td class="astro-table-color astro-table-zodiac-color" style="${zodiacTableColorStyle(planet.signIndex)}">${ZODIAC_SYMBOLS[planet.signIndex] || ""}</td>
        <td class="nodal-year-cell" style="color:${chartPlanetColorCssValue(planet.key, "var(--text)")}">${T("interface.value_anos", { v7: escapeHtml(nodalYearText(planet.longitude, nodal.nodalAsc, 1)) })}</td>
      </tr>
    `).join("");

  return `
    <section class="nodal-table-card">
      <h4>${T("interface.tabla_esquema_nodal")}</h4>
      <table class="chart-inline-table nodal-table">
        <tbody>${rows}</tbody>
      </table>
    </section>
  `;
}

function renderNodalCurrentAspectTable(nodal) {
  const visibleRows = nodal.aspectRows.filter((row) => isChartPlanetVisible(row.planet.key));
  const rows = visibleRows.length ?
  visibleRows.map((row) => `
      <tr>
        <td class="nodal-age-icon">${CURRENT_AGE_SYMBOL}</td>
        <td style="color:${row.color}">${escapeHtml(row.symbol)}</td>
        <td class="astro-table-color astro-table-planet-color${balancedPlanetGlyphClass(row.planet.key)}" style="--astro-table-color:${chartPlanetColorCssValue(row.planet.key, "var(--text)")}">${escapeHtml(planetGlyph(row.planet.key))}</td>
        <td>${formatOrb(row.orb)}º</td>
      </tr>
    `).join("") : `<tr><td colspan="4">${T("interface.sin_aspectos_para_este_punto_de_edad")}</td></tr>`;


  return `
    <section class="nodal-table-card">
      <h4>${T("interface.punto_de_edad_nodal")}</h4>
      <div class="nodal-reference-controls" role="group" aria-label="${T("interface.fecha_y_edad_del_punto_nodal")}">
        <label class="nodal-reference-field nodal-reference-date-field">
          <span>${T("common.date")}</span>
          <input
            type="date"
            value="${escapeHtml(nodal.referenceDate)}"
            min="${escapeHtml(nodal.referenceMinimumDate)}"
            max="${escapeHtml(nodal.referenceMaximumDate)}"
            data-nodal-reference-date
          >
        </label>
        <label class="nodal-reference-field nodal-reference-age-field">
          <span>${T("interface.edad")}</span>
          <input
            type="number"
            value="${escapeHtml(nodal.ageText)}"
            min="0"
            max="${NODAL_MAX_REFERENCE_AGE}"
            step="0.01"
            inputmode="decimal"
            data-nodal-reference-age
          >
        </label>
        <button class="nodal-reference-today" type="button" data-nodal-reference-today ${nodal.isCurrentAge ? "disabled" : ""}>${T("interface.hoy")}</button>
        <small class="nodal-reference-note">${T("interface.fecha_y_edad_se_actualizan_juntas")}</small>
      </div>
      <h4>${T("interface.aspectos_personales")}</h4>
      <p class="nodal-age-summary"><span class="nodal-age-icon">${CURRENT_AGE_SYMBOL}</span> ${T("interface.value_anos_value", { v7: escapeHtml(nodal.ageText), v8: escapeHtml(formatDateForPrompt(nodal.referenceDate)) })}</p>
      <table class="chart-inline-table nodal-table">
        <thead><tr><th>${T("interface.punto")}</th><th>${T("interface.asp")}</th><th>${T("interface.pl_2")}</th><th>${T("interface.orbe")}</th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </section>
  `;
}

function chartReferenceLongitude(chart) {
  const firstHouseLongitude = Number(
    chartDisplayHouses(chart).find((house) => Number(house.number) === 1)?.longitude
  );
  if (Number.isFinite(firstHouseLongitude)) return norm360Client(firstHouseLongitude);
  const ascendant = Number(chart.ascendant?.longitude);
  if (!Number.isFinite(ascendant)) {
    return Number(chart.houses?.[0]?.longitude) || 0;
  }
  return ascendant;
}

function chartCoordinateReference(chart) {
  const value = chartReferenceLongitude(chart);
  return chart?.type === "memoria" || chart?.type === "nodal" ?
  { value, reversed: true } :
  value;
}

function nodalCoordinateReference(nodal) {
  return { value: nodal?.nodalAsc ?? 0, reversed: true };
}

function chartReferenceValue(chartZero) {
  if (chartZero && typeof chartZero === "object") {
    return Number(chartZero.value) || 0;
  }
  return Number(chartZero) || 0;
}

function chartReferenceReversed(chartZero) {
  return Boolean(chartZero && typeof chartZero === "object" && chartZero.reversed);
}

function chartPoint(cx, cy, radius, longitude, chartZero = 0) {
  const zero = chartReferenceValue(chartZero);
  const relative = chartReferenceReversed(chartZero) ?
  norm360Client(zero - Number(longitude)) :
  norm360Client(Number(longitude) - zero);
  const angle = (180 - relative) * Math.PI / 180;
  return {
    x: round(cx + radius * Math.cos(angle), 2),
    y: round(cy + radius * Math.sin(angle), 2)
  };
}

function chartRingSectorPath(center, innerRadius, outerRadius, start, end, chartZero = 0) {
  const outerStart = chartPoint(center, center, outerRadius, start, chartZero);
  const outerEnd = chartPoint(center, center, outerRadius, end, chartZero);
  const innerEnd = chartPoint(center, center, innerRadius, end, chartZero);
  const innerStart = chartPoint(center, center, innerRadius, start, chartZero);
  const largeArc = norm360Client(end - start) > 180 ? 1 : 0;
  const outerSweep = chartReferenceReversed(chartZero) ? 1 : 0;
  const innerSweep = chartReferenceReversed(chartZero) ? 0 : 1;
  return `
    M ${outerStart.x} ${outerStart.y}
    A ${outerRadius} ${outerRadius} 0 ${largeArc} ${outerSweep} ${outerEnd.x} ${outerEnd.y}
    L ${innerEnd.x} ${innerEnd.y}
    A ${innerRadius} ${innerRadius} 0 ${largeArc} ${innerSweep} ${innerStart.x} ${innerStart.y}
    Z
  `;
}

function unitVector(cx, cy, x, y) {
  const dx = x - cx;
  const dy = y - cy;
  const length = Math.sqrt(dx * dx + dy * dy) || 1;
  return { x: dx / length, y: dy / length };
}

function offsetPoint(point, vector, distance) {
  return {
    x: round(point.x + vector.x * distance, 2),
    y: round(point.y + vector.y * distance, 2)
  };
}

function midpointLongitude(start, end) {
  let diff = norm360Client(Number(end) - Number(start));
  if (diff === 0) diff = 30;
  return norm360Client(Number(start) + diff / 2);
}

function midpointLongitudeReverse(start, end) {
  let diff = norm360Client(Number(start) - Number(end));
  if (diff === 0) diff = 30;
  return norm360Client(Number(start) - diff / 2);
}

function houseNumberFromCuspsClient(longitude, houses = []) {
  const entries = houses.
  map((house) => [Number(house.number), Number(house.longitude)]).
  filter(([, value]) => Number.isFinite(value)).
  sort((a, b) => a[0] - b[0]);
  if (!entries.length) return 1;

  const degree = norm360Client(longitude);
  let houseNumber = 1;

  for (const [house, cusp] of entries) {
    const current = norm360Client(cusp);
    const nextHouse = Number(house) % 12 + 1;
    const next = norm360Client(entries.find(([number]) => number === nextHouse)?.[1] ?? entries[0][1]);
    const wraps = next < current;
    const inside = wraps ?
    degree >= current || degree < next :
    degree >= current && degree < next;
    if (inside) {
      houseNumber = Number(house);
      break;
    }
  }

  return houseNumber;
}

function houseNumberFromReverseCuspsClient(longitude, houses = []) {
  const entries = houses.
  map((house) => [Number(house.number), Number(house.longitude)]).
  filter(([, value]) => Number.isFinite(value)).
  sort((a, b) => a[0] - b[0]);
  if (!entries.length) return 1;

  const degree = norm360Client(longitude);

  for (const [house, cusp] of entries) {
    const current = norm360Client(cusp);
    const nextHouse = Number(house) % 12 + 1;
    const next = norm360Client(entries.find(([number]) => number === nextHouse)?.[1] ?? entries[0][1]);
    const span = norm360Client(current - next) || 30;
    const distanceFromCurrent = norm360Client(current - degree);

    if (distanceFromCurrent < span) {
      return Number(house);
    }
  }

  return 1;
}

function romanHouse(value) {
  return ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"][Number(value)] || String(value || "");
}

function angularDistanceClient(a, b) {
  const diff = Math.abs(norm360Client(a) - norm360Client(b));
  return diff > 180 ? 360 - diff : diff;
}

function norm360Client(value) {
  const number = Number(value);
  const normalized = number % 360;
  return normalized < 0 ? normalized + 360 : normalized;
}

function getChartPlanetTooltipHost(planet) {
  const fullscreenElement = document.fullscreenElement;
  if (fullscreenElement?.contains(planet)) return fullscreenElement;

  return planet?.closest?.(".is-chart-card-fallback-fullscreen") ||
  chartWheelStage?.closest(".chart-wheel-modal") ||
  document.body;
}

function getChartPlanetTooltip(planet) {
  let tooltip = document.querySelector("#chart-planet-tooltip");
  if (!tooltip) {
    tooltip = document.createElement("div");
    tooltip.id = "chart-planet-tooltip";
    tooltip.className = "chart-planet-tooltip";
    tooltip.setAttribute("role", "tooltip");
    tooltip.setAttribute("aria-hidden", "true");
    tooltip.hidden = true;
  }

  const host = getChartPlanetTooltipHost(planet);
  if (tooltip.parentElement !== host) host.appendChild(tooltip);
  return tooltip;
}

function ensureChartPlanetTooltipElement() {
  let tooltip = document.querySelector("#chart-planet-tooltip");
  if (tooltip) return;
  tooltip = document.createElement("div");
  tooltip.id = "chart-planet-tooltip";
  tooltip.className = "chart-planet-tooltip";
  tooltip.setAttribute("role", "tooltip");
  tooltip.setAttribute("aria-hidden", "true");
  tooltip.hidden = true;
  I18n.bind(tooltip, "innerHTML", () => `
    <div class="chart-planet-tooltip-header">
      <span class="chart-planet-tooltip-glyph" style="--planet-color: var(--accent)" aria-hidden="true">•</span>
      <div class="chart-planet-tooltip-heading">
        <strong class="chart-planet-tooltip-name">${T("interface.planeta")}</strong>
        <span class="chart-planet-tooltip-context">${T("interface.carta")}</span>
      </div>
    </div>
  `);
  document.body.appendChild(tooltip);
}

let chartPlanetTooltipTarget = null;
let chartPlanetTooltipPinnedTarget = null;
let suppressChartPlanetClickUntil = 0;

function chartPlanetFromEventTarget(target) {
  return target?.closest?.(".chart-planet[data-chart-planet-id]") || null;
}

function nodalAgeMarkerFromEventTarget(target) {
  return target?.closest?.("[data-nodal-current-age-action]") || null;
}

function nodalPlanetAgeMarkerFromEventTarget(target) {
  return target?.closest?.("[data-nodal-planet-age-action]") || null;
}

function chartPlanetFromNodalAgeMarker(marker) {
  if (!marker) return null;
  const svg = marker.closest?.(".nodal-wheel-stack")?.querySelector?.("svg.chart-wheel-svg");
  const planetId = marker.dataset.nodalPlanetId || "";
  return planetId ? chartPlanetGroupByInteractionId(svg, planetId) : null;
}

function chartTooltipTargetFromEventTarget(target) {
  return nodalAgeMarkerFromEventTarget(target) ||
  nodalPlanetAgeMarkerFromEventTarget(target) ||
  chartPlanetFromEventTarget(target);
}

function nodalAgeFocusAspectLines(marker) {
  const svg = marker?.closest?.(".nodal-wheel-stack")?.querySelector?.("svg.chart-wheel-svg");
  if (!svg) return [];
  const ageId = marker.dataset.nodalCurrentAgeId || chartPlanetInteractionId("base", "current-age");
  return Array.from(svg.querySelectorAll(".nodal-current-age-aspect[data-chart-aspect-endpoint-a][data-chart-aspect-endpoint-b]")).
  filter((line) => !line.classList.contains("is-chart-planet-hidden")).
  filter((line) => line.dataset.chartAspectEndpointA === ageId || line.dataset.chartAspectEndpointB === ageId);
}

function chartPlanetFocusAspectLines(planet) {
  const svg = planet?.closest?.("svg.chart-wheel-svg");
  if (!svg) return [];
  const planetId = planet.dataset.chartPlanetId || "";
  const aspectContext = svg.dataset.chartHasCrossAspects === "true" ? "cross" : "base";
  return Array.from(svg.querySelectorAll(".chart-aspect[data-chart-aspect-endpoint-a][data-chart-aspect-endpoint-b]")).
  filter((line) => !line.classList.contains("is-chart-planet-hidden")).
  filter((line) => line.dataset.chartAspectContext === aspectContext).
  filter((line) =>
  line.dataset.chartAspectEndpointA === planetId || line.dataset.chartAspectEndpointB === planetId
  );
}

function chartPlanetGroupByInteractionId(svg, planetId) {
  return Array.from(svg?.querySelectorAll?.(".chart-planet[data-chart-planet-id]") || []).
  find((planet) => planet.dataset.chartPlanetId === planetId) || null;
}

function chartPlanetKeyFromInteractionId(planetId) {
  const separator = String(planetId || "").indexOf(":");
  return separator >= 0 ? String(planetId).slice(separator + 1) : String(planetId || "");
}

function chartPlanetTooltipAspectMarkup(planet, line) {
  const svg = planet.closest("svg.chart-wheel-svg");
  const planetId = planet.dataset.chartPlanetId || "";
  const targetId = line.dataset.chartAspectEndpointA === planetId ?
  line.dataset.chartAspectEndpointB :
  line.dataset.chartAspectEndpointA;
  const targetPlanet = chartPlanetGroupByInteractionId(svg, targetId);
  const targetKey = targetPlanet?.dataset.chartPlanetKey || chartPlanetKeyFromInteractionId(targetId);
  const targetName = targetPlanet?.dataset.planetTitle || PROMPT_PLANET_LABELS[targetKey] || targetKey;
  const angle = Number(line.dataset.chartAspectAngle);
  const aspectName = line.dataset.chartAspectName ||
  ASPECT_CONFIGS.find((item) => Number(item.angle) === angle)?.label ||
  `Aspecto ${angle}°`;
  const symbol = ASPECT_SYMBOLS[angle] || "•";
  const rawOrb = line.dataset.chartAspectOrb;
  const hasOrb = svg.dataset.chartAspectMode !== "sign" && rawOrb !== "" && Number.isFinite(Number(rawOrb));
  const orbLabel = hasOrb ? T("interface.orbe_value", { v0: formatOrb(Number(rawOrb)) }) : T("interface.sin_orbe_2");
  const aspectColor = chartAspectColorCssValue(angle);

  return `
    <li class="chart-planet-tooltip-aspect" style="--aspect-color:${aspectColor}">
      <span class="chart-planet-tooltip-aspect-marker" aria-hidden="true"></span>
      <span class="chart-planet-tooltip-aspect-name"><span aria-hidden="true">${escapeHtml(symbol)}</span> ${escapeHtml(I18n.label(aspectName))}</span>
      <strong class="chart-planet-tooltip-aspect-target">${escapeHtml(targetName)}</strong>
      <small class="chart-planet-tooltip-aspect-orb">${escapeHtml(orbLabel)}</small>
    </li>
  `;
}

function nodalAgeTooltipAspectMarkup(marker, line) {
  const svg = marker.closest(".nodal-wheel-stack")?.querySelector("svg.chart-wheel-svg");
  const ageId = marker.dataset.nodalCurrentAgeId || chartPlanetInteractionId("base", "current-age");
  const targetId = line.dataset.chartAspectEndpointA === ageId ?
  line.dataset.chartAspectEndpointB :
  line.dataset.chartAspectEndpointA;
  const targetPlanet = chartPlanetGroupByInteractionId(svg, targetId);
  const targetKey = targetPlanet?.dataset.chartPlanetKey || chartPlanetKeyFromInteractionId(targetId);
  const targetName = targetPlanet?.dataset.planetTitle || PROMPT_PLANET_LABELS[targetKey] || targetKey;
  const angle = Number(line.dataset.chartAspectAngle);
  const aspectName = line.dataset.chartAspectName ||
  ASPECT_CONFIGS.find((item) => Number(item.angle) === angle)?.label ||
  `Aspecto ${angle}°`;
  const symbol = ASPECT_SYMBOLS[angle] || "•";
  const rawOrb = line.dataset.chartAspectOrb;
  const orbLabel = rawOrb !== "" && Number.isFinite(Number(rawOrb)) ? T("interface.orbe_value", { v0: formatOrb(Number(rawOrb)) }) : T("interface.sin_orbe_2");


  const aspectColor = chartAspectColorCssValue(angle);

  return `
    <li class="chart-planet-tooltip-aspect" style="--aspect-color:${aspectColor}">
      <span class="chart-planet-tooltip-aspect-marker" aria-hidden="true"></span>
      <span class="chart-planet-tooltip-aspect-name"><span aria-hidden="true">${escapeHtml(symbol)}</span> ${escapeHtml(I18n.label(aspectName))}</span>
      <strong class="chart-planet-tooltip-aspect-target">${escapeHtml(targetName)}</strong>
      <small class="chart-planet-tooltip-aspect-orb">${escapeHtml(orbLabel)}</small>
    </li>
  `;
}

function chartPlanetTooltipZodiacIndex(sign = "", explicitIndex = Number.NaN) {
  const normalizedSign = String(sign || "").
  normalize("NFD").
  replace(/[\u0300-\u036f]/g, "").
  trim().
  toLocaleLowerCase("es-ES");
  const nameIndex = PROMPT_SIGNS.findIndex((name) => name.toLocaleLowerCase("es-ES") === normalizedSign);
  if (nameIndex >= 0) return nameIndex;

  const numericIndex = Number(explicitIndex);
  return Number.isFinite(numericIndex) ? (numericIndex % 12 + 12) % 12 : -1;
}

function chartPlanetTooltipZodiacMarkup(sign = "", explicitIndex = Number.NaN) {
  const index = chartPlanetTooltipZodiacIndex(sign, explicitIndex);
  if (index < 0) return escapeHtml(sign || "—");

  const name = I18n.label(sign || PROMPT_SIGNS[index] || "—");
  const symbol = ZODIAC_SYMBOLS[index] || "";
  const lightColor = ZODIAC_LIGHT_GLYPH_COLORS[index] || ZODIAC_TABLE_COLORS[index] || "var(--text)";
  const darkColor = ZODIAC_GLYPH_COLORS[index] || lightColor;
  return `
    <span class="chart-planet-tooltip-zodiac" style="--zodiac-tooltip-color:${lightColor};--zodiac-tooltip-dark-color:${darkColor}">
      <span class="chart-planet-tooltip-zodiac-symbol" aria-hidden="true">${escapeHtml(symbol)}</span>
      <span>${escapeHtml(name)}</span>
    </span>
  `;
}

function renderNodalAgeTooltip(marker, options = {}) {
  const sign = marker.dataset.nodalCurrentAgeSign || "";
  const signIndex = marker.dataset.nodalCurrentAgeSignIndex === "" ?
  Number.NaN :
  Number(marker.dataset.nodalCurrentAgeSignIndex);
  const degree = marker.dataset.nodalCurrentAgeDegree || "";
  const minute = marker.dataset.nodalCurrentAgeMinute || "0";
  const second = marker.dataset.nodalCurrentAgeSecond || "0";
  const house = Number(marker.dataset.nodalCurrentAgeHouse);
  const age = marker.dataset.nodalCurrentAgeValue || "";
  const date = marker.dataset.nodalCurrentAgeDate || "";
  const aspectLines = nodalAgeFocusAspectLines(marker);
  const stack = marker.closest(".nodal-wheel-stack");
  const svg = stack?.querySelector("svg.chart-wheel-svg");
  const isFocused = svg?.dataset.chartFocusedPlanet === (marker.dataset.nodalCurrentAgeId || chartPlanetInteractionId("base", "current-age"));
  const degreePosition = degree === "" ?
  "" :
  `${degree}° ${pad(minute)}′ ${pad(second)}″`;
  const houseLabel = Number.isFinite(house) && house >= 1 && house <= 12 ? T("interface.casa_value", { v0: romanHouse(house) }) : T("interface.sin_casas");
  const note = !aspectLines.length ? T("interface.sin_aspectos_visibles_con_la_configuracion_actual") : "";

  return `
    <div class="chart-planet-tooltip-header">
      <span class="chart-planet-tooltip-glyph chart-planet-tooltip-age-glyph" style="--planet-color:#dc2626" aria-hidden="true"><span class="chart-planet-tooltip-glyph-symbol">${CURRENT_AGE_SYMBOL}</span></span>
      <div class="chart-planet-tooltip-heading">
        <strong class="chart-planet-tooltip-name">${T("interface.punto_de_edad")}</strong>
        <span class="chart-planet-tooltip-context">${T("interface.esquema_nodal_3")}</span>
      </div>
    </div>
    <p class="chart-planet-tooltip-position">
      ${chartPlanetTooltipZodiacMarkup(sign, signIndex)}
      ${degreePosition ? `<span class="chart-planet-tooltip-separator">·</span><span>${escapeHtml(degreePosition)}</span>` : ""}
      <span class="chart-planet-tooltip-separator">·</span><span>${escapeHtml(houseLabel)}</span>
    </p>
    <div class="chart-planet-tooltip-meta chart-planet-tooltip-age-meta">
      <div class="chart-planet-tooltip-meta-item" style="--planet-color:#dc2626"><span>${T("interface.edad")}</span><strong>${T("interface.value_anos_2", { v4: escapeHtml(age) })}</strong></div>
      <div class="chart-planet-tooltip-meta-item"><span>${T("common.date")}</span><strong>${escapeHtml(formatDateForPrompt(date))}</strong></div>
      ${window.AtlasCharts?.entry(marker) || ""}
    </div>
    <div class="chart-planet-tooltip-aspects">
      <div class="chart-planet-tooltip-aspects-title"><span>${T("interface.aspectos_visibles")}</span><small>${aspectLines.length}</small></div>
      ${aspectLines.length ? `<ul class="chart-planet-tooltip-aspect-list">${aspectLines.map((line) => nodalAgeTooltipAspectMarkup(marker, line)).join("")}</ul>` : ""}
    </div>
    ${note ? `<p class="chart-planet-tooltip-note">${escapeHtml(note)}</p>` : ""}
  `;
}

function renderChartPlanetTooltip(planet, options = {}) {
  const key = planet.dataset.chartPlanetKey || "";
  const isAnglePoint = CHART_ANGLE_POINT_KEYS.includes(key);
  const isTextPoint = ["Vertex", "Chariklo", "Eros", "Icarus", "Nessus", "Pholus"].includes(key);
  const tooltipGlyphClasses = [
  isAnglePoint ? "is-angle-point" : "",
  isTextPoint ? "is-text-point" : "",
  key === "tierra" ? "is-earth-point" : ""].
  filter(Boolean).join(" ");
  const title = I18n.label(planet.dataset.planetTitle || PROMPT_PLANET_LABELS[key] || key);
  const context = I18n.label(planet.dataset.chartPlanetContext || T("interface.carta"));
  const sign = planet.dataset.chartPlanetSign || "";
  const signIndex = planet.dataset.chartPlanetSignIndex === "" ?
  Number.NaN :
  Number(planet.dataset.chartPlanetSignIndex);
  const degree = planet.dataset.chartPlanetDegree;
  const minute = planet.dataset.chartPlanetMinute;
  const second = planet.dataset.chartPlanetSecond;
  const house = Number(planet.dataset.chartPlanetHouse);
  const promptHouse = Number(planet.dataset.chartPlanetPromptHouse);
  const hasPromptHouseShift = house >= 1 && house <= 12 && promptHouse === house % 12 + 1;
  const decanate = planet.dataset.chartPlanetDecanate || "—";
  const decanateSignIndex = planet.dataset.chartPlanetDecanateIndex === "" ?
  Number.NaN :
  Number(planet.dataset.chartPlanetDecanateIndex);
  const dodecatemoria = planet.dataset.chartPlanetDodecatemoria || "—";
  const dodecatemoriaSignIndex = planet.dataset.chartPlanetDodecatemoriaIndex === "" ?
  Number.NaN :
  Number(planet.dataset.chartPlanetDodecatemoriaIndex);
  const nodalAges = String(planet.dataset.chartPlanetNodalAges || "").
  split("|").
  map((value) => value.trim()).
  filter(Boolean);
  const nodalAgeLabel = nodalAges.length > 1 ? T("interface.edades_nodales") : T("interface.edad_nodal");
  const nodalAgeText = nodalAges.length ? T("interface.value_anos_3", { v0: nodalAges.join(" | ") }) : "";
  const retrograde = planet.dataset.chartPlanetRetrograde === "true";
  const aspectsEnabled = planet.dataset.chartPlanetAspectsEnabled !== "false";
  const aspectLines = chartPlanetFocusAspectLines(planet);
  const svg = planet.closest("svg.chart-wheel-svg");
  const isSignAspectChart = svg?.dataset.chartAspectMode === "sign";
  const isCrossAspectChart = svg?.dataset.chartHasCrossAspects === "true";
  const counterpartContext = isCrossAspectChart ?
  Array.from(svg.querySelectorAll(".chart-planet[data-chart-planet-context]")).
  find((candidate) => candidate.dataset.chartPlanetLayer !== planet.dataset.chartPlanetLayer)?.
  dataset.chartPlanetContext :
  "";
  const zodiacPosition = chartPlanetTooltipZodiacMarkup(sign, signIndex);
  const degreePosition = degree === "" ?
  "" :
  `${degree}° ${pad(minute || 0)}′${second !== "" ? ` ${pad(second || 0)}″` : ""}`;
  const houseLabel = Number.isFinite(house) && house >= 1 && house <= 12 ? T("interface.casa_value", { v0: romanHouse(house) }) : T("interface.sin_casas");
  const relationTitle = isSignAspectChart ? T("interface.aspectos_por_signo") :

  isCrossAspectChart && counterpartContext ? T("interface.aspectos_con_value", { v0: counterpartContext }) : T("interface.aspectos_visibles");
  const note = !aspectsEnabled ?
  T(isAnglePoint ? "charts.tooltipDisabledPoint" : "charts.tooltipDisabledBody") :
  !aspectLines.length ? T("interface.sin_aspectos_visibles_con_la_configuracion_actual") : "";

  return `
    <div class="chart-planet-tooltip-header">
      <span class="chart-planet-tooltip-glyph${tooltipGlyphClasses ? ` ${tooltipGlyphClasses}` : ""}" style="--planet-color:${chartPlanetColorCssValue(key, "var(--accent)")}" aria-hidden="true"><span class="chart-planet-tooltip-glyph-symbol">${escapeHtml(planetGlyph(key))}</span></span>
      <div class="chart-planet-tooltip-heading">
        <strong class="chart-planet-tooltip-name">${escapeHtml(title)}${retrograde ? " ℞" : ""}</strong>
        <span class="chart-planet-tooltip-context">${escapeHtml(context)}</span>
      </div>
    </div>
    <p class="chart-planet-tooltip-position">
      ${zodiacPosition}
      ${degreePosition ? `<span class="chart-planet-tooltip-separator">·</span><span>${escapeHtml(degreePosition)}</span>` : ""}
      <span class="chart-planet-tooltip-separator">·</span><span>${escapeHtml(houseLabel)}${hasPromptHouseShift ? ` → ${romanHouse(promptHouse)}` : ""}</span>
    </p>
    <div class="chart-planet-tooltip-meta">
      <div class="chart-planet-tooltip-meta-item"><span>${T("interface.decanato")}</span><strong>${chartPlanetTooltipZodiacMarkup(decanate, decanateSignIndex)}</strong></div>
      <div class="chart-planet-tooltip-meta-item"><span>${T("interface.dodecatemoria")}</span><strong>${chartPlanetTooltipZodiacMarkup(dodecatemoria, dodecatemoriaSignIndex)}</strong></div>
      ${nodalAgeText ? `<div class="chart-planet-tooltip-meta-item chart-planet-tooltip-nodal-age" style="--planet-color:${chartPlanetColorCssValue(key, "var(--accent)")}"><span>${escapeHtml(nodalAgeLabel)}</span><strong>${escapeHtml(nodalAgeText)}</strong></div>` : ""}
      ${window.AtlasCharts?.entry(planet) || ""}
    </div>
    <div class="chart-planet-tooltip-aspects">
      <div class="chart-planet-tooltip-aspects-title"><span>${escapeHtml(relationTitle)}</span><small>${aspectLines.length}${isSignAspectChart ? T("interface.sin_orbe") : ""}</small></div>
      ${aspectLines.length ? `<ul class="chart-planet-tooltip-aspect-list">${aspectLines.map((line) => chartPlanetTooltipAspectMarkup(planet, line)).join("")}</ul>` : ""}
    </div>
    ${retrograde && planet.dataset.chartStationUtc ? `<div class="chart-planet-tooltip-station" data-direct-station aria-live="polite">${escapeHtml(T("stations.loading"))}</div>` : ""}
    ${note ? `<p class="chart-planet-tooltip-note">${escapeHtml(note)}</p>` : ""}
  `;
}

// Load the integration (including structural metadata) only for the existing
// server-granted capability. The asset route also checks admin session + MFA.
function syncAtlasChartAccess() {
  if (window.AtlasCharts) {
    window.AtlasCharts.configure({
      authorized: () => Boolean(currentUser?.canAccessAtlas),
      view: () => activeChartViewType,
      pointAppearance: (key) => ({
        glyph: key === "current-age" ? "◷" : planetGlyph(key),
        color: chartPlanetColorCssValue(key, "var(--accent)"),
        isAngle: CHART_ANGLE_POINT_KEYS.includes(key),
        isText: ["Vertex", "Chariklo", "Eros", "Icarus", "Nessus", "Pholus"].includes(key)
      }),
      beforeOpen: () => hideChartPlanetTooltip({ force: true })
    });
    return;
  }
  if (!currentUser?.canAccessAtlas || atlasChartScriptLoading) return;
  atlasChartScriptLoading = true;
  const script = document.createElement("script");
  script.src = "/atlas/assets/chart-context.bundle.js?v=typology-label-20261030";
  script.onload = () => {atlasChartScriptLoading = false;script.remove();syncAtlasChartAccess();};
  script.onerror = () => {atlasChartScriptLoading = false;script.remove();};
  document.head.append(script);
}
document.addEventListener("admin-security-ready", syncAtlasChartAccess);

function chartPlanetTooltipOverlapArea(left, top, width, height, targetRect, padding = 0) {
  const targetLeft = targetRect.left - padding;
  const targetTop = targetRect.top - padding;
  const targetRight = targetRect.right + padding;
  const targetBottom = targetRect.bottom + padding;
  const overlapWidth = Math.max(0, Math.min(left + width, targetRight) - Math.max(left, targetLeft));
  const overlapHeight = Math.max(0, Math.min(top + height, targetBottom) - Math.max(top, targetTop));
  return overlapWidth * overlapHeight;
}

function chartPlanetTooltipObstacles(trigger) {
  const planet = trigger.matches?.("[data-nodal-planet-age-action]") ?
  chartPlanetFromNodalAgeMarker(trigger) : trigger;
  const svg = planet?.closest?.("svg.chart-wheel-svg") ||
  trigger.closest?.(".nodal-wheel-stack")?.querySelector("svg.chart-wheel-svg");
  if (!svg) return null;
  const lines = trigger.matches?.("[data-nodal-current-age-action]") ?
  nodalAgeFocusAspectLines(trigger) : chartPlanetFocusAspectLines(planet);
  const relatedIds = new Set([planet?.dataset.chartPlanetId]);
  lines.forEach((line) => {
    relatedIds.add(line.dataset.chartAspectEndpointA);
    relatedIds.add(line.dataset.chartAspectEndpointB);
  });
  const rects = [trigger.getBoundingClientRect()];
  svg.querySelectorAll(".chart-planet[data-chart-planet-id], [data-chart-aspect-anchor-id]").forEach((element) => {
    const id = element.dataset.chartPlanetId || element.dataset.chartAspectAnchorId;
    if (relatedIds.has(id) && !element.classList.contains("is-chart-planet-hidden")) {
      rects.push(element.getBoundingClientRect());
    }
  });
  // Compare actual segments, rather than their bounding boxes: the empty space
  // on either side of a diagonal aspect remains available for the tooltip.
  const segments = lines.flatMap((line) => {
    const matrix = line.getScreenCTM?.();
    if (!matrix) return [];
    const point = (x, y) => ({
      x: matrix.a * x + matrix.c * y + matrix.e,
      y: matrix.b * x + matrix.d * y + matrix.f
    });
    return [{ start: point(line.x1.baseVal.value, line.y1.baseVal.value),
      end: point(line.x2.baseVal.value, line.y2.baseVal.value) }];
  });
  return { chartRect: svg.getBoundingClientRect(), rects, segments };
}

function chartTooltipCoveredSegmentLength(left, top, width, height, segment, padding = 8) {
  const dx = segment.end.x - segment.start.x;
  const dy = segment.end.y - segment.start.y;
  let start = 0;
  let end = 1;
  for (const [origin, delta, minimum, maximum] of [
  [segment.start.x, dx, left - padding, left + width + padding],
  [segment.start.y, dy, top - padding, top + height + padding]])
  {
    if (delta === 0) {
      if (origin < minimum || origin > maximum) return 0;
    } else {
      const a = (minimum - origin) / delta;
      const b = (maximum - origin) / delta;
      start = Math.max(start, Math.min(a, b));
      end = Math.min(end, Math.max(a, b));
      if (end <= start) return 0;
    }
  }
  return (end - start) * Math.hypot(dx, dy);
}

function calculateDesktopChartTooltipPlacement(options) {
  const { planetRect, obstacles } = options;
  const width = options.tooltipWidth;
  const safeLeft = (options.viewportLeft || 0) + 8;
  const safeTop = (options.viewportTop || 0) + 8;
  const safeRight = (options.viewportLeft || 0) + options.viewportWidth - 8;
  const safeBottom = (options.viewportTop || 0) + options.viewportHeight - 8;
  const naturalHeight = Math.min(options.tooltipHeight, safeBottom - safeTop);
  const clamp = (value, min, max) => Math.max(min, Math.min(Math.max(min, max), value));
  const centerX = planetRect.left + planetRect.width / 2;
  const centerY = planetRect.top + planetRect.height / 2;
  const gap = 14;
  let fallback = null;
  // Keep the complete card whenever possible. On crowded desktop charts the
  // existing internal scroll lets a shorter card leave the aspects uncovered.
  const heights = [...new Set([naturalHeight, Math.min(naturalHeight, 240), Math.min(naturalHeight, 160)])];
  for (const height of heights) {
    const xs = new Set([safeLeft, safeRight - width, centerX - width / 2]);
    const ys = new Set([safeTop, safeBottom - height, centerY - height / 2]);
    for (const rect of [obstacles.chartRect, ...obstacles.rects]) {
      xs.add(rect.left - gap - width);
      xs.add(rect.right + gap);
      ys.add(rect.top - gap - height);
      ys.add(rect.bottom + gap);
    }
    // Include empty quadrants even when the wheel fills the whole viewport.
    for (let x = safeLeft; x <= safeRight - width; x += 48) xs.add(x);
    for (let y = safeTop; y <= safeBottom - height; y += 48) ys.add(y);
    let best = null;
    for (const rawLeft of xs) for (const rawTop of ys) {
      const left = clamp(rawLeft, safeLeft, safeRight - width);
      const top = clamp(rawTop, safeTop, safeBottom - height);
      const coveredPlanets = obstacles.rects.reduce((sum, rect) => sum +
      chartPlanetTooltipOverlapArea(left, top, width, height, rect, 8), 0);
      const coveredAspects = obstacles.segments.reduce((sum, segment) => sum +
      chartTooltipCoveredSegmentLength(left, top, width, height, segment), 0);
      const coverage = coveredPlanets + coveredAspects * 16;
      const chartOverlap = chartPlanetTooltipOverlapArea(left, top, width, height, obstacles.chartRect, gap);
      const distance = Math.hypot(left + width / 2 - centerX, top + height / 2 - centerY);
      const candidate = { left, top, coverage, chartOverlap, distance,
        maxHeight: Math.floor(height), placement: chartOverlap === 0 ? "outside-chart" : "clear-space" };
      if (!best || coverage < best.coverage ||
      coverage === best.coverage && (distance < best.distance ||
      distance === best.distance && chartOverlap < best.chartOverlap)) best = candidate;
    }
    if (best?.coverage === 0) return best;
    if (best && (!fallback || best.coverage < fallback.coverage)) fallback = best;
  }
  return fallback;
}

function calculateChartPlanetTooltipPlacement(options = {}) {
  const planetRect = options.planetRect;
  const width = Math.max(0, Number(options.tooltipWidth) || 0);
  const naturalHeight = Math.max(0, Number(options.tooltipHeight) || 0);
  const viewportLeft = Number(options.viewportLeft) || 0;
  const viewportTop = Number(options.viewportTop) || 0;
  const viewportWidth = Math.max(0, Number(options.viewportWidth) || 0);
  const viewportHeight = Math.max(0, Number(options.viewportHeight) || 0);
  const compact = Boolean(options.compact);
  if (!compact && options.obstacles) {
    const desktopPlacement = calculateDesktopChartTooltipPlacement(options);
    if (desktopPlacement) return desktopPlacement;
  }
  const margin = 8;
  const gap = compact ? 16 : 14;
  const safeLeft = viewportLeft + margin;
  const safeTop = viewportTop + margin;
  const safeRight = viewportLeft + viewportWidth - margin;
  const safeBottom = viewportTop + viewportHeight - margin;
  const centerX = planetRect.left + planetRect.width / 2;
  const centerY = planetRect.top + planetRect.height / 2;
  const clamp = (value, minimum, maximum) => Math.max(minimum, Math.min(Math.max(minimum, maximum), value));

  /*
   * En pantallas táctiles el tooltip ocupa casi todo el ancho, así que la
   * posición más clara es arriba o abajo del planeta. Si no cabe completo,
   * reducimos únicamente su altura: el contenido ya dispone de scroll propio.
   */
  if (compact) {
    const spaceAbove = Math.max(0, planetRect.top - gap - safeTop);
    const spaceBelow = Math.max(0, safeBottom - planetRect.bottom - gap);
    const placeAbove = spaceAbove > spaceBelow;
    const availableHeight = placeAbove ? spaceAbove : spaceBelow;
    const minimumUsefulHeight = Math.min(120, Math.max(72, viewportHeight * 0.2));
    if (availableHeight >= minimumUsefulHeight) {
      const height = Math.min(naturalHeight, availableHeight);
      const left = clamp(centerX - width / 2, safeLeft, safeRight - width);
      const top = placeAbove ? planetRect.top - gap - height : planetRect.bottom + gap;
      return {
        left,
        top,
        maxHeight: Math.floor(availableHeight),
        placement: placeAbove ? "above" : "below"
      };
    }
  }

  const height = naturalHeight;
  const maxLeft = safeRight - width;
  const maxTop = safeBottom - height;
  const pointerX = Number(options.pointerX);
  const pointerY = Number(options.pointerY);
  const hasPointer = Number.isFinite(pointerX) && Number.isFinite(pointerY) && (
  pointerX !== 0 || pointerY !== 0);
  const rawCandidates = [];
  const addCandidate = (placement, left, top, priority) => {
    rawCandidates.push({ placement, left, top, priority });
  };

  addCandidate("right", planetRect.right + gap, centerY - height / 2, 4);
  addCandidate("left", planetRect.left - gap - width, centerY - height / 2, 5);
  addCandidate("below", centerX - width / 2, planetRect.bottom + gap, 6);
  addCandidate("above", centerX - width / 2, planetRect.top - gap - height, 7);
  if (hasPointer) {
    addCandidate("pointer-bottom-right", pointerX + gap, pointerY + gap, 0);
    addCandidate("pointer-bottom-left", pointerX - gap - width, pointerY + gap, 1);
    addCandidate("pointer-top-right", pointerX + gap, pointerY - gap - height, 2);
    addCandidate("pointer-top-left", pointerX - gap - width, pointerY - gap - height, 3);
  }

  const avoidancePadding = compact ? 10 : 6;
  const candidates = rawCandidates.map((candidate) => {
    const left = clamp(candidate.left, safeLeft, maxLeft);
    const top = clamp(candidate.top, safeTop, maxTop);
    const overlapArea = chartPlanetTooltipOverlapArea(
      left,
      top,
      width,
      height,
      planetRect,
      avoidancePadding
    );
    const clampDistance = Math.abs(left - candidate.left) + Math.abs(top - candidate.top);
    return {
      ...candidate,
      left,
      top,
      overlapArea,
      score: (overlapArea > 0 ? 10000000 + overlapArea : 0) + clampDistance * 20 + candidate.priority
    };
  });
  candidates.sort((a, b) => a.score - b.score);
  const best = candidates[0] || { left: safeLeft, top: safeTop, placement: "viewport" };
  return { left: best.left, top: best.top, maxHeight: null, placement: best.placement };
}

function positionChartPlanetTooltip(tooltip, planet, event = null) {
  if (!tooltip || !planet) return;
  tooltip.style.maxHeight = "";
  const planetRect = planet.querySelector?.(".chart-planet-hit, rect")?.getBoundingClientRect() ||
  planet.getBoundingClientRect();
  const rect = tooltip.getBoundingClientRect();
  const visualViewport = window.visualViewport;
  const viewportWidth = visualViewport?.width || window.innerWidth;
  const viewportHeight = visualViewport?.height || window.innerHeight;
  const viewportLeft = visualViewport?.offsetLeft || 0;
  const viewportTop = visualViewport?.offsetTop || 0;
  const compact = event?.pointerType === "touch" ||
  window.matchMedia?.("(max-width: 640px), (pointer: coarse)")?.matches;
  const placement = calculateChartPlanetTooltipPlacement({
    planetRect,
    tooltipWidth: rect.width,
    tooltipHeight: rect.height,
    viewportLeft,
    viewportTop,
    viewportWidth,
    viewportHeight,
    pointerX: event?.clientX,
    pointerY: event?.clientY,
    obstacles: compact ? null : chartPlanetTooltipObstacles(planet),
    compact
  });
  tooltip.style.maxHeight = Number.isFinite(placement.maxHeight) ? `${placement.maxHeight}px` : "";
  tooltip.style.left = `${placement.left}px`;
  tooltip.style.top = `${placement.top}px`;
  tooltip.dataset.placement = placement.placement;
}

function repositionActiveChartPlanetTooltip() {
  if (!chartPlanetTooltipTarget?.isConnected) return;
  const tooltip = document.querySelector("#chart-planet-tooltip");
  if (!tooltip || tooltip.hidden) return;
  positionChartPlanetTooltip(tooltip, chartPlanetTooltipTarget);
}

const chartDirectStationRequests = new Map();

function fetchChartDirectStation(body, at, mode = "transit", birthAt = "") {
  const key = JSON.stringify([body, at, mode, birthAt]);
  const cached = chartDirectStationRequests.get(key);
  if (cached && cached.expires > Date.now()) return cached.promise;
  chartDirectStationRequests.delete(key);
  if (chartDirectStationRequests.size >= 40) chartDirectStationRequests.delete(chartDirectStationRequests.keys().next().value);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 25000);
  const params = new URLSearchParams({ body, at, mode });
  if (mode === "progressed") params.set("birthAt", birthAt);
  const promise = I18n.fetch(`/api/chart/direct-station?${params}`, { signal: controller.signal }).
  then((response) => {
    if (!response.ok) throw new Error();
    return response.json();
  }).then((result) => {
    if (result.body !== body || Date.parse(result.at) !== Date.parse(at) || result.mode !== mode ||
    mode === "progressed" && Date.parse(result.birthAt) !== Date.parse(birthAt)) throw new Error();
    if (result.status === "unavailable") chartDirectStationRequests.delete(key);
    return result;
  }).catch((error) => {
    chartDirectStationRequests.delete(key);
    throw error;
  }).finally(() => clearTimeout(timeout));
  chartDirectStationRequests.set(key, { promise, expires: Date.now() + 3600000 });
  return promise;
}

function chartDirectStationText(result, timeZone) {
  const mode = result.mode || "transit";
  const node = ["true Node", "south Node"].includes(result.body);
  if (result.status === "unavailable" || result.status === "not_retrograde") return [];
  if (result.status === "not_found") return [T(mode === "progressed" ? "stations.progressedNotFound" : "stations.notFound", { count: result.maxAgeYears || result.searchedDays || 370 })];
  const date = new Date(mode === "progressed" ? result.progressedDirectAt : result.directAt);
  const remaining = Date.parse(result.directAt) - Date.parse(result.at);
  if (!Number.isFinite(date.getTime()) || !Number.isFinite(remaining) || remaining <= 0) return [];
  const format = { timeZone, day: "numeric", month: "short", year: "numeric" };
  if (mode !== "progressed") Object.assign(format, { hour: "2-digit", minute: "2-digit", timeZoneName: "short" });
  const formatted = new Intl.DateTimeFormat(I18n.locale(), format).format(date);
  if (mode === "progressed") {
    if (!Number.isFinite(result.ageYears) || result.ageYears < 0 || result.ageYears > 120) return [];
    return [T("stations.progressedHeading"), T("stations.progressedAt", { date: formatted }),
    T("stations.progressedNote", { age: new Intl.NumberFormat(I18n.locale(), { maximumFractionDigits: 1 }).format(result.ageYears) }),
    ...(node ? [T("stations.nodeNote")] : [])];
  }
  if (mode === "natal") return [T("stations.natalHeading"), formatted, T(node ? "stations.natalNodeNote" : "stations.natalNote")];
  const duration = remaining < 86400000 ?
  T("stations.hours", { count: Math.max(1, Math.ceil(remaining / 3600000)) }) :
  T("stations.days", { count: Math.ceil(remaining / 86400000) });
  return [T(node ? "stations.nodeHeading" : "stations.heading"), T("stations.directAt", { date: formatted }), duration];
}

async function loadChartPlanetDirectStation(tooltip, planet, trigger) {
  const block = tooltip.querySelector("[data-direct-station]");
  if (!block || block.dataset.requested) return;
  block.dataset.requested = "true";
  const body = planet.dataset.chartPlanetKey;
  const at = planet.dataset.chartStationUtc;
  let lines;
  try {
    const result = await fetchChartDirectStation(body, at, planet.dataset.chartStationMode || "transit", planet.dataset.chartStationBirth || "");
    lines = chartDirectStationText(result, planet.dataset.chartStationZone || "UTC");
  } catch {
    lines = [T("stations.unavailable")];
  }
  if (!block.isConnected || !planet.isConnected || !tooltip.contains(block)) return;
  if (!lines.length) block.remove();else
  I18n.replaceChildren(block, ...lines.map((text, index) => {const element = document.createElement(lines.length === 1 ? "span" : index === 0 ? "strong" : index >= 2 ? "small" : "span");I18n.bind(element, "textContent", () => text);return element;}));




  if (!tooltip.hidden && chartPlanetTooltipTarget === trigger) positionChartPlanetTooltip(tooltip, trigger);
}


function displayChartPlanetTooltip(planet, event = null, options = {}) {
  if (!planet || !planet.isConnected) return;
  const trigger = options.trigger?.isConnected ? options.trigger : planet;
  const tooltip = getChartPlanetTooltip(trigger);
  if (chartPlanetTooltipTarget !== trigger || options.refresh) {
    chartPlanetTooltipTarget?.removeAttribute("aria-describedby");
    I18n.bind(tooltip, "innerHTML", () => chartPlanetTooltipCloseButton() + renderChartPlanetTooltip(planet, { touch: event?.pointerType === "touch", nodalAgeTrigger: trigger.matches?.("[data-nodal-planet-age-action]") }));



    chartPlanetTooltipTarget = trigger;
  }
  if (options.pinned) chartPlanetTooltipPinnedTarget = trigger;
  if (!options.pinned) chartPlanetTooltipPinnedTarget = null;
  tooltip.classList.toggle("is-pinned", Boolean(options.pinned));
  tooltip.setAttribute("role", options.pinned ? "dialog" : "tooltip");
  if (options.pinned) I18n.bind(tooltip, "@aria-label", () => planet.dataset.planetTitle || planet.dataset.chartPlanetKey);else
  tooltip.removeAttribute("aria-label");
  tooltip.hidden = false;
  tooltip.setAttribute("aria-hidden", "false");
  trigger.setAttribute("aria-describedby", tooltip.id);
  positionChartPlanetTooltip(tooltip, trigger, event);
  loadChartPlanetDirectStation(tooltip, planet, trigger);
}

function displayNodalAgeTooltip(marker, event = null, options = {}) {
  if (!marker || !marker.isConnected) return;
  const tooltip = getChartPlanetTooltip(marker);
  tooltip.setAttribute("role", "tooltip");
  tooltip.removeAttribute("aria-label");
  if (chartPlanetTooltipTarget !== marker || options.refresh) {
    chartPlanetTooltipTarget?.removeAttribute("aria-describedby");
    I18n.bind(tooltip, "innerHTML", () => chartPlanetTooltipCloseButton() + renderNodalAgeTooltip(marker, { touch: event?.pointerType === "touch" }));
    chartPlanetTooltipTarget = marker;
  }
  if (options.pinned) chartPlanetTooltipPinnedTarget = marker;
  if (!options.pinned) chartPlanetTooltipPinnedTarget = null;
  tooltip.classList.toggle("is-pinned", Boolean(options.pinned));
  tooltip.hidden = false;
  tooltip.setAttribute("aria-hidden", "false");
  marker.setAttribute("aria-describedby", tooltip.id);
  positionChartPlanetTooltip(tooltip, marker, event);
}

function showChartPlanetTooltip(event) {
  if (event.target.closest?.("#chart-planet-tooltip")) return;
  if (chartPlanetTooltipPinnedTarget) return;
  if (event.pointerType === "touch") return;
  const ageMarker = nodalAgeMarkerFromEventTarget(event.target);
  if (ageMarker && chartWheelStage.contains(ageMarker)) {
    if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== ageMarker) return;
    displayNodalAgeTooltip(ageMarker, event);
    return;
  }
  const planetAgeMarker = nodalPlanetAgeMarkerFromEventTarget(event.target);
  if (planetAgeMarker && chartWheelStage.contains(planetAgeMarker)) {
    const planet = chartPlanetFromNodalAgeMarker(planetAgeMarker);
    if (!planet) {
      hideChartPlanetTooltip({ force: true });
      return;
    }
    if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== planetAgeMarker) return;
    displayChartPlanetTooltip(planet, event, { trigger: planetAgeMarker });
    return;
  }
  const planet = chartPlanetFromEventTarget(event.target);
  if (!planet || !chartWheelStage.contains(planet)) {
    hideChartPlanetTooltip({ force: true });
    return;
  }
  if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== planet) return;
  displayChartPlanetTooltip(planet, event);
}

function chartPlanetTooltipCloseButton() {
  return `<button type="button" class="modal-close chart-planet-tooltip-close" data-chart-tooltip-close aria-label="${T("interface.cerrar_informacion_del_planeta")}" title="${T("public-offers.close")}">×</button>`;
}

let chartTooltipOutsidePressClosesOnly = false;

function isChartTooltipOutsidePress(event) {
  return (event.pointerType === "touch" || window.matchMedia("(max-width: 860px), (pointer: coarse)").matches) &&
  !event.target.closest?.("[data-atlas-position]") &&
  !event.target.closest?.("#chart-planet-tooltip") &&
  !chartTooltipTargetFromEventTarget(event.target);
}

function rememberChartTooltipOutsidePress(event) {
  const tooltip = document.querySelector("#chart-planet-tooltip");
  // Remember before focusout/touch zoom can hide the tooltip in fullscreen.
  chartTooltipOutsidePressClosesOnly = Boolean(tooltip && !tooltip.hidden && isChartTooltipOutsidePress(event));
}

function handleChartTooltipOutsidePress(event) {
  const closeOnly = chartTooltipOutsidePressClosesOnly;
  chartTooltipOutsidePressClosesOnly = false;
  if (!isChartTooltipOutsidePress(event)) return;
  // A map-background tap reaches the chart handler immediately, even while
  // information is open. Other outside taps only dismiss the information.
  if (event.target.closest?.("svg.chart-wheel-svg, .chart-svg-wrap, .nodal-wheel-stack") &&
  !event.target.closest?.("button, a, input, select, textarea, .floating-chart-panel")) return;
  const tooltip = document.querySelector("#chart-planet-tooltip");
  if (!closeOnly && (!tooltip || tooltip.hidden)) return;
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
  hideChartPlanetTooltip({ force: true });
}

function handleChartPlanetTooltipDismiss(event) {
  if (event.target.closest?.("[data-atlas-position]")) return;
  if (event.target.closest?.("[data-chart-tooltip-close]")) {
    hideChartPlanetTooltip({ force: true });
    return;
  }
  if (event.target.closest?.("#chart-planet-tooltip") || chartTooltipTargetFromEventTarget(event.target)) return;
  if (event.pointerType === "touch" || window.matchMedia("(max-width: 860px), (pointer: coarse)").matches) {
    hideChartPlanetTooltip({ force: true });
  }
}

function handleChartTooltipCloseInteraction(event) {
  if (!event.target.closest?.("[data-chart-tooltip-close]")) return;
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
  if (event.type === "touchend" || event.type === "click") {
    hideChartPlanetTooltip({ force: true });
  }
}

function hideChartPlanetTooltip(options = {}) {
  const force = options?.force === true;
  if (chartPlanetTooltipPinnedTarget && !force) return;
  const tooltip = document.querySelector("#chart-planet-tooltip");
  if (tooltip) {
    tooltip.hidden = true;
    tooltip.setAttribute("aria-hidden", "true");
    tooltip.classList.remove("is-pinned");
  }
  chartPlanetTooltipTarget?.removeAttribute("aria-describedby");
  chartPlanetTooltipTarget = null;
  if (force) chartPlanetTooltipPinnedTarget = null;
}

function chartPatternSvgForPrefix(workspace, prefix) {
  const normalizedPrefix = String(prefix || "");
  return Array.from(workspace?.querySelectorAll?.("svg.chart-wheel-svg") || []).
  find((svg) => svg.dataset.chartPanelPrefix === normalizedPrefix) || null;
}

function parseChartPatternEdges(value) {
  return String(value || "").split(";").map((entry) => {
    const [planetA, planetB, rawAngle] = entry.split("|");
    const angle = Number(rawAngle);
    return planetA && planetB && Number.isFinite(angle) ? { planetA, planetB, angle } : null;
  }).filter(Boolean);
}

function chartPatternLineMatchesEdge(line, edge, layer = "base") {
  if (Number(line?.dataset?.chartAspectAngle) !== Number(edge?.angle)) return false;
  if ((line?.dataset?.chartAspectContext || "base") !== layer) return false;
  const [planetA, planetB] = String(line?.dataset?.chartAspectPlanets || "").split("|");
  return (
    planetA === edge.planetA && planetB === edge.planetB ||
    planetA === edge.planetB && planetB === edge.planetA);

}

function clearChartPatternFocus(svg = null) {
  const scopes = svg ? [svg] : Array.from(chartWheelStage.querySelectorAll("svg.chart-wheel-svg"));
  scopes.forEach((scope) => {
    const prefix = scope.dataset.chartPanelPrefix || "";
    scope.classList.remove("has-chart-pattern-focus");
    scope.removeAttribute("data-chart-focused-pattern");
    scope.querySelectorAll(".is-chart-pattern-aspect, .is-chart-pattern-planet, .is-chart-pattern-anchor, .is-chart-pattern-dimmed").forEach((element) => {
      element.classList.remove("is-chart-pattern-aspect", "is-chart-pattern-planet", "is-chart-pattern-anchor", "is-chart-pattern-dimmed");
    });
    const workspace = scope.closest(".chart-wheel-workspace") || chartWheelStage;
    workspace.querySelectorAll("[data-chart-pattern-id]").forEach((button) => {
      if ((button.dataset.chartPatternPrefix || "") !== prefix) return;
      button.classList.remove("is-active");
      button.setAttribute("aria-pressed", "false");
    });
  });
}

function applyChartPatternFocus(button) {
  const workspace = button?.closest?.(".chart-wheel-workspace");
  if (!workspace) return false;
  const prefix = button.dataset.chartPatternPrefix || "";
  const svg = chartPatternSvgForPrefix(workspace, prefix);
  if (!svg) return false;
  const patternId = button.dataset.chartPatternId || "";
  const wasFocused = svg.dataset.chartFocusedPattern === patternId;

  clearChartPatternFocus(svg);
  clearChartPlanetFocus(svg);
  hideChartPlanetTooltip({ force: true });
  if (wasFocused) return false;

  const edges = parseChartPatternEdges(button.dataset.chartPatternEdges);
  const selectedLayer = button.dataset.chartPatternLayer || "base";
  const planets = new Set(String(button.dataset.chartPatternPlanets || "").split("|").filter(Boolean));
  if (!edges.length || planets.size < 3) return false;

  svg.querySelectorAll(".chart-aspect[data-chart-aspect-planets]").forEach((line) => {
    line.classList.toggle(
      "is-chart-pattern-aspect",
      edges.some((edge) => chartPatternLineMatchesEdge(line, edge, selectedLayer))
    );
  });
  svg.querySelectorAll(".chart-planet[data-chart-planet-id]").forEach((planet) => {
    const [layer, key] = String(planet.dataset.chartPlanetId || "").split(":");
    const isParticipant = layer === selectedLayer && planets.has(key);
    planet.classList.toggle("is-chart-pattern-planet", isParticipant);
    planet.classList.toggle("is-chart-pattern-dimmed", !isParticipant);
  });
  svg.querySelectorAll(".chart-aspect-anchor").forEach((anchor) => {
    const key = anchor.dataset.chartAspectAnchorKey || "";
    const isParticipant = anchor.dataset.chartAspectAnchorId === chartPlanetInteractionId(selectedLayer, key) &&
    planets.has(key);
    anchor.classList.toggle("is-chart-pattern-anchor", isParticipant);
    anchor.classList.toggle("is-chart-pattern-dimmed", !isParticipant);
  });

  svg.classList.add("has-chart-pattern-focus");
  svg.dataset.chartFocusedPattern = patternId;
  button.classList.add("is-active");
  button.setAttribute("aria-pressed", "true");
  return true;
}

function isCompactChartPatternViewport() {
  return window.matchMedia(
    "(max-width: 860px), (orientation: landscape) and (max-width: 960px) and (max-height: 600px)"
  ).matches;
}

function dismissChartPatternPanelOnMobile(control) {
  if (!isCompactChartPatternViewport()) return;
  const panel = control.closest('.floating-chart-panel[data-panel-kind="figuras"]');
  if (!panel) return;
  const workspace = panel.closest(".chart-wheel-workspace");
  const svg = chartPatternSvgForPrefix(workspace, control.dataset.chartPatternPrefix);
  toggleFloatingPanel(panel.id, "close", null, { preservePatternFocus: true });
  svg?.scrollIntoView({ block: "center", inline: "nearest", behavior: "instant" });
}

function handleChartPatternClick(event) {
  const card = event.target.closest?.("[data-chart-pattern-id]");
  if (card && chartWheelStage.contains(card)) {
    event.preventDefault();
    if (applyChartPatternFocus(card)) dismissChartPatternPanelOnMobile(card);
    return;
  }

  const clearButton = event.target.closest?.("[data-chart-pattern-clear]");
  if (!clearButton || !chartWheelStage.contains(clearButton)) return;
  event.preventDefault();
  const workspace = clearButton.closest(".chart-wheel-workspace");
  const svg = chartPatternSvgForPrefix(workspace, clearButton.dataset.chartPatternPrefix);
  if (svg) {
    clearChartPatternFocus(svg);
    dismissChartPatternPanelOnMobile(clearButton);
  }
}

function clearChartPlanetFocus(svg = null) {
  const scopes = svg ? [svg] : Array.from(chartWheelStage.querySelectorAll("svg.chart-wheel-svg"));
  scopes.forEach((scope) => {
    scope.classList.remove("has-chart-planet-focus");
    scope.removeAttribute("data-chart-focused-planet");
    scope.querySelectorAll(".is-chart-planet-focused, .is-chart-planet-related, .is-chart-planet-dimmed, .is-planet-focus-aspect, .is-chart-planet-related-anchor").forEach((element) => {
      element.classList.remove("is-chart-planet-focused", "is-chart-planet-related", "is-chart-planet-dimmed", "is-planet-focus-aspect", "is-chart-planet-related-anchor");
    });
    scope.querySelectorAll(".chart-planet[aria-pressed]").forEach((planet) => planet.setAttribute("aria-pressed", "false"));
    const nodalStack = scope.closest(".nodal-wheel-stack");
    nodalStack?.querySelectorAll("[data-nodal-current-age-action]").forEach((marker) => {
      marker.classList.remove("is-nodal-age-focused");
      marker.setAttribute("aria-pressed", "false");
    });
    nodalStack?.querySelectorAll("[data-nodal-planet-age-action]").forEach((marker) => {
      marker.classList.remove("is-nodal-planet-age-focused");
      marker.setAttribute("aria-pressed", "false");
    });
  });
}

function applyChartPlanetFocus(planet, options = {}) {
  const svg = planet?.closest?.("svg.chart-wheel-svg");
  if (!svg) return false;
  const planetId = planet.dataset.chartPlanetId || "";
  const isAlreadyFocused = svg.dataset.chartFocusedPlanet === planetId;
  if (isAlreadyFocused && options.preserveSelection) return false;
  clearChartPatternFocus(svg);
  clearChartPlanetFocus(svg);
  if (isAlreadyFocused) return false;

  const matchingLines = chartPlanetFocusAspectLines(planet);
  const relatedIds = new Set([planetId]);
  matchingLines.forEach((line) => {
    line.classList.add("is-planet-focus-aspect");
    relatedIds.add(line.dataset.chartAspectEndpointA || "");
    relatedIds.add(line.dataset.chartAspectEndpointB || "");
  });

  svg.classList.add("has-chart-planet-focus");
  svg.dataset.chartFocusedPlanet = planetId;
  svg.querySelectorAll("[data-chart-planet-id]").forEach((element) => {
    const elementId = element.dataset.chartPlanetId || "";
    const isSource = element === planet;
    const isRelated = !isSource && relatedIds.has(elementId);
    element.classList.toggle("is-chart-planet-focused", isSource);
    element.classList.toggle("is-chart-planet-related", isRelated);
    element.classList.toggle("is-chart-planet-dimmed", !isSource && !isRelated);
    if (element.matches(".chart-planet[aria-pressed]")) {
      element.setAttribute("aria-pressed", String(isSource));
    }
  });
  // Las pequeñas marcas radiales de los grados de los aspectos deben seguir
  // visibles únicamente para los planetas relacionados con el foco actual.
  svg.querySelectorAll("[data-chart-aspect-anchor-id]").forEach((anchor) => {
    anchor.classList.toggle(
      "is-chart-planet-related-anchor",
      relatedIds.has(anchor.dataset.chartAspectAnchorId || "")
    );
  });
  const nodalStack = svg.closest(".nodal-wheel-stack");
  nodalStack?.querySelectorAll("[data-nodal-planet-age-action]").forEach((marker) => {
    const isSource = marker.dataset.nodalPlanetId === planetId;
    marker.classList.toggle("is-nodal-planet-age-focused", isSource);
    marker.setAttribute("aria-pressed", String(isSource));
  });
  return true;
}

function applyNodalAgeFocus(marker, options = {}) {
  const stack = marker?.closest?.(".nodal-wheel-stack");
  const svg = stack?.querySelector?.("svg.chart-wheel-svg");
  if (!svg) return false;
  const ageId = marker.dataset.nodalCurrentAgeId || chartPlanetInteractionId("base", "current-age");
  const isAlreadyFocused = svg.dataset.chartFocusedPlanet === ageId;
  if (isAlreadyFocused && options.preserveSelection) return false;
  clearChartPlanetFocus(svg);
  if (isAlreadyFocused) return false;

  const matchingLines = nodalAgeFocusAspectLines(marker);
  const relatedIds = new Set([ageId]);
  matchingLines.forEach((line) => {
    line.classList.add("is-planet-focus-aspect");
    const targetId = line.dataset.chartAspectEndpointA === ageId ?
    line.dataset.chartAspectEndpointB :
    line.dataset.chartAspectEndpointA;
    if (targetId) relatedIds.add(targetId);
  });

  svg.classList.add("has-chart-planet-focus");
  svg.dataset.chartFocusedPlanet = ageId;
  marker.classList.add("is-nodal-age-focused");
  marker.setAttribute("aria-pressed", "true");
  svg.querySelectorAll("[data-chart-planet-id]").forEach((element) => {
    const elementId = element.dataset.chartPlanetId || "";
    const isRelated = relatedIds.has(elementId);
    element.classList.toggle("is-chart-planet-related", isRelated);
    element.classList.toggle("is-chart-planet-dimmed", !isRelated);
    element.classList.remove("is-chart-planet-focused");
    if (element.matches(".chart-planet[aria-pressed]")) element.setAttribute("aria-pressed", "false");
  });
  svg.querySelectorAll("[data-chart-aspect-anchor-id]").forEach((anchor) => {
    anchor.classList.toggle(
      "is-chart-planet-related-anchor",
      relatedIds.has(anchor.dataset.chartAspectAnchorId || "")
    );
  });
  return true;
}

function handleChartPlanetFocusClick(event) {
  if (event.target.closest?.("[data-atlas-position]")) return;
  if (event.target.closest?.("#chart-planet-tooltip")) return;
  if (performance.now() < suppressChartPlanetClickUntil) return;
  const preserveSelection = event.pointerType === "touch" ||
  Boolean(window.matchMedia?.("(max-width: 860px), (pointer: coarse)")?.matches);
  const nodalAgeMarker = event.target.closest?.("[data-nodal-current-age-action]");
  if (nodalAgeMarker && chartWheelStage.contains(nodalAgeMarker)) {
    event.preventDefault();
    const focused = applyNodalAgeFocus(nodalAgeMarker, { preserveSelection });
    if (focused) displayNodalAgeTooltip(nodalAgeMarker, event, { refresh: true, pinned: Boolean(window.AtlasCharts?.eligible(nodalAgeMarker)) });else
    hideChartPlanetTooltip({ force: true });
    return;
  }
  const planetAgeMarker = nodalPlanetAgeMarkerFromEventTarget(event.target);
  if (planetAgeMarker && chartWheelStage.contains(planetAgeMarker)) {
    event.preventDefault();
    const planet = chartPlanetFromNodalAgeMarker(planetAgeMarker);
    if (!planet) return;
    const focused = applyChartPlanetFocus(planet, { preserveSelection });
    if (focused) {
      displayChartPlanetTooltip(planet, event, { trigger: planetAgeMarker, refresh: true, pinned: Boolean(window.AtlasCharts?.eligible(planet)) });
    } else {
      hideChartPlanetTooltip({ force: true });
    }
    return;
  }
  const planet = chartPlanetFromEventTarget(event.target);
  if (planet && chartWheelStage.contains(planet)) {
    const focused = applyChartPlanetFocus(planet, { preserveSelection });
    if (focused) displayChartPlanetTooltip(planet, event, { refresh: true, pinned: Boolean(window.AtlasCharts?.eligible(planet)) });
    if (!focused) hideChartPlanetTooltip({ force: true });
    return;
  }

  // Controls and panels are not empty areas of the map.
  if (event.target.closest?.("button, a, input, select, textarea, .floating-chart-panel")) return;

  const svg = event.target.closest?.("svg.chart-wheel-svg") ||
  event.target.closest?.(".chart-svg-wrap")?.querySelector?.("svg.chart-wheel-svg") ||
  event.target.closest?.(".nodal-wheel-stack")?.querySelector?.("svg.chart-wheel-svg");
  if (svg && chartWheelStage.contains(svg)) {
    clearChartPatternFocus(svg);
    clearChartPlanetFocus(svg);
    hideChartPlanetTooltip({ force: true });
  }
}

function handleChartPlanetFocusKeydown(event) {
  if (event.key === "Escape") {
    clearChartPatternFocus();
    clearChartPlanetFocus();
    hideChartPlanetTooltip({ force: true });
    return;
  }
  const nodalAgeMarker = event.target.closest?.("[data-nodal-current-age-action]");
  if (nodalAgeMarker && ["Enter", " "].includes(event.key)) {
    event.preventDefault();
    chartPlanetTooltipPinnedTarget = null;
    const focused = applyNodalAgeFocus(nodalAgeMarker);
    if (focused) displayNodalAgeTooltip(nodalAgeMarker, null, { pinned: Boolean(window.AtlasCharts?.eligible(nodalAgeMarker)), refresh: true });else
    hideChartPlanetTooltip({ force: true });
    if (focused && chartPlanetTooltipPinnedTarget) document.querySelector("#chart-planet-tooltip [data-atlas-open]")?.focus();
    return;
  }
  const planetAgeMarker = nodalPlanetAgeMarkerFromEventTarget(event.target);
  if (planetAgeMarker && ["Enter", " "].includes(event.key)) {
    event.preventDefault();
    chartPlanetTooltipPinnedTarget = null;
    const planet = chartPlanetFromNodalAgeMarker(planetAgeMarker);
    if (!planet) return;
    const focused = applyChartPlanetFocus(planet);
    if (focused) {
      displayChartPlanetTooltip(planet, null, { trigger: planetAgeMarker, pinned: Boolean(window.AtlasCharts?.eligible(planet)), refresh: true });
      if (chartPlanetTooltipPinnedTarget) document.querySelector("#chart-planet-tooltip [data-atlas-open]")?.focus();
    } else {
      hideChartPlanetTooltip({ force: true });
    }
    return;
  }
  const planet = chartPlanetFromEventTarget(event.target);
  if (!planet || !["Enter", " "].includes(event.key)) return;
  event.preventDefault();
  chartPlanetTooltipPinnedTarget = null;
  const focused = applyChartPlanetFocus(planet);
  if (focused) displayChartPlanetTooltip(planet, null, { pinned: Boolean(window.AtlasCharts?.eligible(planet)), refresh: true });
  if (focused && chartPlanetTooltipPinnedTarget) document.querySelector("#chart-planet-tooltip [data-atlas-open]")?.focus();else
  hideChartPlanetTooltip({ force: true });
}

function handleChartPlanetTooltipFocusIn(event) {
  const ageMarker = nodalAgeMarkerFromEventTarget(event.target);
  if (ageMarker) {
    if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== ageMarker) {
      chartPlanetTooltipPinnedTarget = null;
    }
    if (!chartPlanetTooltipPinnedTarget) displayNodalAgeTooltip(ageMarker);
    return;
  }
  const planetAgeMarker = nodalPlanetAgeMarkerFromEventTarget(event.target);
  if (planetAgeMarker) {
    if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== planetAgeMarker) {
      chartPlanetTooltipPinnedTarget = null;
    }
    if (chartPlanetTooltipPinnedTarget) return;
    const planet = chartPlanetFromNodalAgeMarker(planetAgeMarker);
    if (planet) displayChartPlanetTooltip(planet, null, { trigger: planetAgeMarker });
    return;
  }
  const planet = chartPlanetFromEventTarget(event.target);
  if (!planet) return;
  if (chartPlanetTooltipPinnedTarget && chartPlanetTooltipPinnedTarget !== planet) {
    chartPlanetTooltipPinnedTarget = null;
  }
  if (chartPlanetTooltipPinnedTarget) return;
  displayChartPlanetTooltip(planet);
}

function handleChartPlanetTooltipFocusOut(event) {
  const target = chartTooltipTargetFromEventTarget(event.target);
  if (!target || chartPlanetTooltipPinnedTarget) return;
  const tooltip = document.querySelector("#chart-planet-tooltip");
  if (target.contains(event.relatedTarget) || tooltip && tooltip.contains(event.relatedTarget)) return;
  hideChartPlanetTooltip({ force: true });
}

function handleChartPlanetTooltipPointerOut(event) {
  if (chartPlanetTooltipPinnedTarget) return;
  if (event.pointerType === "touch") return;
  const fromTarget = chartTooltipTargetFromEventTarget(event.target);
  if (!fromTarget) return;
  const tooltip = document.querySelector("#chart-planet-tooltip");
  const related = event.relatedTarget;
  if (related && (fromTarget.contains(related) || chartTooltipTargetFromEventTarget(related) || tooltip && tooltip.contains(related))) {
    return;
  }
  hideChartPlanetTooltip({ force: true });
}

let chartPlanetTooltipTrackRaf = 0;
function handleChartPlanetTooltipGlobalPointerMove(event) {
  if (chartPlanetTooltipPinnedTarget) return;
  if (event.pointerType === "touch") return;
  if (!chartPlanetTooltipTarget) return;
  const clientX = Number(event.clientX);
  const clientY = Number(event.clientY);
  if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return;
  if (chartPlanetTooltipTrackRaf) cancelAnimationFrame(chartPlanetTooltipTrackRaf);
  chartPlanetTooltipTrackRaf = requestAnimationFrame(() => {
    chartPlanetTooltipTrackRaf = 0;
    if (chartPlanetTooltipPinnedTarget) return;
    if (event?.type === "mouseout" || event?.type === "mouseleave") return;
    const tooltip = document.querySelector("#chart-planet-tooltip");
    const topmost = document.elementFromPoint(clientX, clientY);
    if (tooltip && tooltip.contains(topmost)) return;
    const hoveredTarget = topmost ? chartTooltipTargetFromEventTarget(topmost) : null;
    if (!hoveredTarget) {
      hideChartPlanetTooltip({ force: true });
    }
  });
}

function planetGlyph(key) {
  return PLANET_SYMBOLS[key] || String(key).slice(0, 2);
}

function balancedPlanetGlyphClass(key) {
  if (key === "Mercury") return " planet-glyph-mercury";
  return key === "Venus" || key === "Mars" ? " planet-glyph-balanced" : "";
}

function startFloatingPanelDrag(event) {
  if (event.target.closest(".floating-resizer")) return;
  const header = event.target.closest(".floating-panel-header");
  if (!header || event.target.closest("button")) return;

  const panel = header.closest(".floating-chart-panel");
  const workspace = header.closest(".chart-wheel-workspace");
  if (!panel || !workspace || panel.classList.contains("is-mobile-fullscreen-longitude")) return;

  event.preventDefault();
  const panelRect = panel.getBoundingClientRect();
  const workspaceRect = workspace.getBoundingClientRect();
  const viewportAnchored = panel.classList.contains("is-viewport-anchored");
  const startX = event.clientX;
  const startY = event.clientY;
  const offsetX = viewportAnchored ? panelRect.left : panelRect.left - workspaceRect.left;
  const offsetY = viewportAnchored ? panelRect.top : panelRect.top - workspaceRect.top;

  bringFloatingPanelToFront(panel);
  panel.dataset.userPositioned = "1";
  panel.classList.add("dragging");
  panel.style.maxHeight = "none";
  panel.style.left = `${offsetX}px`;
  panel.style.top = `${offsetY}px`;
  panel.style.right = "auto";
  panel.style.bottom = "auto";
  panel.style.transform = "none";
  panel.setPointerCapture?.(event.pointerId);

  function move(moveEvent) {
    const inset = viewportAnchored ? 8 : 0;
    const visualViewport = viewportAnchored ? window.visualViewport : null;
    const boundaryLeft = viewportAnchored ? visualViewport?.offsetLeft || 0 : 0;
    const viewportBoundaryTop = viewportAnchored ? visualViewport?.offsetTop || 0 : 0;
    const boundaryWidth = viewportAnchored ? visualViewport?.width || window.innerWidth : workspace.clientWidth;
    const boundaryHeight = viewportAnchored ? visualViewport?.height || window.innerHeight : workspace.clientHeight;
    const storedSafeTop = Number.parseFloat(panel.dataset.viewportSafeTop || "");
    const storedSafeBottom = Number.parseFloat(panel.dataset.viewportSafeBottom || "");
    const minX = boundaryLeft + inset;
    const minY = Number.isFinite(storedSafeTop) ? storedSafeTop : viewportBoundaryTop + inset;
    const rightBoundary = boundaryLeft + boundaryWidth - inset;
    const bottomBoundary = Number.isFinite(storedSafeBottom) ?
    storedSafeBottom :
    viewportBoundaryTop + boundaryHeight - inset;
    const maxX = Math.max(minX, rightBoundary - panel.offsetWidth);
    const maxY = Math.max(minY, bottomBoundary - panel.offsetHeight);
    const nextX = Math.min(maxX, Math.max(minX, offsetX + moveEvent.clientX - startX));
    const nextY = Math.min(maxY, Math.max(minY, offsetY + moveEvent.clientY - startY));
    panel.style.left = `${nextX}px`;
    panel.style.top = `${nextY}px`;
  }

  function stop() {
    panel.classList.remove("dragging");
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", stop);
  }

  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", stop, { once: true });
}

function startFloatingPanelResize(event) {
  const handle = event.target.closest(".floating-resizer");
  if (!handle) return;

  const panel = handle.closest(".floating-chart-panel");
  const workspace = handle.closest(".chart-wheel-workspace");
  if (!panel || !workspace) return;

  event.preventDefault();
  const direction = handle.dataset.resizeDir || "";
  const panelRect = panel.getBoundingClientRect();
  const workspaceRect = workspace.getBoundingClientRect();
  const viewportAnchored = panel.classList.contains("is-viewport-anchored");
  const startX = event.clientX;
  const startY = event.clientY;
  const startLeft = viewportAnchored ? panelRect.left : panelRect.left - workspaceRect.left;
  const startTop = viewportAnchored ? panelRect.top : panelRect.top - workspaceRect.top;
  const startWidth = panelRect.width;
  const startHeight = panelRect.height;
  const visualViewport = viewportAnchored ? window.visualViewport : null;
  const boundaryLeft = viewportAnchored ? visualViewport?.offsetLeft || 0 : 0;
  const viewportBoundaryTop = viewportAnchored ? visualViewport?.offsetTop || 0 : 0;
  const boundaryWidth = viewportAnchored ? visualViewport?.width || window.innerWidth : workspace.clientWidth;
  const boundaryHeight = viewportAnchored ? visualViewport?.height || window.innerHeight : workspace.clientHeight;
  const boundaryInset = viewportAnchored ? 8 : 0;
  const storedSafeTop = Number.parseFloat(panel.dataset.viewportSafeTop || "");
  const storedSafeBottom = Number.parseFloat(panel.dataset.viewportSafeBottom || "");
  const minBoundaryLeft = boundaryLeft + boundaryInset;
  const maxBoundaryRight = boundaryLeft + boundaryWidth - boundaryInset;
  const minBoundaryTop = Number.isFinite(storedSafeTop) ? storedSafeTop : viewportBoundaryTop + boundaryInset;
  const maxBoundaryBottom = Number.isFinite(storedSafeBottom) ?
  storedSafeBottom :
  viewportBoundaryTop + boundaryHeight - boundaryInset;
  const availableBoundaryWidth = Math.max(1, maxBoundaryRight - minBoundaryLeft);
  const availableBoundaryHeight = Math.max(1, maxBoundaryBottom - minBoundaryTop);
  const minWidth = Math.min(260, availableBoundaryWidth);
  const minHeight = Math.min(170, availableBoundaryHeight);

  bringFloatingPanelToFront(panel);
  panel.dataset.userPositioned = "1";
  panel.classList.add("resizing");
  panel.style.maxHeight = "none";
  panel.style.left = `${startLeft}px`;
  panel.style.top = `${startTop}px`;
  panel.style.right = "auto";
  panel.style.bottom = "auto";
  panel.style.transform = "none";
  panel.style.width = `${startWidth}px`;
  panel.style.height = `${startHeight}px`;
  panel.setPointerCapture?.(event.pointerId);

  function move(moveEvent) {
    const deltaX = moveEvent.clientX - startX;
    const deltaY = moveEvent.clientY - startY;
    let nextLeft = startLeft;
    let nextTop = startTop;
    let nextWidth = startWidth;
    let nextHeight = startHeight;

    if (direction.includes("e")) nextWidth = startWidth + deltaX;
    if (direction.includes("s")) nextHeight = startHeight + deltaY;
    if (direction.includes("w")) {
      nextWidth = startWidth - deltaX;
      nextLeft = startLeft + deltaX;
    }
    if (direction.includes("n")) {
      nextHeight = startHeight - deltaY;
      nextTop = startTop + deltaY;
    }

    if (nextWidth < minWidth) {
      if (direction.includes("w")) nextLeft -= minWidth - nextWidth;
      nextWidth = minWidth;
    }
    if (nextHeight < minHeight) {
      if (direction.includes("n")) nextTop -= minHeight - nextHeight;
      nextHeight = minHeight;
    }

    nextWidth = Math.min(Math.max(minWidth, nextWidth), availableBoundaryWidth);
    nextHeight = Math.min(Math.max(minHeight, nextHeight), availableBoundaryHeight);
    nextLeft = Math.min(
      Math.max(minBoundaryLeft, nextLeft),
      Math.max(minBoundaryLeft, maxBoundaryRight - nextWidth)
    );
    nextTop = Math.min(
      Math.max(minBoundaryTop, nextTop),
      Math.max(minBoundaryTop, maxBoundaryBottom - nextHeight)
    );

    panel.style.left = `${nextLeft}px`;
    panel.style.top = `${nextTop}px`;
    panel.style.width = `${nextWidth}px`;
    panel.style.height = `${nextHeight}px`;
  }

  function stop() {
    panel.classList.remove("resizing");
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", stop);
  }

  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", stop, { once: true });
}

let chartExportDesignsLoading = null;
let chartExportDesignsBusy = false;

function canUseChartExportDesigns() {
  return String(currentUser?.email || "").trim().toLowerCase() === "pello566@gmail.com";
}

async function loadChartExportDesigns() {
  if (window.ChartExportDesigns && document.getElementById("chart-export-designs-style")?.sheet) return;
  if (chartExportDesignsLoading) return chartExportDesignsLoading;
  chartExportDesignsLoading = Promise.all([
  new Promise((resolve, reject) => {
    if (window.ChartExportDesigns) return resolve();
    const script = document.createElement("script");
    script.src = "/chart-exports/designs.js?v=56dc2d5e0ed1";
    script.onload = () => {script.remove();resolve();};
    script.onerror = () => {script.remove();reject(new Error(I18n.label("No se pudo abrir la colección de diseños.")));};
    document.head.append(script);
  }),
  new Promise((resolve, reject) => {
    if (document.getElementById("chart-export-designs-style")?.sheet) return resolve();
    document.getElementById("chart-export-designs-style")?.remove();
    const link = document.createElement("link");
    link.id = "chart-export-designs-style";link.rel = "stylesheet";
    link.href = "/chart-exports/designs.css?v=56dc2d5e0ed1";
    link.onload = () => resolve();
    link.onerror = () => {link.remove();reject(new Error(I18n.label("No se pudo abrir la colección de diseños.")));};
    document.head.append(link);
  })]
  ).finally(() => {chartExportDesignsLoading = null;});
  return chartExportDesignsLoading;
}

function captureChartExportDesignItems() {
  return chartExportItems().map((item) => {
    const sources = item.stack ? [...item.stack.querySelectorAll("svg")] : [item.svg];
    const baseWidth = svgExportBox(sources[0]).width;
    return {
      title: I18n.label(item.title), position: item.position,
      layers: sources.map((svg) => cloneSvgWithComputedStyles(svg, { padding: 80 * svgExportBox(svg).width / baseWidth }))
    };
  });
}

async function requestStyledChartDownload(triggerButton) {
  if (chartExportDesignsBusy) return;
  const ownerId = currentUser?.id;
  const authorized = () => canUseChartExportDesigns() && currentUser?.id === ownerId;
  chartExportDesignsBusy = true;
  if (triggerButton) triggerButton.disabled = true;
  try {
    await loadChartExportDesigns();
    if (!authorized()) return;
    const items = captureChartExportDesignItems();
    if (!items.length) throw new Error(I18n.label("No hay gráfico para descargar."));
    for (const item of items) for (const svg of item.layers) await inlineExportSvgImages(svg);
    if (!authorized()) return;
    const filename = chartExportFilename("png");
    const primary = currentChartPersonName();
    const paired = /compuesta|composite|sinastr|synastry/.test(chartWheelTypeSelect.value);
    const partner = /sinastr|synastry/.test(chartWheelTypeSelect.value) ? synastryCalculation?.profile?.name : compositeCalculation?.partner?.profile?.name;
    const choice = await window.ChartExportDesigns.choose({
      language: document.documentElement.lang,
      items,
      metadata: { subject: paired && partner ? `${primary} + ${partner}` : primary, context: I18n.label(chartContextLabel(chartWheelTypeSelect.value)) },
      renderOriginal: () => buildCurrentChartCanvas(),
      isAuthorized: authorized
    });
    if (!choice || !authorized()) return;
    const blob = await new Promise((resolve) => choice.canvas.toBlob(resolve, "image/png"));
    if (!blob) throw new Error(I18n.label("No se pudo generar la imagen."));
    if (!authorized()) return;
    downloadBlob(blob, choice.id === "original" ? filename : filename.replace(/\.png$/, `-${choice.id}.png`));
    setChartWheelStatus(() => T("interface.imagen_descargada"));
  } catch (error) {
    if (authorized()) setChartWheelStatus(() => error.message || T("interface.no_se_pudo_descargar_la_carta"), true);
  } finally {
    chartExportDesignsBusy = false;
    if (triggerButton) triggerButton.disabled = false;
  }
}

async function requestChartDownload(format, triggerButton = null) {
  if (!chartWheelStage?.querySelector(".chart-wheel-svg")) {
    setChartWheelStatus(() => T("interface.no_hay_grafico_para_descargar"), true);
    return;
  }

  if (format !== "pdf" && canUseChartExportDesigns()) {
    await requestStyledChartDownload(triggerButton);
    return;
  }
  if (!(await confirmChartDownload(format))) return;
  await downloadCurrentChart(format, triggerButton);
}

async function downloadCurrentChart(format, triggerButton = null) {
  const button = triggerButton;
  if (!chartWheelStage.querySelector(".chart-wheel-svg")) {
    setChartWheelStatus(() => T("interface.no_hay_grafico_para_descargar"), true);
    return;
  }

  if (button) button.disabled = true;
  setChartWheelStatus(() => format === "pdf" ? T("interface.preparando_pdf") : T("interface.preparando_imagen"));

  try {
    const canvas = await buildCurrentChartCanvas();
    const filename = chartExportFilename(format === "pdf" ? "pdf" : "png");
    if (format === "pdf") {
      downloadBlob(canvasToPdfBlob(canvas), filename);
    } else {
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
      if (!blob) throw new Error(T("interface.no_se_pudo_generar_la_imagen"));
      downloadBlob(blob, filename);
    }
    setChartWheelStatus(() => format === "pdf" ? T("interface.pdf_descargado") : T("interface.imagen_descargada"));
  } catch (error) {
    setChartWheelStatus(() => error.message || T("interface.no_se_pudo_descargar_la_carta"), true);
  } finally {
    if (button) button.disabled = false;
  }
}

async function toggleChartCardFullscreen(card) {
  if (!card) return;

  const isFallbackFullscreen = card.classList.contains("is-chart-card-fallback-fullscreen");

  try {
    if (document.fullscreenElement === card) {
      await document.exitFullscreen();
    } else if (isFallbackFullscreen) {
      card.classList.remove("is-chart-card-fallback-fullscreen");
      restoreMobileFullscreenLongitudePanel();
    } else if (card.requestFullscreen) {
      prepareMobileFullscreenLongitudePanel(card);
      await card.requestFullscreen();
    } else {
      prepareMobileFullscreenLongitudePanel(card);
      card.classList.add("is-chart-card-fallback-fullscreen");
    }
  } catch {
    card.classList.add("is-chart-card-fallback-fullscreen");
  }

  syncChartCardFullscreenState();
  const workspace = card.matches?.(".chart-wheel-workspace") ?
  card :
  card.closest?.(".chart-wheel-workspace");
  arrangeFloatingPanels(workspace);
  resetInactiveChartTouchZoom();
  scheduleChartViewportFit();
}

const chartTouchZoomStates = new WeakMap();
let activeChartTouchZoomState = null;
let mobileFullscreenLongitudeState = null;

function prepareMobileFullscreenLongitudePanel(workspace) {
  restoreMobileFullscreenLongitudePanel();

  const isPortraitPhone = window.matchMedia?.("(orientation: portrait) and (max-width: 640px)").matches;
  const isIndividualChart = workspace?.classList?.contains("chart-wheel-workspace") &&
  !workspace.classList.contains("chart-wheel-workspace-multiple");
  if (!isPortraitPhone || !isIndividualChart) return;

  const prefix = workspace.querySelector(".chart-wheel-svg")?.dataset.chartPanelPrefix;
  const panel = Array.from(workspace.querySelectorAll('.floating-chart-panel[data-panel-kind="longitud"]')).
  find((item) => item.id === `${prefix}-longitud`) ||
  workspace.querySelector('.floating-chart-panel[data-panel-kind="longitud"]');
  if (!panel) return;

  const chartCard = workspace.querySelector(".chart-wheel-card");
  const chartBody = chartCard?.querySelector(".chart-svg-wrap-only, .nodal-schema-layout");

  mobileFullscreenLongitudeState = {
    panel,
    wasOpen: !panel.hidden && !panel.classList.contains("is-panel-hidden"),
    originalParent: panel.parentNode,
    originalNextSibling: panel.nextSibling
  };
  if (chartBody) chartBody.after(panel);
  panel.classList.add("is-mobile-fullscreen-longitude");
  toggleFloatingPanel(panel.id, "show");
}

function restoreMobileFullscreenLongitudePanel() {
  const state = mobileFullscreenLongitudeState;
  if (!state) return;

  state.panel.classList.remove("is-mobile-fullscreen-longitude");
  if (state.originalParent?.isConnected && state.panel.isConnected) {
    const referenceNode = state.originalNextSibling?.parentNode === state.originalParent ?
    state.originalNextSibling :
    null;
    state.originalParent.insertBefore(state.panel, referenceNode);
  }
  if (!state.wasOpen && state.panel.isConnected) {
    toggleFloatingPanel(state.panel.id, "close");
  }
  mobileFullscreenLongitudeState = null;
}

function syncMobileFullscreenLongitudePanel() {
  const state = mobileFullscreenLongitudeState;
  if (!state) return;

  const workspace = state.panel.closest(".chart-wheel-workspace");
  const isStillFullscreen = document.fullscreenElement === workspace ||
  workspace?.classList.contains("is-chart-card-fallback-fullscreen");
  if (!isStillFullscreen) restoreMobileFullscreenLongitudePanel();
}

function isChartTouchZoomSurfaceAvailable(surface) {
  if (!surface) return false;

  // The two three-map views must own the pinch gesture on phones even when
  // they are not fullscreen. Otherwise the browser zooms the whole page and
  // the page's horizontal overflow lock prevents panning the enlarged maps.
  if (surface.closest(".chart-wheel-workspace-multiple")) return true;

  const fullscreenElement = document.fullscreenElement;
  if (fullscreenElement?.contains(surface)) return true;

  return Boolean(surface.closest(".is-chart-card-fallback-fullscreen"));
}

function chartTouchZoomSurface(target) {
  const multipleWorkspace = target?.closest?.(".chart-wheel-workspace-multiple");
  if (!multipleWorkspace?.classList.contains("chart-wheel-workspace-custom") && isChartTouchZoomSurfaceAvailable(multipleWorkspace)) {
    return multipleWorkspace.querySelector(":scope > .chart-wheel-main") || multipleWorkspace;
  }

  return target?.closest?.(".chart-svg-wrap, .nodal-schema-layout") || null;
}

function chartTouchZoomState(surface) {
  let state = chartTouchZoomStates.get(surface);
  const multipleWorkspace = surface?.closest?.(".chart-wheel-workspace-multiple:not(.chart-wheel-workspace-custom)");
  const visual = multipleWorkspace ?
  surface.querySelector(".chart-wheel-triple") :
  surface?.querySelector(".nodal-wheel-stack, .chart-wheel-svg");
  if (!visual) return null;

  if (!state || state.visual !== visual) {
    state = {
      surface,
      visual,
      scale: 1,
      x: 0,
      y: 0,
      mode: "",
      startDistance: 0,
      startScale: 1,
      focalX: 0,
      focalY: 0,
      panStartX: 0,
      panStartY: 0,
      panOriginX: 0,
      panOriginY: 0
    };
    chartTouchZoomStates.set(surface, state);
  }

  return state;
}

function chartTouchPoint(touch, surfaceRect) {
  return {
    x: touch.clientX - surfaceRect.left,
    y: touch.clientY - surfaceRect.top
  };
}

function chartTouchPair(touches, surfaceRect) {
  const first = chartTouchPoint(touches[0], surfaceRect);
  const second = chartTouchPoint(touches[1], surfaceRect);
  return {
    distance: Math.hypot(second.x - first.x, second.y - first.y),
    midpoint: {
      x: (first.x + second.x) / 2,
      y: (first.y + second.y) / 2
    }
  };
}

function clampChartTouchZoomOffset(state, x, y, scale = state.scale) {
  const surfaceRect = state.surface.getBoundingClientRect();
  const visualRect = state.visual.getBoundingClientRect();
  const baseWidth = visualRect.width / Math.max(state.scale, 1);
  const baseHeight = visualRect.height / Math.max(state.scale, 1);
  const maxX = Math.max(0, (baseWidth * scale - surfaceRect.width) / 2) + 24;
  const maxY = Math.max(0, (baseHeight * scale - surfaceRect.height) / 2) + 24;
  return {
    x: Math.max(-maxX, Math.min(maxX, x)),
    y: Math.max(-maxY, Math.min(maxY, y))
  };
}

function applyChartTouchZoom(state) {
  if (state.scale <= 1.001) {
    state.scale = 1;
    state.x = 0;
    state.y = 0;
    state.visual.style.removeProperty("transform");
    state.visual.classList.remove("is-touch-zoomed");
    state.surface.classList.remove("is-chart-touch-zoomed");
    return;
  }

  state.visual.style.transform = `translate3d(${state.x}px, ${state.y}px, 0) scale(${state.scale})`;
  state.visual.classList.add("is-touch-zoomed");
  state.surface.classList.add("is-chart-touch-zoomed");
}

function beginChartTouchPinch(state, touches) {
  const rect = state.surface.getBoundingClientRect();
  const pair = chartTouchPair(touches, rect);
  const centerX = rect.width / 2;
  const centerY = rect.height / 2;
  state.mode = "pinch";
  state.startDistance = Math.max(pair.distance, 1);
  state.startScale = state.scale;
  state.focalX = (pair.midpoint.x - centerX - state.x) / state.scale;
  state.focalY = (pair.midpoint.y - centerY - state.y) / state.scale;
  state.surface.classList.add("is-chart-touch-interacting");
}

function beginChartTouchPan(state, touch, mode = "pan") {
  state.mode = mode;
  state.panStartX = touch.clientX;
  state.panStartY = touch.clientY;
  state.panOriginX = state.x;
  state.panOriginY = state.y;
  if (mode === "pan") state.surface.classList.add("is-chart-touch-interacting");
}

function resetChartTouchZoom(state) {
  if (!state) return;
  state.scale = 1;
  state.x = 0;
  state.y = 0;
  state.mode = "";
  state.visual.style.removeProperty("transform");
  state.visual.classList.remove("is-touch-zoomed");
  state.surface.classList.remove("is-chart-touch-zoomed", "is-chart-touch-interacting");
  if (activeChartTouchZoomState === state) activeChartTouchZoomState = null;
}

function resetInactiveChartTouchZoom() {
  chartWheelStage?.querySelectorAll(".chart-svg-wrap, .nodal-schema-layout, .chart-wheel-workspace-multiple > .chart-wheel-main").forEach((surface) => {
    const state = chartTouchZoomStates.get(surface);
    if (state && !isChartTouchZoomSurfaceAvailable(surface)) resetChartTouchZoom(state);
  });
}

function handleChartTouchZoomStart(event) {
  // In fullscreen the tooltip is hosted inside the stage. Let its close button
  // and scrollable content receive touches without starting a chart gesture.
  if (event.target.closest?.("#chart-planet-tooltip")) return;
  hideChartPlanetTooltip({ force: true });
  const surface = chartTouchZoomSurface(event.target);
  if (!isChartTouchZoomSurfaceAvailable(surface)) return;

  const state = chartTouchZoomState(surface);
  if (!state) return;
  if (activeChartTouchZoomState && activeChartTouchZoomState !== state) {
    activeChartTouchZoomState.surface.classList.remove("is-chart-touch-interacting");
  }
  activeChartTouchZoomState = state;

  if (event.touches.length >= 2) {
    event.preventDefault();
    beginChartTouchPinch(state, event.touches);
  } else if (event.touches.length === 1 && state.scale > 1) {
    // Preserve the native click for a tap on an enlarged planet. Claim the
    // gesture only after movement exceeds normal finger jitter.
    suppressChartPlanetClickUntil = 0;
    beginChartTouchPan(state, event.touches[0], "pending-pan");
  }
}

function handleChartTouchZoomMove(event) {
  if (event.target.closest?.("#chart-planet-tooltip")) return;
  const state = activeChartTouchZoomState;
  if (!state || !isChartTouchZoomSurfaceAvailable(state.surface)) return;

  if (event.touches.length >= 2) {
    event.preventDefault();
    suppressChartPlanetClickUntil = performance.now() + 450;
    if (state.mode !== "pinch") beginChartTouchPinch(state, event.touches);
    const rect = state.surface.getBoundingClientRect();
    const pair = chartTouchPair(event.touches, rect);
    const nextScale = Math.max(1, Math.min(4, state.startScale * pair.distance / state.startDistance));
    const nextX = pair.midpoint.x - rect.width / 2 - state.focalX * nextScale;
    const nextY = pair.midpoint.y - rect.height / 2 - state.focalY * nextScale;
    const offset = clampChartTouchZoomOffset(state, nextX, nextY, nextScale);
    state.scale = nextScale;
    state.x = offset.x;
    state.y = offset.y;
    applyChartTouchZoom(state);
    return;
  }

  if (event.touches.length === 1 && state.scale > 1) {
    if (state.mode === "pending-pan") {
      const distance = Math.hypot(
        event.touches[0].clientX - state.panStartX,
        event.touches[0].clientY - state.panStartY
      );
      if (distance < 8) return;
      state.mode = "pan";
      state.surface.classList.add("is-chart-touch-interacting");
    }
    event.preventDefault();
    suppressChartPlanetClickUntil = performance.now() + 450;
    if (state.mode !== "pan") beginChartTouchPan(state, event.touches[0]);
    const nextX = state.panOriginX + event.touches[0].clientX - state.panStartX;
    const nextY = state.panOriginY + event.touches[0].clientY - state.panStartY;
    const offset = clampChartTouchZoomOffset(state, nextX, nextY);
    state.x = offset.x;
    state.y = offset.y;
    applyChartTouchZoom(state);
  }
}

function handleChartTouchZoomEnd(event) {
  if (event.target.closest?.("#chart-planet-tooltip")) return;
  hideChartPlanetTooltip({ force: true });
  const state = activeChartTouchZoomState;
  if (!state) return;

  // A completed pinch/drag must not select whatever is under the last finger.
  // A pending pan is a tap, so leave its native click untouched.
  if (state.mode === "pan" || state.mode === "pinch" || event.type === "touchcancel") {
    if (event.cancelable) event.preventDefault();
    suppressChartPlanetClickUntil = performance.now() + 450;
  }

  if (event.touches.length >= 2) {
    beginChartTouchPinch(state, event.touches);
    return;
  }
  if (event.touches.length === 1 && state.scale > 1) {
    beginChartTouchPan(state, event.touches[0]);
    return;
  }

  state.mode = "";
  state.surface.classList.remove("is-chart-touch-interacting");
  activeChartTouchZoomState = null;
}

function chartActionFullscreenTarget(actionButton) {
  const workspace = actionButton.closest(".chart-wheel-workspace");
  return actionButton.closest(".chart-wheel-workspace-multiple") ||
  workspace ||
  actionButton.closest(".chart-wheel-card") ||
  null;
}

function syncChartCardFullscreenState() {
  const fullscreenCard = document.fullscreenElement?.classList?.contains("chart-wheel-card") ||
  document.fullscreenElement?.classList?.contains("chart-wheel-workspace") ||
  document.fullscreenElement?.classList?.contains("chart-wheel-workspace-multiple") ?
  document.fullscreenElement :
  chartWheelStage?.querySelector(".chart-wheel-card.is-chart-card-fallback-fullscreen, .chart-wheel-workspace.is-chart-card-fallback-fullscreen, .chart-wheel-workspace-multiple.is-chart-card-fallback-fullscreen");

  chartWheelStage?.querySelectorAll("[data-chart-card-action='fullscreen']").forEach((button) => {
    const card = chartActionFullscreenTarget(button);
    const isActive = Boolean(card && fullscreenCard === card);
    const label = isActive ? T("interface.salir_de_pantalla_completa") : T("interface.pantalla_completa");
    I18n.bind(button, "@aria-label", () => isActive ? T("interface.salir_de_pantalla_completa") : T("interface.pantalla_completa"));
    button.setAttribute("aria-pressed", String(isActive));
    I18n.bind(button, "title", () => isActive ? T("interface.salir_de_pantalla_completa") : T("interface.pantalla_completa"));
  });
}

async function buildCurrentChartCanvas() {
  const items = chartExportItems();
  if (!items.length) throw new Error(T("interface.no_hay_grafico_para_descargar"));
  const triangularMultipleExport = items.length === 3 &&
  items.every((item) => ["left", "top", "right"].includes(item.position));

  const rendered = [];
  for (const item of items) {
    rendered.push({
      title: item.title,
      position: item.position || "",
      canvas: item.stack ?
      await renderSvgStackToCanvas(item.stack) :
      await renderSvgToCanvas(
        item.svg,
        undefined,
        undefined,
        triangularMultipleExport,
        { padding: triangularMultipleExport ? 56 : 0 }
      )
    });
  }

  if (rendered.length === 1) return rendered[0].canvas;
  if (triangularMultipleExport) return buildTriangularMultipleChartCanvas(rendered);

  const gap = 36;
  const labelHeight = 42;
  const width = rendered.reduce((total, item) => total + item.canvas.width, 0) + gap * (rendered.length - 1);
  const height = Math.max(...rendered.map((item) => item.canvas.height)) + labelHeight;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#f8fafc";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "#0f172a";
  ctx.font = "700 24px Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "top";

  let x = 0;
  for (const item of rendered) {
    ctx.fillText(I18n.label(item.title), x + item.canvas.width / 2, 6);
    ctx.drawImage(item.canvas, x, labelHeight);
    x += item.canvas.width + gap;
  }

  return canvas;
}

function buildTriangularMultipleChartCanvas(rendered) {
  const byPosition = new Map(rendered.map((item) => [item.position, item]));
  const left = byPosition.get("left");
  const top = byPosition.get("top");
  const right = byPosition.get("right");
  if (!left || !top || !right) throw new Error(T("interface.no_se_pudo_preparar_la_composicion_de_las_cartas"));

  const chartWidth = Math.max(...rendered.map((item) => item.canvas.width));
  const chartHeight = Math.max(...rendered.map((item) => item.canvas.height));
  const outerPadding = 24;
  const labelHeight = 46;
  const columnStep = Math.round(chartWidth * 0.86);
  const sideOffsetY = Math.round(chartHeight * 0.38);
  const width = outerPadding * 2 + chartWidth + columnStep * 2;
  const height = outerPadding * 2 + labelHeight + sideOffsetY + chartHeight;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#f8fafc";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "#0f172a";
  ctx.font = "700 24px Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "top";

  const placements = [
  { item: top, x: outerPadding + columnStep, y: outerPadding },
  { item: left, x: outerPadding, y: outerPadding + sideOffsetY },
  { item: right, x: outerPadding + columnStep * 2, y: outerPadding + sideOffsetY }];

  placements.forEach(({ item, x, y }) => {
    const centeredX = x + (chartWidth - item.canvas.width) / 2;
    const centeredY = y + labelHeight + (chartHeight - item.canvas.height) / 2;
    ctx.fillText(I18n.label(item.title), x + chartWidth / 2, y + 7);
    ctx.drawImage(item.canvas, centeredX, centeredY);
  });

  return canvas;
}

function chartExportItems() {
  if (chartWheelTypeSelect.value === "nodal") {
    const stack = chartWheelStage.querySelector(".nodal-wheel-stack");
    if (stack) return [{ get title() {return T("interface.esquema_nodal_2");}, stack }];
  }

  return Array.from(chartWheelStage.querySelectorAll(".chart-wheel-card")).
  map((card) => {
    const svg = card.querySelector(".chart-wheel-svg");
    if (!svg) return null;
    const slot = card.closest(".chart-triple-slot");
    const position = ["left", "top", "right"].
    find((candidate) => slot?.classList.contains(`chart-triple-slot-${candidate}`)) || "";
    return {
      title: clean(card.querySelector("h3")?.textContent) || chartContextLabel(chartWheelTypeSelect.value),
      position,
      svg
    };
  }).
  filter(Boolean);
}

async function renderSvgStackToCanvas(stack) {
  const base = stack.querySelector(".chart-wheel-svg");
  if (!base) throw new Error(T("interface.no_se_encontro_la_carta_para_descargar"));
  const canvas = await renderSvgToCanvas(base);
  const ctx = canvas.getContext("2d");
  const overlays = Array.from(stack.querySelectorAll("svg")).filter((svg) => svg !== base);

  for (const overlay of overlays) {
    const overlayCanvas = await renderSvgToCanvas(overlay, canvas.width, canvas.height, true);
    ctx.drawImage(overlayCanvas, 0, 0);
  }

  return canvas;
}

async function renderSvgToCanvas(svg, targetWidth, targetHeight, transparent = false, options = {}) {
  const padding = Math.max(0, Number(options.padding) || 0);
  const clone = cloneSvgWithComputedStyles(svg, { padding });
  await inlineExportSvgImages(clone);
  const { width, height } = svgExportSize(svg, padding);
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(targetWidth || width);
  canvas.height = Math.round(targetHeight || height);
  const ctx = canvas.getContext("2d");
  if (!transparent) {
    ctx.fillStyle = "#f8fafc";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  const image = await svgElementToImage(clone);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  return canvas;
}

function cloneSvgWithComputedStyles(svg, options = {}) {
  const clone = svg.cloneNode(true);
  const padding = Math.max(0, Number(options.padding) || 0);
  const sourceBox = svgExportBox(svg);
  const { width, height } = svgExportSize(svg, padding);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("width", String(width));
  clone.setAttribute("height", String(height));
  clone.setAttribute(
    "viewBox",
    `${sourceBox.x - padding} ${sourceBox.y - padding} ${width} ${height}`
  );

  const sandbox = document.createElement("div");
  sandbox.style.cssText = `
    position: fixed;
    left: -10000px;
    top: -10000px;
    width: ${width}px;
    height: ${height}px;
    visibility: hidden;
    pointer-events: none;
    color-scheme: light;
    --bg: #f7f8fa;
    --surface: #ffffff;
    --surface-soft: #fbfcfd;
    --text: #171a1f;
    --text-soft: #2c313a;
    --muted: #68707d;
    --line: #d9dee6;
    --accent: #0f766e;
    --accent-strong: #115e59;
    --on-accent: #ffffff;
    --accent-soft: #f3fbf9;
    --accent-line: rgba(15, 118, 110, 0.38);
    --accent-ring: rgba(15, 118, 110, 0.14);
    --ink-soft: #eef1f5;
    --user: #0f766e;
    --danger: #b42318;
    --danger-soft: #fff1f0;
    --danger-line: rgba(180, 35, 24, 0.3);
  `;
  sandbox.appendChild(clone);
  document.body.appendChild(sandbox);

  const clonedNodes = [clone, ...clone.querySelectorAll("*")];
  const styleProperties = [
  "color", "fill", "stroke", "stroke-width", "stroke-opacity", "fill-opacity", "opacity",
  "font-size", "font-weight", "font-family", "text-anchor", "dominant-baseline",
  "paint-order", "stroke-linecap", "stroke-linejoin", "stroke-dasharray", "display",
  "stop-color", "stop-opacity"];


  clonedNodes.forEach((node) => {
    const computed = window.getComputedStyle(node);
    const style = styleProperties.
    map((property) => `${property}:${computed.getPropertyValue(property)}`).
    join(";");
    node.setAttribute("style", `${node.getAttribute("style") || ""};${style}`);
  });

  sandbox.remove();
  normalizeExportSvgPaint(clone);
  normalizeExportSvgHrefs(clone);
  // The SVG is rasterized in isolation; retain the embedded Jupiter font there.
  for (const sheet of document.styleSheets) {
    let rules;
    try {rules = sheet.cssRules;} catch {continue;}
    for (const rule of rules) {
      if (rule.type !== CSSRule.FONT_FACE_RULE || !rule.style.fontFamily.includes("Astro Jupiter")) continue;
      const fontStyle = document.createElementNS("http://www.w3.org/2000/svg", "style");
      I18n.bind(fontStyle, "textContent", () => rule.cssText);
      clone.prepend(fontStyle);
    }
  }
  return clone;
}

function normalizeExportSvgPaint(svg) {
  svg.querySelectorAll("stop").forEach((stop) => {
    if (stop.style.stopColor) stop.setAttribute("stop-color", stop.style.stopColor);
    if (stop.style.stopOpacity) stop.setAttribute("stop-opacity", stop.style.stopOpacity);
  });

  svg.querySelectorAll("[style]").forEach((node) => {
    const style = node.getAttribute("style") || "";
    node.setAttribute("style", style.
    replaceAll("var(--surface)", "#ffffff").
    replaceAll("var(--surface-soft)", "#fbfcfd").
    replaceAll("var(--text)", "#171a1f").
    replaceAll("var(--text-soft)", "#2c313a").
    replaceAll("var(--muted)", "#68707d").
    replaceAll("var(--line)", "#d9dee6").
    replaceAll("var(--accent)", "#0f766e").
    replaceAll("var(--accent-soft)", "#f3fbf9").
    replaceAll("var(--danger)", "#b42318"));
  });
}

function normalizeExportSvgHrefs(svg) {
  svg.querySelectorAll("image").forEach((image) => {
    const href = image.getAttribute("href") || image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
    if (!href || /^data:|^https?:|^blob:/i.test(href)) return;
    const absolute = new URL(href, window.location.href).href;
    image.setAttribute("href", absolute);
    image.setAttributeNS("http://www.w3.org/1999/xlink", "href", absolute);
  });
}

const chartExportImageDataUrlCache = new Map();

async function inlineExportSvgImages(svg) {
  const images = Array.from(svg.querySelectorAll("image"));
  await Promise.all(images.map(async (image) => {
    const href = image.getAttribute("href") || image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
    if (!href || href.startsWith("data:")) return;

    try {
      let pendingDataUrl = chartExportImageDataUrlCache.get(href);
      if (!pendingDataUrl) {
        pendingDataUrl = I18n.fetch(href, { credentials: "same-origin" }).
        then((response) => {
          if (!response.ok) throw new Error(T("interface.no_se_pudo_cargar_el_recurso_svg_value", { v0: response.status }));
          return response.blob();
        }).
        then(blobToDataUrl).
        catch((error) => {
          chartExportImageDataUrlCache.delete(href);
          throw error;
        });
        chartExportImageDataUrlCache.set(href, pendingDataUrl);
      }
      const dataUrl = await pendingDataUrl;
      image.setAttribute("href", dataUrl);
      image.setAttributeNS("http://www.w3.org/1999/xlink", "href", dataUrl);
    } catch {

      // Keep the absolute URL as a graceful fallback for non-local images.
    }}));
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error || new Error(T("interface.no_se_pudo_incrustar_el_recurso_svg")));
    reader.readAsDataURL(blob);
  });
}

function svgExportBox(svg) {
  const box = svg.viewBox?.baseVal;
  if (box?.width && box?.height) return { x: box.x, y: box.y, width: box.width, height: box.height };
  const rect = svg.getBoundingClientRect();
  return {
    x: 0,
    y: 0,
    width: Math.max(1, Math.round(rect.width || 950)),
    height: Math.max(1, Math.round(rect.height || 950))
  };
}

function svgExportSize(svg, padding = 0) {
  const box = svgExportBox(svg);
  return {
    width: box.width + padding * 2,
    height: box.height + padding * 2
  };
}

function svgElementToImage(svg) {
  return new Promise((resolve, reject) => {
    const serialized = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([serialized], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(T("interface.no_se_pudo_renderizar_el_grafico")));
    };
    image.src = url;
  });
}

function canvasToPdfBlob(canvas) {
  const jpegData = canvas.toDataURL("image/jpeg", 0.92).split(",")[1];
  const imageBytes = base64ToBytes(jpegData);
  const pageWidth = Math.min(1440, Math.max(520, canvas.width * 0.75));
  const pageHeight = pageWidth * (canvas.height / canvas.width);
  const content = `q\n${pageWidth.toFixed(2)} 0 0 ${pageHeight.toFixed(2)} 0 0 cm\n/Im0 Do\nQ`;
  const objects = [
  asciiBytes("<< /Type /Catalog /Pages 2 0 R >>"),
  asciiBytes("<< /Type /Pages /Kids [3 0 R] /Count 1 >>"),
  asciiBytes(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth.toFixed(2)} ${pageHeight.toFixed(2)}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>`),
  concatBytes([
  asciiBytes(`<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${imageBytes.length} >>\nstream\n`),
  imageBytes,
  asciiBytes("\nendstream")]
  ),
  asciiBytes(`<< /Length ${content.length} >>\nstream\n${content}\nendstream`)];


  const chunks = [asciiBytes("%PDF-1.4\n")];
  const offsets = [0];
  let cursor = chunks[0].length;
  objects.forEach((object, index) => {
    offsets.push(cursor);
    const prefix = asciiBytes(`${index + 1} 0 obj\n`);
    const suffix = asciiBytes("\nendobj\n");
    chunks.push(prefix, object, suffix);
    cursor += prefix.length + object.length + suffix.length;
  });

  const xrefOffset = cursor;
  const xrefRows = ["0000000000 65535 f ", ...offsets.slice(1).map((offset) => `${String(offset).padStart(10, "0")} 00000 n `)];
  chunks.push(asciiBytes(`xref\n0 ${objects.length + 1}\n${xrefRows.join("\n")}\ntrailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`));
  return new Blob(chunks, { type: "application/pdf" });
}

function asciiBytes(text) {
  return new TextEncoder().encode(text);
}

function base64ToBytes(value) {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}

function concatBytes(parts) {
  const total = parts.reduce((sum, part) => sum + part.length, 0);
  const output = new Uint8Array(total);
  let offset = 0;
  parts.forEach((part) => {
    output.set(part, offset);
    offset += part.length;
  });
  return output;
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function chartExportFilename(extension) {
  const personName = slugId(birthProfile?.name || "eliseo");
  const type = slugId(chartContextLabel(chartWheelTypeSelect.value));
  return `eliseo-${personName}-${type}.${extension}`;
}

function setChartWheelStatus(text, isError = false) {
  I18n.bind(chartWheelStatus, "textContent", () => text || "");
  chartWheelStatus.classList.toggle("error", Boolean(isError));
}

function updateChartDataButton() {
  const canUseGpt = canAccessGptIa();
  openChartWheelButton?.classList.add("is-hidden");
  if (openChartWheelButton) {
    openChartWheelButton.disabled = true;
    I18n.clear(openChartWheelButton, "title");
  }
  collapsedOpenChartWheelButton?.classList.add("is-hidden");
  if (collapsedOpenChartWheelButton) {
    collapsedOpenChartWheelButton.disabled = true;
    I18n.clear(collapsedOpenChartWheelButton, "title");
  }
  privateMapChatButton?.classList.add("is-hidden");
  if (privateMapChatButton) {
    privateMapChatButton.disabled = true;
    I18n.clear(privateMapChatButton, "title");
  }
  if (privateMapPromptButton) {
    const promptDisabled = !chartCalculation || !canUseGpt;
    privateMapPromptButton.disabled = promptDisabled;
    I18n.bind(privateMapPromptButton, "title", () => canUseGpt ? T("interface.ver_y_copiar_el_prompt_exportable") : T("interface.disponible_con_la_suscripcion_de_astroanamnesis"));


    I18n.bind(privateMapPromptButton, "@aria-label", () => canUseGpt ? T("interface.interpretar_carta") : T("interface.interpretar_carta_disponible_con_la_suscripcion_de_astroanamnesis"));





  }
  openChartDataButton.classList.toggle("is-hidden", !chartCalculation || !canUseGpt);
  openChartDataButton.disabled = !chartCalculation || !canUseGpt;
  I18n.bind(openChartDataButton, "title", () => canUseGpt ? T("interface.ver_y_copiar_el_prompt_exportable") : T("interface.disponible_con_la_suscripcion_de_astroanamnesis"));


  chartWheelStage?.querySelectorAll("[data-chart-card-action='interpret']").forEach((button) => {
    button.classList.toggle("is-hidden", !canUseGpt);
    button.setAttribute("aria-hidden", canUseGpt ? "false" : "true");
    button.disabled = !chartCalculation || !canUseGpt;
    I18n.bind(button, "title", () => canUseGpt ? T("interface.interpretar_carta") : T("interface.disponible_con_la_suscripcion_de_astroanamnesis"));


  });
  sidebarChartControls?.classList.toggle("is-hidden", !chartCalculation);
}

function renderCreditWidgets() {
  const visible = Boolean(currentUser);
  chatCreditSummary?.classList.toggle("is-hidden", true);
  openBillingInfoButton?.classList.add("is-hidden");
  if (!visible) return;
  renderAccountSettings();
}

function applyChatSidebarState() {
  chatScreen?.classList.toggle("sidebar-collapsed", chatSidebarCollapsed);
  collapsedSidebarActions?.classList.toggle("is-hidden", !chatSidebarCollapsed);
  if (!chatSidebarCollapsed) closeCollapsedChatPopover();
  renderCollapsedChatList();
  if (!toggleChatSidebarButton) return;
  toggleChatSidebarButton.setAttribute("aria-expanded", chatSidebarCollapsed ? "false" : "true");
  I18n.bind(toggleChatSidebarButton, "@aria-label", ((__i18nSnapshot0) => () => __i18nSnapshot0 ? T("interface.mostrar_barra_lateral") : T("interface.ocultar_barra_lateral"))(chatSidebarCollapsed));
  I18n.bind(toggleChatSidebarButton, "title", ((__i18nSnapshot0) => () => __i18nSnapshot0 ? T("interface.mostrar_barra_lateral") : T("interface.ocultar_barra_lateral"))(chatSidebarCollapsed));
}

function applyPrivateSidebarState() {
  syncPrivateMapContextPlacement();
  privateScreen?.classList.toggle("sidebar-collapsed", privateSidebarCollapsed);
  window.requestAnimationFrame(() => {
    if (privateSidebarCollapsed && chartWheelStage?.classList.contains("is-full-chart")) {
      chartWheelStage.scrollTop = 0;
      chartWheelStage.scrollLeft = 0;
      const chartWorkspace = chartWheelStage.querySelector(".chart-wheel-workspace:not(.chart-wheel-workspace-multiple)");
      if (chartWorkspace) {
        chartWorkspace.scrollTop = 0;
        chartWorkspace.scrollLeft = 0;
      }
    }
    arrangeFloatingPanels(chartWheelStage?.querySelector(".chart-wheel-workspace"));
    initChartToolsScrollHints(chartWheelStage);
    initChartViewportFit(chartWheelStage);
  });
  const isMobile = privateSidebarMobileQuery.matches;
  privateSidebar?.setAttribute("aria-hidden", isMobile && privateSidebarCollapsed ? "true" : "false");
  privateSidebar?.toggleAttribute("inert", isMobile && privateSidebarCollapsed);
  privatePanel?.toggleAttribute("inert", isMobile && !privateSidebarCollapsed);
  if (privateSidebarBackdrop) {
    privateSidebarBackdrop.tabIndex = isMobile && !privateSidebarCollapsed ? 0 : -1;
    privateSidebarBackdrop.setAttribute("aria-hidden", isMobile && !privateSidebarCollapsed ? "false" : "true");
  }
  if (!togglePrivateSidebarButton) return;
  togglePrivateSidebarButton.setAttribute("aria-expanded", privateSidebarCollapsed ? "false" : "true");
  const sidebarLabel = isMobile ? privateSidebarCollapsed ? T("interface.mostrar_barra_lateral") : T("interface.ocultar_barra_lateral") : privateSidebarCollapsed ? T("sidebar-rail.pin") : T("sidebar-rail.auto");
  I18n.bind(togglePrivateSidebarButton, "@aria-label", ((__i18nSnapshot0) => () => isMobile ? __i18nSnapshot0 ? T("interface.mostrar_barra_lateral") : T("interface.ocultar_barra_lateral") : __i18nSnapshot0 ? T("sidebar-rail.pin") : T("sidebar-rail.auto"))(privateSidebarCollapsed));
  I18n.bind(togglePrivateSidebarButton, "title", ((__i18nSnapshot0) => () => isMobile ? __i18nSnapshot0 ? T("interface.mostrar_barra_lateral") : T("interface.ocultar_barra_lateral") : __i18nSnapshot0 ? T("sidebar-rail.pin") : T("sidebar-rail.auto"))(privateSidebarCollapsed));
}

function renderBillingInfoModal() {
  if (!billingSummary) {
    I18n.bind(billingInfoContent, "innerHTML", () => `<p>${T("interface.aun_no_se_ha_cargado_la_informacion_de_suscripcion_abre_mi_espacio_o_actualiza_la_cue")}</p>`);
    return;
  }

  const subscribed = isSubscribedUser();
  const capabilities = getCapabilities();
  if (!subscribed) {
    I18n.bind(billingInfoContent, "innerHTML", () => `<p>${T("interface.esta_cuenta_no_tiene_una_suscripcion_activa")}</p>`);
    return;
  }

  I18n.bind(billingInfoContent, "innerHTML", () => `
    <section>
      <h3>${T("interface.suscripcion_activa")}</h3>
      <p>${T("interface.tu_suscripcion_habilita_la_exportacion_de_prompts_configurables_dentro_del_apartado_d")}</p>
    </section>
    <section>
      <h3>${T("interface.incluido_en_la_suscripcion")}</h3>
      <ul class="subscription-benefits-list">
        <li>${T("interface.value_personas_guardadas_en_base_de_datos_2", { v0: formatNumber(capabilities.maxPeople) })}</li>
        <li>${T("interface.extraccion_de_prompts_configurables")}</li>
        <li>${T("interface.acceso_al_gpt_especializado_del_sistema_astroanamnesis_creado_por_el_astrologo_eliseo")}</li>
        <li>${T("interface.preparacion_de_lecturas_profesionales_desde_mapas")}</li>
      </ul>
    </section>
  `);
}

function closeBillingInfoModal() {
  billingInfoDialog.close();
}

function applyUsageUpdate(data) {
  if (!billingSummary) billingSummary = {};
  billingSummary.account = {
    ...(billingSummary.account || {}),
    balance: Number(data.account?.balance ?? data.balanceAfter ?? 0),
    lifetimeSpent: Number(billingSummary.account?.lifetimeSpent || 0) + Number(data.creditsCharged || 0),
    lowBalance: Boolean(data.account?.lowBalance)
  };
  billingSummary.recentUsage = [
  {
    provider: data.provider,
    modelLevel: data.modelLevel,
    model: data.model,
    inputTokens: data.inputTokens,
    outputTokens: data.outputTokens,
    totalTokens: data.totalTokens,
    creditsCharged: data.creditsCharged,
    balanceAfter: data.balanceAfter,
    estimated: data.estimated,
    createdAt: new Date().toISOString()
  },
  ...(billingSummary.recentUsage || [])].
  slice(0, 8);
  if (currentUser) currentUser.billing = billingSummary.account;
  renderCreditWidgets();
  renderAccountSettings();
  const remainingBalance = Number(billingSummary.account?.balance || 0);
  if (remainingBalance <= 0) {
    setStatus(() => T("interface.saldo_de_lumens_agotado_anade_lumens_desde_configuracion_o_mi_espacio_para_continuar"));
  } else if (billingSummary.account?.lowBalance) {
    setStatus(() => T("interface.te_quedan_pocos_lumens_puedes_anadir_mas_desde_configuracion_o_mi_espacio"));
  }
}

function buildLoadedContextJson() {
  const type = currentChartDataType();
  const profile = chartCalculation?.profile || birthProfile || null;
  const localWeekday = profile ? getLocalBirthWeekdayInfo(profile).label : "";
  const contextWeekday = type === "sideral" ?
  getUniversalWeekdayLabel(profile) || localWeekday :
  localWeekday;
  const cardSelection = promptConfigCardSelection();
  return {
    formato: "eliseo.contexto_cargado.v1",
    generadoEn: new Date().toISOString(),
    persona: profile ? {
      nombre: profile.name || birthProfile?.name || "",
      fechaNacimiento: profile.birthDate || `${birthProfile?.year || ""}-${pad(birthProfile?.month || "")}-${pad(birthProfile?.day || "")}`,
      horaNacimiento: profile.birthTime || `${pad(birthProfile?.hour || "")}:${pad(birthProfile?.minute || "")}`,
      lugar: profile.location?.name || birthProfile?.city || "",
      pais: profile.location?.country || birthProfile?.countryName || birthProfile?.country || "",
      diaSemana: contextWeekday
    } : null,
    contextoActivo: {
      tipo: type,
      etiqueta: chartViewSummaryLabel(type),
      descripcion: chartContextDescription(type),
      metadatos: selectedChartContextMetadata(type)
    },
    configuracionPrompt: {
      perfil: type === "multiple" ?
      promptModeMetadata() :
      "vista_actual",
      cartasIncluidas: type === "multiple" ?
      Object.entries(cardSelection).filter(([, enabled]) => enabled).map(([key]) => key) :
      type === "customChart" ? normalizeCustomChartSelection(customChartSelection) :
      type === "nodal" ? [type, ...Object.keys(nodalAvailableContextCharts())] : [type],
      preferencias: buildPromptPreferencesPayload()
    },
    textoCargado: buildCurrentChartDataContextText(),
    calculoCartas: buildVisibleChartDataPayload(type)
  };
}

function renderChartDataModal() {
  syncPromptConfigUi();
  const format = chartDataFormatSelect?.value || "text";
  I18n.bind(chartDataOutput, "textContent", () => format === "json" ? JSON.stringify(buildLoadedContextJson(), null, 2) : buildCurrentChartDataContextText());


  I18n.clear(chartDataCopyStatus, "textContent");
}

function currentChartDataType() {
  return activeChartViewType || chartWheelTypeSelect?.value || "multiple";
}

function buildCurrentChartDataContextText() {
  return buildChartContextForType(currentChartDataType());
}

async function ensureChartDataMatchesCurrentView() {
  const type = currentChartDataType();
  if (["transits", "progressed", "solarReturn", "synastry", "composite", "compositeMultiple"].includes(type)) {
    await renderSelectedChartWheel();
  }
}

function buildVisibleChartDataPayload(type) {
  return filterVisiblePromptData(buildChartDataPayload(type));
}

function filterVisiblePromptData(value, field = "") {
  if (!value || typeof value !== "object") return value;
  if (Array.isArray(value)) {
    return value.filter((item) => {
      if (field === "planetOrder") return isChartPlanetVisible(item);
      if (field === "planets") return isChartPlanetVisible(item.key);
      if (item?.planetA && item?.planetB) return isChartPlanetVisible(item.planetA) && isChartPlanetVisible(item.planetB);
      if (item?.planet?.key) return isChartPlanetVisible(item.planet.key);
      if (typeof item?.planet === "string") return isChartPlanetVisible(item.planet);
      return true;
    }).map((item) => filterVisiblePromptData(item));
  }
  return Object.fromEntries(Object.entries(value).filter(([key, item]) => {
    if (field === "planetsByKey") return isChartPlanetVisible(key);
    if (field === "rulers") return item?.ruler && isChartPlanetVisible(item.ruler);
    if (key === "ascendant" || key === "referenceAscendant") return isChartPlanetVisible("Ascendant");
    if (key === "midheaven") return isChartPlanetVisible("Midheaven");
    if (key === "natalSun") return isChartPlanetVisible("Sun");
    return true;
  }).map(([key, item]) => [key, filterVisiblePromptData(item, key)]));
}

function buildChartDataPayload(type) {
  if (!chartCalculation) return null;
  const tropical = chartCalculation.charts?.tropical;

  if (type === "customChart") {
    return {
      ...chartCalculation,
      mode: "customChart",
      charts: Object.fromEntries(normalizeCustomChartSelection(customChartSelection).
      map((key) => [key, chartCalculation.charts?.[key] || null]))
    };
  }

  if (type === "multiple") {
    const selection = promptConfigCardSelection();
    return {
      ...chartCalculation,
      charts: {
        ...(selection.tropical ? { tropical: chartCalculation.charts?.tropical || null } : {}),
        ...(selection.memoria ? { memoria: chartCalculation.charts?.memoria || null } : {}),
        ...(selection.sideral ? { sideral: chartCalculation.charts?.sideral || null } : {})
      },
      promptSelection: selection
    };
  }
  if (type === "tropical" || type === "memoria" || type === "sideral") {
    return {
      mode: type,
      source: chartCalculation.source,
      profile: chartCalculation.profile,
      chart: chartCalculation.charts?.[type] || null
    };
  }
  if (type === "nodal") {
    const schema = tropical ? buildNodalSchema(tropical) : null;
    return {
      mode: "nodal",
      profile: chartCalculation.profile,
      schema: schema ? {
        ...schema,
        chart: visibleNodalContextChart(schema.chart),
        planetOrder: (schema.planetOrder || []).filter(isChartPlanetVisible),
        aspectRows: schema.aspectRows.filter((row) => isChartPlanetVisible(row.planet.key))
      } : null,
      charts: Object.fromEntries(Object.entries(nodalAvailableContextCharts()).
      map(([key, chart]) => [key, visibleNodalContextChart(chart)]))
    };
  }
  if (type === "transits") {
    return {
      mode: "transits",
      profile: chartCalculation.profile,
      natal: tropical || null,
      transits: transitCalculation || null
    };
  }
  if (type === "progressed") {
    return {
      mode: "secondaryProgressed",
      profile: chartCalculation.profile,
      natal: tropical || null,
      progression: progressedCalculation || null
    };
  }
  if (type === "solarReturn") {
    if (!solarReturnCalculation) return null;
    return solarReturnComparisonVisible || solarReturnNatalVisible ?
    { ...solarReturnCalculation, natal: tropical || null, view: { comparison: solarReturnComparisonVisible, solarOverlay: solarReturnNatalVisible } } :
    solarReturnCalculation;
  }
  if (type === "synastry") {
    return {
      mode: "synastry",
      profile: chartCalculation.profile,
      subjectChart: tropical || null,
      partnerCalculation: synastryCalculation || null
    };
  }
  if (type === "composite") return compositeCalculation || null;
  if (type === "compositeMultiple") {
    return {
      mode: "compositeMultiple",
      profile: chartCalculation.profile,
      composite: compositeCalculation || null
    };
  }
  return chartCalculation;
}

function closeChartDataModal() {
  chartDataDialog.close();
  I18n.clear(chartDataCopyStatus, "textContent");
}

function contactFieldErrorElement(field) {
  return field ? document.querySelector(`#${field.id}-error`) : null;
}

function clearContactFieldError(field) {
  if (!field) return;
  field.removeAttribute("aria-invalid");
  const errorElement = contactFieldErrorElement(field);
  if (errorElement) I18n.clear(errorElement, "textContent");
}

function setContactFieldError(field, message) {
  if (!field) return;
  field.setAttribute("aria-invalid", "true");
  const errorElement = contactFieldErrorElement(field);
  if (errorElement) I18n.bind(errorElement, "textContent", () => message);
}

function resetContactModal() {
  contactDialog?.setAttribute("aria-describedby", "contact-intro");
  contactForm?.reset();
  [contactReasonInput, contactNameInput, contactEmailInput, contactMessageInput].forEach(clearContactFieldError);
  if (contactNameInput) contactNameInput.value = currentUser?.name || "";
  if (contactEmailInput) contactEmailInput.value = currentUser?.email || "";
  if (contactStatus) {
    I18n.clear(contactStatus, "textContent");
    contactStatus.classList.remove("error");
  }
  if (contactForm) {
    contactForm.hidden = false;
    contactForm.removeAttribute("aria-busy");
  }
  if (contactSuccess) contactSuccess.hidden = true;
  if (contactSubmitButton) {
    contactSubmitButton.disabled = false;
    I18n.bind(contactSubmitButton, "textContent", () => T("interface.enviar_mensaje"));
  }
  contactSubmissionPending = false;
}

function openContactModal(trigger = null) {
  if (!contactDialog) return;
  contactReturnFocus = trigger || document.activeElement;
  resetContactModal();
  if (!contactDialog.open) contactDialog.showModal();
  window.requestAnimationFrame(() => contactReasonInput?.focus({ preventScroll: true }));
}

function closeContactModal() {
  if (!contactDialog?.open) return;
  contactDialog.close();
}

function validateContactForm() {
  const fields = [contactReasonInput, contactNameInput, contactEmailInput, contactMessageInput];
  fields.forEach(clearContactFieldError);
  const errors = [];
  if (!contactReasonInput?.value) errors.push([contactReasonInput, T("interface.selecciona_un_motivo_2")]);
  if (!contactNameInput?.value.trim()) errors.push([contactNameInput, T("server.escribe_tu_nombre")]);
  if (!contactEmailInput?.value.trim()) {
    errors.push([contactEmailInput, T("interface.escribe_tu_email")]);
  } else if (!contactEmailInput.validity.valid) {
    errors.push([contactEmailInput, T("server.introduce_un_email_valido")]);
  }
  if (!contactMessageInput?.value.trim()) errors.push([contactMessageInput, T("server.escribe_tu_mensaje")]);
  errors.forEach(([field, message]) => setContactFieldError(field, message));
  errors[0]?.[0]?.focus({ preventScroll: true });
  return errors.length === 0;
}

async function submitContactForm(event) {
  event.preventDefault();
  if (contactSubmissionPending || !validateContactForm()) return;

  contactSubmissionPending = true;
  contactForm?.setAttribute("aria-busy", "true");
  if (contactSubmitButton) {
    contactSubmitButton.disabled = true;
    I18n.bind(contactSubmitButton, "textContent", () => T("interface.enviando"));
  }
  if (contactStatus) {
    I18n.clear(contactStatus, "textContent");
    contactStatus.classList.remove("error");
  }

  try {
    const turnstileToken = await window.BotProtection.token("contact");
    const response = await I18n.fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        turnstileToken,
        reason: contactReasonInput.value,
        name: contactNameInput.value.trim(),
        email: contactEmailInput.value.trim(),
        message: contactMessageInput.value.trim()
      })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_enviar_el_mensaje_intentalo_de_nuevo"));

    contactForm.hidden = true;
    contactSuccess.hidden = false;
    contactDialog?.setAttribute("aria-describedby", "contact-success-description");
    window.requestAnimationFrame(() => contactSuccessCloseButton?.focus({ preventScroll: true }));
  } catch (error) {
    if (contactStatus) {
      I18n.bind(contactStatus, "textContent", () => error.message || T("interface.no_se_pudo_enviar_el_mensaje_intentalo_de_nuevo"));
      contactStatus.classList.add("error");
    }
  } finally {
    contactSubmissionPending = false;
    contactForm?.removeAttribute("aria-busy");
    if (contactSubmitButton) {
      contactSubmitButton.disabled = false;
      I18n.bind(contactSubmitButton, "textContent", () => T("interface.enviar_mensaje"));
    }
  }
}

function openLegalSection(sectionKey) {
  const section = LEGAL_SECTIONS[sectionKey];
  if (!section) return;

  I18n.bind(legalTitle, "textContent", () => section.title);
  I18n.bind(legalContent, "innerHTML", () => section.html);
  legalDialog.showModal();
}

function closeLegalModal() {
  legalDialog.close();
}

function hasLegalConsent() {
  return localStorage.getItem(LEGAL_CONSENT_KEY) === "true";
}

function acceptLegalConsent() {
  localStorage.setItem(LEGAL_CONSENT_KEY, "true");
  renderLegalConsentState();
}

function renderLegalConsentState() {
  const accepted = hasLegalConsent();
  if (birthLegalConsentInput) birthLegalConsentInput.checked = accepted;
  if (personLegalConsentInput) personLegalConsentInput.checked = accepted;
  if (chatLegalAcceptInput) chatLegalAcceptInput.checked = accepted;
  if (chatLegalConsent) chatLegalConsent.classList.toggle("is-hidden", accepted);
}

function acceptLegalConsentFromInput(inputEl, setMessage) {
  if (hasLegalConsent()) return true;
  if (inputEl?.checked) {
    acceptLegalConsent();
    return true;
  }

  inputEl?.focus();
  setMessage(T("interface.acepta_las_condiciones_de_uso_y_confirma_que_has_leido_la_politica_de_privacidad_ante"), true);
  return false;
}

function ensureChatLegalConsent() {
  if (hasLegalConsent()) return true;
  if (chatLegalAcceptInput?.checked) {
    acceptLegalConsent();
    return true;
  }

  renderLegalConsentState();
  chatLegalAcceptInput?.focus();
  setStatus(() => T("interface.acepta_el_uso_de_ia_y_las_condiciones_legales_antes_de_enviar_una_consulta"));
  return false;
}


function addMessage(role, content, options = {}) {
  const el = document.createElement("div");
  el.className = `message ${role}`;
  if (role === "assistant") {
    const body = document.createElement("div");
    body.className = "message-content";
    I18n.bind(body, "textContent", () => content || "");
    el.appendChild(body);
    if (options.feedback) el.dataset.feedback = options.feedback;
    if (content) renderAssistantMessageActions(el);
  } else {
    I18n.bind(el, "textContent", () => content);
  }
  messagesEl.appendChild(el);
  if (!isStreaming || !autoScrollLocked) scrollToBottom();
  updateEmptyChatState();
  return el;
}

function getMessageContentEl(message) {
  return message?.querySelector?.(".message-content") || message;
}

function getMessageText(message) {
  return getMessageContentEl(message)?.textContent || "";
}

function setMessageText(message, content) {
  I18n.bind(getMessageContentEl(message), "textContent", () => content || "");
}

function appendMessageText(message, content) {
  const contentEl = getMessageContentEl(message);
  contentEl.textContent += content || "";
}

function hasDraggedContextFiles(event) {
  const transfer = event.dataTransfer;
  if (!transfer) return false;
  if (transfer.files?.length) return true;
  return Array.from(transfer.items || []).some((item) => item.kind === "file");
}

function handleContextDragEnter(event) {
  if (!hasDraggedContextFiles(event)) return;
  event.preventDefault();
  contextDragDepth += 1;
  chatScreen?.classList.add("is-context-drag-over");
}

function handleContextDragOver(event) {
  if (!hasDraggedContextFiles(event)) return;
  event.preventDefault();
  if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
  chatScreen?.classList.add("is-context-drag-over");
}

function handleContextDragLeave(event) {
  if (!hasDraggedContextFiles(event)) return;
  contextDragDepth = Math.max(0, contextDragDepth - 1);
  if (contextDragDepth === 0) chatScreen?.classList.remove("is-context-drag-over");
}

async function handleContextDrop(event) {
  if (!hasDraggedContextFiles(event)) return;
  event.preventDefault();
  contextDragDepth = 0;
  chatScreen?.classList.remove("is-context-drag-over");
  const files = Array.from(event.dataTransfer?.files || []);
  if (files.length) await addContextFiles(files);
}

async function addContextFiles(files) {
  const allowedExtensions = [".pdf", ".txt", ".md", ".docx"];
  const maxFiles = 3;
  const maxBytes = 2 * 1024 * 1024;
  const availableSlots = maxFiles - attachedContextDocuments.length;
  if (availableSlots <= 0) {
    setStatus(() => T("interface.puedes_adjuntar_como_maximo_value_documentos_por_consulta", { v0: maxFiles }));
    return;
  }

  const selected = files.slice(0, availableSlots);
  const invalid = selected.find((file) => {
    const extension = fileExtension(file.name);
    return !allowedExtensions.includes(extension) || file.size > maxBytes;
  });
  if (invalid) {
    const extension = fileExtension(invalid.name).toUpperCase() || "archivo";
    setStatus(() => invalid.size > maxBytes ? T("interface.el_archivo_value_supera_el_limite_de_2_mb", { v0: invalid.name }) : T("interface.formato_value_no_admitido_usa_pdf_txt_md_o_docx", { v0: extension })

    );
    return;
  }

  setContextFilesBusy(true);
  setStatus(() => T("interface.extrayendo_contexto_documental"));
  try {
    const encodedFiles = [];
    for (const file of selected) {
      encodedFiles.push({
        name: file.name,
        type: file.type,
        size: file.size,
        data: await fileToBase64(file)
      });
    }

    const response = await I18n.fetch("/api/context-files/extract", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ files: encodedFiles })
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("interface.no_se_pudo_extraer_el_texto_de_los_documentos"));

    const documents = (payload.documents || []).map((document) => ({
      id: cryptoRandomId(),
      name: document.name,
      size: document.size,
      chars: document.chars,
      truncated: Boolean(document.truncated),
      text: document.text
    }));
    attachedContextDocuments = [...attachedContextDocuments, ...documents].slice(0, maxFiles);
    renderAttachedContextDocuments();
    setStatus(() => T("interface.value_documentovalue_preparadovalue_como_contexto_de_esta_consulta", { v0: documents.length, v1: documents.length === 1 ? "" : "s", v2: documents.length === 1 ? "" : "s" }));
  } catch (error) {
    setStatus(() => error.message || T("interface.no_se_pudo_adjuntar_el_contexto_documental"));
  } finally {
    setContextFilesBusy(false);
  }
}

function renderAttachedContextDocuments() {
  if (!contextFilesList) return;
  I18n.bind(contextFilesList, "innerHTML", ((__i18nSnapshot0) => () => __i18nSnapshot0.map((document) => `
    <li>
      <span>
        <b>${escapeHtml(document.name)}</b>
        <small>${T("interface.value_value_caracteresvalue", { v1: formatFileSize(document.size), v2: formatNumber(document.chars), get v3() {return document.truncated ? T("interface.recortado") : "";} })}</small>
      </span>
      <button type="button" data-remove-context-file="${escapeHtml(document.id)}" aria-label="${T("interface.quitar_value", { v5: escapeHtml(document.name) })}">x</button>
    </li>
  `).join(""))(attachedContextDocuments));
}

function buildAttachedContextPayload() {
  if (!attachedContextDocuments.length) return null;
  return {
    documents: attachedContextDocuments.map((document) => ({
      name: document.name,
      text: document.text
    }))
  };
}

function clearAttachedContextDocuments() {
  if (!attachedContextDocuments.length) return;
  attachedContextDocuments = [];
  renderAttachedContextDocuments();
}

function setContextFilesBusy(busy) {
  contextFilesBusy = busy;
  if (attachContextFileButton) {
    attachContextFileButton.disabled = busy;
    attachContextFileButton.classList.toggle("is-loading", busy);
  }
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || "").split(",")[1] || "");
    reader.onerror = () => reject(new Error(T("interface.no_se_pudo_leer_value", { v0: file.name })));
    reader.readAsDataURL(file);
  });
}

function fileExtension(name) {
  const match = String(name || "").toLowerCase().match(/\.[^.]+$/);
  return match ? match[0] : "";
}

function formatFileSize(bytes) {
  const size = Number(bytes || 0);
  if (size >= 1024 * 1024) return `${(size / 1024 / 1024).toFixed(size >= 10 * 1024 * 1024 ? 0 : 1)} MB`;
  return `${Math.max(1, Math.round(size / 1024))} KB`;
}

function cryptoRandomId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `context-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function setupVoiceDictationButton() {
  if (!voiceDictationButton) return;
  if (!getSpeechRecognitionConstructor()) {
    voiceDictationButton.disabled = true;
    I18n.bind(voiceDictationButton, "title", () => T("interface.el_dictado_por_voz_no_esta_disponible_en_este_navegador"));
    I18n.bind(voiceDictationButton, "@aria-label", () => T("interface.dictado_por_voz_no_disponible"));
  }
}

function getSpeechRecognitionConstructor() {
  return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

function toggleVoiceDictation() {
  if (isDictating) {
    stopVoiceDictation();
    return;
  }
  startVoiceDictation();
}

function startVoiceDictation() {
  const Recognition = getSpeechRecognitionConstructor();
  if (!Recognition) {
    setStatus(() => T("interface.el_dictado_por_voz_no_esta_disponible_en_este_navegador_2"));
    return;
  }

  stopVoiceDictation(false);
  dictationBaseText = input.value.trim();
  speechRecognition = new Recognition();
  speechRecognition.lang = "es-ES";
  speechRecognition.continuous = true;
  speechRecognition.interimResults = true;
  speechRecognition.maxAlternatives = 1;

  speechRecognition.onstart = () => {
    isDictating = true;
    voiceDictationButton.classList.add("is-listening");
    voiceDictationButton.setAttribute("aria-pressed", "true");
    I18n.bind(voiceDictationButton, "title", () => T("interface.detener_dictado"));
    setStatus(() => T("interface.escuchando_habla_con_naturalidad_pulsa_el_micro_para_detener"));
  };

  speechRecognition.onresult = (event) => {
    let finalText = "";
    let interimText = "";
    for (let index = 0; index < event.results.length; index += 1) {
      const transcript = event.results[index][0]?.transcript || "";
      if (event.results[index].isFinal) {
        finalText += `${transcript.trim()} `;
      } else {
        interimText += transcript;
      }
    }

    const parts = [dictationBaseText, finalText.trim(), interimText.trim()].filter(Boolean);
    input.value = parts.join(" ").replace(/\s+/g, " ");
    resizeInput();
    syncModelLevelWithMessage(input.value);
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  };

  speechRecognition.onerror = (event) => {
    const message = event.error === "not-allowed" ? T("interface.permite_el_microfono_en_el_navegador_para_usar_el_dictado") : T("interface.no_se_pudo_usar_el_dictado_por_voz");


    setStatus(message);
  };

  speechRecognition.onend = () => {
    setVoiceDictationInactive();
    if (statusEl.textContent.startsWith("Escuchando")) setStatus("");
  };

  try {
    speechRecognition.start();
  } catch {
    setVoiceDictationInactive();
    setStatus(() => T("interface.no_se_pudo_iniciar_el_dictado_por_voz"));
  }
}

function stopVoiceDictation(clearStatus = true) {
  if (!speechRecognition && !isDictating) return;
  try {
    speechRecognition?.stop();
  } catch {

    // The recognition instance may already be closed by the browser.
  }setVoiceDictationInactive();
  if (clearStatus) setStatus("");
}

function setVoiceDictationInactive() {
  isDictating = false;
  speechRecognition = null;
  voiceDictationButton?.classList.remove("is-listening");
  voiceDictationButton?.setAttribute("aria-pressed", "false");
  if (voiceDictationButton && !voiceDictationButton.disabled) {
    I18n.bind(voiceDictationButton, "title", () => T("interface.dictar_mensaje"));
  }
}

function renderAssistantMessageActions(message) {
  if (!message || !message.classList.contains("assistant") || message.classList.contains("error")) return;
  message.querySelector(".message-actions")?.remove();

  const actions = document.createElement("div");
  actions.className = "message-actions";
  I18n.bind(actions, "innerHTML", () => `
    <button class="message-action message-copy" type="button" data-message-action="copy" aria-label="${T("interface.copiar_respuesta")}" title="${T("interface.copiar_respuesta")}">
      ${copyIconSvg()}
    </button>
    <button class="message-action" type="button" data-message-action="download-word" aria-label="${T("interface.descargar_respuesta_en_word")}" title="${T("interface.descargar_word")}">
      ${wordIconSvg()}
    </button>
    <button class="message-action" type="button" data-message-action="download-pdf" aria-label="${T("interface.descargar_respuesta_en_pdf")}" title="${T("interface.descargar_pdf")}">
      ${pdfIconSvg()}
    </button>
    <button class="message-action" type="button" data-message-action="branch" aria-label="${T("interface.bifurcar_conversacion_desde_esta_respuesta")}" title="${T("interface.bifurcar_conversacion")}">
      ${branchIconSvg()}
    </button>
    <button class="message-action message-feedback" type="button" data-message-action="feedback" data-feedback="useful" aria-label="${T("interface.marcar_como_util")}" title="${T("interface.util")}">
      ${thumbIconSvg("up")}
    </button>
    <button class="message-action message-feedback" type="button" data-message-action="feedback" data-feedback="not_useful" aria-label="${T("interface.marcar_como_no_util")}" title="${T("interface.no_util")}">
      ${thumbIconSvg("down")}
    </button>
  `);
  message.appendChild(actions);
  syncMessageFeedbackButtons(message);
}

function syncMessageFeedbackButtons(message) {
  const selected = message.dataset.feedback || "";
  message.querySelectorAll(".message-feedback").forEach((button) => {
    const active = button.dataset.feedback === selected;
    button.classList.toggle("is-selected", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

async function handleMessageActionClick(event) {
  const button = event.target.closest("button[data-message-action]");
  if (!button) return;

  const message = button.closest(".message.assistant");
  if (!message) return;

  const action = button.dataset.messageAction;
  if (action === "copy") {
    await copyTextToClipboard(getMessageText(message));
    button.classList.add("is-copied");
    window.setTimeout(() => button.classList.remove("is-copied"), 1100);
    return;
  }

  if (action === "download-word") {
    downloadAssistantResponse(message, "word");
    return;
  }

  if (action === "download-pdf") {
    downloadAssistantResponse(message, "pdf");
    return;
  }

  if (action === "branch") {
    await branchConversationFromMessage(message);
    return;
  }

  if (action === "feedback") {
    message.dataset.feedback = message.dataset.feedback === button.dataset.feedback ? "" : button.dataset.feedback;
    syncMessageFeedbackButtons(message);
    await saveActiveChat().catch(() => null);
  }
}

async function copyTextToClipboard(text) {
  const value = clean(text);
  if (!value) return;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.remove();
}

function downloadAssistantResponse(message, format) {
  const text = clean(getMessageText(message));
  if (!text) return;

  const title = responseDownloadTitle();
  const filename = `eliseo-respuesta-${slugId(title)}.${format === "pdf" ? "pdf" : "doc"}`;
  if (format === "pdf") {
    const canvas = textToPdfCanvas(title, text);
    downloadBlob(canvasToPdfBlob(canvas), filename);
    return;
  }

  const html = `
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>${escapeHtml(title)}</title>
        <style>
          body { font-family: "Astro Jupiter", Arial, sans-serif; color: #111827; line-height: 1.55; }
          h1 { font-size: 20pt; margin: 0 0 18pt; }
          p { margin: 0 0 10pt; white-space: pre-wrap; }
        </style>
      </head>
      <body>
        <h1>${escapeHtml(title)}</h1>
        ${text.split(/\n{2,}/).map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`).join("")}
      </body>
    </html>
  `;
  downloadBlob(new Blob([html], { type: "application/msword;charset=utf-8" }), filename);
}

function responseDownloadTitle() {
  const person = birthProfile?.name ? `${birthProfile.name} - ` : "";
  const title = getActiveChatTitle() || T("interface.respuesta_eliseo");
  return `${person}${title}`.slice(0, 90);
}

function textToPdfCanvas(title, text) {
  const scale = 2;
  const pageWidth = 794;
  const margin = 64;
  const lineHeight = 21;
  const titleLineHeight = 30;
  const bodyFont = "16px Arial, sans-serif";
  const titleFont = "700 24px Arial, sans-serif";
  const measureCanvas = document.createElement("canvas");
  const measureContext = measureCanvas.getContext("2d");
  measureContext.font = bodyFont;
  const bodyLines = wrapTextLines(measureContext, text, pageWidth - margin * 2);
  measureContext.font = titleFont;
  const titleLines = wrapTextLines(measureContext, title, pageWidth - margin * 2);
  const pageHeight = Math.max(1123, margin * 2 + titleLines.length * titleLineHeight + 22 + bodyLines.length * lineHeight);

  const canvas = document.createElement("canvas");
  canvas.width = pageWidth * scale;
  canvas.height = pageHeight * scale;
  const context = canvas.getContext("2d");
  context.scale(scale, scale);
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, pageWidth, pageHeight);
  context.fillStyle = "#111827";
  context.font = titleFont;

  let y = margin;
  for (const line of titleLines) {
    context.fillText(line, margin, y);
    y += titleLineHeight;
  }

  y += 14;
  context.font = bodyFont;
  for (const line of bodyLines) {
    context.fillText(line, margin, y);
    y += lineHeight;
  }

  return canvas;
}

function wrapTextLines(context, text, maxWidth) {
  const lines = [];
  String(text || "").split("\n").forEach((paragraph) => {
    const words = paragraph.trim() ? paragraph.split(/\s+/) : [""];
    let line = "";
    for (const word of words) {
      const candidate = line ? `${line} ${word}` : word;
      if (context.measureText(candidate).width <= maxWidth || !line) {
        line = candidate;
      } else {
        lines.push(line);
        line = word;
      }
    }
    lines.push(line);
  });
  return lines;
}

async function branchConversationFromMessage(message) {
  if (!currentUser) {
    setStatus(() => T("interface.inicia_sesion_para_bifurcar_y_guardar_una_conversacion"));
    return;
  }
  if (!birthProfile || !chartCalculation) {
    setStatus(() => T("interface.primero_carga_una_carta_antes_de_bifurcar_la_conversacion"));
    return;
  }

  const messages = collectVisibleMessagesUntil(message);
  if (!messages.length) return;

  const personKey = getCurrentPersonKey();
  if (!personKey) return;

  const branchConversationId = cryptoRandomId();
  const payload = {
    personKey,
    personName: birthProfile.name || "Persona",
    title: buildBranchChatTitle(),
    conversationId: branchConversationId,
    context: buildBirthContext(),
    profile: {
      ...birthProfile,
      personId: activePersonId || birthProfile.personId || ""
    },
    calculation: chartCalculation,
    messages
  };

  setStatus(() => T("interface.bifurcando_conversacion"));
  try {
    const sourceFolderId = chatFolderAssignments[String(activeChatId)] || (activeChatFolderId !== "all" ? activeChatFolderId : "");
    const response = await I18n.fetch("/api/chat-history", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || T("interface.no_se_pudo_bifurcar_la_conversacion"));

    activeChatId = String(result.chat.id);
    conversationId = result.chat.conversationId || branchConversationId;
    localStorage.setItem("activeChatId", activeChatId);
    localStorage.setItem("conversationId", conversationId);
    if (sourceFolderId && chatFolders.some((folder) => folder.id === sourceFolderId)) {
      chatFolderAssignments[activeChatId] = sourceFolderId;
      await saveChatUiPreferencesNow().catch(() => setStatus(() => T("interface.la_rama_se_creo_pero_no_se_pudo_conservar_la_carpeta_seleccionada")));
    }

    I18n.clear(messagesEl, "innerHTML");
    for (const item of result.chat.messages || messages) {
      addMessage(item.role, item.content, { feedback: item.feedback || "" });
    }
    chatContextPreloaded = true;
    knowledgeStatusLoaded = true;
    await loadChatHistory();
    setStatus(() => T("interface.conversacion_bifurcada_puedes_continuar_desde_esta_rama"));
  } catch (error) {
    setStatus(() => error.message || T("interface.no_se_pudo_bifurcar_la_conversacion"));
  }
}

function collectVisibleMessagesUntil(targetMessage) {
  const output = [];
  for (const message of Array.from(messagesEl.querySelectorAll(".message"))) {
    const role = message.classList.contains("user") ?
    "user" :
    message.classList.contains("assistant") ?
    "assistant" :
    "system";
    const item = { role, content: getMessageText(message).trim() };
    if (role === "assistant" && message.dataset.feedback) item.feedback = message.dataset.feedback;
    if (item.content) output.push(item);
    if (message === targetMessage) break;
  }
  return output;
}

function buildBranchChatTitle() {
  const base = getActiveChatTitle() || "Nueva consulta";
  const prefix = "Rama";
  return base.startsWith(prefix) ? base : `${prefix} - ${base}`.slice(0, 72);
}

function copyIconSvg() {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="8" y="8" width="11" height="11" rx="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"></path>
    </svg>
  `;
}

function wordIconSvg() {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z"></path>
      <path d="M14 3v5h5"></path>
      <path d="M8.2 11.5 9.5 17l1.5-4.2L12.6 17l1.2-5.5"></path>
    </svg>
  `;
}

function pdfIconSvg() {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z"></path>
      <path d="M14 3v5h5"></path>
      <path d="M8 16h1.8a1.3 1.3 0 0 0 0-2.6H8v4.2"></path>
      <path d="M13 13.4v4.2h1a2.1 2.1 0 0 0 0-4.2Z"></path>
      <path d="M17.2 17.6v-4.2H20"></path>
      <path d="M17.2 15.5h2.1"></path>
    </svg>
  `;
}

function branchIconSvg() {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 4v6a6 6 0 0 0 6 6h6"></path>
      <path d="M6 20v-6a6 6 0 0 1 6-6h6"></path>
      <path d="m15 5 3 3-3 3"></path>
      <path d="m15 13 3 3-3 3"></path>
    </svg>
  `;
}

function thumbIconSvg(direction) {
  const transform = direction === "down" ? ' class="thumb-down"' : "";
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true"${transform}>
      <path d="M7 10v10"></path>
      <path d="M15 5.5 14 10h5.5a1.8 1.8 0 0 1 1.7 2.2l-1.4 6A2.4 2.4 0 0 1 17.5 20H9.8A2.8 2.8 0 0 1 7 17.2v-5.4a3 3 0 0 1 .8-2.1L13 4.2a1.4 1.4 0 0 1 2 .1c.3.3.4.8.3 1.2Z"></path>
    </svg>
  `;
}

function folderIconSvg(open = true) {
  return `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h4.1l2 2.3H18a2.5 2.5 0 0 1 2.5 2.5v6.7A2.5 2.5 0 0 1 18 19H6a2.5 2.5 0 0 1-2.5-2.5v-9Z"></path>
      ${open ? '<path d="M3.8 10h16.4"></path>' : ""}
    </svg>
  `;
}

function setStatus(text) {
  statusEl.hidden = !text;
  I18n.bind(statusEl, "textContent", () => text || "");
}

function setBusy(busy, text) {
  isStreaming = busy;
  sendButton.disabled = busy;
  connectionDot.classList.toggle("busy", busy);
  connectionDot.classList.remove("error");
  I18n.bind(connectionText, "textContent", () => I18n.label(text || ""));
}

function setCalculateBusy(busy) {
  calculateButton.disabled = busy;
  I18n.bind(calculateButton, "textContent", () => busy ? T("interface.calculando") : T("interface.calcular"));
}

function setFormStatus(text, isError = false) {
  I18n.bind(formStatus, "textContent", () => text || "");
  formStatus.classList.toggle("error", Boolean(isError));
}

function setError(text) {
  connectionDot.classList.remove("busy");
  connectionDot.classList.add("error");
  I18n.bind(connectionText, "textContent", () => text);
}

function resizeInput() {
  input.style.height = "auto";
  input.style.height = `${Math.min(input.scrollHeight, 180)}px`;
}

function scrollToBottom() {
  if (autoScrollLocked) return;
  messagesEl.scrollTop = messagesEl.scrollHeight;
  lastMessagesScrollTop = messagesEl.scrollTop;
}

function isNearBottom() {
  return messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight < 48;
}

function populateDateTimeSelects(monthTarget, hourTarget, minuteTarget) {
  const months = [
  ["01", "Enero"],
  ["02", "Febrero"],
  ["03", "Marzo"],
  ["04", "Abril"],
  ["05", "Mayo"],
  ["06", "Junio"],
  ["07", "Julio"],
  ["08", "Agosto"],
  ["09", "Septiembre"],
  ["10", "Octubre"],
  ["11", "Noviembre"],
  ["12", "Diciembre"]];


  I18n.bind(monthTarget, "innerHTML", () => months.map(([value, label]) => `<option value="${value}">${I18n.label(label)}</option>`).join(""));



  I18n.bind(hourTarget, "innerHTML", () => Array.from({ length: 24 }, (_, index) => {const value = pad(index);return `<option value="${value}">${value}</option>`;}).join(""));




  I18n.bind(minuteTarget, "innerHTML", () => Array.from({ length: 60 }, (_, index) => {const value = pad(index);return `<option value="${value}">${value}</option>`;}).join(""));



}

async function loadCountries() {
  try {
    const response = await I18n.fetch("/api/locations/countries");
    if (!response.ok) throw new Error(T("interface.no_se_pudieron_cargar_los_paises"));

    const countries = await response.json();
    countriesCache = countries;
    populateCountryOptions(countrySelect, countries, "Selecciona país");
    populateCountryOptions(personCountrySelect, countries, "Selecciona país");
    populateCountryOptions(chartSolarReturnCountrySelect, countries, "Selecciona país");
    populateCountryOptions(accountPersonalCountrySelect, countries, "Selecciona país");
    populateCountryOptions(aspectFinderCountry, countries, "Selecciona país");
    populateCountryOptions(natalAspectFinderCountry, countries, "Selecciona país");
    if (accountPersonalCountrySelect) accountPersonalCountrySelect.value = accountPersonalInformation.country;
    personCountrySearchInput.disabled = false;
    I18n.bind(personCountrySearchInput, "placeholder", () => T("interface.buscar_pais"));
    syncCountryCombobox();
    solarReturnCountryControl.input.disabled = false;
    I18n.bind(solarReturnCountryControl.input, "placeholder", () => T("interface.buscar_pais"));
    syncCountryCombobox(solarReturnCountryControl);

    if (birthProfile) {
      fillBirthForm(birthProfile);
      if (birthProfile.country) {
        await loadCities(birthProfile.country, birthProfile.city || "");
      }
      syncSolarReturnLocationDefaults(true);
    }
  } catch {
    I18n.bind(countrySelect, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    I18n.bind(personCountrySelect, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    if (chartSolarReturnCountrySelect) I18n.bind(chartSolarReturnCountrySelect, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    if (accountPersonalCountrySelect) I18n.bind(accountPersonalCountrySelect, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    if (aspectFinderCountry) I18n.bind(aspectFinderCountry, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    if (natalAspectFinderCountry) I18n.bind(natalAspectFinderCountry, "innerHTML", () => `<option value="">${T("interface.no_se_pudieron_cargar_paises")}</option>`);
    countrySelect.disabled = true;
    personCountrySelect.disabled = true;
    personCountrySearchInput.value = "";
    I18n.bind(personCountrySearchInput, "placeholder", () => T("interface.no_se_pudieron_cargar_paises"));
    personCountrySearchInput.disabled = true;
    closeCountrySuggestions();
    if (chartSolarReturnCountrySelect) chartSolarReturnCountrySelect.disabled = true;
    solarReturnCountryControl.input.value = "";
    I18n.bind(solarReturnCountryControl.input, "placeholder", () => T("interface.no_se_pudieron_cargar_paises"));
    solarReturnCountryControl.input.disabled = true;
    closeCountrySuggestions(solarReturnCountryControl);
    if (accountPersonalCountrySelect) accountPersonalCountrySelect.disabled = true;
    if (aspectFinderCountry) aspectFinderCountry.disabled = true;
    if (natalAspectFinderCountry) natalAspectFinderCountry.disabled = true;
    cityInput.disabled = true;
    personCityInput.disabled = true;
    if (aspectFinderCity) aspectFinderCity.disabled = true;
    if (natalAspectFinderCity) natalAspectFinderCity.disabled = true;
    if (chartSolarReturnCityInput) chartSolarReturnCityInput.disabled = true;
  }
}

function sortCountriesByName(countries) {
  const collator = new Intl.Collator(document.documentElement.lang || "es", { sensitivity: "base" });
  return [...countries].sort((left, right) => collator.compare(left.name, right.name));
}

function populateCountryOptions(select, countries, placeholder) {
  if (!select) return;
  const currentValue = select.value;
  I18n.bind(select, "innerHTML", () => `<option value="">${escapeHtml(I18n.label(I18n.label(placeholder)))}</option>${sortCountriesByName(countries).map((country) => `<option value="${escapeHtml(country.code)}">${escapeHtml(country.name)}</option>`).join("")}`);

  if (currentValue) select.value = currentValue;
}

async function loadCities(country, query = "") {
  const selectedCountry = clean(country);
  if (!selectedCountry) {
    cityList = [];
    lastCountry = "";
    return;
  }

  const params = new URLSearchParams({ country: selectedCountry });
  if (query) params.set("q", query);

  const response = await I18n.fetch(`/api/locations/cities?${params}`);
  if (!response.ok) {
    cityList = [];
    return;
  }

  cityList = await response.json();
  lastCountry = selectedCountry;
}

function renderCitySuggestions(query) {
  const normalized = query.trim().toLowerCase();
  I18n.clear(cityResults, "innerHTML");

  if (!normalized || !cityList.length) return;

  cityList.
  filter((city) => city.name.toLowerCase().startsWith(normalized)).
  slice(0, 10).
  forEach((city) => {
    const option = document.createElement("button");
    option.type = "button";
    option.className = "city-suggestion";
    I18n.bind(option, "textContent", () => `${city.name} · ${city.tz}`);
    option.addEventListener("click", () => selectCity(city));
    cityResults.appendChild(option);
  });
}

function selectCity(city) {
  cityInput.value = city.name;
  placeIdInput.value = city.id;
  latInput.value = city.lat;
  lonInput.value = city.lon;
  tzInput.value = city.tz;
  I18n.clear(cityResults, "innerHTML");
  I18n.validity(cityInput, () => "");
}

function normalizeSolarReturnText(value) {
  return clean(value).toLowerCase();
}

function cleanDatasetValue(value) {
  return value === undefined || value === null ? "" : String(value).trim();
}

function setSolarReturnPlaceSelection(city, country = "") {
  if (!chartSolarReturnPlaceIdInput || !city) return;
  chartSolarReturnPlaceIdInput.value = city.id || "";
  chartSolarReturnPlaceIdInput.dataset.city = clean(city.name);
  chartSolarReturnPlaceIdInput.dataset.country = clean(country || chartSolarReturnCountrySelect?.value);
  chartSolarReturnPlaceIdInput.dataset.lat = cleanDatasetValue(city.lat ?? city.latitude);
  chartSolarReturnPlaceIdInput.dataset.lon = cleanDatasetValue(city.lon ?? city.lng ?? city.longitude);
  chartSolarReturnPlaceIdInput.dataset.timezone = cleanDatasetValue(city.tz ?? city.timezone);
}

function clearSolarReturnPlaceSelection() {
  if (!chartSolarReturnPlaceIdInput) return;
  chartSolarReturnPlaceIdInput.value = "";
  delete chartSolarReturnPlaceIdInput.dataset.city;
  delete chartSolarReturnPlaceIdInput.dataset.country;
  delete chartSolarReturnPlaceIdInput.dataset.lat;
  delete chartSolarReturnPlaceIdInput.dataset.lon;
  delete chartSolarReturnPlaceIdInput.dataset.timezone;
}

function hasValidSolarReturnPlaceSelection(country, cityName) {
  if (!chartSolarReturnPlaceIdInput?.value) return false;

  const selectedCity = normalizeSolarReturnText(chartSolarReturnPlaceIdInput.dataset.city);
  const selectedCountry = normalizeSolarReturnText(chartSolarReturnPlaceIdInput.dataset.country);
  const currentCity = normalizeSolarReturnText(cityName);
  const currentCountry = normalizeSolarReturnText(country);

  return Boolean(
    selectedCity &&
    selectedCountry &&
    currentCity &&
    currentCountry &&
    selectedCity === currentCity &&
    selectedCountry === currentCountry
  );
}

function syncSolarReturnLocationDefaults(force = false) {
  if (!chartSolarReturnCountrySelect || !chartSolarReturnCityInput || !chartSolarReturnPlaceIdInput || !birthProfile) return;

  if (force || !chartSolarReturnCountrySelect.value) {
    chartSolarReturnCountrySelect.value = birthProfile.country || "";
    syncCountryCombobox(solarReturnCountryControl);
    closeCountrySuggestions(solarReturnCountryControl);
  }
  if (force || !chartSolarReturnCityInput.value) {
    chartSolarReturnCityInput.value = birthProfile.city || "";
  }
  if (force || !chartSolarReturnPlaceIdInput.value) {
    setSolarReturnPlaceSelection(
      {
        id: birthProfile.placeId || "",
        name: birthProfile.city || "",
        lat: birthProfile.lat,
        lon: birthProfile.lon,
        tz: birthProfile.tz || birthProfile.timezone
      },
      birthProfile.country || chartSolarReturnCountrySelect.value || ""
    );
  }

  chartSolarReturnCityInput.disabled = !chartSolarReturnCountrySelect.value;
}

function syncSolarReturnLocationControls() {
  const visible = Boolean(chartSolarReturnCustomLocationInput?.checked);
  chartSolarReturnLocation?.classList.toggle("is-hidden", !visible);
  if (!visible) closeCountrySuggestions(solarReturnCountryControl);
  if (visible) syncSolarReturnLocationDefaults();
}

async function resolveSolarReturnLocationSelection() {
  if (!chartSolarReturnCustomLocationInput?.checked) return true;

  const country = clean(chartSolarReturnCountrySelect?.value);
  const cityName = clean(chartSolarReturnCityInput?.value);

  if (!country || !cityName) {
    solarReturnCalculation = null;
    setChartWheelStatus(() => T("interface.selecciona_pais_y_ciudad_de_revolucion_para_recalcular"));
    return false;
  }

  if (hasValidSolarReturnPlaceSelection(country, cityName)) return true;

  clearSolarReturnPlaceSelection();

  let exactCity = findSolarReturnExactCity(cityName);
  if (!exactCity) {
    await loadSolarReturnCities(country, cityName);
    exactCity = findSolarReturnExactCity(cityName);
  }

  if (exactCity) {
    selectSolarReturnCity(exactCity, { refresh: false });
    return true;
  }

  const matchingCities = findSolarReturnCityMatches(cityName);
  solarReturnCalculation = null;
  renderSolarReturnCitySuggestions(cityName);

  if (matchingCities.length) {
    setChartWheelStatus("");
    return false;
  }

  setChartWheelStatus(() => T("interface.no_se_ha_encontrado_ninguna_ciudad_que_coincida_con_value", { v0: cityName }), true);
  return false;
}

async function requestSolarReturnRefresh(options = {}) {
  if (chartWheelTypeSelect.value !== "solarReturn") return;
  if (options.resolveLocation) {
    const hasLocation = await resolveSolarReturnLocationSelection();
    if (!hasLocation) return;
  }
  solarReturnCalculation = null;
  renderBirthSummary();
  await renderSelectedChartWheel();
}

function scheduleSolarReturnLocationRefresh() {
  window.clearTimeout(solarReturnLocationRefreshTimer);
  solarReturnLocationRefreshTimer = window.setTimeout(() => {
    if (chartWheelTypeSelect.value !== "solarReturn" || !chartSolarReturnCustomLocationInput?.checked) return;
    requestSolarReturnRefresh({ resolveLocation: true });
  }, 320);
}

async function loadSolarReturnCities(country, query = "") {
  const selectedCountry = clean(country);
  if (!selectedCountry) {
    solarReturnCityList = [];
    solarReturnLastCountry = "";
    return;
  }

  const params = new URLSearchParams({ country: selectedCountry });
  if (query) params.set("q", query);

  const response = await I18n.fetch(`/api/locations/cities?${params}`);
  if (!response.ok) {
    solarReturnCityList = [];
    return;
  }

  solarReturnCityList = await response.json();
  solarReturnLastCountry = selectedCountry;
}

function findSolarReturnExactCity(query) {
  const normalized = clean(query).toLowerCase();
  if (!normalized) return null;
  return solarReturnCityList.find((city) => clean(city.name).toLowerCase() === normalized) || null;
}

function findSolarReturnCityMatches(query) {
  const normalized = clean(query).toLowerCase();
  if (!normalized) return [];
  return solarReturnCityList.filter((city) => clean(city.name).toLowerCase().includes(normalized));
}

function renderSolarReturnCitySuggestions(query) {
  if (!chartSolarReturnCityResults) return;
  I18n.clear(chartSolarReturnCityResults, "innerHTML");

  findSolarReturnCityMatches(query).
  slice(0, 10).
  forEach((city) => {
    const option = document.createElement("button");
    option.type = "button";
    option.className = "city-suggestion";
    I18n.bind(option, "textContent", () => `${city.name} · ${city.tz}`);
    option.addEventListener("click", () => selectSolarReturnCity(city));
    chartSolarReturnCityResults.appendChild(option);
  });
}

function selectSolarReturnCity(city, options = {}) {
  const { refresh = true } = options;
  chartSolarReturnCityInput.value = city.name;
  setSolarReturnPlaceSelection(city, chartSolarReturnCountrySelect?.value);
  I18n.clear(chartSolarReturnCityResults, "innerHTML");
  I18n.validity(chartSolarReturnCityInput, () => "");

  if (refresh) requestSolarReturnRefresh({ resolveLocation: true });
}

function clearSolarReturnSelectedCity() {
  window.clearTimeout(solarReturnLocationRefreshTimer);
  solarReturnCityList = [];
  solarReturnLastCountry = "";
  chartSolarReturnCityInput.value = "";
  chartSolarReturnCityInput.disabled = true;
  clearSolarReturnPlaceSelection();
  if (chartSolarReturnCityResults) I18n.clear(chartSolarReturnCityResults, "innerHTML");
}

function clearSelectedCity() {
  cityInput.value = "";
  cityInput.disabled = true;
  placeIdInput.value = "";
  latInput.value = "";
  lonInput.value = "";
  tzInput.value = "";
  I18n.clear(cityResults, "innerHTML");
}

async function loadKnowledgeStatus() {
  if (knowledgeStatusLoaded) return;
  knowledgeStatusLoaded = true;

  try {
    const response = await I18n.fetch("/api/knowledge/status");
    if (!response.ok) return;

    const status = await response.json();
    if (status.provider !== "openai") return;

    if (status.vectorStoreConfigured && status.fileSearchEnabled) return;
  } catch {

    // The chat can still work without the status check.
  }}

function clean(value) {
  return String(value || "").trim();
}

function pad(value) {
  return String(value || "").padStart(2, "0");
}

function round(value, digits = 2) {
  const factor = 10 ** digits;
  return Math.round(Number(value) * factor) / factor;
}

function formatNumber(value) {
  return new Intl.NumberFormat("es-ES").format(Number(value || 0));
}

function formatLumens(value) {
  const amount = Number(value || 0);
  return `${formatNumber(amount)} ${Math.abs(amount) === 1 ? "Lumen" : "Lumens"}`;
}

function escapeHtml(value) {
  return String(value).
  replaceAll("&", "&amp;").
  replaceAll("<", "&lt;").
  replaceAll(">", "&gt;").
  replaceAll('"', "&quot;");
}
document.addEventListener("admin-security-ready", () => loadAdminPanel(activeAdminTab, { force: true }));

// Account-scoped product tour. The private module and state are authorized again by the server.
function syncOnboardingAccess() {
  if (onboardingOwnerId !== currentUser?.id) {
    onboardingController?.destroy();
    onboardingController = null;
    onboardingLoading = null;
    onboardingOwnerId = currentUser?.id || null;
  }
  let button = document.getElementById("repeat-onboarding");
  if (!currentUser?.canUseOnboarding) {
    button?.remove();onboardingController?.destroy();onboardingController = null;onboardingLoading = null;
    return;
  }
  if (!button && privateAccountMenu) {
    button = document.createElement("button");
    button.id = "repeat-onboarding";
    button.type = "button";
    button.className = "private-account-action";
    I18n.bind(button, "innerHTML", () => '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M9.5 9a2.5 2.5 0 1 1 4.5 1.5c-1 .6-2 1-2 2.5M12 16h.01"></path></svg><span></span>');
    button.addEventListener("click", async () => {
      if (isPersonFormOpen()) {setPrivateStatus(() => T("onboarding.closeForm"), true);return;}
      closePrivateAccountMenu();
      try {const controller = await loadOnboarding();await controller?.start();}
      catch {setPrivateStatus(() => T("onboarding.loadError"), true);}
    });
    privateAccountMenu.querySelector(".private-account-divider")?.before(button);
  }
  if (button) I18n.bind(button.querySelector("span"), "textContent", () => T("onboarding.repeat"));
}

async function onboardingApi(path, options = {}) {
  const response = await I18n.fetch(path, {
    method: options.method || "GET", cache: "no-store", credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    ...(options.body ? { body: JSON.stringify(options.body) } : {})
  });
  const payload = await response.json();
  if (!response.ok) throw new Error(T("onboarding.loadError"));
  return payload;
}

async function loadOnboarding() {
  if (!currentUser?.canUseOnboarding) return null;
  if (onboardingController) return onboardingController;
  if (onboardingLoading) return onboardingLoading;
  const owner = currentUser.id;
  const work = (async () => {
    const source = "/onboarding/assets/tour.js";
    const module = await import(source);
    if (currentUser?.id !== owner || !currentUser?.canUseOnboarding) return null;
    let css = document.getElementById("onboarding-styles");
    if (!css) {
      css = document.createElement("link");css.id = "onboarding-styles";css.rel = "stylesheet";css.href = "/onboarding/assets/tour.css";
      await new Promise((resolve, reject) => {css.onload = resolve;css.onerror = () => {css.remove();reject(Error("Onboarding styles unavailable"));};document.head.append(css);});
    }
    if (currentUser?.id !== owner || !currentUser?.canUseOnboarding) return null;
    onboardingController = module.createTour({
      document, api: onboardingApi,
      authorized: () => currentUser?.id === owner && Boolean(currentUser?.canUseOnboarding) && !privateScreen.classList.contains("is-hidden"),
      context: () => ({ hasChart: Boolean(chartCalculation), canExport: canAccessGptIa() }),
      prepare: async (step) => {
        if (onboardingSidebarBefore === null) onboardingSidebarBefore = privateSidebarCollapsed;
        if (step !== "copy" && onboardingOpenedExport && chartDataDialog.open) {chartDataDialog.close();onboardingOpenedExport = false;}
        if (["create", "list"].includes(step) && activePrivateSection !== "list") showPrivateSection("list");
        if (["maps", "views", "export", "copy"].includes(step) && activePrivateSection !== "maps") showPrivateSection("maps");
        // On mobile the map controls live above the chart, not in the account menu.
        if (["maps", "views", "export", "copy"].includes(step) || ["create", "list"].includes(step) && privateSidebarMobileQuery.matches) {
          privateSidebarCollapsed = true;applyPrivateSidebarState();
        }
        if (step === "help") {privateSidebarCollapsed = false;applyPrivateSidebarState();}
        if (step === "copy" && !chartDataDialog.open) {
          const instance = onboardingController;
          await openChartDataDialog();onboardingOpenedExport = chartDataDialog.open;
          if (onboardingController !== instance || !instance?.active || currentUser?.id !== owner || privateScreen.classList.contains("is-hidden")) {
            if (onboardingOpenedExport) chartDataDialog.close();onboardingOpenedExport = false;
          }
        }
        if (step === "copy" && chartDataDialog.open) onboardingOpenedExport = true;
        if (step === "help") {
          privateAccountMenu.classList.remove("is-hidden");
          privateUser.querySelector("#private-account-toggle")?.setAttribute("aria-expanded", "true");
        }
      },
      restore: () => {
        if (onboardingOpenedExport) chartDataDialog.close();
        onboardingOpenedExport = false;
        closePrivateAccountMenu();
        if (onboardingSidebarBefore !== null) {privateSidebarCollapsed = onboardingSidebarBefore;onboardingSidebarBefore = null;applyPrivateSidebarState();}
      }
    });
    return onboardingController;
  })();
  onboardingLoading = work;
  try {return await work;} finally
  {if (onboardingLoading === work) onboardingLoading = null;}
}

function offerOnboarding() {
  if (!currentUser?.canUseOnboarding || privateScreen.classList.contains("is-hidden") || isPersonFormOpen() || document.querySelector("dialog[open]")) return;
  void loadOnboarding().then((controller) => controller?.offer()).catch(() => {/* Optional help must not block login. Manual retry remains in the account menu. */});
}

window.WorkDashboard?.connect({
  root: document.getElementById("private-work-dashboard"),
  context() {
    const subscribed = hasConfirmedSubscription();
    const enabled = (section) => !PRIVATE_SECTION_MODULE_MAP[section] || isModuleEnabled(PRIVATE_SECTION_MODULE_MAP[section]);
    return {
      ownerId: currentUser?.id || null,
      active: activePrivateSection === "space" && !privateScreen.classList.contains("is-hidden"),
      workspaceActive: !privateScreen.classList.contains("is-hidden"),
      language: document.documentElement.lang,
      peopleLoaded: !!currentUser && privateWorkPeopleOwner === currentUser.id,
      peopleError: !!currentUser && privateWorkPeopleError === currentUser.id,
      people: privateWorkPeopleOwner === currentUser?.id ? savedPeople : [],
      section: activePrivateSection, toolsView: activePrivateToolsView,
      personId: activePrivateSection === "maps" ? activePersonId : activePrivateSection === "atlas" || activePrivateSection === "tools" && activePrivateToolsView !== "natal" ? "" : activePrivateSection === "tools" ? natalAspectFinderPerson?.value || "" : getToolPersonId(),
      allowed: { maps: enabled('maps'), atlas: enabled('atlas') && !!(currentUser?.canAccessAtlas || currentUser?.canAccessAtlas3D), atlas3d: enabled('atlas3d') && subscribed && currentUser?.canAccessAtlas3D === true, observatory: subscribed && currentUser?.canAccessObservatory === true, timeline: subscribed && currentUser?.canAccessTimeline === true, tools: enabled('tools') && subscribed },
      notebookAllowed: subscribed && currentUser?.canAccessObservatory === true && currentUser?.canAccessTimeline === true,
      canGuide: currentUser?.canUseOnboarding === true
    };
  },
  async loadWork(signal) {
    const ownerId = currentUser?.id;
    const response = await I18n.fetch('/api/account/workspace', { credentials: 'same-origin', cache: 'no-store', signal, headers: { 'X-Workspace-Owner': String(ownerId) } });
    const result = await response.json();
    if (signal.aborted || currentUser?.id !== ownerId) throw new DOMException('Aborted', 'AbortError');
    if (!response.ok || result.ownerId !== ownerId) throw new Error(T('timeline.error'));
    return result;
  },
  async saveWork(input, signal) {
    const ownerId = currentUser?.id;
    const response = await I18n.fetch('/api/account/workspace', { method: 'PATCH', credentials: 'same-origin', cache: 'no-store', keepalive: true, signal, headers: { 'Content-Type': 'application/json', 'X-Workspace-Owner': String(ownerId) }, body: JSON.stringify({ ...input, ownerId }) });
    const result = await response.json();
    if (signal.aborted || currentUser?.id !== ownerId) throw new DOMException('Aborted', 'AbortError');
    if (!response.ok && !(response.status === 409 && result.conflict) || result.ownerId !== ownerId) throw new Error(T('timeline.error'));
    return result;
  },
  async loadNotebook(signal) {
    const ownerId = currentUser?.id;
    const response = await I18n.fetch('/api/timeline/notebook', { credentials: 'same-origin', cache: 'no-store', signal });
    const result = await response.json();
    if (signal.aborted || currentUser?.id !== ownerId) throw new DOMException('Aborted', 'AbortError');
    if (!response.ok) throw new Error(T('timeline.error'));
    return result;
  },
  async onAction(action, { work, id, personId, state, ownerId }) {
    if (!ownerId || currentUser?.id !== ownerId) return;
    if (action === 'verify') {
      if (currentUser.isAdmin && !(await window.AdminSecurity.ensure())) throw new Error(T('timeline.error'));
      return;
    }
    if (action === 'create') return openPrivateAddChart();
    if (action === 'load-people') return loadPeople({ ownerId });
    if (action === 'choose') return handlePrivateDashboardAction('saved-charts');
    if (action === 'subscription') return handlePrivateDashboardAction('plans');
    if (action === 'guide') {
      const guide = await loadOnboarding();
      if (currentUser?.id === ownerId) await guide?.start();
      return;
    }
    if (action === 'entry' || action === 'notebook') {
      if (!(currentUser.canAccessObservatory && currentUser.canAccessTimeline && hasConfirmedSubscription())) return;
      const person = savedPeople.find((p) => String(p.id) === String(action === 'entry' ? personId : work?.personId));
      if (action === 'entry' && !person) return;
      if (person) rememberToolPerson(person.id);
      privateNotebookTarget = { ownerId, id, state };
      showPrivateSection('observatory');
      return;
    }
    if (action === 'resume') {
      const person = savedPeople.find((p) => String(p.id) === work.personId);
      if (work.personId && !person) return;
      if (work.section === 'maps' && person) return useSavedPerson(person);
      if (work.section === 'tools' && work.toolsView === 'natal') {
        await prepareNatalAspectFinderSection();
        if (currentUser?.id !== ownerId) return;
        natalAspectFinderPerson.value = work.personId;
        setNatalAspectFinderDefaultPlaceForPerson();
      }
      if (['atlas3d', 'observatory', 'timeline'].includes(work.section)) rememberToolPerson(work.personId);
      showPrivateSection(work.section, { toolsView: work.toolsView });
    }
  }
});
window.openAuthDialog=openAuthDialog;